
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $5c3935b0e0970262$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"gNOL9\",\"index.773d3407.js\",\"cKZe0\",\"favicon.dad33c62.svg\",\"gsLnW\",\"logo.8c2f6b64.svg\",\"eMWCt\",\"wysiwyg.aa5c5cd4.css\"]"));

// Importing these modules via script tags caused console errors
// Here is an ugly workaround to add them to the global scope
var $0abbbd36a260e067$exports = {};

$parcel$export($0abbbd36a260e067$exports, "Button", () => $0abbbd36a260e067$export$353f5b6fc5456de1);
$parcel$export($0abbbd36a260e067$exports, "Offcanvas", () => $0abbbd36a260e067$export$591ca0244c9dfcd4);
$parcel$export($0abbbd36a260e067$exports, "Carousel", () => $0abbbd36a260e067$export$144901db2ea8e967);
$parcel$export($0abbbd36a260e067$exports, "Popover", () => $0abbbd36a260e067$export$5b6b19405a83ff9d);
$parcel$export($0abbbd36a260e067$exports, "ScrollSpy", () => $0abbbd36a260e067$export$a6472a5298a374be);
$parcel$export($0abbbd36a260e067$exports, "Tab", () => $0abbbd36a260e067$export$3e41faf802a29e71);
$parcel$export($0abbbd36a260e067$exports, "Tooltip", () => $0abbbd36a260e067$export$28c660c63b792dea);
$parcel$export($0abbbd36a260e067$exports, "Input", () => $0abbbd36a260e067$export$f5b8910cec6cf069);
$parcel$export($0abbbd36a260e067$exports, "Collapse", () => $0abbbd36a260e067$export$78768a9af065a7b);
$parcel$export($0abbbd36a260e067$exports, "Dropdown", () => $0abbbd36a260e067$export$931cbfb6bfb85fc);
$parcel$export($0abbbd36a260e067$exports, "Ripple", () => $0abbbd36a260e067$export$9e9146f7e027fdaa);
$parcel$export($0abbbd36a260e067$exports, "Range", () => $0abbbd36a260e067$export$9a58ef0d7ad3278c);
$parcel$export($0abbbd36a260e067$exports, "Animate", () => $0abbbd36a260e067$export$83a1293bbde53b95);
$parcel$export($0abbbd36a260e067$exports, "Lightbox", () => $0abbbd36a260e067$export$7d2670a66155874b);
$parcel$export($0abbbd36a260e067$exports, "Rating", () => $0abbbd36a260e067$export$8ba663d22f9191ae);
$parcel$export($0abbbd36a260e067$exports, "Sidenav", () => $0abbbd36a260e067$export$40a91cd7866fd4b5);
$parcel$export($0abbbd36a260e067$exports, "Alert", () => $0abbbd36a260e067$export$caec2af78bcc877f);
$parcel$export($0abbbd36a260e067$exports, "Toast", () => $0abbbd36a260e067$export$8d8dc7d5f743331b);
$parcel$export($0abbbd36a260e067$exports, "Timepicker", () => $0abbbd36a260e067$export$8497164ca5dbf597);
$parcel$export($0abbbd36a260e067$exports, "Navbar", () => $0abbbd36a260e067$export$42cfbb80f7861e77);
$parcel$export($0abbbd36a260e067$exports, "InfiniteScroll", () => $0abbbd36a260e067$export$c5295390d6167a3e);
$parcel$export($0abbbd36a260e067$exports, "LazyLoad", () => $0abbbd36a260e067$export$7767ad0d5ed2b01b);
$parcel$export($0abbbd36a260e067$exports, "Datepicker", () => $0abbbd36a260e067$export$7235422eca03ec90);
$parcel$export($0abbbd36a260e067$exports, "Popconfirm", () => $0abbbd36a260e067$export$154a38f911af10de);
$parcel$export($0abbbd36a260e067$exports, "Select", () => $0abbbd36a260e067$export$ef9b1a59e592288f);
$parcel$export($0abbbd36a260e067$exports, "Datatable", () => $0abbbd36a260e067$export$aeedc005af528695);
$parcel$export($0abbbd36a260e067$exports, "Stepper", () => $0abbbd36a260e067$export$ed8ca599049e8881);
$parcel$export($0abbbd36a260e067$exports, "Sticky", () => $0abbbd36a260e067$export$cbb1b0785b69b9d8);
$parcel$export($0abbbd36a260e067$exports, "Touch", () => $0abbbd36a260e067$export$746b04bbf92762fd);
$parcel$export($0abbbd36a260e067$exports, "SmoothScroll", () => $0abbbd36a260e067$export$f8250c268cd0d487);
$parcel$export($0abbbd36a260e067$exports, "PerfectScrollbar", () => $0abbbd36a260e067$export$cdf548474a278786);
$parcel$export($0abbbd36a260e067$exports, "Loading", () => $0abbbd36a260e067$export$669f6ea7d267feaf);
$parcel$export($0abbbd36a260e067$exports, "Autocomplete", () => $0abbbd36a260e067$export$2f2b9559550c7bbc);
$parcel$export($0abbbd36a260e067$exports, "Modal", () => $0abbbd36a260e067$export$2b77a92f1a5ad772);
$parcel$export($0abbbd36a260e067$exports, "Clipboard", () => $0abbbd36a260e067$export$8b44c43c7d8f0830);
$parcel$export($0abbbd36a260e067$exports, "Chip", () => $0abbbd36a260e067$export$5a7f9a6004988d01);
$parcel$export($0abbbd36a260e067$exports, "ChipsInput", () => $0abbbd36a260e067$export$8d350cc6ca027c91);
$parcel$export($0abbbd36a260e067$exports, "MultiRangeSlider", () => $0abbbd36a260e067$export$8e9b6dbf9d49587f);
$parcel$export($0abbbd36a260e067$exports, "Datetimepicker", () => $0abbbd36a260e067$export$54050e8fb4df7bd9);
$parcel$export($0abbbd36a260e067$exports, "initMDB", () => $0abbbd36a260e067$export$c471ba63047b6fd4);
var $0abbbd36a260e067$var$__defProp = Object.defineProperty;
var $0abbbd36a260e067$var$__defNormalProp = (obj, key, value)=>key in obj ? $0abbbd36a260e067$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0abbbd36a260e067$var$__publicField = (obj, key, value)=>{
    $0abbbd36a260e067$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
const $0abbbd36a260e067$var$mapData = (()=>{
    const storeData = {};
    let id = 1;
    return {
        set (element2, key, data) {
            if (typeof element2[key] === "undefined") {
                element2[key] = {
                    key: key,
                    id: id
                };
                id++;
            }
            storeData[element2[key].id] = data;
        },
        get (element2, key) {
            if (!element2 || typeof element2[key] === "undefined") return null;
            const keyProperties = element2[key];
            if (keyProperties.key === key) return storeData[keyProperties.id];
            return null;
        },
        delete (element2, key) {
            if (typeof element2[key] === "undefined") return;
            const keyProperties = element2[key];
            if (keyProperties.key === key) {
                delete storeData[keyProperties.id];
                delete element2[key];
            }
        }
    };
})();
const $0abbbd36a260e067$var$Data$1 = {
    setData (instance, key, data) {
        $0abbbd36a260e067$var$mapData.set(instance, key, data);
    },
    getData (instance, key) {
        return $0abbbd36a260e067$var$mapData.get(instance, key);
    },
    removeData (instance, key) {
        $0abbbd36a260e067$var$mapData.delete(instance, key);
    }
};
const $0abbbd36a260e067$var$MAX_UID$1 = 1e6;
const $0abbbd36a260e067$var$toType$1 = (obj)=>{
    if (obj === null || obj === void 0) return `${obj}`;
    return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
};
const $0abbbd36a260e067$var$getUID$1 = (prefix)=>{
    do prefix += Math.floor(Math.random() * $0abbbd36a260e067$var$MAX_UID$1);
    while (document.getElementById(prefix));
    return prefix;
};
const $0abbbd36a260e067$var$getSelector$1 = (element2)=>{
    let selector = element2.getAttribute("data-mdb-target");
    if (!selector || selector === "#") {
        const hrefAttr = element2.getAttribute("href");
        selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
    }
    return selector;
};
const $0abbbd36a260e067$var$getSelectorFromElement = (element2)=>{
    const selector = $0abbbd36a260e067$var$getSelector$1(element2);
    if (selector) return document.querySelector(selector) ? selector : null;
    return null;
};
const $0abbbd36a260e067$var$getElementFromSelector = (element2)=>{
    const selector = $0abbbd36a260e067$var$getSelector$1(element2);
    return selector ? document.querySelector(selector) : null;
};
const $0abbbd36a260e067$var$isElement$2 = (obj)=>{
    if (!obj || typeof obj !== "object") return false;
    if (typeof obj.jquery !== "undefined") obj = obj[0];
    return typeof obj.nodeType !== "undefined";
};
const $0abbbd36a260e067$var$getElement$1 = (obj)=>{
    if ($0abbbd36a260e067$var$isElement$2(obj)) return obj.jquery ? obj[0] : obj;
    if (typeof obj === "string" && obj.length > 0) return document.querySelector(obj);
    return null;
};
const $0abbbd36a260e067$var$typeCheckConfig = (componentName, config, configTypes)=>{
    Object.keys(configTypes).forEach((property)=>{
        const expectedTypes = configTypes[property];
        const value = config[property];
        const valueType = value && $0abbbd36a260e067$var$isElement$2(value) ? "element" : $0abbbd36a260e067$var$toType$1(value);
        if (!new RegExp(expectedTypes).test(valueType)) throw new Error(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
    });
};
const $0abbbd36a260e067$var$isVisible$1 = (element2)=>{
    if (!element2) return false;
    if (element2.style && element2.parentNode && element2.parentNode.style) {
        const elementStyle = getComputedStyle(element2);
        const parentNodeStyle = getComputedStyle(element2.parentNode);
        return elementStyle.display !== "none" && parentNodeStyle.display !== "none" && elementStyle.visibility !== "hidden";
    }
    return false;
};
const $0abbbd36a260e067$var$isDisabled$1 = (element2)=>{
    if (!element2 || element2.nodeType !== Node.ELEMENT_NODE) return true;
    if (element2.classList.contains("disabled")) return true;
    if (typeof element2.disabled !== "undefined") return element2.disabled;
    return element2.hasAttribute("disabled") && element2.getAttribute("disabled") !== "false";
};
const $0abbbd36a260e067$var$getjQuery$1 = ()=>{
    const { jQuery: jQuery } = window;
    if (jQuery && !document.body.hasAttribute("data-mdb-no-jquery")) return jQuery;
    return null;
};
const $0abbbd36a260e067$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", callback);
    else callback();
};
const $0abbbd36a260e067$var$isRTL$1 = document.documentElement.dir === "rtl";
const $0abbbd36a260e067$var$array = (collection)=>{
    return Array.from(collection);
};
const $0abbbd36a260e067$var$element = (tag)=>{
    return document.createElement(tag);
};
const $0abbbd36a260e067$var$defineJQueryPlugin = (plugin)=>{
    $0abbbd36a260e067$var$onDOMContentLoaded(()=>{
        const $2 = $0abbbd36a260e067$var$getjQuery$1();
        if ($2) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $2.fn[name];
            $2.fn[name] = plugin.jQueryInterface;
            $2.fn[name].Constructor = plugin;
            $2.fn[name].noConflict = ()=>{
                $2.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $0abbbd36a260e067$var$$ = $0abbbd36a260e067$var$getjQuery$1();
const $0abbbd36a260e067$var$namespaceRegex$1 = /[^.]*(?=\..*)\.|.*/;
const $0abbbd36a260e067$var$stripNameRegex$1 = /\..*/;
const $0abbbd36a260e067$var$stripUidRegex$1 = /::\d+$/;
const $0abbbd36a260e067$var$eventRegistry$1 = {};
let $0abbbd36a260e067$var$uidEvent$1 = 1;
const $0abbbd36a260e067$var$customEvents$1 = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $0abbbd36a260e067$var$nativeEvents$1 = [
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
];
function $0abbbd36a260e067$var$getUidEvent(element2, uid) {
    return uid && `${uid}::${$0abbbd36a260e067$var$uidEvent$1++}` || element2.uidEvent || $0abbbd36a260e067$var$uidEvent$1++;
}
function $0abbbd36a260e067$var$getEvent(element2) {
    const uid = $0abbbd36a260e067$var$getUidEvent(element2);
    element2.uidEvent = uid;
    $0abbbd36a260e067$var$eventRegistry$1[uid] = $0abbbd36a260e067$var$eventRegistry$1[uid] || {};
    return $0abbbd36a260e067$var$eventRegistry$1[uid];
}
function $0abbbd36a260e067$var$bootstrapHandler$1(element2, fn2) {
    return function handler(event) {
        event.delegateTarget = element2;
        if (handler.oneOff) $0abbbd36a260e067$var$EventHandler$1.off(element2, event.type, fn2);
        return fn2.apply(element2, [
            event
        ]);
    };
}
function $0abbbd36a260e067$var$bootstrapDelegationHandler$1(element2, selector, fn2) {
    return function handler(event) {
        const domElements = element2.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode){
            for(let i = domElements.length; i--;)if (domElements[i] === target) {
                event.delegateTarget = target;
                if (handler.oneOff) $0abbbd36a260e067$var$EventHandler$1.off(element2, event.type, fn2);
                return fn2.apply(target, [
                    event
                ]);
            }
        }
        return null;
    };
}
function $0abbbd36a260e067$var$findHandler$1(events, handler, delegationSelector = null) {
    const uidEventList = Object.keys(events);
    for(let i = 0, len = uidEventList.length; i < len; i++){
        const event = events[uidEventList[i]];
        if (event.originalHandler === handler && event.delegationSelector === delegationSelector) return event;
    }
    return null;
}
function $0abbbd36a260e067$var$normalizeParams(originalTypeEvent, handler, delegationFn) {
    const delegation = typeof handler === "string";
    const originalHandler = delegation ? delegationFn : handler;
    let typeEvent = originalTypeEvent.replace($0abbbd36a260e067$var$stripNameRegex$1, "");
    const custom = $0abbbd36a260e067$var$customEvents$1[typeEvent];
    if (custom) typeEvent = custom;
    const isNative = $0abbbd36a260e067$var$nativeEvents$1.indexOf(typeEvent) > -1;
    if (!isNative) typeEvent = originalTypeEvent;
    return [
        delegation,
        originalHandler,
        typeEvent
    ];
}
function $0abbbd36a260e067$var$addHandler$1(element2, originalTypeEvent, handler, delegationFn, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element2) return;
    if (!handler) {
        handler = delegationFn;
        delegationFn = null;
    }
    const [delegation, originalHandler, typeEvent] = $0abbbd36a260e067$var$normalizeParams(originalTypeEvent, handler, delegationFn);
    const events = $0abbbd36a260e067$var$getEvent(element2);
    const handlers2 = events[typeEvent] || (events[typeEvent] = {});
    const previousFn = $0abbbd36a260e067$var$findHandler$1(handlers2, originalHandler, delegation ? handler : null);
    if (previousFn) {
        previousFn.oneOff = previousFn.oneOff && oneOff;
        return;
    }
    const uid = $0abbbd36a260e067$var$getUidEvent(originalHandler, originalTypeEvent.replace($0abbbd36a260e067$var$namespaceRegex$1, ""));
    const fn2 = delegation ? $0abbbd36a260e067$var$bootstrapDelegationHandler$1(element2, handler, delegationFn) : $0abbbd36a260e067$var$bootstrapHandler$1(element2, handler);
    fn2.delegationSelector = delegation ? handler : null;
    fn2.originalHandler = originalHandler;
    fn2.oneOff = oneOff;
    fn2.uidEvent = uid;
    handlers2[uid] = fn2;
    element2.addEventListener(typeEvent, fn2, delegation);
}
function $0abbbd36a260e067$var$removeHandler$1(element2, events, typeEvent, handler, delegationSelector) {
    const fn2 = $0abbbd36a260e067$var$findHandler$1(events[typeEvent], handler, delegationSelector);
    if (!fn2) return;
    element2.removeEventListener(typeEvent, fn2, Boolean(delegationSelector));
    delete events[typeEvent][fn2.uidEvent];
}
function $0abbbd36a260e067$var$removeNamespacedHandlers$1(element2, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    Object.keys(storeElementEvent).forEach((handlerKey)=>{
        if (handlerKey.indexOf(namespace) > -1) {
            const event = storeElementEvent[handlerKey];
            $0abbbd36a260e067$var$removeHandler$1(element2, events, typeEvent, event.originalHandler, event.delegationSelector);
        }
    });
}
const $0abbbd36a260e067$var$EventHandler$1 = {
    on (element2, event, handler, delegationFn) {
        $0abbbd36a260e067$var$addHandler$1(element2, event, handler, delegationFn, false);
    },
    one (element2, event, handler, delegationFn) {
        $0abbbd36a260e067$var$addHandler$1(element2, event, handler, delegationFn, true);
    },
    extend (element2, events, componentName) {
        events.forEach((event)=>{
            $0abbbd36a260e067$var$EventHandler$1.on(element2, `${event.name}.bs.${componentName}`, (e)=>{
                const eventParameters = {};
                if (event.parametersToCopy) event.parametersToCopy.forEach((param)=>{
                    eventParameters[param] = e[param];
                });
                const mdbEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(element2, `${event.name}.mdb.${componentName}`, eventParameters);
                if (mdbEvent.defaultPrevented) e.preventDefault();
            });
        });
    },
    off (element2, originalTypeEvent, handler, delegationFn) {
        if (typeof originalTypeEvent !== "string" || !element2) return;
        const [delegation, originalHandler, typeEvent] = $0abbbd36a260e067$var$normalizeParams(originalTypeEvent, handler, delegationFn);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $0abbbd36a260e067$var$getEvent(element2);
        const isNamespace = originalTypeEvent.charAt(0) === ".";
        if (typeof originalHandler !== "undefined") {
            if (!events || !events[typeEvent]) return;
            $0abbbd36a260e067$var$removeHandler$1(element2, events, typeEvent, originalHandler, delegation ? handler : null);
            return;
        }
        if (isNamespace) Object.keys(events).forEach((elementEvent)=>{
            $0abbbd36a260e067$var$removeNamespacedHandlers$1(element2, events, elementEvent, originalTypeEvent.slice(1));
        });
        const storeElementEvent = events[typeEvent] || {};
        Object.keys(storeElementEvent).forEach((keyHandlers)=>{
            const handlerKey = keyHandlers.replace($0abbbd36a260e067$var$stripUidRegex$1, "");
            if (!inNamespace || originalTypeEvent.indexOf(handlerKey) > -1) {
                const event = storeElementEvent[keyHandlers];
                $0abbbd36a260e067$var$removeHandler$1(element2, events, typeEvent, event.originalHandler, event.delegationSelector);
            }
        });
    },
    trigger (element2, event, args) {
        if (typeof event !== "string" || !element2) return null;
        const typeEvent = event.replace($0abbbd36a260e067$var$stripNameRegex$1, "");
        const inNamespace = event !== typeEvent;
        const isNative = $0abbbd36a260e067$var$nativeEvents$1.indexOf(typeEvent) > -1;
        let jQueryEvent;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        let evt = null;
        if (inNamespace && $0abbbd36a260e067$var$$) {
            jQueryEvent = $0abbbd36a260e067$var$$.Event(event, args);
            $0abbbd36a260e067$var$$(element2).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        if (isNative) {
            evt = document.createEvent("HTMLEvents");
            evt.initEvent(typeEvent, bubbles, true);
        } else evt = new CustomEvent(event, {
            bubbles: bubbles,
            cancelable: true
        });
        if (typeof args !== "undefined") Object.keys(args).forEach((key)=>{
            Object.defineProperty(evt, key, {
                get () {
                    return args[key];
                }
            });
        });
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element2.dispatchEvent(evt);
        if (evt.defaultPrevented && typeof jQueryEvent !== "undefined") jQueryEvent.preventDefault();
        return evt;
    }
};
const $0abbbd36a260e067$var$EventHandlerMulti = {
    on (element2, eventsName, handler, delegationFn) {
        const events = eventsName.split(" ");
        for(let i = 0; i < events.length; i++)$0abbbd36a260e067$var$EventHandler$1.on(element2, events[i], handler, delegationFn);
    },
    off (element2, originalTypeEvent, handler, delegationFn) {
        const events = originalTypeEvent.split(" ");
        for(let i = 0; i < events.length; i++)$0abbbd36a260e067$var$EventHandler$1.off(element2, events[i], handler, delegationFn);
    }
};
function $0abbbd36a260e067$var$normalizeData$1(val) {
    if (val === "true") return true;
    if (val === "false") return false;
    if (val === Number(val).toString()) return Number(val);
    if (val === "" || val === "null") return null;
    return val;
}
function $0abbbd36a260e067$var$normalizeDataKey$1(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $0abbbd36a260e067$var$Manipulator$1 = {
    setDataAttribute (element2, key, value) {
        element2.setAttribute(`data-mdb-${$0abbbd36a260e067$var$normalizeDataKey$1(key)}`, value);
    },
    removeDataAttribute (element2, key) {
        element2.removeAttribute(`data-mdb-${$0abbbd36a260e067$var$normalizeDataKey$1(key)}`);
    },
    getDataAttributes (element2) {
        if (!element2) return {};
        const attributes = {
            ...element2.dataset
        };
        Object.keys(attributes).filter((key)=>key.startsWith("mdb")).forEach((key)=>{
            let pureKey = key.replace(/^mdb/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $0abbbd36a260e067$var$normalizeData$1(attributes[key]);
        });
        return attributes;
    },
    getDataAttribute (element2, key) {
        return $0abbbd36a260e067$var$normalizeData$1(element2.getAttribute(`data-mdb-${$0abbbd36a260e067$var$normalizeDataKey$1(key)}`));
    },
    offset (element2) {
        const rect = element2.getBoundingClientRect();
        return {
            top: rect.top + document.body.scrollTop,
            left: rect.left + document.body.scrollLeft
        };
    },
    position (element2) {
        return {
            top: element2.offsetTop,
            left: element2.offsetLeft
        };
    },
    style (element2, style) {
        Object.assign(element2.style, style);
    },
    toggleClass (element2, className) {
        if (!element2) return;
        if (element2.classList.contains(className)) element2.classList.remove(className);
        else element2.classList.add(className);
    },
    addClass (element2, className) {
        if (element2.classList.contains(className)) return;
        element2.classList.add(className);
    },
    addStyle (element2, style) {
        Object.keys(style).forEach((property)=>{
            element2.style[property] = style[property];
        });
    },
    removeClass (element2, className) {
        if (!element2.classList.contains(className)) return;
        element2.classList.remove(className);
    },
    hasClass (element2, className) {
        return element2.classList.contains(className);
    }
};
const $0abbbd36a260e067$var$NODE_TEXT = 3;
const $0abbbd36a260e067$var$SelectorEngine$1 = {
    closest (element2, selector) {
        return element2.closest(selector);
    },
    matches (element2, selector) {
        return element2.matches(selector);
    },
    find (selector, element2 = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element2, selector));
    },
    findOne (selector, element2 = document.documentElement) {
        return Element.prototype.querySelector.call(element2, selector);
    },
    children (element2, selector) {
        const children = [].concat(...element2.children);
        return children.filter((child)=>child.matches(selector));
    },
    parents (element2, selector) {
        const parents = [];
        let ancestor = element2.parentNode;
        while(ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== $0abbbd36a260e067$var$NODE_TEXT){
            if (this.matches(ancestor, selector)) parents.push(ancestor);
            ancestor = ancestor.parentNode;
        }
        return parents;
    },
    prev (element2, selector) {
        let previous = element2.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    next (element2, selector) {
        let next = element2.nextElementSibling;
        while(next){
            if (this.matches(next, selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    }
};
const $0abbbd36a260e067$var$elementMap = /* @__PURE__ */ new Map();
const $0abbbd36a260e067$var$Data = {
    set (element2, key, instance) {
        if (!$0abbbd36a260e067$var$elementMap.has(element2)) $0abbbd36a260e067$var$elementMap.set(element2, /* @__PURE__ */ new Map());
        const instanceMap = $0abbbd36a260e067$var$elementMap.get(element2);
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element2, key) {
        if ($0abbbd36a260e067$var$elementMap.has(element2)) return $0abbbd36a260e067$var$elementMap.get(element2).get(key) || null;
        return null;
    },
    remove (element2, key) {
        if (!$0abbbd36a260e067$var$elementMap.has(element2)) return;
        const instanceMap = $0abbbd36a260e067$var$elementMap.get(element2);
        instanceMap.delete(key);
        if (instanceMap.size === 0) $0abbbd36a260e067$var$elementMap.delete(element2);
    }
};
const $0abbbd36a260e067$var$MAX_UID = 1e6;
const $0abbbd36a260e067$var$MILLISECONDS_MULTIPLIER = 1e3;
const $0abbbd36a260e067$var$TRANSITION_END = "transitionend";
const $0abbbd36a260e067$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
const $0abbbd36a260e067$var$toType = (object)=>{
    if (object === null || object === void 0) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
const $0abbbd36a260e067$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $0abbbd36a260e067$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $0abbbd36a260e067$var$getTransitionDurationFromElement = (element2)=>{
    if (!element2) return 0;
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element2);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $0abbbd36a260e067$var$MILLISECONDS_MULTIPLIER;
};
const $0abbbd36a260e067$var$triggerTransitionEnd = (element2)=>{
    element2.dispatchEvent(new Event($0abbbd36a260e067$var$TRANSITION_END));
};
const $0abbbd36a260e067$var$isElement$1 = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $0abbbd36a260e067$var$getElement = (object)=>{
    if ($0abbbd36a260e067$var$isElement$1(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($0abbbd36a260e067$var$parseSelector(object));
    return null;
};
const $0abbbd36a260e067$var$isVisible = (element2)=>{
    if (!$0abbbd36a260e067$var$isElement$1(element2) || element2.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element2).getPropertyValue("visibility") === "visible";
    const closedDetails = element2.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element2) {
        const summary = element2.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $0abbbd36a260e067$var$isDisabled = (element2)=>{
    if (!element2 || element2.nodeType !== Node.ELEMENT_NODE) return true;
    if (element2.classList.contains("disabled")) return true;
    if (typeof element2.disabled !== "undefined") return element2.disabled;
    return element2.hasAttribute("disabled") && element2.getAttribute("disabled") !== "false";
};
const $0abbbd36a260e067$var$findShadowRoot = (element2)=>{
    if (!document.documentElement.attachShadow) return null;
    if (typeof element2.getRootNode === "function") {
        const root = element2.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element2 instanceof ShadowRoot) return element2;
    if (!element2.parentNode) return null;
    return $0abbbd36a260e067$var$findShadowRoot(element2.parentNode);
};
const $0abbbd36a260e067$var$noop = ()=>{};
const $0abbbd36a260e067$var$reflow = (element2)=>{
    element2.offsetHeight;
};
const $0abbbd36a260e067$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-mdb-no-jquery")) return window.jQuery;
    return null;
};
const $0abbbd36a260e067$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $0abbbd36a260e067$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $0abbbd36a260e067$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $0abbbd36a260e067$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $0abbbd36a260e067$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($0abbbd36a260e067$var$TRANSITION_END, handler);
        $0abbbd36a260e067$var$execute(callback);
    };
    transitionElement.addEventListener($0abbbd36a260e067$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $0abbbd36a260e067$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
const $0abbbd36a260e067$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
const $0abbbd36a260e067$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $0abbbd36a260e067$var$stripNameRegex = /\..*/;
const $0abbbd36a260e067$var$stripUidRegex = /::\d+$/;
const $0abbbd36a260e067$var$eventRegistry = {};
let $0abbbd36a260e067$var$uidEvent = 1;
const $0abbbd36a260e067$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $0abbbd36a260e067$var$nativeEvents = /* @__PURE__ */ new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
function $0abbbd36a260e067$var$makeEventUid(element2, uid) {
    return uid && `${uid}::${$0abbbd36a260e067$var$uidEvent++}` || element2.uidEvent || $0abbbd36a260e067$var$uidEvent++;
}
function $0abbbd36a260e067$var$getElementEvents(element2) {
    const uid = $0abbbd36a260e067$var$makeEventUid(element2);
    element2.uidEvent = uid;
    $0abbbd36a260e067$var$eventRegistry[uid] = $0abbbd36a260e067$var$eventRegistry[uid] || {};
    return $0abbbd36a260e067$var$eventRegistry[uid];
}
function $0abbbd36a260e067$var$bootstrapHandler(element2, fn2) {
    return function handler(event) {
        $0abbbd36a260e067$var$hydrateObj(event, {
            delegateTarget: element2
        });
        if (handler.oneOff) $0abbbd36a260e067$var$EventHandler.off(element2, event.type, fn2);
        return fn2.apply(element2, [
            event
        ]);
    };
}
function $0abbbd36a260e067$var$bootstrapDelegationHandler(element2, selector, fn2) {
    return function handler(event) {
        const domElements = element2.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $0abbbd36a260e067$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $0abbbd36a260e067$var$EventHandler.off(element2, event.type, selector, fn2);
            return fn2.apply(target, [
                event
            ]);
        }
    };
}
function $0abbbd36a260e067$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $0abbbd36a260e067$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $0abbbd36a260e067$var$getTypeEvent(originalTypeEvent);
    if (!$0abbbd36a260e067$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $0abbbd36a260e067$var$addHandler(element2, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element2) return;
    let [isDelegated, callable, typeEvent] = $0abbbd36a260e067$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    if (originalTypeEvent in $0abbbd36a260e067$var$customEvents) {
        const wrapFunction = (fn3)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn3.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $0abbbd36a260e067$var$getElementEvents(element2);
    const handlers2 = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $0abbbd36a260e067$var$findHandler(handlers2, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $0abbbd36a260e067$var$makeEventUid(callable, originalTypeEvent.replace($0abbbd36a260e067$var$namespaceRegex, ""));
    const fn2 = isDelegated ? $0abbbd36a260e067$var$bootstrapDelegationHandler(element2, handler, callable) : $0abbbd36a260e067$var$bootstrapHandler(element2, callable);
    fn2.delegationSelector = isDelegated ? handler : null;
    fn2.callable = callable;
    fn2.oneOff = oneOff;
    fn2.uidEvent = uid;
    handlers2[uid] = fn2;
    element2.addEventListener(typeEvent, fn2, isDelegated);
}
function $0abbbd36a260e067$var$removeHandler(element2, events, typeEvent, handler, delegationSelector) {
    const fn2 = $0abbbd36a260e067$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn2) return;
    element2.removeEventListener(typeEvent, fn2, Boolean(delegationSelector));
    delete events[typeEvent][fn2.uidEvent];
}
function $0abbbd36a260e067$var$removeNamespacedHandlers(element2, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $0abbbd36a260e067$var$removeHandler(element2, events, typeEvent, event.callable, event.delegationSelector);
}
function $0abbbd36a260e067$var$getTypeEvent(event) {
    event = event.replace($0abbbd36a260e067$var$stripNameRegex, "");
    return $0abbbd36a260e067$var$customEvents[event] || event;
}
const $0abbbd36a260e067$var$EventHandler = {
    on (element2, event, handler, delegationFunction) {
        $0abbbd36a260e067$var$addHandler(element2, event, handler, delegationFunction, false);
    },
    one (element2, event, handler, delegationFunction) {
        $0abbbd36a260e067$var$addHandler(element2, event, handler, delegationFunction, true);
    },
    off (element2, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element2) return;
        const [isDelegated, callable, typeEvent] = $0abbbd36a260e067$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $0abbbd36a260e067$var$getElementEvents(element2);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            if (!Object.keys(storeElementEvent).length) return;
            $0abbbd36a260e067$var$removeHandler(element2, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$0abbbd36a260e067$var$removeNamespacedHandlers(element2, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($0abbbd36a260e067$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $0abbbd36a260e067$var$removeHandler(element2, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element2, event, args) {
        if (typeof event !== "string" || !element2) return null;
        const $2 = $0abbbd36a260e067$var$getjQuery();
        const typeEvent = $0abbbd36a260e067$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $2) {
            jQueryEvent = $2.Event(event, args);
            $2(element2).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $0abbbd36a260e067$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element2.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $0abbbd36a260e067$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch  {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
function $0abbbd36a260e067$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch  {
        return value;
    }
}
function $0abbbd36a260e067$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $0abbbd36a260e067$var$Manipulator = {
    setDataAttribute (element2, key, value) {
        element2.setAttribute(`data-mdb-${$0abbbd36a260e067$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element2, key) {
        element2.removeAttribute(`data-mdb-${$0abbbd36a260e067$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element2) {
        if (!element2) return {};
        const attributes = {};
        const mdbKeys = Object.keys(element2.dataset).filter((key)=>key.startsWith("mdb") && !key.startsWith("mdbConfig"));
        for (const key of mdbKeys){
            let pureKey = key.replace(/^mdb/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $0abbbd36a260e067$var$normalizeData(element2.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element2, key) {
        return $0abbbd36a260e067$var$normalizeData(element2.getAttribute(`data-mdb-${$0abbbd36a260e067$var$normalizeDataKey(key)}`));
    }
};
class $0abbbd36a260e067$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element2) {
        const jsonConfig = $0abbbd36a260e067$var$isElement$1(element2) ? $0abbbd36a260e067$var$Manipulator.getDataAttribute(element2, "config") : {};
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$0abbbd36a260e067$var$isElement$1(element2) ? $0abbbd36a260e067$var$Manipulator.getDataAttributes(element2) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $0abbbd36a260e067$var$isElement$1(value) ? "element" : $0abbbd36a260e067$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
const $0abbbd36a260e067$var$VERSION = "5.3.3";
let $0abbbd36a260e067$var$BaseComponent$1 = class BaseComponent extends $0abbbd36a260e067$var$Config {
    constructor(element2, config){
        super();
        element2 = $0abbbd36a260e067$var$getElement(element2);
        if (!element2) return;
        this._element = element2;
        this._config = this._getConfig(config);
        $0abbbd36a260e067$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $0abbbd36a260e067$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $0abbbd36a260e067$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element2, isAnimated = true) {
        $0abbbd36a260e067$var$executeAfterTransition(callback, element2, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element2) {
        return $0abbbd36a260e067$var$Data.get($0abbbd36a260e067$var$getElement(element2), this.DATA_KEY);
    }
    static getOrCreateInstance(element2, config = {}) {
        return this.getInstance(element2) || new this(element2, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $0abbbd36a260e067$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
};
const $0abbbd36a260e067$var$NAME$X = "button";
const $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$7 = "active";
let $0abbbd36a260e067$var$Button$1 = class Button extends $0abbbd36a260e067$var$BaseComponent$1 {
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$X;
    }
    // Public
    toggle() {
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$7));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Button.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
};
const $0abbbd36a260e067$var$mapComponentsData = (()=>{
    const componentsData = [];
    return {
        set (componentName) {
            componentsData.push(componentName);
        },
        get (componentName) {
            return componentsData.includes(componentName);
        }
    };
})();
const $0abbbd36a260e067$var$InitializedComponents = {
    set (componentName) {
        $0abbbd36a260e067$var$mapComponentsData.set(componentName);
    },
    get (componentName) {
        return $0abbbd36a260e067$var$mapComponentsData.get(componentName);
    }
};
const $0abbbd36a260e067$var$isInitialized = (componentName)=>{
    return $0abbbd36a260e067$var$InitializedComponents.get(componentName);
};
const $0abbbd36a260e067$var$bindCallbackEventsIfNeeded = (component)=>{
    if (!$0abbbd36a260e067$var$isInitialized(component.NAME)) {
        const manualInit = true;
        $0abbbd36a260e067$var$initComponent(component, manualInit);
    }
};
const $0abbbd36a260e067$var$initComponent = (component, manualInit = false)=>{
    if (!component || $0abbbd36a260e067$var$InitializedComponents.get(component.NAME)) return;
    if (!manualInit) $0abbbd36a260e067$var$InitializedComponents.set(component.NAME);
    const thisComponent = $0abbbd36a260e067$var$_defaultInitSelectors[component.NAME] || null;
    const isToggler = (thisComponent == null ? void 0 : thisComponent.isToggler) || false;
    $0abbbd36a260e067$var$defineJQueryPlugin(component);
    if (thisComponent == null ? void 0 : thisComponent.advanced) {
        thisComponent.advanced(component, thisComponent == null ? void 0 : thisComponent.selector);
        return;
    }
    if (isToggler) {
        thisComponent.callback(component, thisComponent == null ? void 0 : thisComponent.selector);
        return;
    }
    if (manualInit) return;
    $0abbbd36a260e067$var$SelectorEngine$1.find(thisComponent == null ? void 0 : thisComponent.selector).forEach((element2)=>{
        let instance = component.getInstance(element2);
        if (!instance) {
            instance = new component(element2);
            if (thisComponent == null ? void 0 : thisComponent.onInit) instance[thisComponent.onInit]();
        }
    });
};
let $0abbbd36a260e067$var$_defaultInitSelectors;
class $0abbbd36a260e067$var$InitMDB {
    constructor(defaultInitSelectors2){
        $0abbbd36a260e067$var$__publicField(this, "init", (components)=>{
            components.forEach((component)=>$0abbbd36a260e067$var$initComponent(component));
        });
        $0abbbd36a260e067$var$__publicField(this, "initMDB", (components, checkOtherImports = false)=>{
            const componentList = Object.keys($0abbbd36a260e067$var$_defaultInitSelectors).map((element2)=>{
                const requireAutoInit = Boolean(document.querySelector($0abbbd36a260e067$var$_defaultInitSelectors[element2].selector));
                if (requireAutoInit) {
                    const component = components[$0abbbd36a260e067$var$_defaultInitSelectors[element2].name];
                    if (!component && !$0abbbd36a260e067$var$InitializedComponents.get(element2) && checkOtherImports) console.warn(`Please import ${$0abbbd36a260e067$var$_defaultInitSelectors[element2].name} from "MDB" package and add it to a object parameter inside "initMDB" function`);
                    return component;
                }
                return null;
            });
            this.init(componentList);
        });
        $0abbbd36a260e067$var$_defaultInitSelectors = defaultInitSelectors2;
    }
}
const $0abbbd36a260e067$var$NAME$W = "button";
const $0abbbd36a260e067$var$DATA_KEY$E = `mdb.${$0abbbd36a260e067$var$NAME$W}`;
const $0abbbd36a260e067$var$EVENT_KEY$w = `.${$0abbbd36a260e067$var$DATA_KEY$E}`;
const $0abbbd36a260e067$var$EVENT_CLICK$3 = `click${$0abbbd36a260e067$var$EVENT_KEY$w}`;
const $0abbbd36a260e067$var$EVENT_TRANSITIONEND = "transitionend";
const $0abbbd36a260e067$var$EVENT_MOUSEENTER$2 = "mouseenter";
const $0abbbd36a260e067$var$EVENT_MOUSELEAVE$2 = "mouseleave";
const $0abbbd36a260e067$var$EVENT_HIDE$a = `hide${$0abbbd36a260e067$var$EVENT_KEY$w}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN$b = `hidden${$0abbbd36a260e067$var$EVENT_KEY$w}`;
const $0abbbd36a260e067$var$EVENT_SHOW$b = `show${$0abbbd36a260e067$var$EVENT_KEY$w}`;
const $0abbbd36a260e067$var$EVENT_SHOWN$a = `shown${$0abbbd36a260e067$var$EVENT_KEY$w}`;
const $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$6 = "active";
const $0abbbd36a260e067$var$CLASS_NAME_SHOWN = "shown";
const $0abbbd36a260e067$var$CLASS_NAME_FIXED_ACTION_BTN = "fixed-action-btn";
const $0abbbd36a260e067$var$SELECTOR_ACTION_BUTTON = ".fixed-action-btn:not(.smooth-scroll) > .btn-floating";
const $0abbbd36a260e067$var$SELECTOR_LIST_ELEMENT = "ul .btn";
const $0abbbd36a260e067$var$SELECTOR_LIST$1 = "ul";
class $0abbbd36a260e067$export$353f5b6fc5456de1 extends $0abbbd36a260e067$var$Button$1 {
    constructor(element2){
        super(element2);
        this._fn = {};
        if (this._element) {
            $0abbbd36a260e067$var$Data$1.setData(this._element, $0abbbd36a260e067$var$DATA_KEY$E, this);
            this._init();
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // Static
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$W;
    }
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$E);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$353f5b6fc5456de1(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
    // Getters
    get _actionButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_ACTION_BUTTON, this._element);
    }
    get _buttonListElements() {
        return $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_LIST_ELEMENT, this._element);
    }
    get _buttonList() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_LIST$1, this._element);
    }
    get _isTouchDevice() {
        return "ontouchstart" in document.documentElement;
    }
    // Public
    show() {
        if ($0abbbd36a260e067$var$Manipulator$1.hasClass(this._element, $0abbbd36a260e067$var$CLASS_NAME_FIXED_ACTION_BTN)) {
            $0abbbd36a260e067$var$EventHandler$1.off(this._buttonList, $0abbbd36a260e067$var$EVENT_TRANSITIONEND);
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOW$b);
            this._bindListOpenTransitionEnd();
            $0abbbd36a260e067$var$Manipulator$1.addStyle(this._element, {
                height: `${this._fullContainerHeight}px`
            });
            this._toggleVisibility(true);
        }
    }
    hide() {
        if ($0abbbd36a260e067$var$Manipulator$1.hasClass(this._element, $0abbbd36a260e067$var$CLASS_NAME_FIXED_ACTION_BTN)) {
            $0abbbd36a260e067$var$EventHandler$1.off(this._buttonList, $0abbbd36a260e067$var$EVENT_TRANSITIONEND);
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDE$a);
            this._bindListHideTransitionEnd();
            this._toggleVisibility(false);
        }
    }
    dispose() {
        if ($0abbbd36a260e067$var$Manipulator$1.hasClass(this._element, $0abbbd36a260e067$var$CLASS_NAME_FIXED_ACTION_BTN)) {
            $0abbbd36a260e067$var$EventHandler$1.off(this._actionButton, $0abbbd36a260e067$var$EVENT_CLICK$3);
            this._actionButton.removeEventListener($0abbbd36a260e067$var$EVENT_MOUSEENTER$2, this._fn.mouseenter);
            this._element.removeEventListener($0abbbd36a260e067$var$EVENT_MOUSELEAVE$2, this._fn.mouseleave);
        }
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _init() {
        if ($0abbbd36a260e067$var$Manipulator$1.hasClass(this._element, $0abbbd36a260e067$var$CLASS_NAME_FIXED_ACTION_BTN)) {
            this._saveInitialHeights();
            this._setInitialStyles();
            this._bindInitialEvents();
        }
    }
    _bindMouseEnter() {
        this._actionButton.addEventListener($0abbbd36a260e067$var$EVENT_MOUSEENTER$2, // prettier-ignore
        this._fn.mouseenter = ()=>{
            if (!this._isTouchDevice) this.show();
        });
    }
    _bindMouseLeave() {
        this._element.addEventListener($0abbbd36a260e067$var$EVENT_MOUSELEAVE$2, // prettier-ignore
        this._fn.mouseleave = ()=>{
            this.hide();
        });
    }
    _bindClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._actionButton, $0abbbd36a260e067$var$EVENT_CLICK$3, ()=>{
            if ($0abbbd36a260e067$var$Manipulator$1.hasClass(this._element, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$6)) this.hide();
            else this.show();
        });
    }
    _bindListHideTransitionEnd() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._buttonList, $0abbbd36a260e067$var$EVENT_TRANSITIONEND, (event)=>{
            if (event.propertyName === "transform") {
                $0abbbd36a260e067$var$EventHandler$1.off(this._buttonList, $0abbbd36a260e067$var$EVENT_TRANSITIONEND);
                this._element.style.height = `${this._initialContainerHeight}px`;
                $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN$b);
            }
        });
    }
    _bindListOpenTransitionEnd() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._buttonList, $0abbbd36a260e067$var$EVENT_TRANSITIONEND, (event)=>{
            if (event.propertyName === "transform") {
                $0abbbd36a260e067$var$EventHandler$1.off(this._buttonList, $0abbbd36a260e067$var$EVENT_TRANSITIONEND);
                $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOWN$a);
            }
        });
    }
    _toggleVisibility(isVisible2) {
        const action = isVisible2 ? "addClass" : "removeClass";
        const listTranslate = isVisible2 ? "translate(0)" : `translateY(${this._fullContainerHeight}px)`;
        $0abbbd36a260e067$var$Manipulator$1.addStyle(this._buttonList, {
            transform: listTranslate
        });
        if (this._buttonListElements) this._buttonListElements.forEach((el)=>$0abbbd36a260e067$var$Manipulator$1[action](el, $0abbbd36a260e067$var$CLASS_NAME_SHOWN));
        $0abbbd36a260e067$var$Manipulator$1[action](this._element, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$6);
    }
    _getHeight(element2) {
        const computed = window.getComputedStyle(element2);
        const height = parseFloat(computed.getPropertyValue("height"));
        return height;
    }
    _saveInitialHeights() {
        this._initialContainerHeight = this._getHeight(this._element);
        this._initialListHeight = this._getHeight(this._buttonList);
        this._fullContainerHeight = this._initialContainerHeight + this._initialListHeight;
    }
    _bindInitialEvents() {
        this._bindClick();
        this._bindMouseEnter();
        this._bindMouseLeave();
    }
    _setInitialStyles() {
        this._buttonList.style.marginBottom = `${this._initialContainerHeight}px`;
        this._buttonList.style.transform = `translateY(${this._fullContainerHeight}px)`;
        this._element.style.height = `${this._initialContainerHeight}px`;
    }
}
const $0abbbd36a260e067$var$getSelector = (element2)=>{
    let selector = element2.getAttribute("data-mdb-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element2.getAttribute("href");
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$0abbbd36a260e067$var$parseSelector(sel)).join(",") : null;
};
const $0abbbd36a260e067$var$SelectorEngine = {
    find (selector, element2 = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element2, selector));
    },
    findOne (selector, element2 = document.documentElement) {
        return Element.prototype.querySelector.call(element2, selector);
    },
    children (element2, selector) {
        return [].concat(...element2.children).filter((child)=>child.matches(selector));
    },
    parents (element2, selector) {
        const parents = [];
        let ancestor = element2.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element2, selector) {
        let previous = element2.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element2, selector) {
        let next = element2.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element2) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element2).filter((el)=>!$0abbbd36a260e067$var$isDisabled(el) && $0abbbd36a260e067$var$isVisible(el));
    },
    getSelectorFromElement (element2) {
        const selector = $0abbbd36a260e067$var$getSelector(element2);
        if (selector) return $0abbbd36a260e067$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element2) {
        const selector = $0abbbd36a260e067$var$getSelector(element2);
        return selector ? $0abbbd36a260e067$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element2) {
        const selector = $0abbbd36a260e067$var$getSelector(element2);
        return selector ? $0abbbd36a260e067$var$SelectorEngine.find(selector) : [];
    }
};
const $0abbbd36a260e067$var$NAME$V = "backdrop";
const $0abbbd36a260e067$var$CLASS_NAME_FADE$6 = "fade";
const $0abbbd36a260e067$var$CLASS_NAME_SHOW$9 = "show";
const $0abbbd36a260e067$var$EVENT_MOUSEDOWN$2 = `mousedown.bs.${$0abbbd36a260e067$var$NAME$V}`;
const $0abbbd36a260e067$var$Default$z = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body"
};
const $0abbbd36a260e067$var$DefaultType$z = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
class $0abbbd36a260e067$var$Backdrop extends $0abbbd36a260e067$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$z;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$z;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$V;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $0abbbd36a260e067$var$execute(callback);
            return;
        }
        this._append();
        const element2 = this._getElement();
        if (this._config.isAnimated) $0abbbd36a260e067$var$reflow(element2);
        element2.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOW$9);
        this._emulateAnimation(()=>{
            $0abbbd36a260e067$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $0abbbd36a260e067$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOW$9);
        this._emulateAnimation(()=>{
            this.dispose();
            $0abbbd36a260e067$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $0abbbd36a260e067$var$EventHandler.off(this._element, $0abbbd36a260e067$var$EVENT_MOUSEDOWN$2);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($0abbbd36a260e067$var$CLASS_NAME_FADE$6);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        config.rootElement = $0abbbd36a260e067$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element2 = this._getElement();
        this._config.rootElement.append(element2);
        $0abbbd36a260e067$var$EventHandler.on(element2, $0abbbd36a260e067$var$EVENT_MOUSEDOWN$2, ()=>{
            $0abbbd36a260e067$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $0abbbd36a260e067$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
const $0abbbd36a260e067$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $0abbbd36a260e067$var$EventHandler.on(document, clickEvent, `[data-mdb-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($0abbbd36a260e067$var$isDisabled(this)) return;
        const target = $0abbbd36a260e067$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        instance[method]();
    });
};
const $0abbbd36a260e067$var$NAME$U = "focustrap";
const $0abbbd36a260e067$var$DATA_KEY$D = "bs.focustrap";
const $0abbbd36a260e067$var$EVENT_KEY$v = `.${$0abbbd36a260e067$var$DATA_KEY$D}`;
const $0abbbd36a260e067$var$EVENT_FOCUSIN$2 = `focusin${$0abbbd36a260e067$var$EVENT_KEY$v}`;
const $0abbbd36a260e067$var$EVENT_KEYDOWN_TAB = `keydown.tab${$0abbbd36a260e067$var$EVENT_KEY$v}`;
const $0abbbd36a260e067$var$TAB_KEY$1 = "Tab";
const $0abbbd36a260e067$var$TAB_NAV_FORWARD = "forward";
const $0abbbd36a260e067$var$TAB_NAV_BACKWARD = "backward";
const $0abbbd36a260e067$var$Default$y = {
    autofocus: true,
    trapElement: null
};
const $0abbbd36a260e067$var$DefaultType$y = {
    autofocus: "boolean",
    trapElement: "element"
};
let $0abbbd36a260e067$var$FocusTrap$1 = class FocusTrap extends $0abbbd36a260e067$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$y;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$y;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$U;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $0abbbd36a260e067$var$EventHandler.off(document, $0abbbd36a260e067$var$EVENT_KEY$v);
        $0abbbd36a260e067$var$EventHandler.on(document, $0abbbd36a260e067$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $0abbbd36a260e067$var$EventHandler.on(document, $0abbbd36a260e067$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $0abbbd36a260e067$var$EventHandler.off(document, $0abbbd36a260e067$var$EVENT_KEY$v);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $0abbbd36a260e067$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $0abbbd36a260e067$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $0abbbd36a260e067$var$TAB_KEY$1) return;
        this._lastTabNavDirection = event.shiftKey ? $0abbbd36a260e067$var$TAB_NAV_BACKWARD : $0abbbd36a260e067$var$TAB_NAV_FORWARD;
    }
};
const $0abbbd36a260e067$var$SELECTOR_FIXED_CONTENT$1 = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $0abbbd36a260e067$var$SELECTOR_STICKY_CONTENT$1 = ".sticky-top";
const $0abbbd36a260e067$var$PROPERTY_PADDING = "padding-right";
const $0abbbd36a260e067$var$PROPERTY_MARGIN = "margin-right";
class $0abbbd36a260e067$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        this._setElementAttributes(this._element, $0abbbd36a260e067$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($0abbbd36a260e067$var$SELECTOR_FIXED_CONTENT$1, $0abbbd36a260e067$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($0abbbd36a260e067$var$SELECTOR_STICKY_CONTENT$1, $0abbbd36a260e067$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $0abbbd36a260e067$var$PROPERTY_PADDING);
        this._resetElementAttributes($0abbbd36a260e067$var$SELECTOR_FIXED_CONTENT$1, $0abbbd36a260e067$var$PROPERTY_PADDING);
        this._resetElementAttributes($0abbbd36a260e067$var$SELECTOR_STICKY_CONTENT$1, $0abbbd36a260e067$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element2)=>{
            if (element2 !== this._element && window.innerWidth > element2.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element2, styleProperty);
            const calculatedValue = window.getComputedStyle(element2).getPropertyValue(styleProperty);
            element2.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element2, styleProperty) {
        const actualValue = element2.style.getPropertyValue(styleProperty);
        if (actualValue) $0abbbd36a260e067$var$Manipulator.setDataAttribute(element2, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element2)=>{
            const value = $0abbbd36a260e067$var$Manipulator.getDataAttribute(element2, styleProperty);
            if (value === null) {
                element2.style.removeProperty(styleProperty);
                return;
            }
            $0abbbd36a260e067$var$Manipulator.removeDataAttribute(element2, styleProperty);
            element2.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($0abbbd36a260e067$var$isElement$1(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $0abbbd36a260e067$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
const $0abbbd36a260e067$var$NAME$T = "offcanvas";
const $0abbbd36a260e067$var$DATA_KEY$C = "bs.offcanvas";
const $0abbbd36a260e067$var$EVENT_KEY$u = `.${$0abbbd36a260e067$var$DATA_KEY$C}`;
const $0abbbd36a260e067$var$ESCAPE_KEY$2 = "Escape";
const $0abbbd36a260e067$var$CLASS_NAME_SHOW$8 = "show";
const $0abbbd36a260e067$var$CLASS_NAME_SHOWING$1 = "showing";
const $0abbbd36a260e067$var$CLASS_NAME_HIDING = "hiding";
const $0abbbd36a260e067$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $0abbbd36a260e067$var$EVENT_SHOW$a = `show${$0abbbd36a260e067$var$EVENT_KEY$u}`;
const $0abbbd36a260e067$var$EVENT_SHOWN$9 = `shown${$0abbbd36a260e067$var$EVENT_KEY$u}`;
const $0abbbd36a260e067$var$EVENT_HIDE$9 = `hide${$0abbbd36a260e067$var$EVENT_KEY$u}`;
const $0abbbd36a260e067$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$0abbbd36a260e067$var$EVENT_KEY$u}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN$a = `hidden${$0abbbd36a260e067$var$EVENT_KEY$u}`;
const $0abbbd36a260e067$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$0abbbd36a260e067$var$EVENT_KEY$u}`;
const $0abbbd36a260e067$var$Default$x = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $0abbbd36a260e067$var$DefaultType$x = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
class $0abbbd36a260e067$export$591ca0244c9dfcd4 extends $0abbbd36a260e067$var$BaseComponent$1 {
    constructor(element2, config){
        super(element2, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$x;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$x;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$T;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOW$a, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $0abbbd36a260e067$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOW$8);
            this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOWING$1);
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOWN$9, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDE$9);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOW$8, $0abbbd36a260e067$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $0abbbd36a260e067$var$ScrollBarHelper().reset();
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN$a);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDE_PREVENTED$1);
                return;
            }
            this.hide();
        };
        const isVisible2 = Boolean(this._config.backdrop);
        return new $0abbbd36a260e067$var$Backdrop({
            className: $0abbbd36a260e067$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible2,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible2 ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $0abbbd36a260e067$var$FocusTrap$1({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $0abbbd36a260e067$var$ESCAPE_KEY$2) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDE_PREVENTED$1);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $0abbbd36a260e067$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === void 0 || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
const $0abbbd36a260e067$var$NAME$S = "swipe";
const $0abbbd36a260e067$var$EVENT_KEY$t = ".bs.swipe";
const $0abbbd36a260e067$var$EVENT_TOUCHSTART = `touchstart${$0abbbd36a260e067$var$EVENT_KEY$t}`;
const $0abbbd36a260e067$var$EVENT_TOUCHMOVE = `touchmove${$0abbbd36a260e067$var$EVENT_KEY$t}`;
const $0abbbd36a260e067$var$EVENT_TOUCHEND = `touchend${$0abbbd36a260e067$var$EVENT_KEY$t}`;
const $0abbbd36a260e067$var$EVENT_POINTERDOWN = `pointerdown${$0abbbd36a260e067$var$EVENT_KEY$t}`;
const $0abbbd36a260e067$var$EVENT_POINTERUP = `pointerup${$0abbbd36a260e067$var$EVENT_KEY$t}`;
const $0abbbd36a260e067$var$POINTER_TYPE_TOUCH = "touch";
const $0abbbd36a260e067$var$POINTER_TYPE_PEN = "pen";
const $0abbbd36a260e067$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $0abbbd36a260e067$var$SWIPE_THRESHOLD = 40;
const $0abbbd36a260e067$var$Default$w = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $0abbbd36a260e067$var$DefaultType$w = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
let $0abbbd36a260e067$var$Swipe$2 = class Swipe extends $0abbbd36a260e067$var$Config {
    constructor(element2, config){
        super();
        this._element = element2;
        if (!element2 || !Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$w;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$w;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$S;
    }
    // Public
    dispose() {
        $0abbbd36a260e067$var$EventHandler.off(this._element, $0abbbd36a260e067$var$EVENT_KEY$t);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $0abbbd36a260e067$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $0abbbd36a260e067$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $0abbbd36a260e067$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $0abbbd36a260e067$var$POINTER_TYPE_PEN || event.pointerType === $0abbbd36a260e067$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
};
const $0abbbd36a260e067$var$NAME$R = "carousel";
const $0abbbd36a260e067$var$DATA_KEY$B = "bs.carousel";
const $0abbbd36a260e067$var$EVENT_KEY$s = `.${$0abbbd36a260e067$var$DATA_KEY$B}`;
const $0abbbd36a260e067$var$ARROW_LEFT_KEY$2 = "ArrowLeft";
const $0abbbd36a260e067$var$ARROW_RIGHT_KEY$2 = "ArrowRight";
const $0abbbd36a260e067$var$TOUCHEVENT_COMPAT_WAIT = 500;
const $0abbbd36a260e067$var$ORDER_NEXT = "next";
const $0abbbd36a260e067$var$ORDER_PREV = "prev";
const $0abbbd36a260e067$var$DIRECTION_LEFT = "left";
const $0abbbd36a260e067$var$DIRECTION_RIGHT = "right";
const $0abbbd36a260e067$var$EVENT_SLIDE = `slide${$0abbbd36a260e067$var$EVENT_KEY$s}`;
const $0abbbd36a260e067$var$EVENT_SLID = `slid${$0abbbd36a260e067$var$EVENT_KEY$s}`;
const $0abbbd36a260e067$var$EVENT_KEYDOWN$3 = `keydown${$0abbbd36a260e067$var$EVENT_KEY$s}`;
const $0abbbd36a260e067$var$EVENT_MOUSEENTER$1 = `mouseenter${$0abbbd36a260e067$var$EVENT_KEY$s}`;
const $0abbbd36a260e067$var$EVENT_MOUSELEAVE$1 = `mouseleave${$0abbbd36a260e067$var$EVENT_KEY$s}`;
const $0abbbd36a260e067$var$EVENT_DRAG_START = `dragstart${$0abbbd36a260e067$var$EVENT_KEY$s}`;
const $0abbbd36a260e067$var$CLASS_NAME_CAROUSEL = "carousel";
const $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$5 = "active";
const $0abbbd36a260e067$var$CLASS_NAME_SLIDE = "slide";
const $0abbbd36a260e067$var$CLASS_NAME_END = "carousel-item-end";
const $0abbbd36a260e067$var$CLASS_NAME_START = "carousel-item-start";
const $0abbbd36a260e067$var$CLASS_NAME_NEXT = "carousel-item-next";
const $0abbbd36a260e067$var$CLASS_NAME_PREV = "carousel-item-prev";
const $0abbbd36a260e067$var$SELECTOR_ACTIVE$2 = ".active";
const $0abbbd36a260e067$var$SELECTOR_ITEM$1 = ".carousel-item";
const $0abbbd36a260e067$var$SELECTOR_ACTIVE_ITEM = $0abbbd36a260e067$var$SELECTOR_ACTIVE$2 + $0abbbd36a260e067$var$SELECTOR_ITEM$1;
const $0abbbd36a260e067$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $0abbbd36a260e067$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $0abbbd36a260e067$var$KEY_TO_DIRECTION = {
    [$0abbbd36a260e067$var$ARROW_LEFT_KEY$2]: $0abbbd36a260e067$var$DIRECTION_RIGHT,
    [$0abbbd36a260e067$var$ARROW_RIGHT_KEY$2]: $0abbbd36a260e067$var$DIRECTION_LEFT
};
const $0abbbd36a260e067$var$Default$v = {
    interval: 5e3,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $0abbbd36a260e067$var$DefaultType$v = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
let $0abbbd36a260e067$var$Carousel$1 = class Carousel extends $0abbbd36a260e067$var$BaseComponent$1 {
    constructor(element2, config){
        super(element2, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $0abbbd36a260e067$var$SelectorEngine.findOne($0abbbd36a260e067$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $0abbbd36a260e067$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$v;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$v;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$R;
    }
    // Public
    next() {
        this._slide($0abbbd36a260e067$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        if (!document.hidden && $0abbbd36a260e067$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($0abbbd36a260e067$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $0abbbd36a260e067$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $0abbbd36a260e067$var$EventHandler.one(this._element, $0abbbd36a260e067$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $0abbbd36a260e067$var$EventHandler.one(this._element, $0abbbd36a260e067$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order2 = index > activeIndex ? $0abbbd36a260e067$var$ORDER_NEXT : $0abbbd36a260e067$var$ORDER_PREV;
        this._slide(order2, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_KEYDOWN$3, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $0abbbd36a260e067$var$Swipe$2.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $0abbbd36a260e067$var$SelectorEngine.find($0abbbd36a260e067$var$SELECTOR_ITEM_IMG, this._element))$0abbbd36a260e067$var$EventHandler.on(img, $0abbbd36a260e067$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $0abbbd36a260e067$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($0abbbd36a260e067$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($0abbbd36a260e067$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $0abbbd36a260e067$var$Swipe$2(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $0abbbd36a260e067$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element2) {
        return this._getItems().indexOf(element2);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $0abbbd36a260e067$var$SelectorEngine.findOne($0abbbd36a260e067$var$SELECTOR_ACTIVE$2, this._indicatorsElement);
        activeIndicator.classList.remove($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$5);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $0abbbd36a260e067$var$SelectorEngine.findOne(`[data-mdb-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$5);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element2 = this._activeElement || this._getActive();
        if (!element2) return;
        const elementInterval = Number.parseInt(element2.getAttribute("data-mdb-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order2, element2 = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order2 === $0abbbd36a260e067$var$ORDER_NEXT;
        const nextElement = element2 || $0abbbd36a260e067$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $0abbbd36a260e067$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order2),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($0abbbd36a260e067$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $0abbbd36a260e067$var$CLASS_NAME_START : $0abbbd36a260e067$var$CLASS_NAME_END;
        const orderClassName = isNext ? $0abbbd36a260e067$var$CLASS_NAME_NEXT : $0abbbd36a260e067$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $0abbbd36a260e067$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$5);
            activeElement.classList.remove($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$5, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($0abbbd36a260e067$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($0abbbd36a260e067$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $0abbbd36a260e067$var$SelectorEngine.findOne($0abbbd36a260e067$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $0abbbd36a260e067$var$SelectorEngine.find($0abbbd36a260e067$var$SELECTOR_ITEM$1, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($0abbbd36a260e067$var$isRTL()) return direction === $0abbbd36a260e067$var$DIRECTION_LEFT ? $0abbbd36a260e067$var$ORDER_PREV : $0abbbd36a260e067$var$ORDER_NEXT;
        return direction === $0abbbd36a260e067$var$DIRECTION_LEFT ? $0abbbd36a260e067$var$ORDER_NEXT : $0abbbd36a260e067$var$ORDER_PREV;
    }
    _orderToDirection(order2) {
        if ($0abbbd36a260e067$var$isRTL()) return order2 === $0abbbd36a260e067$var$ORDER_PREV ? $0abbbd36a260e067$var$DIRECTION_LEFT : $0abbbd36a260e067$var$DIRECTION_RIGHT;
        return order2 === $0abbbd36a260e067$var$ORDER_PREV ? $0abbbd36a260e067$var$DIRECTION_RIGHT : $0abbbd36a260e067$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Carousel.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === void 0 || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
};
const $0abbbd36a260e067$var$NAME$Q = "carousel";
const $0abbbd36a260e067$var$EVENT_SLIDE_BS = "slide.bs.carousel";
const $0abbbd36a260e067$var$EVENT_SLID_BS = "slid.bs.carousel";
const $0abbbd36a260e067$var$EXTENDED_EVENTS$6 = [
    {
        name: "slide",
        parametersToCopy: [
            "relatedTarget",
            "direction",
            "from",
            "to"
        ]
    },
    {
        name: "slid",
        parametersToCopy: [
            "relatedTarget",
            "direction",
            "from",
            "to"
        ]
    }
];
class $0abbbd36a260e067$export$144901db2ea8e967 extends $0abbbd36a260e067$var$Carousel$1 {
    constructor(element2, data){
        super(element2, data);
        this._init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SLIDE_BS);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SLID_BS);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$Q;
    }
    // Private
    _init() {
        this._bindMdbEvents();
    }
    _bindMdbEvents() {
        $0abbbd36a260e067$var$EventHandler$1.extend(this._element, $0abbbd36a260e067$var$EXTENDED_EVENTS$6, $0abbbd36a260e067$var$NAME$Q);
    }
}
var $0abbbd36a260e067$var$top = "top";
var $0abbbd36a260e067$var$bottom = "bottom";
var $0abbbd36a260e067$var$right = "right";
var $0abbbd36a260e067$var$left = "left";
var $0abbbd36a260e067$var$auto = "auto";
var $0abbbd36a260e067$var$basePlacements = [
    $0abbbd36a260e067$var$top,
    $0abbbd36a260e067$var$bottom,
    $0abbbd36a260e067$var$right,
    $0abbbd36a260e067$var$left
];
var $0abbbd36a260e067$var$start = "start";
var $0abbbd36a260e067$var$end = "end";
var $0abbbd36a260e067$var$clippingParents = "clippingParents";
var $0abbbd36a260e067$var$viewport = "viewport";
var $0abbbd36a260e067$var$popper = "popper";
var $0abbbd36a260e067$var$reference = "reference";
var $0abbbd36a260e067$var$variationPlacements = /* @__PURE__ */ $0abbbd36a260e067$var$basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $0abbbd36a260e067$var$start,
        placement + "-" + $0abbbd36a260e067$var$end
    ]);
}, []);
var $0abbbd36a260e067$var$placements = /* @__PURE__ */ [].concat($0abbbd36a260e067$var$basePlacements, [
    $0abbbd36a260e067$var$auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $0abbbd36a260e067$var$start,
        placement + "-" + $0abbbd36a260e067$var$end
    ]);
}, []);
var $0abbbd36a260e067$var$beforeRead = "beforeRead";
var $0abbbd36a260e067$var$read = "read";
var $0abbbd36a260e067$var$afterRead = "afterRead";
var $0abbbd36a260e067$var$beforeMain = "beforeMain";
var $0abbbd36a260e067$var$main = "main";
var $0abbbd36a260e067$var$afterMain = "afterMain";
var $0abbbd36a260e067$var$beforeWrite = "beforeWrite";
var $0abbbd36a260e067$var$write = "write";
var $0abbbd36a260e067$var$afterWrite = "afterWrite";
var $0abbbd36a260e067$var$modifierPhases = [
    $0abbbd36a260e067$var$beforeRead,
    $0abbbd36a260e067$var$read,
    $0abbbd36a260e067$var$afterRead,
    $0abbbd36a260e067$var$beforeMain,
    $0abbbd36a260e067$var$main,
    $0abbbd36a260e067$var$afterMain,
    $0abbbd36a260e067$var$beforeWrite,
    $0abbbd36a260e067$var$write,
    $0abbbd36a260e067$var$afterWrite
];
function $0abbbd36a260e067$var$getNodeName(element2) {
    return element2 ? (element2.nodeName || "").toLowerCase() : null;
}
function $0abbbd36a260e067$var$getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}
function $0abbbd36a260e067$var$isElement(node) {
    var OwnElement = $0abbbd36a260e067$var$getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0abbbd36a260e067$var$isHTMLElement(node) {
    var OwnElement = $0abbbd36a260e067$var$getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0abbbd36a260e067$var$isShadowRoot(node) {
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = $0abbbd36a260e067$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
function $0abbbd36a260e067$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element2 = state.elements[name];
        if (!$0abbbd36a260e067$var$isHTMLElement(element2) || !$0abbbd36a260e067$var$getNodeName(element2)) return;
        Object.assign(element2.style, style);
        Object.keys(attributes).forEach(function(name2) {
            var value = attributes[name2];
            if (value === false) element2.removeAttribute(name2);
            else element2.setAttribute(name2, value === true ? "" : value);
        });
    });
}
function $0abbbd36a260e067$var$effect$2(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element2 = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
            var style = styleProperties.reduce(function(style2, property) {
                style2[property] = "";
                return style2;
            }, {});
            if (!$0abbbd36a260e067$var$isHTMLElement(element2) || !$0abbbd36a260e067$var$getNodeName(element2)) return;
            Object.assign(element2.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element2.removeAttribute(attribute);
            });
        });
    };
}
const $0abbbd36a260e067$var$applyStyles$1 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $0abbbd36a260e067$var$applyStyles,
    effect: $0abbbd36a260e067$var$effect$2,
    requires: [
        "computeStyles"
    ]
};
function $0abbbd36a260e067$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
var $0abbbd36a260e067$var$max = Math.max;
var $0abbbd36a260e067$var$min = Math.min;
var $0abbbd36a260e067$var$round = Math.round;
function $0abbbd36a260e067$var$getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}
function $0abbbd36a260e067$var$isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test($0abbbd36a260e067$var$getUAString());
}
function $0abbbd36a260e067$var$getBoundingClientRect(element2, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element2.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && $0abbbd36a260e067$var$isHTMLElement(element2)) {
        scaleX = element2.offsetWidth > 0 ? $0abbbd36a260e067$var$round(clientRect.width) / element2.offsetWidth || 1 : 1;
        scaleY = element2.offsetHeight > 0 ? $0abbbd36a260e067$var$round(clientRect.height) / element2.offsetHeight || 1 : 1;
    }
    var _ref = $0abbbd36a260e067$var$isElement(element2) ? $0abbbd36a260e067$var$getWindow(element2) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !$0abbbd36a260e067$var$isLayoutViewport() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}
function $0abbbd36a260e067$var$getLayoutRect(element2) {
    var clientRect = $0abbbd36a260e067$var$getBoundingClientRect(element2);
    var width = element2.offsetWidth;
    var height = element2.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element2.offsetLeft,
        y: element2.offsetTop,
        width: width,
        height: height
    };
}
function $0abbbd36a260e067$var$contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode();
    if (parent.contains(child)) return true;
    else if (rootNode && $0abbbd36a260e067$var$isShadowRoot(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
            next = next.parentNode || next.host;
        }while (next);
    }
    return false;
}
function $0abbbd36a260e067$var$getComputedStyle$1(element2) {
    return $0abbbd36a260e067$var$getWindow(element2).getComputedStyle(element2);
}
function $0abbbd36a260e067$var$isTableElement(element2) {
    return [
        "table",
        "td",
        "th"
    ].indexOf($0abbbd36a260e067$var$getNodeName(element2)) >= 0;
}
function $0abbbd36a260e067$var$getDocumentElement(element2) {
    return (($0abbbd36a260e067$var$isElement(element2) ? element2.ownerDocument : // $FlowFixMe[prop-missing]
    element2.document) || window.document).documentElement;
}
function $0abbbd36a260e067$var$getParentNode(element2) {
    if ($0abbbd36a260e067$var$getNodeName(element2) === "html") return element2;
    return(// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element2.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element2.parentNode || // DOM Element detected
    ($0abbbd36a260e067$var$isShadowRoot(element2) ? element2.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    $0abbbd36a260e067$var$getDocumentElement(element2));
}
function $0abbbd36a260e067$var$getTrueOffsetParent(element2) {
    if (!$0abbbd36a260e067$var$isHTMLElement(element2) || // https://github.com/popperjs/popper-core/issues/837
    $0abbbd36a260e067$var$getComputedStyle$1(element2).position === "fixed") return null;
    return element2.offsetParent;
}
function $0abbbd36a260e067$var$getContainingBlock(element2) {
    var isFirefox = /firefox/i.test($0abbbd36a260e067$var$getUAString());
    var isIE = /Trident/i.test($0abbbd36a260e067$var$getUAString());
    if (isIE && $0abbbd36a260e067$var$isHTMLElement(element2)) {
        var elementCss = $0abbbd36a260e067$var$getComputedStyle$1(element2);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = $0abbbd36a260e067$var$getParentNode(element2);
    if ($0abbbd36a260e067$var$isShadowRoot(currentNode)) currentNode = currentNode.host;
    while($0abbbd36a260e067$var$isHTMLElement(currentNode) && [
        "html",
        "body"
    ].indexOf($0abbbd36a260e067$var$getNodeName(currentNode)) < 0){
        var css = $0abbbd36a260e067$var$getComputedStyle$1(currentNode);
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
}
function $0abbbd36a260e067$var$getOffsetParent(element2) {
    var window2 = $0abbbd36a260e067$var$getWindow(element2);
    var offsetParent = $0abbbd36a260e067$var$getTrueOffsetParent(element2);
    while(offsetParent && $0abbbd36a260e067$var$isTableElement(offsetParent) && $0abbbd36a260e067$var$getComputedStyle$1(offsetParent).position === "static")offsetParent = $0abbbd36a260e067$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ($0abbbd36a260e067$var$getNodeName(offsetParent) === "html" || $0abbbd36a260e067$var$getNodeName(offsetParent) === "body" && $0abbbd36a260e067$var$getComputedStyle$1(offsetParent).position === "static")) return window2;
    return offsetParent || $0abbbd36a260e067$var$getContainingBlock(element2) || window2;
}
function $0abbbd36a260e067$var$getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}
function $0abbbd36a260e067$var$within(min$1, value, max$1) {
    return $0abbbd36a260e067$var$max(min$1, $0abbbd36a260e067$var$min(value, max$1));
}
function $0abbbd36a260e067$var$withinMaxClamp(min2, value, max2) {
    var v = $0abbbd36a260e067$var$within(min2, value, max2);
    return v > max2 ? max2 : v;
}
function $0abbbd36a260e067$var$getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}
function $0abbbd36a260e067$var$mergePaddingObject(paddingObject) {
    return Object.assign({}, $0abbbd36a260e067$var$getFreshSideObject(), paddingObject);
}
function $0abbbd36a260e067$var$expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}
var $0abbbd36a260e067$var$toPaddingObject = function toPaddingObject2(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return $0abbbd36a260e067$var$mergePaddingObject(typeof padding !== "number" ? padding : $0abbbd36a260e067$var$expandToHashMap(padding, $0abbbd36a260e067$var$basePlacements));
};
function $0abbbd36a260e067$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets2 = state.modifiersData.popperOffsets;
    var basePlacement = $0abbbd36a260e067$var$getBasePlacement(state.placement);
    var axis = $0abbbd36a260e067$var$getMainAxisFromPlacement(basePlacement);
    var isVertical = [
        $0abbbd36a260e067$var$left,
        $0abbbd36a260e067$var$right
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets2) return;
    var paddingObject = $0abbbd36a260e067$var$toPaddingObject(options.padding, state);
    var arrowRect = $0abbbd36a260e067$var$getLayoutRect(arrowElement);
    var minProp = axis === "y" ? $0abbbd36a260e067$var$top : $0abbbd36a260e067$var$left;
    var maxProp = axis === "y" ? $0abbbd36a260e067$var$bottom : $0abbbd36a260e067$var$right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
    var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
    var arrowOffsetParent = $0abbbd36a260e067$var$getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2;
    var min2 = paddingObject[minProp];
    var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset2 = $0abbbd36a260e067$var$within(min2, center, max2);
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function $0abbbd36a260e067$var$effect$1(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!$0abbbd36a260e067$var$contains(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
}
const $0abbbd36a260e067$var$arrow$1 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $0abbbd36a260e067$var$arrow,
    effect: $0abbbd36a260e067$var$effect$1,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};
function $0abbbd36a260e067$var$getVariation(placement) {
    return placement.split("-")[1];
}
var $0abbbd36a260e067$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
};
function $0abbbd36a260e067$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: $0abbbd36a260e067$var$round(x * dpr) / dpr || 0,
        y: $0abbbd36a260e067$var$round(y * dpr) / dpr || 0
    };
}
function $0abbbd36a260e067$var$mapToStyles(_ref2) {
    var _Object$assign2;
    var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = $0abbbd36a260e067$var$left;
    var sideY = $0abbbd36a260e067$var$top;
    var win = window;
    if (adaptive) {
        var offsetParent = $0abbbd36a260e067$var$getOffsetParent(popper2);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === $0abbbd36a260e067$var$getWindow(popper2)) {
            offsetParent = $0abbbd36a260e067$var$getDocumentElement(popper2);
            if ($0abbbd36a260e067$var$getComputedStyle$1(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        }
        offsetParent;
        if (placement === $0abbbd36a260e067$var$top || (placement === $0abbbd36a260e067$var$left || placement === $0abbbd36a260e067$var$right) && variation === $0abbbd36a260e067$var$end) {
            sideY = $0abbbd36a260e067$var$bottom;
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
            offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === $0abbbd36a260e067$var$left || (placement === $0abbbd36a260e067$var$top || placement === $0abbbd36a260e067$var$bottom) && variation === $0abbbd36a260e067$var$end) {
            sideX = $0abbbd36a260e067$var$right;
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
            offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $0abbbd36a260e067$var$unsetSides);
    var _ref4 = roundOffsets === true ? $0abbbd36a260e067$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, $0abbbd36a260e067$var$getWindow(popper2)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $0abbbd36a260e067$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: $0abbbd36a260e067$var$getBasePlacement(state.placement),
        variation: $0abbbd36a260e067$var$getVariation(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $0abbbd36a260e067$var$mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $0abbbd36a260e067$var$mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
}
const $0abbbd36a260e067$var$computeStyles$1 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $0abbbd36a260e067$var$computeStyles,
    data: {}
};
var $0abbbd36a260e067$var$passive = {
    passive: true
};
function $0abbbd36a260e067$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window2 = $0abbbd36a260e067$var$getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $0abbbd36a260e067$var$passive);
    });
    if (resize) window2.addEventListener("resize", instance.update, $0abbbd36a260e067$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $0abbbd36a260e067$var$passive);
        });
        if (resize) window2.removeEventListener("resize", instance.update, $0abbbd36a260e067$var$passive);
    };
}
const $0abbbd36a260e067$var$eventListeners = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $0abbbd36a260e067$var$effect,
    data: {}
};
var $0abbbd36a260e067$var$hash$1 = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $0abbbd36a260e067$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $0abbbd36a260e067$var$hash$1[matched];
    });
}
var $0abbbd36a260e067$var$hash = {
    start: "end",
    end: "start"
};
function $0abbbd36a260e067$var$getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $0abbbd36a260e067$var$hash[matched];
    });
}
function $0abbbd36a260e067$var$getWindowScroll(node) {
    var win = $0abbbd36a260e067$var$getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}
function $0abbbd36a260e067$var$getWindowScrollBarX(element2) {
    return $0abbbd36a260e067$var$getBoundingClientRect($0abbbd36a260e067$var$getDocumentElement(element2)).left + $0abbbd36a260e067$var$getWindowScroll(element2).scrollLeft;
}
function $0abbbd36a260e067$var$getViewportRect(element2, strategy) {
    var win = $0abbbd36a260e067$var$getWindow(element2);
    var html = $0abbbd36a260e067$var$getDocumentElement(element2);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = $0abbbd36a260e067$var$isLayoutViewport();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + $0abbbd36a260e067$var$getWindowScrollBarX(element2),
        y: y
    };
}
function $0abbbd36a260e067$var$getDocumentRect(element2) {
    var _element$ownerDocumen;
    var html = $0abbbd36a260e067$var$getDocumentElement(element2);
    var winScroll = $0abbbd36a260e067$var$getWindowScroll(element2);
    var body = (_element$ownerDocumen = element2.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = $0abbbd36a260e067$var$max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = $0abbbd36a260e067$var$max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + $0abbbd36a260e067$var$getWindowScrollBarX(element2);
    var y = -winScroll.scrollTop;
    if ($0abbbd36a260e067$var$getComputedStyle$1(body || html).direction === "rtl") x += $0abbbd36a260e067$var$max(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $0abbbd36a260e067$var$isScrollParent(element2) {
    var _getComputedStyle = $0abbbd36a260e067$var$getComputedStyle$1(element2), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function $0abbbd36a260e067$var$getScrollParent(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf($0abbbd36a260e067$var$getNodeName(node)) >= 0) return node.ownerDocument.body;
    if ($0abbbd36a260e067$var$isHTMLElement(node) && $0abbbd36a260e067$var$isScrollParent(node)) return node;
    return $0abbbd36a260e067$var$getScrollParent($0abbbd36a260e067$var$getParentNode(node));
}
function $0abbbd36a260e067$var$listScrollParents(element2, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = $0abbbd36a260e067$var$getScrollParent(element2);
    var isBody = scrollParent === ((_element$ownerDocumen = element2.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = $0abbbd36a260e067$var$getWindow(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], $0abbbd36a260e067$var$isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat($0abbbd36a260e067$var$listScrollParents($0abbbd36a260e067$var$getParentNode(target)));
}
function $0abbbd36a260e067$var$rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}
function $0abbbd36a260e067$var$getInnerBoundingClientRect(element2, strategy) {
    var rect = $0abbbd36a260e067$var$getBoundingClientRect(element2, false, strategy === "fixed");
    rect.top = rect.top + element2.clientTop;
    rect.left = rect.left + element2.clientLeft;
    rect.bottom = rect.top + element2.clientHeight;
    rect.right = rect.left + element2.clientWidth;
    rect.width = element2.clientWidth;
    rect.height = element2.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $0abbbd36a260e067$var$getClientRectFromMixedType(element2, clippingParent, strategy) {
    return clippingParent === $0abbbd36a260e067$var$viewport ? $0abbbd36a260e067$var$rectToClientRect($0abbbd36a260e067$var$getViewportRect(element2, strategy)) : $0abbbd36a260e067$var$isElement(clippingParent) ? $0abbbd36a260e067$var$getInnerBoundingClientRect(clippingParent, strategy) : $0abbbd36a260e067$var$rectToClientRect($0abbbd36a260e067$var$getDocumentRect($0abbbd36a260e067$var$getDocumentElement(element2)));
}
function $0abbbd36a260e067$var$getClippingParents(element2) {
    var clippingParents2 = $0abbbd36a260e067$var$listScrollParents($0abbbd36a260e067$var$getParentNode(element2));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf($0abbbd36a260e067$var$getComputedStyle$1(element2).position) >= 0;
    var clipperElement = canEscapeClipping && $0abbbd36a260e067$var$isHTMLElement(element2) ? $0abbbd36a260e067$var$getOffsetParent(element2) : element2;
    if (!$0abbbd36a260e067$var$isElement(clipperElement)) return [];
    return clippingParents2.filter(function(clippingParent) {
        return $0abbbd36a260e067$var$isElement(clippingParent) && $0abbbd36a260e067$var$contains(clippingParent, clipperElement) && $0abbbd36a260e067$var$getNodeName(clippingParent) !== "body";
    });
}
function $0abbbd36a260e067$var$getClippingRect(element2, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $0abbbd36a260e067$var$getClippingParents(element2) : [].concat(boundary);
    var clippingParents2 = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents2[0];
    var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
        var rect = $0abbbd36a260e067$var$getClientRectFromMixedType(element2, clippingParent, strategy);
        accRect.top = $0abbbd36a260e067$var$max(rect.top, accRect.top);
        accRect.right = $0abbbd36a260e067$var$min(rect.right, accRect.right);
        accRect.bottom = $0abbbd36a260e067$var$min(rect.bottom, accRect.bottom);
        accRect.left = $0abbbd36a260e067$var$max(rect.left, accRect.left);
        return accRect;
    }, $0abbbd36a260e067$var$getClientRectFromMixedType(element2, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}
function $0abbbd36a260e067$var$computeOffsets(_ref) {
    var reference2 = _ref.reference, element2 = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? $0abbbd36a260e067$var$getBasePlacement(placement) : null;
    var variation = placement ? $0abbbd36a260e067$var$getVariation(placement) : null;
    var commonX = reference2.x + reference2.width / 2 - element2.width / 2;
    var commonY = reference2.y + reference2.height / 2 - element2.height / 2;
    var offsets;
    switch(basePlacement){
        case $0abbbd36a260e067$var$top:
            offsets = {
                x: commonX,
                y: reference2.y - element2.height
            };
            break;
        case $0abbbd36a260e067$var$bottom:
            offsets = {
                x: commonX,
                y: reference2.y + reference2.height
            };
            break;
        case $0abbbd36a260e067$var$right:
            offsets = {
                x: reference2.x + reference2.width,
                y: commonY
            };
            break;
        case $0abbbd36a260e067$var$left:
            offsets = {
                x: reference2.x - element2.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference2.x,
                y: reference2.y
            };
    }
    var mainAxis = basePlacement ? $0abbbd36a260e067$var$getMainAxisFromPlacement(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case $0abbbd36a260e067$var$start:
                offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element2[len] / 2);
                break;
            case $0abbbd36a260e067$var$end:
                offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element2[len] / 2);
                break;
        }
    }
    return offsets;
}
function $0abbbd36a260e067$var$detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? $0abbbd36a260e067$var$clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? $0abbbd36a260e067$var$viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? $0abbbd36a260e067$var$popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = $0abbbd36a260e067$var$mergePaddingObject(typeof padding !== "number" ? padding : $0abbbd36a260e067$var$expandToHashMap(padding, $0abbbd36a260e067$var$basePlacements));
    var altContext = elementContext === $0abbbd36a260e067$var$popper ? $0abbbd36a260e067$var$reference : $0abbbd36a260e067$var$popper;
    var popperRect = state.rects.popper;
    var element2 = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = $0abbbd36a260e067$var$getClippingRect($0abbbd36a260e067$var$isElement(element2) ? element2 : element2.contextElement || $0abbbd36a260e067$var$getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = $0abbbd36a260e067$var$getBoundingClientRect(state.elements.reference);
    var popperOffsets2 = $0abbbd36a260e067$var$computeOffsets({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = $0abbbd36a260e067$var$rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
    var elementClientRect = elementContext === $0abbbd36a260e067$var$popper ? popperClientRect : referenceClientRect;
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset;
    if (elementContext === $0abbbd36a260e067$var$popper && offsetData) {
        var offset2 = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                $0abbbd36a260e067$var$right,
                $0abbbd36a260e067$var$bottom
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                $0abbbd36a260e067$var$top,
                $0abbbd36a260e067$var$bottom
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset2[axis] * multiply;
        });
    }
    return overflowOffsets;
}
function $0abbbd36a260e067$var$computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? $0abbbd36a260e067$var$placements : _options$allowedAutoP;
    var variation = $0abbbd36a260e067$var$getVariation(placement);
    var placements$1 = variation ? flipVariations ? $0abbbd36a260e067$var$variationPlacements : $0abbbd36a260e067$var$variationPlacements.filter(function(placement2) {
        return $0abbbd36a260e067$var$getVariation(placement2) === variation;
    }) : $0abbbd36a260e067$var$basePlacements;
    var allowedPlacements = placements$1.filter(function(placement2) {
        return allowedAutoPlacements.indexOf(placement2) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements$1;
    var overflows = allowedPlacements.reduce(function(acc, placement2) {
        acc[placement2] = $0abbbd36a260e067$var$detectOverflow(state, {
            placement: placement2,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[$0abbbd36a260e067$var$getBasePlacement(placement2)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}
function $0abbbd36a260e067$var$getExpandedFallbackPlacements(placement) {
    if ($0abbbd36a260e067$var$getBasePlacement(placement) === $0abbbd36a260e067$var$auto) return [];
    var oppositePlacement = $0abbbd36a260e067$var$getOppositePlacement(placement);
    return [
        $0abbbd36a260e067$var$getOppositeVariationPlacement(placement),
        oppositePlacement,
        $0abbbd36a260e067$var$getOppositeVariationPlacement(oppositePlacement)
    ];
}
function $0abbbd36a260e067$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = $0abbbd36a260e067$var$getBasePlacement(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        $0abbbd36a260e067$var$getOppositePlacement(preferredPlacement)
    ] : $0abbbd36a260e067$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements2 = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement2) {
        return acc.concat($0abbbd36a260e067$var$getBasePlacement(placement2) === $0abbbd36a260e067$var$auto ? $0abbbd36a260e067$var$computeAutoPlacement(state, {
            placement: placement2,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement2);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = /* @__PURE__ */ new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements2[0];
    for(var i = 0; i < placements2.length; i++){
        var placement = placements2[i];
        var _basePlacement = $0abbbd36a260e067$var$getBasePlacement(placement);
        var isStartVariation = $0abbbd36a260e067$var$getVariation(placement) === $0abbbd36a260e067$var$start;
        var isVertical = [
            $0abbbd36a260e067$var$top,
            $0abbbd36a260e067$var$bottom
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = $0abbbd36a260e067$var$detectOverflow(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? $0abbbd36a260e067$var$right : $0abbbd36a260e067$var$left : isStartVariation ? $0abbbd36a260e067$var$bottom : $0abbbd36a260e067$var$top;
        if (referenceRect[len] > popperRect[len]) mainVariationSide = $0abbbd36a260e067$var$getOppositePlacement(mainVariationSide);
        var altVariationSide = $0abbbd36a260e067$var$getOppositePlacement(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop2(_i2) {
            var fittingPlacement = placements2.find(function(placement2) {
                var checks2 = checksMap.get(placement2);
                if (checks2) return checks2.slice(0, _i2).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
}
const $0abbbd36a260e067$var$flip$1 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $0abbbd36a260e067$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};
function $0abbbd36a260e067$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $0abbbd36a260e067$var$isAnySideFullyClipped(overflow) {
    return [
        $0abbbd36a260e067$var$top,
        $0abbbd36a260e067$var$right,
        $0abbbd36a260e067$var$bottom,
        $0abbbd36a260e067$var$left
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $0abbbd36a260e067$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = $0abbbd36a260e067$var$detectOverflow(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = $0abbbd36a260e067$var$detectOverflow(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $0abbbd36a260e067$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $0abbbd36a260e067$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $0abbbd36a260e067$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $0abbbd36a260e067$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
}
const $0abbbd36a260e067$var$hide$1 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $0abbbd36a260e067$var$hide
};
function $0abbbd36a260e067$var$distanceAndSkiddingToXY(placement, rects, offset2) {
    var basePlacement = $0abbbd36a260e067$var$getBasePlacement(placement);
    var invertDistance = [
        $0abbbd36a260e067$var$left,
        $0abbbd36a260e067$var$top
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
        placement: placement
    })) : offset2, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        $0abbbd36a260e067$var$left,
        $0abbbd36a260e067$var$right
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $0abbbd36a260e067$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = $0abbbd36a260e067$var$placements.reduce(function(acc, placement) {
        acc[placement] = $0abbbd36a260e067$var$distanceAndSkiddingToXY(placement, state.rects, offset2);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
}
const $0abbbd36a260e067$var$offset$1 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $0abbbd36a260e067$var$offset
};
function $0abbbd36a260e067$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    state.modifiersData[name] = $0abbbd36a260e067$var$computeOffsets({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
}
const $0abbbd36a260e067$var$popperOffsets$1 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $0abbbd36a260e067$var$popperOffsets,
    data: {}
};
function $0abbbd36a260e067$var$getAltAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function $0abbbd36a260e067$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = $0abbbd36a260e067$var$detectOverflow(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = $0abbbd36a260e067$var$getBasePlacement(state.placement);
    var variation = $0abbbd36a260e067$var$getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = $0abbbd36a260e067$var$getMainAxisFromPlacement(basePlacement);
    var altAxis = $0abbbd36a260e067$var$getAltAxis(mainAxis);
    var popperOffsets2 = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets2) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? $0abbbd36a260e067$var$top : $0abbbd36a260e067$var$left;
        var altSide = mainAxis === "y" ? $0abbbd36a260e067$var$bottom : $0abbbd36a260e067$var$right;
        var len = mainAxis === "y" ? "height" : "width";
        var offset2 = popperOffsets2[mainAxis];
        var min$1 = offset2 + overflow[mainSide];
        var max$1 = offset2 - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === $0abbbd36a260e067$var$start ? referenceRect[len] : popperRect[len];
        var maxLen = variation === $0abbbd36a260e067$var$start ? -popperRect[len] : -referenceRect[len];
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? $0abbbd36a260e067$var$getLayoutRect(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : $0abbbd36a260e067$var$getFreshSideObject();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide];
        var arrowLen = $0abbbd36a260e067$var$within(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && $0abbbd36a260e067$var$getOffsetParent(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset2 + maxOffset - offsetModifierValue;
        var preventedOffset = $0abbbd36a260e067$var$within(tether ? $0abbbd36a260e067$var$min(min$1, tetherMin) : min$1, offset2, tether ? $0abbbd36a260e067$var$max(max$1, tetherMax) : max$1);
        popperOffsets2[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset2;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? $0abbbd36a260e067$var$top : $0abbbd36a260e067$var$left;
        var _altSide = mainAxis === "x" ? $0abbbd36a260e067$var$bottom : $0abbbd36a260e067$var$right;
        var _offset = popperOffsets2[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            $0abbbd36a260e067$var$top,
            $0abbbd36a260e067$var$left
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? $0abbbd36a260e067$var$withinMaxClamp(_tetherMin, _offset, _tetherMax) : $0abbbd36a260e067$var$within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets2[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
}
const $0abbbd36a260e067$var$preventOverflow$1 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $0abbbd36a260e067$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};
function $0abbbd36a260e067$var$getHTMLElementScroll(element2) {
    return {
        scrollLeft: element2.scrollLeft,
        scrollTop: element2.scrollTop
    };
}
function $0abbbd36a260e067$var$getNodeScroll(node) {
    if (node === $0abbbd36a260e067$var$getWindow(node) || !$0abbbd36a260e067$var$isHTMLElement(node)) return $0abbbd36a260e067$var$getWindowScroll(node);
    else return $0abbbd36a260e067$var$getHTMLElementScroll(node);
}
function $0abbbd36a260e067$var$isElementScaled(element2) {
    var rect = element2.getBoundingClientRect();
    var scaleX = $0abbbd36a260e067$var$round(rect.width) / element2.offsetWidth || 1;
    var scaleY = $0abbbd36a260e067$var$round(rect.height) / element2.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
}
function $0abbbd36a260e067$var$getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = $0abbbd36a260e067$var$isHTMLElement(offsetParent);
    var offsetParentIsScaled = $0abbbd36a260e067$var$isHTMLElement(offsetParent) && $0abbbd36a260e067$var$isElementScaled(offsetParent);
    var documentElement = $0abbbd36a260e067$var$getDocumentElement(offsetParent);
    var rect = $0abbbd36a260e067$var$getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($0abbbd36a260e067$var$getNodeName(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        $0abbbd36a260e067$var$isScrollParent(documentElement)) scroll = $0abbbd36a260e067$var$getNodeScroll(offsetParent);
        if ($0abbbd36a260e067$var$isHTMLElement(offsetParent)) {
            offsets = $0abbbd36a260e067$var$getBoundingClientRect(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = $0abbbd36a260e067$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $0abbbd36a260e067$var$order(modifiers) {
    var map = /* @__PURE__ */ new Map();
    var visited = /* @__PURE__ */ new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    });
    function sort2(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort2(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) sort2(modifier);
    });
    return result;
}
function $0abbbd36a260e067$var$orderModifiers(modifiers) {
    var orderedModifiers = $0abbbd36a260e067$var$order(modifiers);
    return $0abbbd36a260e067$var$modifierPhases.reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}
function $0abbbd36a260e067$var$debounce(fn2) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = void 0;
                resolve(fn2());
            });
        });
        return pending;
    };
}
function $0abbbd36a260e067$var$mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged2, current) {
        var existing = merged2[current.name];
        merged2[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged2;
    }, {});
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}
var $0abbbd36a260e067$var$DEFAULT_OPTIONS$d = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $0abbbd36a260e067$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element2) {
        return !(element2 && typeof element2.getBoundingClientRect === "function");
    });
}
function $0abbbd36a260e067$var$popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $0abbbd36a260e067$var$DEFAULT_OPTIONS$d : _generatorOptions$def2;
    return function createPopper2(reference2, popper2, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $0abbbd36a260e067$var$DEFAULT_OPTIONS$d, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference2,
                popper: popper2
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options2);
                state.scrollParents = {
                    reference: $0abbbd36a260e067$var$isElement(reference2) ? $0abbbd36a260e067$var$listScrollParents(reference2) : reference2.contextElement ? $0abbbd36a260e067$var$listScrollParents(reference2.contextElement) : [],
                    popper: $0abbbd36a260e067$var$listScrollParents(popper2)
                };
                var orderedModifiers = $0abbbd36a260e067$var$orderModifiers($0abbbd36a260e067$var$mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
                if (!$0abbbd36a260e067$var$areValidElements(reference3, popper3)) return;
                state.rects = {
                    reference: $0abbbd36a260e067$var$getCompositeRect(reference3, $0abbbd36a260e067$var$getOffsetParent(popper3), state.options.strategy === "fixed"),
                    popper: $0abbbd36a260e067$var$getLayoutRect(popper3)
                };
                state.reset = false;
                state.placement = state.options.placement;
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn2 === "function") state = fn2({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: $0abbbd36a260e067$var$debounce(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$0abbbd36a260e067$var$areValidElements(reference2, popper2)) return instance;
        instance.setOptions(options).then(function(state2) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state2);
        });
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options2 = _ref$options === void 0 ? {} : _ref$options, effect2 = _ref.effect;
                if (typeof effect2 === "function") {
                    var cleanupFn = effect2({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options2
                    });
                    var noopFn = function noopFn2() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn2) {
                return fn2();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $0abbbd36a260e067$var$createPopper$2 = /* @__PURE__ */ $0abbbd36a260e067$var$popperGenerator();
var $0abbbd36a260e067$var$defaultModifiers$1 = [
    $0abbbd36a260e067$var$eventListeners,
    $0abbbd36a260e067$var$popperOffsets$1,
    $0abbbd36a260e067$var$computeStyles$1,
    $0abbbd36a260e067$var$applyStyles$1
];
var $0abbbd36a260e067$var$createPopper$1 = /* @__PURE__ */ $0abbbd36a260e067$var$popperGenerator({
    defaultModifiers: $0abbbd36a260e067$var$defaultModifiers$1
});
var $0abbbd36a260e067$var$defaultModifiers = [
    $0abbbd36a260e067$var$eventListeners,
    $0abbbd36a260e067$var$popperOffsets$1,
    $0abbbd36a260e067$var$computeStyles$1,
    $0abbbd36a260e067$var$applyStyles$1,
    $0abbbd36a260e067$var$offset$1,
    $0abbbd36a260e067$var$flip$1,
    $0abbbd36a260e067$var$preventOverflow$1,
    $0abbbd36a260e067$var$arrow$1,
    $0abbbd36a260e067$var$hide$1
];
var $0abbbd36a260e067$var$createPopper = /* @__PURE__ */ $0abbbd36a260e067$var$popperGenerator({
    defaultModifiers: $0abbbd36a260e067$var$defaultModifiers
});
const $0abbbd36a260e067$var$Popper = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    afterMain: $0abbbd36a260e067$var$afterMain,
    afterRead: $0abbbd36a260e067$var$afterRead,
    afterWrite: $0abbbd36a260e067$var$afterWrite,
    applyStyles: $0abbbd36a260e067$var$applyStyles$1,
    arrow: $0abbbd36a260e067$var$arrow$1,
    auto: $0abbbd36a260e067$var$auto,
    basePlacements: $0abbbd36a260e067$var$basePlacements,
    beforeMain: $0abbbd36a260e067$var$beforeMain,
    beforeRead: $0abbbd36a260e067$var$beforeRead,
    beforeWrite: $0abbbd36a260e067$var$beforeWrite,
    bottom: $0abbbd36a260e067$var$bottom,
    clippingParents: $0abbbd36a260e067$var$clippingParents,
    computeStyles: $0abbbd36a260e067$var$computeStyles$1,
    createPopper: $0abbbd36a260e067$var$createPopper,
    createPopperBase: $0abbbd36a260e067$var$createPopper$2,
    createPopperLite: $0abbbd36a260e067$var$createPopper$1,
    detectOverflow: $0abbbd36a260e067$var$detectOverflow,
    end: $0abbbd36a260e067$var$end,
    eventListeners: $0abbbd36a260e067$var$eventListeners,
    flip: $0abbbd36a260e067$var$flip$1,
    hide: $0abbbd36a260e067$var$hide$1,
    left: $0abbbd36a260e067$var$left,
    main: $0abbbd36a260e067$var$main,
    modifierPhases: $0abbbd36a260e067$var$modifierPhases,
    offset: $0abbbd36a260e067$var$offset$1,
    placements: $0abbbd36a260e067$var$placements,
    popper: $0abbbd36a260e067$var$popper,
    popperGenerator: $0abbbd36a260e067$var$popperGenerator,
    popperOffsets: $0abbbd36a260e067$var$popperOffsets$1,
    preventOverflow: $0abbbd36a260e067$var$preventOverflow$1,
    read: $0abbbd36a260e067$var$read,
    reference: $0abbbd36a260e067$var$reference,
    right: $0abbbd36a260e067$var$right,
    start: $0abbbd36a260e067$var$start,
    top: $0abbbd36a260e067$var$top,
    variationPlacements: $0abbbd36a260e067$var$variationPlacements,
    viewport: $0abbbd36a260e067$var$viewport,
    write: $0abbbd36a260e067$var$write
}, Symbol.toStringTag, {
    value: "Module"
}));
const $0abbbd36a260e067$var$ARIA_ATTRIBUTE_PATTERN$1 = /^aria-[\w-]*$/i;
const $0abbbd36a260e067$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $0abbbd36a260e067$var$ARIA_ATTRIBUTE_PATTERN$1
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
const $0abbbd36a260e067$var$uriAttributes = /* @__PURE__ */ new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
const $0abbbd36a260e067$var$SAFE_URL_PATTERN$1 = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $0abbbd36a260e067$var$allowedAttribute$1 = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($0abbbd36a260e067$var$uriAttributes.has(attributeName)) return Boolean($0abbbd36a260e067$var$SAFE_URL_PATTERN$1.test(attribute.nodeValue));
        return true;
    }
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $0abbbd36a260e067$var$sanitizeHtml$1(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element2 of elements){
        const elementName = element2.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element2.remove();
            continue;
        }
        const attributeList = [].concat(...element2.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$0abbbd36a260e067$var$allowedAttribute$1(attribute, allowedAttributes)) element2.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
const $0abbbd36a260e067$var$NAME$P = "TemplateFactory";
const $0abbbd36a260e067$var$Default$u = {
    allowList: $0abbbd36a260e067$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $0abbbd36a260e067$var$DefaultType$u = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $0abbbd36a260e067$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
class $0abbbd36a260e067$var$TemplateFactory extends $0abbbd36a260e067$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$u;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$u;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$P;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $0abbbd36a260e067$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $0abbbd36a260e067$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($0abbbd36a260e067$var$isElement$1(content)) {
            this._putElementInTemplate($0abbbd36a260e067$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $0abbbd36a260e067$var$sanitizeHtml$1(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $0abbbd36a260e067$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element2, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element2);
            return;
        }
        templateElement.textContent = element2.textContent;
    }
}
const $0abbbd36a260e067$var$NAME$O = "tooltip";
const $0abbbd36a260e067$var$DISALLOWED_ATTRIBUTES = /* @__PURE__ */ new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $0abbbd36a260e067$var$CLASS_NAME_FADE$5 = "fade";
const $0abbbd36a260e067$var$CLASS_NAME_MODAL = "modal";
const $0abbbd36a260e067$var$CLASS_NAME_SHOW$7 = "show";
const $0abbbd36a260e067$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $0abbbd36a260e067$var$SELECTOR_MODAL = `.${$0abbbd36a260e067$var$CLASS_NAME_MODAL}`;
const $0abbbd36a260e067$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $0abbbd36a260e067$var$TRIGGER_HOVER = "hover";
const $0abbbd36a260e067$var$TRIGGER_FOCUS = "focus";
const $0abbbd36a260e067$var$TRIGGER_CLICK = "click";
const $0abbbd36a260e067$var$TRIGGER_MANUAL = "manual";
const $0abbbd36a260e067$var$EVENT_HIDE$8 = "hide";
const $0abbbd36a260e067$var$EVENT_HIDDEN$9 = "hidden";
const $0abbbd36a260e067$var$EVENT_SHOW$9 = "show";
const $0abbbd36a260e067$var$EVENT_SHOWN$8 = "shown";
const $0abbbd36a260e067$var$EVENT_INSERTED = "inserted";
const $0abbbd36a260e067$var$EVENT_CLICK$2 = "click";
const $0abbbd36a260e067$var$EVENT_FOCUSIN$1 = "focusin";
const $0abbbd36a260e067$var$EVENT_FOCUSOUT$2 = "focusout";
const $0abbbd36a260e067$var$EVENT_MOUSEENTER = "mouseenter";
const $0abbbd36a260e067$var$EVENT_MOUSELEAVE = "mouseleave";
const $0abbbd36a260e067$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $0abbbd36a260e067$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $0abbbd36a260e067$var$isRTL() ? "right" : "left"
};
const $0abbbd36a260e067$var$Default$t = {
    allowList: $0abbbd36a260e067$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $0abbbd36a260e067$var$DefaultType$t = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
let $0abbbd36a260e067$var$Tooltip$1 = class Tooltip extends $0abbbd36a260e067$var$BaseComponent$1 {
    constructor(element2, config){
        if (typeof $0abbbd36a260e067$var$Popper === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element2, config);
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$t;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$t;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$O;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $0abbbd36a260e067$var$EventHandler.off(this._element.closest($0abbbd36a260e067$var$SELECTOR_MODAL), $0abbbd36a260e067$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-mdb-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-mdb-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, this.constructor.eventName($0abbbd36a260e067$var$EVENT_SHOW$9));
        const shadowRoot = $0abbbd36a260e067$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, this.constructor.eventName($0abbbd36a260e067$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOW$7);
        if ("ontouchstart" in document.documentElement) for (const element2 of [].concat(...document.body.children))$0abbbd36a260e067$var$EventHandler.on(element2, "mouseover", $0abbbd36a260e067$var$noop);
        const complete = ()=>{
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, this.constructor.eventName($0abbbd36a260e067$var$EVENT_SHOWN$8));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, this.constructor.eventName($0abbbd36a260e067$var$EVENT_HIDE$8));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOW$7);
        if ("ontouchstart" in document.documentElement) for (const element2 of [].concat(...document.body.children))$0abbbd36a260e067$var$EventHandler.off(element2, "mouseover", $0abbbd36a260e067$var$noop);
        this._activeTrigger[$0abbbd36a260e067$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$0abbbd36a260e067$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$0abbbd36a260e067$var$TRIGGER_HOVER] = false;
        this._isHovered = null;
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, this.constructor.eventName($0abbbd36a260e067$var$EVENT_HIDDEN$9));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        if (!tip) return null;
        tip.classList.remove($0abbbd36a260e067$var$CLASS_NAME_FADE$5, $0abbbd36a260e067$var$CLASS_NAME_SHOW$7);
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $0abbbd36a260e067$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($0abbbd36a260e067$var$CLASS_NAME_FADE$5);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $0abbbd36a260e067$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$0abbbd36a260e067$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-mdb-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($0abbbd36a260e067$var$CLASS_NAME_FADE$5);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($0abbbd36a260e067$var$CLASS_NAME_SHOW$7);
    }
    _createPopper(tip) {
        const placement = $0abbbd36a260e067$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $0abbbd36a260e067$var$AttachmentMap[placement.toUpperCase()];
        return $0abbbd36a260e067$var$createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset2 } = this._config;
        if (typeof offset2 === "string") return offset2.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset2 === "function") return (popperData)=>offset2(popperData, this._element);
        return offset2;
    }
    _resolvePossibleFunction(arg) {
        return $0abbbd36a260e067$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$0abbbd36a260e067$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $0abbbd36a260e067$var$EventHandler.on(this._element, this.constructor.eventName($0abbbd36a260e067$var$EVENT_CLICK$2), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $0abbbd36a260e067$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $0abbbd36a260e067$var$TRIGGER_HOVER ? this.constructor.eventName($0abbbd36a260e067$var$EVENT_MOUSEENTER) : this.constructor.eventName($0abbbd36a260e067$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $0abbbd36a260e067$var$TRIGGER_HOVER ? this.constructor.eventName($0abbbd36a260e067$var$EVENT_MOUSELEAVE) : this.constructor.eventName($0abbbd36a260e067$var$EVENT_FOCUSOUT$2);
                $0abbbd36a260e067$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $0abbbd36a260e067$var$TRIGGER_FOCUS : $0abbbd36a260e067$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $0abbbd36a260e067$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $0abbbd36a260e067$var$TRIGGER_FOCUS : $0abbbd36a260e067$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $0abbbd36a260e067$var$EventHandler.on(this._element.closest($0abbbd36a260e067$var$SELECTOR_MODAL), $0abbbd36a260e067$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-mdb-original-title", title);
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($0abbbd36a260e067$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $0abbbd36a260e067$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Tooltip.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
};
const $0abbbd36a260e067$var$NAME$N = "popover";
const $0abbbd36a260e067$var$SELECTOR_TITLE = ".popover-header";
const $0abbbd36a260e067$var$SELECTOR_CONTENT = ".popover-body";
const $0abbbd36a260e067$var$Default$s = {
    ...$0abbbd36a260e067$var$Tooltip$1.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $0abbbd36a260e067$var$DefaultType$s = {
    ...$0abbbd36a260e067$var$Tooltip$1.DefaultType,
    content: "(null|string|element|function)"
};
let $0abbbd36a260e067$var$Popover$1 = class Popover extends $0abbbd36a260e067$var$Tooltip$1 {
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$s;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$s;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$N;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$0abbbd36a260e067$var$SELECTOR_TITLE]: this._getTitle(),
            [$0abbbd36a260e067$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Popover.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
};
const $0abbbd36a260e067$var$NAME$M = "popover";
const $0abbbd36a260e067$var$EVENT_SHOW_BS$4 = "show.bs.popover";
const $0abbbd36a260e067$var$EVENT_SHOWN_BS$4 = "shown.bs.popover";
const $0abbbd36a260e067$var$EVENT_HIDE_BS$4 = "hide.bs.popover";
const $0abbbd36a260e067$var$EVENT_HIDDEN_BS$4 = "hidden.bs.popover";
const $0abbbd36a260e067$var$EVENT_INSERTED_BS$1 = "inserted.bs.popover";
const $0abbbd36a260e067$var$EXTENDED_EVENTS$5 = [
    {
        name: "show"
    },
    {
        name: "shown"
    },
    {
        name: "hide"
    },
    {
        name: "hidden"
    },
    {
        name: "inserted"
    }
];
class $0abbbd36a260e067$export$5b6b19405a83ff9d extends $0abbbd36a260e067$var$Popover$1 {
    constructor(element2, data){
        super(element2, data);
        this._init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this.element, $0abbbd36a260e067$var$EVENT_SHOW_BS$4);
        $0abbbd36a260e067$var$EventHandler$1.off(this.element, $0abbbd36a260e067$var$EVENT_SHOWN_BS$4);
        $0abbbd36a260e067$var$EventHandler$1.off(this.element, $0abbbd36a260e067$var$EVENT_HIDE_BS$4);
        $0abbbd36a260e067$var$EventHandler$1.off(this.element, $0abbbd36a260e067$var$EVENT_HIDDEN_BS$4);
        $0abbbd36a260e067$var$EventHandler$1.off(this.element, $0abbbd36a260e067$var$EVENT_INSERTED_BS$1);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$M;
    }
    // Private
    _init() {
        this._bindMdbEvents();
    }
    _bindMdbEvents() {
        $0abbbd36a260e067$var$EventHandler$1.extend(this._element, $0abbbd36a260e067$var$EXTENDED_EVENTS$5, $0abbbd36a260e067$var$NAME$M);
    }
}
const $0abbbd36a260e067$var$NAME$L = "scrollspy";
const $0abbbd36a260e067$var$DATA_KEY$A = "bs.scrollspy";
const $0abbbd36a260e067$var$EVENT_KEY$r = `.${$0abbbd36a260e067$var$DATA_KEY$A}`;
const $0abbbd36a260e067$var$EVENT_ACTIVATE$1 = `activate${$0abbbd36a260e067$var$EVENT_KEY$r}`;
const $0abbbd36a260e067$var$EVENT_CLICK$1 = `click${$0abbbd36a260e067$var$EVENT_KEY$r}`;
const $0abbbd36a260e067$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$4 = "active";
const $0abbbd36a260e067$var$SELECTOR_TARGET_LINKS = "[href]";
const $0abbbd36a260e067$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $0abbbd36a260e067$var$SELECTOR_NAV_LINKS = ".nav-link";
const $0abbbd36a260e067$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $0abbbd36a260e067$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $0abbbd36a260e067$var$SELECTOR_LINK_ITEMS = `${$0abbbd36a260e067$var$SELECTOR_NAV_LINKS}, ${$0abbbd36a260e067$var$SELECTOR_NAV_ITEMS} > ${$0abbbd36a260e067$var$SELECTOR_NAV_LINKS}, ${$0abbbd36a260e067$var$SELECTOR_LIST_ITEMS}`;
const $0abbbd36a260e067$var$SELECTOR_DROPDOWN$2 = ".dropdown";
const $0abbbd36a260e067$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $0abbbd36a260e067$var$Default$r = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $0abbbd36a260e067$var$DefaultType$r = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
let $0abbbd36a260e067$var$ScrollSpy$1 = class ScrollSpy extends $0abbbd36a260e067$var$BaseComponent$1 {
    constructor(element2, config){
        super(element2, config);
        if (!this._config.target) return;
        this._targetLinks = /* @__PURE__ */ new Map();
        this._observableSections = /* @__PURE__ */ new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh();
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$r;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$r;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$L;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        if (this._observer) this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.target = $0abbbd36a260e067$var$getElement(config.target) || document.body;
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        $0abbbd36a260e067$var$EventHandler.off(this._config.target, $0abbbd36a260e067$var$EVENT_CLICK$1);
        $0abbbd36a260e067$var$EventHandler.on(this._config.target, $0abbbd36a260e067$var$EVENT_CLICK$1, $0abbbd36a260e067$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                if (!parentScrollTop) return;
                continue;
            }
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = /* @__PURE__ */ new Map();
        this._observableSections = /* @__PURE__ */ new Map();
        const targetLinks = $0abbbd36a260e067$var$SelectorEngine.find($0abbbd36a260e067$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            if (!anchor.hash || $0abbbd36a260e067$var$isDisabled(anchor)) continue;
            const observableSection = $0abbbd36a260e067$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            if ($0abbbd36a260e067$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$4);
        this._activateParents(target);
        $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_ACTIVATE$1, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        if (target.classList.contains($0abbbd36a260e067$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $0abbbd36a260e067$var$SelectorEngine.findOne($0abbbd36a260e067$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($0abbbd36a260e067$var$SELECTOR_DROPDOWN$2)).classList.add($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$4);
            return;
        }
        for (const listGroup of $0abbbd36a260e067$var$SelectorEngine.parents(target, $0abbbd36a260e067$var$SELECTOR_NAV_LIST_GROUP))for (const item of $0abbbd36a260e067$var$SelectorEngine.prev(listGroup, $0abbbd36a260e067$var$SELECTOR_LINK_ITEMS))item.classList.add($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$4);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$4);
        const activeNodes = $0abbbd36a260e067$var$SelectorEngine.find(`${$0abbbd36a260e067$var$SELECTOR_TARGET_LINKS}.${$0abbbd36a260e067$var$CLASS_NAME_ACTIVE$4}`, parent);
        for (const node of activeNodes)node.classList.remove($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$4);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = ScrollSpy.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === void 0 || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
};
const $0abbbd36a260e067$var$NAME$K = "scrollspy";
const $0abbbd36a260e067$var$DATA_KEY$z = `mdb.${$0abbbd36a260e067$var$NAME$K}`;
const $0abbbd36a260e067$var$EVENT_KEY$q = `.${$0abbbd36a260e067$var$DATA_KEY$z}`;
const $0abbbd36a260e067$var$EVENT_ACTIVATE_BS = "activate.bs.scrollspy";
const $0abbbd36a260e067$var$EVENT_ACTIVATE = `activate${$0abbbd36a260e067$var$EVENT_KEY$q}`;
const $0abbbd36a260e067$var$CLASS_COLLAPSIBLE = "collapsible-scrollspy";
const $0abbbd36a260e067$var$CLASS_ACTIVE = "active";
const $0abbbd36a260e067$var$SELECTOR_LIST = "ul";
const $0abbbd36a260e067$var$SELECTOR_ACTIVE$1 = `.${$0abbbd36a260e067$var$CLASS_ACTIVE}`;
const $0abbbd36a260e067$var$SELECTOR_COLLAPSIBLE_SCROLLSPY = `.${$0abbbd36a260e067$var$CLASS_COLLAPSIBLE}`;
class $0abbbd36a260e067$export$a6472a5298a374be extends $0abbbd36a260e067$var$ScrollSpy$1 {
    constructor(element2, data){
        super(element2, data);
        this._collapsibles = [];
        this._init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._scrollElement, $0abbbd36a260e067$var$EVENT_ACTIVATE_BS);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$K;
    }
    // Private
    _init() {
        this._bindActivateEvent();
        this._getCollapsibles();
        if (this._collapsibles.length === 0) return;
        this._showSubsection();
        this._hideSubsection();
    }
    _getHeight(element2) {
        return element2.offsetHeight;
    }
    _hide(target) {
        const itemsToHide = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_LIST, target.parentNode);
        itemsToHide.style.overflow = "hidden";
        itemsToHide.style.height = `${0}px`;
    }
    _show(target, destinedHeight) {
        target.style.height = destinedHeight;
    }
    _getCollapsibles() {
        const collapsibleElements = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_COLLAPSIBLE_SCROLLSPY);
        if (!collapsibleElements) return;
        collapsibleElements.forEach((collapsibleElement)=>{
            const listParent = collapsibleElement.parentNode;
            const list = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_LIST, listParent);
            const listHeight = list.offsetHeight;
            this._collapsibles.push({
                element: list,
                relatedTarget: collapsibleElement.getAttribute("href"),
                height: `${listHeight}px`
            });
        });
    }
    _showSubsection() {
        const activeElements = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_ACTIVE$1);
        const actives = activeElements.filter((active)=>{
            return $0abbbd36a260e067$var$Manipulator$1.hasClass(active, $0abbbd36a260e067$var$CLASS_COLLAPSIBLE);
        });
        actives.forEach((active)=>{
            const list = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_LIST, active.parentNode);
            const height = this._collapsibles.find((collapsible)=>{
                return collapsible.relatedTarget = active.getAttribute("href");
            }).height;
            this._show(list, height);
        });
    }
    _hideSubsection() {
        const unactives = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_COLLAPSIBLE_SCROLLSPY).filter((collapsible)=>{
            return $0abbbd36a260e067$var$Manipulator$1.hasClass(collapsible, "active") === false;
        });
        unactives.forEach((unactive)=>{
            this._hide(unactive);
        });
    }
    _bindActivateEvent() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_ACTIVATE_BS, (e)=>{
            this._showSubsection();
            this._hideSubsection();
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_ACTIVATE, {
                relatedTarget: e.relatedTarget
            });
        });
    }
}
const $0abbbd36a260e067$var$NAME$J = "tab";
const $0abbbd36a260e067$var$DATA_KEY$y = "bs.tab";
const $0abbbd36a260e067$var$EVENT_KEY$p = `.${$0abbbd36a260e067$var$DATA_KEY$y}`;
const $0abbbd36a260e067$var$EVENT_HIDE$7 = `hide${$0abbbd36a260e067$var$EVENT_KEY$p}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN$8 = `hidden${$0abbbd36a260e067$var$EVENT_KEY$p}`;
const $0abbbd36a260e067$var$EVENT_SHOW$8 = `show${$0abbbd36a260e067$var$EVENT_KEY$p}`;
const $0abbbd36a260e067$var$EVENT_SHOWN$7 = `shown${$0abbbd36a260e067$var$EVENT_KEY$p}`;
const $0abbbd36a260e067$var$EVENT_KEYDOWN$2 = `keydown${$0abbbd36a260e067$var$EVENT_KEY$p}`;
const $0abbbd36a260e067$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $0abbbd36a260e067$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $0abbbd36a260e067$var$ARROW_UP_KEY$1 = "ArrowUp";
const $0abbbd36a260e067$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $0abbbd36a260e067$var$HOME_KEY = "Home";
const $0abbbd36a260e067$var$END_KEY = "End";
const $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$3 = "active";
const $0abbbd36a260e067$var$CLASS_NAME_FADE$4 = "fade";
const $0abbbd36a260e067$var$CLASS_NAME_SHOW$6 = "show";
const $0abbbd36a260e067$var$CLASS_DROPDOWN = "dropdown";
const $0abbbd36a260e067$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $0abbbd36a260e067$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $0abbbd36a260e067$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$0abbbd36a260e067$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $0abbbd36a260e067$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $0abbbd36a260e067$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $0abbbd36a260e067$var$SELECTOR_INNER = `.nav-link${$0abbbd36a260e067$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$0abbbd36a260e067$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$0abbbd36a260e067$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$5 = "[data-mdb-tab-initialized]";
const $0abbbd36a260e067$var$SELECTOR_INNER_ELEM = `${$0abbbd36a260e067$var$SELECTOR_INNER}, ${$0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$5}`;
let $0abbbd36a260e067$var$Tab$1 = class Tab extends $0abbbd36a260e067$var$BaseComponent$1 {
    constructor(element2){
        super(element2);
        this._parent = this._element.closest($0abbbd36a260e067$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        this._setInitialAttributes(this._parent, this._getChildren());
        $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_KEYDOWN$2, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$J;
    }
    // Public
    show() {
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        const active = this._getActiveElem();
        const hideEvent = active ? $0abbbd36a260e067$var$EventHandler.trigger(active, $0abbbd36a260e067$var$EVENT_HIDE$7, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $0abbbd36a260e067$var$EventHandler.trigger(innerElem, $0abbbd36a260e067$var$EVENT_SHOW$8, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element2, relatedElem) {
        if (!element2) return;
        element2.classList.add($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$3);
        this._activate($0abbbd36a260e067$var$SelectorEngine.getElementFromSelector(element2));
        const complete = ()=>{
            if (element2.getAttribute("role") !== "tab") {
                element2.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOW$6);
                return;
            }
            element2.removeAttribute("tabindex");
            element2.setAttribute("aria-selected", true);
            this._toggleDropDown(element2, true);
            $0abbbd36a260e067$var$EventHandler.trigger(element2, $0abbbd36a260e067$var$EVENT_SHOWN$7, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element2, element2.classList.contains($0abbbd36a260e067$var$CLASS_NAME_FADE$4));
    }
    _deactivate(element2, relatedElem) {
        if (!element2) return;
        element2.classList.remove($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$3);
        element2.blur();
        this._deactivate($0abbbd36a260e067$var$SelectorEngine.getElementFromSelector(element2));
        const complete = ()=>{
            if (element2.getAttribute("role") !== "tab") {
                element2.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOW$6);
                return;
            }
            element2.setAttribute("aria-selected", false);
            element2.setAttribute("tabindex", "-1");
            this._toggleDropDown(element2, false);
            $0abbbd36a260e067$var$EventHandler.trigger(element2, $0abbbd36a260e067$var$EVENT_HIDDEN$8, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element2, element2.classList.contains($0abbbd36a260e067$var$CLASS_NAME_FADE$4));
    }
    _keydown(event) {
        if (![
            $0abbbd36a260e067$var$ARROW_LEFT_KEY$1,
            $0abbbd36a260e067$var$ARROW_RIGHT_KEY$1,
            $0abbbd36a260e067$var$ARROW_UP_KEY$1,
            $0abbbd36a260e067$var$ARROW_DOWN_KEY$1,
            $0abbbd36a260e067$var$HOME_KEY,
            $0abbbd36a260e067$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation();
        event.preventDefault();
        const children = this._getChildren().filter((element2)=>!$0abbbd36a260e067$var$isDisabled(element2));
        let nextActiveElement;
        if ([
            $0abbbd36a260e067$var$HOME_KEY,
            $0abbbd36a260e067$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $0abbbd36a260e067$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $0abbbd36a260e067$var$ARROW_RIGHT_KEY$1,
                $0abbbd36a260e067$var$ARROW_DOWN_KEY$1
            ].includes(event.key);
            nextActiveElement = $0abbbd36a260e067$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            Tab.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        return $0abbbd36a260e067$var$SelectorEngine.find($0abbbd36a260e067$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $0abbbd36a260e067$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element2, open) {
        const outerElem = this._getOuterElement(element2);
        if (!outerElem.classList.contains($0abbbd36a260e067$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element3 = $0abbbd36a260e067$var$SelectorEngine.findOne(selector, outerElem);
            if (element3) element3.classList.toggle(className, open);
        };
        toggle($0abbbd36a260e067$var$SELECTOR_DROPDOWN_TOGGLE, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$3);
        toggle($0abbbd36a260e067$var$SELECTOR_DROPDOWN_MENU, $0abbbd36a260e067$var$CLASS_NAME_SHOW$6);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element2, attribute, value) {
        if (!element2.hasAttribute(attribute)) element2.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$3);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($0abbbd36a260e067$var$SELECTOR_INNER_ELEM) ? elem : $0abbbd36a260e067$var$SelectorEngine.findOne($0abbbd36a260e067$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($0abbbd36a260e067$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Tab.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === void 0 || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
};
const $0abbbd36a260e067$var$NAME$I = "tab";
const $0abbbd36a260e067$var$DATA_KEY$x = `mdb.${$0abbbd36a260e067$var$NAME$I}`;
const $0abbbd36a260e067$var$EVENT_KEY$o = `.${$0abbbd36a260e067$var$DATA_KEY$x}`;
const $0abbbd36a260e067$var$EVENT_SHOW_BS$3 = "show.bs.tab";
const $0abbbd36a260e067$var$EVENT_SHOWN_BS$3 = "shown.bs.tab";
const $0abbbd36a260e067$var$EVENT_HIDE_BS$3 = "hide.bs.tab";
const $0abbbd36a260e067$var$EVENT_HIDDEN_BS$3 = "hidden.bs.tab";
const $0abbbd36a260e067$var$EVENT_SHOW$7 = `show${$0abbbd36a260e067$var$EVENT_KEY$o}`;
const $0abbbd36a260e067$var$EVENT_SHOWN$6 = `shown${$0abbbd36a260e067$var$EVENT_KEY$o}`;
const $0abbbd36a260e067$var$EVENT_HIDE$6 = `hide${$0abbbd36a260e067$var$EVENT_KEY$o}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN$7 = `hidden${$0abbbd36a260e067$var$EVENT_KEY$o}`;
const $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$2 = "active";
const $0abbbd36a260e067$var$CLASS_NAME_FADE$3 = "fade";
const $0abbbd36a260e067$var$CLASS_NAME_SHOW$5 = "show";
class $0abbbd36a260e067$export$3e41faf802a29e71 extends $0abbbd36a260e067$var$Tab$1 {
    constructor(element2){
        super(element2);
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOW_BS$3);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOWN_BS$3);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$I;
    }
    // Override
    show() {
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        const active = this._getActiveElem();
        let hideEvent = null;
        let hideEventMdb = null;
        if (active) {
            hideEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(active, $0abbbd36a260e067$var$EVENT_HIDE_BS$3, {
                relatedTarget: innerElem
            });
            hideEventMdb = $0abbbd36a260e067$var$EventHandler$1.trigger(active, $0abbbd36a260e067$var$EVENT_HIDE$6, {
                relatedTarget: innerElem
            });
        }
        const showEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(innerElem, $0abbbd36a260e067$var$EVENT_SHOW_BS$3, {
            relatedTarget: active
        });
        const showEventMdb = $0abbbd36a260e067$var$EventHandler$1.trigger(innerElem, $0abbbd36a260e067$var$EVENT_SHOW$7, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || showEventMdb.defaultPrevented || hideEvent && hideEvent.defaultPrevented || hideEventMdb && hideEventMdb.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    _activate(element2, relatedElem) {
        if (!element2) return;
        element2.classList.add($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$2);
        this._activate($0abbbd36a260e067$var$getElementFromSelector(element2));
        const complete = ()=>{
            if (element2.getAttribute("role") !== "tab") {
                element2.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOW$5);
                return;
            }
            element2.focus();
            element2.removeAttribute("tabindex");
            element2.setAttribute("aria-selected", true);
            this._toggleDropDown(element2, true);
            $0abbbd36a260e067$var$EventHandler$1.trigger(element2, $0abbbd36a260e067$var$EVENT_SHOWN_BS$3, {
                relatedTarget: relatedElem
            });
            $0abbbd36a260e067$var$EventHandler$1.trigger(element2, $0abbbd36a260e067$var$EVENT_SHOWN$6, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element2, element2.classList.contains($0abbbd36a260e067$var$CLASS_NAME_FADE$3));
    }
    _deactivate(element2, relatedElem) {
        if (!element2) return;
        element2.classList.remove($0abbbd36a260e067$var$CLASS_NAME_ACTIVE$2);
        element2.blur();
        this._deactivate($0abbbd36a260e067$var$getElementFromSelector(element2));
        const complete = ()=>{
            if (element2.getAttribute("role") !== "tab") {
                element2.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOW$5);
                return;
            }
            element2.setAttribute("aria-selected", false);
            element2.setAttribute("tabindex", "-1");
            this._toggleDropDown(element2, false);
            $0abbbd36a260e067$var$EventHandler$1.trigger(element2, $0abbbd36a260e067$var$EVENT_HIDDEN_BS$3, {
                relatedTarget: relatedElem
            });
            $0abbbd36a260e067$var$EventHandler$1.trigger(element2, $0abbbd36a260e067$var$EVENT_HIDDEN$7, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element2, element2.classList.contains($0abbbd36a260e067$var$CLASS_NAME_FADE$3));
    }
}
const $0abbbd36a260e067$var$NAME$H = "tooltip";
const $0abbbd36a260e067$var$EVENT_HIDE_BS$2 = "hide.bs.tooltip";
const $0abbbd36a260e067$var$EVENT_HIDDEN_BS$2 = "hidden.bs.tooltip";
const $0abbbd36a260e067$var$EVENT_SHOW_BS$2 = "show.bs.tooltip";
const $0abbbd36a260e067$var$EVENT_SHOWN_BS$2 = "shown.bs.tooltip";
const $0abbbd36a260e067$var$EVENT_INSERTED_BS = "inserted.bs.tooltip";
const $0abbbd36a260e067$var$EXTENDED_EVENTS$4 = [
    {
        name: "show"
    },
    {
        name: "shown"
    },
    {
        name: "hide"
    },
    {
        name: "hidden"
    },
    {
        name: "inserted"
    }
];
class $0abbbd36a260e067$export$28c660c63b792dea extends $0abbbd36a260e067$var$Tooltip$1 {
    constructor(element2, data){
        super(element2, data);
        this._init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOW_BS$2);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOWN_BS$2);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_HIDE_BS$2);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN_BS$2);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_INSERTED_BS);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$H;
    }
    // Private
    _init() {
        this._bindMdbEvents();
    }
    _bindMdbEvents() {
        $0abbbd36a260e067$var$EventHandler$1.extend(this._element, $0abbbd36a260e067$var$EXTENDED_EVENTS$4, $0abbbd36a260e067$var$NAME$H);
    }
}
(()=>{
    var e = {
        454: (e2, t2, n2)=>{
            n2.d(t2, {
                Z: ()=>a
            });
            var r = n2(645), o = n2.n(r)()(function(e3) {
                return e3[1];
            });
            o.push([
                e2.id,
                "INPUT:-webkit-autofill,SELECT:-webkit-autofill,TEXTAREA:-webkit-autofill{animation-name:onautofillstart}INPUT:not(:-webkit-autofill),SELECT:not(:-webkit-autofill),TEXTAREA:not(:-webkit-autofill){animation-name:onautofillcancel}@keyframes onautofillstart{}@keyframes onautofillcancel{}",
                ""
            ]);
            const a = o;
        },
        645: (e2)=>{
            e2.exports = function(e3) {
                var t2 = [];
                return t2.toString = function() {
                    return this.map(function(t3) {
                        var n2 = e3(t3);
                        return t3[2] ? "@media ".concat(t3[2], " {").concat(n2, "}") : n2;
                    }).join("");
                }, t2.i = function(e4, n2, r) {
                    "string" == typeof e4 && (e4 = [
                        [
                            null,
                            e4,
                            ""
                        ]
                    ]);
                    var o = {};
                    if (r) for(var a = 0; a < this.length; a++){
                        var i = this[a][0];
                        null != i && (o[i] = true);
                    }
                    for(var u = 0; u < e4.length; u++){
                        var c = [].concat(e4[u]);
                        r && o[c[0]] || (n2 && (c[2] ? c[2] = "".concat(n2, " and ").concat(c[2]) : c[2] = n2), t2.push(c));
                    }
                }, t2;
            };
        },
        810: ()=>{
            !function() {
                if ("undefined" != typeof window) try {
                    var e2 = new window.CustomEvent("test", {
                        cancelable: true
                    });
                    if (e2.preventDefault(), true !== e2.defaultPrevented) throw new Error("Could not prevent default");
                } catch (e3) {
                    var t2 = function(e4, t3) {
                        var n2, r;
                        return (t3 = t3 || {}).bubbles = !!t3.bubbles, t3.cancelable = !!t3.cancelable, (n2 = document.createEvent("CustomEvent")).initCustomEvent(e4, t3.bubbles, t3.cancelable, t3.detail), r = n2.preventDefault, n2.preventDefault = function() {
                            r.call(this);
                            try {
                                Object.defineProperty(this, "defaultPrevented", {
                                    get: function() {
                                        return true;
                                    }
                                });
                            } catch (e5) {
                                this.defaultPrevented = true;
                            }
                        }, n2;
                    };
                    t2.prototype = window.Event.prototype, window.CustomEvent = t2;
                }
            }();
        },
        379: (e2, t2, n2)=>{
            var r, o = function() {
                var e3 = {};
                return function(t3) {
                    if (void 0 === e3[t3]) {
                        var n3 = document.querySelector(t3);
                        if (window.HTMLIFrameElement && n3 instanceof window.HTMLIFrameElement) try {
                            n3 = n3.contentDocument.head;
                        } catch (e4) {
                            n3 = null;
                        }
                        e3[t3] = n3;
                    }
                    return e3[t3];
                };
            }(), a = [];
            function i(e3) {
                for(var t3 = -1, n3 = 0; n3 < a.length; n3++)if (a[n3].identifier === e3) {
                    t3 = n3;
                    break;
                }
                return t3;
            }
            function u(e3, t3) {
                for(var n3 = {}, r2 = [], o2 = 0; o2 < e3.length; o2++){
                    var u2 = e3[o2], c2 = t3.base ? u2[0] + t3.base : u2[0], l2 = n3[c2] || 0, s2 = "".concat(c2, " ").concat(l2);
                    n3[c2] = l2 + 1;
                    var d2 = i(s2), f2 = {
                        css: u2[1],
                        media: u2[2],
                        sourceMap: u2[3]
                    };
                    -1 !== d2 ? (a[d2].references++, a[d2].updater(f2)) : a.push({
                        identifier: s2,
                        updater: m(f2, t3),
                        references: 1
                    }), r2.push(s2);
                }
                return r2;
            }
            function c(e3) {
                var t3 = document.createElement("style"), r2 = e3.attributes || {};
                if (void 0 === r2.nonce) {
                    var a2 = n2.nc;
                    a2 && (r2.nonce = a2);
                }
                if (Object.keys(r2).forEach(function(e4) {
                    t3.setAttribute(e4, r2[e4]);
                }), "function" == typeof e3.insert) e3.insert(t3);
                else {
                    var i2 = o(e3.insert || "head");
                    if (!i2) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                    i2.appendChild(t3);
                }
                return t3;
            }
            var l, s = (l = [], function(e3, t3) {
                return l[e3] = t3, l.filter(Boolean).join("\n");
            });
            function d(e3, t3, n3, r2) {
                var o2 = n3 ? "" : r2.media ? "@media ".concat(r2.media, " {").concat(r2.css, "}") : r2.css;
                if (e3.styleSheet) e3.styleSheet.cssText = s(t3, o2);
                else {
                    var a2 = document.createTextNode(o2), i2 = e3.childNodes;
                    i2[t3] && e3.removeChild(i2[t3]), i2.length ? e3.insertBefore(a2, i2[t3]) : e3.appendChild(a2);
                }
            }
            function f(e3, t3, n3) {
                var r2 = n3.css, o2 = n3.media, a2 = n3.sourceMap;
                if (o2 ? e3.setAttribute("media", o2) : e3.removeAttribute("media"), a2 && "undefined" != typeof btoa && (r2 += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a2)))), " */")), e3.styleSheet) e3.styleSheet.cssText = r2;
                else {
                    for(; e3.firstChild;)e3.removeChild(e3.firstChild);
                    e3.appendChild(document.createTextNode(r2));
                }
            }
            var v = null, p = 0;
            function m(e3, t3) {
                var n3, r2, o2;
                if (t3.singleton) {
                    var a2 = p++;
                    n3 = v || (v = c(t3)), r2 = d.bind(null, n3, a2, false), o2 = d.bind(null, n3, a2, true);
                } else n3 = c(t3), r2 = f.bind(null, n3, t3), o2 = function() {
                    !function(e4) {
                        if (null === e4.parentNode) return false;
                        e4.parentNode.removeChild(e4);
                    }(n3);
                };
                return r2(e3), function(t4) {
                    if (t4) {
                        if (t4.css === e3.css && t4.media === e3.media && t4.sourceMap === e3.sourceMap) return;
                        r2(e3 = t4);
                    } else o2();
                };
            }
            e2.exports = function(e3, t3) {
                (t3 = t3 || {}).singleton || "boolean" == typeof t3.singleton || (t3.singleton = (void 0 === r && (r = Boolean(window && document && document.all && !window.atob)), r));
                var n3 = u(e3 = e3 || [], t3);
                return function(e4) {
                    if (e4 = e4 || [], "[object Array]" === Object.prototype.toString.call(e4)) {
                        for(var r2 = 0; r2 < n3.length; r2++){
                            var o2 = i(n3[r2]);
                            a[o2].references--;
                        }
                        for(var c2 = u(e4, t3), l2 = 0; l2 < n3.length; l2++){
                            var s2 = i(n3[l2]);
                            0 === a[s2].references && (a[s2].updater(), a.splice(s2, 1));
                        }
                        n3 = c2;
                    }
                };
            };
        }
    }, t = {};
    function n(r) {
        var o = t[r];
        if (void 0 !== o) return o.exports;
        var a = t[r] = {
            id: r,
            exports: {}
        };
        return e[r](a, a.exports, n), a.exports;
    }
    n.n = (e2)=>{
        var t2 = e2 && e2.__esModule ? ()=>e2.default : ()=>e2;
        return n.d(t2, {
            a: t2
        }), t2;
    }, n.d = (e2, t2)=>{
        for(var r in t2)n.o(t2, r) && !n.o(e2, r) && Object.defineProperty(e2, r, {
            enumerable: true,
            get: t2[r]
        });
    }, n.o = (e2, t2)=>Object.prototype.hasOwnProperty.call(e2, t2), (()=>{
        var e2 = n(379), t2 = n.n(e2), r = n(454);
        function o(e3) {
            if (!e3.hasAttribute("autocompleted")) {
                e3.setAttribute("autocompleted", "");
                var t3 = new window.CustomEvent("onautocomplete", {
                    bubbles: true,
                    cancelable: true,
                    detail: null
                });
                e3.dispatchEvent(t3) || (e3.value = "");
            }
        }
        function a(e3) {
            e3.hasAttribute("autocompleted") && (e3.removeAttribute("autocompleted"), e3.dispatchEvent(new window.CustomEvent("onautocomplete", {
                bubbles: true,
                cancelable: false,
                detail: null
            })));
        }
        t2()(r.Z, {
            insert: "head",
            singleton: false
        }), r.Z.locals, n(810), document.addEventListener("animationstart", function(e3) {
            "onautofillstart" === e3.animationName ? o(e3.target) : a(e3.target);
        }, true), document.addEventListener("input", function(e3) {
            "insertReplacementText" !== e3.inputType && "data" in e3 ? a(e3.target) : o(e3.target);
        }, true);
    })();
})();
class $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2){
        element2 = $0abbbd36a260e067$var$getElement$1(element2);
        if (!element2) return;
        this._element = element2;
        $0abbbd36a260e067$var$Data$1.setData(this._element, this.constructor.DATA_KEY, this);
    }
    dispose() {
        $0abbbd36a260e067$var$Data$1.removeData(this._element, this.constructor.DATA_KEY);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, this.constructor.EVENT_KEY);
        Object.getOwnPropertyNames(this).forEach((propertyName)=>{
            this[propertyName] = null;
        });
    }
    /** Static */ static getInstance(element2) {
        return $0abbbd36a260e067$var$Data$1.getData($0abbbd36a260e067$var$getElement$1(element2), this.DATA_KEY);
    }
    static getOrCreateInstance(element2, config = {}) {
        return this.getInstance(element2) || new this(element2, typeof config === "object" ? config : null);
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    static get DATA_KEY() {
        return `mdb.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
}
const $0abbbd36a260e067$var$NAME$G = "input";
const $0abbbd36a260e067$var$DATA_KEY$w = "mdb.input";
const $0abbbd36a260e067$var$CLASSNAME_ACTIVE$2 = "active";
const $0abbbd36a260e067$var$CLASSNAME_NOTCH = "form-notch";
const $0abbbd36a260e067$var$CLASSNAME_NOTCH_LEADING = "form-notch-leading";
const $0abbbd36a260e067$var$CLASSNAME_NOTCH_MIDDLE = "form-notch-middle";
const $0abbbd36a260e067$var$CLASSNAME_NOTCH_TRAILING = "form-notch-trailing";
const $0abbbd36a260e067$var$CLASSNAME_PLACEHOLDER_ACTIVE = "placeholder-active";
const $0abbbd36a260e067$var$CLASSNAME_HELPER = "form-helper";
const $0abbbd36a260e067$var$CLASSNAME_COUNTER$1 = "form-counter";
const $0abbbd36a260e067$var$SELECTOR_NOTCH = `.${$0abbbd36a260e067$var$CLASSNAME_NOTCH}`;
const $0abbbd36a260e067$var$SELECTOR_NOTCH_LEADING = `.${$0abbbd36a260e067$var$CLASSNAME_NOTCH_LEADING}`;
const $0abbbd36a260e067$var$SELECTOR_NOTCH_MIDDLE = `.${$0abbbd36a260e067$var$CLASSNAME_NOTCH_MIDDLE}`;
const $0abbbd36a260e067$var$SELECTOR_HELPER = `.${$0abbbd36a260e067$var$CLASSNAME_HELPER}`;
class $0abbbd36a260e067$export$f5b8910cec6cf069 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2){
        super(element2);
        this._label = null;
        this._labelWidth = 0;
        this._labelMarginLeft = 0;
        this._notchLeading = null;
        this._notchMiddle = null;
        this._notchTrailing = null;
        this._initiated = false;
        this._helper = null;
        this._counter = false;
        this._counterElement = null;
        this._maxLength = 0;
        this._leadingIcon = null;
        if (this._element) {
            this.init();
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$G;
    }
    get input() {
        const inputElement = $0abbbd36a260e067$var$SelectorEngine$1.findOne("input", this._element) || $0abbbd36a260e067$var$SelectorEngine$1.findOne("textarea", this._element);
        return inputElement;
    }
    // Public
    init() {
        if (this._initiated) return;
        this._getLabelData();
        this._applyDivs();
        this._applyNotch();
        this._activate();
        this._getHelper();
        this._getCounter();
        this._initiated = true;
    }
    update() {
        this._getLabelData();
        this._getNotchData();
        this._applyNotch();
        this._activate();
        this._getHelper();
        this._getCounter();
    }
    forceActive() {
        $0abbbd36a260e067$var$Manipulator$1.addClass(this.input, $0abbbd36a260e067$var$CLASSNAME_ACTIVE$2);
    }
    forceInactive() {
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this.input, $0abbbd36a260e067$var$CLASSNAME_ACTIVE$2);
    }
    dispose() {
        this._removeBorder();
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    /*
    _getIcons() {
      this._leadingIcon = SelectorEngine.findOne('i.leading', this._element);
  
      if (this._leadingIcon !== null) {
        this._applyLeadingIcon();
      }
    }
  
    _applyLeadingIcon() {
      this._label.innerHTML = ` ${this._label.innerHTML}`;
      this._label.insertBefore(this._leadingIcon, this._label.firstChild);
    }
    */ _getLabelData() {
        this._label = $0abbbd36a260e067$var$SelectorEngine$1.findOne("label", this._element);
        if (this._label === null) this._showPlaceholder();
        else {
            this._getLabelWidth();
            this._getLabelPositionInInputGroup();
            this._toggleDefaultDatePlaceholder();
        }
    }
    _getHelper() {
        this._helper = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_HELPER, this._element);
    }
    _getCounter() {
        this._counter = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(this.input, "showcounter");
        if (this._counter) {
            this._maxLength = this.input.maxLength;
            this._showCounter();
        }
    }
    _showCounter() {
        const counters = $0abbbd36a260e067$var$SelectorEngine$1.find(".form-counter", this._element);
        if (counters.length > 0) return;
        this._counterElement = document.createElement("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._counterElement, $0abbbd36a260e067$var$CLASSNAME_COUNTER$1);
        const actualLength = this.input.value.length;
        this._counterElement.innerHTML = `${actualLength} / ${this._maxLength}`;
        this._helper.appendChild(this._counterElement);
        this._bindCounter();
    }
    _bindCounter() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.input, "input", ()=>{
            const actualLength = this.input.value.length;
            this._counterElement.innerHTML = `${actualLength} / ${this._maxLength}`;
        });
    }
    _toggleDefaultDatePlaceholder(input = this.input) {
        const type = input.getAttribute("type");
        const typesWithPlaceholder = [
            "date",
            "time",
            "datetime-local",
            "month",
            "week"
        ];
        if (!typesWithPlaceholder.includes(type)) return;
        const isInputFocused = document.activeElement === input;
        if (!isInputFocused && !input.value) input.style.opacity = 0;
        else input.style.opacity = 1;
    }
    _showPlaceholder() {
        $0abbbd36a260e067$var$Manipulator$1.addClass(this.input, $0abbbd36a260e067$var$CLASSNAME_PLACEHOLDER_ACTIVE);
    }
    _getNotchData() {
        this._notchMiddle = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_NOTCH_MIDDLE, this._element);
        this._notchLeading = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_NOTCH_LEADING, this._element);
    }
    _getLabelWidth() {
        this._labelWidth = this._label.clientWidth * 0.8 + 8;
    }
    _getLabelPositionInInputGroup() {
        this._labelMarginLeft = 0;
        if (!this._element.classList.contains("input-group")) return;
        const input = this.input;
        const prefix = $0abbbd36a260e067$var$SelectorEngine$1.prev(input, ".input-group-text")[0];
        if (prefix === void 0) this._labelMarginLeft = 0;
        else this._labelMarginLeft = prefix.offsetWidth - 1;
    }
    _applyDivs() {
        const allNotchWrappers = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_NOTCH, this._element);
        const notchWrapper = $0abbbd36a260e067$var$element("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(notchWrapper, $0abbbd36a260e067$var$CLASSNAME_NOTCH);
        this._notchLeading = $0abbbd36a260e067$var$element("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._notchLeading, $0abbbd36a260e067$var$CLASSNAME_NOTCH_LEADING);
        this._notchMiddle = $0abbbd36a260e067$var$element("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._notchMiddle, $0abbbd36a260e067$var$CLASSNAME_NOTCH_MIDDLE);
        this._notchTrailing = $0abbbd36a260e067$var$element("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._notchTrailing, $0abbbd36a260e067$var$CLASSNAME_NOTCH_TRAILING);
        if (allNotchWrappers.length >= 1) return;
        notchWrapper.append(this._notchLeading);
        notchWrapper.append(this._notchMiddle);
        notchWrapper.append(this._notchTrailing);
        this._element.append(notchWrapper);
    }
    _applyNotch() {
        this._notchMiddle.style.width = `${this._labelWidth}px`;
        this._notchLeading.style.width = `${this._labelMarginLeft + 9}px`;
        if (this._label === null) return;
        this._label.style.marginLeft = `${this._labelMarginLeft}px`;
    }
    _removeBorder() {
        const border = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_NOTCH, this._element);
        if (border) border.remove();
    }
    _activate(event) {
        $0abbbd36a260e067$var$onDOMContentLoaded(()=>{
            this._getElements(event);
            if (!this._element) return;
            const input = event ? event.target : this.input;
            if (input.value !== "") $0abbbd36a260e067$var$Manipulator$1.addClass(input, $0abbbd36a260e067$var$CLASSNAME_ACTIVE$2);
            this._toggleDefaultDatePlaceholder(input);
        });
    }
    _getElements(event) {
        let initialized;
        if (event) {
            this._element = event.target.parentNode;
            this._label = $0abbbd36a260e067$var$SelectorEngine$1.findOne("label", this._element);
            initialized = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        }
        if (!initialized) return;
        if (event && this._label) {
            const prevLabelWidth = this._labelWidth;
            this._getLabelData();
            if (prevLabelWidth !== this._labelWidth) {
                this._notchMiddle = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".form-notch-middle", event.target.parentNode);
                this._notchLeading = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_NOTCH_LEADING, event.target.parentNode);
                this._applyNotch();
            }
        }
    }
    _deactivate(event) {
        const input = event ? event.target : this.input;
        if (input.value === "") input.classList.remove($0abbbd36a260e067$var$CLASSNAME_ACTIVE$2);
        this._toggleDefaultDatePlaceholder(input);
    }
    static activate(instance) {
        return function(event) {
            instance._activate(event);
        };
    }
    static deactivate(instance) {
        return function(event) {
            instance._deactivate(event);
        };
    }
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$w);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$f5b8910cec6cf069(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$F = "collapse";
const $0abbbd36a260e067$var$DATA_KEY$v = "bs.collapse";
const $0abbbd36a260e067$var$EVENT_KEY$n = `.${$0abbbd36a260e067$var$DATA_KEY$v}`;
const $0abbbd36a260e067$var$EVENT_SHOW$6 = `show${$0abbbd36a260e067$var$EVENT_KEY$n}`;
const $0abbbd36a260e067$var$EVENT_SHOWN$5 = `shown${$0abbbd36a260e067$var$EVENT_KEY$n}`;
const $0abbbd36a260e067$var$EVENT_HIDE$5 = `hide${$0abbbd36a260e067$var$EVENT_KEY$n}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN$6 = `hidden${$0abbbd36a260e067$var$EVENT_KEY$n}`;
const $0abbbd36a260e067$var$CLASS_NAME_SHOW$4 = "show";
const $0abbbd36a260e067$var$CLASS_NAME_COLLAPSE = "collapse";
const $0abbbd36a260e067$var$CLASS_NAME_COLLAPSING = "collapsing";
const $0abbbd36a260e067$var$CLASS_NAME_COLLAPSED = "collapsed";
const $0abbbd36a260e067$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$0abbbd36a260e067$var$CLASS_NAME_COLLAPSE} .${$0abbbd36a260e067$var$CLASS_NAME_COLLAPSE}`;
const $0abbbd36a260e067$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $0abbbd36a260e067$var$WIDTH = "width";
const $0abbbd36a260e067$var$HEIGHT = "height";
const $0abbbd36a260e067$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$4 = "[data-mdb-collapse-init]";
const $0abbbd36a260e067$var$Default$q = {
    parent: null,
    toggle: true
};
const $0abbbd36a260e067$var$DefaultType$q = {
    parent: "(null|element)",
    toggle: "boolean"
};
let $0abbbd36a260e067$var$Collapse$1 = class Collapse extends $0abbbd36a260e067$var$BaseComponent$1 {
    constructor(element2, config){
        super(element2, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $0abbbd36a260e067$var$SelectorEngine.find($0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $0abbbd36a260e067$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $0abbbd36a260e067$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$q;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$q;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$F;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($0abbbd36a260e067$var$SELECTOR_ACTIVES).filter((element2)=>element2 !== this._element).map((element2)=>Collapse.getOrCreateInstance(element2, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_COLLAPSE, $0abbbd36a260e067$var$CLASS_NAME_SHOW$4);
            this._element.style[dimension] = "";
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOWN$5);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDE$5);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $0abbbd36a260e067$var$reflow(this._element);
        this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_COLLAPSE, $0abbbd36a260e067$var$CLASS_NAME_SHOW$4);
        for (const trigger of this._triggerArray){
            const element2 = $0abbbd36a260e067$var$SelectorEngine.getElementFromSelector(trigger);
            if (element2 && !this._isShown(element2)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_COLLAPSE);
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element2 = this._element) {
        return element2.classList.contains($0abbbd36a260e067$var$CLASS_NAME_SHOW$4);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle);
        config.parent = $0abbbd36a260e067$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($0abbbd36a260e067$var$CLASS_NAME_HORIZONTAL) ? $0abbbd36a260e067$var$WIDTH : $0abbbd36a260e067$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$4);
        for (const element2 of children){
            const selected = $0abbbd36a260e067$var$SelectorEngine.getElementFromSelector(element2);
            if (selected) this._addAriaAndCollapsedClass([
                element2
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $0abbbd36a260e067$var$SelectorEngine.find($0abbbd36a260e067$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        return $0abbbd36a260e067$var$SelectorEngine.find(selector, this._config.parent).filter((element2)=>!children.includes(element2));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element2 of triggerArray){
            element2.classList.toggle($0abbbd36a260e067$var$CLASS_NAME_COLLAPSED, !isOpen);
            element2.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = Collapse.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
};
const $0abbbd36a260e067$var$NAME$E = "collapse";
const $0abbbd36a260e067$var$EVENT_SHOW_BS$1 = "show.bs.collapse";
const $0abbbd36a260e067$var$EVENT_SHOWN_BS$1 = "shown.bs.collapse";
const $0abbbd36a260e067$var$EVENT_HIDE_BS$1 = "hide.bs.collapse";
const $0abbbd36a260e067$var$EVENT_HIDDEN_BS$1 = "hidden.bs.collapse";
const $0abbbd36a260e067$var$EXTENDED_EVENTS$3 = [
    {
        name: "show"
    },
    {
        name: "shown"
    },
    {
        name: "hide"
    },
    {
        name: "hidden"
    }
];
class $0abbbd36a260e067$export$78768a9af065a7b extends $0abbbd36a260e067$var$Collapse$1 {
    constructor(element2, data = {}){
        super(element2, data);
        this._init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOW_BS$1);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOWN_BS$1);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_HIDE_BS$1);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN_BS$1);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$E;
    }
    // Private
    _init() {
        this._bindMdbEvents();
    }
    _bindMdbEvents() {
        $0abbbd36a260e067$var$EventHandler$1.extend(this._element, $0abbbd36a260e067$var$EXTENDED_EVENTS$3, $0abbbd36a260e067$var$NAME$E);
    }
}
const $0abbbd36a260e067$var$NAME$D = "dropdown";
const $0abbbd36a260e067$var$DATA_KEY$u = "bs.dropdown";
const $0abbbd36a260e067$var$EVENT_KEY$m = `.${$0abbbd36a260e067$var$DATA_KEY$u}`;
const $0abbbd36a260e067$var$ESCAPE_KEY$1 = "Escape";
const $0abbbd36a260e067$var$TAB_KEY = "Tab";
const $0abbbd36a260e067$var$ARROW_UP_KEY = "ArrowUp";
const $0abbbd36a260e067$var$ARROW_DOWN_KEY = "ArrowDown";
const $0abbbd36a260e067$var$RIGHT_MOUSE_BUTTON = 2;
const $0abbbd36a260e067$var$EVENT_HIDE$4 = `hide${$0abbbd36a260e067$var$EVENT_KEY$m}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN$5 = `hidden${$0abbbd36a260e067$var$EVENT_KEY$m}`;
const $0abbbd36a260e067$var$EVENT_SHOW$5 = `show${$0abbbd36a260e067$var$EVENT_KEY$m}`;
const $0abbbd36a260e067$var$EVENT_SHOWN$4 = `shown${$0abbbd36a260e067$var$EVENT_KEY$m}`;
const $0abbbd36a260e067$var$CLASS_NAME_SHOW$3 = "show";
const $0abbbd36a260e067$var$CLASS_NAME_DROPUP = "dropup";
const $0abbbd36a260e067$var$CLASS_NAME_DROPEND = "dropend";
const $0abbbd36a260e067$var$CLASS_NAME_DROPSTART = "dropstart";
const $0abbbd36a260e067$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $0abbbd36a260e067$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$3 = "[data-mdb-dropdown-initialized]:not(.disabled):not(:disabled)";
const $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$3}.${$0abbbd36a260e067$var$CLASS_NAME_SHOW$3}`;
const $0abbbd36a260e067$var$SELECTOR_MENU = ".dropdown-menu";
const $0abbbd36a260e067$var$SELECTOR_NAVBAR = ".navbar";
const $0abbbd36a260e067$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $0abbbd36a260e067$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $0abbbd36a260e067$var$PLACEMENT_TOP = $0abbbd36a260e067$var$isRTL() ? "top-end" : "top-start";
const $0abbbd36a260e067$var$PLACEMENT_TOPEND = $0abbbd36a260e067$var$isRTL() ? "top-start" : "top-end";
const $0abbbd36a260e067$var$PLACEMENT_BOTTOM = $0abbbd36a260e067$var$isRTL() ? "bottom-end" : "bottom-start";
const $0abbbd36a260e067$var$PLACEMENT_BOTTOMEND = $0abbbd36a260e067$var$isRTL() ? "bottom-start" : "bottom-end";
const $0abbbd36a260e067$var$PLACEMENT_RIGHT = $0abbbd36a260e067$var$isRTL() ? "left-start" : "right-start";
const $0abbbd36a260e067$var$PLACEMENT_LEFT = $0abbbd36a260e067$var$isRTL() ? "right-start" : "left-start";
const $0abbbd36a260e067$var$PLACEMENT_TOPCENTER = "top";
const $0abbbd36a260e067$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $0abbbd36a260e067$var$Default$p = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $0abbbd36a260e067$var$DefaultType$p = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
let $0abbbd36a260e067$var$Dropdown$1 = class Dropdown extends $0abbbd36a260e067$var$BaseComponent$1 {
    constructor(element2, config){
        super(element2, config);
        this._popper = null;
        this._parent = this._element.parentNode;
        this._menu = $0abbbd36a260e067$var$SelectorEngine.next(this._element, $0abbbd36a260e067$var$SELECTOR_MENU)[0] || $0abbbd36a260e067$var$SelectorEngine.prev(this._element, $0abbbd36a260e067$var$SELECTOR_MENU)[0] || $0abbbd36a260e067$var$SelectorEngine.findOne($0abbbd36a260e067$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$p;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$p;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$D;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($0abbbd36a260e067$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        if ("ontouchstart" in document.documentElement && !this._parent.closest($0abbbd36a260e067$var$SELECTOR_NAVBAR_NAV)) for (const element2 of [].concat(...document.body.children))$0abbbd36a260e067$var$EventHandler.on(element2, "mouseover", $0abbbd36a260e067$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOW$3);
        this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOW$3);
        $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOWN$4, relatedTarget);
    }
    hide() {
        if ($0abbbd36a260e067$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDE$4, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        if ("ontouchstart" in document.documentElement) for (const element2 of [].concat(...document.body.children))$0abbbd36a260e067$var$EventHandler.off(element2, "mouseover", $0abbbd36a260e067$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOW$3);
        this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOW$3);
        this._element.setAttribute("aria-expanded", "false");
        $0abbbd36a260e067$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$0abbbd36a260e067$var$isElement$1(config.reference) && typeof config.reference.getBoundingClientRect !== "function") throw new TypeError(`${$0abbbd36a260e067$var$NAME$D.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $0abbbd36a260e067$var$Popper === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($0abbbd36a260e067$var$isElement$1(this._config.reference)) referenceElement = $0abbbd36a260e067$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $0abbbd36a260e067$var$createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($0abbbd36a260e067$var$CLASS_NAME_SHOW$3);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($0abbbd36a260e067$var$CLASS_NAME_DROPEND)) return $0abbbd36a260e067$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($0abbbd36a260e067$var$CLASS_NAME_DROPSTART)) return $0abbbd36a260e067$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($0abbbd36a260e067$var$CLASS_NAME_DROPUP_CENTER)) return $0abbbd36a260e067$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($0abbbd36a260e067$var$CLASS_NAME_DROPDOWN_CENTER)) return $0abbbd36a260e067$var$PLACEMENT_BOTTOMCENTER;
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--mdb-position").trim() === "end";
        if (parentDropdown.classList.contains($0abbbd36a260e067$var$CLASS_NAME_DROPUP)) return isEnd ? $0abbbd36a260e067$var$PLACEMENT_TOPEND : $0abbbd36a260e067$var$PLACEMENT_TOP;
        return isEnd ? $0abbbd36a260e067$var$PLACEMENT_BOTTOMEND : $0abbbd36a260e067$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($0abbbd36a260e067$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset2 } = this._config;
        if (typeof offset2 === "string") return offset2.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset2 === "function") return (popperData)=>offset2(popperData, this._element);
        return offset2;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        if (this._inNavbar || this._config.display === "static") {
            $0abbbd36a260e067$var$Manipulator.setDataAttribute(this._menu, "popper", "static");
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$0abbbd36a260e067$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $0abbbd36a260e067$var$SelectorEngine.find($0abbbd36a260e067$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element2)=>$0abbbd36a260e067$var$isVisible(element2));
        if (!items.length) return;
        $0abbbd36a260e067$var$getNextActiveElement(items, target, key === $0abbbd36a260e067$var$ARROW_DOWN_KEY, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Dropdown.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $0abbbd36a260e067$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $0abbbd36a260e067$var$TAB_KEY) return;
        const openToggles = $0abbbd36a260e067$var$SelectorEngine.find($0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = Dropdown.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $0abbbd36a260e067$var$TAB_KEY || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $0abbbd36a260e067$var$ESCAPE_KEY$1;
        const isUpOrDownEvent = [
            $0abbbd36a260e067$var$ARROW_UP_KEY,
            $0abbbd36a260e067$var$ARROW_DOWN_KEY
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        const getToggleButton = this.matches($0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$3) ? this : $0abbbd36a260e067$var$SelectorEngine.prev(this, $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$3)[0] || $0abbbd36a260e067$var$SelectorEngine.next(this, $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$3)[0] || $0abbbd36a260e067$var$SelectorEngine.findOne($0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = Dropdown.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
};
const $0abbbd36a260e067$var$NAME$C = "dropdown";
const $0abbbd36a260e067$var$DATA_KEY$t = `mdb.${$0abbbd36a260e067$var$NAME$C}`;
const $0abbbd36a260e067$var$EVENT_KEY$l = `.${$0abbbd36a260e067$var$DATA_KEY$t}`;
const $0abbbd36a260e067$var$Default$o = {
    offset: [
        0,
        2
    ],
    boundary: "clippingParents",
    reference: "toggle",
    display: "dynamic",
    popperConfig: null,
    dropdownAnimation: "on"
};
const $0abbbd36a260e067$var$DefaultType$o = {
    offset: "(array|string|function)",
    boundary: "(string|element)",
    reference: "(string|element|object)",
    display: "string",
    popperConfig: "(null|object|function)",
    dropdownAnimation: "string"
};
const $0abbbd36a260e067$var$EVENT_HIDE$3 = "hide.bs.dropdown";
const $0abbbd36a260e067$var$EVENT_HIDDEN$4 = "hidden.bs.dropdown";
const $0abbbd36a260e067$var$EVENT_SHOW$4 = "show.bs.dropdown";
const $0abbbd36a260e067$var$EVENT_SHOWN$3 = "shown.bs.dropdown";
const $0abbbd36a260e067$var$EVENT_HIDE_MDB = `hide${$0abbbd36a260e067$var$EVENT_KEY$l}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN_MDB = `hidden${$0abbbd36a260e067$var$EVENT_KEY$l}`;
const $0abbbd36a260e067$var$EVENT_SHOW_MDB = `show${$0abbbd36a260e067$var$EVENT_KEY$l}`;
const $0abbbd36a260e067$var$EVENT_SHOWN_MDB = `shown${$0abbbd36a260e067$var$EVENT_KEY$l}`;
const $0abbbd36a260e067$var$ANIMATION_CLASS = "animation";
const $0abbbd36a260e067$var$ANIMATION_SHOW_CLASS = "fade-in";
const $0abbbd36a260e067$var$ANIMATION_HIDE_CLASS = "fade-out";
class $0abbbd36a260e067$export$931cbfb6bfb85fc extends $0abbbd36a260e067$var$Dropdown$1 {
    constructor(element2, data){
        super(element2, data);
        this._config = this._getConfig(data);
        this._menuStyle = "";
        this._popperPlacement = "";
        this._mdbPopperConfig = "";
        const isPrefersReducedMotionSet = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (this._config.dropdownAnimation === "on" && !isPrefersReducedMotionSet) this._init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOW$4);
        $0abbbd36a260e067$var$EventHandler$1.off(this._parent, $0abbbd36a260e067$var$EVENT_SHOWN$3);
        $0abbbd36a260e067$var$EventHandler$1.off(this._parent, $0abbbd36a260e067$var$EVENT_HIDE$3);
        $0abbbd36a260e067$var$EventHandler$1.off(this._parent, $0abbbd36a260e067$var$EVENT_HIDDEN$4);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$C;
    }
    // Private
    _init() {
        this._bindShowEvent();
        this._bindShownEvent();
        this._bindHideEvent();
        this._bindHiddenEvent();
    }
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$Default$o,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$C, config, $0abbbd36a260e067$var$DefaultType$o);
        return config;
    }
    _getOffset() {
        const { offset: offset2 } = this._config;
        if (typeof offset2 === "string") return offset2.split(",").map((val)=>Number.parseInt(val, 10));
        if (typeof offset2 === "function") return (popperData)=>offset2(popperData, this._element);
        return offset2;
    }
    _getPopperConfig() {
        const popperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        if (this._config.display === "static") {
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._menu, "popper", "static");
            popperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...popperConfig,
            /* eslint no-extra-parens: "off" */ ...typeof this._config.popperConfig === "function" ? this._config.popperConfig(popperConfig) : this._config.popperConfig
        };
    }
    _bindShowEvent() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_SHOW$4, (e)=>{
            const showEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOW_MDB, {
                relatedTarget: e.relatedTarget
            });
            if (showEvent.defaultPrevented) {
                e.preventDefault();
                return;
            }
            this._dropdownAnimationStart("show");
        });
    }
    _bindShownEvent() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._parent, $0abbbd36a260e067$var$EVENT_SHOWN$3, (e)=>{
            const shownEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._parent, $0abbbd36a260e067$var$EVENT_SHOWN_MDB, {
                relatedTarget: e.relatedTarget
            });
            if (shownEvent.defaultPrevented) {
                e.preventDefault();
                return;
            }
        });
    }
    _bindHideEvent() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._parent, $0abbbd36a260e067$var$EVENT_HIDE$3, (e)=>{
            const hideEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._parent, $0abbbd36a260e067$var$EVENT_HIDE_MDB, {
                relatedTarget: e.relatedTarget
            });
            if (hideEvent.defaultPrevented) {
                e.preventDefault();
                return;
            }
            this._menuStyle = this._menu.style.cssText;
            this._popperPlacement = this._menu.getAttribute("data-popper-placement");
            this._mdbPopperConfig = this._menu.getAttribute("data-mdb-popper");
        });
    }
    _bindHiddenEvent() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._parent, $0abbbd36a260e067$var$EVENT_HIDDEN$4, (e)=>{
            const hiddenEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._parent, $0abbbd36a260e067$var$EVENT_HIDDEN_MDB, {
                relatedTarget: e.relatedTarget
            });
            if (hiddenEvent.defaultPrevented) {
                e.preventDefault();
                return;
            }
            if (this._config.display !== "static" && this._menuStyle !== "") this._menu.style.cssText = this._menuStyle;
            this._menu.setAttribute("data-popper-placement", this._popperPlacement);
            this._menu.setAttribute("data-mdb-popper", this._mdbPopperConfig);
            this._dropdownAnimationStart("hide");
        });
    }
    _dropdownAnimationStart(action) {
        switch(action){
            case "show":
                this._menu.classList.add($0abbbd36a260e067$var$ANIMATION_CLASS, $0abbbd36a260e067$var$ANIMATION_SHOW_CLASS);
                this._menu.classList.remove($0abbbd36a260e067$var$ANIMATION_HIDE_CLASS);
                break;
            default:
                this._menu.classList.add($0abbbd36a260e067$var$ANIMATION_CLASS, $0abbbd36a260e067$var$ANIMATION_HIDE_CLASS);
                this._menu.classList.remove($0abbbd36a260e067$var$ANIMATION_SHOW_CLASS);
                break;
        }
        this._bindAnimationEnd();
    }
    _bindAnimationEnd() {
        $0abbbd36a260e067$var$EventHandler$1.one(this._menu, "animationend", ()=>{
            this._menu.classList.remove($0abbbd36a260e067$var$ANIMATION_CLASS, $0abbbd36a260e067$var$ANIMATION_HIDE_CLASS, $0abbbd36a260e067$var$ANIMATION_SHOW_CLASS);
        });
    }
}
const $0abbbd36a260e067$var$NAME$B = "ripple";
const $0abbbd36a260e067$var$DATA_KEY$s = "mdb.ripple";
const $0abbbd36a260e067$var$CLASSNAME_RIPPLE = "ripple-surface";
const $0abbbd36a260e067$var$CLASSNAME_RIPPLE_WAVE = "ripple-wave";
const $0abbbd36a260e067$var$CLASSNAME_RIPPLE_WRAPPER = "input-wrapper";
const $0abbbd36a260e067$var$SELECTOR_BTN = ".btn";
const $0abbbd36a260e067$var$SELECTOR_COMPONENT = [
    $0abbbd36a260e067$var$SELECTOR_BTN,
    `[data-mdb-${$0abbbd36a260e067$var$NAME$B}-init]`
];
const $0abbbd36a260e067$var$CLASSNAME_UNBOUND = "ripple-surface-unbound";
const $0abbbd36a260e067$var$GRADIENT = "rgba({{color}}, 0.2) 0, rgba({{color}}, 0.3) 40%, rgba({{color}}, 0.4) 50%, rgba({{color}}, 0.5) 60%, rgba({{color}}, 0) 70%";
const $0abbbd36a260e067$var$DEFAULT_RIPPLE_COLOR = [
    0,
    0,
    0
];
const $0abbbd36a260e067$var$BOOTSTRAP_COLORS = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark"
];
const $0abbbd36a260e067$var$TRANSITION_BREAK_OPACITY = 0.5;
const $0abbbd36a260e067$var$Default$n = {
    rippleCentered: false,
    rippleColor: "",
    rippleDuration: "500ms",
    rippleRadius: 0,
    rippleUnbound: false
};
const $0abbbd36a260e067$var$DefaultType$n = {
    rippleCentered: "boolean",
    rippleColor: "string",
    rippleDuration: "string",
    rippleRadius: "number",
    rippleUnbound: "boolean"
};
class $0abbbd36a260e067$export$9e9146f7e027fdaa extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options){
        super(element2);
        this._options = this._getConfig(options);
        if (this._element) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$CLASSNAME_RIPPLE);
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
        this._clickHandler = this._createRipple.bind(this);
        this._rippleTimer = null;
        this._isMinWidthSet = false;
        this._rippleInSpan = false;
        this.init();
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$B;
    }
    // Public
    init() {
        this._addClickEvent(this._element);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "mousedown", this._clickHandler);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _autoInit(event) {
        $0abbbd36a260e067$var$SELECTOR_COMPONENT.forEach((selector)=>{
            const target = $0abbbd36a260e067$var$SelectorEngine$1.closest(event.target, selector);
            if (target) this._element = $0abbbd36a260e067$var$SelectorEngine$1.closest(event.target, selector);
        });
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        if (this._element.classList.contains("btn") && dataAttributes.rippleInit === false) return;
        this._options = this._getConfig();
        if (this._element.tagName.toLowerCase() === "input") {
            const parent = this._element.parentNode;
            this._rippleInSpan = true;
            if (parent.tagName.toLowerCase() === "span" && parent.classList.contains($0abbbd36a260e067$var$CLASSNAME_RIPPLE)) this._element = parent;
            else {
                const shadow = getComputedStyle(this._element).boxShadow;
                const btn = this._element;
                const wrapper = document.createElement("span");
                if (btn.classList.contains("btn-block")) wrapper.style.display = "block";
                $0abbbd36a260e067$var$EventHandler$1.one(wrapper, "mouseup", (e)=>{
                    if (e.button === 0) btn.click();
                });
                wrapper.classList.add($0abbbd36a260e067$var$CLASSNAME_RIPPLE, $0abbbd36a260e067$var$CLASSNAME_RIPPLE_WRAPPER);
                $0abbbd36a260e067$var$Manipulator$1.addStyle(wrapper, {
                    border: 0,
                    "box-shadow": shadow
                });
                parent.replaceChild(wrapper, this._element);
                wrapper.appendChild(this._element);
                this._element = wrapper;
            }
            this._element.focus();
        }
        if (!this._element.style.minWidth) {
            $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
                "min-width": `${getComputedStyle(this._element).width}`
            });
            this._isMinWidthSet = true;
        }
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$CLASSNAME_RIPPLE);
        this._createRipple(event);
    }
    _addClickEvent(target) {
        $0abbbd36a260e067$var$EventHandler$1.on(target, "mousedown", this._clickHandler);
    }
    _getEventLayer(event) {
        const x = Math.round(event.clientX - event.target.getBoundingClientRect().x);
        const y = Math.round(event.clientY - event.target.getBoundingClientRect().y);
        return {
            layerX: x,
            layerY: y
        };
    }
    _createRipple(event) {
        if (this._element === null) return;
        if (!$0abbbd36a260e067$var$Manipulator$1.hasClass(this._element, $0abbbd36a260e067$var$CLASSNAME_RIPPLE)) $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$CLASSNAME_RIPPLE);
        const { layerX: layerX, layerY: layerY } = this._getEventLayer(event);
        const offsetX = layerX;
        const offsetY = layerY;
        const height = this._element.offsetHeight;
        const width = this._element.offsetWidth;
        const duration = this._durationToMsNumber(this._options.rippleDuration);
        const diameterOptions = {
            offsetX: this._options.rippleCentered ? height / 2 : offsetX,
            offsetY: this._options.rippleCentered ? width / 2 : offsetY,
            height: height,
            width: width
        };
        const diameter = this._getDiameter(diameterOptions);
        const radiusValue = this._options.rippleRadius || diameter / 2;
        const opacity = {
            delay: duration * $0abbbd36a260e067$var$TRANSITION_BREAK_OPACITY,
            duration: duration - duration * $0abbbd36a260e067$var$TRANSITION_BREAK_OPACITY
        };
        const styles = {
            left: this._options.rippleCentered ? `${width / 2 - radiusValue}px` : `${offsetX - radiusValue}px`,
            top: this._options.rippleCentered ? `${height / 2 - radiusValue}px` : `${offsetY - radiusValue}px`,
            height: `${this._options.rippleRadius * 2 || diameter}px`,
            width: `${this._options.rippleRadius * 2 || diameter}px`,
            transitionDelay: `0s, ${opacity.delay}ms`,
            transitionDuration: `${duration}ms, ${opacity.duration}ms`
        };
        const rippleHTML = $0abbbd36a260e067$var$element("div");
        this._createHTMLRipple({
            wrapper: this._element,
            ripple: rippleHTML,
            styles: styles
        });
        this._removeHTMLRipple({
            ripple: rippleHTML,
            duration: duration
        });
    }
    _createHTMLRipple({ wrapper: wrapper, ripple: ripple, styles: styles }) {
        Object.keys(styles).forEach((property)=>ripple.style[property] = styles[property]);
        ripple.classList.add($0abbbd36a260e067$var$CLASSNAME_RIPPLE_WAVE);
        if (this._options.rippleColor !== "") {
            this._removeOldColorClasses(wrapper);
            this._addColor(ripple, wrapper);
        }
        this._toggleUnbound(wrapper);
        this._appendRipple(ripple, wrapper);
    }
    _removeHTMLRipple({ ripple: ripple, duration: duration }) {
        if (this._rippleTimer) {
            clearTimeout(this._rippleTimer);
            this._rippleTimer = null;
        }
        this._rippleTimer = setTimeout(()=>{
            if (ripple) {
                ripple.remove();
                if (this._element) {
                    $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$CLASSNAME_RIPPLE_WAVE}`, this._element).forEach((rippleEl)=>{
                        rippleEl.remove();
                    });
                    if (this._isMinWidthSet) {
                        $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
                            "min-width": ""
                        });
                        this._isMinWidthSet = false;
                    }
                    if (this._rippleInSpan && this._element.classList.contains($0abbbd36a260e067$var$CLASSNAME_RIPPLE_WRAPPER)) this._removeWrapperSpan();
                    else $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, $0abbbd36a260e067$var$CLASSNAME_RIPPLE);
                }
            }
        }, duration);
    }
    _removeWrapperSpan() {
        const child = this._element.firstChild;
        this._element.replaceWith(child);
        this._element = child;
        this._element.focus();
        this._rippleInSpan = false;
    }
    _durationToMsNumber(time) {
        return Number(time.replace("ms", "").replace("s", "000"));
    }
    _getConfig(config = {}) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        config = {
            ...$0abbbd36a260e067$var$Default$n,
            ...dataAttributes,
            ...config
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$B, config, $0abbbd36a260e067$var$DefaultType$n);
        return config;
    }
    _getDiameter({ offsetX: offsetX, offsetY: offsetY, height: height, width: width }) {
        const top2 = offsetY <= height / 2;
        const left2 = offsetX <= width / 2;
        const pythagorean = (sideA, sideB)=>Math.sqrt(sideA ** 2 + sideB ** 2);
        const positionCenter = offsetY === height / 2 && offsetX === width / 2;
        const quadrant = {
            first: top2 === true && left2 === false,
            second: top2 === true && left2 === true,
            third: top2 === false && left2 === true,
            fourth: top2 === false && left2 === false
        };
        const getCorner = {
            topLeft: pythagorean(offsetX, offsetY),
            topRight: pythagorean(width - offsetX, offsetY),
            bottomLeft: pythagorean(offsetX, height - offsetY),
            bottomRight: pythagorean(width - offsetX, height - offsetY)
        };
        let diameter = 0;
        if (positionCenter || quadrant.fourth) diameter = getCorner.topLeft;
        else if (quadrant.third) diameter = getCorner.topRight;
        else if (quadrant.second) diameter = getCorner.bottomRight;
        else if (quadrant.first) diameter = getCorner.bottomLeft;
        return diameter * 2;
    }
    _appendRipple(target, parent) {
        const FIX_ADD_RIPPLE_EFFECT = 50;
        parent.appendChild(target);
        setTimeout(()=>{
            $0abbbd36a260e067$var$Manipulator$1.addClass(target, "active");
        }, FIX_ADD_RIPPLE_EFFECT);
    }
    _toggleUnbound(target) {
        if (this._options.rippleUnbound === true) $0abbbd36a260e067$var$Manipulator$1.addClass(target, $0abbbd36a260e067$var$CLASSNAME_UNBOUND);
        else target.classList.remove($0abbbd36a260e067$var$CLASSNAME_UNBOUND);
    }
    _addColor(target, parent) {
        const IS_BOOTSTRAP_COLOR = $0abbbd36a260e067$var$BOOTSTRAP_COLORS.find((color)=>color === this._options.rippleColor.toLowerCase());
        if (IS_BOOTSTRAP_COLOR) $0abbbd36a260e067$var$Manipulator$1.addClass(parent, `${$0abbbd36a260e067$var$CLASSNAME_RIPPLE}-${this._options.rippleColor.toLowerCase()}`);
        else {
            const rgbValue = this._colorToRGB(this._options.rippleColor).join(",");
            const gradientImage = $0abbbd36a260e067$var$GRADIENT.split("{{color}}").join(`${rgbValue}`);
            target.style.backgroundImage = `radial-gradient(circle, ${gradientImage})`;
        }
    }
    _removeOldColorClasses(target) {
        const REGEXP_CLASS_COLOR = new RegExp(`${$0abbbd36a260e067$var$CLASSNAME_RIPPLE}-[a-z]+`, "gi");
        const PARENT_CLASSS_COLOR = target.classList.value.match(REGEXP_CLASS_COLOR) || [];
        PARENT_CLASSS_COLOR.forEach((className)=>{
            target.classList.remove(className);
        });
    }
    _colorToRGB(color) {
        function hexToRgb(color2) {
            const HEX_COLOR_LENGTH = 7;
            const IS_SHORT_HEX = color2.length < HEX_COLOR_LENGTH;
            if (IS_SHORT_HEX) color2 = `#${color2[1]}${color2[1]}${color2[2]}${color2[2]}${color2[3]}${color2[3]}`;
            return [
                parseInt(color2.substr(1, 2), 16),
                parseInt(color2.substr(3, 2), 16),
                parseInt(color2.substr(5, 2), 16)
            ];
        }
        function namedColorsToRgba(color2) {
            const tempElem = document.body.appendChild(document.createElement("fictum"));
            const flag = "rgb(1, 2, 3)";
            tempElem.style.color = flag;
            if (tempElem.style.color !== flag) return $0abbbd36a260e067$var$DEFAULT_RIPPLE_COLOR;
            tempElem.style.color = color2;
            if (tempElem.style.color === flag || tempElem.style.color === "") return $0abbbd36a260e067$var$DEFAULT_RIPPLE_COLOR;
            color2 = getComputedStyle(tempElem).color;
            document.body.removeChild(tempElem);
            return color2;
        }
        function rgbaToRgb(color2) {
            color2 = color2.match(/[.\d]+/g).map((a)=>+Number(a));
            color2.length = 3;
            return color2;
        }
        if (color.toLowerCase() === "transparent") return $0abbbd36a260e067$var$DEFAULT_RIPPLE_COLOR;
        if (color[0] === "#") return hexToRgb(color);
        if (color.indexOf("rgb") === -1) color = namedColorsToRgba(color);
        if (color.indexOf("rgb") === 0) return rgbaToRgb(color);
        return $0abbbd36a260e067$var$DEFAULT_RIPPLE_COLOR;
    }
    // Static
    static autoInitial(instance) {
        return function(event) {
            instance._autoInit(event);
        };
    }
    static jQueryInterface(options) {
        return this.each(function() {
            const data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$s);
            if (!data) return new $0abbbd36a260e067$export$9e9146f7e027fdaa(this, options);
            return null;
        });
    }
}
const $0abbbd36a260e067$var$NAME$A = "range";
const $0abbbd36a260e067$var$DATA_KEY$r = "mdb.range";
const $0abbbd36a260e067$var$CLASSNAME_THUMB = "thumb";
const $0abbbd36a260e067$var$CLASSNAME_ACTIVE$1 = "thumb-active";
const $0abbbd36a260e067$var$CLASSNAME_THUMB_VALUE = "thumb-value";
const $0abbbd36a260e067$var$SELECTOR_THUMB_VALUE = `.${$0abbbd36a260e067$var$CLASSNAME_THUMB_VALUE}`;
const $0abbbd36a260e067$var$SELECTOR_THUMB = `.${$0abbbd36a260e067$var$CLASSNAME_THUMB}`;
class $0abbbd36a260e067$export$9a58ef0d7ad3278c extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2){
        super(element2);
        this._initiated = false;
        this._thumb = null;
        if (this._element) {
            this.init();
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$A;
    }
    get rangeInput() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne("input[type=range]", this._element);
    }
    // Public
    init() {
        if (this._initiated) return;
        this._addThumb();
        this._thumbUpdate();
        this._handleEvents();
        this._initiated = true;
    }
    dispose() {
        this._disposeEvents();
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _addThumb() {
        const RANGE_THUMB = $0abbbd36a260e067$var$element("span");
        $0abbbd36a260e067$var$Manipulator$1.addClass(RANGE_THUMB, $0abbbd36a260e067$var$CLASSNAME_THUMB);
        RANGE_THUMB.innerHTML = '<span class="thumb-value"></span>';
        this._element.append(RANGE_THUMB);
        this._thumb = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_THUMB, this._element);
    }
    _handleEvents() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.rangeInput, "mousedown", ()=>this._showThumb());
        $0abbbd36a260e067$var$EventHandler$1.on(this.rangeInput, "mouseup", ()=>this._hideThumb());
        $0abbbd36a260e067$var$EventHandler$1.on(this.rangeInput, "touchstart", ()=>this._showThumb());
        $0abbbd36a260e067$var$EventHandler$1.on(this.rangeInput, "touchend", ()=>this._hideThumb());
        $0abbbd36a260e067$var$EventHandler$1.on(this.rangeInput, "input", ()=>this._thumbUpdate());
    }
    _disposeEvents() {
        $0abbbd36a260e067$var$EventHandler$1.off(this.rangeInput, "mousedown");
        $0abbbd36a260e067$var$EventHandler$1.off(this.rangeInput, "mouseup");
        $0abbbd36a260e067$var$EventHandler$1.off(this.rangeInput, "touchstart");
        $0abbbd36a260e067$var$EventHandler$1.off(this.rangeInput, "touchend");
        $0abbbd36a260e067$var$EventHandler$1.off(this.rangeInput, "input");
    }
    _showThumb() {
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._thumb, $0abbbd36a260e067$var$CLASSNAME_ACTIVE$1);
    }
    _hideThumb() {
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this._thumb, $0abbbd36a260e067$var$CLASSNAME_ACTIVE$1);
    }
    _thumbUpdate() {
        const rangeInput = this.rangeInput;
        const inputValue = rangeInput.value;
        const minValue = rangeInput.min ? rangeInput.min : 0;
        const maxValue = rangeInput.max ? rangeInput.max : 100;
        const thumbValue = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_THUMB_VALUE, this._thumb);
        thumbValue.textContent = inputValue;
        const newValue = Number((inputValue - minValue) * 100 / (maxValue - minValue));
        $0abbbd36a260e067$var$Manipulator$1.style(this._thumb, {
            left: `calc(${newValue}% + (${8 - newValue * 0.15}px))`
        });
    }
    // Static
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$r);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$9a58ef0d7ad3278c(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$z = "animation";
const $0abbbd36a260e067$var$DefaultType$m = {
    animation: "string",
    animationStart: "string",
    animationShowOnLoad: "boolean",
    onStart: "(null|function)",
    onEnd: "(null|function)",
    onHide: "(null|function)",
    onShow: "(null|function)",
    animationOnScroll: "(string)",
    animationOffset: "(number|string)",
    animationDelay: "(number|string)",
    animationDuration: "(number|string)",
    animationReverse: "boolean",
    animationInterval: "(number|string)",
    animationRepeat: "(number|boolean)",
    animationReset: "boolean"
};
const $0abbbd36a260e067$var$Default$m = {
    animation: "fade",
    animationStart: "onClick",
    animationShowOnLoad: true,
    onStart: null,
    onEnd: null,
    onHide: null,
    onShow: null,
    animationOnScroll: "once",
    animationOffset: 0,
    animationDelay: 0,
    animationDuration: 500,
    animationReverse: false,
    animationInterval: 0,
    animationRepeat: false,
    animationReset: false
};
class $0abbbd36a260e067$export$83a1293bbde53b95 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options){
        super(element2);
        this._animateElement = this._getAnimateElement();
        this._isFirstScroll = true;
        this._repeatAnimateOnScroll = true;
        this._options = this._getConfig(options);
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$z;
    }
    // Public
    init() {
        this._init();
    }
    startAnimation() {
        this._startAnimation();
    }
    stopAnimation() {
        this._clearAnimationClass();
    }
    changeAnimationType(animation) {
        this._options.animation = animation;
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "mousedown");
        $0abbbd36a260e067$var$EventHandler$1.off(this._animateElement, "animationend");
        $0abbbd36a260e067$var$EventHandler$1.off(window, "scroll");
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "mouseover");
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _init() {
        switch(this._options.animationStart){
            case "onHover":
                this._bindHoverEvents();
                break;
            case "onLoad":
                this._startAnimation();
                break;
            case "onScroll":
                this._bindScrollEvents();
                break;
            case "onClick":
                this._bindClickEvents();
                break;
        }
        this._bindTriggerOnEndCallback();
        if (this._options.animationReset) this._bindResetAnimationAfterFinish();
    }
    _getAnimateElement() {
        const targetId = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(this._element, "animation-target");
        return targetId ? $0abbbd36a260e067$var$SelectorEngine$1.find(targetId)[0] : this._element;
    }
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._animateElement);
        config = {
            ...$0abbbd36a260e067$var$Default$m,
            ...dataAttributes,
            ...config
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$z, config, $0abbbd36a260e067$var$DefaultType$m);
        return config;
    }
    _animateOnScroll() {
        const elementOffsetTop = $0abbbd36a260e067$var$Manipulator$1.offset(this._animateElement).top;
        const elementHeight = this._animateElement.offsetHeight;
        const windowHeight = window.innerHeight;
        const shouldBeVisible = elementOffsetTop + this._options.animationOffset <= windowHeight && elementOffsetTop + this._options.animationOffset + elementHeight >= 0;
        const isElementVisible = this._animateElement.style.visibility === "visible";
        switch(true){
            case shouldBeVisible && this._isFirstScroll:
                this._isFirstScroll = false;
                this._startAnimation();
                break;
            case !shouldBeVisible && this._isFirstScroll:
                this._isFirstScroll = false;
                this._hideAnimateElement();
                break;
            case shouldBeVisible && !isElementVisible && this._repeatAnimateOnScroll:
                if (this._options.animationOnScroll !== "repeat") this._repeatAnimateOnScroll = false;
                this._callback(this._options.onShow);
                this._showAnimateElement();
                this._startAnimation();
                break;
            case !shouldBeVisible && isElementVisible && this._repeatAnimateOnScroll:
                this._hideAnimateElement();
                this._clearAnimationClass();
                this._callback(this._options.onHide);
                break;
        }
    }
    _addAnimatedClass() {
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._animateElement, "animation");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._animateElement, this._options.animation);
    }
    _clearAnimationClass() {
        this._animateElement.classList.remove(this._options.animation, "animation");
    }
    _removeInvisibleClass() {
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this._animateElement, "invisible");
    }
    _startAnimation() {
        this._callback(this._options.onStart);
        this._removeInvisibleClass();
        this._addAnimatedClass();
        if (this._options.animationRepeat && !this._options.animationInterval) this._setAnimationRepeat();
        if (this._options.animationReverse) this._setAnimationReverse();
        if (this._options.animationDelay) this._setAnimationDelay();
        if (this._options.animationDuration) this._setAnimationDuration();
        if (this._options.animationInterval) this._setAnimationInterval();
    }
    _setAnimationReverse() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._animateElement, {
            animationIterationCount: this._options.animationRepeat === true ? "infinite" : "2",
            animationDirection: "alternate"
        });
    }
    _setAnimationDuration() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._animateElement, {
            animationDuration: `${this._options.animationDuration}ms`
        });
    }
    _setAnimationDelay() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._animateElement, {
            animationDelay: `${this._options.animationDelay}ms`
        });
    }
    _setAnimationRepeat() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._animateElement, {
            animationIterationCount: this._options.animationRepeat === true ? "infinite" : this._options.animationRepeat
        });
    }
    _setAnimationInterval() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._animateElement, "animationend", ()=>{
            this._clearAnimationClass();
            setTimeout(()=>{
                this._addAnimatedClass();
            }, this._options.animationInterval);
        });
    }
    _hideAnimateElement() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._animateElement, {
            visibility: "hidden"
        });
    }
    _showAnimateElement() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._animateElement, {
            visibility: "visible"
        });
    }
    _bindResetAnimationAfterFinish() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._animateElement, "animationend", ()=>{
            this._clearAnimationClass();
        });
    }
    _bindTriggerOnEndCallback() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._animateElement, "animationend", ()=>{
            this._callback(this._options.onEnd);
        });
    }
    _bindScrollEvents() {
        if (!this._options.animationShowOnLoad) this._animateOnScroll();
        $0abbbd36a260e067$var$EventHandler$1.on(window, "scroll", ()=>{
            this._animateOnScroll();
        });
    }
    _bindClickEvents() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "mousedown", ()=>{
            this._startAnimation();
        });
    }
    _bindHoverEvents() {
        $0abbbd36a260e067$var$EventHandler$1.one(this._element, "mouseover", ()=>{
            this._startAnimation();
        });
        $0abbbd36a260e067$var$EventHandler$1.one(this._animateElement, "animationend", ()=>{
            setTimeout(()=>{
                this._bindHoverEvents();
            }, 100);
        });
    }
    _callback(fn2) {
        if (fn2 instanceof Function) fn2();
    }
    // Static
    static autoInit(instance) {
        instance._init();
    }
    static jQueryInterface(options) {
        const animate = new $0abbbd36a260e067$export$83a1293bbde53b95(this[0], options);
        animate.init();
    }
}
const $0abbbd36a260e067$var$NAME$y = "lightbox";
const $0abbbd36a260e067$var$DATA_KEY$q = "mdb.lightbox";
const $0abbbd36a260e067$var$EVENT_KEY$k = `.${$0abbbd36a260e067$var$DATA_KEY$q}`;
const $0abbbd36a260e067$var$DATA_API_KEY$2 = ".data-api";
const $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$2 = `click${$0abbbd36a260e067$var$EVENT_KEY$k}${$0abbbd36a260e067$var$DATA_API_KEY$2}`;
const $0abbbd36a260e067$var$CLASSNAME_LIGHTBOX = "lightbox";
const $0abbbd36a260e067$var$CLASSNAME_GALLERY = "lightbox-gallery";
const $0abbbd36a260e067$var$CLASSNAME_TOOLBAR = "lightbox-gallery-toolbar";
const $0abbbd36a260e067$var$CLASSNAME_GALLERY_CONTENT = "lightbox-gallery-content";
const $0abbbd36a260e067$var$CLASSNAME_COUNTER = "lightbox-gallery-counter";
const $0abbbd36a260e067$var$CLASSNAME_FULLSCREEN_BTN = "lightbox-gallery-fullscreen-btn";
const $0abbbd36a260e067$var$CLASSNAME_ZOOM_BTN = "lightbox-gallery-zoom-btn";
const $0abbbd36a260e067$var$CLASSNAME_LEFT_TOOLS = "lightbox-gallery-left-tools";
const $0abbbd36a260e067$var$CLASSNAME_RIGHT_TOOLS = "lightbox-gallery-right-tools";
const $0abbbd36a260e067$var$CLASSNAME_CLOSE_BTN = "lightbox-gallery-close-btn";
const $0abbbd36a260e067$var$CLASSNAME_LOADER = "lightbox-gallery-loader";
const $0abbbd36a260e067$var$CLASSNAME_ARROW_LEFT = "lightbox-gallery-arrow-left";
const $0abbbd36a260e067$var$CLASSNAME_ARROW_RIGHT = "lightbox-gallery-arrow-right";
const $0abbbd36a260e067$var$CLASSNAME_CAPTION_WRAPPER = "lightbox-gallery-caption-wrapper";
const $0abbbd36a260e067$var$CLASSNAME_CAPTION = "lightbox-gallery-caption";
const $0abbbd36a260e067$var$CLASSNAME_IMG = "lightbox-gallery-image";
const $0abbbd36a260e067$var$SELECTOR_TOGGLE$2 = `[data-mdb-${$0abbbd36a260e067$var$NAME$y}-init] img:not(.lightbox-disabled)`;
const $0abbbd36a260e067$var$OPTIONS_TYPE$2 = {
    container: "string",
    zoomLevel: "(number|string)"
};
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$c = {
    container: "body",
    zoomLevel: 1
};
class $0abbbd36a260e067$export$7d2670a66155874b extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options = {}){
        super(element2);
        this._options = options;
        this._getContainer();
        this._id = `lightbox-${Math.random().toString(36).substr(2, 9)}`;
        this._activeImg = 0;
        this._images = [];
        this._preloadedImages = [];
        this._zoom = 1;
        this._gallery = null;
        this._galleryToolbar = null;
        this._galleryContent = null;
        this._loader = null;
        this._imgCounter = null;
        this._animating = false;
        this._fullscreen = false;
        this._zoomBtn = null;
        this._fullscreenBtn = null;
        this._toolsToggleTimer = 0;
        this._mousedown = false;
        this._mousedownPositionX = 0;
        this._mousedownPositionY = 0;
        this._originalPositionX = 0;
        this._originalPositionY = 0;
        this._positionX = 0;
        this._positionY = 0;
        this._zoomTimer = 0;
        this._tapCounter = 0;
        this._tapTime = 0;
        this._rightArrow = null;
        this._leftArrowWrapper = null;
        this._rightArrowWrapper = null;
        this._initiated = false;
        this._multitouch = false;
        this._touchZoomPosition = [];
        if (this._element) {
            this.init();
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$y;
    }
    get activeImg() {
        return this._activeImg;
    }
    get currentImg() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(".active", this._galleryContent);
    }
    get nextImage() {
        return this._activeImg === this._images.length - 1 ? 0 : this._activeImg + 1;
    }
    get previousImage() {
        return this._activeImg === 0 ? this._images.length - 1 : this._activeImg - 1;
    }
    get options() {
        const config = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$c,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...this._options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$y, config, $0abbbd36a260e067$var$OPTIONS_TYPE$2);
        return config;
    }
    // Public
    init() {
        if (this._initiated) return;
        this._appendTemplate();
        this._initiated = true;
    }
    open(target = 0) {
        this._getImages();
        this._setActiveImg(target);
        this._triggerEvents("open", "opened");
        this._loadImages().then((images)=>{
            this._preloadedImages = images;
            this._resizeImages(images);
            this._toggleTemplate();
            this._addEvents();
            this._focusFullscreenBtn();
        });
    }
    close() {
        this.reset();
        this._removeEvents();
        this._toggleTemplate();
        this._triggerEvents("close", "closed");
    }
    slide(target = "right") {
        if (this._animating === true || this._images.length <= 1) return;
        this._triggerEvents("slide", "slid");
        this._beforeSlideEvents();
        if (target === "right") this._slideHorizontally(target);
        if (target === "left") this._slideHorizontally(target);
        if (target === "first") this._slideToTarget(target);
        if (target === "last") this._slideToTarget(target);
        this._afterSlideEvents();
    }
    zoomIn() {
        if (this._zoom >= 3) return;
        this._triggerEvents("zoomIn", "zoomedIn");
        this._zoom += parseFloat(this.options.zoomLevel);
        $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg.parentNode, {
            transform: `scale(${this._zoom})`
        });
        this._updateZoomBtn();
    }
    zoomOut() {
        if (this._zoom <= 1) return;
        this._triggerEvents("zoomOut", "zoomedOut");
        this._zoom -= parseFloat(this.options.zoomLevel);
        $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg.parentNode, {
            transform: `scale(${this._zoom})`
        });
        this._updateZoomBtn();
        this._updateImgPosition();
    }
    toggleFullscreen() {
        if (this._fullscreen === false) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._fullscreenBtn, "active");
            if (this._gallery.requestFullscreen) this._gallery.requestFullscreen();
            this._fullscreen = true;
        } else {
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this._fullscreenBtn, "active");
            if (document.exitFullscreen) document.exitFullscreen();
            this._fullscreen = false;
        }
    }
    reset() {
        this._restoreDefaultFullscreen();
        this._restoreDefaultPosition();
        this._restoreDefaultZoom();
        clearTimeout(this._toolsToggleTimer);
        clearTimeout(this._doubleTapTimer);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(document, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$2, $0abbbd36a260e067$var$SELECTOR_TOGGLE$2, this.toggle);
        if (this._galleryContent) this._removeEvents();
        if (this._gallery) this._gallery.remove();
        $0abbbd36a260e067$var$Data$1.removeData(this._element, $0abbbd36a260e067$var$DATA_KEY$q);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _getImages() {
        const allImages = $0abbbd36a260e067$var$SelectorEngine$1.find("img", this._element);
        const lightboxImages = allImages.filter((image)=>{
            return !image.classList.contains("lightbox-disabled");
        });
        this._images = lightboxImages;
    }
    _getContainer() {
        this._container = $0abbbd36a260e067$var$SelectorEngine$1.findOne(this.options.container);
    }
    _setActiveImg(target) {
        this._activeImg = typeof target === "number" ? target : this._images.indexOf(target.target);
    }
    _appendTemplate() {
        this._gallery = $0abbbd36a260e067$var$element("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._gallery, $0abbbd36a260e067$var$CLASSNAME_GALLERY);
        this._element.dataset.id = this._id;
        this._gallery.id = this._id;
        this._appendLoader();
        this._appendToolbar();
        this._appendContent();
        this._appendArrows();
        this._appendCaption();
        this._container.append(this._gallery);
    }
    _appendToolbar() {
        this._galleryToolbar = $0abbbd36a260e067$var$element("div");
        this._imgCounter = $0abbbd36a260e067$var$element("p");
        this._fullscreenBtn = $0abbbd36a260e067$var$element("button");
        this._zoomBtn = $0abbbd36a260e067$var$element("button");
        const leftTools = $0abbbd36a260e067$var$element("div");
        const rightTools = $0abbbd36a260e067$var$element("div");
        const closeBtn = $0abbbd36a260e067$var$element("button");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._galleryToolbar, $0abbbd36a260e067$var$CLASSNAME_TOOLBAR);
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._imgCounter, $0abbbd36a260e067$var$CLASSNAME_COUNTER);
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._fullscreenBtn, $0abbbd36a260e067$var$CLASSNAME_FULLSCREEN_BTN);
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._zoomBtn, $0abbbd36a260e067$var$CLASSNAME_ZOOM_BTN);
        $0abbbd36a260e067$var$Manipulator$1.addClass(leftTools, $0abbbd36a260e067$var$CLASSNAME_LEFT_TOOLS);
        $0abbbd36a260e067$var$Manipulator$1.addClass(rightTools, $0abbbd36a260e067$var$CLASSNAME_RIGHT_TOOLS);
        $0abbbd36a260e067$var$Manipulator$1.addClass(closeBtn, $0abbbd36a260e067$var$CLASSNAME_CLOSE_BTN);
        this._fullscreenBtn.setAttribute("aria-label", "Toggle fullscreen");
        this._zoomBtn.setAttribute("aria-label", "Zoom in");
        closeBtn.setAttribute("aria-label", "Close");
        $0abbbd36a260e067$var$EventHandler$1.on(this._fullscreenBtn, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$2, ()=>this.toggleFullscreen());
        $0abbbd36a260e067$var$EventHandler$1.on(this._zoomBtn, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$2, ()=>this._toggleZoom());
        $0abbbd36a260e067$var$EventHandler$1.on(closeBtn, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$2, ()=>this.close());
        leftTools.append(this._imgCounter);
        rightTools.append(this._fullscreenBtn);
        rightTools.append(this._zoomBtn);
        rightTools.append(closeBtn);
        this._galleryToolbar.append(leftTools);
        this._galleryToolbar.append(rightTools);
        this._gallery.append(this._galleryToolbar);
    }
    _appendContent() {
        this._galleryContent = $0abbbd36a260e067$var$element("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._galleryContent, $0abbbd36a260e067$var$CLASSNAME_GALLERY_CONTENT);
        this._gallery.append(this._galleryContent);
    }
    _appendLoader() {
        this._loader = $0abbbd36a260e067$var$element("div");
        const spinner = $0abbbd36a260e067$var$element("div");
        const spinnerContent = $0abbbd36a260e067$var$element("span");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._loader, $0abbbd36a260e067$var$CLASSNAME_LOADER);
        $0abbbd36a260e067$var$Manipulator$1.addClass(spinner, "spinner-grow");
        $0abbbd36a260e067$var$Manipulator$1.addClass(spinner, "text-light");
        $0abbbd36a260e067$var$Manipulator$1.addClass(spinnerContent, "sr-only");
        spinner.setAttribute("role", "status");
        spinnerContent.innerHTML = "Loading...";
        spinner.append(spinnerContent);
        this._loader.append(spinner);
        this._gallery.append(this._loader);
    }
    _appendArrows() {
        this._leftArrowWrapper = $0abbbd36a260e067$var$element("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._leftArrowWrapper, $0abbbd36a260e067$var$CLASSNAME_ARROW_LEFT);
        const leftArrow = $0abbbd36a260e067$var$element("button");
        leftArrow.setAttribute("aria-label", "Previous");
        $0abbbd36a260e067$var$EventHandler$1.on(leftArrow, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$2, ()=>this.slide("left"));
        this._leftArrowWrapper.append(leftArrow);
        this._rightArrowWrapper = $0abbbd36a260e067$var$element("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._rightArrowWrapper, $0abbbd36a260e067$var$CLASSNAME_ARROW_RIGHT);
        this._rightArrow = $0abbbd36a260e067$var$element("button");
        this._rightArrow.setAttribute("aria-label", "Next");
        $0abbbd36a260e067$var$EventHandler$1.on(this._rightArrow, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$2, ()=>this.slide());
        this._rightArrowWrapper.append(this._rightArrow);
        this._getImages();
        if (this._images.length <= 1) return;
        this._gallery.append(this._leftArrowWrapper);
        this._gallery.append(this._rightArrowWrapper);
    }
    _appendCaption() {
        const captionWrapper = $0abbbd36a260e067$var$element("div");
        const caption = $0abbbd36a260e067$var$element("p");
        $0abbbd36a260e067$var$Manipulator$1.addClass(captionWrapper, $0abbbd36a260e067$var$CLASSNAME_CAPTION_WRAPPER);
        $0abbbd36a260e067$var$Manipulator$1.addClass(caption, $0abbbd36a260e067$var$CLASSNAME_CAPTION);
        captionWrapper.append(caption);
        this._gallery.append(captionWrapper);
    }
    async _loadImages() {
        const promiseArray = [];
        const imageArray = [];
        this._galleryContent.innerHTML = "";
        let positionLeft = -100;
        const activeIndexes = [
            this.previousImage,
            this._activeImg,
            this.nextImage
        ];
        activeIndexes.forEach((key)=>{
            promiseArray.push(new Promise((resolve)=>{
                const img = this._createImage(key, positionLeft, "right");
                img.onload = ()=>{
                    imageArray.push(img);
                    resolve(img);
                };
            }));
            positionLeft += 100;
        });
        await Promise.all(promiseArray);
        return imageArray;
    }
    _createImage(index, positionLeft, direction) {
        const img = this._images[index];
        const newImg = new Image();
        const newImgWrapper = $0abbbd36a260e067$var$element("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(newImgWrapper, $0abbbd36a260e067$var$CLASSNAME_IMG);
        this._addImgStyles(newImg, newImgWrapper, positionLeft, img);
        newImgWrapper.append(newImg);
        if (direction === "right") this._galleryContent.append(newImgWrapper);
        else this._galleryContent.prepend(newImgWrapper);
        newImg.src = img.dataset.mdbImg || img.src;
        return newImg;
    }
    _updatePreloadedImages(direction) {
        const isDirectionRight = direction === "right";
        const targetChild = isDirectionRight ? this._galleryContent.firstChild : this._galleryContent.lastChild;
        const targetImage = targetChild == null ? void 0 : targetChild.querySelector("img");
        this._removeImageEvents(targetImage);
        this._galleryContent.removeChild(targetChild);
        const newIndex = isDirectionRight ? this.nextImage : this.previousImage;
        const positionLeft = isDirectionRight ? 200 : -200;
        const addedImage = this._createImage(newIndex, positionLeft, direction);
        this._addImageEvents(addedImage);
        this._preloadedImages = $0abbbd36a260e067$var$SelectorEngine$1.find("img", this._galleryContent);
    }
    _addImgStyles(newImg, newImgWrapper, positionLeft, img) {
        newImg.alt = img.alt;
        newImg.draggable = false;
        $0abbbd36a260e067$var$Manipulator$1.style(newImgWrapper, {
            position: "absolute",
            left: `${positionLeft}%`,
            top: 0
        });
        if (img.dataset.mdbCaption || img.dataset.mdbCaption === "") newImg.dataset.caption = img.dataset.mdbCaption;
        if (positionLeft === 0) {
            if (newImg.width < newImg.height) $0abbbd36a260e067$var$Manipulator$1.addClass(newImg, "vertical");
            $0abbbd36a260e067$var$Manipulator$1.style(newImgWrapper, {
                opacity: 1
            });
            $0abbbd36a260e067$var$Manipulator$1.addClass(newImg, "active");
        } else $0abbbd36a260e067$var$Manipulator$1.removeClass(newImg, "active");
    }
    _resizeImages(images) {
        images.forEach((img)=>{
            this._calculateImgSize(img);
        });
    }
    _calculateImgSize(img) {
        if (img.width >= img.height) {
            img.style.width = "100%";
            img.style.maxWidth = "100%";
            img.style.height = "auto";
            img.style.top = `${(img.parentNode.offsetHeight - img.height) / 2}px`;
            img.style.left = 0;
        } else {
            img.style.height = "100%";
            img.style.maxHeight = "100%";
            img.style.width = "auto";
            img.style.left = `${(img.parentNode.offsetWidth - img.width) / 2}px`;
            img.style.top = 0;
        }
        if (img.width >= img.parentNode.offsetWidth) {
            img.style.width = `${img.parentNode.offsetWidth}px`;
            img.style.height = "auto";
            img.style.left = 0;
            img.style.top = `${(img.parentNode.offsetHeight - img.height) / 2}px`;
        }
        if (img.height >= img.parentNode.offsetHeight) {
            img.style.height = `${img.parentNode.offsetHeight}px`;
            img.style.width = "auto";
            img.style.top = 0;
            img.style.left = `${(img.parentNode.offsetWidth - img.width) / 2}px`;
        }
        this._positionX = parseFloat(img.style.left) || 0;
        this._positionY = parseFloat(img.style.top) || 0;
    }
    _onResize() {
        this._preloadedImages.forEach((img)=>{
            this._calculateImgSize(img);
        });
    }
    _onFullscreenChange() {
        const isFullscreenEnabled = document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement;
        if (isFullscreenEnabled === void 0) {
            this._fullscreen = false;
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this._fullscreenBtn, "active");
        }
    }
    _beforeSlideEvents() {
        this._animationStart();
        this._restoreDefaultZoom();
        this._restoreDefaultPosition();
        this._resetDoubleTap();
    }
    _slideHorizontally(direction) {
        this._updateActiveImg(direction);
        this._updatePreloadedImages(direction);
        this._resizeImages(this._preloadedImages);
        this._preloadedImages = $0abbbd36a260e067$var$SelectorEngine$1.find("img", this._galleryContent);
        this._slidePreloadedImages();
    }
    _slideImg(img, position) {
        if (position === 0) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(img, "active");
            $0abbbd36a260e067$var$Manipulator$1.style(img.parentNode, {
                opacity: 1,
                transform: "scale(1)"
            });
        } else {
            $0abbbd36a260e067$var$Manipulator$1.removeClass(img, "active");
            $0abbbd36a260e067$var$Manipulator$1.style(img.parentNode, {
                opacity: 0,
                transform: "scale(0.25)"
            });
        }
        img.parentNode.style.left = `${position}%`;
    }
    _slidePreloadedImages() {
        let positionLeft = -100;
        this._preloadedImages.forEach((image)=>{
            this._slideImg(image, positionLeft);
            positionLeft += 100;
        });
    }
    _slideToTarget(target) {
        if (target === "first" && this._activeImg === 0) return;
        if (target === "last" && this._activeImg === this._images.length - 1) return;
        this.reset();
        this._removeEvents();
        this._showLoader();
        this._getImages();
        this._activeImg = target === "first" ? 0 : this._images.length - 1;
        $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg.parentNode, {
            transform: "scale(0.25)",
            opacity: 0
        });
        setTimeout(()=>{
            this._loadImages().then((images)=>{
                this._preloadedImages = images;
                this._resizeImages(images);
                this._addEvents();
                this._updateCaption();
                this._hideLoader();
                setTimeout(()=>{
                    $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg.parentNode, {
                        transform: "scale(1)",
                        opacity: 1
                    });
                }, 10);
            });
        }, 400);
    }
    _updateActiveImg(direction) {
        if (direction === "right") this._activeImg = this.nextImage;
        if (direction === "left") this._activeImg = this.previousImage;
    }
    _afterSlideEvents() {
        this._updateCounter();
        this._updateCaption();
    }
    _updateCounter() {
        if (this._images.length <= 1) return;
        setTimeout(()=>{
            this._imgCounter.innerHTML = `${this._activeImg + 1} / ${this._images.length}`;
        }, 200);
    }
    _updateCaption() {
        setTimeout(()=>{
            let caption = this.currentImg.alt;
            if (this.currentImg.dataset.caption || this.currentImg.dataset.caption === "") caption = this.currentImg.dataset.caption;
            $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CLASSNAME_CAPTION}`, this._gallery).innerHTML = caption;
        }, 200);
    }
    _toggleTemplate() {
        if (this._gallery.style.visibility === "visible") {
            $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg.parentNode, {
                transform: "scale(0.25)"
            });
            setTimeout(()=>{
                this._hideGallery();
                this._enableScroll();
                this._showLoader();
            }, 100);
        } else {
            this._showGallery();
            this._disableScroll();
            this._updateCounter();
            this._updateCaption();
            this._setToolsToggleTimout();
            this._hideLoader();
        }
    }
    _showLoader() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._loader, {
            opacity: 1
        });
    }
    _hideLoader() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._loader, {
            opacity: 0
        });
    }
    _hideGallery() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._gallery, {
            opacity: 0,
            pointerEvents: "none",
            visibility: "hidden"
        });
    }
    _showGallery() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._gallery, {
            opacity: 1,
            pointerEvents: "initial",
            visibility: "visible"
        });
        setTimeout(()=>{
            $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg.parentNode, {
                transform: "scale(1)"
            });
        }, 50);
    }
    _toggleZoom() {
        if (this._zoom !== 1) this._restoreDefaultZoom();
        else this.zoomIn();
    }
    _updateZoomBtn() {
        if (this._zoom > 1) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._zoomBtn, "active");
            this._zoomBtn.setAttribute("aria-label", "Zoom out");
        } else {
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this._zoomBtn, "active");
            this._zoomBtn.setAttribute("aria-label", "Zoom in");
        }
    }
    _updateImgPosition() {
        if (this._zoom === 1) this._restoreDefaultPosition();
    }
    _addEvents() {
        const images = $0abbbd36a260e067$var$SelectorEngine$1.find("img", this._galleryContent);
        this._onWindowTouchmove = this._onWindowTouchmove.bind(this);
        this._onWindowTouchstart = this._onWindowTouchstart.bind(this);
        this._onImgMousedown = this._onMousedown.bind(this);
        this._onImgMousemove = this._onMousemove.bind(this);
        this._onImgWheel = this._onWheel.bind(this);
        this._onImgMouseup = this._onMouseup.bind(this);
        this._onImgTouchend = this._onTouchend.bind(this);
        this._onImgDoubleClick = this._onDoubleClick.bind(this);
        this._onWindowResize = this._onResize.bind(this);
        this._onWindowFullscreenChange = this._onFullscreenChange.bind(this);
        this._onAnyImgAction = this._resetToolsToggler.bind(this);
        this._onGalleryClick = this._onBackdropClick.bind(this);
        this._onKeyupEvent = this._onKeyup.bind(this);
        this._onRightArrowKeydownEvent = this._onRightArrowKeydown.bind(this);
        this._onFullscreenBtnKeydownEvent = this._onFullscreenBtnKeydown.bind(this);
        images.forEach((img)=>{
            this._addImageEvents(img);
        });
        document.addEventListener("touchmove", this._onWindowTouchmove, {
            passive: false
        });
        $0abbbd36a260e067$var$EventHandler$1.on(window, "touchstart", this._onWindowTouchstart);
        $0abbbd36a260e067$var$EventHandler$1.on(window, "mouseup", this._onImgMouseup);
        $0abbbd36a260e067$var$EventHandler$1.on(window, "touchend", this._onImgTouchend);
        $0abbbd36a260e067$var$EventHandler$1.on(window, "resize", this._onWindowResize);
        $0abbbd36a260e067$var$EventHandler$1.on(window, "orientationchange", this._onWindowResize);
        $0abbbd36a260e067$var$EventHandler$1.on(window, "keyup", this._onKeyupEvent);
        $0abbbd36a260e067$var$EventHandler$1.on(window, "fullscreenchange", this._onWindowFullscreenChange);
        $0abbbd36a260e067$var$EventHandler$1.on(this._gallery, "mousemove", this._onAnyImgAction);
        $0abbbd36a260e067$var$EventHandler$1.on(this._gallery, "click", this._onGalleryClick);
        $0abbbd36a260e067$var$EventHandler$1.on(this._rightArrow, "keydown", this._onRightArrowKeydownEvent);
        $0abbbd36a260e067$var$EventHandler$1.on(this._fullscreenBtn, "keydown", this._onFullscreenBtnKeydownEvent);
    }
    _addImageEvents(img) {
        $0abbbd36a260e067$var$EventHandler$1.on(img, "mousedown", this._onImgMousedown, {
            passive: true
        });
        $0abbbd36a260e067$var$EventHandler$1.on(img, "touchstart", this._onImgMousedown, {
            passive: true
        });
        $0abbbd36a260e067$var$EventHandler$1.on(img, "mousemove", this._onImgMousemove, {
            passive: true
        });
        $0abbbd36a260e067$var$EventHandler$1.on(img, "touchmove", this._onImgMousemove, {
            passive: true
        });
        $0abbbd36a260e067$var$EventHandler$1.on(img, "wheel", this._onImgWheel, {
            passive: true
        });
        $0abbbd36a260e067$var$EventHandler$1.on(img, "dblclick", this._onImgDoubleClick, {
            passive: true
        });
    }
    _removeEvents() {
        const images = $0abbbd36a260e067$var$SelectorEngine$1.find("img", this._galleryContent);
        images.forEach((img)=>{
            this._removeImageEvents(img);
        });
        document.removeEventListener("touchmove", this._onWindowTouchmove, {
            passive: false
        });
        $0abbbd36a260e067$var$EventHandler$1.off(window, "touchstart", this._onWindowTouchstart);
        $0abbbd36a260e067$var$EventHandler$1.off(window, "mouseup", this._onImgMouseup);
        $0abbbd36a260e067$var$EventHandler$1.off(window, "touchend", this._onImgTouchend);
        $0abbbd36a260e067$var$EventHandler$1.off(window, "resize", this._onWindowResize);
        $0abbbd36a260e067$var$EventHandler$1.off(window, "orientationchange", this._onWindowResize);
        $0abbbd36a260e067$var$EventHandler$1.off(window, "keyup", this._onKeyupEvent);
        $0abbbd36a260e067$var$EventHandler$1.off(window, "fullscreenchange", this._onWindowFullscreenChange);
        $0abbbd36a260e067$var$EventHandler$1.off(this._gallery, "mousemove", this._onAnyImgAction);
        $0abbbd36a260e067$var$EventHandler$1.off(this._gallery, "click", this._onGalleryClick);
        $0abbbd36a260e067$var$EventHandler$1.off(this._rightArrow, "keydown", this._onRightArrowKeydownEvent);
        $0abbbd36a260e067$var$EventHandler$1.off(this._fullscreenBtn, "keydown", this._onFullscreenBtnKeydownEvent);
    }
    _removeImageEvents(img) {
        $0abbbd36a260e067$var$EventHandler$1.off(img, "mousedown", this._onImgMousedown);
        $0abbbd36a260e067$var$EventHandler$1.off(img, "touchstart", this._onImgMousedown);
        $0abbbd36a260e067$var$EventHandler$1.off(img, "mousemove", this._onImgMousemove);
        $0abbbd36a260e067$var$EventHandler$1.off(img, "touchmove", this._onImgMousemove);
        $0abbbd36a260e067$var$EventHandler$1.off(img, "wheel", this._onImgWheel);
        $0abbbd36a260e067$var$EventHandler$1.off(img, "dblclick", this._onImgDoubleClick);
    }
    _onMousedown(e) {
        const touch2 = e.touches;
        const x = touch2 ? touch2[0].clientX : e.clientX;
        const y = touch2 ? touch2[0].clientY : e.clientY;
        this._originalPositionX = parseFloat(this.currentImg.style.left) || 0;
        this._originalPositionY = parseFloat(this.currentImg.style.top) || 0;
        this._positionX = this._originalPositionX;
        this._positionY = this._originalPositionY;
        this._mousedownPositionX = x * (1 / this._zoom) - this._positionX;
        this._mousedownPositionY = y * (1 / this._zoom) - this._positionY;
        this._mousedown = true;
        if (e.type === "touchstart") {
            if (e.touches.length > 1) {
                this._multitouch = true;
                this._touchZoomPosition = e.touches;
            }
        }
    }
    _onMousemove(e) {
        if (!this._mousedown) return;
        const touch2 = e.touches;
        const x = touch2 ? touch2[0].clientX : e.clientX;
        const y = touch2 ? touch2[0].clientY : e.clientY;
        if (touch2) this._resetToolsToggler();
        if (!this._multitouch) {
            if (this._zoom !== 1) {
                this._positionX = x * (1 / this._zoom) - this._mousedownPositionX;
                this._positionY = y * (1 / this._zoom) - this._mousedownPositionY;
                $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg, {
                    left: `${this._positionX}px`,
                    top: `${this._positionY}px`
                });
            } else {
                if (this._images.length <= 1) return;
                this._positionX = x * (1 / this._zoom) - this._mousedownPositionX;
                $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg, {
                    left: `${this._positionX}px`
                });
            }
        }
    }
    _onMouseup(e) {
        this._mousedown = false;
        this._moveImg(e.target);
    }
    _onTouchend(e) {
        this._mousedown = false;
        if (this._multitouch) {
            if (e.targetTouches.length === 0) {
                this._multitouch = false;
                this._touchZoomPosition = [];
            }
        } else if (!this._multitouch) {
            this._checkDoubleTap(e);
            this._moveImg(e.target);
        }
    }
    _calculateTouchZoom(e) {
        const initialDistance = Math.hypot(this._touchZoomPosition[1].pageX - this._touchZoomPosition[0].pageX, this._touchZoomPosition[1].pageY - this._touchZoomPosition[0].pageY);
        const finalDistance = Math.hypot(e.touches[1].pageX - e.touches[0].pageX, e.touches[1].pageY - e.touches[0].pageY);
        const distanceChange = Math.abs(initialDistance - finalDistance);
        const screenWidth = e.view.screen.width;
        if (distanceChange > screenWidth * 0.03) {
            if (initialDistance <= finalDistance) this.zoomIn();
            else this.zoomOut();
            this._touchZoomPosition = e.touches;
        }
    }
    _onWindowTouchstart(e) {
        if (e.touches.length > 1) {
            this._multitouch = true;
            this._touchZoomPosition = e.touches;
        }
    }
    _onWindowTouchmove(e) {
        e.preventDefault();
        if (e.type === "touchmove" && e.targetTouches.length > 1) this._calculateTouchZoom(e);
    }
    _onRightArrowKeydown(e) {
        switch(e.keyCode){
            case 9:
                if (e.shiftKey) break;
                e.preventDefault();
                this._focusFullscreenBtn();
                break;
        }
    }
    _onFullscreenBtnKeydown(e) {
        switch(e.keyCode){
            case 9:
                if (!e.shiftKey) break;
                e.preventDefault();
                this._focusRightArrow();
                break;
        }
    }
    _onKeyup(e) {
        this._resetToolsToggler();
        switch(e.keyCode){
            case 39:
                if ($0abbbd36a260e067$var$isRTL$1) this.slide("left");
                else this.slide();
                break;
            case 37:
                if ($0abbbd36a260e067$var$isRTL$1) this.slide();
                else this.slide("left");
                break;
            case 27:
                this.close();
                break;
            case 36:
                this.slide("first");
                break;
            case 35:
                this.slide("last");
                break;
            case 38:
                this.zoomIn();
                break;
            case 40:
                this.zoomOut();
                break;
        }
    }
    _focusFullscreenBtn() {
        setTimeout(()=>{
            this._fullscreenBtn.focus();
        }, 100);
    }
    _focusRightArrow() {
        this._rightArrow.focus();
    }
    _moveImg(target) {
        if (this._multitouch) return;
        if (this._zoom !== 1 || target !== this.currentImg || this._images.length <= 1) return;
        const movement = this._positionX - this._originalPositionX;
        if (movement > 0) {
            if ($0abbbd36a260e067$var$isRTL$1) this.slide();
            else this.slide("left");
        } else if (movement < 0) {
            if ($0abbbd36a260e067$var$isRTL$1) this.slide("left");
            else this.slide();
        }
    }
    _checkDoubleTap(e) {
        clearTimeout(this._doubleTapTimer);
        const currentTime = /* @__PURE__ */ new Date().getTime();
        const tapLength = currentTime - this._tapTime;
        if (this._tapCounter > 0 && tapLength < 500) {
            this._onDoubleClick(e);
            this._doubleTapTimer = setTimeout(()=>{
                this._tapTime = /* @__PURE__ */ new Date().getTime();
                this._tapCounter = 0;
            }, 300);
        } else {
            this._tapCounter++;
            this._tapTime = /* @__PURE__ */ new Date().getTime();
        }
    }
    _resetDoubleTap() {
        this._tapTime = 0;
        this._tapCounter = 0;
        clearTimeout(this._doubleTapTimer);
    }
    _onDoubleClick(e) {
        if (this._multitouch) return;
        if (!e.touches) this._setNewPositionOnZoomIn(e);
        if (this._zoom !== 1) this._restoreDefaultZoom();
        else this.zoomIn();
    }
    _onWheel(e) {
        const delta = Math.max(-1, Math.min(1, e.deltaY));
        this._zoomOnWheel(e.x, e.y, delta);
    }
    _zoomOnWheel(x, y, delta) {
        if (-delta > 0) this._triggerEvents("zoomIn");
        else this._triggerEvents("zoomOut");
        if (this._zoom === 1) {
            this._positionX = 0;
            this._positionY = 0;
        }
        $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg, {
            transition: "none"
        });
        const activeImageClientRect = this.currentImg.getBoundingClientRect();
        const pointerX = (x - activeImageClientRect.left) / this._zoom;
        const pointerY = (y - activeImageClientRect.top) / this._zoom;
        const targetX = (pointerX - this._positionX) / this._zoom;
        const targetY = (pointerY - this._positionY) / this._zoom;
        this._zoom += -delta * this.options.zoomLevel;
        const maxZoom = 3;
        const minZoom = 1;
        this._zoom = Math.max(minZoom, Math.min(maxZoom, this._zoom));
        if (this._zoom === 1) {
            this._positionX = 0;
            this._positionY = 0;
        } else {
            this._positionX = -targetX * this._zoom + pointerX;
            this._positionY = -targetY * this._zoom + pointerY;
        }
        $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg, {
            transition: ""
        });
        $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg, {
            transform: `translate(${this._positionX}px,${this._positionY}px) scale(${this._zoom})`
        });
        this._updateZoomBtn();
        if (-delta > 0) this._triggerEvents("zoomedIn");
        else this._triggerEvents("zoomedOut");
    }
    _onBackdropClick(e) {
        this._resetToolsToggler();
        if (e.target.tagName !== "DIV") return;
        this.close();
    }
    _setNewPositionOnZoomIn(e) {
        clearTimeout(this._zoomTimer);
        this._positionX = window.innerWidth / 2 - e.offsetX - 50;
        this._positionY = window.innerHeight / 2 - e.offsetY - 50;
        this.currentImg.style.transition = "all 0.5s ease-out";
        this.currentImg.style.left = `${this._positionX}px`;
        this.currentImg.style.top = `${this._positionY}px`;
        this._zoomTimer = setTimeout(()=>{
            this.currentImg.style.transition = "none";
        }, 500);
    }
    _resetToolsToggler() {
        this._showTools();
        clearTimeout(this._toolsToggleTimer);
        this._setToolsToggleTimout();
    }
    _setToolsToggleTimout() {
        this._toolsToggleTimer = setTimeout(()=>{
            this._hideTools();
            clearTimeout(this._toolsToggleTimer);
        }, 4e3);
    }
    _hideTools() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._galleryToolbar, {
            opacity: 0
        });
        $0abbbd36a260e067$var$Manipulator$1.style(this._leftArrowWrapper, {
            opacity: 0
        });
        $0abbbd36a260e067$var$Manipulator$1.style(this._rightArrowWrapper, {
            opacity: 0
        });
    }
    _showTools() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._galleryToolbar, {
            opacity: 1
        });
        $0abbbd36a260e067$var$Manipulator$1.style(this._leftArrowWrapper, {
            opacity: 1
        });
        $0abbbd36a260e067$var$Manipulator$1.style(this._rightArrowWrapper, {
            opacity: 1
        });
    }
    _disableScroll() {
        $0abbbd36a260e067$var$Manipulator$1.addClass(document.body, "disabled-scroll");
        if (document.documentElement.scrollHeight > document.documentElement.clientHeight) $0abbbd36a260e067$var$Manipulator$1.addClass(document.body, "replace-scrollbar");
    }
    _enableScroll() {
        setTimeout(()=>{
            $0abbbd36a260e067$var$Manipulator$1.removeClass(document.body, "disabled-scroll");
            $0abbbd36a260e067$var$Manipulator$1.removeClass(document.body, "replace-scrollbar");
        }, 300);
    }
    _animationStart() {
        this._animating = true;
        setTimeout(()=>{
            this._animating = false;
        }, 400);
    }
    _restoreDefaultZoom() {
        if (this._zoom !== 1) {
            this._zoom = 1;
            $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg.parentNode, {
                transform: `scale(${this._zoom})`
            });
            $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg, {
                transform: `scale(${this._zoom})`
            });
            this._updateZoomBtn();
            this._updateImgPosition();
        }
    }
    _restoreDefaultFullscreen() {
        if (this._fullscreen) this.toggleFullscreen();
    }
    _restoreDefaultPosition() {
        clearTimeout(this._zoomTimer);
        const currentImg = this.currentImg;
        $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg.parentNode, {
            left: 0,
            top: 0
        });
        $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg, {
            transition: "all 0.5s ease-out",
            left: 0,
            top: 0
        });
        this._calculateImgSize(currentImg);
        setTimeout(()=>{
            $0abbbd36a260e067$var$Manipulator$1.style(this.currentImg, {
                transition: "none"
            });
        }, 500);
    }
    async _triggerEvents(startEvent, completeEvent) {
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, `${startEvent}.mdb.lightbox`);
        if (completeEvent) await setTimeout(()=>{
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, `${completeEvent}.mdb.lightbox`);
        }, 505);
    }
    static toggle(event) {
        const lightbox = $0abbbd36a260e067$var$SelectorEngine$1.closest(event.target, `.${$0abbbd36a260e067$var$CLASSNAME_LIGHTBOX}`);
        const instance = $0abbbd36a260e067$export$7d2670a66155874b.getInstance(lightbox) || new $0abbbd36a260e067$export$7d2670a66155874b(lightbox);
        instance.open(event);
    }
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$q);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$7d2670a66155874b(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$x = "rating";
const $0abbbd36a260e067$var$DATA_KEY$p = `mdb.${$0abbbd36a260e067$var$NAME$x}`;
const $0abbbd36a260e067$var$EVENT_KEY$j = `.${$0abbbd36a260e067$var$DATA_KEY$p}`;
const $0abbbd36a260e067$var$ARROW_LEFT_KEY = "ArrowLeft";
const $0abbbd36a260e067$var$ARROW_RIGHT_KEY = "ArrowRight";
const $0abbbd36a260e067$var$DefaultType$l = {
    tooltip: "string",
    value: "(string|number)",
    readonly: "boolean",
    after: "string",
    before: "string",
    dynamic: "boolean"
};
const $0abbbd36a260e067$var$Default$l = {
    tooltip: "top",
    value: "",
    readonly: false,
    after: "",
    before: "",
    dynamic: false
};
const $0abbbd36a260e067$var$EVENT_SELECT$3 = `scoreSelect${$0abbbd36a260e067$var$EVENT_KEY$j}`;
const $0abbbd36a260e067$var$EVENT_HOVER = `scoreHover${$0abbbd36a260e067$var$EVENT_KEY$j}`;
const $0abbbd36a260e067$var$EVENT_KEYUP$1 = `keyup${$0abbbd36a260e067$var$EVENT_KEY$j}`;
const $0abbbd36a260e067$var$EVENT_FOCUSOUT$1 = `focusout${$0abbbd36a260e067$var$EVENT_KEY$j}`;
const $0abbbd36a260e067$var$EVENT_KEYDOWN$1 = `keydown${$0abbbd36a260e067$var$EVENT_KEY$j}`;
const $0abbbd36a260e067$var$EVENT_MOUSEDOWN$1 = `mousedown${$0abbbd36a260e067$var$EVENT_KEY$j}`;
class $0abbbd36a260e067$export$8ba663d22f9191ae extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options){
        super(element2);
        this._icons = $0abbbd36a260e067$var$SelectorEngine$1.find("i", this._element);
        this._options = this._getConfig(options);
        this._index = -1;
        this._savedIndex = null;
        this._originalClassList = [];
        this._fn = {};
        this._tooltips = [];
        if (this._element) {
            this._init();
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$x;
    }
    dispose() {
        if (!this._options.readonly) {
            $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_KEYUP$1);
            $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_FOCUSOUT$1);
            $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_KEYDOWN$1);
            this._element.removeEventListener("mouseleave", this._fn.mouseleave);
            this._icons.forEach((el, i)=>{
                $0abbbd36a260e067$var$EventHandler$1.off(el, $0abbbd36a260e067$var$EVENT_MOUSEDOWN$1);
                el.removeEventListener("mouseenter", this._fn.mouseenter[i]);
            });
            this._tooltips.forEach((el)=>{
                el._element.removeAttribute("data-mdb-toggle");
                el.dispose();
            });
            this._element.removeAttribute("tabIndex");
        }
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _init() {
        if (!this._options.readonly) {
            this._bindMouseEnter();
            this._bindMouseLeave();
            this._bindMouseDown();
            this._bindKeyDown();
            this._bindKeyUp();
            this._bindFocusLost();
        }
        if (this._options.dynamic) this._saveOriginalClassList();
        this._setCustomText();
        this._setCustomColor();
        this._setToolTips();
        if (this._options.value) {
            this._index = this._options.value - 1;
            this._updateRating(this._index);
        }
    }
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        config = {
            ...$0abbbd36a260e067$var$Default$l,
            ...dataAttributes,
            ...config
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$x, config, $0abbbd36a260e067$var$DefaultType$l);
        return config;
    }
    _bindMouseEnter() {
        this._fn.mouseenter = [];
        this._icons.forEach((el, i)=>{
            el.addEventListener("mouseenter", // this._fn.mouseenter[i] is needed to create reference and unpin events after call dispose
            // prettier-ignore
            this._fn.mouseenter[i] = (e)=>{
                this._index = this._icons.indexOf(e.target);
                this._updateRating(this._index);
                this._triggerEvents(el, $0abbbd36a260e067$var$EVENT_HOVER);
            });
        });
    }
    _bindMouseLeave() {
        this._element.addEventListener("mouseleave", // this._fn.mouseleave is needed to create reference and unpin events after call dispose
        // prettier-ignore
        this._fn.mouseleave = ()=>{
            if (this._savedIndex !== null) {
                this._updateRating(this._savedIndex);
                this._index = this._savedIndex;
            } else if (this._options.value) {
                this._updateRating(this._options.value - 1);
                this._index = this._options.value - 1;
            } else {
                this._index = -1;
                this._clearRating();
            }
        });
    }
    _bindMouseDown() {
        this._icons.forEach((el)=>{
            $0abbbd36a260e067$var$EventHandler$1.on(el, $0abbbd36a260e067$var$EVENT_MOUSEDOWN$1, ()=>{
                this._setElementOutline("none");
                this._savedIndex = this._index;
                this._triggerEvents(el, $0abbbd36a260e067$var$EVENT_SELECT$3);
            });
        });
    }
    _bindKeyDown() {
        this._element.tabIndex = 0;
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_KEYDOWN$1, (e)=>this._updateAfterKeyDown(e));
    }
    _bindKeyUp() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_KEYUP$1, ()=>this._setElementOutline("auto"));
    }
    _bindFocusLost() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_FOCUSOUT$1, ()=>this._setElementOutline("none"));
    }
    _setElementOutline(value) {
        this._element.style.outline = value;
    }
    _triggerEvents(el, event) {
        $0abbbd36a260e067$var$EventHandler$1.trigger(el, event, {
            value: this._index + 1
        });
    }
    _updateAfterKeyDown(e) {
        const maxIndex = this._icons.length - 1;
        const indexBeforeChange = this._index;
        if (e.key === $0abbbd36a260e067$var$ARROW_RIGHT_KEY && this._index < maxIndex) this._index += 1;
        if (e.key === $0abbbd36a260e067$var$ARROW_LEFT_KEY && this._index > -1) this._index -= 1;
        if (indexBeforeChange !== this._index) {
            this._savedIndex = this._index;
            this._updateRating(this._savedIndex);
            this._triggerEvents(this._icons[this._savedIndex], $0abbbd36a260e067$var$EVENT_SELECT$3);
        }
    }
    _updateRating(index) {
        this._clearRating();
        if (this._options.dynamic) this._restoreOriginalIcon(index);
        this._icons.forEach((el, i)=>{
            if (i <= index) {
                el.classList.add("fas", "active");
                el.classList.remove("far");
            }
        });
    }
    _clearRating() {
        this._icons.forEach((el, i)=>{
            if (this._options.dynamic) el.classList = this._originalClassList[i];
            else {
                el.classList.remove("fas", "active");
                el.classList.add("far");
            }
        });
    }
    _setToolTips() {
        this._icons.forEach((el, i)=>{
            const hasOwnTooltips = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(el, "toggle");
            if (el.title && !hasOwnTooltips) {
                $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(el, "toggle", "tooltip");
                this._tooltips[i] = new $0abbbd36a260e067$export$28c660c63b792dea(el, {
                    placement: this._options.tooltip
                });
            }
        });
    }
    _setCustomText() {
        this._icons.forEach((el)=>{
            const after = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(el, "after");
            const before = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(el, "before");
            if (after) el.insertAdjacentHTML("afterEnd", after);
            if (before) el.insertAdjacentHTML("beforeBegin", before);
        });
    }
    _setCustomColor() {
        this._icons.forEach((el)=>{
            const color = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(el, "color");
            if (color) el.style.color = color;
        });
    }
    _saveOriginalClassList() {
        this._icons.forEach((el)=>{
            const classList = el.classList.value;
            this._originalClassList.push(classList);
        });
    }
    _restoreOriginalIcon(index) {
        const classList = this._originalClassList[index];
        const color = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(this._icons[index], "color");
        this._icons.forEach((el, i)=>{
            if (i <= index) {
                el.classList = classList;
                el.style.color = color;
            }
        });
    }
    // Static
    static autoInit(el) {
        return new $0abbbd36a260e067$export$8ba663d22f9191ae(el);
    }
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$p);
            const _config = typeof config === "object" && config;
            if (!data && /dispose|hide/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$8ba663d22f9191ae(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
function $0abbbd36a260e067$var$get(element2) {
    return getComputedStyle(element2);
}
function $0abbbd36a260e067$var$set(element2, obj) {
    for(const key in obj){
        let val = obj[key];
        if (typeof val === "number") val = `${val}px`;
        element2.style[key] = val;
    }
    return element2;
}
function $0abbbd36a260e067$var$div(className) {
    const div2 = document.createElement("div");
    div2.className = className;
    return div2;
}
const $0abbbd36a260e067$var$elMatches = typeof Element !== "undefined" && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function $0abbbd36a260e067$var$matches(element2, query) {
    if (!$0abbbd36a260e067$var$elMatches) throw new Error("No element matching method supported");
    return $0abbbd36a260e067$var$elMatches.call(element2, query);
}
function $0abbbd36a260e067$var$remove(element2) {
    if (element2.remove) element2.remove();
    else if (element2.parentNode) element2.parentNode.removeChild(element2);
}
function $0abbbd36a260e067$var$queryChildren(element2, selector) {
    return Array.prototype.filter.call(element2.children, (child)=>$0abbbd36a260e067$var$matches(child, selector));
}
const $0abbbd36a260e067$var$cls = {
    main: "ps",
    rtl: "ps__rtl",
    element: {
        thumb: (x)=>`ps__thumb-${x}`,
        rail: (x)=>`ps__rail-${x}`,
        consuming: "ps__child--consume"
    },
    state: {
        focus: "ps--focus",
        clicking: "ps--clicking",
        active: (x)=>`ps--active-${x}`,
        scrolling: (x)=>`ps--scrolling-${x}`
    }
};
const $0abbbd36a260e067$var$scrollingClassTimeout = {
    x: null,
    y: null
};
function $0abbbd36a260e067$var$addScrollingClass(i, x) {
    const classList = i.element.classList;
    const className = $0abbbd36a260e067$var$cls.state.scrolling(x);
    if (classList.contains(className)) clearTimeout($0abbbd36a260e067$var$scrollingClassTimeout[x]);
    else classList.add(className);
}
function $0abbbd36a260e067$var$removeScrollingClass(i, x) {
    $0abbbd36a260e067$var$scrollingClassTimeout[x] = setTimeout(()=>i.isAlive && i.element.classList.remove($0abbbd36a260e067$var$cls.state.scrolling(x)), i.settings.scrollingThreshold);
}
function $0abbbd36a260e067$var$setScrollingClassInstantly(i, x) {
    $0abbbd36a260e067$var$addScrollingClass(i, x);
    $0abbbd36a260e067$var$removeScrollingClass(i, x);
}
class $0abbbd36a260e067$var$EventElement {
    constructor(element2){
        this.element = element2;
        this.handlers = {};
    }
    bind(eventName, handler) {
        if (typeof this.handlers[eventName] === "undefined") this.handlers[eventName] = [];
        this.handlers[eventName].push(handler);
        this.element.addEventListener(eventName, handler, false);
    }
    unbind(eventName, target) {
        this.handlers[eventName] = this.handlers[eventName].filter((handler)=>{
            if (target && handler !== target) return true;
            this.element.removeEventListener(eventName, handler, false);
            return false;
        });
    }
    unbindAll() {
        for(const name in this.handlers)this.unbind(name);
    }
    get isEmpty() {
        return Object.keys(this.handlers).every((key)=>this.handlers[key].length === 0);
    }
}
class $0abbbd36a260e067$var$EventManager {
    constructor(){
        this.eventElements = [];
    }
    eventElement(element2) {
        let ee = this.eventElements.filter((ee2)=>ee2.element === element2)[0];
        if (!ee) {
            ee = new $0abbbd36a260e067$var$EventElement(element2);
            this.eventElements.push(ee);
        }
        return ee;
    }
    bind(element2, eventName, handler) {
        this.eventElement(element2).bind(eventName, handler);
    }
    unbind(element2, eventName, handler) {
        const ee = this.eventElement(element2);
        ee.unbind(eventName, handler);
        if (ee.isEmpty) this.eventElements.splice(this.eventElements.indexOf(ee), 1);
    }
    unbindAll() {
        this.eventElements.forEach((e)=>e.unbindAll());
        this.eventElements = [];
    }
    once(element2, eventName, handler) {
        const ee = this.eventElement(element2);
        const onceHandler = (evt)=>{
            ee.unbind(eventName, onceHandler);
            handler(evt);
        };
        ee.bind(eventName, onceHandler);
    }
}
function $0abbbd36a260e067$var$createEvent(name) {
    if (typeof window.CustomEvent === "function") return new CustomEvent(name);
    const evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(name, false, false, void 0);
    return evt;
}
function $0abbbd36a260e067$var$processScrollDiff(i, axis, diff, useScrollingClass = true, forceFireReachEvent = false) {
    let fields;
    if (axis === "top") fields = [
        "contentHeight",
        "containerHeight",
        "scrollTop",
        "y",
        "up",
        "down"
    ];
    else if (axis === "left") fields = [
        "contentWidth",
        "containerWidth",
        "scrollLeft",
        "x",
        "left",
        "right"
    ];
    else throw new Error("A proper axis should be provided");
    $0abbbd36a260e067$var$processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
}
function $0abbbd36a260e067$var$processScrollDiff$1(i, diff, [contentHeight, containerHeight, scrollTop, y, up, down], useScrollingClass = true, forceFireReachEvent = false) {
    const element2 = i.element;
    i.reach[y] = null;
    if (element2[scrollTop] < 1) i.reach[y] = "start";
    if (element2[scrollTop] > i[contentHeight] - i[containerHeight] - 1) i.reach[y] = "end";
    if (diff) {
        element2.dispatchEvent($0abbbd36a260e067$var$createEvent(`ps-scroll-${y}`));
        if (diff < 0) element2.dispatchEvent($0abbbd36a260e067$var$createEvent(`ps-scroll-${up}`));
        else if (diff > 0) element2.dispatchEvent($0abbbd36a260e067$var$createEvent(`ps-scroll-${down}`));
        if (useScrollingClass) $0abbbd36a260e067$var$setScrollingClassInstantly(i, y);
    }
    if (i.reach[y] && (diff || forceFireReachEvent)) element2.dispatchEvent($0abbbd36a260e067$var$createEvent(`ps-${y}-reach-${i.reach[y]}`));
}
function $0abbbd36a260e067$var$toInt(x) {
    return parseInt(x, 10) || 0;
}
function $0abbbd36a260e067$var$isEditable(el) {
    return $0abbbd36a260e067$var$matches(el, "input,[contenteditable]") || $0abbbd36a260e067$var$matches(el, "select,[contenteditable]") || $0abbbd36a260e067$var$matches(el, "textarea,[contenteditable]") || $0abbbd36a260e067$var$matches(el, "button,[contenteditable]");
}
function $0abbbd36a260e067$var$outerWidth(element2) {
    const styles = $0abbbd36a260e067$var$get(element2);
    return $0abbbd36a260e067$var$toInt(styles.width) + $0abbbd36a260e067$var$toInt(styles.paddingLeft) + $0abbbd36a260e067$var$toInt(styles.paddingRight) + $0abbbd36a260e067$var$toInt(styles.borderLeftWidth) + $0abbbd36a260e067$var$toInt(styles.borderRightWidth);
}
const $0abbbd36a260e067$var$env = {
    isWebKit: typeof document !== "undefined" && "WebkitAppearance" in document.documentElement.style,
    supportsTouch: typeof window !== "undefined" && ("ontouchstart" in window || "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
    supportsIePointer: typeof navigator !== "undefined" && navigator.msMaxTouchPoints,
    isChrome: typeof navigator !== "undefined" && /Chrome/i.test(navigator && navigator.userAgent)
};
function $0abbbd36a260e067$var$updateGeometry(i) {
    const element2 = i.element;
    const roundedScrollTop = Math.floor(element2.scrollTop);
    const rect = element2.getBoundingClientRect();
    i.containerWidth = Math.floor(rect.width);
    i.containerHeight = Math.floor(rect.height);
    i.contentWidth = element2.scrollWidth;
    i.contentHeight = element2.scrollHeight;
    if (!element2.contains(i.scrollbarXRail)) {
        $0abbbd36a260e067$var$queryChildren(element2, $0abbbd36a260e067$var$cls.element.rail("x")).forEach((el)=>$0abbbd36a260e067$var$remove(el));
        element2.appendChild(i.scrollbarXRail);
    }
    if (!element2.contains(i.scrollbarYRail)) {
        $0abbbd36a260e067$var$queryChildren(element2, $0abbbd36a260e067$var$cls.element.rail("y")).forEach((el)=>$0abbbd36a260e067$var$remove(el));
        element2.appendChild(i.scrollbarYRail);
    }
    if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
        i.scrollbarXActive = true;
        i.railXWidth = i.containerWidth - i.railXMarginWidth;
        i.railXRatio = i.containerWidth / i.railXWidth;
        i.scrollbarXWidth = $0abbbd36a260e067$var$getThumbSize(i, $0abbbd36a260e067$var$toInt(i.railXWidth * i.containerWidth / i.contentWidth));
        i.scrollbarXLeft = $0abbbd36a260e067$var$toInt((i.negativeScrollAdjustment + element2.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
    } else i.scrollbarXActive = false;
    if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
        i.scrollbarYActive = true;
        i.railYHeight = i.containerHeight - i.railYMarginHeight;
        i.railYRatio = i.containerHeight / i.railYHeight;
        i.scrollbarYHeight = $0abbbd36a260e067$var$getThumbSize(i, $0abbbd36a260e067$var$toInt(i.railYHeight * i.containerHeight / i.contentHeight));
        i.scrollbarYTop = $0abbbd36a260e067$var$toInt(roundedScrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
    } else i.scrollbarYActive = false;
    if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
    if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
    $0abbbd36a260e067$var$updateCss(element2, i);
    if (i.scrollbarXActive) element2.classList.add($0abbbd36a260e067$var$cls.state.active("x"));
    else {
        element2.classList.remove($0abbbd36a260e067$var$cls.state.active("x"));
        i.scrollbarXWidth = 0;
        i.scrollbarXLeft = 0;
        element2.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
    }
    if (i.scrollbarYActive) element2.classList.add($0abbbd36a260e067$var$cls.state.active("y"));
    else {
        element2.classList.remove($0abbbd36a260e067$var$cls.state.active("y"));
        i.scrollbarYHeight = 0;
        i.scrollbarYTop = 0;
        element2.scrollTop = 0;
    }
}
function $0abbbd36a260e067$var$getThumbSize(i, thumbSize) {
    if (i.settings.minScrollbarLength) thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
    if (i.settings.maxScrollbarLength) thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
    return thumbSize;
}
function $0abbbd36a260e067$var$updateCss(element2, i) {
    const xRailOffset = {
        width: i.railXWidth
    };
    const roundedScrollTop = Math.floor(element2.scrollTop);
    if (i.isRtl) xRailOffset.left = i.negativeScrollAdjustment + element2.scrollLeft + i.containerWidth - i.contentWidth;
    else xRailOffset.left = element2.scrollLeft;
    if (i.isScrollbarXUsingBottom) xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
    else xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
    $0abbbd36a260e067$var$set(i.scrollbarXRail, xRailOffset);
    const yRailOffset = {
        top: roundedScrollTop,
        height: i.railYHeight
    };
    if (i.isScrollbarYUsingRight) {
        if (i.isRtl) yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element2.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth - 9;
        else yRailOffset.right = i.scrollbarYRight - element2.scrollLeft;
    } else if (i.isRtl) yRailOffset.left = i.negativeScrollAdjustment + element2.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    else yRailOffset.left = i.scrollbarYLeft + element2.scrollLeft;
    $0abbbd36a260e067$var$set(i.scrollbarYRail, yRailOffset);
    $0abbbd36a260e067$var$set(i.scrollbarX, {
        left: i.scrollbarXLeft,
        width: i.scrollbarXWidth - i.railBorderXWidth
    });
    $0abbbd36a260e067$var$set(i.scrollbarY, {
        top: i.scrollbarYTop,
        height: i.scrollbarYHeight - i.railBorderYWidth
    });
}
function $0abbbd36a260e067$var$clickRail(i) {
    i.event.bind(i.scrollbarY, "mousedown", (e)=>e.stopPropagation());
    i.event.bind(i.scrollbarYRail, "mousedown", (e)=>{
        const positionTop = e.pageY - window.pageYOffset - i.scrollbarYRail.getBoundingClientRect().top;
        const direction = positionTop > i.scrollbarYTop ? 1 : -1;
        i.element.scrollTop += direction * i.containerHeight;
        $0abbbd36a260e067$var$updateGeometry(i);
        e.stopPropagation();
    });
    i.event.bind(i.scrollbarX, "mousedown", (e)=>e.stopPropagation());
    i.event.bind(i.scrollbarXRail, "mousedown", (e)=>{
        const positionLeft = e.pageX - window.pageXOffset - i.scrollbarXRail.getBoundingClientRect().left;
        const direction = positionLeft > i.scrollbarXLeft ? 1 : -1;
        i.element.scrollLeft += direction * i.containerWidth;
        $0abbbd36a260e067$var$updateGeometry(i);
        e.stopPropagation();
    });
}
let $0abbbd36a260e067$var$activeSlider = null;
function $0abbbd36a260e067$var$setupScrollHandlers(i) {
    $0abbbd36a260e067$var$bindMouseScrollHandler(i, [
        "containerHeight",
        "contentHeight",
        "pageY",
        "railYHeight",
        "scrollbarY",
        "scrollbarYHeight",
        "scrollTop",
        "y",
        "scrollbarYRail"
    ]);
    $0abbbd36a260e067$var$bindMouseScrollHandler(i, [
        "containerWidth",
        "contentWidth",
        "pageX",
        "railXWidth",
        "scrollbarX",
        "scrollbarXWidth",
        "scrollLeft",
        "x",
        "scrollbarXRail"
    ]);
}
function $0abbbd36a260e067$var$bindMouseScrollHandler(i, [containerDimension, contentDimension, pageAxis, railDimension, scrollbarAxis, scrollbarDimension, scrollAxis, axis, scrollbarRail]) {
    const element2 = i.element;
    let startingScrollPosition = null;
    let startingMousePagePosition = null;
    let scrollBy = null;
    function moveHandler(e) {
        if (e.touches && e.touches[0]) e[pageAxis] = e.touches[0][`page${axis.toUpperCase()}`];
        if ($0abbbd36a260e067$var$activeSlider === scrollbarAxis) {
            element2[scrollAxis] = startingScrollPosition + scrollBy * (e[pageAxis] - startingMousePagePosition);
            $0abbbd36a260e067$var$addScrollingClass(i, axis);
            $0abbbd36a260e067$var$updateGeometry(i);
            e.stopPropagation();
            e.preventDefault();
        }
    }
    function endHandler() {
        $0abbbd36a260e067$var$removeScrollingClass(i, axis);
        i[scrollbarRail].classList.remove($0abbbd36a260e067$var$cls.state.clicking);
        document.removeEventListener("mousemove", moveHandler);
        document.removeEventListener("mouseup", endHandler);
        document.removeEventListener("touchmove", moveHandler);
        document.removeEventListener("touchend", endHandler);
        $0abbbd36a260e067$var$activeSlider = null;
    }
    function bindMoves(e) {
        if ($0abbbd36a260e067$var$activeSlider === null) {
            $0abbbd36a260e067$var$activeSlider = scrollbarAxis;
            startingScrollPosition = element2[scrollAxis];
            if (e.touches) e[pageAxis] = e.touches[0][`page${axis.toUpperCase()}`];
            startingMousePagePosition = e[pageAxis];
            scrollBy = (i[contentDimension] - i[containerDimension]) / (i[railDimension] - i[scrollbarDimension]);
            if (!e.touches) {
                document.addEventListener("mousemove", moveHandler);
                document.addEventListener("mouseup", endHandler);
            } else {
                document.addEventListener("touchmove", moveHandler, {
                    passive: false
                });
                document.addEventListener("touchend", endHandler);
            }
            i[scrollbarRail].classList.add($0abbbd36a260e067$var$cls.state.clicking);
        }
        e.stopPropagation();
        if (e.cancelable) e.preventDefault();
    }
    i[scrollbarAxis].addEventListener("mousedown", bindMoves);
    i[scrollbarAxis].addEventListener("touchstart", bindMoves);
}
function $0abbbd36a260e067$var$keyboard(i) {
    const element2 = i.element;
    const elementHovered = ()=>$0abbbd36a260e067$var$matches(element2, ":hover");
    const scrollbarFocused = ()=>$0abbbd36a260e067$var$matches(i.scrollbarX, ":focus") || $0abbbd36a260e067$var$matches(i.scrollbarY, ":focus");
    function shouldPreventDefault(deltaX, deltaY) {
        const scrollTop = Math.floor(element2.scrollTop);
        if (deltaX === 0) {
            if (!i.scrollbarYActive) return false;
            if (scrollTop === 0 && deltaY > 0 || scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0) return !i.settings.wheelPropagation;
        }
        const scrollLeft = element2.scrollLeft;
        if (deltaY === 0) {
            if (!i.scrollbarXActive) return false;
            if (scrollLeft === 0 && deltaX < 0 || scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0) return !i.settings.wheelPropagation;
        }
        return true;
    }
    i.event.bind(i.ownerDocument, "keydown", (e)=>{
        if (e.isDefaultPrevented && e.isDefaultPrevented() || e.defaultPrevented) return;
        if (!elementHovered() && !scrollbarFocused()) return;
        let activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
        if (activeElement) {
            if (activeElement.tagName === "IFRAME") activeElement = activeElement.contentDocument.activeElement;
            else while(activeElement.shadowRoot)activeElement = activeElement.shadowRoot.activeElement;
            if ($0abbbd36a260e067$var$isEditable(activeElement)) return;
        }
        let deltaX = 0;
        let deltaY = 0;
        switch(e.which){
            case 37:
                if (e.metaKey) deltaX = -i.contentWidth;
                else if (e.altKey) deltaX = -i.containerWidth;
                else deltaX = -30;
                break;
            case 38:
                if (e.metaKey) deltaY = i.contentHeight;
                else if (e.altKey) deltaY = i.containerHeight;
                else deltaY = 30;
                break;
            case 39:
                if (e.metaKey) deltaX = i.contentWidth;
                else if (e.altKey) deltaX = i.containerWidth;
                else deltaX = 30;
                break;
            case 40:
                if (e.metaKey) deltaY = -i.contentHeight;
                else if (e.altKey) deltaY = -i.containerHeight;
                else deltaY = -30;
                break;
            case 32:
                if (e.shiftKey) deltaY = i.containerHeight;
                else deltaY = -i.containerHeight;
                break;
            case 33:
                deltaY = i.containerHeight;
                break;
            case 34:
                deltaY = -i.containerHeight;
                break;
            case 36:
                deltaY = i.contentHeight;
                break;
            case 35:
                deltaY = -i.contentHeight;
                break;
            default:
                return;
        }
        if (i.settings.suppressScrollX && deltaX !== 0) return;
        if (i.settings.suppressScrollY && deltaY !== 0) return;
        element2.scrollTop -= deltaY;
        element2.scrollLeft += deltaX;
        $0abbbd36a260e067$var$updateGeometry(i);
        if (shouldPreventDefault(deltaX, deltaY)) e.preventDefault();
    });
}
function $0abbbd36a260e067$var$wheel(i) {
    const element2 = i.element;
    function shouldPreventDefault(deltaX, deltaY) {
        const roundedScrollTop = Math.floor(element2.scrollTop);
        const isTop = element2.scrollTop === 0;
        const isBottom = roundedScrollTop + element2.offsetHeight === element2.scrollHeight;
        const isLeft = element2.scrollLeft === 0;
        const isRight = element2.scrollLeft + element2.offsetWidth === element2.scrollWidth;
        let hitsBound;
        if (Math.abs(deltaY) > Math.abs(deltaX)) hitsBound = isTop || isBottom;
        else hitsBound = isLeft || isRight;
        return hitsBound ? !i.settings.wheelPropagation : true;
    }
    function getDeltaFromEvent(e) {
        let deltaX = e.deltaX;
        let deltaY = -1 * e.deltaY;
        if (typeof deltaX === "undefined" || typeof deltaY === "undefined") {
            deltaX = -1 * e.wheelDeltaX / 6;
            deltaY = e.wheelDeltaY / 6;
        }
        if (e.deltaMode && e.deltaMode === 1) {
            deltaX *= 10;
            deltaY *= 10;
        }
        if (deltaX !== deltaX && deltaY !== deltaY) {
            deltaX = 0;
            deltaY = e.wheelDelta;
        }
        if (e.shiftKey) return [
            -deltaY,
            -deltaX
        ];
        return [
            deltaX,
            deltaY
        ];
    }
    function shouldBeConsumedByChild(target, deltaX, deltaY) {
        if (!$0abbbd36a260e067$var$env.isWebKit && element2.querySelector("select:focus")) return true;
        if (!element2.contains(target)) return false;
        let cursor = target;
        while(cursor && cursor !== element2){
            if (cursor.classList.contains($0abbbd36a260e067$var$cls.element.consuming)) return true;
            const style = $0abbbd36a260e067$var$get(cursor);
            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                const maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                if (maxScrollTop > 0) {
                    if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) return true;
                }
            }
            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                const maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                if (maxScrollLeft > 0) {
                    if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) return true;
                }
            }
            cursor = cursor.parentNode;
        }
        return false;
    }
    function mousewheelHandler(e) {
        const [deltaX, deltaY] = getDeltaFromEvent(e);
        if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) return;
        let shouldPrevent = false;
        if (!i.settings.useBothWheelAxes) {
            element2.scrollTop -= deltaY * i.settings.wheelSpeed;
            element2.scrollLeft += deltaX * i.settings.wheelSpeed;
        } else if (i.scrollbarYActive && !i.scrollbarXActive) {
            if (deltaY) element2.scrollTop -= deltaY * i.settings.wheelSpeed;
            else element2.scrollTop += deltaX * i.settings.wheelSpeed;
            shouldPrevent = true;
        } else if (i.scrollbarXActive && !i.scrollbarYActive) {
            if (deltaX) element2.scrollLeft += deltaX * i.settings.wheelSpeed;
            else element2.scrollLeft -= deltaY * i.settings.wheelSpeed;
            shouldPrevent = true;
        }
        $0abbbd36a260e067$var$updateGeometry(i);
        shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
        if (shouldPrevent && !e.ctrlKey) {
            e.stopPropagation();
            e.preventDefault();
        }
    }
    if (typeof window.onwheel !== "undefined") i.event.bind(element2, "wheel", mousewheelHandler);
    else if (typeof window.onmousewheel !== "undefined") i.event.bind(element2, "mousewheel", mousewheelHandler);
}
function $0abbbd36a260e067$var$touch(i) {
    if (!$0abbbd36a260e067$var$env.supportsTouch && !$0abbbd36a260e067$var$env.supportsIePointer) return;
    const element2 = i.element;
    const state = {
        startOffset: {},
        startTime: 0,
        speed: {},
        easingLoop: null
    };
    function shouldPrevent(deltaX, deltaY) {
        const scrollTop = Math.floor(element2.scrollTop);
        const scrollLeft = element2.scrollLeft;
        const magnitudeX = Math.abs(deltaX);
        const magnitudeY = Math.abs(deltaY);
        if (magnitudeY > magnitudeX) {
            if (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight || deltaY > 0 && scrollTop === 0) return window.scrollY === 0 && deltaY > 0 && $0abbbd36a260e067$var$env.isChrome;
        } else if (magnitudeX > magnitudeY) {
            if (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth || deltaX > 0 && scrollLeft === 0) return true;
        }
        return true;
    }
    function applyTouchMove(differenceX, differenceY) {
        element2.scrollTop -= differenceY;
        element2.scrollLeft -= differenceX;
        $0abbbd36a260e067$var$updateGeometry(i);
    }
    function getTouch(e) {
        if (e.targetTouches) return e.targetTouches[0];
        return e;
    }
    function shouldHandle(e) {
        if (e.target === i.scrollbarX || e.target === i.scrollbarY) return false;
        if (e.pointerType && e.pointerType === "pen" && e.buttons === 0) return false;
        if (e.targetTouches && e.targetTouches.length === 1) return true;
        if (e.pointerType && e.pointerType !== "mouse" && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) return true;
        return false;
    }
    function touchStart(e) {
        if (!shouldHandle(e)) return;
        const touch2 = getTouch(e);
        state.startOffset.pageX = touch2.pageX;
        state.startOffset.pageY = touch2.pageY;
        state.startTime = /* @__PURE__ */ new Date().getTime();
        if (state.easingLoop !== null) clearInterval(state.easingLoop);
    }
    function shouldBeConsumedByChild(target, deltaX, deltaY) {
        if (!element2.contains(target)) return false;
        let cursor = target;
        while(cursor && cursor !== element2){
            if (cursor.classList.contains($0abbbd36a260e067$var$cls.element.consuming)) return true;
            const style = $0abbbd36a260e067$var$get(cursor);
            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                const maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                if (maxScrollTop > 0) {
                    if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) return true;
                }
            }
            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                const maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                if (maxScrollLeft > 0) {
                    if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) return true;
                }
            }
            cursor = cursor.parentNode;
        }
        return false;
    }
    function touchMove(e) {
        if (shouldHandle(e)) {
            const touch2 = getTouch(e);
            const currentOffset = {
                pageX: touch2.pageX,
                pageY: touch2.pageY
            };
            const differenceX = currentOffset.pageX - state.startOffset.pageX;
            const differenceY = currentOffset.pageY - state.startOffset.pageY;
            if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) return;
            applyTouchMove(differenceX, differenceY);
            state.startOffset = currentOffset;
            const currentTime = /* @__PURE__ */ new Date().getTime();
            const timeGap = currentTime - state.startTime;
            if (timeGap > 0) {
                state.speed.x = differenceX / timeGap;
                state.speed.y = differenceY / timeGap;
                state.startTime = currentTime;
            }
            if (shouldPrevent(differenceX, differenceY)) {
                if (e.cancelable) e.preventDefault();
            }
        }
    }
    function touchEnd() {
        if (i.settings.swipeEasing) {
            clearInterval(state.easingLoop);
            state.easingLoop = setInterval(()=>{
                if (i.isInitialized) {
                    clearInterval(state.easingLoop);
                    return;
                }
                if (!state.speed.x && !state.speed.y) {
                    clearInterval(state.easingLoop);
                    return;
                }
                if (Math.abs(state.speed.x) < 0.01 && Math.abs(state.speed.y) < 0.01) {
                    clearInterval(state.easingLoop);
                    return;
                }
                applyTouchMove(state.speed.x * 30, state.speed.y * 30);
                state.speed.x *= 0.8;
                state.speed.y *= 0.8;
            }, 10);
        }
    }
    if ($0abbbd36a260e067$var$env.supportsTouch) {
        i.event.bind(element2, "touchstart", touchStart);
        i.event.bind(element2, "touchmove", touchMove);
        i.event.bind(element2, "touchend", touchEnd);
    } else if ($0abbbd36a260e067$var$env.supportsIePointer) {
        if (window.PointerEvent) {
            i.event.bind(element2, "pointerdown", touchStart);
            i.event.bind(element2, "pointermove", touchMove);
            i.event.bind(element2, "pointerup", touchEnd);
        } else if (window.MSPointerEvent) {
            i.event.bind(element2, "MSPointerDown", touchStart);
            i.event.bind(element2, "MSPointerMove", touchMove);
            i.event.bind(element2, "MSPointerUp", touchEnd);
        }
    }
}
const $0abbbd36a260e067$var$defaultSettings = ()=>({
        handlers: [
            "click-rail",
            "drag-thumb",
            "keyboard",
            "wheel",
            "touch"
        ],
        maxScrollbarLength: null,
        minScrollbarLength: null,
        scrollingThreshold: 1e3,
        scrollXMarginOffset: 0,
        scrollYMarginOffset: 0,
        suppressScrollX: false,
        suppressScrollY: false,
        swipeEasing: true,
        useBothWheelAxes: false,
        wheelPropagation: true,
        wheelSpeed: 1
    });
const $0abbbd36a260e067$var$handlers = {
    "click-rail": $0abbbd36a260e067$var$clickRail,
    "drag-thumb": $0abbbd36a260e067$var$setupScrollHandlers,
    keyboard: $0abbbd36a260e067$var$keyboard,
    wheel: $0abbbd36a260e067$var$wheel,
    touch: $0abbbd36a260e067$var$touch
};
class $0abbbd36a260e067$var$PerfectScrollbar {
    constructor(element2, userSettings = {}){
        if (typeof element2 === "string") element2 = document.querySelector(element2);
        if (!element2 || !element2.nodeName) throw new Error("no element is specified to initialize PerfectScrollbar");
        this.element = element2;
        element2.classList.add($0abbbd36a260e067$var$cls.main);
        this.settings = $0abbbd36a260e067$var$defaultSettings();
        for(const key in userSettings)this.settings[key] = userSettings[key];
        this.containerWidth = null;
        this.containerHeight = null;
        this.contentWidth = null;
        this.contentHeight = null;
        const focus = ()=>element2.classList.add($0abbbd36a260e067$var$cls.state.focus);
        const blur = ()=>element2.classList.remove($0abbbd36a260e067$var$cls.state.focus);
        this.isRtl = $0abbbd36a260e067$var$get(element2).direction === "rtl";
        if (this.isRtl === true) element2.classList.add($0abbbd36a260e067$var$cls.rtl);
        this.isNegativeScroll = (()=>{
            const originalScrollLeft = element2.scrollLeft;
            let result = null;
            element2.scrollLeft = -1;
            result = element2.scrollLeft < 0;
            element2.scrollLeft = originalScrollLeft;
            return result;
        })();
        this.negativeScrollAdjustment = this.isNegativeScroll ? element2.scrollWidth - element2.clientWidth : 0;
        this.event = new $0abbbd36a260e067$var$EventManager();
        this.ownerDocument = element2.ownerDocument || document;
        this.scrollbarXRail = $0abbbd36a260e067$var$div($0abbbd36a260e067$var$cls.element.rail("x"));
        element2.appendChild(this.scrollbarXRail);
        this.scrollbarX = $0abbbd36a260e067$var$div($0abbbd36a260e067$var$cls.element.thumb("x"));
        this.scrollbarXRail.appendChild(this.scrollbarX);
        this.scrollbarX.setAttribute("tabindex", 0);
        this.event.bind(this.scrollbarX, "focus", focus);
        this.event.bind(this.scrollbarX, "blur", blur);
        this.scrollbarXActive = null;
        this.scrollbarXWidth = null;
        this.scrollbarXLeft = null;
        const railXStyle = $0abbbd36a260e067$var$get(this.scrollbarXRail);
        this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
        if (isNaN(this.scrollbarXBottom)) {
            this.isScrollbarXUsingBottom = false;
            this.scrollbarXTop = $0abbbd36a260e067$var$toInt(railXStyle.top);
        } else this.isScrollbarXUsingBottom = true;
        this.railBorderXWidth = $0abbbd36a260e067$var$toInt(railXStyle.borderLeftWidth) + $0abbbd36a260e067$var$toInt(railXStyle.borderRightWidth);
        $0abbbd36a260e067$var$set(this.scrollbarXRail, {
            display: "block"
        });
        this.railXMarginWidth = $0abbbd36a260e067$var$toInt(railXStyle.marginLeft) + $0abbbd36a260e067$var$toInt(railXStyle.marginRight);
        $0abbbd36a260e067$var$set(this.scrollbarXRail, {
            display: ""
        });
        this.railXWidth = null;
        this.railXRatio = null;
        this.scrollbarYRail = $0abbbd36a260e067$var$div($0abbbd36a260e067$var$cls.element.rail("y"));
        element2.appendChild(this.scrollbarYRail);
        this.scrollbarY = $0abbbd36a260e067$var$div($0abbbd36a260e067$var$cls.element.thumb("y"));
        this.scrollbarYRail.appendChild(this.scrollbarY);
        this.scrollbarY.setAttribute("tabindex", 0);
        this.event.bind(this.scrollbarY, "focus", focus);
        this.event.bind(this.scrollbarY, "blur", blur);
        this.scrollbarYActive = null;
        this.scrollbarYHeight = null;
        this.scrollbarYTop = null;
        const railYStyle = $0abbbd36a260e067$var$get(this.scrollbarYRail);
        this.scrollbarYRight = parseInt(railYStyle.right, 10);
        if (isNaN(this.scrollbarYRight)) {
            this.isScrollbarYUsingRight = false;
            this.scrollbarYLeft = $0abbbd36a260e067$var$toInt(railYStyle.left);
        } else this.isScrollbarYUsingRight = true;
        this.scrollbarYOuterWidth = this.isRtl ? $0abbbd36a260e067$var$outerWidth(this.scrollbarY) : null;
        this.railBorderYWidth = $0abbbd36a260e067$var$toInt(railYStyle.borderTopWidth) + $0abbbd36a260e067$var$toInt(railYStyle.borderBottomWidth);
        $0abbbd36a260e067$var$set(this.scrollbarYRail, {
            display: "block"
        });
        this.railYMarginHeight = $0abbbd36a260e067$var$toInt(railYStyle.marginTop) + $0abbbd36a260e067$var$toInt(railYStyle.marginBottom);
        $0abbbd36a260e067$var$set(this.scrollbarYRail, {
            display: ""
        });
        this.railYHeight = null;
        this.railYRatio = null;
        this.reach = {
            x: element2.scrollLeft <= 0 ? "start" : element2.scrollLeft >= this.contentWidth - this.containerWidth ? "end" : null,
            y: element2.scrollTop <= 0 ? "start" : element2.scrollTop >= this.contentHeight - this.containerHeight ? "end" : null
        };
        this.isAlive = true;
        this.settings.handlers.forEach((handlerName)=>$0abbbd36a260e067$var$handlers[handlerName](this));
        this.lastScrollTop = Math.floor(element2.scrollTop);
        this.lastScrollLeft = element2.scrollLeft;
        this.event.bind(this.element, "scroll", (e)=>this.onScroll(e));
        $0abbbd36a260e067$var$updateGeometry(this);
    }
    update() {
        if (!this.isAlive) return;
        this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0;
        $0abbbd36a260e067$var$set(this.scrollbarXRail, {
            display: "block"
        });
        $0abbbd36a260e067$var$set(this.scrollbarYRail, {
            display: "block"
        });
        this.railXMarginWidth = $0abbbd36a260e067$var$toInt($0abbbd36a260e067$var$get(this.scrollbarXRail).marginLeft) + $0abbbd36a260e067$var$toInt($0abbbd36a260e067$var$get(this.scrollbarXRail).marginRight);
        this.railYMarginHeight = $0abbbd36a260e067$var$toInt($0abbbd36a260e067$var$get(this.scrollbarYRail).marginTop) + $0abbbd36a260e067$var$toInt($0abbbd36a260e067$var$get(this.scrollbarYRail).marginBottom);
        $0abbbd36a260e067$var$set(this.scrollbarXRail, {
            display: "none"
        });
        $0abbbd36a260e067$var$set(this.scrollbarYRail, {
            display: "none"
        });
        $0abbbd36a260e067$var$updateGeometry(this);
        $0abbbd36a260e067$var$processScrollDiff(this, "top", 0, false, true);
        $0abbbd36a260e067$var$processScrollDiff(this, "left", 0, false, true);
        $0abbbd36a260e067$var$set(this.scrollbarXRail, {
            display: ""
        });
        $0abbbd36a260e067$var$set(this.scrollbarYRail, {
            display: ""
        });
    }
    onScroll(e) {
        if (!this.isAlive) return;
        $0abbbd36a260e067$var$updateGeometry(this);
        $0abbbd36a260e067$var$processScrollDiff(this, "top", this.element.scrollTop - this.lastScrollTop);
        $0abbbd36a260e067$var$processScrollDiff(this, "left", this.element.scrollLeft - this.lastScrollLeft);
        this.lastScrollTop = Math.floor(this.element.scrollTop);
        this.lastScrollLeft = this.element.scrollLeft;
    }
    destroy() {
        if (!this.isAlive) return;
        this.event.unbindAll();
        $0abbbd36a260e067$var$remove(this.scrollbarX);
        $0abbbd36a260e067$var$remove(this.scrollbarY);
        $0abbbd36a260e067$var$remove(this.scrollbarXRail);
        $0abbbd36a260e067$var$remove(this.scrollbarYRail);
        this.removePsClasses();
        this.element = null;
        this.scrollbarX = null;
        this.scrollbarY = null;
        this.scrollbarXRail = null;
        this.scrollbarYRail = null;
        this.isAlive = false;
    }
    removePsClasses() {
        this.element.className = this.element.className.split(" ").filter((name)=>!name.match(/^ps([-_].+|)$/)).join(" ");
    }
}
class $0abbbd36a260e067$var$FocusTrap2 {
    constructor(element2, options = {}, toggler){
        this._element = element2;
        this._toggler = toggler;
        this._event = options.event || "blur";
        this._condition = options.condition || (()=>true);
        this._selector = options.selector || 'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])';
        this._onlyVisible = options.onlyVisible || false;
        this._focusableElements = [];
        this._firstElement = null;
        this._lastElement = null;
        this.handler = (e)=>{
            if (this._condition(e) && e.target === this._lastElement) {
                e.preventDefault();
                this._firstElement.focus();
            }
        };
    }
    trap() {
        this._setElements();
        this._init();
        this._setFocusTrap();
    }
    disable() {
        this._focusableElements.forEach((element2)=>{
            element2.removeEventListener(this._event, this.handler);
        });
        if (this._toggler) this._toggler.focus();
    }
    update() {
        this._setElements();
        this._setFocusTrap();
    }
    _init() {
        const handler = (e)=>{
            if (!this._firstElement || e.key !== "Tab" || this._focusableElements.includes(e.target)) return;
            e.preventDefault();
            this._firstElement.focus();
            window.removeEventListener("keydown", handler);
        };
        window.addEventListener("keydown", handler);
    }
    _filterVisible(elements) {
        return elements.filter((el)=>{
            if (!$0abbbd36a260e067$var$isVisible$1(el)) return false;
            const ancestors = $0abbbd36a260e067$var$SelectorEngine$1.parents(el, "*");
            for(let i = 0; i < ancestors.length; i++){
                const style = window.getComputedStyle(ancestors[i]);
                if (style && (style.display === "none" || style.visibility === "hidden")) return false;
            }
            return true;
        });
    }
    _setElements() {
        const allElements = $0abbbd36a260e067$var$SelectorEngine$1.find(this._selector, this._element);
        this._focusableElements = allElements.filter((el)=>{
            const hasDisabledAttribute = el.getAttribute("data-mdb-disabled") === "true" || el.hasAttribute("disabled");
            const isDisabled2 = el.disabled || hasDisabledAttribute;
            if (!isDisabled2) return el;
            return null;
        });
        if (this._onlyVisible) this._focusableElements = this._filterVisible(this._focusableElements);
        this._firstElement = this._focusableElements[0];
        this._lastElement = this._focusableElements[this._focusableElements.length - 1];
    }
    _setFocusTrap() {
        this._focusableElements.forEach((element2, i)=>{
            if (i === this._focusableElements.length - 1) element2.addEventListener(this._event, this.handler);
            else element2.removeEventListener(this._event, this.handler);
        });
    }
}
const $0abbbd36a260e067$var$LEFT_ARROW = 37;
const $0abbbd36a260e067$var$UP_ARROW = 38;
const $0abbbd36a260e067$var$RIGHT_ARROW = 39;
const $0abbbd36a260e067$var$DOWN_ARROW = 40;
const $0abbbd36a260e067$var$HOME = 36;
const $0abbbd36a260e067$var$END = 35;
const $0abbbd36a260e067$var$PAGE_UP = 33;
const $0abbbd36a260e067$var$PAGE_DOWN = 34;
const $0abbbd36a260e067$var$ENTER = 13;
const $0abbbd36a260e067$var$SPACE = 32;
const $0abbbd36a260e067$var$ESCAPE = 27;
const $0abbbd36a260e067$var$TAB = 9;
const $0abbbd36a260e067$var$BACKSPACE = 8;
const $0abbbd36a260e067$var$DELETE = 46;
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$b = {
    threshold: 10,
    direction: "all"
};
let $0abbbd36a260e067$var$Swipe$1 = class Swipe2 {
    constructor(element2, options){
        this._element = element2;
        this._startPosition = null;
        this._options = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$b,
            ...options
        };
    }
    handleTouchStart(e) {
        this._startPosition = this._getCoordinates(e);
    }
    handleTouchMove(e) {
        if (!this._startPosition) return;
        const position = this._getCoordinates(e);
        const displacement = {
            x: position.x - this._startPosition.x,
            y: position.y - this._startPosition.y
        };
        const swipe = this._getDirection(displacement);
        if (this._options.direction === "all") {
            if (swipe.y.value < this._options.threshold && swipe.x.value < this._options.threshold) return;
            const direction = swipe.y.value > swipe.x.value ? swipe.y.direction : swipe.x.direction;
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, `swipe${direction}`);
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, "swipe", {
                direction: direction
            });
            this._startPosition = null;
            return;
        }
        const axis = this._options.direction === "left" || this._options === "right" ? "x" : "y";
        if (swipe[axis].direction === this._options.direction && swipe[axis].value > this._options.threshold) {
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, `swipe${swipe[axis].direction}`);
            this._startPosition = null;
        }
    }
    handleTouchEnd() {
        this._startPosition = null;
    }
    _getCoordinates(e) {
        const [touch2] = e.touches;
        return {
            x: touch2.clientX,
            y: touch2.clientY
        };
    }
    _getDirection(displacement) {
        return {
            x: {
                direction: displacement.x < 0 ? "left" : "right",
                value: Math.abs(displacement.x)
            },
            y: {
                direction: displacement.y < 0 ? "up" : "down",
                value: Math.abs(displacement.y)
            }
        };
    }
};
let $0abbbd36a260e067$var$Touch$1 = class Touch {
    constructor(element2, event = "swipe", options = {}){
        this._element = element2;
        this._event = event;
        this.swipe = new $0abbbd36a260e067$var$Swipe$1(element2, options);
        this._touchStartHandler = this._handleTouchStart.bind(this);
        this._touchMoveHandler = this._handleTouchMove.bind(this);
        this._touchEndHandler = this._handleTouchEnd.bind(this);
    }
    dispose() {
        this._element.removeEventListener("touchstart", this._touchStartHandler);
        this._element.removeEventListener("touchmove", this._touchMoveHandler);
        window.removeEventListener("touchend", this._touchEndHandler);
    }
    init() {
        this._element.addEventListener("touchstart", (e)=>this._handleTouchStart(e));
        this._element.addEventListener("touchmove", (e)=>this._handleTouchMove(e));
        window.addEventListener("touchend", (e)=>this._handleTouchEnd(e));
    }
    _handleTouchStart(e) {
        this[this._event].handleTouchStart(e);
    }
    _handleTouchMove(e) {
        this[this._event].handleTouchMove(e);
    }
    _handleTouchEnd(e) {
        this[this._event].handleTouchEnd(e);
    }
};
const $0abbbd36a260e067$var$NAME$w = "sidenav";
const $0abbbd36a260e067$var$DATA_KEY$o = "mdb.sidenav";
const $0abbbd36a260e067$var$ARROW_CLASS = "rotate-icon";
const $0abbbd36a260e067$var$BACKDROP_CLASS = "sidenav-backdrop";
const $0abbbd36a260e067$var$SELECTOR_TOGGLE$1 = '[data-mdb-toggle="sidenav"]';
const $0abbbd36a260e067$var$SELECTOR_TOGGLE_COLLAPSE = "[data-mdb-collapse-init]";
const $0abbbd36a260e067$var$SELECTOR_SHOW_SLIM = '[data-mdb-slim="true"]';
const $0abbbd36a260e067$var$SELECTOR_HIDE_SLIM = '[data-mdb-slim="false"]';
const $0abbbd36a260e067$var$SELECTOR_NAVIGATION = ".sidenav-menu";
const $0abbbd36a260e067$var$SELECTOR_COLLAPSE = ".sidenav-collapse";
const $0abbbd36a260e067$var$SELECTOR_LINK = ".sidenav-link";
const $0abbbd36a260e067$var$TRANSLATION_LEFT = $0abbbd36a260e067$var$isRTL$1 ? 100 : -100;
const $0abbbd36a260e067$var$TRANSLATION_RIGHT = $0abbbd36a260e067$var$isRTL$1 ? -100 : 100;
let $0abbbd36a260e067$var$instanceCount = 0;
const $0abbbd36a260e067$var$OPTIONS_TYPE$1 = {
    accordion: "(boolean)",
    backdrop: "(boolean)",
    backdropClass: "(null|string)",
    closeOnEsc: "(boolean)",
    color: "(string)",
    content: "(null|string)",
    expandable: "(boolean)",
    expandOnHover: "(boolean)",
    focusTrap: "(boolean)",
    hidden: "(boolean)",
    mode: "(string)",
    scrollContainer: "(null|string)",
    slim: "(boolean)",
    slimCollapsed: "(boolean)",
    slimWidth: "(number)",
    position: "(string)",
    right: "(boolean)",
    transitionDuration: "(number)",
    width: "(number)"
};
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$a = {
    accordion: false,
    backdrop: true,
    backdropClass: null,
    closeOnEsc: true,
    color: "primary",
    content: null,
    expandable: true,
    expandOnHover: false,
    focusTrap: true,
    hidden: true,
    mode: "over",
    scrollContainer: null,
    slim: false,
    slimCollapsed: false,
    slimWidth: 77,
    position: "fixed",
    right: false,
    transitionDuration: 300,
    width: 240
};
class $0abbbd36a260e067$export$40a91cd7866fd4b5 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(node, options = {}){
        super(node);
        this._options = options;
        $0abbbd36a260e067$var$instanceCount++;
        this._ID = $0abbbd36a260e067$var$instanceCount;
        this._backdrop = null;
        this._content = null;
        this._initialContentStyle = null;
        this._slimCollapsed = false;
        this._activeNode = null;
        this._tempSlim = false;
        this._focusTrap = null;
        this._perfectScrollbar = null;
        this._touch = null;
        this.escHandler = (e)=>{
            if (e.keyCode === $0abbbd36a260e067$var$ESCAPE && this.toggler && $0abbbd36a260e067$var$isVisible$1(this.toggler)) {
                this._update(false);
                $0abbbd36a260e067$var$EventHandler$1.off(window, "keydown", this.escHandler);
            }
        };
        this.hashHandler = ()=>{
            this._setActiveElements();
        };
        if (node) this._setup();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$w;
    }
    get container() {
        if (this.options.position === "fixed") return $0abbbd36a260e067$var$SelectorEngine$1.findOne("body");
        const findContainer = (el)=>{
            if (!el.parentNode || el.parentNode === document) return el;
            const isRelative = el.parentNode.style.position === "relative" || el.parentNode.classList.contains("position-relative");
            if (isRelative) return el.parentNode;
            return findContainer(el.parentNode);
        };
        return findContainer(this._element);
    }
    get isVisible() {
        let containerStart = 0;
        let containerEnd = window.innerWidth;
        if (this.options.position !== "fixed") {
            const boundry = this.container.getBoundingClientRect();
            containerStart = boundry.x;
            containerEnd = boundry.x + boundry.width;
        }
        const { x: x } = this._element.getBoundingClientRect();
        if (this.options.right && !$0abbbd36a260e067$var$isRTL$1 || !this.options.right && $0abbbd36a260e067$var$isRTL$1) {
            let scrollBarWidth = 0;
            if (this.container.scrollHeight > this.container.clientHeight) scrollBarWidth = this.container.offsetWidth - this.container.clientWidth;
            if (this.container.tagName === "BODY") {
                const documentWidth = document.documentElement.clientWidth;
                scrollBarWidth = Math.abs(window.innerWidth - documentWidth);
            }
            return Math.abs(x + scrollBarWidth - containerEnd) > 10;
        }
        return Math.abs(x - containerStart) < 10;
    }
    get links() {
        return $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_LINK, this._element);
    }
    get navigation() {
        return $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_NAVIGATION, this._element);
    }
    get options() {
        const config = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$a,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...this._options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$w, config, $0abbbd36a260e067$var$OPTIONS_TYPE$1);
        return config;
    }
    get sidenavStyle() {
        return {
            width: `${this.width}px`,
            height: this.options.position === "fixed" ? "100vh" : "100%",
            position: this.options.position,
            transitionDuration: this.transitionDuration,
            transitionProperty: "transform, width, padding, margin",
            transitionTimingFunction: "linear"
        };
    }
    get toggler() {
        const toggleElement = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_TOGGLE$1).find((toggler)=>{
            const target = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(toggler, "target");
            return $0abbbd36a260e067$var$SelectorEngine$1.findOne(target) === this._element;
        });
        return toggleElement;
    }
    get transitionDuration() {
        return `${this.options.transitionDuration / 1e3}s`;
    }
    get translation() {
        return this.options.right ? $0abbbd36a260e067$var$TRANSLATION_RIGHT : $0abbbd36a260e067$var$TRANSLATION_LEFT;
    }
    get width() {
        return this._slimCollapsed ? this.options.slimWidth : this.options.width;
    }
    // Public
    changeMode(mode) {
        this._setMode(mode);
    }
    dispose() {
        if (this._backdrop) this._removeBackdrop();
        $0abbbd36a260e067$var$EventHandler$1.off(window, "keydown", this.escHandler);
        $0abbbd36a260e067$var$EventHandler$1.off(window, "hashchange", this.hashHandler);
        this._touch.dispose();
        $0abbbd36a260e067$var$Data$1.removeData(this._element, $0abbbd36a260e067$var$DATA_KEY$o);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    hide() {
        this._setVisibility(false);
        this._update(false);
    }
    show() {
        this._setVisibility(true);
        this._update(true);
    }
    toggle() {
        this._setVisibility(!this.isVisible);
        this._update(!this.isVisible);
    }
    toggleSlim() {
        this._setSlim(!this._slimCollapsed);
    }
    update(options) {
        this._options = options;
        this._setup();
    }
    // Private
    _appendArrow(node) {
        const arrow2 = $0abbbd36a260e067$var$element("i");
        [
            "fas",
            "fa-angle-down",
            $0abbbd36a260e067$var$ARROW_CLASS
        ].forEach((className)=>{
            $0abbbd36a260e067$var$Manipulator$1.addClass(arrow2, className);
        });
        if ($0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$ARROW_CLASS}`, node).length === 0) node.appendChild(arrow2);
    }
    _collapseItems() {
        this.navigation.forEach((menu)=>{
            const collapseElements = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_COLLAPSE, menu);
            collapseElements.forEach((el)=>{
                $0abbbd36a260e067$var$Collapse$1.getInstance(el).hide();
            });
        });
    }
    _setupBackdrop() {
        const classes = [];
        if (this.options.backdropClass) classes.push(this.options.backdropClass);
        const style = {
            transition: `opacity ${this.transitionDuration} ease-out`,
            position: this.options.position,
            width: this.options.position === "fixed" ? "100vw" : "100%",
            height: this.options.position === "fixed" ? "100vh" : "100%"
        };
        if (!this._backdrop) {
            const backdrop = $0abbbd36a260e067$var$element("div");
            classes.push($0abbbd36a260e067$var$BACKDROP_CLASS);
            style.opacity = 0;
            $0abbbd36a260e067$var$EventHandler$1.on(backdrop, "click", ()=>{
                this._setVisibility(false);
                this._update(false);
            });
            this._backdrop = backdrop;
        }
        this._backdrop.classList.add(...classes);
        $0abbbd36a260e067$var$Manipulator$1.style(this._backdrop, style);
    }
    _getOffsetValue(show, { index: index, property: property, offsets: offsets }) {
        const initialValue = this._getPxValue(this._initialContentStyle[index][offsets[property].property]);
        const offset2 = show ? offsets[property].value : 0;
        return initialValue + offset2;
    }
    _getProperty(...args) {
        return args.map((arg, i)=>{
            if (i === 0) return arg;
            return arg[0].toUpperCase().concat(arg.slice(1));
        }).join("");
    }
    _getPxValue(property) {
        if (!property) return 0;
        return parseFloat(property);
    }
    _handleSwipe(e, inverseDirecion) {
        if (inverseDirecion && this._slimCollapsed && this.options.slim && this.options.expandable) this.toggleSlim();
        else if (!inverseDirecion) {
            if (this._slimCollapsed || !this.options.slim || !this.options.expandable) {
                if (this.toggler && $0abbbd36a260e067$var$isVisible$1(this.toggler)) this.toggle();
            } else this.toggleSlim();
        }
    }
    _isActive(link, reference2) {
        if (reference2) return reference2 === link;
        if (link.attributes.href) {
            const trimmedLink = window.location.href.split(/#|\?/)[0];
            const strippedRequests = window.location.href.split("?")[0];
            return new URL(link, window.location.href).href === trimmedLink || new URL(link, window.location.href).href === strippedRequests;
        }
        return false;
    }
    _isAllToBeCollapsed() {
        const collapseElements = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_TOGGLE_COLLAPSE, this._element);
        const collapseElementsExpanded = collapseElements.filter((collapsible)=>collapsible.getAttribute("aria-expanded") === "true");
        return collapseElementsExpanded.length === 0;
    }
    _isAllCollapsed() {
        return $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_COLLAPSE, this._element).filter((el)=>$0abbbd36a260e067$var$isVisible$1(el)).length === 0;
    }
    _setup() {
        this._setupTouch();
        if (this.options.focusTrap) this._setupFocusTrap();
        if (this.options.backdrop) {
            this._setupBackdrop();
            if (!this.options.hidden && this.options.mode === "over") this._appendBackdrop();
        }
        this._setupCollapse();
        if (this.options.slimCollapsed) $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, "sidenav-slim");
        if (this.options.slim) this._setupSlim();
        this._setupInitialStyling();
        this._setupScrolling();
        if (this.options.content) this._setupContent();
        this._setupActiveState();
        this._setupRippleEffect();
        if (!this.options.hidden) {
            if (this.options.right) this.show();
            this._updateOffsets(true, true);
        }
    }
    _setupActiveState() {
        this._setActiveElements();
        this.links.forEach((link)=>{
            $0abbbd36a260e067$var$EventHandler$1.on(link, "click", ()=>this._setActiveElements(link));
            $0abbbd36a260e067$var$EventHandler$1.on(link, "keydown", (e)=>{
                if (e.keyCode === $0abbbd36a260e067$var$ENTER) this._setActiveElements(link);
            });
        });
        $0abbbd36a260e067$var$EventHandler$1.on(window, "hashchange", this.hashHandler);
    }
    _setupCollapse() {
        this.navigation.forEach((menu, menuIndex)=>{
            const categories = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_COLLAPSE, menu);
            categories.forEach((list, index)=>this._setupCollapseList({
                    list: list,
                    index: index,
                    menu: menu,
                    menuIndex: menuIndex
                }));
        });
    }
    _generateCollpaseID(index, menuIndex) {
        return `sidenav-collapse-${this._ID}-${menuIndex}-${index}`;
    }
    _setupCollapseList({ list: list, index: index, menu: menu, menuIndex: menuIndex }) {
        const ID = this._generateCollpaseID(index, menuIndex);
        list.classList.add("collapse");
        list.setAttribute("id", ID);
        const [toggler] = $0abbbd36a260e067$var$SelectorEngine$1.prev(list, $0abbbd36a260e067$var$SELECTOR_LINK);
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(toggler, "collapse-init", "");
        toggler.setAttribute("href", `#${ID}`);
        toggler.setAttribute("role", "button");
        const instance = $0abbbd36a260e067$var$Collapse$1.getInstance(list) || new $0abbbd36a260e067$var$Collapse$1(list, {
            toggle: false,
            parent: this.options.accordion ? menu : list
        });
        this._appendArrow(toggler);
        if ($0abbbd36a260e067$var$Manipulator$1.hasClass(list, "show")) this._rotateArrow(toggler, 180);
        $0abbbd36a260e067$var$EventHandler$1.on(toggler, "click", (e)=>{
            this._toggleCategory(e, instance, list);
            if (this._tempSlim && this._isAllToBeCollapsed()) {
                this._setSlim(true);
                this._tempSlim = false;
            }
            if (this.options.mode === "over" && this._focusTrap) this._focusTrap.update();
        });
        $0abbbd36a260e067$var$EventHandler$1.on(list, "show.bs.collapse", ()=>this._rotateArrow(toggler, 180));
        $0abbbd36a260e067$var$EventHandler$1.on(list, "hide.bs.collapse", ()=>this._rotateArrow(toggler, 0));
        $0abbbd36a260e067$var$EventHandler$1.on(list, "shown.bs.collapse", ()=>{
            if (this.options.mode === "over" && this._focusTrap) this._focusTrap.update();
        });
        $0abbbd36a260e067$var$EventHandler$1.on(list, "hidden.bs.collapse", ()=>{
            if (this._tempSlim && this._isAllCollapsed()) {
                this._setSlim(true);
                this._tempSlim = false;
            }
            if (this.options.mode === "over" && this._focusTrap) this._focusTrap.update();
        });
    }
    _setupContent() {
        this._content = $0abbbd36a260e067$var$SelectorEngine$1.find(this.options.content);
        if (!this._initialContentStyle) this._initialContentStyle = this._content.map((el)=>{
            const { paddingLeft: paddingLeft, paddingRight: paddingRight, marginLeft: marginLeft, marginRight: marginRight, transition: transition } = window.getComputedStyle(el);
            return {
                paddingLeft: paddingLeft,
                paddingRight: paddingRight,
                marginLeft: marginLeft,
                marginRight: marginRight,
                transition: transition
            };
        });
    }
    _setupFocusTrap() {
        this._focusTrap = new $0abbbd36a260e067$var$FocusTrap2(this._element, {
            event: "keydown",
            condition: (e)=>e.keyCode === $0abbbd36a260e067$var$TAB,
            onlyVisible: true
        }, this.toggler);
    }
    _setupInitialStyling() {
        this._setColor();
        $0abbbd36a260e067$var$Manipulator$1.style(this._element, this.sidenavStyle);
    }
    _setupScrolling() {
        let container = this._element;
        if (this.options.scrollContainer) {
            container = $0abbbd36a260e067$var$SelectorEngine$1.findOne(this.options.scrollContainer, this._element);
            const siblings = $0abbbd36a260e067$var$array(container.parentNode.children).filter((el)=>el !== container);
            const siblingsHeight = siblings.reduce((a, b)=>{
                return a + b.clientHeight;
            }, 0);
            $0abbbd36a260e067$var$Manipulator$1.style(container, {
                maxHeight: `calc(100% - ${siblingsHeight}px)`,
                position: "relative"
            });
        }
        this._perfectScrollbar = new $0abbbd36a260e067$var$PerfectScrollbar(container, {
            suppressScrollX: true,
            handlers: [
                "click-rail",
                "drag-thumb",
                "wheel",
                "touch"
            ]
        });
    }
    _setupSlim() {
        this._slimCollapsed = this.options.slimCollapsed;
        this._toggleSlimDisplay(this._slimCollapsed);
        if (this.options.expandOnHover) {
            this._element.addEventListener("mouseenter", ()=>{
                if (this._slimCollapsed) this._setSlim(false);
            });
            this._element.addEventListener("mouseleave", ()=>{
                if (!this._slimCollapsed) this._setSlim(true);
            });
        }
    }
    _setupRippleEffect() {
        this.links.forEach((link)=>{
            let wave = $0abbbd36a260e067$export$9e9146f7e027fdaa.getInstance(link);
            if (wave && wave._options.color !== this.options.color) wave.dispose();
            else if (wave) return;
            wave = new $0abbbd36a260e067$export$9e9146f7e027fdaa(link, {
                rippleColor: this.options.color
            });
        });
    }
    _setupTouch() {
        this._touch = new $0abbbd36a260e067$var$Touch$1(this._element, "swipe", {
            threshold: 20
        });
        this._touch.init();
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "swipeleft", (e)=>this._handleSwipe(e, this.options.right));
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "swiperight", (e)=>this._handleSwipe(e, !this.options.right));
    }
    _setActive(link, reference2) {
        $0abbbd36a260e067$var$Manipulator$1.addClass(link, "active");
        if (this._activeNode) this._activeNode.classList.remove("active");
        this._activeNode = link;
        const [collapse] = $0abbbd36a260e067$var$SelectorEngine$1.parents(this._activeNode, $0abbbd36a260e067$var$SELECTOR_COLLAPSE);
        if (!collapse) {
            this._setActiveCategory();
            return;
        }
        const [category] = $0abbbd36a260e067$var$SelectorEngine$1.prev(collapse, $0abbbd36a260e067$var$SELECTOR_LINK);
        this._setActiveCategory(category);
        if (!reference2 && !this._slimCollapsed) $0abbbd36a260e067$var$Collapse$1.getInstance(collapse).show();
    }
    _setActiveCategory(el) {
        this.navigation.forEach((menu)=>{
            const categories = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_COLLAPSE, menu);
            categories.forEach((collapse)=>{
                const [collapseToggler] = $0abbbd36a260e067$var$SelectorEngine$1.prev(collapse, $0abbbd36a260e067$var$SELECTOR_LINK);
                if (collapseToggler !== el) collapseToggler.classList.remove("active");
                else $0abbbd36a260e067$var$Manipulator$1.addClass(collapseToggler, "active");
            });
        });
    }
    _setActiveElements(reference2) {
        this.navigation.forEach((menu)=>{
            const links = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_LINK, menu);
            links.filter((link)=>{
                return $0abbbd36a260e067$var$SelectorEngine$1.next(link, $0abbbd36a260e067$var$SELECTOR_COLLAPSE).length === 0;
            }).forEach((link)=>{
                if (this._isActive(link, reference2) && link !== this._activeNode) this._setActive(link, reference2);
            });
        });
    }
    _setColor() {
        const colors = [
            "primary",
            "secondary",
            "success",
            "info",
            "warning",
            "danger",
            "light",
            "dark"
        ];
        const { color: optionColor } = this.options;
        const color = colors.includes(optionColor) ? optionColor : "primary";
        colors.forEach((color2)=>{
            this._element.classList.remove(`sidenav-${color2}`);
        });
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, `sidenav-${color}`);
    }
    _setContentOffsets(show, offsets, initial) {
        this._content.forEach((el, i)=>{
            const padding = this._getOffsetValue(show, {
                index: i,
                property: "padding",
                offsets: offsets
            });
            const margin = this._getOffsetValue(show, {
                index: i,
                property: "margin",
                offsets: offsets
            });
            const style = {};
            if (!initial) style.transition = `all ${this.transitionDuration} linear`;
            style[offsets.padding.property] = `${padding}px`;
            style[offsets.margin.property] = `${margin}px`;
            $0abbbd36a260e067$var$Manipulator$1.style(el, style);
            if (!show) return;
            if (initial) {
                $0abbbd36a260e067$var$Manipulator$1.style(el, {
                    transition: this._initialContentStyle[i].transition
                });
                return;
            }
            $0abbbd36a260e067$var$EventHandler$1.on(el, "transitionend", ()=>{
                $0abbbd36a260e067$var$Manipulator$1.style(el, {
                    transition: this._initialContentStyle[i].transition
                });
            });
        });
    }
    _setMode(mode) {
        if (this.options.mode === mode) return;
        this._options.mode = mode;
        this._update(this.isVisible);
    }
    _setSlim(value) {
        const events = value ? [
            "collapse",
            "collapsed"
        ] : [
            "expand",
            "expanded"
        ];
        this._triggerEvents(...events);
        if (value) {
            this._collapseItems();
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, "sidenav-slim");
        } else $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, "sidenav-slim");
        this._slimCollapsed = value;
        this._toggleSlimDisplay(value);
        $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            width: `${this.width}px`
        });
        this._updateOffsets(this.isVisible);
    }
    _setTabindex(value) {
        this.links.forEach((link)=>{
            link.tabIndex = value ? 1 : -1;
        });
    }
    _setVisibility(show) {
        const events = show ? [
            "show",
            "shown"
        ] : [
            "hide",
            "hidden"
        ];
        this._triggerEvents(...events);
    }
    _rotateArrow(toggler, angle) {
        const [arrow2] = $0abbbd36a260e067$var$SelectorEngine$1.children(toggler, `.${$0abbbd36a260e067$var$ARROW_CLASS}`);
        if (!arrow2) return;
        $0abbbd36a260e067$var$Manipulator$1.style(arrow2, {
            transform: `rotate(${angle}deg)`
        });
    }
    async _toggleBackdrop(value) {
        if (value && this.options.mode === "over") this._appendBackdrop();
        else {
            $0abbbd36a260e067$var$Manipulator$1.style(this._backdrop, {
                opacity: 0
            });
            await setTimeout(()=>{
                this._removeBackdrop();
            }, this.options.transitionDuration);
        }
    }
    _removeBackdrop() {
        if (this._backdrop.parentNode === this.container) this.container.removeChild(this._backdrop);
    }
    _appendBackdrop() {
        this.container.appendChild(this._backdrop);
        setTimeout(()=>$0abbbd36a260e067$var$Manipulator$1.style(this._backdrop, {
                opacity: 1
            }), 0);
    }
    _toggleCategory(e, instance) {
        e.preventDefault();
        instance.toggle();
        if (this._slimCollapsed && this.options.expandable) {
            this._tempSlim = true;
            this._setSlim(false);
        }
    }
    _toggleSlimDisplay(slim) {
        const slimCollapsedElements = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_SHOW_SLIM, this._element);
        const fullWidthElements = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_HIDE_SLIM, this._element);
        const toggleElements = ()=>{
            slimCollapsedElements.forEach((el)=>{
                $0abbbd36a260e067$var$Manipulator$1.style(el, {
                    display: this._slimCollapsed ? "unset" : "none"
                });
            });
            fullWidthElements.forEach((el)=>{
                $0abbbd36a260e067$var$Manipulator$1.style(el, {
                    display: this._slimCollapsed ? "none" : "unset"
                });
            });
        };
        if (slim) setTimeout(()=>toggleElements(), this.options.transitionDuration);
        else toggleElements();
    }
    async _triggerEvents(startEvent, completeEvent) {
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, `${startEvent}.mdb.sidenav`);
        if (completeEvent) await setTimeout(()=>{
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, `${completeEvent}.mdb.sidenav`);
        }, this.options.transitionDuration + 5);
    }
    _update(show) {
        if (this.toggler) this._updateTogglerAria(show);
        this._updateDisplay(show);
        if (this.options.backdrop) this._toggleBackdrop(show);
        this._updateOffsets(show);
        if (show && this.options.closeOnEsc && this.options.mode !== "side") $0abbbd36a260e067$var$EventHandler$1.on(window, "keydown", this.escHandler);
        if (this.options.focusTrap) this._updateFocus(show);
    }
    _updateDisplay(value) {
        const translation = value ? 0 : this.translation;
        $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            transform: `translateX(${translation}%)`
        });
    }
    _updateFocus(show) {
        this._setTabindex(show);
        if (this.options.mode === "over" && this.options.focusTrap) {
            if (show) {
                this._focusTrap.trap();
                return;
            }
            this._focusTrap.disable();
        }
        this._focusTrap.disable();
    }
    _updateOffsets(show, initial = false) {
        const [paddingPosition, marginPosition] = this.options.right && !$0abbbd36a260e067$var$isRTL$1 || !this.options.right && $0abbbd36a260e067$var$isRTL$1 ? [
            "right",
            "left"
        ] : [
            "left",
            "right"
        ];
        const padding = {
            property: this._getProperty("padding", paddingPosition),
            value: this.options.mode === "over" ? 0 : this.width
        };
        const margin = {
            property: this._getProperty("margin", marginPosition),
            value: this.options.mode === "push" ? -1 * this.width : 0
        };
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, "update.mdb.sidenav", {
            margin: margin,
            padding: padding
        });
        if (!this._content) return;
        this._setContentOffsets(show, {
            padding: padding,
            margin: margin
        }, initial);
    }
    _updateTogglerAria(value) {
        this.toggler.setAttribute("aria-expanded", value);
    }
    // Static
    static toggleSidenav() {
        return function(e) {
            const toggler = $0abbbd36a260e067$var$SelectorEngine$1.closest(e.target, $0abbbd36a260e067$var$SELECTOR_TOGGLE$1);
            const elementSelector = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(toggler).target;
            $0abbbd36a260e067$var$SelectorEngine$1.find(elementSelector).forEach((element2)=>{
                const instance = $0abbbd36a260e067$export$40a91cd7866fd4b5.getInstance(element2) || new $0abbbd36a260e067$export$40a91cd7866fd4b5(element2);
                instance.toggle();
            });
        };
    }
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$o);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$40a91cd7866fd4b5(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$v = "alert";
const $0abbbd36a260e067$var$DATA_KEY$n = "bs.alert";
const $0abbbd36a260e067$var$EVENT_KEY$i = `.${$0abbbd36a260e067$var$DATA_KEY$n}`;
const $0abbbd36a260e067$var$EVENT_CLOSE$5 = `close${$0abbbd36a260e067$var$EVENT_KEY$i}`;
const $0abbbd36a260e067$var$EVENT_CLOSED$1 = `closed${$0abbbd36a260e067$var$EVENT_KEY$i}`;
const $0abbbd36a260e067$var$CLASS_NAME_FADE$2 = "fade";
const $0abbbd36a260e067$var$CLASS_NAME_SHOW$2 = "show";
let $0abbbd36a260e067$var$Alert$1 = class Alert extends $0abbbd36a260e067$var$BaseComponent$1 {
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$v;
    }
    // Public
    close() {
        const closeEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_CLOSE$5);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOW$2);
        const isAnimated = this._element.classList.contains($0abbbd36a260e067$var$CLASS_NAME_FADE$2);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_CLOSED$1);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Alert.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === void 0 || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
};
const $0abbbd36a260e067$var$NAME$u = "Stack";
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$9 = {
    position: "top",
    container: null,
    refresh: 1e3,
    filter: (el)=>{
        return el;
    }
};
const $0abbbd36a260e067$var$TYPE_OPTIONS$1 = {
    position: "string",
    container: "(undefined|null|string)",
    refresh: "number",
    filter: "function"
};
class $0abbbd36a260e067$var$Stack {
    constructor(element2, selector, options){
        this._element = element2;
        this._selector = selector;
        this._options = this._getConfig(options);
        this._offset = null;
        if (this._options.container) this._parent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(this._options.container);
    }
    get stackableElements() {
        return $0abbbd36a260e067$var$SelectorEngine$1.find(this._selector).filter((el, i)=>this._options.filter(el, i)).map((el)=>({
                el: el,
                rect: el.getBoundingClientRect()
            })).filter(({ el: el, rect: rect })=>{
            const basicCondition = el !== this._element && $0abbbd36a260e067$var$isVisible$1(el);
            if (this._offset === null) return basicCondition;
            return basicCondition && this._getBoundryOffset(rect) < this._offset;
        }).sort((a, b)=>{
            return this._getBoundryOffset(b.rect) - this._getBoundryOffset(a.rect);
        });
    }
    get nextElements() {
        return $0abbbd36a260e067$var$SelectorEngine$1.find(this._selector).filter((el)=>el !== this._element).filter((el, i)=>this._options.filter(el, i)).filter((el)=>{
            this._offset = null;
            return this._getBoundryOffset(el.getBoundingClientRect()) > this._offset;
        });
    }
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$9,
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$u, config, $0abbbd36a260e067$var$TYPE_OPTIONS$1);
        return config;
    }
    _getBoundryOffset(rect) {
        const { position: position } = this._options;
        let parentTopOffset = 0;
        let parentBottomBoundry = window.innerHeight;
        if (this._parent) {
            const parentRect = this._parent.getBoundingClientRect();
            parentTopOffset = parentRect.top;
            parentBottomBoundry = parentRect.bottom;
        }
        if (position === "top") return rect.top - parentTopOffset;
        return parentBottomBoundry - rect.bottom;
    }
    calculateOffset() {
        const [previousElement] = this.stackableElements;
        if (!previousElement) this._offset = 0;
        else this._offset = this._getBoundryOffset(previousElement.rect) + previousElement.rect.height;
        return this._offset;
    }
}
const $0abbbd36a260e067$var$NAME$t = "alert";
const $0abbbd36a260e067$var$SELECTOR_ALERT = ".alert";
const $0abbbd36a260e067$var$DATA_KEY$m = `mdb.${$0abbbd36a260e067$var$NAME$t}`;
const $0abbbd36a260e067$var$EVENT_KEY$h = `.${$0abbbd36a260e067$var$DATA_KEY$m}`;
const $0abbbd36a260e067$var$EVENT_CLOSE_BS = "close.bs.alert";
const $0abbbd36a260e067$var$EVENT_CLOSED_BS = "closed.bs.alert";
const $0abbbd36a260e067$var$EVENT_HIDE$2 = `hide${$0abbbd36a260e067$var$EVENT_KEY$h}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN$3 = `hidden${$0abbbd36a260e067$var$EVENT_KEY$h}`;
const $0abbbd36a260e067$var$EVENT_SHOW$3 = `show${$0abbbd36a260e067$var$EVENT_KEY$h}`;
const $0abbbd36a260e067$var$EVENT_SHOWN$2 = `shown${$0abbbd36a260e067$var$EVENT_KEY$h}`;
const $0abbbd36a260e067$var$EXTENDED_EVENTS$2 = [
    {
        name: "close"
    },
    {
        name: "closed"
    }
];
const $0abbbd36a260e067$var$DefaultType$k = {
    position: "(string || null)",
    delay: "number",
    autohide: "boolean",
    width: "(string || null)",
    offset: "number",
    stacking: "boolean",
    hidden: "boolean",
    appendToBody: "boolean",
    color: "(string || null)",
    container: "(string|null)"
};
const $0abbbd36a260e067$var$Default$k = {
    position: null,
    delay: 1e3,
    autohide: false,
    width: null,
    offset: 10,
    stacking: false,
    hidden: false,
    appendToBody: false,
    color: null,
    container: null
};
class $0abbbd36a260e067$export$caec2af78bcc877f extends $0abbbd36a260e067$var$Alert$1 {
    constructor(element2, data = {}){
        super(element2, data);
        this._options = this._getConfig(data);
        this._isOpen = true;
        this._init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_CLOSE_BS);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_CLOSED_BS);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Getters
    get verticalOffset() {
        if (!this._options.stacking) return 0;
        return this.stackUtil.calculateOffset();
    }
    get parent() {
        const [parent] = $0abbbd36a260e067$var$SelectorEngine$1.parents(this._element, this._options.container);
        return parent;
    }
    get position() {
        const [y, x] = this._options.position.split("-");
        return {
            y: y,
            x: x
        };
    }
    // Public
    update(updatedData = {}) {
        if (this._timeout !== null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        this._options = this._getConfig(updatedData);
        this._setup();
    }
    hide() {
        const hideEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDE$2);
        if (!this._isOpen || hideEvent.defaultPrevented) return;
        if (!this._element) return;
        if (this._element.classList.contains("show")) {
            $0abbbd36a260e067$var$Manipulator$1.toggleClass(this._element, "show");
            const handler = (e)=>{
                $0abbbd36a260e067$var$Manipulator$1.style(e.target, {
                    display: "none"
                });
                if (this._timeout !== null) {
                    clearTimeout(this._timeout);
                    this._timeout = null;
                }
                if (this._options.stacking) this._updateAlertStack();
                $0abbbd36a260e067$var$EventHandler$1.off(e.target, "transitionend", handler);
                $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN$3);
                this._isOpen = false;
            };
            $0abbbd36a260e067$var$EventHandler$1.on(this._element, "transitionend", handler);
        }
    }
    show() {
        const showEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOW$3);
        if (this._isOpen || showEvent.defaultPrevented) return;
        if (this._options.autohide) this._setupAutohide();
        if (this._options.stacking) this._updateAlertStack();
        if (!this._element.classList.contains("show")) {
            $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
                display: "block"
            });
            if ($0abbbd36a260e067$var$isVisible$1(this._element)) {
                const handler = (e)=>{
                    $0abbbd36a260e067$var$Manipulator$1.style(e.target, {
                        display: "block"
                    });
                    $0abbbd36a260e067$var$EventHandler$1.off(e.target, "transitionend", handler);
                    $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOWN$2);
                    this._isOpen = true;
                };
                $0abbbd36a260e067$var$Manipulator$1.toggleClass(this._element, "show");
                if (this._options.position) this._setupAlignment();
                $0abbbd36a260e067$var$EventHandler$1.on(this._element, "transitionend", handler);
            }
        }
    }
    // Private
    _init() {
        if (this._options.hidden) {
            $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
                display: "none"
            });
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, "show");
            this._isOpen = false;
        }
        this._bindMdbEvents();
        this._setup();
    }
    _setup() {
        if (this._options.color) this._setColor();
        if (this._options.stacking) this._setupStacking();
        if (this._options.autohide && !this._options.hidden) this._setupAutohide();
        if (this._options.width) this._setupWidth();
        if (this._options.appendToBody) this._appendToBody();
        if (!this._options.position) return;
        this._setupAlignment();
        this._setupPosition();
    }
    _setupStacking() {
        this.stackUtil = new $0abbbd36a260e067$var$Stack(this._element, $0abbbd36a260e067$var$SELECTOR_ALERT, {
            position: this.position.y,
            offset: this._options.offset,
            container: this._options.container,
            filter: (el)=>{
                const instance = $0abbbd36a260e067$export$caec2af78bcc877f.getInstance(el);
                if (!instance) return false;
                return instance._options.container === this._options.container && instance._options.position === this._options.position;
            }
        });
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_CLOSED_BS, ()=>{
            this._updateAlertStack();
        });
    }
    _setColor() {
        const colors = [
            "primary",
            "secondary",
            "success",
            "info",
            "warning",
            "danger",
            "light",
            "dark"
        ];
        const color = colors.includes(this._options.color) ? this._options.color : "primary";
        colors.forEach((color2)=>{
            this._element.classList.remove(`alert-${color2}`);
        });
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, `alert-${color}`);
    }
    _setupWidth() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            width: this._options.width
        });
    }
    _setupAutohide() {
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._options.delay);
    }
    _setupAlignment() {
        const oppositeY = this.position.y === "top" ? "bottom" : "top";
        const oppositeX = this.position.x === "left" ? "right" : "left";
        if (this.position.x === "center") $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            [this.position.y]: `${this.verticalOffset + this._options.offset}px`,
            [oppositeY]: "unset",
            left: "50%",
            transform: "translate(-50%)"
        });
        else $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            [this.position.y]: `${this.verticalOffset + this._options.offset}px`,
            [this.position.x]: `${this._options.offset}px`,
            [oppositeY]: "unset",
            [oppositeX]: "unset",
            transform: "unset"
        });
    }
    _setupPosition() {
        if (this._options.container) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.parent, "parent-alert-relative");
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, "alert-absolute");
        } else $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, "alert-fixed");
    }
    _appendToBody() {
        this._element.parentNode.removeChild(this._element);
        document.body.appendChild(this._element);
    }
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$Default$k,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$t, config, $0abbbd36a260e067$var$DefaultType$k);
        return config;
    }
    _bindMdbEvents() {
        $0abbbd36a260e067$var$EventHandler$1.extend(this._element, $0abbbd36a260e067$var$EXTENDED_EVENTS$2, $0abbbd36a260e067$var$NAME$t);
    }
    _updatePosition() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            [this.position.y]: `${this.verticalOffset + this._options.offset}px`
        });
    }
    _updateAlertStack() {
        this.stackUtil.nextElements.forEach((el)=>{
            const instance = $0abbbd36a260e067$export$caec2af78bcc877f.getInstance(el);
            if (!instance) return;
            instance._updatePosition();
        });
    }
}
const $0abbbd36a260e067$var$NAME$s = "toast";
const $0abbbd36a260e067$var$DATA_KEY$l = "bs.toast";
const $0abbbd36a260e067$var$EVENT_KEY$g = `.${$0abbbd36a260e067$var$DATA_KEY$l}`;
const $0abbbd36a260e067$var$EVENT_MOUSEOVER = `mouseover${$0abbbd36a260e067$var$EVENT_KEY$g}`;
const $0abbbd36a260e067$var$EVENT_MOUSEOUT = `mouseout${$0abbbd36a260e067$var$EVENT_KEY$g}`;
const $0abbbd36a260e067$var$EVENT_FOCUSIN = `focusin${$0abbbd36a260e067$var$EVENT_KEY$g}`;
const $0abbbd36a260e067$var$EVENT_FOCUSOUT = `focusout${$0abbbd36a260e067$var$EVENT_KEY$g}`;
const $0abbbd36a260e067$var$EVENT_HIDE$1 = `hide${$0abbbd36a260e067$var$EVENT_KEY$g}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN$2 = `hidden${$0abbbd36a260e067$var$EVENT_KEY$g}`;
const $0abbbd36a260e067$var$EVENT_SHOW$2 = `show${$0abbbd36a260e067$var$EVENT_KEY$g}`;
const $0abbbd36a260e067$var$EVENT_SHOWN$1 = `shown${$0abbbd36a260e067$var$EVENT_KEY$g}`;
const $0abbbd36a260e067$var$CLASS_NAME_FADE$1 = "fade";
const $0abbbd36a260e067$var$CLASS_NAME_HIDE = "hide";
const $0abbbd36a260e067$var$CLASS_NAME_SHOW$1 = "show";
const $0abbbd36a260e067$var$CLASS_NAME_SHOWING = "showing";
const $0abbbd36a260e067$var$DefaultType$j = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $0abbbd36a260e067$var$Default$j = {
    animation: true,
    autohide: true,
    delay: 5e3
};
let $0abbbd36a260e067$var$Toast$1 = class Toast extends $0abbbd36a260e067$var$BaseComponent$1 {
    constructor(element2, config){
        super(element2, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$j;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$j;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$s;
    }
    // Public
    show() {
        const showEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOW$2);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_FADE$1);
        const complete = ()=>{
            this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOWING);
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOWN$1);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_HIDE);
        $0abbbd36a260e067$var$reflow(this._element);
        this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOW$1, $0abbbd36a260e067$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDE$1);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_HIDE);
            this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOWING, $0abbbd36a260e067$var$CLASS_NAME_SHOW$1);
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN$2);
        };
        this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOW$1);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($0abbbd36a260e067$var$CLASS_NAME_SHOW$1);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = Toast.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
};
const $0abbbd36a260e067$var$NAME$r = "toast";
const $0abbbd36a260e067$var$SELECTOR_TOAST = ".toast";
const $0abbbd36a260e067$var$SELECTOR_HEADER$1 = ".toast-header";
const $0abbbd36a260e067$var$EVENT_SHOW_BS = "show.bs.toast";
const $0abbbd36a260e067$var$EVENT_SHOWN_BS = "shown.bs.toast";
const $0abbbd36a260e067$var$EVENT_HIDE_BS = "hide.bs.toast";
const $0abbbd36a260e067$var$EVENT_HIDDEN_BS = "hidden.bs.toast";
const $0abbbd36a260e067$var$EVENT_SHOW$1 = "show.mdb.toast";
const $0abbbd36a260e067$var$EVENT_HIDDEN$1 = "hidden.mdb.toast";
const $0abbbd36a260e067$var$EXTENDED_EVENTS$1 = [
    {
        name: "shown"
    },
    {
        name: "hide"
    }
];
const $0abbbd36a260e067$var$DefaultType$i = {
    position: "(string|null)",
    animation: "boolean",
    autohide: "boolean",
    width: "(string || null)",
    color: "(string|null)",
    delay: "(boolean|number)",
    offset: "number",
    appendToBody: "boolean",
    stacking: "boolean",
    container: "(string|null)"
};
const $0abbbd36a260e067$var$Default$i = {
    position: null,
    animation: true,
    autohide: true,
    width: null,
    color: null,
    delay: 500,
    offset: 10,
    appendToBody: false,
    stacking: true,
    container: ""
};
class $0abbbd36a260e067$export$8d8dc7d5f743331b extends $0abbbd36a260e067$var$Toast$1 {
    constructor(element2, data = {}){
        super(element2, data);
        this._config = this._getConfig(data);
        this._setup();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    get parent() {
        const [parent] = $0abbbd36a260e067$var$SelectorEngine$1.parents(this._element, this._config.container);
        return parent;
    }
    get position() {
        if (!this._config.position) return null;
        const [y, x] = this._config.position.split("-");
        return {
            y: y,
            x: x
        };
    }
    get verticalOffset() {
        if (!this._config.stacking || !this.position) return 0;
        return this.stackUtil.calculateOffset();
    }
    // Public
    update(updatedData = {}) {
        this._config = this._getConfig(updatedData);
        this._setupColor();
        if (!this._config.position) return;
        if (this._config.stacking) {
            this._setupStacking();
            $0abbbd36a260e067$var$EventHandler$1.on(this._element, "hidden.bs.toast", ()=>{
                setTimeout(()=>this._updateToastStack(), 150);
            });
        }
        this._setupPosition();
        this._setupAlignment();
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOW_BS);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOWN_BS);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_HIDE_BS);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN_BS);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _setup() {
        this._setupColor();
        if (this._config.width) this._setupWidth();
        this._bindMdbEvents();
        this._setupDisplay();
        if (!this._config.position) return;
        if (this._config.stacking) {
            this._setupStacking();
            $0abbbd36a260e067$var$EventHandler$1.on(this._element, "hidden.bs.toast", ()=>{
                setTimeout(()=>this._updateToastStack(), 150);
            });
        }
        this._setupPosition();
        if (!this._config.container && this._config.appendToBody) this._appendToBody();
    }
    _setupStacking() {
        this.stackUtil = new $0abbbd36a260e067$var$Stack(this._element, $0abbbd36a260e067$var$SELECTOR_TOAST, {
            position: this.position.y,
            offset: this._config.offset,
            container: this._config.container,
            filter: (el)=>{
                const instance = $0abbbd36a260e067$export$8d8dc7d5f743331b.getInstance(el);
                if (!instance) return false;
                return instance._config.container === this._config.container && instance._config.position === this._config.position;
            }
        });
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "closed.bs.alert", ()=>{
            this._updateAlertStack();
        });
    }
    _setupColor() {
        if (!this._config.color) return;
        const header = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_HEADER$1, this._element);
        const toasts = [
            "primary",
            "secondary",
            "success",
            "info",
            "warning",
            "danger",
            "light",
            "dark"
        ];
        const color = toasts.includes(this._config.color) ? this._config.color : "primary";
        toasts.forEach((color2)=>{
            this._element.classList.remove(`toast-${color2}`);
            if (header) header.classList.remove(`toast-${color2}`);
        });
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, `toast-${color}`);
        if (header) $0abbbd36a260e067$var$Manipulator$1.addClass(header, `toast-${color}`);
    }
    _setupWidth() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            width: this._config.width
        });
    }
    _setupPosition() {
        if (this._config.container) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.parent, "parent-toast-relative");
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, "toast-absolute");
        } else $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, "toast-fixed");
    }
    _setupAlignment() {
        var _a, _b, _c, _d, _e, _f, _g;
        const oppositeY = ((_a = this.position) == null ? void 0 : _a.y) === "top" ? "bottom" : "top";
        const oppositeX = ((_b = this.position) == null ? void 0 : _b.x) === "left" ? "right" : "left";
        if (((_c = this.position) == null ? void 0 : _c.x) === "center") $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            [this.position.y]: `${this.verticalOffset + this._config.offset}px`,
            [oppositeY]: "unset",
            left: "50%",
            transform: "translate(-50%)"
        });
        else $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            [((_d = this.position) == null ? void 0 : _d.y) || "defaultY"]: `${this.verticalOffset + ((_e = this._config) == null ? void 0 : _e.offset)}px`,
            [((_f = this.position) == null ? void 0 : _f.x) || "defaultX"]: `${(_g = this._config) == null ? void 0 : _g.offset}px`,
            [oppositeY]: "unset",
            [oppositeX]: "unset",
            transform: "unset"
        });
    }
    _setupDisplay() {
        if (!this._element.classList.contains("show")) $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            display: "none"
        });
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN_BS, ()=>{
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN$1);
            $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
                display: "none"
            });
        });
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_SHOW_BS, ()=>{
            const showEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOW$1);
            if (showEvent.defaultPrevented) return;
            this._setupAlignment();
            $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
                display: "block"
            });
        });
    }
    _bindMdbEvents() {
        $0abbbd36a260e067$var$EventHandler$1.extend(this._element, $0abbbd36a260e067$var$EXTENDED_EVENTS$1, $0abbbd36a260e067$var$NAME$r);
    }
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$Default$i,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$r, config, $0abbbd36a260e067$var$DefaultType$i);
        return config;
    }
    _appendToBody() {
        this._element.parentNode.removeChild(this._element);
        document.body.appendChild(this._element);
    }
    _updatePosition() {
        $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
            [this.position.y]: `${this.verticalOffset + this._config.offset}px`
        });
    }
    _updateToastStack() {
        this.stackUtil.nextElements.forEach((el)=>{
            const instance = $0abbbd36a260e067$export$8d8dc7d5f743331b.getInstance(el);
            if (!instance) return;
            instance._updatePosition();
        });
    }
    // Static
    static jQueryInterface(config, options = {}) {
        return this.each(function() {
            let data;
            if (typeof config === "object") data = new $0abbbd36a260e067$export$8d8dc7d5f743331b(this, config);
            else data = $0abbbd36a260e067$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
const $0abbbd36a260e067$var$getTimepickerTemplate = ({ format24: format24, okLabel: okLabel, cancelLabel: cancelLabel, headId: headId, footerId: footerId, bodyId: bodyId, pickerId: pickerId, clearLabel: clearLabel, inline: inline, showClearBtn: showClearBtn, amLabel: amLabel, pmLabel: pmLabel, isRTL: isRTL2 }, id)=>{
    const normalTemplate = `<div id='${pickerId}' class='timepicker-wrapper h-100 d-flex align-items-center justify-content-center flex-column position-fixed'>
      <div class="d-flex align-items-center justify-content-center flex-column timepicker-container timepicker-container-${id}">
        <div class="d-flex flex-column timepicker-elements justify-content-around">
          ${$0abbbd36a260e067$var$createHead(headId, format24, amLabel, pmLabel, okLabel, inline, isRTL2)}
          ${$0abbbd36a260e067$var$createTimepickerClockWrapper(bodyId, format24)}
        </div>
        ${$0abbbd36a260e067$var$createFooter$1(footerId, showClearBtn, clearLabel, cancelLabel, okLabel)}

      </div>
    </div>`;
    const inlineTemplate = `
    <div id='${pickerId}' class='timepicker-wrapper h-100 d-flex align-items-center justify-content-center flex-column timepicker-wrapper-inline'>
      <div class="d-flex align-items-center justify-content-center flex-column timepicker-container timepicker-container-${id}">

        <div class="d-flex flex-column timepicker-elements justify-content-around timepicker-elements-inline">

        ${$0abbbd36a260e067$var$createHead(headId, format24, amLabel, pmLabel, okLabel, inline, isRTL2)}

        </div>

      </div>
    </div>
  `;
    return inline ? inlineTemplate : normalTemplate;
};
function $0abbbd36a260e067$var$createFooter$1(footerId, showClearBtn, clearLabel, cancelLabel, okLabel) {
    return `
  <div id='${footerId}' class='timepicker-footer'>
    <div class="w-100 d-flex justify-content-between">
      ${showClearBtn ? `<button type='button' class='timepicker-button timepicker-clear' tabindex="0">${clearLabel}</button>` : ""}
      <button type='button' class='timepicker-button timepicker-cancel' tabindex="0">${cancelLabel}</button>
      <button type='button' class='timepicker-button timepicker-submit' tabindex="0">${okLabel}</button>
    </div>
  </div>`;
}
function $0abbbd36a260e067$var$createTimepickerClockWrapper(bodyId, format24) {
    return `
  <div id='${bodyId}' class='timepicker-clock-wrapper d-flex justify-content-center flex-column align-items-center'>
    <div class='timepicker-clock'>
      <span class='timepicker-middle-dot position-absolute'></span>
      <div class='timepicker-hand-pointer position-absolute'>
        <div class='timepicker-circle position-absolute'></div>
      </div>
      ${format24 ? '<div class="timepicker-clock-inner"></div>' : ""}
    </div>
  </div>`;
}
function $0abbbd36a260e067$var$createModeWrapper(inline, format24, amLabel, pmLabel, okLabel) {
    const submitBtn = `<button type='button' class='timepicker-button timepicker-submit timepicker-submit-inline py-1 px-2 mb-0' tabindex="0">${okLabel}</button>`;
    if (format24) return inline ? `${submitBtn}` : "";
    else return `
      <div class="d-flex ${!inline ? "flex-column " : ""}justify-content-center timepicker-mode-wrapper">
        <button type='button' class="timepicker-hour-mode timepicker-am${inline ? " me-2 ms-4" : ""}" tabindex="0">${amLabel}</button>
        <button type='button' class="timepicker-hour-mode timepicker-pm" tabindex="0">${pmLabel}</button>
        ${inline ? `${submitBtn}` : ""}
      </div>`;
}
function $0abbbd36a260e067$var$createHead(headId, format24, amLabel, pmLabel, okLabel, inline, isRTL2) {
    return `
  <div id='${headId}' class='timepicker-head d-flex flex-row align-items-center justify-content-center ${inline ? "timepicker-head-inline" : ""}'
  style='padding-${isRTL2 ? "left" : "right"}:${format24 && !inline ? 50 : 0}px'>
    <div class='timepicker-head-content d-flex w-100 justify-content-evenly'>
    ${!inline ? `${$0abbbd36a260e067$var$createCurrentWrapperNormal()}` : `${$0abbbd36a260e067$var$createCurrentWrapperInline()}`}
      ${$0abbbd36a260e067$var$createModeWrapper(inline, format24, amLabel, pmLabel, okLabel)}
    </div>
  </div>
  `;
}
function $0abbbd36a260e067$var$createCurrentWrapperNormal() {
    return `
    <div class="timepicker-current-wrapper">
      <span class="position-relative h-100">
        <button type='button' class='timepicker-current timepicker-hour active' tabindex="0">21</button>
      </span>
      <button type='button' class='timepicker-dot' disabled>:</button>
      <span class="position-relative h-100">
        <button type='button' class='timepicker-current timepicker-minute' tabindex="0">21</button>
      </span>
    </div>
  `;
}
function $0abbbd36a260e067$var$createCurrentWrapperInline() {
    return `
    <div class="timepicker-current-wrapper">
      <span class="position-relative h-100 timepicker-inline-hour-icons">
        <i class="fas fa-chevron-up position-absolute text-white timepicker-icon-up timepicker-icon-inline-hour"></i>
        <button type='button' class='timepicker-current timepicker-hour active timepicker-current-inline' tabindex="0">21</button>
        <i class="fas fa-chevron-down position-absolute text-white timepicker-icon-down timepicker-icon-inline-hour"></i>
      </span>
      <button type='button' class='timepicker-dot timepicker-current-inline' disabled>:</button>
      <span class="position-relative h-100  timepicker-inline-minutes-icons">
        <i class="fas fa-chevron-up position-absolute text-white timepicker-icon-up timepicker-icon-inline-minute"></i>
        <button type='button' class='timepicker-current timepicker-minute timepicker-current-inline' tabindex="0">21</button>
        <i class="fas fa-chevron-down position-absolute text-white timepicker-icon-down timepicker-icon-inline-minute"></i>
      </span>
    </div>
  `;
}
const $0abbbd36a260e067$var$getToggleButtonTemplate$1 = (options, id)=>{
    const { iconClass: iconClass } = options;
    return `
  <button id="${id}" tabindex="0" type="button" class="timepicker-toggle-button" data-mdb-toggle="timepicker"  >
    <i class="${iconClass}"></i>
  </button>
`;
};
const $0abbbd36a260e067$var$formatToAmPm = (date)=>{
    if (date === "") return;
    let hours;
    let minutes;
    let amOrPm;
    let originalHours;
    if ($0abbbd36a260e067$var$isValidDate$2(date)) {
        hours = date.getHours();
        originalHours = hours;
        minutes = date.getMinutes();
        hours %= 12;
        if (hours === 0) amOrPm = "AM";
        else if (hours > 12) amOrPm = "PM";
        hours = hours || 12;
        if (amOrPm === void 0) amOrPm = hours >= 12 ? "PM" : "AM";
        minutes = minutes < 10 ? `0${minutes}` : minutes;
    } else {
        [hours, minutes, amOrPm] = $0abbbd36a260e067$var$takeValue(date, false);
        originalHours = hours;
        hours %= 12;
        if (hours === 0 && amOrPm === void 0) amOrPm = "AM";
        hours = hours || 12;
        if (amOrPm === void 0) amOrPm = originalHours >= 12 ? "PM" : "AM";
    }
    return {
        hours: hours,
        minutes: minutes,
        amOrPm: amOrPm
    };
};
const $0abbbd36a260e067$var$isValidDate$2 = (date)=>{
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
};
const $0abbbd36a260e067$var$formatNormalHours = (date)=>{
    if (date === "") return;
    let hours;
    let minutes;
    if (!$0abbbd36a260e067$var$isValidDate$2(date)) [hours, minutes] = $0abbbd36a260e067$var$takeValue(date, false);
    else {
        hours = date.getHours();
        minutes = date.getMinutes();
    }
    minutes = Number(minutes) < 10 ? `0${Number(minutes)}` : minutes;
    return {
        hours: hours,
        minutes: minutes
    };
};
const $0abbbd36a260e067$var$toggleClassHandler = (event, classes)=>{
    return $0abbbd36a260e067$var$EventHandler$1.on(document, event, classes, ({ target: target })=>{
        if (!$0abbbd36a260e067$var$Manipulator$1.hasClass(target, "active")) {
            const allElements = document.querySelectorAll(classes);
            allElements.forEach((element2)=>{
                if ($0abbbd36a260e067$var$Manipulator$1.hasClass(element2, "active")) $0abbbd36a260e067$var$Manipulator$1.removeClass(element2, "active");
            });
            $0abbbd36a260e067$var$Manipulator$1.addClass(target, "active");
        }
    });
};
const $0abbbd36a260e067$var$findMousePosition = ({ clientX: clientX, clientY: clientY, touches: touches }, object, isMobile = false)=>{
    const { left: left2, top: top2 } = object.getBoundingClientRect();
    let obj = {};
    if (!isMobile || !touches) obj = {
        x: clientX - left2,
        y: clientY - top2
    };
    else if (isMobile && Object.keys(touches).length > 0) obj = {
        x: touches[0].clientX - left2,
        y: touches[0].clientY - top2
    };
    return obj;
};
const $0abbbd36a260e067$var$checkBrowser = ()=>{
    let result = false;
    if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform) || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) result = true;
    return result;
};
const $0abbbd36a260e067$var$takeValue = (element2, isInput = true)=>{
    let valueInput;
    if (isInput) valueInput = element2.value.replace(/:/gi, " ");
    else valueInput = element2.replace(/:/gi, " ");
    return valueInput.split(" ");
};
const $0abbbd36a260e067$var$compareTimes = (time1, time2)=>{
    const [time1Hour, time1Minutes, time1maxTimeFormat] = $0abbbd36a260e067$var$takeValue(time1, false);
    const [time2Hour, time2Minutes, time2maxTimeFormat] = $0abbbd36a260e067$var$takeValue(time2, false);
    const bothFormatsEqual = time1maxTimeFormat == time2maxTimeFormat;
    if (time1maxTimeFormat == "PM" && time2maxTimeFormat == "AM") return 1;
    else if (time1maxTimeFormat == "AM" && time2maxTimeFormat == "PM") return 2;
    if (bothFormatsEqual && time1Hour > time2Hour) return 1;
    else if (time1Hour < time2Hour) return 2;
    if (time1Minutes > time2Minutes) return 1;
    else if (time1Minutes < time2Minutes) return 2;
};
const $0abbbd36a260e067$var$getCurrentTime = ()=>{
    const date = /* @__PURE__ */ new Date();
    const currentHours = date.getHours();
    let currentMinutes = String(date.getMinutes());
    if (currentMinutes.length === 1) currentMinutes = `0${currentMinutes}`;
    const currentTime = `${currentHours}:${currentMinutes}`;
    return currentTime;
};
const $0abbbd36a260e067$var$setMinTime = (minTime, disabledPast, format12)=>{
    if (!disabledPast) return minTime;
    let currentTime = $0abbbd36a260e067$var$getCurrentTime();
    if (format12) currentTime = `${$0abbbd36a260e067$var$formatToAmPm(currentTime).hours}:${$0abbbd36a260e067$var$formatToAmPm(currentTime).minutes} ${$0abbbd36a260e067$var$formatToAmPm(currentTime).amOrPm}`;
    if (minTime != "" && $0abbbd36a260e067$var$compareTimes(currentTime, minTime) == 1 || minTime === "") minTime = currentTime;
    return minTime;
};
const $0abbbd36a260e067$var$setMaxTime = (maxTime, disabledFuture, format12)=>{
    if (!disabledFuture) return maxTime;
    let currentTime = $0abbbd36a260e067$var$getCurrentTime();
    if (format12) currentTime = `${$0abbbd36a260e067$var$formatToAmPm(currentTime).hours}:${$0abbbd36a260e067$var$formatToAmPm(currentTime).minutes} ${$0abbbd36a260e067$var$formatToAmPm(currentTime).amOrPm}`;
    if (maxTime != "" && $0abbbd36a260e067$var$compareTimes(currentTime, maxTime) == 2 || maxTime === "") maxTime = currentTime;
    return maxTime;
};
const $0abbbd36a260e067$var$checkValueBeforeAccept = ({ format12: format12, maxTime: maxTime, minTime: minTime, disablePast: disablePast, disableFuture: disableFuture }, input, hourHeader, minutesHeader)=>{
    const minute = $0abbbd36a260e067$var$takeValue(input)[1];
    minTime = $0abbbd36a260e067$var$setMinTime(minTime, disablePast, format12);
    maxTime = $0abbbd36a260e067$var$setMaxTime(maxTime, disableFuture, format12);
    const [maxTimeHour, maxTimeMin, maxTimeFormat] = $0abbbd36a260e067$var$takeValue(maxTime, false);
    const [minTimeHour, minTimeMin, minTimeFormat] = $0abbbd36a260e067$var$takeValue(minTime, false);
    if (maxTimeFormat === void 0 && minTimeFormat === void 0) {
        if (maxTimeFormat === void 0) {
            if (maxTimeHour !== "" && minTimeHour === "") {
                if (Number(hourHeader) > Number(maxTimeHour)) return;
                if (maxTimeMin !== "" && minTimeMin === void 0) {
                    if (Number(hourHeader) > Number(maxTimeHour)) return;
                }
            } else if (maxTimeHour === "" && minTimeHour !== "") {
                if (maxTimeMin === void 0 && minTimeMin !== "") {
                    if (Number(hourHeader) < Number(minTimeHour) || Number(hourHeader) < Number(minTimeHour) && minutesHeader < Number(minTimeMin)) return;
                }
            }
        } else if (minTimeFormat === void 0) {
            if (maxTimeHour !== "" && minTimeHour === "") {
                if (Number(hourHeader) > Number(maxTimeHour)) return;
                if (maxTimeMin !== "" && minTimeMin === void 0) {
                    if (Number(hourHeader) > Number(maxTimeHour) || minutesHeader > Number(maxTimeMin)) return;
                }
            } else if (maxTimeHour === "" && minTimeHour !== "") {
                if (maxTimeMin === void 0 && minTimeMin !== "") {
                    if (Number(hourHeader) < Number(minTimeHour) || minutesHeader < Number(minTimeMin)) return;
                }
            }
        }
    }
    return [
        hourHeader,
        minute
    ];
};
const $0abbbd36a260e067$var$_verifyMaxTimeHourAndAddDisabledClass = (tips, maxTimeHour)=>{
    tips.forEach((tip)=>{
        if (tip.textContent === "00" || Number(tip.textContent) > maxTimeHour) $0abbbd36a260e067$var$Manipulator$1.addClass(tip, "disabled");
    });
};
const $0abbbd36a260e067$var$_verifyMinTimeHourAndAddDisabledClass = (tips, minTimeHour)=>{
    tips.forEach((tip)=>{
        if (tip.textContent !== "00" && Number(tip.textContent) < minTimeHour) $0abbbd36a260e067$var$Manipulator$1.addClass(tip, "disabled");
    });
};
const $0abbbd36a260e067$var$_verifyMaxTimeMinutesTipsAndAddDisabledClass = (tips, maxMinutes, maxHour, currHour)=>{
    tips.forEach((tip)=>{
        if (Number(tip.textContent) > maxMinutes && Number(currHour) == maxHour) $0abbbd36a260e067$var$Manipulator$1.addClass(tip, "disabled");
    });
};
const $0abbbd36a260e067$var$_verifyMinTimeMinutesTipsAndAddDisabledClass = (tips, minMinutes, minHour, currHour)=>{
    tips.forEach((tip)=>{
        if (Number(tip.textContent) < minMinutes && Number(currHour) == minHour) $0abbbd36a260e067$var$Manipulator$1.addClass(tip, "disabled");
    });
};
const $0abbbd36a260e067$var$_convertHourToNumber = (string)=>{
    let hour;
    if (string.startsWith("0")) hour = Number(string.slice(1));
    else hour = Number(string);
    return hour;
};
const $0abbbd36a260e067$var$NAME$q = "timepicker";
const $0abbbd36a260e067$var$DATA_KEY$k = `mdb.${$0abbbd36a260e067$var$NAME$q}`;
const $0abbbd36a260e067$var$EVENT_KEY$f = `.${$0abbbd36a260e067$var$DATA_KEY$k}`;
const $0abbbd36a260e067$var$DATA_API_KEY$1 = ".data-api";
const $0abbbd36a260e067$var$EVENT_CLOSE$4 = `close${$0abbbd36a260e067$var$EVENT_KEY$f}`;
const $0abbbd36a260e067$var$EVENT_OPEN$4 = `open${$0abbbd36a260e067$var$EVENT_KEY$f}`;
const $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$1 = `click${$0abbbd36a260e067$var$EVENT_KEY$f}${$0abbbd36a260e067$var$DATA_API_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_KEYDOWN_DATA_API = `keydown${$0abbbd36a260e067$var$EVENT_KEY$f}${$0abbbd36a260e067$var$DATA_API_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_MOUSEDOWN_DATA_API = `mousedown${$0abbbd36a260e067$var$EVENT_KEY$f}${$0abbbd36a260e067$var$DATA_API_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_MOUSEUP_DATA_API = `mouseup${$0abbbd36a260e067$var$EVENT_KEY$f}${$0abbbd36a260e067$var$DATA_API_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_MOUSEMOVE_DATA_API = `mousemove${$0abbbd36a260e067$var$EVENT_KEY$f}${$0abbbd36a260e067$var$DATA_API_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_MOUSELEAVE_DATA_API = `mouseleave${$0abbbd36a260e067$var$EVENT_KEY$f}${$0abbbd36a260e067$var$DATA_API_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_MOUSEOVER_DATA_API = `mouseover${$0abbbd36a260e067$var$EVENT_KEY$f}${$0abbbd36a260e067$var$DATA_API_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_TOUCHMOVE_DATA_API = `touchmove${$0abbbd36a260e067$var$EVENT_KEY$f}${$0abbbd36a260e067$var$DATA_API_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_TOUCHEND_DATA_API = `touchend${$0abbbd36a260e067$var$EVENT_KEY$f}${$0abbbd36a260e067$var$DATA_API_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_TOUCHSTART_DATA_API = `touchstart${$0abbbd36a260e067$var$EVENT_KEY$f}${$0abbbd36a260e067$var$DATA_API_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_VALUE_CHANGED$4 = `valueChanged${$0abbbd36a260e067$var$EVENT_KEY$f}`;
const $0abbbd36a260e067$var$EVENT_CLEAR = `clear${$0abbbd36a260e067$var$EVENT_KEY$f}`;
const $0abbbd36a260e067$var$ACTIVE_CLASS$1 = "active";
const $0abbbd36a260e067$var$AM_CLASS = `${$0abbbd36a260e067$var$NAME$q}-am`;
const $0abbbd36a260e067$var$BUTTON_CANCEL_CLASS = `${$0abbbd36a260e067$var$NAME$q}-cancel`;
const $0abbbd36a260e067$var$BUTTON_CLEAR_CLASS = `${$0abbbd36a260e067$var$NAME$q}-clear`;
const $0abbbd36a260e067$var$BUTTON_SUBMIT_CLASS = `${$0abbbd36a260e067$var$NAME$q}-submit`;
const $0abbbd36a260e067$var$CIRCLE_CLASS = `${$0abbbd36a260e067$var$NAME$q}-circle`;
const $0abbbd36a260e067$var$CLOCK_ANIMATION_CLASS = `${$0abbbd36a260e067$var$NAME$q}-clock-animation`;
const $0abbbd36a260e067$var$CLOCK_CLASS = `${$0abbbd36a260e067$var$NAME$q}-clock`;
const $0abbbd36a260e067$var$CLOCK_INNER_CLASS = `${$0abbbd36a260e067$var$NAME$q}-clock-inner`;
const $0abbbd36a260e067$var$CLOCK_WRAPPER_CLASS = `${$0abbbd36a260e067$var$NAME$q}-clock-wrapper`;
const $0abbbd36a260e067$var$CURRENT_CLASS = `.${$0abbbd36a260e067$var$NAME$q}-current`;
const $0abbbd36a260e067$var$CURRENT_INLINE_CLASS = `${$0abbbd36a260e067$var$NAME$q}-current-inline`;
const $0abbbd36a260e067$var$WRAPPER_OPEN_ANIMATION_CLASS = "fade-in";
const $0abbbd36a260e067$var$WRAPPER_CLOSE_ANIMATION_CLASS = "fade-out";
const $0abbbd36a260e067$var$HAND_CLASS = `${$0abbbd36a260e067$var$NAME$q}-hand-pointer`;
const $0abbbd36a260e067$var$HOUR_CLASS = `${$0abbbd36a260e067$var$NAME$q}-hour`;
const $0abbbd36a260e067$var$HOUR_MODE_CLASS = `${$0abbbd36a260e067$var$NAME$q}-hour-mode`;
const $0abbbd36a260e067$var$ICON_DOWN_CLASS = `${$0abbbd36a260e067$var$NAME$q}-icon-down`;
const $0abbbd36a260e067$var$ICON_INLINE_HOUR_CLASS = `${$0abbbd36a260e067$var$NAME$q}-icon-inline-hour`;
const $0abbbd36a260e067$var$ICON_INLINE_MINUTE_CLASS = `${$0abbbd36a260e067$var$NAME$q}-icon-inline-minute`;
const $0abbbd36a260e067$var$ICON_UP_CLASS = `${$0abbbd36a260e067$var$NAME$q}-icon-up`;
const $0abbbd36a260e067$var$ICONS_HOUR_INLINE = `${$0abbbd36a260e067$var$NAME$q}-inline-hour-icons`;
const $0abbbd36a260e067$var$MIDDLE_DOT_CLASS = `${$0abbbd36a260e067$var$NAME$q}-middle-dot`;
const $0abbbd36a260e067$var$MINUTE_CLASS = `${$0abbbd36a260e067$var$NAME$q}-minute`;
const $0abbbd36a260e067$var$MODAL_CLASS$1 = `${$0abbbd36a260e067$var$NAME$q}-modal`;
const $0abbbd36a260e067$var$PM_CLASS = `${$0abbbd36a260e067$var$NAME$q}-pm`;
const $0abbbd36a260e067$var$TIPS_ELEMENT_CLASS = `${$0abbbd36a260e067$var$NAME$q}-tips-element`;
const $0abbbd36a260e067$var$TIPS_HOURS_CLASS = `${$0abbbd36a260e067$var$NAME$q}-time-tips-hours`;
const $0abbbd36a260e067$var$TIPS_INNER_ELEMENT_CLASS = `${$0abbbd36a260e067$var$NAME$q}-tips-inner-element`;
const $0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS = `${$0abbbd36a260e067$var$NAME$q}-time-tips-inner`;
const $0abbbd36a260e067$var$TIPS_MINUTES_CLASS = `${$0abbbd36a260e067$var$NAME$q}-time-tips-minutes`;
const $0abbbd36a260e067$var$TRANSFORM_CLASS = `${$0abbbd36a260e067$var$NAME$q}-transform`;
const $0abbbd36a260e067$var$WRAPPER_CLASS = `${$0abbbd36a260e067$var$NAME$q}-wrapper`;
const $0abbbd36a260e067$var$INPUT_CLASS = `${$0abbbd36a260e067$var$NAME$q}-input`;
const $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$2 = "[data-mdb-toggle]";
const $0abbbd36a260e067$var$SELECTOR_CONTAINER = ".timepicker-container";
const $0abbbd36a260e067$var$Default$h = {
    bodyId: "",
    cancelLabel: "Cancel",
    clearLabel: "Clear",
    closeModalOnBackdropClick: true,
    closeModalOnMinutesClick: false,
    container: "body",
    defaultTime: "",
    disablePast: false,
    disableFuture: false,
    focusInputAfterApprove: false,
    footerId: "",
    format12: true,
    format24: false,
    headId: "",
    increment: false,
    inline: false,
    maxTime: "",
    minTime: "",
    modalId: "",
    okLabel: "Ok",
    overflowHidden: true,
    pickerId: "",
    readOnly: false,
    showClearBtn: true,
    switchHoursToMinutesOnClick: true,
    iconClass: "far fa-clock fa-sm timepicker-icon",
    withIcon: true,
    pmLabel: "PM",
    amLabel: "AM",
    animations: true
};
const $0abbbd36a260e067$var$DefaultType$h = {
    bodyId: "string",
    cancelLabel: "string",
    clearLabel: "string",
    closeModalOnBackdropClick: "boolean",
    closeModalOnMinutesClick: "boolean",
    container: "string",
    disablePast: "boolean",
    disableFuture: "boolean",
    footerId: "string",
    format12: "boolean",
    format24: "boolean",
    headId: "string",
    increment: "boolean",
    inline: "boolean",
    maxTime: "(string|date|null)",
    minTime: "(string|date|null)",
    modalId: "string",
    okLabel: "string",
    overflowHidden: "boolean",
    pickerId: "string",
    readOnly: "boolean",
    showClearBtn: "boolean",
    switchHoursToMinutesOnClick: "boolean",
    defaultTime: "(string|date|number)",
    iconClass: "string",
    withIcon: "boolean",
    pmLabel: "string",
    amLabel: "string",
    animations: "boolean"
};
class $0abbbd36a260e067$export$8497164ca5dbf597 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options = {}){
        super(element2);
        $0abbbd36a260e067$var$__publicField(this, "_toggleAmPm", (enabled)=>{
            if (enabled == "PM") {
                this._isPmEnabled = true;
                this._isAmEnabled = false;
            } else if (enabled == "AM") {
                this._isPmEnabled = false;
                this._isAmEnabled = true;
            }
        });
        $0abbbd36a260e067$var$__publicField(this, "_toggleBackgroundColorCircle", (classes)=>{
            const tips = this._modal.querySelector(`.${classes}.${$0abbbd36a260e067$var$ACTIVE_CLASS$1}`) !== null;
            if (tips) {
                $0abbbd36a260e067$var$Manipulator$1.addClass(this._circle, "active");
                return;
            }
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this._circle, "active");
        });
        $0abbbd36a260e067$var$__publicField(this, "_toggleClassActive", (array2, { textContent: textContent }, tips)=>{
            const findInArray = [
                ...array2
            ].find((e)=>Number(e) === Number(textContent));
            return tips.forEach((e)=>{
                if (!$0abbbd36a260e067$var$Manipulator$1.hasClass(e, "disabled")) {
                    if (e.textContent === findInArray) $0abbbd36a260e067$var$Manipulator$1.addClass(e, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
                    else $0abbbd36a260e067$var$Manipulator$1.removeClass(e, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
                }
            });
        });
        $0abbbd36a260e067$var$__publicField(this, "_makeMinutesDegrees", (degrees, minute)=>{
            const { increment: increment } = this._options;
            if (degrees < 0) {
                minute = Math.round(360 + degrees / 6) % 60;
                degrees = 360 + Math.round(degrees / 6) * 6;
            } else {
                minute = Math.round(degrees / 6) % 60;
                degrees = Math.round(degrees / 6) * 6;
            }
            if (increment) {
                degrees = Math.round(degrees / 30) * 30;
                minute = Math.round(degrees / 6) * 6 / 6;
                if (minute === 60) minute = "00";
            }
            if (degrees >= 360) degrees = 0;
            return {
                degrees: degrees,
                minute: minute,
                addDegrees: increment ? 30 : 6
            };
        });
        $0abbbd36a260e067$var$__publicField(this, "_makeHourDegrees", (target, degrees, hour)=>{
            if (!target) return;
            if (this._hasTargetInnerClass(target)) {
                if (degrees < 0) {
                    hour = Math.round(360 + degrees / 30) % 24;
                    degrees = 360 + degrees;
                } else {
                    hour = Math.round(degrees / 30) + 12;
                    if (hour === 12) hour = "00";
                }
            } else if (degrees < 0) {
                hour = Math.round(360 + degrees / 30) % 12;
                degrees = 360 + degrees;
            } else {
                hour = Math.round(degrees / 30) % 12;
                if (hour === 0 || hour > 12) hour = 12;
            }
            if (degrees >= 360) degrees = 0;
            return {
                degrees: degrees,
                hour: hour,
                addDegrees: 30
            };
        });
        $0abbbd36a260e067$var$__publicField(this, "_makeInnerHoursDegrees", (degrees, hour)=>{
            if (degrees < 0) {
                hour = Math.round(360 + degrees / 30) % 24;
                degrees = 360 + degrees;
            } else {
                hour = Math.round(degrees / 30) + 12;
                if (hour === 12) hour = "00";
            }
            return {
                degrees: degrees,
                hour: hour,
                addDegrees: 30
            };
        });
        $0abbbd36a260e067$var$__publicField(this, "_getAppendClock", (array2 = [], clockClass = `.${$0abbbd36a260e067$var$CLOCK_CLASS}`, tipsClass)=>{
            let { minTime: minTime, maxTime: maxTime } = this._options;
            const { inline: inline, format12: format12, disablePast: disablePast, disableFuture: disableFuture } = this._options;
            minTime = $0abbbd36a260e067$var$setMinTime(minTime, disablePast, format12);
            maxTime = $0abbbd36a260e067$var$setMaxTime(maxTime, disableFuture, format12);
            const [maxTimeHour, maxTimeMinutes, maxTimeFormat] = $0abbbd36a260e067$var$takeValue(maxTime, false);
            const [minTimeHour, minTimeMinutes, minTimeFormat] = $0abbbd36a260e067$var$takeValue(minTime, false);
            if (!inline) {
                if (format12) {
                    if (this._isInvalidTimeFormat && !$0abbbd36a260e067$var$Manipulator$1.hasClass(this._AM, "active")) $0abbbd36a260e067$var$Manipulator$1.addClass(this._PM, "active");
                }
            }
            const clock = $0abbbd36a260e067$var$SelectorEngine$1.findOne(clockClass);
            const elements = 360 / array2.length;
            function rad(el) {
                return el * (Math.PI / 180);
            }
            if (clock === null) return;
            const clockWidth = (clock.offsetWidth - 32) / 2;
            const clockHeight = (clock.offsetHeight - 32) / 2;
            const radius = clockWidth - 4;
            setTimeout(()=>{
                let currentFormat;
                if (format12) currentFormat = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HOUR_MODE_CLASS}.${$0abbbd36a260e067$var$ACTIVE_CLASS$1}`).textContent;
                this._handleDisablingTipsMinTime(currentFormat, minTimeFormat, minTimeMinutes, minTimeHour);
                this._handleDisablingTipsMaxTime(currentFormat, maxTimeFormat, maxTimeMinutes, maxTimeHour);
            }, 0);
            [
                ...array2
            ].forEach((e, i)=>{
                const angle = rad(i * elements);
                const span = $0abbbd36a260e067$var$element("span");
                const spanToTips = $0abbbd36a260e067$var$element("span");
                spanToTips.innerHTML = e;
                $0abbbd36a260e067$var$Manipulator$1.addClass(span, tipsClass);
                const itemWidth = span.offsetWidth;
                const itemHeight = span.offsetHeight;
                $0abbbd36a260e067$var$Manipulator$1.addStyle(span, {
                    left: `${clockWidth + Math.sin(angle) * radius - itemWidth}px`,
                    bottom: `${clockHeight + Math.cos(angle) * radius - itemHeight}px`
                });
                if (array2.includes("05")) $0abbbd36a260e067$var$Manipulator$1.addClass(span, `${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`);
                if (array2.includes("13")) spanToTips.classList.add($0abbbd36a260e067$var$TIPS_INNER_ELEMENT_CLASS);
                else spanToTips.classList.add($0abbbd36a260e067$var$TIPS_ELEMENT_CLASS);
                span.appendChild(spanToTips);
                return clock.appendChild(span);
            });
        });
        this._document = document;
        this._options = this._getConfig(options);
        this._currentTime = null;
        this._toggleButtonId = this._element.id ? `timepicker-toggle-${this._element.id}` : $0abbbd36a260e067$var$getUID$1("timepicker-toggle-");
        this.hoursArray = [
            "12",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11"
        ];
        this.innerHours = [
            "00",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23"
        ];
        this.minutesArray = [
            "00",
            "05",
            "10",
            "15",
            "20",
            "25",
            "30",
            "35",
            "40",
            "45",
            "50",
            "55"
        ];
        this._input = $0abbbd36a260e067$var$SelectorEngine$1.findOne("input", this._element);
        this._hour = null;
        this._minutes = null;
        this._AM = null;
        this._PM = null;
        this._wrapper = null;
        this._modal = null;
        this._hand = null;
        this._circle = null;
        this._focusTrap = null;
        this._isOpen = false;
        this._popper = null;
        this._interval = null;
        this._timeoutInterval = null;
        this._inputValue = this._options.defaultTime !== "" ? this._options.defaultTime : this._input.value;
        if (this._options.format24) {
            this._options.format12 = false;
            this._currentTime = $0abbbd36a260e067$var$formatNormalHours(this._inputValue);
        }
        if (this._options.format12) {
            this._options.format24 = false;
            this._currentTime = $0abbbd36a260e067$var$formatToAmPm(this._inputValue);
        }
        if (this._options.readOnly) this._input.setAttribute("readonly", true);
        this._scrollBar = new $0abbbd36a260e067$var$ScrollBarHelper();
        this._animations = !window.matchMedia("(prefers-reduced-motion: reduce)").matches && this._options.animations;
        this.init();
        this._isHours = true;
        this._isMinutes = false;
        this._isInvalidTimeFormat = false;
        this._isMouseMove = false;
        this._isInner = false;
        this._isAmEnabled = false;
        this._isPmEnabled = false;
        if (this._options.format12 && !this._options.defaultTime) this._isPmEnabled = true;
        this._objWithDataOnChange = {
            degrees: null
        };
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$q;
    }
    get container() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$SELECTOR_CONTAINER}-${this._toggleButtonId}`);
    }
    get toggleButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne("[data-mdb-toggle]", this._element);
    }
    get customIcon() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(".timepicker-toggle-button", this._element);
    }
    // Public
    init() {
        if (!this.toggleButton && !this.customIcon && this._options.withIcon) this._appendToggleButton(this._options);
        const { format12: format12, format24: format24 } = this._options;
        let zero;
        let hoursFormat;
        let _amOrPm;
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._input, $0abbbd36a260e067$var$INPUT_CLASS);
        if (this._currentTime !== void 0) {
            const { hours: hours, minutes: minutes, amOrPm: amOrPm } = this._currentTime;
            zero = Number(hours) < 10 ? 0 : "";
            hoursFormat = `${zero}${Number(hours)}:${minutes}`;
            _amOrPm = amOrPm;
            if (format12) this._input.value = `${hoursFormat} ${_amOrPm}`;
            else if (format24) this._input.value = `${hoursFormat}`;
        } else {
            zero = "";
            hoursFormat = "";
            _amOrPm = "";
            this._input.value = "";
        }
        if (this._input.value.length > 0 && this._input.value !== "") $0abbbd36a260e067$var$Manipulator$1.addClass(this._input, "active");
        if (this._options !== null || this._element !== null) {
            this._listenToUserInput();
            this._handleOpen();
            this._listenToToggleKeydown();
        }
    }
    dispose() {
        if (this._isOpen) this.close();
        this._removeInputAndToggleListeners();
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        setTimeout(()=>{
            super.dispose();
        }, 355);
    }
    update(options = {}) {
        this._options = this._getConfig({
            ...this._options,
            ...options
        });
    }
    close() {
        const closeEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CLOSE$4);
        if (!this._isOpen || closeEvent.defaultPrevented) return;
        this._removePicker();
        this._isOpen = false;
        if (this.toggleButton) this.toggleButton.focus();
        else if (this._input && focusInputAfterApprove) this._input.focus();
    }
    open() {
        if (this._input.readOnly || this._input.disabled) return;
        const openEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_OPEN$4);
        if (this._isOpen || openEvent.defaultPrevented) return;
        const container = this._getContainer();
        $0abbbd36a260e067$var$Manipulator$1.addStyle(this.toggleButton, {
            pointerEvents: "none"
        });
        let checkInputValue;
        if ($0abbbd36a260e067$var$takeValue(this._input)[0] === "" || this._isInvalidTimeFormat) checkInputValue = [
            "12",
            "00",
            "PM"
        ];
        else checkInputValue = $0abbbd36a260e067$var$takeValue(this._input);
        const { modalId: modalId, inline: inline, format12: format12 } = this._options;
        const [hour, minute, format] = checkInputValue;
        const div2 = $0abbbd36a260e067$var$element("div");
        if (Number(hour) > 12 || hour === "00") this._isInner = true;
        div2.innerHTML = $0abbbd36a260e067$var$getTimepickerTemplate(this._options, this._toggleButtonId);
        $0abbbd36a260e067$var$Manipulator$1.addClass(div2, $0abbbd36a260e067$var$MODAL_CLASS$1);
        $0abbbd36a260e067$var$Manipulator$1.addClass(div2, `${$0abbbd36a260e067$var$MODAL_CLASS$1}-${this._toggleButtonId}`);
        div2.setAttribute("role", "dialog");
        div2.setAttribute("tabIndex", "-1");
        div2.setAttribute("id", modalId);
        if (!inline) {
            container.appendChild(div2);
            this._scrollBar.hide();
        } else {
            this._popper = $0abbbd36a260e067$var$createPopper(this._input, div2, {
                placement: "bottom-start"
            });
            container.appendChild(div2);
        }
        this._getDomElements();
        if (this._animations) this._toggleBackdropAnimation();
        else $0abbbd36a260e067$var$Manipulator$1.addClass(this._wrapper, "opacity-100");
        this._appendTimes();
        this._setActiveClassToTipsOnOpen(hour, minute, format);
        this._setTipsAndTimesDependOnInputValue(hour, minute);
        if (this._input.value === "") {
            const allTipsHours = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`, this._modal);
            if (format12) $0abbbd36a260e067$var$Manipulator$1.addClass(this._PM, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
            this._hour.textContent = "12";
            this._minutes.textContent = "00";
            this._addActiveClassToTip(allTipsHours, Number(this._hour.textContent));
        }
        this._handleSwitchTimeMode();
        this._handleOkButton();
        this._handleClose();
        if (inline) {
            this._handleHoverInlineBtn();
            this._handleDocumentClickInline();
            this._handleInlineClicks();
        } else {
            this._handleSwitchHourMinute();
            this._handleClockClick();
            this._handleKeyboard();
            $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hour, {
                pointerEvents: "none"
            });
            $0abbbd36a260e067$var$Manipulator$1.addStyle(this._minutes, {
                pointerEvents: ""
            });
        }
        this._setFocusTrap(this.container);
        this._isOpen = true;
    }
    // private
    _removeInputAndToggleListeners() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._input, "input");
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$1, $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$2);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "keydown", $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$2);
    }
    _appendToggleButton() {
        const toggleButton = $0abbbd36a260e067$var$getToggleButtonTemplate$1(this._options, this._toggleButtonId);
        this._input.insertAdjacentHTML("afterend", toggleButton);
    }
    _getDomElements() {
        this._modal = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$MODAL_CLASS$1}-${this._toggleButtonId}`);
        this._hour = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HOUR_CLASS}`, this._modal);
        this._minutes = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$MINUTE_CLASS}`, this._modal);
        this._AM = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$AM_CLASS}`, this._modal);
        this._PM = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$PM_CLASS}`, this._modal);
        this._wrapper = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$WRAPPER_CLASS}`, this._modal);
        this._hand = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HAND_CLASS}`, this._modal);
        this._circle = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CIRCLE_CLASS}`, this._modal);
        this._clock = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CLOCK_CLASS}`, this._modal);
        this._clockInner = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CLOCK_INNER_CLASS}`, this._modal);
    }
    _handlerMaxMinHoursOptions(degrees, maxHour, minHour, maxFormat, minFormat, e) {
        if (!maxHour && !minHour) return true;
        const { format24: format24, format12: format12, disablePast: disablePast, disableFuture: disableFuture } = this._options;
        const { _isAmEnabled: _isAmEnabled, _isPmEnabled: _isPmEnabled } = this;
        const key = e.keyCode;
        const _isMouseOnInnerClock = e.target.classList.contains("timepicker-clock-inner") || e.target.classList.contains("timepicker-time-tips-inner") || e.target.classList.contains("timepicker-tips-inner-element");
        minHour = $0abbbd36a260e067$var$setMinTime(minHour, disablePast, format12);
        maxHour = $0abbbd36a260e067$var$setMaxTime(maxHour, disableFuture, format12);
        let maxHourDegrees = maxHour !== "" ? maxHour * 30 : "";
        let minHourDegrees = minHour !== "" ? minHour * 30 : "";
        if (degrees <= 0) degrees = 360 + degrees;
        const _handleKeyboardEvents = ()=>{
            const tips = document.querySelectorAll(".timepicker-tips-element");
            const innerTips = document.querySelectorAll(".timepicker-tips-inner-element");
            let currentHour = $0abbbd36a260e067$var$_convertHourToNumber(this._hour.innerText);
            let nextHourTip;
            let numberToAdd;
            let nextHour;
            if (key === $0abbbd36a260e067$var$UP_ARROW) numberToAdd = 1;
            else if (key === $0abbbd36a260e067$var$DOWN_ARROW) numberToAdd = -1;
            if (currentHour === 12 && key === $0abbbd36a260e067$var$UP_ARROW) nextHour = 1;
            else if (currentHour === 0 && key === $0abbbd36a260e067$var$UP_ARROW) nextHour = 13;
            else if (currentHour === 0 && key === $0abbbd36a260e067$var$DOWN_ARROW) nextHour = 23;
            else if (currentHour === 13 && key === $0abbbd36a260e067$var$DOWN_ARROW) nextHour = 0;
            else if (currentHour === 1 && key === $0abbbd36a260e067$var$DOWN_ARROW) nextHour = 12;
            else nextHour = currentHour + numberToAdd;
            tips.forEach((tip)=>{
                if (tip.textContent == nextHour) nextHourTip = tip;
            });
            innerTips.forEach((innerTip)=>{
                if (innerTip.textContent == nextHour) nextHourTip = innerTip;
            });
            return !nextHourTip.parentElement.classList.contains("disabled");
        };
        const _handle24FormatMouseEvents = ()=>{
            let minInnerHourDegrees = minHour !== "" && minHour > 12 ? (minHour - 12) * 30 : "";
            let maxInnerHourDegrees = maxHour !== "" && maxHour > 12 ? (maxHour - 12) * 30 : "";
            if (minInnerHourDegrees && degrees < minInnerHourDegrees || maxInnerHourDegrees && degrees > maxInnerHourDegrees || maxHour && maxHour < 12) return;
            return true;
        };
        if (format24 && e.type !== "keydown" && _isMouseOnInnerClock) return _handle24FormatMouseEvents();
        if (e.type === "keydown") return _handleKeyboardEvents();
        const minFormatAndCurrentFormatEqual = !minFormat || minFormat === "PM" && _isPmEnabled || minHour !== "" && minFormat === "AM" && _isAmEnabled;
        const maxFormatAndCurrentFormatEqual = !maxFormat || maxFormat === "PM" && _isPmEnabled || maxHour !== "" && maxFormat === "AM" && _isAmEnabled;
        const isMinHourValid = ()=>{
            if (!minHour) return true;
            else if (minFormat === "PM" && _isAmEnabled || minFormatAndCurrentFormatEqual && degrees < minHourDegrees) return;
            return true;
        };
        const isMaxHourValid = ()=>{
            if (!maxHour) return true;
            else if (maxFormat === "AM" && _isPmEnabled || maxFormatAndCurrentFormatEqual && degrees > maxHourDegrees) return;
            return true;
        };
        if (isMinHourValid() && isMaxHourValid()) return true;
    }
    _handleKeyboard() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._document, $0abbbd36a260e067$var$EVENT_KEYDOWN_DATA_API, "", (e)=>{
            let hour;
            let minute;
            let innerHour;
            let { increment: increment, maxTime: maxTime, minTime: minTime, format12: format12, disablePast: disablePast, disableFuture: disableFuture } = this._options;
            let [minHour, minFormat] = $0abbbd36a260e067$var$takeValue(minTime, false);
            let [maxHour, maxFormat] = $0abbbd36a260e067$var$takeValue(maxTime, false);
            minHour = $0abbbd36a260e067$var$setMinTime(minHour, disablePast, format12);
            maxHour = $0abbbd36a260e067$var$setMaxTime(maxHour, disableFuture, format12);
            const hoursView = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`) === null;
            const innerHoursExist = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS}`) !== null;
            const degrees = Number(this._hand.style.transform.replace(/[^\d-]/g, ""));
            const allTipsMinutes = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`, this._modal);
            const allTipsHours = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`, this._modal);
            const allInnerTips = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS}`, this._modal);
            let hourTime = this._makeHourDegrees(e.target, degrees, hour).hour;
            const { degrees: hourObjDegrees, addDegrees: addDegrees } = this._makeHourDegrees(e.target, degrees, hour);
            let { minute: minHourMinutes, degrees: minObjDegrees } = this._makeMinutesDegrees(degrees, minute);
            const addMinDegrees = this._makeMinutesDegrees(degrees, minute).addDegrees;
            let { hour: innerHourDegrees } = this._makeInnerHoursDegrees(degrees, innerHour);
            if (e.keyCode === $0abbbd36a260e067$var$ESCAPE) {
                const cancelBtn = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$BUTTON_CANCEL_CLASS}`, this._modal);
                $0abbbd36a260e067$var$EventHandler$1.trigger(cancelBtn, "click");
            } else if (hoursView) {
                if (innerHoursExist) {
                    if (e.keyCode === $0abbbd36a260e067$var$RIGHT_ARROW) {
                        this._isInner = false;
                        $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                            height: "calc(40% + 1px)"
                        });
                        this._hour.textContent = this._setHourOrMinute(hourTime > 12 ? 1 : hourTime);
                        this._toggleClassActive(this.hoursArray, this._hour, allTipsHours);
                        this._toggleClassActive(this.innerHours, this._hour, allInnerTips);
                    }
                    if (e.keyCode === $0abbbd36a260e067$var$LEFT_ARROW) {
                        this._isInner = true;
                        $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                            height: "21.5%"
                        });
                        this._hour.textContent = this._setHourOrMinute(innerHourDegrees >= 24 || innerHourDegrees === "00" ? 0 : innerHourDegrees);
                        this._toggleClassActive(this.innerHours, this._hour, allInnerTips);
                        this._toggleClassActive(this.hoursArray, this._hour - 1, allTipsHours);
                    }
                }
                if (e.keyCode === $0abbbd36a260e067$var$UP_ARROW) {
                    const isNextHourValid = this._handlerMaxMinHoursOptions(hourObjDegrees + 30, maxHour, minHour, maxFormat, minFormat, e);
                    if (!isNextHourValid) return;
                    const addRotate = ()=>{
                        return $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                            transform: `rotateZ(${hourObjDegrees + addDegrees}deg)`
                        });
                    };
                    addRotate();
                    if (this._isInner) {
                        innerHourDegrees += 1;
                        if (innerHourDegrees === 24) innerHourDegrees = 0;
                        else if (innerHourDegrees === 25 || innerHourDegrees === "001") innerHourDegrees = 13;
                        this._hour.textContent = this._setHourOrMinute(innerHourDegrees);
                        this._toggleClassActive(this.innerHours, this._hour, allInnerTips);
                    } else {
                        hourTime += 1;
                        this._hour.textContent = this._setHourOrMinute(hourTime > 12 ? 1 : hourTime);
                        this._toggleClassActive(this.hoursArray, this._hour, allTipsHours);
                    }
                }
                if (e.keyCode === $0abbbd36a260e067$var$DOWN_ARROW) {
                    const isNextHourValid = this._handlerMaxMinHoursOptions(hourObjDegrees - 30, maxHour, minHour, maxFormat, minFormat, e);
                    if (!isNextHourValid) return;
                    const addRotate = ()=>{
                        return $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                            transform: `rotateZ(${hourObjDegrees - addDegrees}deg)`
                        });
                    };
                    addRotate();
                    if (this._isInner) {
                        innerHourDegrees -= 1;
                        if (innerHourDegrees === 12) innerHourDegrees = 0;
                        else if (innerHourDegrees === -1) innerHourDegrees = 23;
                        this._hour.textContent = this._setHourOrMinute(innerHourDegrees);
                        this._toggleClassActive(this.innerHours, this._hour, allInnerTips);
                    } else {
                        hourTime -= 1;
                        this._hour.textContent = this._setHourOrMinute(hourTime === 0 ? 12 : hourTime);
                        this._toggleClassActive(this.hoursArray, this._hour, allTipsHours);
                    }
                }
            } else {
                if (e.keyCode === $0abbbd36a260e067$var$UP_ARROW) {
                    minObjDegrees += addMinDegrees;
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                        transform: `rotateZ(${minObjDegrees}deg)`
                    });
                    minHourMinutes += 1;
                    if (increment) {
                        minHourMinutes += 4;
                        if (minHourMinutes === "0014") minHourMinutes = 5;
                    }
                    this._minutes.textContent = this._setHourOrMinute(minHourMinutes > 59 ? 0 : minHourMinutes);
                    this._toggleClassActive(this.minutesArray, this._minutes, allTipsMinutes);
                    this._toggleBackgroundColorCircle(`${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`);
                }
                if (e.keyCode === $0abbbd36a260e067$var$DOWN_ARROW) {
                    minObjDegrees -= addMinDegrees;
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                        transform: `rotateZ(${minObjDegrees}deg)`
                    });
                    if (increment) minHourMinutes -= 5;
                    else minHourMinutes -= 1;
                    if (minHourMinutes === -1) minHourMinutes = 59;
                    else if (minHourMinutes === -5) minHourMinutes = 55;
                    this._minutes.textContent = this._setHourOrMinute(minHourMinutes);
                    this._toggleClassActive(this.minutesArray, this._minutes, allTipsMinutes);
                    this._toggleBackgroundColorCircle(`${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`);
                }
            }
        });
    }
    _setActiveClassToTipsOnOpen(hour, ...rest) {
        if (this._isInvalidTimeFormat) return;
        if (!this._options.format24) {
            [
                ...rest
            ].filter((e)=>{
                if (e.toLowerCase() === "pm") $0abbbd36a260e067$var$Manipulator$1.addClass(this._PM, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
                else if (e.toLowerCase() === "am") $0abbbd36a260e067$var$Manipulator$1.addClass(this._AM, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
                else {
                    $0abbbd36a260e067$var$Manipulator$1.removeClass(this._AM, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
                    $0abbbd36a260e067$var$Manipulator$1.removeClass(this._PM, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
                }
                return e;
            });
            const allTipsHours = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`, this._modal);
            this._addActiveClassToTip(allTipsHours, hour);
        } else {
            const allTipsHours = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`, this._modal);
            const allInnerTips = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS}`, this._modal);
            this._addActiveClassToTip(allTipsHours, hour);
            this._addActiveClassToTip(allInnerTips, hour);
        }
    }
    _setTipsAndTimesDependOnInputValue(hour, minute) {
        const { inline: inline, format12: format12 } = this._options;
        if (!this._isInvalidTimeFormat) {
            const rotateDegrees = hour > 12 ? hour * 30 - 360 : hour * 30;
            this._hour.textContent = hour;
            this._minutes.textContent = minute;
            if (!inline) {
                $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                    transform: `rotateZ(${rotateDegrees}deg)`
                });
                $0abbbd36a260e067$var$Manipulator$1.addClass(this._circle, "active");
                if (Number(hour) > 12 || hour === "00") $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                    height: "21.5%"
                });
            }
        } else {
            this._hour.textContent = "12";
            this._minutes.textContent = "00";
            if (!inline) $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                transform: "rotateZ(0deg)"
            });
            if (format12) $0abbbd36a260e067$var$Manipulator$1.addClass(this._PM, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
        }
    }
    _listenToToggleKeydown() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "keydown", $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$2, (e)=>{
            if (e.keyCode === $0abbbd36a260e067$var$ENTER) this.open();
        });
    }
    _handleOpen() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$1, $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$2, ()=>{
            if (this._options === null) return;
            const fixForInput = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(this._input, "toggle") !== null ? 200 : 0;
            setTimeout(()=>{
                this.open();
            }, fixForInput);
        });
    }
    _setFocusTrap(element2) {
        this._focusTrap = new $0abbbd36a260e067$var$FocusTrap2(element2, {
            event: "keydown",
            condition: (event)=>event.key === "Tab"
        });
        this._focusTrap.trap();
    }
    _handleInlineClicks() {
        let selectedHour;
        let minuteNumber;
        const countMinutes = (count)=>{
            let minutes = count;
            if (minutes > 59) minutes = 0;
            else if (minutes < 0) minutes = 59;
            return minutes;
        };
        const countHours = (count)=>{
            let hour = count;
            if (this._options.format24) {
                if (hour > 24) hour = 1;
                else if (hour < 0) hour = 23;
                if (hour > 23) hour = 0;
            } else {
                if (hour > 12) hour = 1;
                else if (hour < 1) hour = 12;
                if (hour > 12) hour = 1;
            }
            return hour;
        };
        const incrementHours = (hour)=>{
            const counteredNumber = countHours(hour);
            this._hour.textContent = this._setHourOrMinute(counteredNumber);
        };
        const incrementMinutes = (minutes)=>{
            const counteredNumber = countMinutes(minutes);
            this._minutes.textContent = this._setHourOrMinute(counteredNumber);
        };
        const addHours = ()=>{
            selectedHour = countHours(selectedHour) + 1;
            incrementHours(selectedHour);
        };
        const addMinutes = ()=>{
            minuteNumber = countMinutes(minuteNumber) + 1;
            incrementMinutes(minuteNumber);
        };
        const subHours = ()=>{
            selectedHour = countHours(selectedHour) - 1;
            incrementHours(selectedHour);
        };
        const subMinutes = ()=>{
            minuteNumber = countMinutes(minuteNumber) - 1;
            incrementMinutes(minuteNumber);
        };
        const _clearAsyncs = ()=>{
            clearInterval(this._interval);
            clearTimeout(this._timeoutInterval);
        };
        const _clearAndSetThisInterval = (addHoursOrAddMinutes)=>{
            _clearAsyncs();
            this._timeoutInterval = setTimeout(()=>{
                this._interval = setInterval(addHoursOrAddMinutes, 100);
            }, 500);
        };
        $0abbbd36a260e067$var$EventHandlerMulti.on(this._modal, "click mousedown mouseup touchstart touchend contextmenu", `.${$0abbbd36a260e067$var$ICON_UP_CLASS}, .${$0abbbd36a260e067$var$ICON_DOWN_CLASS}`, (e)=>{
            selectedHour = Number(this._hour.textContent);
            minuteNumber = Number(this._minutes.textContent);
            const { target: target, type: type } = e;
            const isEventTypeMousedownOrTouchstart = type === "mousedown" || type === "touchstart";
            if ($0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$ICON_UP_CLASS)) {
                if ($0abbbd36a260e067$var$Manipulator$1.hasClass(target.parentNode, $0abbbd36a260e067$var$ICONS_HOUR_INLINE)) {
                    if (isEventTypeMousedownOrTouchstart) _clearAndSetThisInterval(addHours);
                    else if (type === "mouseup" || type === "touchend" || type === "contextmenu") _clearAsyncs();
                    else addHours();
                } else {
                    if (isEventTypeMousedownOrTouchstart) _clearAndSetThisInterval(addMinutes);
                    else if (type === "mouseup" || type === "touchend" || type === "contextmenu") _clearAsyncs();
                    else addMinutes();
                }
            } else if ($0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$ICON_DOWN_CLASS)) {
                if ($0abbbd36a260e067$var$Manipulator$1.hasClass(target.parentNode, $0abbbd36a260e067$var$ICONS_HOUR_INLINE)) {
                    if (isEventTypeMousedownOrTouchstart) _clearAndSetThisInterval(subHours);
                    else if (type === "mouseup" || type === "touchend") _clearAsyncs();
                    else subHours();
                } else {
                    if (isEventTypeMousedownOrTouchstart) _clearAndSetThisInterval(subMinutes);
                    else if (type === "mouseup" || type === "touchend") _clearAsyncs();
                    else subMinutes();
                }
            }
        });
        $0abbbd36a260e067$var$EventHandlerMulti.on(this._document, `${$0abbbd36a260e067$var$EVENT_MOUSEUP_DATA_API} ${$0abbbd36a260e067$var$EVENT_TOUCHEND_DATA_API}`, ()=>{
            _clearAsyncs();
        });
        $0abbbd36a260e067$var$EventHandler$1.on(window, $0abbbd36a260e067$var$EVENT_KEYDOWN_DATA_API, (e)=>{
            const key = e.code;
            const isHourBtnFocused = document.activeElement.classList.contains("timepicker-hour");
            const isMinuteBtnFocused = document.activeElement.classList.contains("timepicker-minute");
            const isBodyFocused = document.activeElement === document.body;
            selectedHour = Number(this._hour.textContent);
            minuteNumber = Number(this._minutes.textContent);
            switch(key){
                case "ArrowUp":
                    e.preventDefault();
                    if (isBodyFocused || isHourBtnFocused) {
                        this._hour.focus();
                        addHours();
                    } else if (isMinuteBtnFocused) addMinutes();
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    if (isBodyFocused || isHourBtnFocused) {
                        this._hour.focus();
                        subHours();
                    } else if (isMinuteBtnFocused) subMinutes();
                    break;
            }
        });
    }
    _handleClose() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._modal, "click", `.${$0abbbd36a260e067$var$WRAPPER_CLASS}, .${$0abbbd36a260e067$var$BUTTON_CANCEL_CLASS}, .${$0abbbd36a260e067$var$BUTTON_CLEAR_CLASS}`, ({ target: target })=>{
            const { closeModalOnBackdropClick: closeModalOnBackdropClick } = this._options;
            if ($0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$BUTTON_CLEAR_CLASS)) {
                this._toggleAmPm("PM");
                this._input.value = "";
                $0abbbd36a260e067$var$EventHandler$1.trigger(this._input, $0abbbd36a260e067$var$EVENT_CLEAR);
                $0abbbd36a260e067$var$Manipulator$1.removeClass(this._input, "active");
                let checkInputValue;
                if ($0abbbd36a260e067$var$takeValue(this._input)[0] === "") checkInputValue = [
                    "12",
                    "00",
                    "PM"
                ];
                else checkInputValue = $0abbbd36a260e067$var$takeValue(this._input);
                const [hour, minute, format] = checkInputValue;
                this._setTipsAndTimesDependOnInputValue("12", "00");
                this._setActiveClassToTipsOnOpen(hour, minute, format);
                this._hour.click();
            } else if ($0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$BUTTON_CANCEL_CLASS)) this.close();
            else if ($0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$WRAPPER_CLASS) && closeModalOnBackdropClick) this.close();
        });
    }
    _removePicker() {
        $0abbbd36a260e067$var$Manipulator$1.addStyle(this.toggleButton, {
            pointerEvents: "auto"
        });
        if (this._animations) this._toggleBackdropAnimation(true);
        this._removeModal();
    }
    _removeFocusTrap() {
        if (this._focusTrap) {
            this._focusTrap.disable();
            this._focusTrap = null;
        }
    }
    showValueInput() {
        return this._input.value;
    }
    _handleOkButton() {
        $0abbbd36a260e067$var$EventHandlerMulti.on(this._modal, "click", `.${$0abbbd36a260e067$var$BUTTON_SUBMIT_CLASS}`, ()=>{
            let { maxTime: maxTime, minTime: minTime } = this._options;
            const { format12: format12, format24: format24, disablePast: disablePast, disableFuture: disableFuture } = this._options;
            const hourModeActive = this._document.querySelector(`.${$0abbbd36a260e067$var$HOUR_MODE_CLASS}.${$0abbbd36a260e067$var$ACTIVE_CLASS$1}`);
            const currentValue = `${this._hour.textContent}:${this._minutes.textContent}`;
            const selectedHour = Number(this._hour.textContent);
            const selectedMinutes = Number(this._minutes.textContent);
            minTime = $0abbbd36a260e067$var$setMinTime(minTime, disablePast, format12);
            maxTime = $0abbbd36a260e067$var$setMaxTime(maxTime, disableFuture, format12);
            const [maxTimeHour, maxTimeMinutes, maxTimeFormat] = $0abbbd36a260e067$var$takeValue(maxTime, false);
            const [minTimeHour, minTimeMinutes, minTimeFormat] = $0abbbd36a260e067$var$takeValue(minTime, false);
            const isHourLessThanMinHour = selectedHour < Number(minTimeHour);
            const isHourGreaterThanMaxHour = selectedHour > Number(maxTimeHour);
            let maxFormatAndCurrentFormatEqual = true;
            if (hourModeActive) maxFormatAndCurrentFormatEqual = maxTimeFormat === hourModeActive.textContent;
            let minFormatAndCurrentFormatEqual = true;
            if (hourModeActive) minFormatAndCurrentFormatEqual = minTimeFormat === hourModeActive.textContent;
            const hourEqualToMaxAndMinutesGreaterThanMax = selectedMinutes > maxTimeMinutes && selectedHour === Number(maxTimeHour);
            const hourEqualToMinAndMinutesLessThanMin = selectedMinutes < minTimeMinutes && selectedHour === Number(minTimeHour);
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._input, "active");
            $0abbbd36a260e067$var$Manipulator$1.addStyle(this.toggleButton, {
                pointerEvents: "auto"
            });
            if (maxTime !== "") {
                if (maxFormatAndCurrentFormatEqual && (isHourGreaterThanMaxHour || hourEqualToMaxAndMinutesGreaterThanMax)) return;
                else if (maxTimeFormat === "AM" && hourModeActive.textContent === "PM") return;
            }
            if (minTime !== "") {
                if (minFormatAndCurrentFormatEqual && (isHourLessThanMinHour || hourEqualToMinAndMinutesLessThanMin)) return;
                if (minTimeFormat === "PM" && hourModeActive.textContent === "AM") return;
            }
            if ($0abbbd36a260e067$var$checkValueBeforeAccept(this._options, this._input, this._hour.textContent, this._minutes.textContent) === void 0) return;
            if (this._isInvalidTimeFormat) $0abbbd36a260e067$var$Manipulator$1.removeClass(this._input, "is-invalid");
            if (format24) this._input.value = currentValue;
            else if (hourModeActive === null) this._input.value = `${currentValue} PM`;
            else this._input.value = `${currentValue} ${hourModeActive.textContent}`;
            this.close();
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._input, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED$4);
        });
    }
    _handleHoverInlineBtn() {
        $0abbbd36a260e067$var$EventHandlerMulti.on(this._modal, "mouseover mouseleave", `.${$0abbbd36a260e067$var$CURRENT_INLINE_CLASS}`, ({ type: type, target: target })=>{
            const allIconsInlineHour = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$ICON_INLINE_HOUR_CLASS}`, this._modal);
            const allIconsInlineMinute = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$ICON_INLINE_MINUTE_CLASS}`, this._modal);
            if (type === "mouseover") {
                if ($0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$HOUR_CLASS)) allIconsInlineHour.forEach((icon)=>$0abbbd36a260e067$var$Manipulator$1.addClass(icon, $0abbbd36a260e067$var$ACTIVE_CLASS$1));
                else allIconsInlineMinute.forEach((icon)=>$0abbbd36a260e067$var$Manipulator$1.addClass(icon, $0abbbd36a260e067$var$ACTIVE_CLASS$1));
            } else if ($0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$HOUR_CLASS)) allIconsInlineHour.forEach((icon)=>$0abbbd36a260e067$var$Manipulator$1.removeClass(icon, $0abbbd36a260e067$var$ACTIVE_CLASS$1));
            else allIconsInlineMinute.forEach((icon)=>$0abbbd36a260e067$var$Manipulator$1.removeClass(icon, $0abbbd36a260e067$var$ACTIVE_CLASS$1));
        });
    }
    _handleDocumentClickInline() {
        $0abbbd36a260e067$var$EventHandler$1.on(document, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API$1, ({ target: target })=>{
            if (this._modal && !this._modal.contains(target)) {
                clearInterval(this._interval);
                this.close();
            }
        });
    }
    _handleSwitchHourMinute() {
        $0abbbd36a260e067$var$toggleClassHandler("click", $0abbbd36a260e067$var$CURRENT_CLASS);
        $0abbbd36a260e067$var$EventHandler$1.on(this._modal, "click", $0abbbd36a260e067$var$CURRENT_CLASS, ()=>{
            const { format24: format24 } = this._options;
            const current = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$CURRENT_CLASS, this._modal);
            const allTipsMinutes = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`, this._modal);
            const allTipsHours = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`, this._modal);
            const allInnerTips = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS}`, this._modal);
            const hourValue = Number(this._hour.textContent);
            const minuteValue = Number(this._minutes.textContent);
            if (format24 && (hourValue > 12 || hourValue === 0)) this._isInner = true;
            const switchTips = (array2, classes)=>{
                allTipsHours.forEach((tip)=>tip.remove());
                allTipsMinutes.forEach((tip)=>tip.remove());
                $0abbbd36a260e067$var$Manipulator$1.addClass(this._hand, $0abbbd36a260e067$var$TRANSFORM_CLASS);
                setTimeout(()=>{
                    $0abbbd36a260e067$var$Manipulator$1.removeClass(this._hand, $0abbbd36a260e067$var$TRANSFORM_CLASS);
                }, 401);
                this._getAppendClock(array2, `.${$0abbbd36a260e067$var$CLOCK_CLASS}`, classes);
                const toggleActiveClass = ()=>{
                    const allTipsHours2 = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`, this._modal);
                    const allTipsMinutes2 = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`, this._modal);
                    this._addActiveClassToTip(allTipsHours2, hourValue);
                    this._addActiveClassToTip(allTipsMinutes2, minuteValue);
                };
                if (!format24) setTimeout(()=>{
                    toggleActiveClass();
                }, 401);
                else {
                    const allTipsInnerHours = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS}`, this._modal);
                    setTimeout(()=>{
                        this._addActiveClassToTip(allTipsInnerHours, hourValue);
                        toggleActiveClass();
                    }, 401);
                }
            };
            current.forEach((e)=>{
                if ($0abbbd36a260e067$var$Manipulator$1.hasClass(e, $0abbbd36a260e067$var$ACTIVE_CLASS$1)) {
                    if ($0abbbd36a260e067$var$Manipulator$1.hasClass(e, $0abbbd36a260e067$var$MINUTE_CLASS)) {
                        $0abbbd36a260e067$var$Manipulator$1.addClass(this._hand, $0abbbd36a260e067$var$TRANSFORM_CLASS);
                        $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                            transform: `rotateZ(${this._minutes.textContent * 6}deg)`,
                            height: "calc(40% + 1px)"
                        });
                        if (format24 && allInnerTips.length > 0) allInnerTips.forEach((innerTip)=>innerTip.remove());
                        switchTips(this.minutesArray, `${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`);
                        this._hour.style.pointerEvents = "";
                        this._minutes.style.pointerEvents = "none";
                    } else if ($0abbbd36a260e067$var$Manipulator$1.hasClass(e, $0abbbd36a260e067$var$HOUR_CLASS)) {
                        $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                            transform: `rotateZ(${this._hour.textContent * 30}deg)`
                        });
                        if (Number(this._hour.textContent) > 12 || this._hour.textContent === "00") {
                            $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                                transform: `rotateZ(${this._hour.textContent * 30 - 360}deg)`,
                                height: "21.5%"
                            });
                            if (Number(this._hour.textContent) > 12) $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                                height: "21.5%"
                            });
                        } else $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                            height: "calc(40% + 1px)"
                        });
                        if (format24) this._getAppendClock(this.innerHours, `.${$0abbbd36a260e067$var$CLOCK_INNER_CLASS}`, $0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS);
                        if (allInnerTips.length > 0) allInnerTips.forEach((innerTip)=>innerTip.remove());
                        switchTips(this.hoursArray, `${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`);
                        $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hour, {
                            pointerEvents: "none"
                        });
                        $0abbbd36a260e067$var$Manipulator$1.addStyle(this._minutes, {
                            pointerEvents: ""
                        });
                    }
                }
            });
        });
    }
    _handleDisablingTipsMaxTime(selectedFormat, maxTimeFormat, maxTimeMinutes, maxTimeHour) {
        if (!this._options.maxTime && !this._options.disableFuture) return;
        const outerHoursTips = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`);
        const innerHoursTips = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS}`);
        const allTipsMinutes = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`);
        if (!maxTimeFormat || maxTimeFormat === selectedFormat) {
            $0abbbd36a260e067$var$_verifyMaxTimeHourAndAddDisabledClass(innerHoursTips, maxTimeHour);
            $0abbbd36a260e067$var$_verifyMaxTimeHourAndAddDisabledClass(outerHoursTips, maxTimeHour);
            $0abbbd36a260e067$var$_verifyMaxTimeMinutesTipsAndAddDisabledClass(allTipsMinutes, maxTimeMinutes, maxTimeHour, this._hour.textContent);
            return;
        }
        if (maxTimeFormat === "AM" && selectedFormat === "PM") {
            outerHoursTips.forEach((tip)=>{
                $0abbbd36a260e067$var$Manipulator$1.addClass(tip, "disabled");
            });
            allTipsMinutes.forEach((tip)=>{
                $0abbbd36a260e067$var$Manipulator$1.addClass(tip, "disabled");
            });
        }
    }
    _handleDisablingTipsMinTime(selectedFormat, minTimeFormat, minTimeMinutes, minTimeHour) {
        if (!this._options.minTime && !this._options.disablePast) return;
        const outerHoursTips = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`);
        const innerHoursTips = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS}`);
        const allTipsMinutes = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`);
        if (!minTimeFormat || minTimeFormat === selectedFormat) {
            $0abbbd36a260e067$var$_verifyMinTimeHourAndAddDisabledClass(outerHoursTips, minTimeHour);
            $0abbbd36a260e067$var$_verifyMinTimeHourAndAddDisabledClass(innerHoursTips, minTimeHour);
            $0abbbd36a260e067$var$_verifyMinTimeMinutesTipsAndAddDisabledClass(allTipsMinutes, minTimeMinutes, minTimeHour, this._hour.textContent);
        } else if (minTimeFormat === "PM" && selectedFormat === "AM") {
            outerHoursTips.forEach((tip)=>$0abbbd36a260e067$var$Manipulator$1.addClass(tip, "disabled"));
            allTipsMinutes.forEach((tip)=>$0abbbd36a260e067$var$Manipulator$1.addClass(tip, "disabled"));
        }
    }
    _handleSwitchTimeMode() {
        $0abbbd36a260e067$var$EventHandler$1.on(document, "click", `.${$0abbbd36a260e067$var$HOUR_MODE_CLASS}`, ({ target: target })=>{
            let { maxTime: maxTime, minTime: minTime } = this._options;
            const { disablePast: disablePast, disableFuture: disableFuture, format12: format12 } = this._options;
            minTime = $0abbbd36a260e067$var$setMinTime(minTime, disablePast, format12);
            maxTime = $0abbbd36a260e067$var$setMaxTime(maxTime, disableFuture, format12);
            let [maxTimeHour, maxTimeMinutes, maxTimeFormat] = $0abbbd36a260e067$var$takeValue(maxTime, false);
            let [minTimeHour, minTimeMinutes, minTimeFormat] = $0abbbd36a260e067$var$takeValue(minTime, false);
            const allTipsHour = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`);
            const allTipsMinutes = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`);
            const clearDisabledClassForAllTips = ()=>{
                allTipsHour.forEach((tip)=>{
                    $0abbbd36a260e067$var$Manipulator$1.removeClass(tip, "disabled");
                });
                allTipsMinutes.forEach((tip)=>{
                    $0abbbd36a260e067$var$Manipulator$1.removeClass(tip, "disabled");
                });
            };
            clearDisabledClassForAllTips();
            this._handleDisablingTipsMinTime(target.textContent, minTimeFormat, minTimeMinutes, minTimeHour);
            this._handleDisablingTipsMaxTime(target.textContent, maxTimeFormat, maxTimeMinutes, maxTimeHour);
            this._toggleAmPm(target.textContent);
            if (!$0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$ACTIVE_CLASS$1)) {
                const allHoursMode = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$HOUR_MODE_CLASS}`);
                allHoursMode.forEach((element2)=>{
                    if ($0abbbd36a260e067$var$Manipulator$1.hasClass(element2, $0abbbd36a260e067$var$ACTIVE_CLASS$1)) $0abbbd36a260e067$var$Manipulator$1.removeClass(element2, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
                });
                $0abbbd36a260e067$var$Manipulator$1.addClass(target, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
            }
        });
    }
    _handleClockClick() {
        let { maxTime: maxTime, minTime: minTime } = this._options;
        const { disablePast: disablePast, disableFuture: disableFuture, format12: format12 } = this._options;
        minTime = $0abbbd36a260e067$var$setMinTime(minTime, disablePast, format12);
        maxTime = $0abbbd36a260e067$var$setMaxTime(maxTime, disableFuture, format12);
        const maxTimeFormat = $0abbbd36a260e067$var$takeValue(maxTime, false)[2];
        const minTimeFormat = $0abbbd36a260e067$var$takeValue(minTime, false)[2];
        const maxTimeHour = $0abbbd36a260e067$var$takeValue(maxTime, false)[0];
        const minTimeHour = $0abbbd36a260e067$var$takeValue(minTime, false)[0];
        const clockWrapper = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CLOCK_WRAPPER_CLASS}`);
        $0abbbd36a260e067$var$EventHandlerMulti.on(document, `${$0abbbd36a260e067$var$EVENT_MOUSEDOWN_DATA_API} ${$0abbbd36a260e067$var$EVENT_MOUSEUP_DATA_API} ${$0abbbd36a260e067$var$EVENT_MOUSEMOVE_DATA_API} ${$0abbbd36a260e067$var$EVENT_MOUSELEAVE_DATA_API} ${$0abbbd36a260e067$var$EVENT_MOUSEOVER_DATA_API} ${$0abbbd36a260e067$var$EVENT_TOUCHSTART_DATA_API} ${$0abbbd36a260e067$var$EVENT_TOUCHMOVE_DATA_API} ${$0abbbd36a260e067$var$EVENT_TOUCHEND_DATA_API}`, "", (e)=>{
            if (!$0abbbd36a260e067$var$checkBrowser()) e.preventDefault();
            const { type: type, target: target } = e;
            const { closeModalOnMinutesClick: closeModalOnMinutesClick, switchHoursToMinutesOnClick: switchHoursToMinutesOnClick } = this._options;
            const minutes = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`, this._modal) !== null;
            const hours = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`, this._modal) !== null;
            const innerHours = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS}`, this._modal) !== null;
            const allTipsMinutes = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`, this._modal);
            const mouseClick = $0abbbd36a260e067$var$findMousePosition(e, clockWrapper);
            const radius = clockWrapper.offsetWidth / 2;
            let rds = Math.atan2(mouseClick.y - radius, mouseClick.x - radius);
            if ($0abbbd36a260e067$var$checkBrowser()) {
                const touchClick = $0abbbd36a260e067$var$findMousePosition(e, clockWrapper, true);
                rds = Math.atan2(touchClick.y - radius, touchClick.x - radius);
            }
            let xPos = null;
            let yPos = null;
            let elFromPoint = null;
            if (type === "mousedown" || type === "mousemove" || type === "touchmove" || type === "touchstart") {
                if (type === "mousedown" || type === "touchstart" || type === "touchmove") {
                    if (this._hasTargetInnerClass(target) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$CLOCK_WRAPPER_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$CLOCK_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$TIPS_MINUTES_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$TIPS_HOURS_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$CIRCLE_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$HAND_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$MIDDLE_DOT_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$TIPS_ELEMENT_CLASS)) {
                        this._isMouseMove = true;
                        if ($0abbbd36a260e067$var$checkBrowser() && e.touches) {
                            xPos = e.touches[0].clientX;
                            yPos = e.touches[0].clientY;
                            elFromPoint = document.elementFromPoint(xPos, yPos);
                        }
                    }
                }
            } else if (type === "mouseup" || type === "touchend") {
                this._isMouseMove = false;
                if (this._hasTargetInnerClass(target) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$CLOCK_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$TIPS_HOURS_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$CIRCLE_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$HAND_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$MIDDLE_DOT_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$TIPS_ELEMENT_CLASS)) {
                    if ((hours || innerHours) && switchHoursToMinutesOnClick) {
                        const isHourLessThanMinOrGreaterThanMax = Number(this._hour.textContent) > maxTimeHour || Number(this._hour.textContent) < minTimeHour;
                        if (this._options.format24 && maxTimeHour != "" && minTimeHour != "" && isHourLessThanMinOrGreaterThanMax) return;
                        else if (this._options.format24 && maxTimeHour != "" && this._hour.textContent > maxTimeHour) return;
                        else if (this._options.format24 && minTimeHour != "" && this._hour.textContent < minTimeHour) return;
                    }
                    if (!$0abbbd36a260e067$var$Manipulator$1.hasClass(this._minutes, $0abbbd36a260e067$var$ACTIVE_CLASS$1)) $0abbbd36a260e067$var$EventHandler$1.trigger(this._minutes, "click");
                }
                if (minutes && closeModalOnMinutesClick) {
                    const submitBtn = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$BUTTON_SUBMIT_CLASS}`, this._modal);
                    $0abbbd36a260e067$var$EventHandler$1.trigger(submitBtn, "click");
                }
            }
            if (minutes) {
                let minute;
                const degrees = Math.trunc(rds * 180 / Math.PI) + 90;
                const { degrees: minDegrees, minute: minTimeObj } = this._makeMinutesDegrees(degrees, minute);
                if (this._handlerMaxMinMinutesOptions(minDegrees, minTimeObj) === void 0) return;
                const { degrees: _degrees, minute: minuteTimes } = this._handlerMaxMinMinutesOptions(minDegrees, minTimeObj);
                if (this._isMouseMove) {
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                        transform: `rotateZ(${_degrees}deg)`
                    });
                    if (minuteTimes === void 0) return;
                    const changeMinutes = ()=>{
                        return minuteTimes >= 10 || minuteTimes === "00" ? minuteTimes : `0${minuteTimes}`;
                    };
                    this._minutes.textContent = changeMinutes();
                    this._toggleClassActive(this.minutesArray, this._minutes, allTipsMinutes);
                    this._toggleBackgroundColorCircle(`${$0abbbd36a260e067$var$TIPS_MINUTES_CLASS}`);
                    this._objWithDataOnChange.degreesMinutes = _degrees;
                    this._objWithDataOnChange.minutes = minuteTimes;
                }
            }
            if (hours || innerHours) {
                let hour;
                let degrees = Math.trunc(rds * 180 / Math.PI) + 90;
                degrees = Math.round(degrees / 30) * 30;
                $0abbbd36a260e067$var$Manipulator$1.addClass(this._circle, "active");
                if (this._makeHourDegrees(target, degrees, hour) === void 0) return;
                const makeDegrees = ()=>{
                    if ($0abbbd36a260e067$var$checkBrowser() && degrees && elFromPoint) {
                        const { degrees: touchDegrees, hour: touchHours } = this._makeHourDegrees(elFromPoint, degrees, hour);
                        return this._handleMoveHand(elFromPoint, touchHours, touchDegrees);
                    } else {
                        const { degrees: movedDegrees, hour: movedHours } = this._makeHourDegrees(target, degrees, hour);
                        return this._handleMoveHand(target, movedHours, movedDegrees);
                    }
                };
                this._objWithDataOnChange.degreesHours = degrees;
                if (this._handlerMaxMinHoursOptions(degrees, maxTimeHour, minTimeHour, maxTimeFormat, minTimeFormat, e)) makeDegrees();
            }
            e.stopPropagation();
        });
    }
    _hasTargetInnerClass(target) {
        return $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$CLOCK_INNER_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS) || $0abbbd36a260e067$var$Manipulator$1.hasClass(target, $0abbbd36a260e067$var$TIPS_INNER_ELEMENT_CLASS);
    }
    _handleMoveHand(target, hour, degrees) {
        const allTipsHours = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`, this._modal);
        const allTipsInner = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS}`, this._modal);
        if (this._isMouseMove) {
            if (this._hasTargetInnerClass(target)) $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                height: "21.5%"
            });
            else $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                height: "calc(40% + 1px)"
            });
            $0abbbd36a260e067$var$Manipulator$1.addStyle(this._hand, {
                transform: `rotateZ(${degrees}deg)`
            });
            this._hour.textContent = hour >= 10 || hour === "00" ? hour : `0${hour}`;
            this._toggleClassActive(this.hoursArray, this._hour, allTipsHours);
            this._toggleClassActive(this.innerHours, this._hour, allTipsInner);
            this._objWithDataOnChange.hour = hour >= 10 || hour === "00" ? hour : `0${hour}`;
        }
    }
    _handlerMaxMinMinutesOptions(degrees, minute) {
        let { maxTime: maxTime, minTime: minTime } = this._options;
        const { format12: format12, increment: increment, disablePast: disablePast, disableFuture: disableFuture } = this._options;
        minTime = $0abbbd36a260e067$var$setMinTime(minTime, disablePast, format12);
        maxTime = $0abbbd36a260e067$var$setMaxTime(maxTime, disableFuture, format12);
        const maxMin = $0abbbd36a260e067$var$takeValue(maxTime, false)[1];
        const minMin = $0abbbd36a260e067$var$takeValue(minTime, false)[1];
        const maxHourTime = $0abbbd36a260e067$var$takeValue(maxTime, false)[0];
        const minHourTime = $0abbbd36a260e067$var$takeValue(minTime, false)[0];
        const maxTimeFormat = $0abbbd36a260e067$var$takeValue(maxTime, false)[2];
        const minTimeFormat = $0abbbd36a260e067$var$takeValue(minTime, false)[2];
        const maxMinDegrees = maxMin !== "" ? maxMin * 6 : "";
        const minMinDegrees = minMin !== "" ? minMin * 6 : "";
        const selectedHour = Number(this._hour.textContent);
        if (!maxTimeFormat && !minTimeFormat) {
            if (maxTime !== "" && minTime !== "") {
                if (maxHourTime == selectedHour && degrees > maxMinDegrees || minHourTime == selectedHour && degrees < minMinDegrees) return degrees;
            } else if (minTime !== "" && selectedHour <= Number(minHourTime)) {
                if (degrees <= minMinDegrees - 6) return degrees;
            } else if (maxTime !== "" && selectedHour >= Number(maxHourTime)) {
                if (degrees >= maxMinDegrees + 6) return degrees;
            }
        } else {
            if (minTime !== "") {
                if (minTimeFormat === "PM" && this._isAmEnabled) return;
                if (minTimeFormat === "PM" && this._isPmEnabled) {
                    if (selectedHour < Number(minHourTime)) return;
                    if (selectedHour <= Number(minHourTime)) {
                        if (degrees <= minMinDegrees - 6) return degrees;
                    }
                } else if (minTimeFormat === "AM" && this._isAmEnabled) {
                    if (selectedHour < Number(minHourTime)) return;
                    if (selectedHour <= Number(minHourTime)) {
                        if (degrees <= minMinDegrees - 6) return degrees;
                    }
                }
            }
            if (maxTime !== "") {
                if (maxTimeFormat === "AM" && this._isPmEnabled) return;
                if (maxTimeFormat === "PM" && this._isPmEnabled) {
                    if (selectedHour >= Number(maxHourTime)) {
                        if (degrees >= maxMinDegrees + 6) return degrees;
                    }
                } else if (maxTimeFormat === "AM" && this._isAmEnabled) {
                    if (selectedHour >= Number(maxHourTime)) {
                        if (degrees >= maxMinDegrees + 6) return degrees;
                    }
                }
            }
        }
        if (increment) degrees = Math.round(degrees / 30) * 30;
        if (degrees <= 0) degrees = 360 + degrees;
        else if (degrees >= 360) degrees = 0;
        return {
            degrees: degrees,
            minute: minute
        };
    }
    _removeModal() {
        const timeout = this._animations ? 300 : 0;
        setTimeout(()=>{
            this._removeModalElements();
            if (!this._options.inline) this._scrollBar.reset();
        }, timeout);
        this._removeFocusTrap();
        $0abbbd36a260e067$var$EventHandlerMulti.off(this._document, `${$0abbbd36a260e067$var$EVENT_CLICK_DATA_API$1} ${$0abbbd36a260e067$var$EVENT_KEYDOWN_DATA_API} ${$0abbbd36a260e067$var$EVENT_MOUSEDOWN_DATA_API} ${$0abbbd36a260e067$var$EVENT_MOUSEUP_DATA_API} ${$0abbbd36a260e067$var$EVENT_MOUSEMOVE_DATA_API} ${$0abbbd36a260e067$var$EVENT_MOUSELEAVE_DATA_API} ${$0abbbd36a260e067$var$EVENT_MOUSEOVER_DATA_API} ${$0abbbd36a260e067$var$EVENT_TOUCHSTART_DATA_API} ${$0abbbd36a260e067$var$EVENT_TOUCHMOVE_DATA_API} ${$0abbbd36a260e067$var$EVENT_TOUCHEND_DATA_API}`);
        $0abbbd36a260e067$var$EventHandler$1.off(window, $0abbbd36a260e067$var$EVENT_KEYDOWN_DATA_API);
    }
    _removeModalElements() {
        if (this._modal) this._modal.remove();
    }
    _toggleBackdropAnimation(isToRemove = false) {
        if (isToRemove) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._wrapper, "animation");
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._wrapper, $0abbbd36a260e067$var$WRAPPER_CLOSE_ANIMATION_CLASS);
            this._wrapper.style.animationDuration = "300ms";
        } else {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._wrapper, "animation");
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._wrapper, $0abbbd36a260e067$var$WRAPPER_OPEN_ANIMATION_CLASS);
            this._wrapper.style.animationDuration = "300ms";
            if (!this._options.inline) $0abbbd36a260e067$var$Manipulator$1.addClass(this._clock, $0abbbd36a260e067$var$CLOCK_ANIMATION_CLASS);
        }
    }
    _addActiveClassToTip(tips, value) {
        tips.forEach((tip)=>{
            if (Number(tip.textContent) === Number(value)) $0abbbd36a260e067$var$Manipulator$1.addClass(tip, $0abbbd36a260e067$var$ACTIVE_CLASS$1);
        });
    }
    _setHourOrMinute(number) {
        return number < 10 ? `0${number}` : number;
    }
    _appendTimes() {
        const { format24: format24 } = this._options;
        if (format24) {
            this._getAppendClock(this.hoursArray, `.${$0abbbd36a260e067$var$CLOCK_CLASS}`, `${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`);
            this._getAppendClock(this.innerHours, `.${$0abbbd36a260e067$var$CLOCK_INNER_CLASS}`, $0abbbd36a260e067$var$TIPS_INNER_HOURS_CLASS);
        } else this._getAppendClock(this.hoursArray, `.${$0abbbd36a260e067$var$CLOCK_CLASS}`, `${$0abbbd36a260e067$var$TIPS_HOURS_CLASS}`);
    }
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        config = {
            ...$0abbbd36a260e067$var$Default$h,
            ...dataAttributes,
            ...config,
            isRTL: $0abbbd36a260e067$var$isRTL$1
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$q, config, $0abbbd36a260e067$var$DefaultType$h);
        return config;
    }
    _getContainer() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(this._options.container);
    }
    _listenToUserInput() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._input, "input", (event)=>{
            this._handleUserInput(event.target.value);
        });
    }
    _handleUserInput(input) {
        const { format24: format24, format12: format12 } = this._options;
        if (this._input.value === "") return;
        const regexAMFormat = /^(0?[1-9]|1[0-2]):[0-5][0-9] [APap][mM]$/;
        const regexNormalFormat = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
        const testedAMRegex = regexAMFormat.test(input);
        const testedNormalRegex = regexNormalFormat.test(input);
        if (testedNormalRegex === true && format24) {
            this._isInvalidTimeFormat = false;
            this._inputValue = this._input.value;
            this._currentTime = $0abbbd36a260e067$var$formatNormalHours(this._inputValue);
        } else if (testedAMRegex === true && format12) {
            this._isInvalidTimeFormat = false;
            this._inputValue = this._input.value;
            this._currentTime = $0abbbd36a260e067$var$formatToAmPm(this._inputValue);
        } else this._isInvalidTimeFormat = true;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$k);
            const _config = typeof config === "object" && config;
            if (!data && /dispose|hide/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$8497164ca5dbf597(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$p = "navbar";
class $0abbbd36a260e067$export$42cfbb80f7861e77 extends $0abbbd36a260e067$var$BaseComponent2 {
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$p;
    }
    // Public
    init() {
        this._onScroll();
        this._addEvent();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    dispose() {
        this._removeEvent();
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _addEvent() {
        $0abbbd36a260e067$var$EventHandler$1.on(window, "scroll", ()=>this._onScroll());
    }
    _removeEvent() {
        $0abbbd36a260e067$var$EventHandler$1.off(window, "scroll");
    }
    _onScroll() {
        if (window.scrollY > 0) $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, "navbar-scrolled");
        else $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, "navbar-scrolled");
    }
    // Static
    static jQueryInterface(config) {
        this.each(function() {
            const data = $0abbbd36a260e067$export$42cfbb80f7861e77.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
const $0abbbd36a260e067$var$NAME$o = "infiniteScroll";
const $0abbbd36a260e067$var$DATA_KEY$j = `mdb.${$0abbbd36a260e067$var$NAME$o}`;
const $0abbbd36a260e067$var$EVENT_KEY$e = `.${$0abbbd36a260e067$var$DATA_KEY$j}`;
const $0abbbd36a260e067$var$EVENT_COMPLETED = `completed${$0abbbd36a260e067$var$EVENT_KEY$e}`;
const $0abbbd36a260e067$var$Default$g = {
    infiniteDirection: "y"
};
const $0abbbd36a260e067$var$DefaultType$g = {
    infiniteDirection: "string"
};
class $0abbbd36a260e067$export$c5295390d6167a3e extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, data){
        super(element2);
        this._element = element2;
        this._options = this._getConfig(data);
        this._elementScrollHandler = this._scrollHandler.bind(this);
        this._init();
        if (this._element !== window) {
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$o;
    }
    get rect() {
        return this._element.getBoundingClientRect();
    }
    get condition() {
        if (this._element === window) return Math.abs(window.scrollY + window.innerHeight - document.documentElement.scrollHeight) < 1;
        if (this._options.infiniteDirection === "x") return this.rect.width + this._element.scrollLeft + 10 >= this._element.scrollWidth;
        return Math.ceil(this.rect.height + this._element.scrollTop) >= this._element.scrollHeight;
    }
    // Public
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "scroll", this._elementScrollHandler);
        if (this._element !== window) $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _init() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "scroll", this._elementScrollHandler);
    }
    _scrollHandler() {
        if (this.condition) $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_COMPLETED);
    }
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$Default$g,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$o, config, $0abbbd36a260e067$var$DefaultType$g);
        return config;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$j);
            const _config = typeof config === "object" && config;
            if (!data) data = new $0abbbd36a260e067$export$c5295390d6167a3e(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$n = "lazyLoad";
const $0abbbd36a260e067$var$DATA_KEY$i = "mdb.lazyLoad";
const $0abbbd36a260e067$var$CLASSNAME_LAZYLOAD = "lazy";
const $0abbbd36a260e067$var$SELECTOR_LAZYLOAD = ".lazy";
const $0abbbd36a260e067$var$SELECTOR_ELEMENTS = [
    "img",
    "video"
];
const $0abbbd36a260e067$var$EVENT_KEY$d = `.${$0abbbd36a260e067$var$DATA_KEY$i}`;
const $0abbbd36a260e067$var$EVENT_LOADED = `contentLoaded${$0abbbd36a260e067$var$EVENT_KEY$d}`;
const $0abbbd36a260e067$var$EVENT_ERROR = `loadingError${$0abbbd36a260e067$var$EVENT_KEY$d}`;
const $0abbbd36a260e067$var$DefaultType$f = {
    lazySrc: "(string|null)",
    lazyDelay: "number",
    lazyAnimation: "string",
    lazyOffset: "number",
    lazyPlaceholder: "(string|undefined)",
    lazyError: "(string|undefined)"
};
const $0abbbd36a260e067$var$Default$f = {
    lazySrc: null,
    lazyDelay: 500,
    lazyAnimation: "fade-in",
    lazyOffset: 0
};
class $0abbbd36a260e067$export$7767ad0d5ed2b01b extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, data){
        super(element2);
        this._options = this._getConfig(data);
        this._scrollHandler = this._handleScroll.bind(this);
        this._errorHandler = this._setElementError.bind(this);
        this._childrenInstances = null;
        this._init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$n;
    }
    get offsetValues() {
        return this._element.getBoundingClientRect();
    }
    get inViewport() {
        if (this.parent) {
            const parentRect = this.parent.getBoundingClientRect();
            return parentRect.y > 0 && parentRect.y < window.innerHeight && this.offsetValues.y >= parentRect.y && this.offsetValues.y <= parentRect.y + parentRect.height && this.offsetValues.y <= window.innerHeight;
        }
        return this.offsetValues.top + this._options.lazyOffset <= window.innerHeight && this.offsetValues.bottom >= 0;
    }
    get parent() {
        const [container] = $0abbbd36a260e067$var$SelectorEngine$1.parents(this._element, $0abbbd36a260e067$var$SELECTOR_LAZYLOAD);
        return container;
    }
    get node() {
        return this._element.nodeName;
    }
    get isContainer() {
        return !$0abbbd36a260e067$var$SelectorEngine$1.matches(this._element, $0abbbd36a260e067$var$SELECTOR_ELEMENTS);
    }
    // Public
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "load");
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "error", this._errorHandler);
        $0abbbd36a260e067$var$EventHandler$1.off(window, "scroll", this._scrollHandler);
        if (this._animation) {
            this._animation.dispose();
            this._animation = null;
        }
        if (this._childrenInstances) this._childrenInstances.forEach((child)=>child.dispose());
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _init() {
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$CLASSNAME_LAZYLOAD);
        if (this.isContainer) {
            this._setupContainer();
            return;
        }
        this._setupElement();
    }
    _setupElement() {
        $0abbbd36a260e067$var$EventHandler$1.one(this._element, "error", this._errorHandler);
        if (this._options.lazyPlaceholder) this._setPlaceholder();
        this._animation = new $0abbbd36a260e067$export$83a1293bbde53b95(this._element, {
            animation: this._options.lazyAnimation,
            animationStart: "onLoad"
        });
        $0abbbd36a260e067$var$EventHandler$1.one(this._element, "load", this._scrollHandler);
        if (this.parent) $0abbbd36a260e067$var$EventHandler$1.on(this.parent, "scroll", this._scrollHandler);
        $0abbbd36a260e067$var$EventHandler$1.on(window, "scroll", this._scrollHandler);
    }
    _handleScroll() {
        if (this.inViewport) {
            this._timeout = setTimeout(()=>{
                this._setSrc();
                this._element.classList.remove($0abbbd36a260e067$var$CLASSNAME_LAZYLOAD);
                this._removeAttrs();
                this._animation.init();
            }, this._options.lazyDelay);
            if (this.parent) $0abbbd36a260e067$var$EventHandler$1.off(this.parent, "scroll", this._scrollHandler);
            $0abbbd36a260e067$var$EventHandler$1.off(window, "scroll", this._scrollHandler);
        }
    }
    _setElementError() {
        if (!this._options.lazyError || this._element.src === this._options.lazyError) this._element.alt = "404 not found";
        else this._element.setAttribute("src", this._options.lazyError);
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_ERROR);
    }
    _setSrc() {
        this._element.setAttribute("src", this._options.lazySrc);
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_LOADED);
    }
    _setPlaceholder() {
        if (this.node === "IMG") this._element.setAttribute("src", this._options.lazyPlaceholder);
        else if (this.node === "VIDEO") this._element.setAttribute("poster", this._options.lazyPlaceholder);
    }
    _removeAttrs() {
        [
            "src",
            "delay",
            "animation",
            "placeholder",
            "offset",
            "error"
        ].forEach((attr)=>{
            $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `lazy-${attr}`);
        });
    }
    _setupContainer() {
        this._childrenInstances = $0abbbd36a260e067$var$SelectorEngine$1.children(this._element, $0abbbd36a260e067$var$SELECTOR_ELEMENTS).map((child)=>new $0abbbd36a260e067$export$7767ad0d5ed2b01b(child, this._options));
    }
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$Default$f,
            ...options,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element)
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$n, config, $0abbbd36a260e067$var$DefaultType$f);
        return config;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$i);
            const _config = typeof config === "object" && config;
            if (!data) data = new $0abbbd36a260e067$export$7767ad0d5ed2b01b(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
function $0abbbd36a260e067$var$getDate(date) {
    return date.getDate();
}
function $0abbbd36a260e067$var$getDayNumber(date) {
    return date.getDay();
}
function $0abbbd36a260e067$var$getMonth$1(date) {
    return date.getMonth();
}
function $0abbbd36a260e067$var$getYear$1(date) {
    return date.getFullYear();
}
function $0abbbd36a260e067$var$getFirstDayOfWeek(year, month, options) {
    const firstDayIndex = options.startDay;
    const sundayIndex = firstDayIndex > 0 ? 7 - firstDayIndex : 0;
    const date = new Date(year, month);
    const index = date.getDay() + sundayIndex;
    const newIndex = index >= 7 ? index - 7 : index;
    return newIndex;
}
function $0abbbd36a260e067$var$getDaysInMonth(date) {
    return $0abbbd36a260e067$var$getMonthEnd(date).getDate();
}
function $0abbbd36a260e067$var$getMonthEnd(date) {
    return $0abbbd36a260e067$var$createDate(date.getFullYear(), date.getMonth() + 1, 0);
}
function $0abbbd36a260e067$var$getToday() {
    return /* @__PURE__ */ new Date();
}
function $0abbbd36a260e067$var$addYears(date, years) {
    return $0abbbd36a260e067$var$addMonths(date, years * 12);
}
function $0abbbd36a260e067$var$addMonths(date, months) {
    const month = $0abbbd36a260e067$var$createDate(date.getFullYear(), date.getMonth() + months, date.getDate());
    const dayOfPreviousMonth = $0abbbd36a260e067$var$getDate(date);
    const dayOfNewMonth = $0abbbd36a260e067$var$getDate(month);
    if (dayOfPreviousMonth !== dayOfNewMonth) month.setDate(0);
    return month;
}
function $0abbbd36a260e067$var$addDays(date, days) {
    return $0abbbd36a260e067$var$createDate(date.getFullYear(), date.getMonth(), date.getDate() + days);
}
function $0abbbd36a260e067$var$createDate(year, month, day) {
    const result = new Date(year, month, day);
    if (year >= 0 && year < 100) result.setFullYear(result.getFullYear() - 1900);
    return result;
}
function $0abbbd36a260e067$var$convertStringToDate(dateString) {
    const dateArr = dateString.split("-");
    const year = dateArr[0];
    const month = dateArr[1];
    const day = dateArr[2];
    return $0abbbd36a260e067$var$createDate(year, month, day);
}
function $0abbbd36a260e067$var$isValidDate$1(date) {
    return !Number.isNaN(date.getTime());
}
function $0abbbd36a260e067$var$isInRange(date, range) {
    if (range.length === 2) return $0abbbd36a260e067$var$compareDates(date, range[0]) > 0 && $0abbbd36a260e067$var$compareDates(date, range[1]) < 0;
    return false;
}
function $0abbbd36a260e067$var$isEdgeOfRange(date, range) {
    if (range.length === 2) {
        if ($0abbbd36a260e067$var$isSameDate(range[0], range[1])) return false;
        if ($0abbbd36a260e067$var$isSameDate(date, range[0])) return "first";
        if ($0abbbd36a260e067$var$isSameDate(date, range[1])) return "last";
    }
    return false;
}
function $0abbbd36a260e067$var$compareDates(date1, date2) {
    return $0abbbd36a260e067$var$getYear$1(date1) - $0abbbd36a260e067$var$getYear$1(date2) || $0abbbd36a260e067$var$getMonth$1(date1) - $0abbbd36a260e067$var$getMonth$1(date2) || $0abbbd36a260e067$var$getDate(date1) - $0abbbd36a260e067$var$getDate(date2);
}
function $0abbbd36a260e067$var$isSameDate(date1, date2) {
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);
    return date1.getTime() === date2.getTime();
}
function $0abbbd36a260e067$var$getYearsOffset(activeDate, yearsInView) {
    const activeYear = $0abbbd36a260e067$var$getYear$1(activeDate);
    const yearsDifference = activeYear - $0abbbd36a260e067$var$getStartYear();
    return $0abbbd36a260e067$var$modulo(yearsDifference, yearsInView);
}
function $0abbbd36a260e067$var$modulo(a, b) {
    return (a % b + b) % b;
}
function $0abbbd36a260e067$var$getStartYear(yearsInView, minDate, maxDate) {
    let startYear = 0;
    if (maxDate) {
        const maxYear = $0abbbd36a260e067$var$getYear$1(maxDate);
        startYear = maxYear - yearsInView + 1;
    } else if (minDate) startYear = $0abbbd36a260e067$var$getYear$1(minDate);
    return startYear;
}
function $0abbbd36a260e067$var$isDateDisabled(date, minDate, maxDate, filter, disabledPast, disabledFuture) {
    const currentDate = /* @__PURE__ */ new Date();
    currentDate.setHours(0, 0, 0, 0);
    const isBeforeMin = minDate && $0abbbd36a260e067$var$compareDates(date, minDate) <= -1;
    const isAfterMax = maxDate && $0abbbd36a260e067$var$compareDates(date, maxDate) >= 1;
    const isDisabledPast = disabledPast && $0abbbd36a260e067$var$compareDates(date, currentDate) <= -1;
    const isDisabledFuture = disabledFuture && $0abbbd36a260e067$var$compareDates(date, currentDate) >= 1;
    const isDisabled2 = filter && filter(date) === false;
    return isBeforeMin || isAfterMax || isDisabled2 || isDisabledPast || isDisabledFuture;
}
function $0abbbd36a260e067$var$isMonthDisabled(month, year, minDate, maxDate, disabledPast, disabledFuture) {
    const currentDate = /* @__PURE__ */ new Date();
    const maxYear = maxDate && $0abbbd36a260e067$var$getYear$1(maxDate);
    const maxMonth = maxDate && $0abbbd36a260e067$var$getMonth$1(maxDate);
    const minYear = minDate && $0abbbd36a260e067$var$getYear$1(minDate);
    const minMonth = minDate && $0abbbd36a260e067$var$getMonth$1(minDate);
    const currentYear = $0abbbd36a260e067$var$getYear$1(currentDate);
    const currentMonth = $0abbbd36a260e067$var$getMonth$1(currentDate);
    const isMonthAndYearAfterMax = maxMonth && maxYear && (year > maxYear || year === maxYear && month > maxMonth);
    const isMonthAndYearBeforeMin = minMonth && minYear && (year < minYear || year === minYear && month < minMonth);
    const isMonthAndYearDisabledPast = disabledPast && (year < currentYear || year === currentYear && month < currentMonth);
    const isMonthAndYearDisabledFuture = disabledFuture && (year > currentYear || year === currentYear && month > currentMonth);
    return isMonthAndYearAfterMax || isMonthAndYearBeforeMin || isMonthAndYearDisabledPast || isMonthAndYearDisabledFuture;
}
function $0abbbd36a260e067$var$isYearDisabled(year, minDate, maxDate, disabledPast, disabledFuture) {
    const min2 = minDate && $0abbbd36a260e067$var$getYear$1(minDate);
    const max2 = maxDate && $0abbbd36a260e067$var$getYear$1(maxDate);
    const currentYear = $0abbbd36a260e067$var$getYear$1(/* @__PURE__ */ new Date());
    const isAfterMax = max2 && year > max2;
    const isBeforeMin = min2 && year < min2;
    const isDisabledPast = disabledPast && year < currentYear;
    const isDisabledFuture = disabledFuture && year > currentYear;
    return isAfterMax || isBeforeMin || isDisabledPast || isDisabledFuture;
}
function $0abbbd36a260e067$var$isNextDateDisabled(disabledFuture, activeDate, view, yearsInView, minDate, maxDate, lastYearInView, firstYearInView) {
    const currentDate = /* @__PURE__ */ new Date();
    currentDate.setHours(0, 0, 0, 0);
    if (disabledFuture && maxDate && $0abbbd36a260e067$var$compareDates(maxDate, currentDate) < 0) maxDate = currentDate;
    else if (disabledFuture) maxDate = currentDate;
    return maxDate && $0abbbd36a260e067$var$areDatesInSameView(activeDate, maxDate, view, yearsInView, minDate, maxDate, lastYearInView, firstYearInView);
}
function $0abbbd36a260e067$var$isPreviousDateDisabled(disabledPast, activeDate, view, yearsInView, minDate, maxDate, lastYearInView, firstYearInView) {
    const currentDate = /* @__PURE__ */ new Date();
    currentDate.setHours(0, 0, 0, 0);
    if (disabledPast && minDate && $0abbbd36a260e067$var$compareDates(minDate, currentDate) < 0) minDate = currentDate;
    else if (disabledPast) minDate = currentDate;
    return minDate && $0abbbd36a260e067$var$areDatesInSameView(activeDate, minDate, view, yearsInView, minDate, maxDate, lastYearInView, firstYearInView);
}
function $0abbbd36a260e067$var$areDatesInSameView(date1, date2, view, yearsInView, minDate, maxDate, lastYearInView, firstYearInView) {
    if (view === "days") return $0abbbd36a260e067$var$getYear$1(date1) === $0abbbd36a260e067$var$getYear$1(date2) && $0abbbd36a260e067$var$getMonth$1(date1) === $0abbbd36a260e067$var$getMonth$1(date2);
    if (view === "months") return $0abbbd36a260e067$var$getYear$1(date1) === $0abbbd36a260e067$var$getYear$1(date2);
    if (view === "years") return $0abbbd36a260e067$var$getYear$1(date2) >= firstYearInView && $0abbbd36a260e067$var$getYear$1(date2) <= lastYearInView;
    return false;
}
function $0abbbd36a260e067$var$getDatepickerTemplate(date, selectedDate, selectedYear, selectedMonth, options, monthsInRow, yearsInView, yearsInRow, id, selectedRange) {
    const month = $0abbbd36a260e067$var$getMonth$1(date);
    const year = $0abbbd36a260e067$var$getYear$1(date);
    const day = $0abbbd36a260e067$var$getDate(date);
    const dayNumber = $0abbbd36a260e067$var$getDayNumber(date);
    const template = $0abbbd36a260e067$var$element("div");
    if (options.inline) {
        const inlineContent = `
    ${$0abbbd36a260e067$var$createMainContent(date, month, year, selectedDate, selectedYear, selectedMonth, options, monthsInRow, yearsInView, yearsInRow, selectedRange)}
`;
        $0abbbd36a260e067$var$Manipulator$1.addClass(template, "datepicker-dropdown-container");
        $0abbbd36a260e067$var$Manipulator$1.addClass(template, `datepicker-dropdown-container-${id}`);
        template.innerHTML = inlineContent;
    } else {
        const modalContent = `
    ${$0abbbd36a260e067$var$createHeader(day, dayNumber, month, options, date, selectedRange)}
    ${$0abbbd36a260e067$var$createMainContent(date, month, year, selectedDate, selectedYear, selectedMonth, options, monthsInRow, yearsInView, yearsInRow, selectedRange)}
  `;
        $0abbbd36a260e067$var$Manipulator$1.addClass(template, "datepicker-modal-container");
        $0abbbd36a260e067$var$Manipulator$1.addClass(template, `datepicker-modal-container-${id}`);
        template.innerHTML = modalContent;
    }
    if (options.dateRange) $0abbbd36a260e067$var$Manipulator$1.addClass(template, "datepicker-date-range");
    return template;
}
function $0abbbd36a260e067$var$getBackdropTemplate$1() {
    const backdrop = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(backdrop, "datepicker-backdrop");
    return backdrop;
}
function $0abbbd36a260e067$var$createCustomHeader(day, dayNumber, month, selected, options) {
    const { weekdaysShort: weekdaysShort, weekdaysFull: weekdaysFull, monthsShort: monthsShort, headerTemplateModifier: headerTemplateModifier, headerTemplate: headerTemplate } = options;
    const selectedDate = headerTemplateModifier ? headerTemplateModifier(selected) : selected;
    return headerTemplate.replaceAll("[day]", day).replaceAll("[weekday]", weekdaysShort[dayNumber]).replaceAll("[weekdayFull]", weekdaysFull[dayNumber]).replaceAll("[month]", monthsShort[month]).replaceAll("[selected]", selectedDate);
}
function $0abbbd36a260e067$var$createHeader(day, dayNumber, month, options, selected, selectedRange) {
    return `
      <div class="datepicker-header">
      ${options.headerTemplate ? $0abbbd36a260e067$var$createCustomHeader(day, dayNumber, month, selected, options) : `
        <div class="datepicker-title">
          <span class="datepicker-title-text">${options.title}</span>
        </div>
        <div class="datepicker-date">
          <span class="datepicker-date-text">${$0abbbd36a260e067$var$createTitle(selected, selectedRange, options)}</span>
        </div>
        `}
      </div>
    `;
}
function $0abbbd36a260e067$var$createTitle(selected, selectedRange, options) {
    const { dateRange: dateRange, weekdaysShort: weekdaysShort, monthsShort: monthsShort } = options;
    const formatDate = (date)=>{
        const month = $0abbbd36a260e067$var$getMonth$1(date);
        const day = $0abbbd36a260e067$var$getDate(date);
        const dayNumber = $0abbbd36a260e067$var$getDayNumber(date);
        return `${weekdaysShort[dayNumber]}, ${monthsShort[month]} ${day}`;
    };
    if (dateRange) {
        let endDate;
        let startDate;
        if (!selectedRange || selectedRange.length === 0) {
            startDate = selected;
            endDate = selected;
        } else [startDate, endDate] = selectedRange;
        return `${formatDate(startDate)} - ${endDate ? formatDate(endDate) : ""}`;
    }
    return formatDate(selected);
}
function $0abbbd36a260e067$var$createMainContent(date, month, year, selectedDate, selectedYear, selectedMonth, options, monthsInRow, yearsInView, yearsInRow, selectedRange) {
    let mainContentTemplate;
    if (options.inline) mainContentTemplate = `
    <div class="datepicker-main">
      ${$0abbbd36a260e067$var$createControls(month, year, options)}
      <div class="datepicker-view" tabindex="0">
        ${$0abbbd36a260e067$var$createViewTemplate(date, year, selectedDate, selectedYear, selectedMonth, options, monthsInRow, yearsInView, yearsInRow, selectedRange)}
      </div>
    </div>
  `;
    else mainContentTemplate = `
      <div class="datepicker-main">
        ${$0abbbd36a260e067$var$createControls(month, year, options)}
        <div class="datepicker-view" tabindex="0">
          ${$0abbbd36a260e067$var$createViewTemplate(date, year, selectedDate, selectedYear, selectedMonth, options, monthsInRow, yearsInView, yearsInRow, selectedRange)}
        </div>
        ${$0abbbd36a260e067$var$createFooter(options)}
      </div>
    `;
    return mainContentTemplate;
}
function $0abbbd36a260e067$var$createViewTemplate(date, year, selectedDate, selectedYear, selectedMonth, options, monthsInRow, yearsInView, yearsInRow, selectedRange) {
    let viewTemplate;
    if (options.view === "days") viewTemplate = $0abbbd36a260e067$var$createDayViewTemplate(date, selectedDate, options, selectedRange);
    else if (options.view === "months") viewTemplate = $0abbbd36a260e067$var$createMonthViewTemplate(year, selectedYear, selectedMonth, options, monthsInRow);
    else viewTemplate = $0abbbd36a260e067$var$createYearViewTemplate(date, selectedYear, options, yearsInView, yearsInRow);
    return viewTemplate;
}
function $0abbbd36a260e067$var$createControls(month, year, options) {
    return `
    <div class="datepicker-date-controls">
      <button class="datepicker-view-change-button" aria-label="${options.switchToMultiYearViewLabel}">
        ${options.monthsFull[month]} ${year}
      </button>
      <div class="datepicker-arrow-controls">
        <button class="datepicker-previous-button" aria-label="${options.prevMonthLabel}"></button>
        <button class="datepicker-next-button" aria-label="${options.nextMonthLabel}"></button>
      </div>
    </div>
    `;
}
function $0abbbd36a260e067$var$createFooter(options) {
    const okBtn = `<button class="datepicker-footer-btn datepicker-ok-btn" aria-label="${options.okBtnLabel}">${options.okBtnText}</button>`;
    const cancelButton = `<button class="datepicker-footer-btn datepicker-cancel-btn" aria-label="${options.cancelBtnLabel}">${options.cancelBtnText}</button>`;
    const clearButton = `<button class="datepicker-footer-btn datepicker-clear-btn" aria-label="${options.clearBtnLabel}">${options.clearBtnText}</button>`;
    return `
        <div class="datepicker-footer">
          ${options.removeClearBtn ? "" : clearButton}
          ${options.removeCancelBtn ? "" : cancelButton}
          ${options.removeOkBtn ? "" : okBtn}
        </div>
      `;
}
function $0abbbd36a260e067$var$createDayViewTemplate(date, headerDate, options, selectedRange) {
    const dates = $0abbbd36a260e067$var$getDatesArray(date, headerDate, options, selectedRange, 1);
    const nextMonthDates = options.dateRange ? $0abbbd36a260e067$var$getDatesArray($0abbbd36a260e067$var$addMonths(date, 1), headerDate, options, selectedRange, 2) : null;
    const dayNames = options.weekdaysNarrow;
    const tableHeadContent = `
      <tr>
        ${dayNames.map((name, i)=>{
        return `<th class="datepicker-day-heading" scope="col" aria-label="${options.weekdaysFull[i]}">${name}</th>`;
    }).join("")}
      </tr>
    `;
    const tableBodyContent = (dates2)=>dates2.map((week)=>`
          <tr>
            ${week.map((day)=>{
                const dayLabel = `${options.weekdaysFull[$0abbbd36a260e067$var$getDayNumber(day.date)]}, ${options.monthsFull[$0abbbd36a260e067$var$getMonth$1(day.date)]} ${$0abbbd36a260e067$var$getDate(day.date)}, ${$0abbbd36a260e067$var$getYear$1(day.date)}`;
                const currentDate = `${$0abbbd36a260e067$var$getYear$1(day.date)}-${$0abbbd36a260e067$var$getMonth$1(day.date)}-${$0abbbd36a260e067$var$getDate(day.date)}`;
                const isFirst = day.isEdgeOfRange === "first";
                const isLast = day.isEdgeOfRange === "last";
                const classNames = [
                    "datepicker-cell",
                    "datepicker-small-cell",
                    "datepicker-day-cell",
                    day.currentMonth ? "" : "disabled",
                    day.disabled ? "disabled" : "",
                    day.isToday ? "current" : "",
                    day.isSelected ? "selected" : "",
                    day.isInRange ? "in-range" : "",
                    isFirst ? "first-in-range" : "",
                    isLast ? "last-in-range" : ""
                ].filter(Boolean).join(" ");
                return `
                  <td
                    class="${classNames}"
                    data-mdb-date="${day.currentMonth ? currentDate : ""}"
                    aria-label="${dayLabel}"
                    aria-selected="${day.isSelected}"
                    ${day.disabled ? 'aria-disabled="true"' : ""}>
                    <div
                      class="datepicker-cell-content datepicker-small-cell-content"
                      style="${day.currentMonth ? "display: block" : "display: none"}">
                      ${day.dayNumber}
                    </div>
                  </td>
                `;
            }).join("")}
          </tr>
        `).join("");
    const dayViewTemplate = (dates2, month)=>`
    <table class="datepicker-table">
        <thead class="text-center">
          ${options.dateRange ? `
          <tr class="datepicker-month-header">
            <th colspan="7">${options.monthsFull[month]}</th>
          </tr>
          ` : ""}
          ${tableHeadContent}
        </thead>
        <tbody class="datepicker-table-body">
         ${tableBodyContent(dates2)}
        </tbody>
      </table>
    `;
    const rangeTemplate = ()=>`
    ${dayViewTemplate(dates, $0abbbd36a260e067$var$getMonth$1(date))}
    <div class="vr"></div>
    ${dayViewTemplate(nextMonthDates, $0abbbd36a260e067$var$getMonth$1($0abbbd36a260e067$var$addMonths(date, 1)))}
    `;
    return options.dateRange ? rangeTemplate() : dayViewTemplate(dates, $0abbbd36a260e067$var$getMonth$1(date));
}
function $0abbbd36a260e067$var$getDatesArray(activeDate, headerDate, options, selectedRange = [], visibleMonth) {
    const dates = [];
    const month = $0abbbd36a260e067$var$getMonth$1(activeDate);
    const previousMonth = $0abbbd36a260e067$var$getMonth$1($0abbbd36a260e067$var$addMonths(activeDate, -1));
    const nextMonth = $0abbbd36a260e067$var$getMonth$1($0abbbd36a260e067$var$addMonths(activeDate, 1));
    const year = $0abbbd36a260e067$var$getYear$1(activeDate);
    const firstDay = $0abbbd36a260e067$var$getFirstDayOfWeek(year, month, options);
    const daysInMonth = $0abbbd36a260e067$var$getDaysInMonth(activeDate);
    const daysInPreviousMonth = $0abbbd36a260e067$var$getDaysInMonth($0abbbd36a260e067$var$addMonths(activeDate, -1));
    const daysInWeek = 7;
    let dayNumber = 1;
    let isCurrentMonth = false;
    const firstVisibleMonth = visibleMonth === 1 ? month : previousMonth;
    const secondVisibleMonth = visibleMonth === 1 ? nextMonth : month;
    const isVisible2 = options.dateRange ? month === firstVisibleMonth || month === secondVisibleMonth : month === firstVisibleMonth;
    const isSelected = (date, selectedRange2)=>{
        if (!selectedRange2 || (selectedRange2 == null ? void 0 : selectedRange2.length) === 0) return false;
        if (options.dateRange) return selectedRange2.length === 1 ? $0abbbd36a260e067$var$isSameDate(date, selectedRange2[0]) : $0abbbd36a260e067$var$isSameDate(date, selectedRange2[0]) || $0abbbd36a260e067$var$isSameDate(date, selectedRange2[1]);
        return $0abbbd36a260e067$var$isSameDate(date, selectedRange2);
    };
    for(let i = 1; i < daysInWeek; i++){
        const week = [];
        if (i === 1) {
            const previousMonthDay = daysInPreviousMonth - firstDay + 1;
            for(let j = previousMonthDay; j <= daysInPreviousMonth; j++){
                const date = $0abbbd36a260e067$var$createDate(year, previousMonth, j);
                week.push({
                    date: date,
                    currentMonth: isCurrentMonth,
                    isSelected: isSelected(date, headerDate) && isCurrentMonth,
                    isInRange: $0abbbd36a260e067$var$isInRange(date, selectedRange) && isCurrentMonth,
                    isEdgeOfRange: isCurrentMonth ? $0abbbd36a260e067$var$isEdgeOfRange(date, selectedRange) : false,
                    isToday: $0abbbd36a260e067$var$isSameDate(date, $0abbbd36a260e067$var$getToday()),
                    dayNumber: $0abbbd36a260e067$var$getDate(date),
                    disabled: $0abbbd36a260e067$var$isDateDisabled(date, options.min, options.max, options.filter, options.disablePast, options.disableFuture)
                });
            }
            isCurrentMonth = true;
            const daysLeft = daysInWeek - week.length;
            for(let j = 0; j < daysLeft; j++){
                const date = $0abbbd36a260e067$var$createDate(year, month, dayNumber);
                week.push({
                    date: date,
                    currentMonth: isCurrentMonth,
                    isSelected: isSelected(date, headerDate) && isVisible2,
                    isInRange: $0abbbd36a260e067$var$isInRange(date, selectedRange) && isCurrentMonth,
                    isEdgeOfRange: isCurrentMonth ? $0abbbd36a260e067$var$isEdgeOfRange(date, selectedRange) : false,
                    isToday: $0abbbd36a260e067$var$isSameDate(date, $0abbbd36a260e067$var$getToday()),
                    dayNumber: $0abbbd36a260e067$var$getDate(date),
                    disabled: $0abbbd36a260e067$var$isDateDisabled(date, options.min, options.max, options.filter, options.disablePast, options.disableFuture)
                });
                dayNumber++;
            }
        } else for(let j = 1; j < 8; j++){
            if (dayNumber > daysInMonth) {
                dayNumber = 1;
                isCurrentMonth = false;
            }
            const date = $0abbbd36a260e067$var$createDate(year, isCurrentMonth ? month : nextMonth, dayNumber);
            week.push({
                date: date,
                currentMonth: isCurrentMonth,
                isSelected: isSelected(date, headerDate) && isCurrentMonth,
                isInRange: $0abbbd36a260e067$var$isInRange(date, selectedRange) && isCurrentMonth,
                isEdgeOfRange: isCurrentMonth ? $0abbbd36a260e067$var$isEdgeOfRange(date, selectedRange) : false,
                isToday: $0abbbd36a260e067$var$isSameDate(date, $0abbbd36a260e067$var$getToday()),
                dayNumber: $0abbbd36a260e067$var$getDate(date),
                disabled: $0abbbd36a260e067$var$isDateDisabled(date, options.min, options.max, options.filter, options.disablePast, options.disableFuture)
            });
            dayNumber++;
        }
        dates.push(week);
    }
    return dates;
}
function $0abbbd36a260e067$var$createMonthViewTemplate(year, selectedYear, selectedMonth, options, monthsInRow) {
    const months = $0abbbd36a260e067$var$getMonthsArray(options, monthsInRow);
    const currentMonth = $0abbbd36a260e067$var$getMonth$1($0abbbd36a260e067$var$getToday());
    const currentYear = $0abbbd36a260e067$var$getYear$1($0abbbd36a260e067$var$getToday());
    const tableBodyContent = `
      ${months.map((row)=>{
        return `
          <tr>
          ${row.map((month)=>{
            const monthIndex = options.monthsShort.indexOf(month);
            const isDisabled2 = $0abbbd36a260e067$var$isMonthDisabled(monthIndex, year, options.min, options.max, options.disablePast, options.disableFuture);
            return `
                <td class="datepicker-cell datepicker-large-cell datepicker-month-cell 
                ${isDisabled2 ? "disabled" : ""} ${monthIndex === selectedMonth && year === selectedYear ? "selected" : ""} ${monthIndex === currentMonth && year === currentYear ? "current" : ""}" data-mdb-month="${monthIndex}" data-mdb-year="${year}" aria-label="${month}, ${year}"  ${isDisabled2 ? "aria-disabled=true" : ""}>
                  <div class="datepicker-cell-content datepicker-large-cell-content">${month}</div>
                </td>
              `;
        }).join("")}
          </tr>
        `;
    }).join("")}
    `;
    return `
      <table class="datepicker-table">
        <tbody class="datepicker-table-body">
         ${tableBodyContent}
        </tbody>
      </table>
    `;
}
function $0abbbd36a260e067$var$getMonthsArray({ monthsShort: monthsShort }, monthsInRow) {
    return monthsShort.reduce((months, month, index)=>{
        const rowIndex = Math.floor(index / monthsInRow);
        if (!months[rowIndex]) months[rowIndex] = [];
        months[rowIndex].push(month);
        return months;
    }, []);
}
function $0abbbd36a260e067$var$createYearViewTemplate(date, selectedYear, options, yearsInView, yearsInRow) {
    const years = $0abbbd36a260e067$var$getYearsArray(date, yearsInView, yearsInRow);
    const currentYear = $0abbbd36a260e067$var$getYear$1($0abbbd36a260e067$var$getToday());
    const tableBodyContent = `
    ${years.map((row)=>{
        return `
        <tr>
          ${row.map((year)=>{
            const isDisabled2 = $0abbbd36a260e067$var$isYearDisabled(year, options.min, options.max, options.disablePast, options.disableFuture);
            return `
              <td class="datepicker-cell datepicker-large-cell datepicker-year-cell
              ${isDisabled2 ? "disabled" : ""} ${year === selectedYear ? "selected" : ""} ${year === currentYear ? "current" : ""}" aria-label="${year}" data-mdb-year="${year}" ${isDisabled2 ? 'aria-disabled="true"' : ""}>
                <div class="datepicker-cell-content datepicker-large-cell-content">${year}</div>
              </td>
            `;
        }).join("")}
        </tr>
      `;
    }).join("")}
  `;
    return `
      <table class="datepicker-table">
        <tbody class="datepicker-table-body">
        ${tableBodyContent}
        </tbody>
      </table>
    `;
}
function $0abbbd36a260e067$var$getYearsArray(date, yearsInView, yearsInRow) {
    const years = [];
    const activeYear = $0abbbd36a260e067$var$getYear$1(date);
    const yearsOffset = $0abbbd36a260e067$var$getYearsOffset(date, yearsInView);
    const firstYearInView = activeYear - yearsOffset;
    let row = [];
    for(let i = 0; i < yearsInView; i++){
        row.push(firstYearInView + i);
        if (row.length === yearsInRow) {
            const yearsRow = row;
            years.push(yearsRow);
            row = [];
        }
    }
    return years;
}
function $0abbbd36a260e067$var$getToggleButtonTemplate(id) {
    return `
    <button id="${id}" type="button" class="datepicker-toggle-button" data-mdb-toggle="datepicker">
      <i class="far fa-calendar datepicker-toggle-icon"></i>
    </button>
  `;
}
const $0abbbd36a260e067$var$YEARS_IN_VIEW = 24;
const $0abbbd36a260e067$var$YEARS_IN_ROW = 4;
const $0abbbd36a260e067$var$MONTHS_IN_ROW = 4;
const $0abbbd36a260e067$var$NAME$m = "datepicker";
const $0abbbd36a260e067$var$DATA_KEY$h = `mdb.${$0abbbd36a260e067$var$NAME$m}`;
const $0abbbd36a260e067$var$DATA_API_KEY = ".data-api";
const $0abbbd36a260e067$var$EVENT_KEY$c = `.${$0abbbd36a260e067$var$DATA_KEY$h}`;
const $0abbbd36a260e067$var$EVENT_CLOSE$3 = `close${$0abbbd36a260e067$var$EVENT_KEY$c}`;
const $0abbbd36a260e067$var$EVENT_OPEN$3 = `open${$0abbbd36a260e067$var$EVENT_KEY$c}`;
const $0abbbd36a260e067$var$EVENT_VALUE_CHANGED$3 = `valueChanged${$0abbbd36a260e067$var$EVENT_KEY$c}`;
const $0abbbd36a260e067$var$EVENT_VIEW_CHANGED = `viewChanged${$0abbbd36a260e067$var$EVENT_KEY$c}`;
const $0abbbd36a260e067$var$EVENT_CLICK_DATA_API = `click${$0abbbd36a260e067$var$EVENT_KEY$c}${$0abbbd36a260e067$var$DATA_API_KEY}`;
const $0abbbd36a260e067$var$BACKDROP_OPEN_ANIMATION_CLASS = "fade-in";
const $0abbbd36a260e067$var$BACKDROP_CLOSE_ANIMATION_CLASS = "fade-out";
const $0abbbd36a260e067$var$CONTAINER_OPEN_ANIMATION_CLASS = "fade-in";
const $0abbbd36a260e067$var$CONTAINER_CLOSE_ANIMATION_CLASS = "fade-out";
const $0abbbd36a260e067$var$CLASS_FORM_ICON_TRAILING = "form-icon-trailing";
const $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$1 = '[data-mdb-toggle="datepicker"]';
const $0abbbd36a260e067$var$SELECTOR_MODAL_CONTAINER = ".datepicker-modal-container";
const $0abbbd36a260e067$var$SELECTOR_DROPDOWN_CONTAINER = ".datepicker-dropdown-container";
const $0abbbd36a260e067$var$SELECTOR_VIEW_CHANGE_BUTTON = ".datepicker-view-change-button";
const $0abbbd36a260e067$var$SELECTOR_PREVIOUS_BUTTON = ".datepicker-previous-button";
const $0abbbd36a260e067$var$SELECTOR_NEXT_BUTTON = ".datepicker-next-button";
const $0abbbd36a260e067$var$SELECTOR_OK_BUTTON = ".datepicker-ok-btn";
const $0abbbd36a260e067$var$SELECTOR_CANCEL_BUTTON = ".datepicker-cancel-btn";
const $0abbbd36a260e067$var$SELECTOR_CLEAR_BUTTON$1 = ".datepicker-clear-btn";
const $0abbbd36a260e067$var$SELECTOR_DATES_CONTAINER = ".datepicker-view";
const $0abbbd36a260e067$var$Default$e = {
    title: "Select date",
    container: "body",
    disablePast: false,
    disableFuture: false,
    monthsFull: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    monthsShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    weekdaysFull: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    weekdaysShort: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    weekdaysNarrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    okBtnText: "Ok",
    clearBtnText: "Clear",
    cancelBtnText: "Cancel",
    okBtnLabel: "Confirm selection",
    clearBtnLabel: "Clear selection",
    cancelBtnLabel: "Cancel selection",
    nextMonthLabel: "Next month",
    prevMonthLabel: "Previous month",
    nextYearLabel: "Next year",
    prevYearLabel: "Previous year",
    nextMultiYearLabel: "Next 24 years",
    prevMultiYearLabel: "Previous 24 years",
    switchToMultiYearViewLabel: "Switch to year list",
    switchToDayViewLabel: "Switch to day list",
    startDate: null,
    startDay: 0,
    format: "dd/mm/yyyy",
    view: "days",
    min: null,
    max: null,
    filter: null,
    inline: false,
    toggleButton: true,
    disableToggleButton: false,
    disableInput: false,
    animations: true,
    confirmDateOnSelect: false,
    removeOkBtn: false,
    removeCancelBtn: false,
    removeClearBtn: false,
    headerTemplate: null,
    headerTemplateModifier: null,
    dateRange: false
};
const $0abbbd36a260e067$var$DefaultType$e = {
    title: "string",
    container: "string",
    disablePast: "boolean",
    disableFuture: "boolean",
    monthsFull: "array",
    monthsShort: "array",
    weekdaysFull: "array",
    weekdaysShort: "array",
    weekdaysNarrow: "array",
    okBtnText: "string",
    clearBtnText: "string",
    cancelBtnText: "string",
    okBtnLabel: "string",
    clearBtnLabel: "string",
    cancelBtnLabel: "string",
    nextMonthLabel: "string",
    prevMonthLabel: "string",
    nextYearLabel: "string",
    prevYearLabel: "string",
    nextMultiYearLabel: "string",
    prevMultiYearLabel: "string",
    switchToMultiYearViewLabel: "string",
    switchToDayViewLabel: "string",
    startDate: "(null|string|date)",
    startDay: "number",
    format: "string",
    view: "string",
    min: "(null|date|string)",
    max: "(null|date|string)",
    filter: "(null|function)",
    inline: "boolean",
    toggleButton: "boolean",
    disableToggleButton: "boolean",
    disableInput: "boolean",
    animations: "boolean",
    confirmDateOnSelect: "boolean",
    removeOkBtn: "boolean",
    removeCancelBtn: "boolean",
    removeClearBtn: "boolean",
    headerTemplate: "(null|string)",
    headerTemplateModifier: "(null|function)",
    dateRange: "boolean"
};
class $0abbbd36a260e067$export$7235422eca03ec90 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options){
        super(element2);
        this._input = $0abbbd36a260e067$var$SelectorEngine$1.findOne("input", this._element);
        this._options = this._getConfig(options);
        this._activeDate = /* @__PURE__ */ new Date();
        this._selectedDate = null;
        this._selectedRange = [];
        this._selectedYear = null;
        this._selectedMonth = null;
        this._firstVisibleMonth = null;
        this._headerDate = null;
        this._headerYear = null;
        this._headerMonth = null;
        this._view = this._options.view;
        this._popper = null;
        this._focusTrap = null;
        this._isOpen = false;
        this._toggleButtonId = this._element.id ? `datepicker-toggle-${this._element.id}` : $0abbbd36a260e067$var$getUID$1("datepicker-toggle-");
        this._animations = !window.matchMedia("(prefers-reduced-motion: reduce)").matches && this._options.animations;
        this._scrollBar = new $0abbbd36a260e067$var$ScrollBarHelper();
        this._init();
        if (this.toggleButton && this._options.disableToggle) this.toggleButton.disabled = "true";
        if (this._options.disableInput) this._input.disabled = "true";
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$m;
    }
    get container() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$SELECTOR_MODAL_CONTAINER}-${this._toggleButtonId}`) || $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$SELECTOR_DROPDOWN_CONTAINER}-${this._toggleButtonId}`);
    }
    get options() {
        return this._options;
    }
    get activeCell() {
        let activeCell;
        if (this._view === "days") activeCell = this._getActiveDayCell();
        if (this._view === "months") activeCell = this._getActiveMonthCell();
        if (this._view === "years") activeCell = this._getActiveYearCell();
        return activeCell;
    }
    get activeDay() {
        return $0abbbd36a260e067$var$getDate(this._activeDate);
    }
    get activeMonth() {
        return $0abbbd36a260e067$var$getMonth$1(this._activeDate);
    }
    get activeYear() {
        return $0abbbd36a260e067$var$getYear$1(this._activeDate);
    }
    get firstYearInView() {
        return this.activeYear - $0abbbd36a260e067$var$getYearsOffset(this._activeDate, $0abbbd36a260e067$var$YEARS_IN_VIEW);
    }
    get lastYearInView() {
        return this.firstYearInView + $0abbbd36a260e067$var$YEARS_IN_VIEW - 1;
    }
    get viewChangeButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_VIEW_CHANGE_BUTTON, this.container);
    }
    get previousButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_PREVIOUS_BUTTON, this.container);
    }
    get nextButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_NEXT_BUTTON, this.container);
    }
    get okButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_OK_BUTTON, this.container);
    }
    get cancelButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_CANCEL_BUTTON, this.container);
    }
    get clearButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_CLEAR_BUTTON$1, this.container);
    }
    get datesContainer() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_DATES_CONTAINER, this.container);
    }
    get toggleButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(".datepicker-toggle-button", this._element);
    }
    get isSelectionCompleted() {
        return !this.options.dateRange || this.isRangeComplete;
    }
    get isRangeComplete() {
        return this._selectedRange.length === 2;
    }
    get hasPartialRange() {
        return this._selectedRange.length === 1;
    }
    get visibleDates() {
        return $0abbbd36a260e067$var$SelectorEngine$1.find("td", this.datesContainer);
    }
    update(options = {}) {
        this._options = this._getConfig({
            ...this._options,
            ...options
        });
    }
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        config = {
            ...$0abbbd36a260e067$var$Default$e,
            ...dataAttributes,
            ...config
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$m, config, $0abbbd36a260e067$var$DefaultType$e);
        if (config.max && typeof config.max === "string") config.max = new Date(config.max);
        if (config.min && typeof config.min === "string") config.min = new Date(config.min);
        if (config.startDay && config.startDay !== 0) {
            const sortedWeekdaysNarrow = this._getNewDaysOrderArray(config);
            config.weekdaysNarrow = sortedWeekdaysNarrow;
        }
        return config;
    }
    _getContainer() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(this._options.container);
    }
    _getNewDaysOrderArray(config) {
        const index = config.startDay;
        const weekdaysNarrow = config.weekdaysNarrow;
        const sortedWeekdays = weekdaysNarrow.slice(index).concat(weekdaysNarrow.slice(0, index));
        return sortedWeekdays;
    }
    _init() {
        if (!this.toggleButton && this._options.toggleButton) this._appendToggleButton();
        this._listenToUserInput();
        this._listenToToggleClick();
        this._listenToToggleKeydown();
    }
    _appendToggleButton() {
        const toggleButton = $0abbbd36a260e067$var$getToggleButtonTemplate(this._toggleButtonId);
        this._element.insertAdjacentHTML("beforeend", toggleButton);
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._input, $0abbbd36a260e067$var$CLASS_FORM_ICON_TRAILING);
    }
    open() {
        if (this._input.readOnly || this._input.disabled) return;
        const openEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_OPEN$3);
        if (this._isOpen || openEvent.defaultPrevented) return;
        this._setInitialDate();
        const backdrop = $0abbbd36a260e067$var$getBackdropTemplate$1();
        const template = $0abbbd36a260e067$var$getDatepickerTemplate(this._activeDate, this._selectedDate, this._selectedYear, this._selectedMonth, this._options, $0abbbd36a260e067$var$MONTHS_IN_ROW, $0abbbd36a260e067$var$YEARS_IN_VIEW, $0abbbd36a260e067$var$YEARS_IN_ROW, this._toggleButtonId, this._selectedRange);
        this._firstVisibleMonth = this._activeDate;
        if (this._options.inline) this._openDropdown(template);
        else {
            this._openModal(backdrop, template);
            this._scrollBar.hide();
        }
        if (this._animations) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.container, "animation");
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.container, $0abbbd36a260e067$var$CONTAINER_OPEN_ANIMATION_CLASS);
            this.container.style.animationDuration = "300ms";
            $0abbbd36a260e067$var$Manipulator$1.addClass(backdrop, "animation");
            $0abbbd36a260e067$var$Manipulator$1.addClass(backdrop, $0abbbd36a260e067$var$BACKDROP_OPEN_ANIMATION_CLASS);
            backdrop.style.animationDuration = "150ms";
        }
        this._setFocusTrap(this.container);
        this._listenToDateSelection();
        this._addControlsListeners();
        this._updateControlsDisabledState();
        this._listenToEscapeClick();
        this._listenToKeyboardNavigation();
        this._listenToDatesContainerFocus();
        this._listenToDatesContainerBlur();
        this._asyncFocusDatesContainer();
        this._updateViewControlsAndAttributes(this._view);
        this._isOpen = true;
        setTimeout(()=>{
            this._listenToOutsideClick();
        }, 0);
    }
    _openDropdown(template) {
        this._popper = $0abbbd36a260e067$var$createPopper(this._input, template, {
            placement: "bottom-start"
        });
        const container = this._getContainer();
        container.appendChild(template);
    }
    _openModal(backdrop, template) {
        const container = this._getContainer();
        container.appendChild(backdrop);
        container.appendChild(template);
    }
    _setFocusTrap(element2) {
        this._focusTrap = new $0abbbd36a260e067$var$FocusTrap2(element2, {
            event: "keydown",
            condition: (event)=>event.key === "Tab"
        });
        this._focusTrap.trap();
    }
    _listenToUserInput() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._input, "input", (event)=>{
            this._handleUserInput(event.target.value);
        });
    }
    _listenToToggleClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API, $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$1, (event)=>{
            event.preventDefault();
            this.open();
        });
    }
    _listenToToggleKeydown() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "keydown", $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$1, (event)=>{
            if (event.keyCode === $0abbbd36a260e067$var$ENTER && !this._isOpen) this.open();
        });
    }
    _listenToDateSelection() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.datesContainer, "click", (e)=>{
            this._handleDateSelection(e);
        });
    }
    _handleDateSelection(e) {
        const dataset = e.target.nodeName === "DIV" ? e.target.parentNode.dataset : e.target.dataset;
        if (!dataset) return;
        const cell = e.target.nodeName === "DIV" ? e.target.parentNode : e.target;
        if (dataset.mdbDate) this._pickDay(dataset.mdbDate, cell);
        if (dataset.mdbMonth && dataset.mdbYear) {
            const month = parseInt(dataset.mdbMonth, 10);
            const year = parseInt(dataset.mdbYear, 10);
            this._pickMonth(month, year);
        }
        if (dataset.mdbYear && !dataset.mdbMonth) {
            const year = parseInt(dataset.mdbYear, 10);
            this._pickYear(year);
        }
        if (!this._options.inline) {
            if (!this.options.dateRange) this._updateHeaderDate(this._activeDate, this._selectedRange);
            else this._updateHeaderDate(this._selectedRange[0], this._selectedRange);
        }
    }
    _updateHeaderDate(date, selectedRange) {
        const headerDateEl = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".datepicker-date-text", this.container);
        const datepickerHeaderContainer = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".datepicker-header", this.container);
        if (this._options.headerTemplate && datepickerHeaderContainer) {
            const day = $0abbbd36a260e067$var$getDate(date);
            const dayNumber = $0abbbd36a260e067$var$getDayNumber(date);
            const month = $0abbbd36a260e067$var$getMonth$1(date);
            datepickerHeaderContainer.innerHTML = $0abbbd36a260e067$var$createCustomHeader(day, dayNumber, month, date, this._options);
            return;
        }
        headerDateEl.innerHTML = $0abbbd36a260e067$var$createTitle(date, selectedRange, this._options);
    }
    _addControlsListeners() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.nextButton, "click", ()=>{
            if (this._view === "days") this.nextMonth();
            else if (this._view === "years") this.nextYears();
            else this.nextYear();
            this._updateControlsDisabledState();
        });
        $0abbbd36a260e067$var$EventHandler$1.on(this.previousButton, "click", ()=>{
            if (this._view === "days") this.previousMonth();
            else if (this._view === "years") this.previousYears();
            else this.previousYear();
            this._updateControlsDisabledState();
        });
        $0abbbd36a260e067$var$EventHandler$1.on(this.viewChangeButton, "click", ()=>{
            if (this._view === "days") this._changeView("years");
            else if (this._view === "years" || this._view === "months") this._changeView("days");
        });
        if (!this._options.inline) this._listenToFooterButtonsClick();
    }
    _listenToFooterButtonsClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.okButton, "click", ()=>this.handleOk());
        $0abbbd36a260e067$var$EventHandler$1.on(this.cancelButton, "click", ()=>this.handleCancel());
        $0abbbd36a260e067$var$EventHandler$1.on(this.clearButton, "click", ()=>this.handleClear());
    }
    _listenToOutsideClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(document, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API, (e)=>{
            var _a;
            const isContainer = e.target === this.container;
            const isContainerContent = (_a = this.container) == null ? void 0 : _a.contains(e.target);
            if (!isContainer && !isContainerContent) this._options.dateRange ? this._interruptDateRangeSelection() : this.close();
        });
    }
    _listenToEscapeClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(document, "keydown", (event)=>{
            if (event.keyCode === $0abbbd36a260e067$var$ESCAPE && this._isOpen) this._options.dateRange ? this._interruptDateRangeSelection() : this.close();
        });
    }
    _interruptDateRangeSelection() {
        if (this._options.inline && this.hasPartialRange) {
            this._handleSingleDayRange();
            this.close();
            return;
        }
        this.handleCancel();
    }
    _handleSingleDayRange() {
        this._selectedRange.push(this._selectedRange[0]);
        this._confirmSelection(this._selectedRange[0]);
    }
    _listenToKeyboardNavigation() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.datesContainer, "keydown", (event)=>{
            this._handleKeydown(event);
        });
    }
    _listenToDatesContainerFocus() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.datesContainer, "focus", ()=>{
            this._focusActiveCell(this.activeCell);
        });
    }
    _listenToDatesContainerBlur() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.datesContainer, "blur", ()=>{
            this._removeCurrentFocusStyles();
        });
    }
    _handleKeydown(event) {
        if (this._view === "days") this._handleDaysViewKeydown(event);
        if (this._view === "months") this._handleMonthsViewKeydown(event);
        if (this._view === "years") this._handleYearsViewKeydown(event);
    }
    _handleDaysViewKeydown(event) {
        const oldActiveDate = this._activeDate;
        const previousActiveCell = this.activeCell;
        switch(event.keyCode){
            case $0abbbd36a260e067$var$LEFT_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addDays(this._activeDate, $0abbbd36a260e067$var$isRTL$1 ? 1 : -1);
                break;
            case $0abbbd36a260e067$var$RIGHT_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addDays(this._activeDate, $0abbbd36a260e067$var$isRTL$1 ? -1 : 1);
                break;
            case $0abbbd36a260e067$var$UP_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addDays(this._activeDate, -7);
                break;
            case $0abbbd36a260e067$var$DOWN_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addDays(this._activeDate, 7);
                break;
            case $0abbbd36a260e067$var$HOME:
                this._activeDate = $0abbbd36a260e067$var$addDays(this._activeDate, 1 - $0abbbd36a260e067$var$getDate(this._activeDate));
                break;
            case $0abbbd36a260e067$var$END:
                this._activeDate = $0abbbd36a260e067$var$addDays(this._activeDate, $0abbbd36a260e067$var$getDaysInMonth(this._activeDate) - $0abbbd36a260e067$var$getDate(this._activeDate));
                break;
            case $0abbbd36a260e067$var$PAGE_UP:
                this._activeDate = $0abbbd36a260e067$var$addMonths(this._activeDate, -1);
                break;
            case $0abbbd36a260e067$var$PAGE_DOWN:
                this._activeDate = $0abbbd36a260e067$var$addMonths(this._activeDate, 1);
                break;
            case $0abbbd36a260e067$var$ENTER:
            case $0abbbd36a260e067$var$SPACE:
                this._selectDate(this._activeDate);
                this._handleDateSelection(event);
                event.preventDefault();
                return;
            default:
                return;
        }
        const isDateInSameView = $0abbbd36a260e067$var$areDatesInSameView(oldActiveDate, this._activeDate, this._view) || this._options.dateRange && $0abbbd36a260e067$var$areDatesInSameView($0abbbd36a260e067$var$addMonths(this._firstVisibleMonth, 1), this._activeDate, this._view);
        if (!isDateInSameView) this._changeView("days");
        this._removeHighlightFromCell(previousActiveCell);
        this._focusActiveCell(this.activeCell);
        event.preventDefault();
    }
    _asyncFocusDatesContainer() {
        setTimeout(()=>{
            this.datesContainer.focus();
        }, 0);
    }
    _focusActiveCell(cell) {
        if (cell) $0abbbd36a260e067$var$Manipulator$1.addClass(cell, "focused");
    }
    _removeHighlightFromCell(cell) {
        if (cell) cell.classList.remove("focused");
    }
    _getActiveDayCell() {
        const cells = $0abbbd36a260e067$var$SelectorEngine$1.find("td", this.datesContainer);
        const activeCell = Array.from(cells).find((cell)=>{
            const cellDate = $0abbbd36a260e067$var$convertStringToDate(cell.dataset.mdbDate);
            return $0abbbd36a260e067$var$isSameDate(cellDate, this._activeDate);
        });
        return activeCell;
    }
    _handleMonthsViewKeydown(event) {
        const oldActiveDate = this._activeDate;
        const previousActiveCell = this.activeCell;
        switch(event.keyCode){
            case $0abbbd36a260e067$var$LEFT_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addMonths(this._activeDate, $0abbbd36a260e067$var$isRTL$1 ? 1 : -1);
                break;
            case $0abbbd36a260e067$var$RIGHT_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addMonths(this._activeDate, $0abbbd36a260e067$var$isRTL$1 ? -1 : 1);
                break;
            case $0abbbd36a260e067$var$UP_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addMonths(this._activeDate, -4);
                break;
            case $0abbbd36a260e067$var$DOWN_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addMonths(this._activeDate, 4);
                break;
            case $0abbbd36a260e067$var$HOME:
                this._activeDate = $0abbbd36a260e067$var$addMonths(this._activeDate, -this.activeMonth);
                break;
            case $0abbbd36a260e067$var$END:
                this._activeDate = $0abbbd36a260e067$var$addMonths(this._activeDate, 11 - this.activeMonth);
                break;
            case $0abbbd36a260e067$var$PAGE_UP:
                this._activeDate = $0abbbd36a260e067$var$addYears(this._activeDate, -1);
                break;
            case $0abbbd36a260e067$var$PAGE_DOWN:
                this._activeDate = $0abbbd36a260e067$var$addYears(this._activeDate, 1);
                break;
            case $0abbbd36a260e067$var$ENTER:
            case $0abbbd36a260e067$var$SPACE:
                this._selectMonth(this.activeMonth);
                return;
            default:
                return;
        }
        if (!$0abbbd36a260e067$var$areDatesInSameView(oldActiveDate, this._activeDate, this._view, $0abbbd36a260e067$var$YEARS_IN_VIEW, this._options.min, this._options.max)) this._changeView("months");
        this._removeHighlightFromCell(previousActiveCell);
        this._focusActiveCell(this.activeCell);
        event.preventDefault();
    }
    _getActiveMonthCell() {
        const cells = $0abbbd36a260e067$var$SelectorEngine$1.find("td", this.datesContainer);
        const activeCell = Array.from(cells).find((cell)=>{
            const cellYear = parseInt(cell.dataset.mdbYear, 10);
            const cellMonth = parseInt(cell.dataset.mdbMonth, 10);
            return cellYear === this.activeYear && cellMonth === this.activeMonth;
        });
        return activeCell;
    }
    _handleYearsViewKeydown(event) {
        const oldActiveDate = this._activeDate;
        const previousActiveCell = this.activeCell;
        const yearsPerRow = 4;
        const yearsPerPage = 24;
        switch(event.keyCode){
            case $0abbbd36a260e067$var$LEFT_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addYears(this._activeDate, $0abbbd36a260e067$var$isRTL$1 ? 1 : -1);
                break;
            case $0abbbd36a260e067$var$RIGHT_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addYears(this._activeDate, $0abbbd36a260e067$var$isRTL$1 ? -1 : 1);
                break;
            case $0abbbd36a260e067$var$UP_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addYears(this._activeDate, -yearsPerRow);
                break;
            case $0abbbd36a260e067$var$DOWN_ARROW:
                this._activeDate = $0abbbd36a260e067$var$addYears(this._activeDate, yearsPerRow);
                break;
            case $0abbbd36a260e067$var$HOME:
                this._activeDate = $0abbbd36a260e067$var$addYears(this._activeDate, -$0abbbd36a260e067$var$getYearsOffset(this._activeDate, yearsPerPage));
                break;
            case $0abbbd36a260e067$var$END:
                this._activeDate = $0abbbd36a260e067$var$addYears(this._activeDate, yearsPerPage - $0abbbd36a260e067$var$getYearsOffset(this._activeDate, yearsPerPage) - 1);
                break;
            case $0abbbd36a260e067$var$PAGE_UP:
                this._activeDate = $0abbbd36a260e067$var$addYears(this._activeDate, -yearsPerPage);
                break;
            case $0abbbd36a260e067$var$PAGE_DOWN:
                this._activeDate = $0abbbd36a260e067$var$addYears(this._activeDate, yearsPerPage);
                break;
            case $0abbbd36a260e067$var$ENTER:
            case $0abbbd36a260e067$var$SPACE:
                this._selectYear(this.activeYear);
                return;
            default:
                return;
        }
        if (!$0abbbd36a260e067$var$areDatesInSameView(oldActiveDate, this._activeDate, this._view, $0abbbd36a260e067$var$YEARS_IN_VIEW, this._options.min, this._options.max)) this._changeView("years");
        this._removeHighlightFromCell(previousActiveCell);
        this._focusActiveCell(this.activeCell);
        event.preventDefault();
    }
    _getActiveYearCell() {
        const cells = $0abbbd36a260e067$var$SelectorEngine$1.find("td", this.datesContainer);
        const activeCell = Array.from(cells).find((cell)=>{
            const cellYear = parseInt(cell.dataset.mdbYear, 10);
            return cellYear === this.activeYear;
        });
        return activeCell;
    }
    _setInitialDate() {
        if (this._input.value) this._handleUserInput(this._input.value);
        else if (this._options.startDate) this._activeDate = new Date(this._options.startDate);
        else this._activeDate = /* @__PURE__ */ new Date();
    }
    close() {
        const closeEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CLOSE$3);
        if (!this._isOpen || closeEvent.defaultPrevented) return;
        this._removeDatepickerListeners();
        if (this._animations) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.container, "animation");
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.container, $0abbbd36a260e067$var$CONTAINER_CLOSE_ANIMATION_CLASS);
        }
        if (this._options.inline) this._closeDropdown();
        else this._closeModal();
        this._isOpen = false;
        this._view = this._options.view;
        if (this.toggleButton) this.toggleButton.focus();
        else this._input.focus();
    }
    _closeDropdown() {
        const datepicker = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".datepicker-dropdown-container");
        const container = this._getContainer();
        if (this._animations) datepicker.addEventListener("animationend", ()=>{
            if (datepicker) container.removeChild(datepicker);
            if (this._popper) this._popper.destroy();
        });
        else {
            if (datepicker) container.removeChild(datepicker);
            if (this._popper) this._popper.destroy();
        }
        this._removeFocusTrap();
    }
    _closeModal() {
        const backdrop = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".datepicker-backdrop");
        const datepicker = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".datepicker-modal-container");
        if (!datepicker || !backdrop) return;
        if (this._animations) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(backdrop, "animation");
            $0abbbd36a260e067$var$Manipulator$1.addClass(backdrop, $0abbbd36a260e067$var$BACKDROP_CLOSE_ANIMATION_CLASS);
        }
        if (this._animations) backdrop.addEventListener("animationend", ()=>{
            this._removePicker(backdrop, datepicker);
            this._scrollBar.reset();
        });
        else {
            this._removePicker(backdrop, datepicker);
            this._scrollBar.reset();
        }
    }
    _removePicker(backdrop, datepicker) {
        const container = this._getContainer();
        container.removeChild(backdrop);
        container.removeChild(datepicker);
    }
    _removeFocusTrap() {
        if (this._focusTrap) {
            this._focusTrap.disable();
            this._focusTrap = null;
        }
    }
    _removeDatepickerListeners() {
        $0abbbd36a260e067$var$EventHandler$1.off(this.nextButton, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(this.previousButton, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(this.viewChangeButton, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(this.okButton, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(this.cancelButton, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(this.clearButton, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(this.datesContainer, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(this.datesContainer, "keydown");
        $0abbbd36a260e067$var$EventHandler$1.off(this.datesContainer, "focus");
        $0abbbd36a260e067$var$EventHandler$1.off(this.datesContainer, "blur");
        $0abbbd36a260e067$var$EventHandler$1.off(document, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API);
    }
    dispose() {
        if (this._isOpen) this.close();
        this._removeInputAndToggleListeners();
        const generatedToggleButton = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`#${this._toggleButtonId}`);
        if (generatedToggleButton) this._element.removeChild(generatedToggleButton);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    _removeInputAndToggleListeners() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._input, "input");
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_CLICK_DATA_API, $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$1);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "keydown", $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE$1);
    }
    handleOk() {
        if (this.hasPartialRange) this._handleSingleDayRange();
        else if (this.isRangeComplete) this._confirmSelection(this._selectedRange[0]);
        else this._confirmSelection(this._headerDate);
        this.close();
    }
    _selectDate(date, cell = this.activeCell) {
        const { min: min2, max: max2, filter: filter, disablePast: disablePast, disableFuture: disableFuture, inline: inline, confirmDateOnSelect: confirmDateOnSelect, dateRange: dateRange } = this._options;
        if ($0abbbd36a260e067$var$isDateDisabled(date, min2, max2, filter, disablePast, disableFuture)) return;
        this._removeCurrentFocusStyles();
        dateRange ? this._handleDateRangeSelection(date, cell) : this._handleSingleDateSelection(date, cell);
        if (inline || confirmDateOnSelect) {
            this._confirmSelection(date);
            if (this.isSelectionCompleted) this.close();
        }
    }
    _handleSingleDateSelection(date, cell) {
        this._removeCurrentStyle("selected");
        this._selectedDate = date;
        this._selectedYear = $0abbbd36a260e067$var$getYear$1(date);
        this._selectedMonth = $0abbbd36a260e067$var$getMonth$1(date);
        this._addSelectedStyles(cell);
        this._headerDate = date;
    }
    _handleDateRangeSelection(date, cell) {
        if (this.isRangeComplete) {
            this._resetDateRangeStyles();
            this._selectedRange = [];
            this._selectedRange.push(date);
        } else if (this.hasPartialRange) {
            this._selectedRange.push(date);
            this._selectedRange.sort($0abbbd36a260e067$var$compareDates);
            this._addDateRangeStyles();
        } else if (this._selectedRange.length === 0) {
            this._selectedRange.push(date);
            this._headerDate = [
                date
            ];
        }
        this._addSelectedStyles(cell);
    }
    _resetDateRangeStyles() {
        const stylesToRemove = [
            "selected",
            "in-range",
            "first-in-range",
            "last-in-range"
        ];
        stylesToRemove.forEach((style)=>this._removeCurrentStyle(style));
    }
    _selectYear(year, cell = this.activeCell) {
        this._removeCurrentStyle("selected");
        this._removeCurrentFocusStyles();
        this._addSelectedStyles(cell);
        this._headerYear = year;
        this._asyncChangeView("months");
    }
    _selectMonth(month, cell = this.activeCell) {
        this._removeCurrentStyle("selected");
        this._removeCurrentFocusStyles();
        this._addSelectedStyles(cell);
        this._headerMonth = month;
        this._asyncChangeView("days");
    }
    _removeSelectedStyles(cell) {
        if (cell) cell.classList.remove("selected");
    }
    _addSelectedStyles(cell) {
        if (cell) $0abbbd36a260e067$var$Manipulator$1.addClass(cell, "selected");
    }
    _addDateRangeStyles() {
        const firstDate = this._selectedRange[0];
        const lastDate = this._selectedRange[1];
        if ($0abbbd36a260e067$var$isSameDate(firstDate, lastDate)) return;
        this.visibleDates.forEach((cell)=>{
            const cellDate = $0abbbd36a260e067$var$convertStringToDate(cell.dataset.mdbDate);
            if ($0abbbd36a260e067$var$isSameDate(cellDate, firstDate)) $0abbbd36a260e067$var$Manipulator$1.addClass(cell, "first-in-range");
            if ($0abbbd36a260e067$var$isSameDate(cellDate, lastDate)) $0abbbd36a260e067$var$Manipulator$1.addClass(cell, "last-in-range");
            if ($0abbbd36a260e067$var$isInRange(cellDate, [
                firstDate,
                lastDate
            ])) $0abbbd36a260e067$var$Manipulator$1.addClass(cell, "in-range");
        });
    }
    _confirmSelection(date) {
        if (date) {
            let dateString;
            if (this._options.dateRange) {
                if (this.hasPartialRange) dateString = `${this.formatDate(this._selectedRange[0])} - `;
                else if (this.isRangeComplete) dateString = `${this.formatDate(this._selectedRange[0])} - ${this.formatDate(this._selectedRange[1])}`;
            } else dateString = this.formatDate(date);
            this._input.value = dateString;
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._input, "active");
            if (this.isSelectionCompleted) $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED$3, {
                date: this._options.dateRange ? this._selectedRange : date
            });
        }
    }
    handleCancel() {
        this._selectedRange = [];
        this._selectedDate = null;
        this._selectedYear = null;
        this._selectedMonth = null;
        this.close();
    }
    handleClear() {
        this._selectedRange = [];
        this._selectedDate = null;
        this._selectedMonth = null;
        this._selectedYear = null;
        this._headerDate = null;
        this._headerMonth = null;
        this._headerYear = null;
        this._removeCurrentStyle("selected");
        if (this.options.dateRange) this._resetDateRangeStyles();
        this._input.value = "";
        this._input.classList.remove("active");
        this._setInitialDate();
        this._changeView("days");
        this._updateHeaderDate(this._activeDate, this._selectedRange);
    }
    _removeCurrentStyle(style) {
        const currentSelected = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${style}`, this.container);
        if (currentSelected) currentSelected.forEach((el)=>{
            el.classList.remove(`${style}`);
        });
    }
    _removeCurrentFocusStyles() {
        const currentFocused = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".focused", this.container);
        if (currentFocused) currentFocused.classList.remove("focused");
    }
    formatDate(date) {
        const d = $0abbbd36a260e067$var$getDate(date);
        const dd = this._addLeadingZero($0abbbd36a260e067$var$getDate(date));
        const ddd = this._options.weekdaysShort[$0abbbd36a260e067$var$getDayNumber(date)];
        const dddd = this._options.weekdaysFull[$0abbbd36a260e067$var$getDayNumber(date)];
        const m = $0abbbd36a260e067$var$getMonth$1(date) + 1;
        const mm = this._addLeadingZero($0abbbd36a260e067$var$getMonth$1(date) + 1);
        const mmm = this._options.monthsShort[$0abbbd36a260e067$var$getMonth$1(date)];
        const mmmm = this._options.monthsFull[$0abbbd36a260e067$var$getMonth$1(date)];
        const yy = $0abbbd36a260e067$var$getYear$1(date).toString().length === 2 ? $0abbbd36a260e067$var$getYear$1(date) : $0abbbd36a260e067$var$getYear$1(date).toString().slice(2, 4);
        const yyyy = $0abbbd36a260e067$var$getYear$1(date);
        const preformatted = this._options.format.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
        let formatted = "";
        preformatted.forEach((datePart)=>{
            switch(datePart){
                case "dddd":
                    datePart = datePart.replace(datePart, dddd);
                    break;
                case "ddd":
                    datePart = datePart.replace(datePart, ddd);
                    break;
                case "dd":
                    datePart = datePart.replace(datePart, dd);
                    break;
                case "d":
                    datePart = datePart.replace(datePart, d);
                    break;
                case "mmmm":
                    datePart = datePart.replace(datePart, mmmm);
                    break;
                case "mmm":
                    datePart = datePart.replace(datePart, mmm);
                    break;
                case "mm":
                    datePart = datePart.replace(datePart, mm);
                    break;
                case "m":
                    datePart = datePart.replace(datePart, m);
                    break;
                case "yyyy":
                    datePart = datePart.replace(datePart, yyyy);
                    break;
                case "yy":
                    datePart = datePart.replace(datePart, yy);
                    break;
            }
            formatted += datePart;
        });
        return formatted;
    }
    _addLeadingZero(value) {
        return parseInt(value, 10) < 10 ? `0${value}` : value;
    }
    _pickDay(day, el) {
        const date = $0abbbd36a260e067$var$convertStringToDate(day);
        const { min: min2, max: max2, filter: filter, disablePast: disablePast, disableFuture: disableFuture } = this._options;
        if ($0abbbd36a260e067$var$isDateDisabled(date, min2, max2, filter, disablePast, disableFuture)) return;
        this._activeDate = date;
        this._selectDate(date, el);
    }
    _pickYear(year) {
        const { min: min2, max: max2, disablePast: disablePast, disableFuture: disableFuture } = this._options;
        if ($0abbbd36a260e067$var$isYearDisabled(year, min2, max2, disablePast, disableFuture)) return;
        const newDate = $0abbbd36a260e067$var$createDate(year, this.activeMonth, this.activeDay);
        this._activeDate = newDate;
        this._selectedDate = newDate;
        this._selectYear(year);
    }
    _pickMonth(month, year) {
        const { min: min2, max: max2, disablePast: disablePast, disableFuture: disableFuture } = this._options;
        if ($0abbbd36a260e067$var$isMonthDisabled(month, year, min2, max2, disablePast, disableFuture) || $0abbbd36a260e067$var$isYearDisabled(year, min2, max2, disablePast, disableFuture)) return;
        const newDate = $0abbbd36a260e067$var$createDate(year, month, this.activeDay);
        this._activeDate = newDate;
        this._selectMonth(month);
    }
    nextMonth() {
        const nextMonth = this.options.dateRange ? $0abbbd36a260e067$var$addMonths(this._firstVisibleMonth, 1) : $0abbbd36a260e067$var$addMonths(this._activeDate, 1);
        this._activeDate = nextMonth;
        this._firstVisibleMonth = nextMonth;
        const headerDate = this.options.dateRange ? this._selectedRange : this._headerDate;
        const template = $0abbbd36a260e067$var$createDayViewTemplate(nextMonth, headerDate, this._options, this._selectedRange);
        this.viewChangeButton.textContent = `${this._options.monthsFull[this.activeMonth]} ${this.activeYear}`;
        this.datesContainer.innerHTML = template;
    }
    previousMonth() {
        const previousMonth = this.options.dateRange ? $0abbbd36a260e067$var$addMonths(this._firstVisibleMonth, -1) : $0abbbd36a260e067$var$addMonths(this._activeDate, -1);
        this._activeDate = previousMonth;
        this._firstVisibleMonth = previousMonth;
        const headerDate = this.options.dateRange ? this._selectedRange : this._headerDate;
        const template = $0abbbd36a260e067$var$createDayViewTemplate(previousMonth, headerDate, this._options, this._selectedRange);
        this.viewChangeButton.textContent = `${this._options.monthsFull[this.activeMonth]} ${this.activeYear}`;
        this.datesContainer.innerHTML = template;
    }
    nextYear() {
        const nextYear = $0abbbd36a260e067$var$addYears(this._activeDate, 1);
        this._activeDate = nextYear;
        this.viewChangeButton.textContent = `${this.activeYear}`;
        const template = $0abbbd36a260e067$var$createMonthViewTemplate(this.activeYear, this._selectedYear, this._selectedMonth, this._options, $0abbbd36a260e067$var$MONTHS_IN_ROW);
        this.datesContainer.innerHTML = template;
    }
    previousYear() {
        const previousYear = $0abbbd36a260e067$var$addYears(this._activeDate, -1);
        this._activeDate = previousYear;
        this.viewChangeButton.textContent = `${this.activeYear}`;
        const template = $0abbbd36a260e067$var$createMonthViewTemplate(this.activeYear, this._selectedYear, this._selectedMonth, this._options, $0abbbd36a260e067$var$MONTHS_IN_ROW);
        this.datesContainer.innerHTML = template;
    }
    nextYears() {
        const nextYear = $0abbbd36a260e067$var$addYears(this._activeDate, 24);
        this._activeDate = nextYear;
        const template = $0abbbd36a260e067$var$createYearViewTemplate(nextYear, this._selectedYear, this._options, $0abbbd36a260e067$var$YEARS_IN_VIEW, $0abbbd36a260e067$var$YEARS_IN_ROW);
        this.viewChangeButton.textContent = `${this.firstYearInView} - ${this.lastYearInView}`;
        this.datesContainer.innerHTML = template;
    }
    previousYears() {
        const previousYear = $0abbbd36a260e067$var$addYears(this._activeDate, -24);
        this._activeDate = previousYear;
        const template = $0abbbd36a260e067$var$createYearViewTemplate(previousYear, this._selectedYear, this._options, $0abbbd36a260e067$var$YEARS_IN_VIEW, $0abbbd36a260e067$var$YEARS_IN_ROW);
        this.viewChangeButton.textContent = `${this.firstYearInView} - ${this.lastYearInView}`;
        this.datesContainer.innerHTML = template;
    }
    _asyncChangeView(view) {
        setTimeout(()=>{
            this._changeView(view);
        }, 0);
    }
    _changeView(view) {
        this._view = view;
        this.datesContainer.blur();
        const selectedDate = this.options.dateRange ? this._selectedRange : this._headerDate;
        if (view === "days") this.datesContainer.innerHTML = $0abbbd36a260e067$var$createDayViewTemplate(this._activeDate, selectedDate, this._options, this._selectedRange);
        if (view === "months") this.datesContainer.innerHTML = $0abbbd36a260e067$var$createMonthViewTemplate(this.activeYear, this._selectedYear, this._selectedMonth, this._options, $0abbbd36a260e067$var$MONTHS_IN_ROW);
        if (view === "years") this.datesContainer.innerHTML = $0abbbd36a260e067$var$createYearViewTemplate(this._activeDate, this._selectedYear, this._options, $0abbbd36a260e067$var$YEARS_IN_VIEW, $0abbbd36a260e067$var$YEARS_IN_ROW);
        this._firstVisibleMonth = this._activeDate;
        this.datesContainer.focus();
        this._updateViewControlsAndAttributes(view);
        this._updateControlsDisabledState();
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_VIEW_CHANGED, {
            view: this._view
        });
    }
    _updateViewControlsAndAttributes(view) {
        if (view === "days") {
            this.viewChangeButton.textContent = `${this._options.monthsFull[this.activeMonth]} ${this.activeYear}`;
            this.viewChangeButton.setAttribute("aria-label", this._options.switchToMultiYearViewLabel);
            this.previousButton.setAttribute("aria-label", this._options.prevMonthLabel);
            this.nextButton.setAttribute("aria-label", this._options.nextMonthLabel);
        }
        if (view === "months") {
            this.viewChangeButton.textContent = `${this.activeYear}`;
            this.viewChangeButton.setAttribute("aria-label", this._options.switchToDayViewLabel);
            this.previousButton.setAttribute("aria-label", this._options.prevYearLabel);
            this.nextButton.setAttribute("aria-label", this._options.nextYearLabel);
        }
        if (view === "years") {
            this.viewChangeButton.textContent = `${this.firstYearInView} - ${this.lastYearInView}`;
            this.viewChangeButton.setAttribute("aria-label", this._options.switchToDayViewLabel);
            this.previousButton.setAttribute("aria-label", this._options.prevMultiYearLabel);
            this.nextButton.setAttribute("aria-label", this._options.nextMultiYearLabel);
        }
    }
    _updateControlsDisabledState() {
        if ($0abbbd36a260e067$var$isNextDateDisabled(this._options.disableFuture, this._activeDate, this._view, $0abbbd36a260e067$var$YEARS_IN_VIEW, this._options.min, this._options.max, this.lastYearInView, this.firstYearInView)) this.nextButton.disabled = true;
        else this.nextButton.disabled = false;
        if ($0abbbd36a260e067$var$isPreviousDateDisabled(this._options.disablePast, this._activeDate, this._view, $0abbbd36a260e067$var$YEARS_IN_VIEW, this._options.min, this._options.max, this.lastYearInView, this.firstYearInView)) this.previousButton.disabled = true;
        else this.previousButton.disabled = false;
    }
    _handleUserInput(input) {
        const delimeters = this._getDelimeters(this._options.format);
        let areDatesChronological;
        let dates;
        let firstDateValid;
        let secondDateValid;
        if (this.options.dateRange) {
            dates = input.split(" - ");
            dates = dates.map((date2)=>this._parseDate(date2, this._options.format, delimeters));
            firstDateValid = $0abbbd36a260e067$var$isValidDate$1(dates[0]);
            secondDateValid = (dates == null ? void 0 : dates.length) > 1 ? $0abbbd36a260e067$var$isValidDate$1(dates[1]) : false;
            if (firstDateValid && dates.length === 1) {
                dates.push(dates[0]);
                secondDateValid = true;
            }
            if (firstDateValid && secondDateValid) areDatesChronological = $0abbbd36a260e067$var$compareDates(dates[0], dates[1]) <= 0;
        }
        const date = this._parseDate(input, this._options.format, delimeters);
        if ($0abbbd36a260e067$var$isValidDate$1(date) && !this.options.dateRange) this._setDate(date);
        else if (firstDateValid && secondDateValid && areDatesChronological) this._setDate(dates);
        else {
            this._activeDate = this._options.startDate ? new Date(this._options.startDate) : /* @__PURE__ */ new Date();
            this._selectedRange = [];
            this._selectedDate = null;
            this._selectedMonth = null;
            this._selectedYear = null;
            this._headerDate = null;
            this._headerMonth = null;
            this._headerYear = null;
        }
    }
    _setDate(dateOrDates) {
        if (this.options.dateRange) {
            const [startDate, endDate] = dateOrDates;
            this._activeDate = startDate;
            this._selectedDate = [
                startDate,
                endDate
            ];
            this._selectedYear = [
                $0abbbd36a260e067$var$getYear$1(startDate),
                $0abbbd36a260e067$var$getYear$1(endDate)
            ];
            this._selectedMonth = [
                $0abbbd36a260e067$var$getMonth$1(startDate),
                $0abbbd36a260e067$var$getMonth$1(endDate)
            ];
            this._selectedRange = [
                startDate,
                endDate
            ];
        } else {
            this._activeDate = dateOrDates;
            this._selectedDate = dateOrDates;
            this._selectedYear = $0abbbd36a260e067$var$getYear$1(dateOrDates);
            this._selectedMonth = $0abbbd36a260e067$var$getMonth$1(dateOrDates);
            this._headerDate = dateOrDates;
        }
    }
    _getDelimeters(format) {
        return format.match(/[^(dmy)]{1,}/g);
    }
    _parseDate(dateString, format, delimeters) {
        let delimeterPattern;
        if (delimeters[0] !== delimeters[1]) delimeterPattern = delimeters[0] + delimeters[1];
        else delimeterPattern = delimeters[0];
        const regExp = new RegExp(`[${delimeterPattern}]`);
        const dateParts = dateString.split(regExp);
        const formatParts = format.split(regExp);
        const isMonthString = format.indexOf("mmm") !== -1;
        const datesArray = [];
        for(let i = 0; i < formatParts.length; i++){
            if (formatParts[i].indexOf("yy") !== -1) datesArray[0] = {
                value: dateParts[i],
                format: formatParts[i]
            };
            if (formatParts[i].indexOf("m") !== -1) datesArray[1] = {
                value: dateParts[i],
                format: formatParts[i]
            };
            if (formatParts[i].indexOf("d") !== -1 && formatParts[i].length <= 2) datesArray[2] = {
                value: dateParts[i],
                format: formatParts[i]
            };
        }
        let monthsNames;
        if (format.indexOf("mmmm") !== -1) monthsNames = this._options.monthsFull;
        else monthsNames = this._options.monthsShort;
        const year = Number(datesArray[0].value);
        const month = isMonthString ? this.getMonthNumberByMonthName(datesArray[1].value, monthsNames) : Number(datesArray[1].value) - 1;
        const day = Number(datesArray[2].value);
        const parsedDate = $0abbbd36a260e067$var$createDate(year, month, day);
        return parsedDate;
    }
    getMonthNumberByMonthName(monthValue, monthLabels) {
        return monthLabels.findIndex((monthLabel)=>monthLabel === monthValue);
    }
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$h);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$7235422eca03ec90(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$l = "popconfirm";
const $0abbbd36a260e067$var$DATA_KEY$g = "mdb.popconfirm";
const $0abbbd36a260e067$var$SELECTOR_POPCONFIRM_BODY = ".popconfirm";
const $0abbbd36a260e067$var$EVENT_KEY$b = `.${$0abbbd36a260e067$var$DATA_KEY$g}`;
const $0abbbd36a260e067$var$EVENT_CANCEL = `cancel${$0abbbd36a260e067$var$EVENT_KEY$b}`;
const $0abbbd36a260e067$var$EVENT_CONFIRM = `confirm${$0abbbd36a260e067$var$EVENT_KEY$b}`;
const $0abbbd36a260e067$var$DefaultType$d = {
    popconfirmMode: "string",
    message: "string",
    cancelText: "string",
    okText: "string",
    okClass: "string",
    cancelClass: "string",
    popconfirmIcon: "string",
    cancelLabel: "string",
    confirmLabel: "string",
    position: "string"
};
const $0abbbd36a260e067$var$Default$d = {
    popconfirmMode: "inline",
    message: "Are you sure?",
    cancelText: "Cancel",
    okText: "OK",
    okClass: "btn-primary",
    cancelClass: "btn-secondary",
    popconfirmIcon: "",
    cancelLabel: "Cancel",
    confirmLabel: "Confirm",
    position: "bottom"
};
class $0abbbd36a260e067$export$154a38f911af10de extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options){
        super(element2);
        this._options = this._getConfig(options);
        this._cancelButtonTemplate = this._getCancelButtonTemplate();
        this._popper = null;
        this._cancelButton = "";
        this._confirmButton = "";
        this._isOpen = false;
        this._uid = this._element.id ? `popconfirm-${this._element.id}` : $0abbbd36a260e067$var$getUID$1("popconfirm-");
        this._focusTrap = null;
        this._scrollBar = new $0abbbd36a260e067$var$ScrollBarHelper();
        this._clickHandler = this.open.bind(this);
        this._escapeKeydownHandler = this._handleEscapeKey.bind(this);
        this._outsideClickHandler = this._handleOutsideClick.bind(this);
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "click", this._clickHandler);
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$l;
    }
    get container() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(`#${this._uid}`);
    }
    get popconfirmBody() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_POPCONFIRM_BODY, this.container);
    }
    // Public
    dispose() {
        if (this._isOpen || this.container !== null) this.close();
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "click", this._clickHandler);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        const timeout = this._isOpen && this._options.popconfirmMode === "inline" ? 155 : 0;
        setTimeout(()=>{
            super.dispose();
        }, timeout);
    }
    open() {
        if (this._isOpen) return;
        if (this._options.popconfirmMode === "inline") this._openPopover(this._getPopoverTemplate());
        else {
            this._openModal(this._getModalTemplate());
            this._scrollBar.hide();
        }
        this._handleCancelButtonClick();
        this._handleConfirmButtonClick();
        this._listenToEscapeKey();
        this._listenToOutsideClick();
    }
    close() {
        if (!this._isOpen) return;
        if (this._popper !== null || $0abbbd36a260e067$var$SelectorEngine$1.findOne(".popconfirm-popover") !== null) {
            $0abbbd36a260e067$var$EventHandler$1.on(this.popconfirmBody, "transitionend", this._handlePopconfirmTransitionEnd.bind(this));
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this.popconfirmBody, "show");
        } else {
            const tempElement = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".popconfirm-backdrop");
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this.popconfirmBody, "show");
            document.body.removeChild(tempElement);
            this._isOpen = false;
        }
        this._removeFocusTrap();
        this._scrollBar.reset();
        this._element.focus();
        $0abbbd36a260e067$var$EventHandler$1.off(document, "click", this._outsideClickHandler);
        $0abbbd36a260e067$var$EventHandler$1.off(document, "keydown", this._escapeKeydownHandler);
    }
    _setFocusTrap(element2) {
        this._focusTrap = new $0abbbd36a260e067$var$FocusTrap2(element2, {
            event: "keydown",
            condition: (event)=>event.key === "Tab"
        });
        this._focusTrap.trap();
        const cancelButton = $0abbbd36a260e067$var$SelectorEngine$1.findOne("#popconfirm-button-cancel", element2);
        const confirmButton = $0abbbd36a260e067$var$SelectorEngine$1.findOne("#popconfirm-button-confirm", element2);
        if (cancelButton) cancelButton.focus();
        else confirmButton.focus();
    }
    _removeFocusTrap() {
        if (this._focusTrap) {
            this._focusTrap.disable();
            this._focusTrap = null;
        }
    }
    _handlePopconfirmTransitionEnd(event) {
        if (event.target !== this.popconfirmBody) return;
        const popoverTemplate = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".popconfirm-popover");
        $0abbbd36a260e067$var$EventHandler$1.off(this.popconfirmBody, "transitionend");
        if (this._isOpen && event && event.propertyName === "opacity") {
            this._popper.destroy();
            if (popoverTemplate) document.body.removeChild(popoverTemplate);
            this._isOpen = false;
        }
    }
    // Private
    _getPopoverTemplate() {
        const popover = $0abbbd36a260e067$var$element("div");
        const popconfirmTemplate = this._getPopconfirmTemplate();
        $0abbbd36a260e067$var$Manipulator$1.addClass(popover, "popconfirm-popover");
        $0abbbd36a260e067$var$Manipulator$1.addClass(popover, "shadow-2");
        popover.id = this._uid;
        popover.innerHTML = popconfirmTemplate;
        return popover;
    }
    _getModalTemplate() {
        const modal = $0abbbd36a260e067$var$element("div");
        const popconfirmTemplate = this._getPopconfirmTemplate();
        $0abbbd36a260e067$var$Manipulator$1.addClass(modal, "popconfirm-modal");
        $0abbbd36a260e067$var$Manipulator$1.addClass(modal, "shadow-2");
        modal.id = this._uid;
        modal.innerHTML = popconfirmTemplate;
        return modal;
    }
    _getPopconfirmTemplate() {
        return `<div class="popconfirm">
      <p class="popconfirm-message">
      ${this._getMessageIcon()}
      <span class="popconfirm-message-text">${this._options.message}</span>
      </p>
      <div class="popconfirm-buttons-container">
      ${this._cancelButtonTemplate}
      <button type="button" id="popconfirm-button-confirm" data-mdb-ripple-init
      aria-label="${this._options.confirmLabel}"
      class="btn ${this._options.okClass} btn-sm">${this._options.okText}</button>
      </div>
    </div>`;
    }
    _getConfig(config) {
        config = {
            ...$0abbbd36a260e067$var$Default$d,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...config
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$l, config, $0abbbd36a260e067$var$DefaultType$d);
        return config;
    }
    _getCancelButtonTemplate() {
        if (this._options.cancelText === "" || this._options.cancelText === " ") return "";
        return `<button type="button" id="popconfirm-button-cancel" aria-label="${this._options.cancelLabel}"
    class="btn ${this._options.cancelClass} btn-sm" data-mdb-ripple-init >${this._options.cancelText}</button>`;
    }
    _getMessageIcon() {
        if (this._options.popconfirmIcon === "") return "";
        return `<span class="popconfirm-icon-container"><i class="${this._options.popconfirmIcon}"></i></span>`;
    }
    _openPopover(template) {
        this._popper = $0abbbd36a260e067$var$createPopper(this._element, template, {
            placement: this._translatePositionValue(),
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            5
                        ]
                    }
                }
            ]
        });
        document.body.appendChild(template);
        setTimeout(()=>{
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.popconfirmBody, "fade");
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.popconfirmBody, "show");
            this._isOpen = true;
            this._setFocusTrap(this.container);
        }, 0);
    }
    _openModal(template) {
        const backdrop = $0abbbd36a260e067$var$element("div");
        $0abbbd36a260e067$var$Manipulator$1.addClass(backdrop, "popconfirm-backdrop");
        document.body.appendChild(backdrop);
        backdrop.appendChild(template);
        $0abbbd36a260e067$var$Manipulator$1.addClass(this.popconfirmBody, "show");
        this._isOpen = true;
        this._setFocusTrap(this.container);
    }
    _handleCancelButtonClick() {
        const container = this.container;
        this._cancelButton = $0abbbd36a260e067$var$SelectorEngine$1.findOne("#popconfirm-button-cancel", container);
        if (this._cancelButton !== null) $0abbbd36a260e067$var$EventHandler$1.on(this._cancelButton, "click", ()=>{
            this.close();
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CANCEL);
        });
    }
    _handleConfirmButtonClick() {
        const container = this.container;
        this._confirmButton = $0abbbd36a260e067$var$SelectorEngine$1.findOne("#popconfirm-button-confirm", container);
        $0abbbd36a260e067$var$EventHandler$1.on(this._confirmButton, "click", ()=>{
            this.close();
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CONFIRM);
        });
    }
    _listenToEscapeKey() {
        $0abbbd36a260e067$var$EventHandler$1.on(document, "keydown", this._escapeKeydownHandler);
    }
    _handleEscapeKey(event) {
        if (event.keyCode === $0abbbd36a260e067$var$ESCAPE) {
            if (this._isOpen) $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CANCEL);
            this.close();
        }
    }
    _listenToOutsideClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(document, "click", this._outsideClickHandler);
    }
    _handleOutsideClick(event) {
        const container = this.container;
        const isContainer = event.target === container;
        const isContainerContent = container && container.contains(event.target);
        const isElement2 = event.target === this._element;
        const isElementContent = this._element && this._element.contains(event.target);
        if (!isContainer && !isContainerContent && !isElement2 && !isElementContent) {
            if (this._isOpen) $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CANCEL);
            this.close();
        }
    }
    _translatePositionValue() {
        switch(this._options.position){
            case "top left":
                return $0abbbd36a260e067$var$isRTL$1 ? "top-start" : "top-end";
            case "top":
                return "top";
            case "top right":
                return $0abbbd36a260e067$var$isRTL$1 ? "top-end" : "top-start";
            case "bottom left":
                return $0abbbd36a260e067$var$isRTL$1 ? "bottom-start" : "bottom-end";
            case "bottom":
                return "bottom";
            case "bottom right":
                return $0abbbd36a260e067$var$isRTL$1 ? "bottom-end" : "bottom-start";
            case "left":
                return $0abbbd36a260e067$var$isRTL$1 ? "right" : "left";
            case "left top":
                return $0abbbd36a260e067$var$isRTL$1 ? "right-end" : "left-end";
            case "left bottom":
                return $0abbbd36a260e067$var$isRTL$1 ? "right-start" : "left-start";
            case "right":
                return $0abbbd36a260e067$var$isRTL$1 ? "left" : "right";
            case "right top":
                return $0abbbd36a260e067$var$isRTL$1 ? "left-end" : "right-end";
            case "right bottom":
                return $0abbbd36a260e067$var$isRTL$1 ? "left-start" : "right-start";
            case void 0:
                return "bottom";
            default:
                return this._options.position;
        }
    }
    // Static
    static jQueryInterface(config, options) {
        return this.each(function() {
            const data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$g);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) return new $0abbbd36a260e067$export$154a38f911af10de(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
const $0abbbd36a260e067$var$pagination = ({ text: text, entries: entries, entriesOptions: entriesOptions, fullPagination: fullPagination, rowsText: rowsText, allText: allText }, loading)=>{
    const options = entriesOptions.map((option)=>{
        const optionToLowerCase = typeof option === "string" ? option.toLowerCase() : option;
        if (optionToLowerCase === "all") return `<option value="${option}" ${option === entries ? "selected" : ""}>${allText}</option>`;
        return `<option value="${option}" ${option === entries ? "selected" : ""}>${option}</option>`;
    }).join("\n");
    return `
<div class="datatable-pagination">
  <div class="datatable-select-wrapper">
    <p class="datatable-select-text">${rowsText}</p>
    <select name="entries"
      ${loading ? 'data-mdb-disabled="true"' : ""} class="datatable-select select">
      ${options}
    </select>
  </div>
  <div class="datatable-pagination-nav">
  ${text}
  </div>
  <div class="datatable-pagination-buttons">
    ${fullPagination ? '<button data-mdb-ripple-color="dark" data-mdb-ripple-init class="btn btn-link datatable-pagination-button datatable-pagination-start"><i class="fa fa-angle-double-left"></i></button>' : ""}
    <button data-mdb-ripple-color="dark" data-mdb-ripple-init class="btn btn-link datatable-pagination-button datatable-pagination-left"><i class="fa fa-chevron-${$0abbbd36a260e067$var$isRTL$1 ? "right" : "left"}"></i></button>
    <button data-mdb-ripple-color="dark" data-mdb-ripple-init class="btn btn-link datatable-pagination-button datatable-pagination-right"><i class="fa fa-chevron-${$0abbbd36a260e067$var$isRTL$1 ? "left" : "right"}"></i></button>
    ${fullPagination ? '<button data-mdb-ripple-color="dark" data-mdb-ripple-init class="btn btn-link datatable-pagination-button datatable-pagination-end"><i class="fa fa-angle-double-right"></i></button>' : ""}
  </div>
</div>
`;
};
const $0abbbd36a260e067$var$columns = (columns2, selectable, multi)=>{
    const checkboxHeader = multi ? `
<th scope="col">
  <div class="form-check d-flex align-items-center mb-0">
    <input class="datatable-header-checkbox form-check-input" type="checkbox">
  </div>
</th>
` : '<th scope="col"></th>';
    const headers = columns2.map((column, i)=>{
        const fixedOffset = column.fixed ? columns2.filter((cell, j)=>cell.fixed === column.fixed && j < i).reduce((a, b)=>a + b.width, 0) : null;
        return `<th style="${column.fixed ? `${column.fixed === "right" ? "right" : "left"}: ${fixedOffset}px;` : ""}" ${column.fixed ? 'class="fixed-cell"' : ""} scope="col">${column.sort ? `<i data-mdb-sort="${column.field}" class="datatable-sort-icon fas fa-arrow-up"></i>` : ""} ${column.label}</th>`;
    });
    return [
        selectable ? checkboxHeader : "",
        ...headers
    ].join("\n");
};
const $0abbbd36a260e067$var$rows = ({ rows: rows2, columns: columns2, noFoundMessage: noFoundMessage, edit: edit, selectable: selectable, loading: loading })=>{
    const rowsTemplate = rows2.map((row)=>{
        const checkbox = `
    <td data-mdb-field="checkbox">
      <div class="form-check">
        <input data-mdb-row-index="${row.rowIndex}" class="datatable-row-checkbox form-check-input" type="checkbox">
      </div>
    </td>
    `;
        const innerRow = columns2.map((column, i)=>{
            const style = {};
            if (column.width) {
                style["min-width"] = `${column.width - 1}px`;
                style["max-width"] = `${column.width}px`;
                style.width = `${column.width}px`;
            }
            if (column.fixed) {
                const fixedOffset = columns2.filter((cell, j)=>cell.fixed === column.fixed && j < i).reduce((a, b)=>a + b.width, 0);
                style[column.fixed === "right" ? "right" : "left"] = `${fixedOffset}px`;
            }
            const cssText = Object.keys(style).map((property)=>`${property}: ${style[property]}`).join("; ");
            return `<td style="${cssText}" class="${column.fixed ? "fixed-cell" : ""}" data-mdb-field="${column.field}" ${edit && 'contenteditable="true"'}>${row[column.field]}</td>`;
        }).join("");
        return `<tr scope="row" data-mdb-index="${row.rowIndex}">${selectable ? checkbox : ""}${innerRow}</tr>`;
    });
    return rows2.length > 0 || loading ? rowsTemplate.join("\n") : `<tr><td>${noFoundMessage}</td></tr>`;
};
const $0abbbd36a260e067$var$tableTemplate = ({ columns: columns$1, rows: rows$1, noFoundMessage: noFoundMessage, edit: edit, multi: multi, selectable: selectable, loading: loading, loadingMessage: loadingMessage, loaderClass: loaderClass, pagination: pagination$1 })=>{
    const rowsTemplate = $0abbbd36a260e067$var$rows({
        rows: rows$1,
        columns: columns$1,
        noFoundMessage: noFoundMessage,
        edit: edit,
        loading: loading,
        selectable: selectable
    });
    const columnsTemplate = $0abbbd36a260e067$var$columns(columns$1, selectable, multi);
    const table = `
<div class="datatable-inner table-responsive">
  <table class="table datatable-table">
    <thead class="datatable-header">
      <tr>
        ${columnsTemplate}
      </tr>
    </thead>
    <tbody class="datatable-body">
      ${loading ? "" : rowsTemplate}
    </tbody>
  </table>
</div>
  ${loading ? `
  <div class="datatable-loader bg-light}">
    <span class="datatable-loader-inner"><span class="datatable-progress ${loaderClass}"></span></span>
  </div>
  <p class="text-center text-muted my-4">${loadingMessage}</p>
` : ""}
  ${pagination$1.enable ? $0abbbd36a260e067$var$pagination(pagination$1, loading) : ""}
  `;
    return {
        table: table,
        rows: rowsTemplate,
        column: columnsTemplate
    };
};
const $0abbbd36a260e067$var$sort = ({ rows: rows2, field: field, order: order2 })=>{
    const sorted = rows2.sort((a, b)=>{
        let fieldA = a[field];
        let fieldB = b[field];
        if (typeof fieldA === "string") fieldA = fieldA.toLowerCase();
        if (typeof fieldB === "string") fieldB = fieldB.toLowerCase();
        if (fieldA < fieldB) return order2 === "desc" ? 1 : -1;
        if (fieldA > fieldB) return order2 === "desc" ? -1 : 1;
        return 0;
    });
    return sorted;
};
const $0abbbd36a260e067$var$search = (rows2, search2, column)=>{
    if (!search2) return rows2;
    const match = (entry)=>{
        const div2 = document.createElement("div");
        div2.innerHTML = entry;
        entry = div2.textContent || div2.innerText || "";
        return entry.toString().toLowerCase().match(search2.toLowerCase());
    };
    return rows2.filter((row)=>{
        if (column && typeof column === "string") return match(row[column]);
        let values = Object.values(row);
        if (column && Array.isArray(column)) values = Object.keys(row).filter((key)=>column.includes(key)).map((key)=>row[key]);
        return values.filter((value)=>{
            return match(value);
        }).length > 0;
    });
};
const $0abbbd36a260e067$var$paginate = ({ rows: rows2, entries: entries, activePage: activePage })=>{
    const firstVisibleEntry = activePage * entries;
    return rows2.slice(firstVisibleEntry, firstVisibleEntry + Number(entries));
};
const $0abbbd36a260e067$var$SELECTOR_FORM_CHECK_INPUT = ".form-check-input";
const $0abbbd36a260e067$var$CLASS_NAME_SELECTED = "selected";
const $0abbbd36a260e067$var$CLASS_NAME_ACITVE = "active";
class $0abbbd36a260e067$var$SelectOption {
    constructor(id, nativeOption, multiple, value, label, selected, disabled, hidden, secondaryText, groupId, icon){
        this.id = id;
        this.nativeOption = nativeOption;
        this.multiple = multiple;
        this.value = value;
        this.label = label;
        this.selected = selected;
        this.disabled = disabled;
        this.hidden = hidden;
        this.secondaryText = secondaryText;
        this.groupId = groupId;
        this.icon = icon;
        this.node = null;
        this.active = false;
    }
    select() {
        if (this.multiple) this._selectMultiple();
        else this._selectSingle();
    }
    _selectSingle() {
        if (!this.selected) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.node, $0abbbd36a260e067$var$CLASS_NAME_SELECTED);
            this.node.setAttribute("aria-selected", true);
            this.selected = true;
            if (this.nativeOption) this.nativeOption.selected = true;
        }
    }
    _selectMultiple() {
        if (!this.selected) {
            const checkbox = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_FORM_CHECK_INPUT, this.node);
            checkbox.checked = true;
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.node, $0abbbd36a260e067$var$CLASS_NAME_SELECTED);
            this.node.setAttribute("aria-selected", true);
            this.selected = true;
            if (this.nativeOption) this.nativeOption.selected = true;
        }
    }
    deselect() {
        if (this.multiple) this._deselectMultiple();
        else this._deselectSingle();
    }
    _deselectSingle() {
        if (this.selected) {
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this.node, $0abbbd36a260e067$var$CLASS_NAME_SELECTED);
            this.node.setAttribute("aria-selected", false);
            this.selected = false;
            if (this.nativeOption) this.nativeOption.selected = false;
        }
    }
    _deselectMultiple() {
        if (this.selected) {
            const checkbox = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_FORM_CHECK_INPUT, this.node);
            checkbox.checked = false;
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this.node, $0abbbd36a260e067$var$CLASS_NAME_SELECTED);
            this.node.setAttribute("aria-selected", false);
            this.selected = false;
            if (this.nativeOption) this.nativeOption.selected = false;
        }
    }
    setNode(node) {
        this.node = node;
    }
    setActiveStyles() {
        if (!this.active) {
            this.active = true;
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.node, $0abbbd36a260e067$var$CLASS_NAME_ACITVE);
        }
    }
    removeActiveStyles() {
        if (this.active) {
            this.active = false;
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this.node, $0abbbd36a260e067$var$CLASS_NAME_ACITVE);
        }
    }
}
class $0abbbd36a260e067$var$SelectionModel {
    constructor(multiple = false){
        this._multiple = multiple;
        this._selections = [];
    }
    select(option) {
        if (this._multiple) this._selections.push(option);
        else this._selections = [
            option
        ];
    }
    deselect(option) {
        if (this._multiple) {
            const optionIndex = this._selections.findIndex((selection)=>option === selection);
            this._selections.splice(optionIndex, 1);
        } else this._selections = [];
    }
    clear() {
        this._selections = [];
    }
    get selection() {
        return this._selections[0];
    }
    get selections() {
        return this._selections;
    }
    get label() {
        return this._selections[0] && this.selection.label;
    }
    get labels() {
        return this._selections.map((selection)=>selection.label).join(", ");
    }
    get value() {
        return this.selections[0] && this.selection.value;
    }
    get values() {
        return this._selections.map((selection)=>selection.value);
    }
}
function $0abbbd36a260e067$var$allOptionsSelected(options) {
    return options.filter((option)=>!option.disabled).every((option)=>{
        return option.selected;
    });
}
const $0abbbd36a260e067$var$preventKeydown = (event)=>{
    if (event.code === "Tab" || event.code === "Esc") return;
    event.preventDefault();
};
function $0abbbd36a260e067$var$getWrapperTemplate(id, config, label, dropdownContainerId) {
    const wrapper = document.createElement("div");
    wrapper.setAttribute("id", id);
    wrapper.classList.add("select-wrapper");
    const formOutline = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(formOutline, "form-outline");
    formOutline.setAttribute("data-mdb-input-init", "");
    if (config.formWhite) $0abbbd36a260e067$var$Manipulator$1.addClass(formOutline, "form-white");
    const input = $0abbbd36a260e067$var$element("input");
    const disabled = config.disabled ? "true" : "false";
    $0abbbd36a260e067$var$Manipulator$1.addClass(input, "form-control");
    $0abbbd36a260e067$var$Manipulator$1.addClass(input, "select-input");
    if (config.size === "sm") $0abbbd36a260e067$var$Manipulator$1.addClass(input, "form-control-sm");
    if (config.size === "lg") $0abbbd36a260e067$var$Manipulator$1.addClass(input, "form-control-lg");
    input.setAttribute("type", "text");
    input.setAttribute("role", "combobox");
    input.setAttribute("aria-disabled", disabled);
    input.setAttribute("aria-haspopup", "listbox");
    input.setAttribute("aria-expanded", false);
    input.setAttribute("aria-controls", dropdownContainerId);
    if (config.tabIndex) input.setAttribute("tabIndex", config.tabIndex);
    if (config.disabled) input.setAttribute("disabled", "");
    if (config.placeholder !== "") input.setAttribute("placeholder", config.placeholder);
    if (config.validation) {
        $0abbbd36a260e067$var$Manipulator$1.addStyle(input, {
            "pointer-events": "none",
            "caret-color": "transparent"
        });
        $0abbbd36a260e067$var$Manipulator$1.addStyle(formOutline, {
            cursor: "pointer"
        });
    } else input.setAttribute("readonly", "true");
    if (config.validation) {
        input.setAttribute("required", "true");
        input.setAttribute("aria-required", "true");
        input.addEventListener("keydown", $0abbbd36a260e067$var$preventKeydown);
    }
    const validFeedback = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(validFeedback, "valid-feedback");
    const validFeedBackText = document.createTextNode(`${config.validFeedback}`);
    validFeedback.appendChild(validFeedBackText);
    const invalidFeedback = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(invalidFeedback, "invalid-feedback");
    const invalidFeedBackText = document.createTextNode(`${config.invalidFeedback}`);
    invalidFeedback.appendChild(invalidFeedBackText);
    const clearBtn = $0abbbd36a260e067$var$element("span");
    $0abbbd36a260e067$var$Manipulator$1.addClass(clearBtn, "select-clear-btn");
    const clearBtnText = document.createTextNode("\u2715");
    clearBtn.appendChild(clearBtnText);
    clearBtn.setAttribute("tabindex", "0");
    const arrow2 = $0abbbd36a260e067$var$element("span");
    $0abbbd36a260e067$var$Manipulator$1.addClass(arrow2, "select-arrow");
    formOutline.appendChild(input);
    if (label) {
        formOutline.appendChild(label);
        const labelId = label.getAttribute("id");
        if (labelId) input.setAttribute("aria-labelledby", labelId);
    }
    if (config.validation) {
        formOutline.appendChild(validFeedback);
        formOutline.appendChild(invalidFeedback);
    }
    if (config.clearButton) formOutline.appendChild(clearBtn);
    formOutline.appendChild(arrow2);
    wrapper.appendChild(formOutline);
    return wrapper;
}
function $0abbbd36a260e067$var$getDropdownTemplate$1(id, config, width, height, selectAllOption, options, customContent) {
    const dropdownContainer = document.createElement("div");
    dropdownContainer.classList.add("select-dropdown-container");
    dropdownContainer.setAttribute("id", `${id}`);
    dropdownContainer.style.width = `${width}px`;
    const dropdown = document.createElement("div");
    dropdown.setAttribute("tabindex", 0);
    dropdown.classList.add("select-dropdown");
    const optionsWrapper = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(optionsWrapper, "select-options-wrapper");
    optionsWrapper.style.maxHeight = `${height}px`;
    const optionsList = $0abbbd36a260e067$var$getOptionsListTemplate(options, selectAllOption, config);
    optionsWrapper.appendChild(optionsList);
    if (config.filter) dropdown.appendChild($0abbbd36a260e067$var$getFilterTemplate(config.searchPlaceholder));
    dropdown.appendChild(optionsWrapper);
    if (customContent) dropdown.appendChild(customContent);
    dropdownContainer.appendChild(dropdown);
    return dropdownContainer;
}
function $0abbbd36a260e067$var$getOptionsListTemplate(options, selectAllOption, config, label) {
    const optionsList = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(optionsList, "select-options-list");
    if (label == null ? void 0 : label.id) optionsList.setAttribute("aria-labelledby", label.id);
    const multiselectable = config.multiple ? "true" : "false";
    const role = config.filter ? "combobox" : "listbox";
    optionsList.setAttribute("role", role);
    optionsList.setAttribute("aria-multiselectable", multiselectable);
    let optionsNodes;
    if (config.multiple) optionsNodes = $0abbbd36a260e067$var$getMultipleOptionsNodes(options, selectAllOption, config);
    else optionsNodes = $0abbbd36a260e067$var$getSingleOptionsNodes(options, config);
    optionsNodes.forEach((node)=>{
        optionsList.appendChild(node);
    });
    return optionsList;
}
function $0abbbd36a260e067$var$getFilterTemplate(placeholder) {
    const inputGroup = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(inputGroup, "input-group");
    const input = $0abbbd36a260e067$var$element("input");
    $0abbbd36a260e067$var$Manipulator$1.addClass(input, "form-control");
    $0abbbd36a260e067$var$Manipulator$1.addClass(input, "select-filter-input");
    input.placeholder = placeholder;
    input.setAttribute("role", "searchbox");
    input.setAttribute("type", "text");
    inputGroup.appendChild(input);
    return inputGroup;
}
function $0abbbd36a260e067$var$getSingleOptionsNodes(options, config) {
    const nodes = $0abbbd36a260e067$var$getOptionsNodes(options, config);
    return nodes;
}
function $0abbbd36a260e067$var$getMultipleOptionsNodes(options, selectAllOption, config) {
    let selectAllNode = null;
    if (config.selectAll) selectAllNode = $0abbbd36a260e067$var$createSelectAllNode(selectAllOption, options, config);
    const optionsNodes = $0abbbd36a260e067$var$getOptionsNodes(options, config);
    const nodes = selectAllNode ? [
        selectAllNode,
        ...optionsNodes
    ] : optionsNodes;
    return nodes;
}
function $0abbbd36a260e067$var$getOptionsNodes(options, config) {
    const nodes = [];
    options.forEach((option)=>{
        const isOptionGroup = option.hasOwnProperty("options");
        if (isOptionGroup) {
            const group = $0abbbd36a260e067$var$createOptionGroupTemplate(option, config);
            nodes.push(group);
        } else nodes.push($0abbbd36a260e067$var$createOptionTemplate(option, config));
    });
    return nodes;
}
function $0abbbd36a260e067$var$createSelectAllNode(option, options, config) {
    const isSelected = $0abbbd36a260e067$var$allOptionsSelected(options);
    const optionNode = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(optionNode, "select-option");
    $0abbbd36a260e067$var$Manipulator$1.addClass(optionNode, "select-all-option");
    $0abbbd36a260e067$var$Manipulator$1.addStyle(optionNode, {
        height: `${config.optionHeight}px`
    });
    optionNode.setAttribute("role", "option");
    optionNode.setAttribute("aria-selected", isSelected);
    if (isSelected) $0abbbd36a260e067$var$Manipulator$1.addClass(optionNode, "selected");
    optionNode.appendChild($0abbbd36a260e067$var$getOptionContentTemplate(option, config));
    option.setNode(optionNode);
    return optionNode;
}
function $0abbbd36a260e067$var$createOptionTemplate(option, config) {
    if (option.node) return option.node;
    const optionNode = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(optionNode, "select-option");
    $0abbbd36a260e067$var$Manipulator$1.addStyle(optionNode, {
        height: `${config.optionHeight}px`
    });
    $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(optionNode, "id", option.id);
    optionNode.setAttribute("role", "option");
    optionNode.setAttribute("aria-selected", option.selected);
    optionNode.setAttribute("aria-disabled", option.disabled);
    if (option.selected) $0abbbd36a260e067$var$Manipulator$1.addClass(optionNode, "selected");
    if (option.disabled) $0abbbd36a260e067$var$Manipulator$1.addClass(optionNode, "disabled");
    if (option.hidden) $0abbbd36a260e067$var$Manipulator$1.addClass(optionNode, "d-none");
    optionNode.appendChild($0abbbd36a260e067$var$getOptionContentTemplate(option, config));
    if (option.icon) optionNode.appendChild($0abbbd36a260e067$var$getOptionIconTemplate(option));
    option.setNode(optionNode);
    return optionNode;
}
function $0abbbd36a260e067$var$getOptionContentTemplate(option, config) {
    const content = $0abbbd36a260e067$var$element("span");
    $0abbbd36a260e067$var$Manipulator$1.addClass(content, "select-option-text");
    const label = document.createTextNode(option.label);
    if (config.multiple) content.appendChild($0abbbd36a260e067$var$getCheckboxTemplate(option));
    content.appendChild(label);
    if (option.secondaryText || typeof option.secondaryText === "number") content.appendChild($0abbbd36a260e067$var$getSecondaryTextTemplate(option.secondaryText));
    return content;
}
function $0abbbd36a260e067$var$getSecondaryTextTemplate(text) {
    const span = $0abbbd36a260e067$var$element("span");
    $0abbbd36a260e067$var$Manipulator$1.addClass(span, "select-option-secondary-text");
    const textContent = document.createTextNode(text);
    span.appendChild(textContent);
    return span;
}
function $0abbbd36a260e067$var$getCheckboxTemplate(option) {
    const checkbox = $0abbbd36a260e067$var$element("input");
    checkbox.setAttribute("type", "checkbox");
    $0abbbd36a260e067$var$Manipulator$1.addClass(checkbox, "form-check-input");
    const label = $0abbbd36a260e067$var$element("label");
    if (option.selected) checkbox.setAttribute("checked", true);
    if (option.disabled) checkbox.setAttribute("disabled", true);
    checkbox.appendChild(label);
    return checkbox;
}
function $0abbbd36a260e067$var$getOptionIconTemplate(option) {
    const container = $0abbbd36a260e067$var$element("span");
    $0abbbd36a260e067$var$Manipulator$1.addClass(container, "select-option-icon-container");
    const image = $0abbbd36a260e067$var$element("img");
    $0abbbd36a260e067$var$Manipulator$1.addClass(image, "select-option-icon");
    $0abbbd36a260e067$var$Manipulator$1.addClass(image, "rounded-circle");
    image.src = option.icon;
    container.appendChild(image);
    return container;
}
function $0abbbd36a260e067$var$createOptionGroupTemplate(optionGroup, config) {
    const group = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(group, "select-option-group");
    group.setAttribute("role", "group");
    group.setAttribute("id", optionGroup.id);
    if (optionGroup.hidden) $0abbbd36a260e067$var$Manipulator$1.addClass(group, "d-none");
    const label = $0abbbd36a260e067$var$element("label");
    $0abbbd36a260e067$var$Manipulator$1.addClass(label, "select-option-group-label");
    $0abbbd36a260e067$var$Manipulator$1.addStyle(label, {
        height: `${config.optionHeight}px`
    });
    label.setAttribute("for", optionGroup.id);
    label.textContent = optionGroup.label;
    group.appendChild(label);
    optionGroup.options.forEach((option)=>{
        group.appendChild($0abbbd36a260e067$var$createOptionTemplate(option, config));
    });
    return group;
}
function $0abbbd36a260e067$var$getFakeValueTemplate(value) {
    const fakeValue = $0abbbd36a260e067$var$element("div");
    fakeValue.textContent = value;
    $0abbbd36a260e067$var$Manipulator$1.addClass(fakeValue, "form-label");
    $0abbbd36a260e067$var$Manipulator$1.addClass(fakeValue, "select-fake-value");
    return fakeValue;
}
const $0abbbd36a260e067$var$Default$c = {
    autoSelect: false,
    container: "body",
    clearButton: false,
    disabled: false,
    displayedLabels: 5,
    formWhite: false,
    multiple: false,
    optionsSelectedLabel: "options selected",
    optionHeight: 38,
    selectAll: true,
    selectAllLabel: "Select all",
    searchPlaceholder: "Search...",
    size: "default",
    visibleOptions: 5,
    filter: false,
    filterDebounce: 300,
    noResultText: "No results",
    validation: false,
    validFeedback: "Valid",
    invalidFeedback: "Invalid",
    placeholder: "",
    filterFn: null
};
const $0abbbd36a260e067$var$DefaultType$c = {
    autoSelect: "boolean",
    container: "string",
    clearButton: "boolean",
    disabled: "boolean",
    displayedLabels: "number",
    formWhite: "boolean",
    multiple: "boolean",
    optionsSelectedLabel: "string",
    optionHeight: "number",
    selectAll: "boolean",
    selectAllLabel: "string",
    searchPlaceholder: "string",
    size: "string",
    visibleOptions: "number",
    filter: "boolean",
    filterDebounce: "number",
    noResultText: "string",
    validation: "boolean",
    validFeedback: "string",
    invalidFeedback: "string",
    placeholder: "",
    filterFn: "(function|null)"
};
const $0abbbd36a260e067$var$NAME$k = "select";
const $0abbbd36a260e067$var$DATA_KEY$f = "mdb.select";
const $0abbbd36a260e067$var$EVENT_KEY$a = `.${$0abbbd36a260e067$var$DATA_KEY$f}`;
const $0abbbd36a260e067$var$EVENT_CLOSE$2 = `close${$0abbbd36a260e067$var$EVENT_KEY$a}`;
const $0abbbd36a260e067$var$EVENT_OPEN$2 = `open${$0abbbd36a260e067$var$EVENT_KEY$a}`;
const $0abbbd36a260e067$var$EVENT_SELECTED$1 = `optionSelected${$0abbbd36a260e067$var$EVENT_KEY$a}`;
const $0abbbd36a260e067$var$EVENT_DESELECTED = `optionDeselected${$0abbbd36a260e067$var$EVENT_KEY$a}`;
const $0abbbd36a260e067$var$EVENT_VALUE_CHANGED$2 = `valueChanged${$0abbbd36a260e067$var$EVENT_KEY$a}`;
const $0abbbd36a260e067$var$EVENT_CHANGE_NATIVE = "change";
const $0abbbd36a260e067$var$EVENT_OPENED = `opened${$0abbbd36a260e067$var$EVENT_KEY$a}`;
const $0abbbd36a260e067$var$EVENT_CLOSED = `closed${$0abbbd36a260e067$var$EVENT_KEY$a}`;
const $0abbbd36a260e067$var$EVENT_SEARCH = `search${$0abbbd36a260e067$var$EVENT_KEY$a}`;
const $0abbbd36a260e067$var$SELECTOR_LABEL$1 = ".select-label";
const $0abbbd36a260e067$var$SELECTOR_INPUT$1 = ".select-input";
const $0abbbd36a260e067$var$SELECTOR_FILTER_INPUT = ".select-filter-input";
const $0abbbd36a260e067$var$SELECTOR_DROPDOWN$1 = ".select-dropdown";
const $0abbbd36a260e067$var$SELECTOR_OPTIONS_WRAPPER = ".select-options-wrapper";
const $0abbbd36a260e067$var$SELECTOR_OPTIONS_LIST = ".select-options-list";
const $0abbbd36a260e067$var$SELECTOR_OPTION = ".select-option";
const $0abbbd36a260e067$var$SELECTOR_CLEAR_BUTTON = ".select-clear-btn";
const $0abbbd36a260e067$var$SELECTOR_CUSTOM_CONTENT$1 = ".select-custom-content";
const $0abbbd36a260e067$var$SELECTOR_NO_RESULTS = ".select-no-results";
const $0abbbd36a260e067$var$SELECTOR_FORM_OUTLINE = ".form-outline";
const $0abbbd36a260e067$var$SELECTOR_TOGGLE = "[data-mdb-toggle]";
const $0abbbd36a260e067$var$CLASS_NAME_INITIALIZED = "select-initialized";
const $0abbbd36a260e067$var$CLASS_NAME_OPEN$2 = "open";
const $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$1 = "active";
const $0abbbd36a260e067$var$CLASS_NAME_FOCUSED$1 = "focused";
const $0abbbd36a260e067$var$CLASS_NAME_OPTION_GROUP_LABEL = "select-option-group-label";
const $0abbbd36a260e067$var$CLASS_NAME_SELECT_ALL_OPTION = "select-all-option";
const $0abbbd36a260e067$var$ANIMATION_TRANSITION_TIME = 200;
class $0abbbd36a260e067$export$ef9b1a59e592288f extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, config){
        super(element2);
        this._config = this._getConfig(config);
        this._optionsToRender = this._getOptionsToRender(element2);
        this._plainOptions = this._getPlainOptions(this._optionsToRender);
        this._filteredOptionsList = null;
        this._selectionModel = new $0abbbd36a260e067$var$SelectionModel(this.multiple);
        this._activeOptionIndex = -1;
        this._activeOption = null;
        this._wrapperId = this._element.id ? `select-wrapper-${this._element.id}` : $0abbbd36a260e067$var$getUID$1("select-wrapper-");
        this._dropdownContainerId = this._element.id ? `select-dropdown-container-${this._element.id}` : $0abbbd36a260e067$var$getUID$1("select-dropdown-container-");
        this._selectAllId = this._element.id ? `select-all-${this._element.id}` : $0abbbd36a260e067$var$getUID$1("select-all-");
        this._debounceTimeoutId = null;
        this._dropdownHeight = this._config.optionHeight * this._config.visibleOptions;
        this._popper = null;
        this._input = null;
        this._label = $0abbbd36a260e067$var$SelectorEngine$1.next(this._element, $0abbbd36a260e067$var$SELECTOR_LABEL$1)[0];
        this._fakeValue = null;
        this._isFakeValueActive = false;
        this._customContent = $0abbbd36a260e067$var$SelectorEngine$1.next(element2, $0abbbd36a260e067$var$SELECTOR_CUSTOM_CONTENT$1)[0];
        this._toggleButton = null;
        this._elementToggle = null;
        this._wrapper = null;
        this._inputEl = null;
        this._dropdownContainer = null;
        this._container = null;
        this._selectAllOption = null;
        this._init();
        this._mutationObserver = null;
        this._isOpen = false;
        this._addMutationObserver();
        this._inputHandler = this._handleInput.bind(this);
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$k;
    }
    get filterInput() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_FILTER_INPUT, this._dropdownContainer);
    }
    get dropdown() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_DROPDOWN$1, this._dropdownContainer);
    }
    get optionsList() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_OPTIONS_LIST, this._dropdownContainer);
    }
    get optionsWrapper() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_OPTIONS_WRAPPER, this._dropdownContainer);
    }
    get clearButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_CLEAR_BUTTON, this._wrapper);
    }
    get options() {
        return this._filteredOptionsList ? this._filteredOptionsList : this._plainOptions;
    }
    get value() {
        return this.multiple ? this._selectionModel.values : this._selectionModel.value;
    }
    get multiple() {
        return this._config.multiple;
    }
    get hasSelectAll() {
        return this.multiple && this._config.selectAll;
    }
    get hasSelection() {
        return this._selectionModel.selection || this._selectionModel.selections.length > 0;
    }
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        config = {
            ...$0abbbd36a260e067$var$Default$c,
            ...dataAttributes,
            ...config
        };
        if (this._element.hasAttribute("multiple")) config.multiple = true;
        if (this._element.hasAttribute("disabled")) config.disabled = true;
        if (this._element.tabIndex) config.tabIndex = this._element.getAttribute("tabIndex");
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$k, config, $0abbbd36a260e067$var$DefaultType$c);
        return config;
    }
    _getOptionsToRender(select) {
        const options = [];
        const nodes = select.childNodes;
        nodes.forEach((node)=>{
            if (node.nodeName === "OPTGROUP") {
                const optionGroup = {
                    id: node.id ? `group-${node.id}` : $0abbbd36a260e067$var$getUID$1("group-"),
                    label: node.label,
                    disabled: node.hasAttribute("disabled"),
                    hidden: node.hasAttribute("hidden"),
                    options: []
                };
                const groupOptions = node.childNodes;
                groupOptions.forEach((option)=>{
                    if (option.nodeName === "OPTION") optionGroup.options.push(this._createOptionObject(option, optionGroup));
                });
                options.push(optionGroup);
            } else if (node.nodeName === "OPTION") options.push(this._createOptionObject(node));
        });
        return options;
    }
    _getPlainOptions(optionsToRender) {
        const hasOptionGroup = $0abbbd36a260e067$var$SelectorEngine$1.findOne("optgroup", this._element);
        if (!hasOptionGroup) return optionsToRender;
        const options = [];
        optionsToRender.forEach((option)=>{
            const isOptionGroup = option.hasOwnProperty("options");
            if (isOptionGroup) option.options.forEach((nestedOption)=>{
                options.push(nestedOption);
            });
            else options.push(option);
        });
        return options;
    }
    _createOptionObject(nativeOption, group = {}) {
        const id = nativeOption.id ? `option-${nativeOption.id}` : $0abbbd36a260e067$var$getUID$1("option-");
        const groupId = group.id ? group.id : null;
        const groupDisabled = group.disabled ? group.disabled : false;
        const selected = nativeOption.selected || nativeOption.hasAttribute("selected");
        const disabled = nativeOption.hasAttribute("disabled") || groupDisabled;
        const hidden = nativeOption.hasAttribute("hidden") || group && group.hidden;
        const multiple = this.multiple;
        const value = nativeOption.value;
        const label = nativeOption.label;
        const secondaryText = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(nativeOption, "secondaryText");
        const icon = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(nativeOption, "icon");
        return new $0abbbd36a260e067$var$SelectOption(id, nativeOption, multiple, value, label, selected, disabled, hidden, secondaryText, groupId, icon);
    }
    _getNavigationOptions() {
        const availableOptions = this.options.filter((option)=>!option.hidden);
        return this.hasSelectAll ? [
            this._selectAllOption,
            ...availableOptions
        ] : availableOptions;
    }
    _init() {
        this._renderMaterialWrapper();
        this._wrapper = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`#${this._wrapperId}`);
        this._input = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_INPUT$1, this._wrapper);
        if (this._element.getAttribute("autocomplete") === "off") this._input.setAttribute("autocomplete", "off");
        const containerSelector = this._config.container;
        if (containerSelector === "body") this._container = document.body;
        else this._container = $0abbbd36a260e067$var$SelectorEngine$1.findOne(containerSelector);
        this._initOutlineInput();
        this._setDefaultSelections();
        this._updateInputValue();
        this._appendFakeValue();
        this._updateFakeLabelPosition();
        this._updateLabelPosition();
        this._updateClearButtonVisibility();
        this._bindComponentEvents();
        if (this.hasSelectAll) this._selectAllOption = this._createSelectAllOption();
        this._dropdownContainer = $0abbbd36a260e067$var$getDropdownTemplate$1(this._dropdownContainerId, this._config, this._input.offsetWidth, this._dropdownHeight, this._selectAllOption, this._optionsToRender, this._customContent);
        this._setFirstActiveOption();
    }
    _renderMaterialWrapper() {
        const template = $0abbbd36a260e067$var$getWrapperTemplate(this._wrapperId, this._config, this._label, this._dropdownContainerId);
        this._element.parentNode.insertBefore(template, this._element);
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$CLASS_NAME_INITIALIZED);
        template.appendChild(this._element);
    }
    _initOutlineInput() {
        const inputWrapper = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_FORM_OUTLINE, this._wrapper);
        const outlineInput = new $0abbbd36a260e067$export$f5b8910cec6cf069(inputWrapper);
        outlineInput.init();
    }
    _updateOutlineInput() {
        const inputWrapper = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_FORM_OUTLINE, this._wrapper);
        $0abbbd36a260e067$export$f5b8910cec6cf069.getInstance(inputWrapper).update();
    }
    _bindComponentEvents() {
        this._listenToComponentKeydown();
        this._listenToWrapperClick();
        if (!this._config.disabled) {
            this._listenToClearBtnClick();
            this._listenToClearBtnKeydown();
        }
    }
    _setDefaultSelections() {
        this.options.forEach((option)=>{
            if (option.selected) this._selectionModel.select(option);
        });
    }
    _listenToComponentKeydown() {
        this._wrapperKeydownHandler = this._handleKeydown.bind(this);
        $0abbbd36a260e067$var$EventHandler$1.on(this._wrapper, "keydown", this._wrapperKeydownHandler);
    }
    _handleKeydown(event) {
        if (this._isOpen && !this._config.filter) this._handleOpenKeydown(event);
        else this._handleClosedKeydown(event);
    }
    _handleOpenKeydown(event) {
        const key = event.keyCode;
        const isCloseKey = key === $0abbbd36a260e067$var$ESCAPE || (key === $0abbbd36a260e067$var$UP_ARROW || key === $0abbbd36a260e067$var$DOWN_ARROW) && event.altKey || key === $0abbbd36a260e067$var$TAB;
        if (key === $0abbbd36a260e067$var$TAB && this._config.autoSelect && !this.multiple) this._handleAutoSelection(this._activeOption);
        if (isCloseKey) {
            this.close();
            this._input.focus();
            return;
        }
        switch(key){
            case $0abbbd36a260e067$var$DOWN_ARROW:
                this._setNextOptionActive();
                this._scrollToOption(this._activeOption);
                break;
            case $0abbbd36a260e067$var$UP_ARROW:
                this._setPreviousOptionActive();
                this._scrollToOption(this._activeOption);
                break;
            case $0abbbd36a260e067$var$HOME:
                this._setFirstOptionActive();
                this._scrollToOption(this._activeOption);
                break;
            case $0abbbd36a260e067$var$END:
                this._setLastOptionActive();
                this._scrollToOption(this._activeOption);
                break;
            case $0abbbd36a260e067$var$ENTER:
                event.preventDefault();
                if (this._activeOption) {
                    if (this.hasSelectAll && this._activeOptionIndex === 0) this._handleSelectAll();
                    else this._handleSelection(this._activeOption);
                }
                return;
            default:
                return;
        }
        event.preventDefault();
    }
    _handleClosedKeydown(event) {
        const key = event.keyCode;
        if (key === $0abbbd36a260e067$var$ENTER || key === $0abbbd36a260e067$var$SPACE) event.preventDefault();
        const isOpenKey = key === $0abbbd36a260e067$var$ENTER || key === $0abbbd36a260e067$var$SPACE || (key === $0abbbd36a260e067$var$DOWN_ARROW || key === $0abbbd36a260e067$var$UP_ARROW) && event.altKey || key === $0abbbd36a260e067$var$DOWN_ARROW && this.multiple;
        if (isOpenKey) this.open();
        if (!this.multiple) switch(key){
            case $0abbbd36a260e067$var$DOWN_ARROW:
                if (event.altKey) return;
                this._setNextOptionActive();
                this._handleSelection(this._activeOption);
                break;
            case $0abbbd36a260e067$var$UP_ARROW:
                if (event.altKey) return;
                this._setPreviousOptionActive();
                this._handleSelection(this._activeOption);
                break;
            case $0abbbd36a260e067$var$HOME:
                this._setFirstOptionActive();
                this._handleSelection(this._activeOption);
                break;
            case $0abbbd36a260e067$var$END:
                this._setLastOptionActive();
                this._handleSelection(this._activeOption);
                break;
            default:
                return;
        }
        else switch(key){
            case $0abbbd36a260e067$var$DOWN_ARROW:
                this.open();
                break;
            case $0abbbd36a260e067$var$UP_ARROW:
                this.open();
                break;
            default:
                return;
        }
        event.preventDefault();
    }
    _scrollToOption(option) {
        if (!option) return;
        let optionIndex;
        const visibleOptions = this.options.filter((option2)=>!option2.hidden);
        if (this.hasSelectAll) optionIndex = visibleOptions.indexOf(option) + 1;
        else optionIndex = visibleOptions.indexOf(option);
        const groupsNumber = this._getNumberOfGroupsBeforeOption(optionIndex);
        const scrollToIndex = optionIndex + groupsNumber;
        const list = this.optionsWrapper;
        const listHeight = list.offsetHeight;
        const optionHeight = this._config.optionHeight;
        const scrollTop = list.scrollTop;
        if (optionIndex > -1) {
            const optionOffset = scrollToIndex * optionHeight;
            const isBelow = optionOffset + optionHeight > scrollTop + listHeight;
            const isAbove = optionOffset < scrollTop;
            if (isAbove) list.scrollTop = optionOffset;
            else if (isBelow) list.scrollTop = optionOffset - listHeight + optionHeight;
            else list.scrollTop = scrollTop;
        }
    }
    _getNumberOfGroupsBeforeOption(optionIndex) {
        const optionsList = this.options.filter((option)=>!option.hidden);
        const groupsList = this._optionsToRender.filter((group)=>!group.hidden);
        const index = this.hasSelectAll ? optionIndex - 1 : optionIndex;
        let groupsNumber = 0;
        for(let i = 0; i <= index; i++)if (optionsList[i].groupId && groupsList[groupsNumber] && groupsList[groupsNumber].id && optionsList[i].groupId === groupsList[groupsNumber].id) groupsNumber++;
        return groupsNumber;
    }
    _setNextOptionActive() {
        let index = this._activeOptionIndex + 1;
        const options = this._getNavigationOptions();
        if (!options[index]) return;
        while(options[index].disabled){
            index += 1;
            if (!options[index]) return;
        }
        this._updateActiveOption(options[index], index);
    }
    _setPreviousOptionActive() {
        let index = this._activeOptionIndex - 1;
        const options = this._getNavigationOptions();
        if (!options[index]) return;
        while(options[index].disabled){
            index -= 1;
            if (!options[index]) return;
        }
        this._updateActiveOption(options[index], index);
    }
    _setFirstOptionActive() {
        const index = 0;
        const options = this._getNavigationOptions();
        this._updateActiveOption(options[index], index);
    }
    _setLastOptionActive() {
        const options = this._getNavigationOptions();
        const index = options.length - 1;
        this._updateActiveOption(options[index], index);
    }
    _updateActiveOption(newActiveOption, index) {
        const currentActiveOption = this._activeOption;
        if (currentActiveOption) currentActiveOption.removeActiveStyles();
        newActiveOption.setActiveStyles();
        this._activeOptionIndex = index;
        this._activeOption = newActiveOption;
    }
    _listenToWrapperClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._wrapper, "click", ()=>{
            this.toggle();
        });
    }
    _listenToClearBtnClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.clearButton, "click", (event)=>{
            event.preventDefault();
            event.stopPropagation();
            this._handleClear();
        });
    }
    _listenToClearBtnKeydown() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.clearButton, "keydown", (event)=>{
            if (event.keyCode === $0abbbd36a260e067$var$ENTER) {
                this._handleClear();
                event.preventDefault();
                event.stopPropagation();
            }
        });
    }
    _handleClear() {
        if (this.multiple) {
            this._selectionModel.clear();
            this._deselectAllOptions(this.options);
            if (this.hasSelectAll) this._updateSelectAllState();
        } else {
            const selected = this._selectionModel.selection;
            this._selectionModel.clear();
            selected.deselect();
        }
        if (this._optionsToRender[0].hidden === true) this._singleOptionSelect(this._optionsToRender[0]);
        else {
            this._emitValueChangeEvent(null);
            this._emitNativeChangeEvent();
        }
        this._updateInputValue();
        this._updateFakeLabelPosition();
        this._updateLabelPosition();
        this._updateClearButtonVisibility();
    }
    _listenToOptionsClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.optionsWrapper, "click", (event)=>{
            const optionGroupLabel = event.target.classList.contains($0abbbd36a260e067$var$CLASS_NAME_OPTION_GROUP_LABEL);
            if (optionGroupLabel) return;
            const target = event.target.nodeName === "DIV" ? event.target : $0abbbd36a260e067$var$SelectorEngine$1.closest(event.target, $0abbbd36a260e067$var$SELECTOR_OPTION);
            const selectAllOption = target.classList.contains($0abbbd36a260e067$var$CLASS_NAME_SELECT_ALL_OPTION);
            if (selectAllOption) {
                this._handleSelectAll();
                return;
            }
            const id = target.dataset.mdbId;
            const option = this.options.find((option2)=>option2.id === id);
            if (option && !option.disabled) this._handleSelection(option);
        });
    }
    _handleSelectAll() {
        const selected = this._selectAllOption.selected;
        if (selected) {
            this._deselectAllOptions(this.options);
            this._selectAllOption.deselect();
        } else {
            this._selectAllOptions(this.options);
            this._selectAllOption.select();
        }
        this._updateInputValue();
        this._updateFakeLabelPosition();
        this._updateLabelPosition();
        this._updateClearButtonVisibility();
        this._emitValueChangeEvent(this.value);
        this._emitNativeChangeEvent();
    }
    _selectAllOptions(options) {
        options.forEach((option)=>{
            if (!option.selected && !option.disabled) {
                this._selectionModel.select(option);
                option.select();
            }
        });
    }
    _deselectAllOptions(options) {
        options.forEach((option)=>{
            if (option.selected && !option.disabled) {
                this._selectionModel.deselect(option);
                option.deselect();
            }
        });
    }
    _handleSelection(option) {
        if (this.multiple) {
            this._handleMultiSelection(option);
            if (this.hasSelectAll) this._updateSelectAllState();
        } else this._handleSingleSelection(option);
        this._updateInputValue();
        this._updateFakeLabelPosition();
        this._updateLabelPosition();
        this._updateClearButtonVisibility();
        this._updateOutlineInput();
    }
    _handleAutoSelection(option) {
        this._singleOptionSelect(option);
        this._updateInputValue();
        this._updateFakeLabelPosition();
        this._updateLabelPosition();
        this._updateClearButtonVisibility();
        this._updateOutlineInput();
    }
    _handleSingleSelection(option) {
        this._singleOptionSelect(option);
        this.close();
        this._input.focus();
    }
    _singleOptionSelect(option) {
        const currentSelected = this._selectionModel.selections[0];
        if (currentSelected && currentSelected !== option) {
            this._selectionModel.deselect(currentSelected);
            currentSelected.deselect();
            currentSelected.node.setAttribute("selected", false);
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_DESELECTED, {
                value: currentSelected.value
            });
        }
        if (!currentSelected || currentSelected && option !== currentSelected) {
            this._selectionModel.select(option);
            option.select();
            option.node.setAttribute("selected", true);
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SELECTED$1, {
                value: option.value
            });
            this._emitValueChangeEvent(this.value);
            this._emitNativeChangeEvent();
        }
    }
    _handleMultiSelection(option) {
        if (option.selected) {
            this._selectionModel.deselect(option);
            option.deselect();
            option.node.setAttribute("selected", false);
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_DESELECTED, {
                value: option.value
            });
        } else {
            this._selectionModel.select(option);
            option.select();
            option.node.setAttribute("selected", true);
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SELECTED$1, {
                value: option.value
            });
        }
        this._emitValueChangeEvent(this.value);
        this._emitNativeChangeEvent();
    }
    _emitValueChangeEvent(value) {
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED$2, {
            value: value
        });
    }
    _emitNativeChangeEvent() {
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CHANGE_NATIVE);
    }
    _updateInputValue() {
        const labels = this.multiple ? this._selectionModel.labels : this._selectionModel.label;
        let value;
        if (this.multiple && this._config.displayedLabels !== -1 && this._selectionModel.selections.length > this._config.displayedLabels) value = `${this._selectionModel.selections.length} ${this._config.optionsSelectedLabel}`;
        else value = labels;
        if (!this.multiple && !this._isSelectionValid(this._selectionModel.selection)) this._input.value = "";
        else if (this._isLabelEmpty(this._selectionModel.selection)) this._input.value = " ";
        else if (value) this._input.value = value;
        else this.multiple || !this._optionsToRender[0] || this._config.placeholder ? this._input.value = "" : this._input.value = this._optionsToRender[0].label;
    }
    _isSelectionValid(selection) {
        if (selection && (selection.disabled || selection.value === "")) return false;
        return true;
    }
    _isLabelEmpty(selection) {
        if (selection && selection.label === "") return true;
        return false;
    }
    _appendFakeValue() {
        if (!this._selectionModel.selection || this._selectionModel._multiple || this._config.placeholder) return;
        const value = this._selectionModel.selection.label;
        this._fakeValue = $0abbbd36a260e067$var$getFakeValueTemplate(value);
        const inputWrapper = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_FORM_OUTLINE, this._wrapper);
        inputWrapper.appendChild(this._fakeValue);
    }
    _updateLabelPosition() {
        const isInitialized2 = $0abbbd36a260e067$var$Manipulator$1.hasClass(this._element, $0abbbd36a260e067$var$CLASS_NAME_INITIALIZED);
        const isValueEmpty = this._input.value !== "";
        if (!this._label) return;
        if (isInitialized2 && (isValueEmpty || this._isOpen || this._isFakeValueActive)) $0abbbd36a260e067$var$Manipulator$1.addClass(this._label, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$1);
        else $0abbbd36a260e067$var$Manipulator$1.removeClass(this._label, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$1);
    }
    _updateLabelPositionWhileClosing() {
        if (!this._label) return;
        if (this._input.value !== "" || this._isFakeValueActive) $0abbbd36a260e067$var$Manipulator$1.addClass(this._label, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$1);
        else $0abbbd36a260e067$var$Manipulator$1.removeClass(this._label, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$1);
    }
    _updateFakeLabelPosition() {
        if (!this._fakeValue) return;
        if (this.hasSelection) this._fakeValue.textContent = this.hasSelection.label;
        if (this._input.value === "" && this._fakeValue.innerHTML !== "") {
            this._isFakeValueActive = true;
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._fakeValue, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$1);
        } else {
            this._isFakeValueActive = false;
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this._fakeValue, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$1);
        }
    }
    _updateClearButtonVisibility() {
        var _a, _b;
        if (!this.clearButton) return;
        if (((_a = this._optionsToRender[0]) == null ? void 0 : _a.hidden) && ((_b = this._optionsToRender[0]) == null ? void 0 : _b.selected) || !this.hasSelection) $0abbbd36a260e067$var$Manipulator$1.addStyle(this.clearButton, {
            display: "none"
        });
        else $0abbbd36a260e067$var$Manipulator$1.addStyle(this.clearButton, {
            display: "block"
        });
    }
    _updateSelectAllState() {
        const selectAllSelected = this._selectAllOption.selected;
        const allSelected = $0abbbd36a260e067$var$allOptionsSelected(this.options);
        if (!allSelected && selectAllSelected) this._selectAllOption.deselect();
        else if (allSelected && !selectAllSelected) this._selectAllOption.select();
    }
    toggle() {
        if (this._isOpen) this.close();
        else this.open();
    }
    open() {
        const isDisabled2 = this._config.disabled;
        const openEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_OPEN$2);
        if (this._isOpen || isDisabled2 || openEvent.defaultPrevented) return;
        this._openDropdown();
        this._updateDropdownWidth();
        this._setFirstActiveOption();
        this._scrollToOption(this._activeOption);
        if (this._config.filter) {
            setTimeout(()=>{
                this.filterInput.focus();
                this._filterOptions(this.filterInput.value);
            }, 0);
            this._listenToSelectSearch();
            this._listenToDropdownKeydown();
        }
        this._listenToOptionsClick();
        this._listenToOutsideClick();
        this._listenToWindowResize();
        this._isOpen = true;
        this._input.setAttribute("aria-expanded", true);
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_OPENED);
        this._updateLabelPosition();
        this._setInputActiveStyles();
    }
    _openDropdown() {
        this._popper = $0abbbd36a260e067$var$createPopper(this._input, this._dropdownContainer, {
            placement: "bottom-start",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            1
                        ]
                    }
                }
            ]
        });
        this._container.appendChild(this._dropdownContainer);
        setTimeout(()=>{
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.dropdown, $0abbbd36a260e067$var$CLASS_NAME_OPEN$2);
        }, 0);
    }
    _updateDropdownWidth() {
        const inputWidth = this._input.offsetWidth;
        $0abbbd36a260e067$var$Manipulator$1.addStyle(this._dropdownContainer, {
            width: `${inputWidth}px`
        });
    }
    _setFirstActiveOption() {
        const options = this._getNavigationOptions();
        const currentActive = this._activeOption;
        if (currentActive) currentActive.removeActiveStyles();
        const firstSelected = this.multiple ? this._selectionModel.selections[0] : this._selectionModel.selection;
        if (firstSelected) {
            this._activeOption = firstSelected;
            firstSelected.setActiveStyles();
            this._activeOptionIndex = options.findIndex((option)=>option === firstSelected);
        } else {
            this._activeOption = null;
            this._activeOptionIndex = -1;
        }
    }
    _setInputActiveStyles() {
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._input, $0abbbd36a260e067$var$CLASS_NAME_FOCUSED$1);
    }
    _listenToWindowResize() {
        this._windowResizeHandler = this._handleWindowResize.bind(this);
        $0abbbd36a260e067$var$EventHandler$1.on(window, "resize", this._windowResizeHandler);
    }
    _handleWindowResize() {
        if (this._dropdownContainer) {
            this._updateDropdownWidth();
            this._popper.forceUpdate();
        }
    }
    _listenToSelectSearch() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.filterInput, "input", this._inputHandler);
    }
    _handleInput(event) {
        const searchTerm = event.target.value;
        const debounceTime = this._config.filterDebounce;
        const searchEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SEARCH, {
            value: searchTerm
        });
        if (searchEvent.defaultPrevented) return;
        this._debounceFilter(searchTerm, debounceTime);
    }
    _debounceFilter(searchTerm, debounceTime) {
        if (this._debounceTimeoutId) clearTimeout(this._debounceTimeoutId);
        this._debounceTimeoutId = setTimeout(()=>{
            this._filterOptions(searchTerm);
        }, debounceTime);
    }
    _filterOptions(searchTerm) {
        const filtered = [];
        const filterFn = this._config.filterFn;
        this._optionsToRender.forEach((option)=>{
            const isOptionGroup = option.hasOwnProperty("options");
            const isValidOption = !isOptionGroup && option.label.toLowerCase().includes(searchTerm.toLowerCase());
            const group = {};
            if (isOptionGroup) {
                group.label = option.label;
                group.options = this._filter(searchTerm, option.options);
                if (group.options.length > 0) filtered.push(group);
            }
            if (filterFn && !isOptionGroup) {
                const customSearchResult = filterFn(searchTerm, option);
                if (customSearchResult) filtered.push(option);
            } else if (isValidOption) filtered.push(option);
        });
        const hasNoResultsText = this._config.noResultText !== "";
        const hasFilteredOptions = filtered.length !== 0;
        if (hasFilteredOptions) {
            this._updateOptionsListTemplate(filtered);
            this._popper.forceUpdate();
            this._filteredOptionsList = this._getPlainOptions(filtered);
            if (this.hasSelectAll) this._updateSelectAllState();
            this._setFirstActiveOption();
        } else if (!hasFilteredOptions && hasNoResultsText) {
            const noResultsTemplate = this._getNoResultTemplate();
            this.optionsWrapper.innerHTML = noResultsTemplate;
        }
    }
    _updateOptionsListTemplate(optionsToRender) {
        const optionsWrapperContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_OPTIONS_LIST, this._dropdownContainer) || $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_NO_RESULTS, this._dropdownContainer);
        const optionsListTemplate = $0abbbd36a260e067$var$getOptionsListTemplate(optionsToRender, this._selectAllOption, this._config, this._label);
        this.optionsWrapper.removeChild(optionsWrapperContent);
        this.optionsWrapper.appendChild(optionsListTemplate);
    }
    _getNoResultTemplate() {
        return `<div class="select-no-results" style="height: ${this._config.optionHeight}px">${this._config.noResultText}</div>`;
    }
    _filter(value, options) {
        const filterFn = this._config.filterFn;
        if (filterFn) return options.filter((option)=>filterFn(value, option) && !option.hidden);
        const filterValue = value.toLowerCase();
        return options.filter((option)=>option.label.toLowerCase().includes(filterValue) && !option.hidden);
    }
    _listenToDropdownKeydown() {
        this._dropdownKeydownHandler = this._handleOpenKeydown.bind(this);
        $0abbbd36a260e067$var$EventHandler$1.on(this.dropdown, "keydown", this._dropdownKeydownHandler);
    }
    _listenToOutsideClick() {
        this._outsideClickHandler = this._handleOutSideClick.bind(this);
        $0abbbd36a260e067$var$EventHandler$1.on(document, "click", this._outsideClickHandler);
    }
    _handleOutSideClick(event) {
        const isSelectContent = this._wrapper && this._wrapper.contains(event.target);
        const isDropdown = event.target === this._dropdownContainer;
        const isDropdownContent = this._dropdownContainer && this._dropdownContainer.contains(event.target);
        let isButton;
        if (!this._toggleButton) this._elementToggle = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_TOGGLE);
        if (this._elementToggle) this._elementToggle.forEach((button)=>{
            const attributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(button, "toggle");
            if (attributes === this._element.id || this._element.classList.contains(attributes)) {
                this._toggleButton = button;
                isButton = this._toggleButton.contains(event.target);
            }
        });
        if (!isSelectContent && !isDropdown && !isDropdownContent && !isButton) this.close();
    }
    close() {
        const closeEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CLOSE$2);
        if (!this._isOpen || closeEvent.defaultPrevented) return;
        if (this._config.filter) $0abbbd36a260e067$var$EventHandler$1.off(this.filterInput, "input", this._inputHandler);
        if (this._config.filter && this.hasSelectAll) {
            this._resetFilterState();
            this._updateOptionsListTemplate(this._optionsToRender);
            if (this._config.multiple) this._updateSelectAllState();
        }
        this._removeDropdownEvents();
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this.dropdown, $0abbbd36a260e067$var$CLASS_NAME_OPEN$2);
        setTimeout(()=>{
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this._input, $0abbbd36a260e067$var$CLASS_NAME_FOCUSED$1);
            if (this._label && !this.hasSelection) {
                $0abbbd36a260e067$var$Manipulator$1.removeClass(this._label, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$1);
                $0abbbd36a260e067$var$Manipulator$1.removeClass(this._input, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$1);
            }
            this._updateLabelPositionWhileClosing();
        }, 0);
        setTimeout(()=>{
            if (this._container && this._dropdownContainer.parentNode === this._container) this._container.removeChild(this._dropdownContainer);
            this._popper.destroy();
            this._isOpen = false;
            this._input.setAttribute("aria-expanded", false);
            $0abbbd36a260e067$var$EventHandler$1.off(this.dropdown, "transitionend");
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CLOSED);
        }, $0abbbd36a260e067$var$ANIMATION_TRANSITION_TIME);
    }
    _resetFilterState() {
        this.filterInput.value = "";
        this._filteredOptionsList = null;
    }
    _removeDropdownEvents() {
        $0abbbd36a260e067$var$EventHandler$1.off(document, "click", this._outsideClickHandler);
        if (this._config.filter) $0abbbd36a260e067$var$EventHandler$1.off(this.dropdown, "keydown");
        $0abbbd36a260e067$var$EventHandler$1.off(this.optionsWrapper, "click");
    }
    _addMutationObserver() {
        this._mutationObserver = new MutationObserver(()=>{
            if (this._wrapper) {
                this._updateSelections();
                this._updateDisabledState();
            }
        });
        this._observeMutationObserver();
    }
    _updateSelections() {
        this._optionsToRender = this._getOptionsToRender(this._element);
        this._plainOptions = this._getPlainOptions(this._optionsToRender);
        this._selectionModel.clear();
        this._setDefaultSelections();
        this._updateInputValue();
        this._updateFakeLabelPosition();
        this._updateLabelPosition();
        this._updateClearButtonVisibility();
        if (this.hasSelectAll) this._updateSelectAllState();
        const hasFilterValue = this._config.filter && this.filterInput && this.filterInput.value;
        if (this._isOpen && !hasFilterValue) {
            this._updateOptionsListTemplate(this._optionsToRender);
            this._setFirstActiveOption();
        } else if (this._isOpen && hasFilterValue) {
            this._filterOptions(this.filterInput.value);
            this._setFirstActiveOption();
        } else this._dropdownContainer = $0abbbd36a260e067$var$getDropdownTemplate$1(this._dropdownContainerId, this._config, this._input.offsetWidth, this._dropdownHeight, this._selectAllOption, this._optionsToRender, this._customContent);
    }
    _updateDisabledState() {
        const input = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_INPUT$1, this._wrapper);
        if (this._element.hasAttribute("disabled")) {
            this._config.disabled = true;
            input.setAttribute("disabled", "");
        } else {
            this._config.disabled = false;
            input.removeAttribute("disabled");
        }
    }
    _observeMutationObserver() {
        if (!this._mutationObserver) return;
        this._mutationObserver.observe(this._element, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    }
    _disconnectMutationObserver() {
        if (this._mutationObserver) {
            this._mutationObserver.disconnect();
            this._mutationObserver = null;
        }
    }
    _createSelectAllOption() {
        const id = this._selectAllId;
        const nativeOption = null;
        const multiple = true;
        const value = "select-all";
        const label = this._config.selectAllLabel;
        const selected = $0abbbd36a260e067$var$allOptionsSelected(this.options);
        const disabled = false;
        const hidden = false;
        const secondaryText = null;
        const groupId = null;
        const icon = null;
        return new $0abbbd36a260e067$var$SelectOption(id, nativeOption, multiple, value, label, selected, disabled, hidden, secondaryText, groupId, icon);
    }
    dispose() {
        this._disconnectMutationObserver();
        this._removeComponentEvents();
        this._disconnectMutationObserver();
        this._destroyMaterialSelect();
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    _removeComponentEvents() {
        $0abbbd36a260e067$var$EventHandler$1.off(this.input, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(this.wrapper, this._wrapperKeydownHandler);
        $0abbbd36a260e067$var$EventHandler$1.off(this.clearButton, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(this.clearButton, "keydown");
        $0abbbd36a260e067$var$EventHandler$1.off(window, "resize", this._windowResizeHandler);
    }
    _destroyMaterialSelect() {
        if (this._isOpen) this.close();
        this._destroyMaterialTemplate();
    }
    _destroyMaterialTemplate() {
        const wrapperParent = this._wrapper.parentNode;
        const labels = $0abbbd36a260e067$var$SelectorEngine$1.find("label", this._wrapper);
        wrapperParent.appendChild(this._element);
        labels.forEach((label)=>{
            wrapperParent.appendChild(label);
        });
        labels.forEach((label)=>{
            $0abbbd36a260e067$var$Manipulator$1.removeClass(label, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE$1);
        });
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, $0abbbd36a260e067$var$CLASS_NAME_INITIALIZED);
        if (this._customContent) wrapperParent.appendChild(this._customContent);
        wrapperParent.removeChild(this._wrapper);
    }
    setValue(value) {
        if (this._config.filter && this.filterInput.value) {
            this._resetFilterState();
            $0abbbd36a260e067$var$EventHandler$1.trigger(this.filterInput, "input");
        }
        this.options.filter((option)=>option.selected).forEach((selection)=>selection.nativeOption.selected = false);
        const isMultipleValue = Array.isArray(value);
        if (!this.multiple) {
            const option = this.options.find((option2)=>option2.value === value);
            option.select();
        }
        if (isMultipleValue) value.forEach((selectionValue)=>{
            this._selectByValue(selectionValue);
        });
        else this._selectByValue(value);
        this._updateSelections();
        this._emitValueChangeEvent(value);
        this._updateOutlineInput();
    }
    _selectByValue(value) {
        const correspondingOption = this.options.find((option)=>option.value === value);
        if (!correspondingOption) return false;
        correspondingOption.nativeOption.selected = true;
        return true;
    }
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$f);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$ef9b1a59e592288f(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$j = "datatable";
const $0abbbd36a260e067$var$DATA_KEY$e = `mdb.${$0abbbd36a260e067$var$NAME$j}`;
const $0abbbd36a260e067$var$CLASS_DATATABLE = "datatable";
const $0abbbd36a260e067$var$CLASS_FIXED_CELL = "fixed-cell";
const $0abbbd36a260e067$var$SELECTOR_BODY = ".datatable-inner";
const $0abbbd36a260e067$var$SELECTOR_CELL = "td";
const $0abbbd36a260e067$var$SELECTOR_HEADER = ".datatable-header th";
const $0abbbd36a260e067$var$SELECTOR_HEADER_CHECKBOX = ".datatable-header-checkbox";
const $0abbbd36a260e067$var$SELECTOR_PAGINATION_RIGHT = ".datatable-pagination-right";
const $0abbbd36a260e067$var$SELECTOR_PAGINATION_LEFT = ".datatable-pagination-left";
const $0abbbd36a260e067$var$SELECTOR_PAGINATION_START = ".datatable-pagination-start";
const $0abbbd36a260e067$var$SELECTOR_PAGINATION_END = ".datatable-pagination-end";
const $0abbbd36a260e067$var$SELECTOR_PAGINATION_NAV = ".datatable-pagination-nav";
const $0abbbd36a260e067$var$SELECTOR_SELECT = ".datatable-select";
const $0abbbd36a260e067$var$SELECTOR_SORT_ICON = ".datatable-sort-icon";
const $0abbbd36a260e067$var$SELECTOR_ROW = ".datatable-body tr";
const $0abbbd36a260e067$var$SELECTOR_ROW_CHECKBOX = ".datatable-row-checkbox";
const $0abbbd36a260e067$var$EVENT_KEY$9 = `.${$0abbbd36a260e067$var$DATA_KEY$e}`;
const $0abbbd36a260e067$var$EVENT_SELECTED = `rowSelected${$0abbbd36a260e067$var$EVENT_KEY$9}`;
const $0abbbd36a260e067$var$EVENT_RENDER = `render${$0abbbd36a260e067$var$EVENT_KEY$9}`;
const $0abbbd36a260e067$var$EVENT_ROW_CLICKED = `rowClicked${$0abbbd36a260e067$var$EVENT_KEY$9}`;
const $0abbbd36a260e067$var$EVENT_UPDATE$1 = `update${$0abbbd36a260e067$var$EVENT_KEY$9}`;
const $0abbbd36a260e067$var$EVENT_VALUE_CHANGED_SELECT = "valueChanged.mdb.select";
const $0abbbd36a260e067$var$TYPE_OPTIONS = {
    bordered: "boolean",
    borderless: "boolean",
    borderColor: "(string|null)",
    clickableRows: "boolean",
    color: "(string|null)",
    defaultValue: "string",
    edit: "boolean",
    entries: "(number|string)",
    entriesOptions: "array",
    fullPagination: "boolean",
    hover: "boolean",
    loading: "boolean",
    loadingMessage: "string",
    maxWidth: "(null|number|string)",
    maxHeight: "(null|number|string)",
    multi: "boolean",
    noFoundMessage: "string",
    pagination: "boolean",
    selectable: "boolean",
    sm: "boolean",
    sortField: "(null|string)",
    sortOrder: "string",
    loaderClass: "string",
    fixedHeader: "boolean",
    striped: "boolean",
    rowsText: "string",
    ofText: "string",
    allText: "string",
    forceSort: "boolean"
};
const $0abbbd36a260e067$var$TYPE_COLUMN_FIELDS = {
    label: "string",
    field: "string",
    fixed: "(boolean|string)",
    format: "(function|null)",
    width: "(number|null)",
    sort: "boolean"
};
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$8 = {
    bordered: false,
    borderless: false,
    borderColor: null,
    clickableRows: false,
    color: null,
    defaultValue: "-",
    edit: false,
    entries: 10,
    entriesOptions: [
        10,
        25,
        50,
        200
    ],
    fixedHeader: false,
    fullPagination: false,
    hover: false,
    loaderClass: "bg-primary",
    loading: false,
    loadingMessage: "Loading results...",
    maxWidth: null,
    maxHeight: null,
    multi: false,
    noFoundMessage: "No matching results found",
    pagination: true,
    selectable: false,
    sm: false,
    sortField: null,
    sortOrder: "asc",
    striped: false,
    rowsText: "Rows per page:",
    ofText: "of",
    allText: "All",
    forceSort: false
};
const $0abbbd36a260e067$var$DEFAULT_COLUMN = {
    label: "",
    field: "",
    fixed: false,
    format: null,
    width: null,
    sort: true
};
class $0abbbd36a260e067$export$aeedc005af528695 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, data = {}, options = {}){
        super(element2);
        this._options = this._getOptions(options);
        this._sortReverse = false;
        this._activePage = 0;
        this._search = "";
        this._searchColumn = null;
        this._paginationLeft = null;
        this._paginationRight = null;
        this._paginationStart = null;
        this._paginationEnd = null;
        this._select = null;
        this._selectInstance = null;
        this._selected = [];
        this._checkboxes = null;
        this._headerCheckbox = null;
        this._rows = this._getRows(data.rows);
        this._columns = this._getColumns(data.columns);
        this._tableId = null;
        this._hasFixedColumns = null;
        if (this._element) {
            this._perfectScrollbar = null;
            this._setup();
            this._hasFixedColumns = this._columns.some((column)=>column.hasOwnProperty("fixed"));
            if (this._hasFixedColumns) this._listenToWindowResize();
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$j;
    }
    get columns() {
        return this._columns.map((column, index)=>{
            let template = {
                ...$0abbbd36a260e067$var$DEFAULT_COLUMN,
                field: `field_${index}`,
                columnIndex: index
            };
            if (typeof column === "string") template.label = column;
            else if (typeof column === "object") template = {
                ...template,
                ...column
            };
            $0abbbd36a260e067$var$typeCheckConfig("column", template, $0abbbd36a260e067$var$TYPE_COLUMN_FIELDS);
            return template;
        });
    }
    get rows() {
        return this._rows.map((row, index)=>{
            const output = {
                rowIndex: index
            };
            if (Array.isArray(row)) this.columns.forEach((column, i)=>{
                if (row[i] === 0) output[column.field] = row[i];
                else output[column.field] = row[i] || this._options.defaultValue;
            });
            else if (typeof row === "object") this.columns.forEach((column)=>{
                if (row[column.field] === 0) output[column.field] = row[column.field];
                else output[column.field] = row[column.field] || this._options.defaultValue;
            });
            return output;
        });
    }
    get searchResult() {
        return $0abbbd36a260e067$var$search(this.rows, this._search, this._searchColumn);
    }
    get computedRows() {
        let result = [
            ...this.searchResult
        ];
        if (this._options.sortOrder) result = $0abbbd36a260e067$var$sort({
            rows: result,
            field: this._options.sortField,
            order: this._options.sortOrder
        });
        if (this._options.pagination) {
            if (this._optionToLowerCase(this._options.entries) === "all") result = $0abbbd36a260e067$var$paginate({
                rows: result,
                entries: result.length,
                activePage: this._activePage
            });
            else result = $0abbbd36a260e067$var$paginate({
                rows: result,
                entries: this._options.entries,
                activePage: this._activePage
            });
        }
        return result;
    }
    get pages() {
        if (this._optionToLowerCase(this._options.entries) === "all") return 1;
        return Math.ceil(this.searchResult.length / this._options.entries);
    }
    get navigationText() {
        const firstVisibleEntry = this._activePage * this._options.entries;
        if (this.searchResult.length === 0) return `0 ${this._options.ofText} 0`;
        if (this._optionToLowerCase(this._options.entries) === "all") return `1 - ${this.searchResult.length} ${this._options.ofText} ${this.searchResult.length}`;
        return `${firstVisibleEntry + 1} - ${this.computedRows.length + firstVisibleEntry} ${this._options.ofText} ${this.searchResult.length}`;
    }
    get classNames() {
        return [
            $0abbbd36a260e067$var$CLASS_DATATABLE,
            this._options.color,
            this._options.borderColor && `border-${this._options.borderColor}`,
            this._options.hover && "datatable-hover",
            this._options.bordered && "datatable-bordered",
            this._options.borderless && "datatable-borderless",
            this._options.sm && "datatable-sm",
            this._options.striped && "datatable-striped",
            this._options.loading && "datatable-loading",
            this._options.clickableRows && "datatable-clickable-rows"
        ].filter((className)=>className);
    }
    get tableOptions() {
        return {
            columns: this.columns,
            rows: this.computedRows,
            noFoundMessage: this._options.noFoundMessage,
            edit: this._options.edit,
            loading: this._options.loading,
            loaderClass: this._options.loaderClass,
            loadingMessage: this._options.loadingMessage,
            selectable: this._options.selectable,
            multi: this._options.multi,
            pagination: {
                enable: this._options.pagination,
                text: this.navigationText,
                entries: this._options.entries,
                entriesOptions: this._options.entriesOptions,
                fullPagination: this._options.fullPagination,
                rowsText: this._options.rowsText,
                ofText: this._options.ofText,
                allText: this._options.allText
            },
            forceSort: this._options.forceSort
        };
    }
    // Public
    update(data, options = {}) {
        if (data && data.rows) this._rows = data.rows;
        if (data && data.columns) this._columns = data.columns;
        this._clearClassList(options);
        this._options = this._getOptions({
            ...this._options,
            ...options
        });
        this._setup();
        this._performSort();
    }
    dispose() {
        if (this._selectInstance) this._selectInstance.dispose();
        this._removeEventListeners();
        this._perfectScrollbar.destroy();
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    search(string, column) {
        this._search = string;
        this._searchColumn = column;
        this._activePage = 0;
        if (this._options.pagination) this._toggleDisableState();
        this._renderRows();
        if (this._options.maxHeight) {
            this._perfectScrollbar.element.scrollTop = 0;
            this._perfectScrollbar.update();
        }
    }
    sort(column, order2 = "asc") {
        this._options.sortOrder = order2;
        if (typeof column === "string") this._options.sortField = this.columns.find((header)=>header.label === column).field;
        else this._options.sortField = column.field;
        const icon = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`i[data-mdb-sort="${this._options.sortField}"]`, this._element);
        this._toggleDisableState();
        this._renderRows();
        this._setActiveSortIcon(icon);
    }
    setActivePage(index) {
        if (index < this.pages) this._changeActivePage(index);
    }
    // Private
    _changeActivePage(index) {
        this._activePage = index;
        this._toggleDisableState();
        this._renderRows();
    }
    _optionToLowerCase(option) {
        return typeof option === "string" ? option.toLowerCase() : option;
    }
    _clearClassList(options) {
        if (this._options.color && options.color) $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, this._options.color);
        if (this._options.borderColor && options.borderColor) $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, `border-${this._options.borderColor}`);
        [
            "hover",
            "bordered",
            "borderless",
            "sm",
            "striped",
            "loading"
        ].forEach((option)=>{
            if (this._options[option] && !options[option]) $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, `datatable-${option}`);
        });
    }
    _emitSelectEvent() {
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SELECTED, {
            selectedRows: this.rows.filter((row)=>this._selected.indexOf(row.rowIndex) !== -1),
            selectedIndexes: this._selected,
            allSelected: this._selected.length === this.rows.length
        });
    }
    _getRows(rows2 = []) {
        const body = $0abbbd36a260e067$var$SelectorEngine$1.findOne("tbody", this._element);
        if (!body) return rows2;
        const tableRows = $0abbbd36a260e067$var$SelectorEngine$1.find("tr", body).map((row)=>{
            return $0abbbd36a260e067$var$SelectorEngine$1.find("td", row).map((cell)=>cell.innerHTML);
        });
        return [
            ...tableRows,
            ...rows2
        ];
    }
    _getColumns(columns2 = []) {
        const head = $0abbbd36a260e067$var$SelectorEngine$1.findOne("thead", this._element);
        if (!head) return columns2;
        const headerRow = $0abbbd36a260e067$var$SelectorEngine$1.findOne("tr", head);
        const headers = $0abbbd36a260e067$var$SelectorEngine$1.find("th", headerRow).map((cell)=>({
                label: cell.innerHTML,
                ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(cell)
            }));
        return [
            ...headers,
            ...columns2
        ];
    }
    _getCSSValue(size) {
        if (typeof size === "string") return size;
        return `${size}px`;
    }
    _getOptions(options) {
        const config = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$8,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...options
        };
        const entriesOptions = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element).entriesOptions;
        const entriesOptionsAsArray = Array.isArray(config.entriesOptions) ? config.entriesOptions : JSON.parse(entriesOptions.replaceAll("'", '"'));
        config.entriesOptions = entriesOptionsAsArray;
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$j, config, $0abbbd36a260e067$var$TYPE_OPTIONS);
        return config;
    }
    _setActiveRows() {
        $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_ROW, this._element).forEach((row)=>{
            if (this._selected.includes($0abbbd36a260e067$var$Manipulator$1.getDataAttribute(row, "index"))) $0abbbd36a260e067$var$Manipulator$1.addClass(row, "active");
            else $0abbbd36a260e067$var$Manipulator$1.removeClass(row, "active");
        });
    }
    _setEntries(e) {
        this._options = this._getOptions({
            ...this._options,
            entries: e.target.value
        });
        if (this._activePage > this.pages - 1) this._activePage = this.pages - 1;
        this._toggleDisableState();
        this._renderRows();
    }
    _setSelected() {
        $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_ROW_CHECKBOX, this._element).forEach((checkbox)=>{
            const index = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(checkbox, "rowIndex");
            checkbox.checked = this._selected.includes(index);
        });
        this._setActiveRows();
    }
    _setActiveSortIcon(active) {
        $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_SORT_ICON, this._element).forEach((icon)=>{
            const angle = this._options.sortOrder === "desc" && icon === active ? 180 : 0;
            $0abbbd36a260e067$var$Manipulator$1.style(icon, {
                transform: `rotate(${angle}deg)`
            });
            if (icon === active && this._options.sortOrder) $0abbbd36a260e067$var$Manipulator$1.addClass(icon, "active");
            else $0abbbd36a260e067$var$Manipulator$1.removeClass(icon, "active");
        });
    }
    _setClassNames() {
        this.classNames.forEach((className)=>{
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, className);
        });
    }
    _setup() {
        this._setClassNames();
        this._renderTable();
        if (this._options.pagination) this._setupPagination();
        if (this._options.edit) this._setupEditable();
        if (this._options.clickableRows) this._setupClickableRows();
        if (this._options.selectable) this._setupSelectable();
        this._setupScroll();
        this._setupSort();
    }
    _listenToWindowResize() {
        this._windowResizeHandler = this._handleWindowResize.bind(this);
        $0abbbd36a260e067$var$EventHandlerMulti.on(window, "resize DOMContentLoaded", this._windowResizeHandler);
    }
    _handleWindowResize() {
        this._renderRows();
    }
    _setupClickableRows() {
        $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_ROW, this._element).forEach((row)=>{
            const index = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(row, "index");
            $0abbbd36a260e067$var$EventHandler$1.on(row, "click", (e)=>{
                if (!$0abbbd36a260e067$var$SelectorEngine$1.matches(e.target, $0abbbd36a260e067$var$SELECTOR_ROW_CHECKBOX)) $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_ROW_CLICKED, {
                    index: index,
                    row: this.rows[index]
                });
            });
        });
    }
    _setupEditable() {
        $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_ROW, this._element).forEach((row)=>{
            const index = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(row, "index");
            $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_CELL, row).forEach((cell)=>{
                $0abbbd36a260e067$var$EventHandler$1.on(cell, "input", (e)=>this._updateRow(e, index));
            });
        });
    }
    _setupScroll() {
        const datatableBody = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_BODY, this._element);
        const style = {
            overflow: "auto",
            position: "relative"
        };
        if (this._options.maxHeight) style.maxHeight = this._getCSSValue(this._options.maxHeight);
        if (this._options.maxWidth) {
            const width = this._getCSSValue(this._options.maxWidth);
            style.maxWidth = width;
            $0abbbd36a260e067$var$Manipulator$1.style(this._element, {
                maxWidth: width
            });
        }
        $0abbbd36a260e067$var$Manipulator$1.style(datatableBody, style);
        if (this._options.fixedHeader) {
            let headers = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_HEADER, this._element);
            if (this._options.selectable) headers = headers.filter((header, index)=>{
                $0abbbd36a260e067$var$Manipulator$1.addClass(header, $0abbbd36a260e067$var$CLASS_FIXED_CELL);
                if (this._options.color) $0abbbd36a260e067$var$Manipulator$1.addClass(header, this._options.color);
                return index !== 0;
            });
            headers.forEach((header, i)=>{
                $0abbbd36a260e067$var$Manipulator$1.addClass(header, $0abbbd36a260e067$var$CLASS_FIXED_CELL);
                if (this.columns[i].fixed) $0abbbd36a260e067$var$Manipulator$1.addStyle(header, {
                    zIndex: 4
                });
                if (this._options.color) $0abbbd36a260e067$var$Manipulator$1.addClass(header, this._options.color);
            });
        }
        this._perfectScrollbar = new $0abbbd36a260e067$var$PerfectScrollbar(datatableBody);
    }
    _setupSort() {
        $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_SORT_ICON, this._element).forEach((icon)=>{
            const field = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(icon, "sort");
            const [header] = $0abbbd36a260e067$var$SelectorEngine$1.parents(icon, "th");
            $0abbbd36a260e067$var$Manipulator$1.style(header, {
                cursor: "pointer"
            });
            if (field === this._options.sortField) this._setActiveSortIcon(icon);
            $0abbbd36a260e067$var$EventHandler$1.on(header, "click", ()=>{
                if (this._options.sortField === field && this._options.sortOrder === "asc") this._options.sortOrder = "desc";
                else if (this._options.sortField === field && this._options.sortOrder === "desc") this._options.sortOrder = this._options.forceSort ? "asc" : null;
                else this._options.sortOrder = "asc";
                this._options.sortField = field;
                this._performSort();
                this._setActiveSortIcon(icon);
            });
        });
    }
    _performSort() {
        this._toggleDisableState();
        this._renderRows();
    }
    _setupSelectable() {
        this._checkboxes = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_ROW_CHECKBOX, this._element);
        this._headerCheckbox = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_HEADER_CHECKBOX, this._element);
        $0abbbd36a260e067$var$EventHandler$1.on(this._headerCheckbox, "input", (e)=>this._toggleSelectAll(e));
        this._checkboxes.forEach((checkbox)=>{
            const rowIndex = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(checkbox, "rowIndex");
            $0abbbd36a260e067$var$EventHandler$1.on(checkbox, "input", (e)=>this._toggleSelectRow(e, rowIndex));
        });
    }
    _setupPagination() {
        this._paginationRight = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_PAGINATION_RIGHT, this._element);
        this._paginationLeft = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_PAGINATION_LEFT, this._element);
        $0abbbd36a260e067$var$EventHandler$1.on(this._paginationRight, "click", ()=>this._changeActivePage(this._activePage + 1));
        $0abbbd36a260e067$var$EventHandler$1.on(this._paginationLeft, "click", ()=>this._changeActivePage(this._activePage - 1));
        if (this._options.fullPagination) {
            this._paginationStart = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_PAGINATION_START, this._element);
            this._paginationEnd = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_PAGINATION_END, this._element);
            $0abbbd36a260e067$var$EventHandler$1.on(this._paginationStart, "click", ()=>this._changeActivePage(0));
            $0abbbd36a260e067$var$EventHandler$1.on(this._paginationEnd, "click", ()=>this._changeActivePage(this.pages - 1));
        }
        this._toggleDisableState();
        this._setupPaginationSelect();
    }
    _setupPaginationSelect() {
        this._select = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_SELECT, this._element);
        if (this._selectInstance) this._selectInstance.dispose();
        this._selectInstance = new $0abbbd36a260e067$export$ef9b1a59e592288f(this._select);
        $0abbbd36a260e067$var$EventHandler$1.on(this._select, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED_SELECT, (e)=>this._setEntries(e));
    }
    _removeEventListeners() {
        if (this._options.pagination) {
            $0abbbd36a260e067$var$EventHandler$1.off(this._paginationRight, "click");
            $0abbbd36a260e067$var$EventHandler$1.off(this._paginationLeft, "click");
            $0abbbd36a260e067$var$EventHandler$1.off(this._select, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED_SELECT);
            if (this._options.fullPagination) {
                $0abbbd36a260e067$var$EventHandler$1.off(this._paginationStart, "click");
                $0abbbd36a260e067$var$EventHandler$1.off(this._paginationEnd, "click");
            }
            $0abbbd36a260e067$var$EventHandlerMulti.off(window, "resize DOMContentLoaded", this._windowResizeHandler);
        }
        if (this._options.editable) $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_CELL, this._element).forEach((cell)=>{
            $0abbbd36a260e067$var$EventHandler$1.off(cell, "input");
        });
        if (this._options.clickableRows) $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_ROW, this._element).forEach((row)=>{
            $0abbbd36a260e067$var$EventHandler$1.off(row, "click");
        });
        $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_SORT_ICON, this._element).forEach((icon)=>{
            const [header] = $0abbbd36a260e067$var$SelectorEngine$1.parents(icon, "th");
            $0abbbd36a260e067$var$EventHandler$1.off(header, "click");
        });
        if (this._options.selectable) {
            $0abbbd36a260e067$var$EventHandler$1.off(this._headerCheckbox, "input");
            this._checkboxes.forEach((checkbox)=>{
                $0abbbd36a260e067$var$EventHandler$1.off(checkbox, "input");
            });
        }
    }
    _renderTable() {
        const userTable = $0abbbd36a260e067$var$SelectorEngine$1.findOne("table", this._element);
        this._tableId = userTable == null ? void 0 : userTable.getAttribute("id");
        this._element.innerHTML = $0abbbd36a260e067$var$tableTemplate(this.tableOptions).table;
        if (this._tableId) {
            const renderedTable = $0abbbd36a260e067$var$SelectorEngine$1.findOne("table", this._element);
            renderedTable.setAttribute("id", this._tableId);
        }
        this._formatCells();
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_RENDER);
    }
    _renderRows() {
        const body = $0abbbd36a260e067$var$SelectorEngine$1.findOne("tbody", this._element);
        if (this._options.pagination) {
            const navigation = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_PAGINATION_NAV, this._element);
            navigation.innerText = this.navigationText;
        }
        body.innerHTML = $0abbbd36a260e067$var$tableTemplate(this.tableOptions).rows;
        this._formatCells();
        if (this._options.edit) this._setupEditable();
        if (this._options.selectable) {
            this._setupSelectable();
            this._setSelected();
        }
        if (this._options.clickableRows) this._setupClickableRows();
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_RENDER);
    }
    _formatCells() {
        const columnsMap = new Map(this.columns.map((obj)=>{
            return [
                obj.field,
                obj
            ];
        }));
        const rows2 = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_ROW, this._element);
        const rowsData = this.computedRows;
        const cellsToFormat = [];
        rows2.forEach((row, index)=>{
            const cells = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_CELL, row);
            cells.forEach((cell)=>{
                const field = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(cell, "field");
                const column = columnsMap.get(field);
                if (column && column.format !== null) {
                    const cellData = rowsData[index][field];
                    cellsToFormat.push({
                        cell: cell,
                        column: column,
                        cellData: cellData
                    });
                }
            });
        });
        cellsToFormat.forEach(({ cell: cell, column: column, cellData: cellData })=>column.format(cell, cellData));
    }
    _toggleDisableState() {
        if (this._options.pagination === false) return;
        if (this._activePage === 0 || this._options.loading) {
            this._paginationLeft.setAttribute("disabled", true);
            if (this._options.fullPagination) this._paginationStart.setAttribute("disabled", true);
        } else {
            this._paginationLeft.removeAttribute("disabled");
            if (this._options.fullPagination) this._paginationStart.removeAttribute("disabled");
        }
        if (this._activePage === this.pages - 1 || this._options.loading || this.pages === 0) {
            this._paginationRight.setAttribute("disabled", true);
            if (this._options.fullPagination) this._paginationEnd.setAttribute("disabled", true);
        } else {
            this._paginationRight.removeAttribute("disabled");
            if (this._options.fullPagination) this._paginationEnd.removeAttribute("disabled");
        }
    }
    _toggleSelectAll(e) {
        if (e.target.checked) this._selected = this.rows.map((row)=>row.rowIndex);
        else this._selected = [];
        this._setSelected();
        this._emitSelectEvent();
    }
    _toggleSelectRow(e, rowIndex) {
        if (e.target.checked) {
            if (this._options.multi && !this._selected.includes(rowIndex)) this._selected = [
                ...this._selected,
                rowIndex
            ];
            else {
                this._selected = [
                    rowIndex
                ];
                this._checkboxes.forEach((checkbox)=>{
                    if (checkbox !== e.target) checkbox.checked = false;
                });
            }
        } else this._selected = this._selected.filter((index)=>index !== rowIndex);
        if (this._options.multi && !e.target.checked) this._headerCheckbox.checked = false;
        this._setActiveRows();
        this._emitSelectEvent();
    }
    _updateRow(event, index) {
        const field = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(event.target, "field");
        const value = event.target.textContent;
        const row = this._rows[index];
        if (Array.isArray(row)) {
            const column = this.columns.find((column2)=>{
                return column2.field === field;
            });
            const columnIndex = column.columnIndex;
            row[columnIndex] = value;
        } else row[field] = value;
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_UPDATE$1, {
            rows: this._rows,
            columns: this._columns
        });
    }
    static jQueryInterface(config, param1, param2) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$e);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$aeedc005af528695(this, _config, param1);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](param1, param2);
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$i = "stepper";
const $0abbbd36a260e067$var$DATA_KEY$d = "mdb.stepper";
const $0abbbd36a260e067$var$EVENT_KEY$8 = `.${$0abbbd36a260e067$var$DATA_KEY$d}`;
const $0abbbd36a260e067$var$STEPPER_HORIZONTAL = "horizontal";
const $0abbbd36a260e067$var$STEPPER_VERTICAL = "vertical";
const $0abbbd36a260e067$var$STEPPER_MOBILE = "mobile";
const $0abbbd36a260e067$var$DefaultType$b = {
    stepperType: "string",
    stepperLinear: "boolean",
    stepperNoEditable: "boolean",
    stepperActive: "string",
    stepperCompleted: "string",
    stepperInvalid: "string",
    stepperDisabled: "string",
    stepperVerticalBreakpoint: "number",
    stepperMobileBreakpoint: "number",
    stepperMobileBarBreakpoint: "number",
    animations: "boolean",
    stepperHeadClick: "boolean",
    stepperMobileNextBtn: "string",
    stepperMobileBackBtn: "string",
    stepperMobileStepTxt: "string",
    stepperMobileOfTxt: "string"
};
const $0abbbd36a260e067$var$Default$b = {
    stepperType: $0abbbd36a260e067$var$STEPPER_HORIZONTAL,
    stepperLinear: false,
    stepperNoEditable: false,
    stepperActive: "",
    stepperCompleted: "",
    stepperInvalid: "",
    stepperDisabled: "",
    stepperVerticalBreakpoint: 0,
    stepperMobileBreakpoint: 0,
    stepperMobileBarBreakpoint: 4,
    animations: true,
    stepperHeadClick: true,
    stepperMobileNextBtn: "NEXT",
    stepperMobileBackBtn: "BACK",
    stepperMobileStepTxt: "step",
    stepperMobileOfTxt: "of"
};
const $0abbbd36a260e067$var$EVENT_MOUSEDOWN = `mousedown${$0abbbd36a260e067$var$EVENT_KEY$8}`;
const $0abbbd36a260e067$var$EVENT_SUBMIT = `submit${$0abbbd36a260e067$var$EVENT_KEY$8}`;
const $0abbbd36a260e067$var$EVENT_KEYDOWN = `keydown${$0abbbd36a260e067$var$EVENT_KEY$8}`;
const $0abbbd36a260e067$var$EVENT_KEYUP = `keyup${$0abbbd36a260e067$var$EVENT_KEY$8}`;
const $0abbbd36a260e067$var$EVENT_RESIZE$1 = `resize${$0abbbd36a260e067$var$EVENT_KEY$8}`;
const $0abbbd36a260e067$var$EVENT_CLICK = `click${$0abbbd36a260e067$var$EVENT_KEY$8}`;
const $0abbbd36a260e067$var$EVENT_ANIMATIONEND = "animationend";
const $0abbbd36a260e067$var$EVENT_CHANGE_STEP = `stepChange${$0abbbd36a260e067$var$EVENT_KEY$8}`;
const $0abbbd36a260e067$var$EVENT_CHANGED_STEP = `stepChanged${$0abbbd36a260e067$var$EVENT_KEY$8}`;
const $0abbbd36a260e067$var$EVENT_INVALID = `stepInvalid${$0abbbd36a260e067$var$EVENT_KEY$8}`;
const $0abbbd36a260e067$var$EVENT_VALID = `stepValid${$0abbbd36a260e067$var$EVENT_KEY$8}`;
const $0abbbd36a260e067$var$STEP_CLASS = `${$0abbbd36a260e067$var$NAME$i}-step`;
const $0abbbd36a260e067$var$HEAD_CLASS = `${$0abbbd36a260e067$var$NAME$i}-head`;
const $0abbbd36a260e067$var$HEAD_TEXT_CLASS = `${$0abbbd36a260e067$var$NAME$i}-head-text`;
const $0abbbd36a260e067$var$CONTENT_CLASS = `${$0abbbd36a260e067$var$NAME$i}-content`;
const $0abbbd36a260e067$var$ACTIVE_CLASS = `${$0abbbd36a260e067$var$NAME$i}-active`;
const $0abbbd36a260e067$var$COMPLETED_CLASS = `${$0abbbd36a260e067$var$NAME$i}-completed`;
const $0abbbd36a260e067$var$INVALID_CLASS = `${$0abbbd36a260e067$var$NAME$i}-invalid`;
const $0abbbd36a260e067$var$DISABLED_CLASS = `${$0abbbd36a260e067$var$NAME$i}-disabled`;
const $0abbbd36a260e067$var$VERTICAL_CLASS = `${$0abbbd36a260e067$var$NAME$i}-${$0abbbd36a260e067$var$STEPPER_VERTICAL}`;
const $0abbbd36a260e067$var$CONTENT_HIDE_CLASS = `${$0abbbd36a260e067$var$NAME$i}-content-hide`;
const $0abbbd36a260e067$var$HORIZONTAL_CLASS = `${$0abbbd36a260e067$var$NAME$i}-${$0abbbd36a260e067$var$STEPPER_HORIZONTAL}`;
const $0abbbd36a260e067$var$MOBILE_CLASS = `${$0abbbd36a260e067$var$NAME$i}-${$0abbbd36a260e067$var$STEPPER_MOBILE}`;
const $0abbbd36a260e067$var$MOBILE_HEAD_CLASS = `${$0abbbd36a260e067$var$NAME$i}-${$0abbbd36a260e067$var$STEPPER_MOBILE}-head`;
const $0abbbd36a260e067$var$MOBILE_FOOTER_CLASS = `${$0abbbd36a260e067$var$NAME$i}-${$0abbbd36a260e067$var$STEPPER_MOBILE}-footer`;
const $0abbbd36a260e067$var$MOBILE_PROGRESS_BAR_CLASS = `${$0abbbd36a260e067$var$NAME$i}-${$0abbbd36a260e067$var$STEPPER_MOBILE}-progress-bar`;
const $0abbbd36a260e067$var$MOBILE_PROGRESS_CLASS = `${$0abbbd36a260e067$var$NAME$i}-${$0abbbd36a260e067$var$STEPPER_MOBILE}-progress`;
const $0abbbd36a260e067$var$NEXT_BTN_CLASS = `${$0abbbd36a260e067$var$NAME$i}-next-btn`;
const $0abbbd36a260e067$var$BACK_BTN_CLASS = `${$0abbbd36a260e067$var$NAME$i}-back-btn`;
const $0abbbd36a260e067$var$MOBILE_ACTIVE_STEP_ID = `${$0abbbd36a260e067$var$NAME$i}-active-step`;
const $0abbbd36a260e067$var$MOBILE_NUMBER_OF_STEPS_ID = `${$0abbbd36a260e067$var$NAME$i}-all-steps`;
const $0abbbd36a260e067$var$MOBILE_BUTTON_NEXT = (options)=>{
    return `
  <div class="${$0abbbd36a260e067$var$NEXT_BTN_CLASS}">
    <button type="button" class="btn btn-link">
      ${options.stepperMobileNextBtn}
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>
`;
};
const $0abbbd36a260e067$var$MOBILE_BUTTON_BACK = (options)=>{
    return `
  <div class="${$0abbbd36a260e067$var$BACK_BTN_CLASS}">
    <button type="button" class="btn btn-link">
      <i class="fas fa-chevron-left"></i>
      ${options.stepperMobileBackBtn}
    </button>
  </div>
`;
};
const $0abbbd36a260e067$var$MOBILE_STEPPER_HEAD = (options)=>{
    return `
  <div class ="${$0abbbd36a260e067$var$MOBILE_HEAD_CLASS}">
    ${options.stepperMobileStepTxt} <span id="${$0abbbd36a260e067$var$MOBILE_ACTIVE_STEP_ID}"></span> ${options.stepperMobileOfTxt} <span id="${$0abbbd36a260e067$var$MOBILE_NUMBER_OF_STEPS_ID}"></span>
  </div>
`;
};
const $0abbbd36a260e067$var$MOBILE_PROGRESS_BAR = `
  <div class="${$0abbbd36a260e067$var$MOBILE_PROGRESS_CLASS} gray-500">
    <div class="${$0abbbd36a260e067$var$MOBILE_PROGRESS_BAR_CLASS}"></div>
  </div>
`;
const $0abbbd36a260e067$var$MOBILE_FOOTER = `
  <div class="${$0abbbd36a260e067$var$MOBILE_FOOTER_CLASS}"></div>
`;
class $0abbbd36a260e067$export$ed8ca599049e8881 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options){
        super(element2);
        this._options = this._getConfig(options);
        this._elementHeight = 0;
        this._steps = $0abbbd36a260e067$var$SelectorEngine$1.find(`.${$0abbbd36a260e067$var$STEP_CLASS}`, this._element);
        this._currentView = "";
        this._activeStepIndex = 0;
        this._verticalStepperStyles = [];
        this._animations = !window.matchMedia("(prefers-reduced-motion: reduce)").matches && this._options.animations;
        if (this._element) {
            this._init();
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$i;
    }
    get activeStep() {
        return this._steps[this._activeStepIndex];
    }
    get activeStepIndex() {
        return this._activeStepIndex;
    }
    // Public
    dispose() {
        this._steps.forEach((el)=>{
            $0abbbd36a260e067$var$EventHandler$1.off(el, $0abbbd36a260e067$var$EVENT_MOUSEDOWN);
            $0abbbd36a260e067$var$EventHandler$1.off(el, $0abbbd36a260e067$var$EVENT_KEYDOWN);
        });
        $0abbbd36a260e067$var$EventHandler$1.off(window, $0abbbd36a260e067$var$EVENT_RESIZE$1);
        this._unbindMouseDown();
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    changeStep(index) {
        this._toggleStep(index);
    }
    nextStep() {
        this._toggleStep(this._activeStepIndex + 1);
    }
    prevStep() {
        this._toggleStep(this._activeStepIndex - 1);
    }
    resizeStepper() {
        if (this._currentView === $0abbbd36a260e067$var$STEPPER_VERTICAL) this._setSingleStepHeight(this.activeStep);
        if (this._currentView === $0abbbd36a260e067$var$STEPPER_HORIZONTAL) this._setHeight(this.activeStep);
        if (this._options.stepperVerticalBreakpoint || this._options.stepperMobileBreakpoint) this._toggleStepperView();
    }
    // Private
    _init() {
        const activeStep = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$ACTIVE_CLASS}`, this._element);
        if (activeStep) {
            this._activeStepIndex = this._steps.indexOf(activeStep);
            this._toggleStepClass(this._activeStepIndex, "add", this._options.stepperActive);
        } else {
            this._toggleStepClass(this._activeStepIndex, "add", $0abbbd36a260e067$var$ACTIVE_CLASS);
            this._toggleStepClass(this._activeStepIndex, "add", this._options.stepperActive);
        }
        this._setOptional();
        if (this._options.stepperHeadClick) this._bindMouseDown();
        this._bindKeysNavigation();
        switch(this._options.stepperType){
            case $0abbbd36a260e067$var$STEPPER_VERTICAL:
                this._toggleVertical();
                break;
            case $0abbbd36a260e067$var$STEPPER_MOBILE:
                this._toggleMobile();
                break;
            default:
                this._toggleHorizontal();
                break;
        }
        if (this._options.stepperVerticalBreakpoint || this._options.stepperMobileBreakpoint) this._toggleStepperView();
        if (this._options.stepperLinear) this._setValidation();
        this._bindResize();
    }
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        config = {
            ...$0abbbd36a260e067$var$Default$b,
            ...dataAttributes,
            ...config
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$i, config, $0abbbd36a260e067$var$DefaultType$b);
        return config;
    }
    _bindMouseDown() {
        this._steps.forEach((el)=>{
            const stepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, el);
            $0abbbd36a260e067$var$EventHandler$1.on(stepHead, $0abbbd36a260e067$var$EVENT_MOUSEDOWN, (e)=>{
                const step = $0abbbd36a260e067$var$SelectorEngine$1.parents(e.target, `.${$0abbbd36a260e067$var$STEP_CLASS}`)[0];
                const stepIndex = this._steps.indexOf(step);
                e.preventDefault();
                this._toggleStep(stepIndex);
            });
        });
    }
    _unbindMouseDown() {
        this._steps.forEach((el)=>{
            const stepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, el);
            $0abbbd36a260e067$var$EventHandler$1.off(stepHead, $0abbbd36a260e067$var$EVENT_MOUSEDOWN);
        });
    }
    _bindResize() {
        $0abbbd36a260e067$var$EventHandler$1.on(window, $0abbbd36a260e067$var$EVENT_RESIZE$1, ()=>{
            this.resizeStepper();
        });
    }
    _toggleStepperView() {
        const shouldBeHorizontal = this._options.stepperVerticalBreakpoint < window.innerWidth;
        const shouldBeVertical = this._options.stepperVerticalBreakpoint > window.innerWidth;
        const shouldBeMobile = this._options.stepperMobileBreakpoint > window.innerWidth;
        if (shouldBeHorizontal && this._currentView !== $0abbbd36a260e067$var$STEPPER_HORIZONTAL) this._toggleHorizontal();
        if (shouldBeVertical && !shouldBeMobile && this._currentView !== $0abbbd36a260e067$var$STEPPER_VERTICAL) {
            this._steps.forEach((el)=>{
                const stepContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, el);
                this._resetStepperHeight();
                this._showElement(stepContent);
            });
            this._toggleVertical();
        }
        if (shouldBeMobile && this._currentView !== $0abbbd36a260e067$var$STEPPER_MOBILE) this._toggleMobile();
    }
    _toggleStep(index) {
        const numberOfSteps = this._steps.length;
        const isValid = this._validateStep(index);
        const activeStepIndex = this._activeStepIndex;
        if (!isValid) return;
        if (this._options.stepperLinear) $0abbbd36a260e067$var$EventHandler$1.trigger(this.activeStep, $0abbbd36a260e067$var$EVENT_VALID, {
            currentStep: this._activeStepIndex,
            nextStep: index
        });
        if (this._options.stepperNoEditable) this._toggleDisabled();
        this._showElement($0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, this._steps[index]));
        this._toggleActive(index);
        if (!this._options.stepperLinear || index > this._activeStepIndex) this._toggleCompleted(this._activeStepIndex);
        if (this._currentView === $0abbbd36a260e067$var$STEPPER_HORIZONTAL || this._currentView === $0abbbd36a260e067$var$STEPPER_MOBILE) this._animateHorizontalStep(index);
        else {
            this._animateVerticalStep(index);
            this._setSingleStepHeight(this._steps[index]);
        }
        this._toggleStepTabIndex($0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, this.activeStep), $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, this._steps[index]));
        this._activeStepIndex = index;
        if (this._currentView === $0abbbd36a260e067$var$STEPPER_MOBILE) {
            const activeStepElement = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`#${$0abbbd36a260e067$var$MOBILE_ACTIVE_STEP_ID}`, this._element);
            activeStepElement.textContent = this._activeStepIndex + 1;
            if (numberOfSteps > this._options.stepperMobileBarBreakpoint) this._updateProgressBar();
        }
        const inputs = this.activeStep.querySelectorAll(".form-outline");
        const inputNotches = $0abbbd36a260e067$var$SelectorEngine$1.find(".form-notch", inputs[0]);
        if (inputs.length && inputNotches.length < 1) inputs.forEach((formOutline)=>{
            new mdb.Input(formOutline).init();
        });
        $0abbbd36a260e067$var$EventHandler$1.trigger(this.activeStep, $0abbbd36a260e067$var$EVENT_CHANGED_STEP, {
            currentStep: this._activeStepIndex,
            prevStep: activeStepIndex
        });
    }
    _resetStepperHeight() {
        this._element.style.height = "";
    }
    _setStepsHeight() {
        this._steps.forEach((el)=>{
            const stepContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, el);
            const stepComputed = window.getComputedStyle(stepContent);
            this._verticalStepperStyles.push({
                paddingTop: parseFloat(stepComputed.paddingTop),
                paddingBottom: parseFloat(stepComputed.paddingBottom)
            });
            const stepHeight = stepContent.scrollHeight;
            stepContent.style.height = `${stepHeight}px`;
        });
    }
    _setSingleStepHeight(step) {
        const stepContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, step);
        const isActiveStep = this.activeStep === step;
        const stepIndex = this._steps.indexOf(step);
        let stepContentHeight;
        if (!isActiveStep) stepContentHeight = stepContent.scrollHeight + this._verticalStepperStyles[stepIndex].paddingTop + this._verticalStepperStyles[stepIndex].paddingBottom;
        else {
            stepContent.style.height = "";
            stepContentHeight = stepContent.scrollHeight;
        }
        stepContent.style.height = `${stepContentHeight}px`;
    }
    _createMobileElements() {
        this._element.insertAdjacentHTML("beforeend", $0abbbd36a260e067$var$MOBILE_FOOTER);
        const footer = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$MOBILE_FOOTER_CLASS}`, this._element);
        if (this._steps.length > this._options.stepperMobileBarBreakpoint) {
            this._element.classList.add("stepper-progress-bar");
            footer.insertAdjacentHTML("afterbegin", $0abbbd36a260e067$var$MOBILE_PROGRESS_BAR);
            this._updateProgressBar();
        }
        footer.insertAdjacentHTML("afterbegin", $0abbbd36a260e067$var$MOBILE_BUTTON_BACK(this._options));
        footer.insertAdjacentHTML("beforeend", $0abbbd36a260e067$var$MOBILE_BUTTON_NEXT(this._options));
        this._element.insertAdjacentHTML("afterbegin", $0abbbd36a260e067$var$MOBILE_STEPPER_HEAD(this._options));
        const allStepsElement = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`#${$0abbbd36a260e067$var$MOBILE_NUMBER_OF_STEPS_ID}`, this._element);
        allStepsElement.textContent = this._steps.length;
        const ActiveStepsElement = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`#${$0abbbd36a260e067$var$MOBILE_ACTIVE_STEP_ID}`, this._element);
        ActiveStepsElement.textContent = this._activeStepIndex + 1;
    }
    _toggleMobile() {
        this._currentView = $0abbbd36a260e067$var$STEPPER_MOBILE;
        this._toggleStepperClass($0abbbd36a260e067$var$MOBILE_CLASS);
        this._createMobileElements();
        this._bindMobileButtons();
        this._setHeight(this.activeStep);
        this._hideInactiveSteps();
    }
    _toggleVertical() {
        if (this._currentView === $0abbbd36a260e067$var$STEPPER_MOBILE) {
            this._deleteMobileElements();
            this._unbindMobileButtons();
        }
        this._currentView = $0abbbd36a260e067$var$STEPPER_VERTICAL;
        this._toggleStepperClass($0abbbd36a260e067$var$VERTICAL_CLASS);
        this._setStepsHeight();
        this._hideInactiveSteps();
    }
    _toggleHorizontal() {
        if (this._currentView === $0abbbd36a260e067$var$STEPPER_MOBILE) {
            this._deleteMobileElements();
            this._unbindMobileButtons();
        }
        this._currentView = $0abbbd36a260e067$var$STEPPER_HORIZONTAL;
        this._toggleStepperClass($0abbbd36a260e067$var$HORIZONTAL_CLASS);
        this._setHeight(this.activeStep);
        this._hideInactiveSteps();
    }
    _toggleStepperClass(className) {
        this._element.classList.remove($0abbbd36a260e067$var$HORIZONTAL_CLASS, $0abbbd36a260e067$var$MOBILE_CLASS, $0abbbd36a260e067$var$VERTICAL_CLASS);
        this._element.classList.add(className);
        if (className !== $0abbbd36a260e067$var$VERTICAL_CLASS) this._steps.forEach((el)=>{
            $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, el).classList.remove($0abbbd36a260e067$var$CONTENT_HIDE_CLASS);
        });
    }
    _toggleStepClass(index, action, className) {
        if (className) this._steps[index].classList[action](className);
    }
    _deleteMobileElements() {
        const footer = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$MOBILE_FOOTER_CLASS}`, this._element);
        const head = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$MOBILE_HEAD_CLASS}`, this._element);
        footer.remove();
        head.remove();
    }
    _bindKeysNavigation() {
        this._toggleStepTabIndex(false, $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, this.activeStep));
        this._steps.forEach((el)=>{
            const stepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, el);
            $0abbbd36a260e067$var$EventHandler$1.on(stepHead, $0abbbd36a260e067$var$EVENT_KEYDOWN, (e)=>{
                const focusedStep = $0abbbd36a260e067$var$SelectorEngine$1.parents(e.currentTarget, `.${$0abbbd36a260e067$var$STEP_CLASS}`)[0];
                const nextStep = $0abbbd36a260e067$var$SelectorEngine$1.next(focusedStep, `.${$0abbbd36a260e067$var$STEP_CLASS}`)[0];
                const prevStep = $0abbbd36a260e067$var$SelectorEngine$1.prev(focusedStep, `.${$0abbbd36a260e067$var$STEP_CLASS}`)[0];
                const focusedStepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, focusedStep);
                const activeStepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, this.activeStep);
                let nextStepHead = null;
                let prevStepHead = null;
                if (nextStep) nextStepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, nextStep);
                if (prevStep) prevStepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, prevStep);
                if (e.keyCode === $0abbbd36a260e067$var$LEFT_ARROW && this._currentView !== $0abbbd36a260e067$var$STEPPER_VERTICAL) {
                    if (!$0abbbd36a260e067$var$isRTL$1 && prevStepHead) {
                        this._toggleStepTabIndex(focusedStepHead, prevStepHead);
                        this._toggleOutlineStyles(focusedStepHead, prevStepHead);
                        prevStepHead.focus();
                    } else if ($0abbbd36a260e067$var$isRTL$1 && nextStepHead) {
                        this._toggleStepTabIndex(focusedStepHead, nextStepHead);
                        this._toggleOutlineStyles(focusedStepHead, nextStepHead);
                        nextStepHead.focus();
                    }
                }
                if (e.keyCode === $0abbbd36a260e067$var$RIGHT_ARROW && this._currentView !== $0abbbd36a260e067$var$STEPPER_VERTICAL) {
                    if (!$0abbbd36a260e067$var$isRTL$1 && nextStepHead) {
                        this._toggleStepTabIndex(focusedStepHead, nextStepHead);
                        this._toggleOutlineStyles(focusedStepHead, nextStepHead);
                        nextStepHead.focus();
                    } else if ($0abbbd36a260e067$var$isRTL$1 && prevStepHead) {
                        this._toggleStepTabIndex(focusedStepHead, prevStepHead);
                        this._toggleOutlineStyles(focusedStepHead, prevStepHead);
                        prevStepHead.focus();
                    }
                }
                if (e.keyCode === $0abbbd36a260e067$var$DOWN_ARROW && this._currentView === $0abbbd36a260e067$var$STEPPER_VERTICAL) {
                    e.preventDefault();
                    if (nextStepHead) {
                        this._toggleStepTabIndex(focusedStepHead, nextStepHead);
                        this._toggleOutlineStyles(focusedStepHead, nextStepHead);
                        nextStepHead.focus();
                    }
                }
                if (e.keyCode === $0abbbd36a260e067$var$UP_ARROW && this._currentView === $0abbbd36a260e067$var$STEPPER_VERTICAL) {
                    e.preventDefault();
                    if (prevStepHead) {
                        this._toggleStepTabIndex(focusedStepHead, prevStepHead);
                        this._toggleOutlineStyles(focusedStepHead, prevStepHead);
                        prevStepHead.focus();
                    }
                }
                if (e.keyCode === $0abbbd36a260e067$var$HOME) {
                    const firstStepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, this._steps[0]);
                    this._toggleStepTabIndex(focusedStepHead, firstStepHead);
                    this._toggleOutlineStyles(focusedStepHead, firstStepHead);
                    firstStepHead.focus();
                }
                if (e.keyCode === $0abbbd36a260e067$var$END) {
                    const lastStep = this._steps[this._steps.length - 1];
                    const lastStepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, lastStep);
                    this._toggleStepTabIndex(focusedStepHead, lastStepHead);
                    this._toggleOutlineStyles(focusedStepHead, lastStepHead);
                    lastStepHead.focus();
                }
                if (e.keyCode === $0abbbd36a260e067$var$ENTER || e.keyCode === $0abbbd36a260e067$var$SPACE) {
                    e.preventDefault();
                    this.changeStep(this._steps.indexOf(focusedStep));
                }
                if (e.keyCode === $0abbbd36a260e067$var$TAB) {
                    this._toggleStepTabIndex(focusedStepHead, activeStepHead);
                    this._toggleOutlineStyles(focusedStepHead, false);
                    activeStepHead.focus();
                }
            });
            $0abbbd36a260e067$var$EventHandler$1.on(stepHead, $0abbbd36a260e067$var$EVENT_KEYUP, (e)=>{
                const focusedStep = $0abbbd36a260e067$var$SelectorEngine$1.parents(e.currentTarget, `.${$0abbbd36a260e067$var$STEP_CLASS}`)[0];
                const focusedStepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, focusedStep);
                const activeStepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, this.activeStep);
                if (e.keyCode === $0abbbd36a260e067$var$TAB) {
                    this._toggleStepTabIndex(focusedStepHead, activeStepHead);
                    this._toggleOutlineStyles(false, activeStepHead);
                    activeStepHead.focus();
                }
            });
        });
    }
    _bindMobileButtons() {
        const btnBack = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$BACK_BTN_CLASS}`, this._element);
        const btnNext = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$NEXT_BTN_CLASS}`, this._element);
        $0abbbd36a260e067$var$EventHandler$1.on(btnBack, $0abbbd36a260e067$var$EVENT_CLICK, ()=>this.prevStep());
        $0abbbd36a260e067$var$EventHandler$1.on(btnNext, $0abbbd36a260e067$var$EVENT_CLICK, ()=>this.nextStep());
    }
    _unbindMobileButtons() {
        const btnBack = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$BACK_BTN_CLASS}`, this._element);
        const btnNext = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$NEXT_BTN_CLASS}`, this._element);
        $0abbbd36a260e067$var$EventHandler$1.off(btnBack, $0abbbd36a260e067$var$EVENT_CLICK, ()=>this.prevStep());
        $0abbbd36a260e067$var$EventHandler$1.off(btnNext, $0abbbd36a260e067$var$EVENT_CLICK, ()=>this.nextStep());
    }
    _toggleStepTabIndex(focusedElement, newTarget) {
        if (focusedElement) focusedElement.setAttribute("tabIndex", -1);
        if (newTarget) newTarget.setAttribute("tabIndex", 0);
    }
    _validateActiveStepRequiredElements() {
        const isValid = $0abbbd36a260e067$var$SelectorEngine$1.find("[required]", this.activeStep).every((el)=>{
            return el.checkValidity() === true;
        });
        return isValid;
    }
    _validateStep(index) {
        const numberOfSteps = this._steps.length;
        let result = true;
        if (index === this._activeStepIndex) result = false;
        if (index >= numberOfSteps || index < 0) result = false;
        const changeStepEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this.activeStep, $0abbbd36a260e067$var$EVENT_CHANGE_STEP, {
            currentStep: this._activeStepIndex,
            nextStep: index
        });
        if (this._options.stepperLinear) {
            const stepsToCheck = index - this.activeStepIndex - 1;
            if (index > this._activeStepIndex + 1) {
                let nextStepToValidate = $0abbbd36a260e067$var$SelectorEngine$1.next(this.activeStep, "li")[0];
                for(let i = 0; i < stepsToCheck; i++){
                    if (!nextStepToValidate.classList.contains("stepper-completed")) {
                        nextStepToValidate.classList.add("stepper-invalid");
                        result = false;
                    }
                    nextStepToValidate = $0abbbd36a260e067$var$SelectorEngine$1.next(nextStepToValidate, "li")[0];
                }
            }
            if (index < this._activeStepIndex) {
                if (!this._validateActiveStepRequiredElements()) this.activeStep.classList.remove("stepper-completed");
            }
            if (index > this._activeStepIndex || index === numberOfSteps - 1) {
                this.activeStep.classList.add("was-validated");
                if (!this._validateActiveStepRequiredElements()) {
                    this._toggleInvalid(this._activeStepIndex);
                    $0abbbd36a260e067$var$EventHandler$1.trigger(this.activeStep, $0abbbd36a260e067$var$EVENT_INVALID, {
                        currentStep: this._activeStepIndex,
                        nextStep: index
                    });
                    if (this._currentView !== $0abbbd36a260e067$var$STEPPER_VERTICAL) setTimeout(()=>{
                        this._setHeight(this.activeStep);
                    }, 210);
                    else setTimeout(()=>{
                        this._setSingleStepHeight(this.activeStep);
                    }, 210);
                    result = false;
                }
            }
        }
        if (index > this._activeStepIndex && changeStepEvent.defaultPrevented) result = false;
        if (this._options.stepperNoEditable) {
            if (this._steps[index].classList.contains($0abbbd36a260e067$var$DISABLED_CLASS)) result = false;
        }
        return result;
    }
    _updateProgressBar() {
        const numberOfSteps = this._steps.length;
        const progressBar = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$MOBILE_PROGRESS_BAR_CLASS}`, this._element);
        progressBar.style.width = `${(this._activeStepIndex + 1) / numberOfSteps * 100}%`;
    }
    _toggleOutlineStyles(focusedElement, newTarget) {
        if (focusedElement) focusedElement.style.outline = "";
        if (newTarget) newTarget.style.outline = "revert";
    }
    _toggleDisabled() {
        this._toggleStepClass(this._activeStepIndex, "add", $0abbbd36a260e067$var$DISABLED_CLASS);
        this._toggleStepClass(this._activeStepIndex, "add", this._options.stepperDisabled);
    }
    _toggleActive(index) {
        this._toggleStepClass(index, "add", $0abbbd36a260e067$var$ACTIVE_CLASS);
        this._toggleStepClass(this._activeStepIndex, "remove", $0abbbd36a260e067$var$ACTIVE_CLASS);
        this._toggleStepClass(index, "add", this._options.stepperActive);
        this._toggleStepClass(this._activeStepIndex, "remove", this._options.stepperActive);
    }
    _toggleCompleted(index) {
        this._toggleStepClass(index, "add", $0abbbd36a260e067$var$COMPLETED_CLASS);
        this._toggleStepClass(index, "remove", $0abbbd36a260e067$var$INVALID_CLASS);
        this._toggleStepClass(index, "add", this._options.stepperCompleted);
        this._toggleStepClass(index, "remove", this._options.stepperInvalid);
    }
    _toggleInvalid(index) {
        this._toggleStepClass(index, "add", $0abbbd36a260e067$var$INVALID_CLASS);
        this._toggleStepClass(index, "remove", $0abbbd36a260e067$var$COMPLETED_CLASS);
        this._toggleStepClass(index, "add", this._options.stepperInvalid);
        this._toggleStepClass(index, "remove", this._options.stepperCompleted);
    }
    _setOptional() {
        this._steps.forEach((el)=>{
            const isOptional = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(el, "stepper-optional");
            if (isOptional) {
                const stepHeadText = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_TEXT_CLASS}`, el);
                stepHeadText.setAttribute("data-mdb-content", "Optional");
            }
        });
    }
    _hideInactiveSteps() {
        this._steps.forEach((el)=>{
            if (!el.classList.contains($0abbbd36a260e067$var$ACTIVE_CLASS)) this._hideElement($0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, el));
        });
    }
    _setValidation() {
        const form = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".needs-validation.stepper-form", this._element);
        $0abbbd36a260e067$var$EventHandler$1.on(form, $0abbbd36a260e067$var$EVENT_SUBMIT, (event)=>{
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
            }
            this._steps.forEach((el, i)=>{
                const isValid = this._validateStep(i);
                if (!isValid) {
                    this._toggleInvalid(i);
                    $0abbbd36a260e067$var$EventHandler$1.trigger(this.activeStep, $0abbbd36a260e067$var$EVENT_INVALID);
                }
            });
        }, false);
    }
    _setHeight(stepElement) {
        const stepContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, stepElement);
        const stepFooter = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$MOBILE_FOOTER_CLASS}`, this._element);
        const contentStyle = getComputedStyle(stepContent);
        const footerStyle = stepFooter ? getComputedStyle(stepFooter) : "";
        let stepHead;
        if (this._currentView === $0abbbd36a260e067$var$STEPPER_MOBILE) stepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$MOBILE_HEAD_CLASS}`, this._element);
        else stepHead = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$HEAD_CLASS}`, stepElement);
        const headStyle = getComputedStyle(stepHead);
        const stepContentHeight = stepContent.offsetHeight + parseFloat(contentStyle.marginTop) + parseFloat(contentStyle.marginBottom);
        const stepHeadHeight = stepHead.offsetHeight + parseFloat(headStyle.marginTop) + parseFloat(headStyle.marginBottom);
        const stepFooterHeight = footerStyle ? stepFooter.offsetHeight + parseFloat(footerStyle.marginTop) + parseFloat(footerStyle.marginBottom) : 0;
        this._element.style.height = `${stepHeadHeight + stepContentHeight + stepFooterHeight}px`;
    }
    _hideElement(stepContent) {
        const isActive = $0abbbd36a260e067$var$SelectorEngine$1.parents(stepContent, `.${$0abbbd36a260e067$var$STEP_CLASS}`)[0].classList.contains($0abbbd36a260e067$var$ACTIVE_CLASS);
        if (!isActive && this._currentView !== $0abbbd36a260e067$var$STEPPER_VERTICAL) stepContent.style.display = "none";
        else stepContent.classList.add($0abbbd36a260e067$var$CONTENT_HIDE_CLASS);
    }
    _showElement(stepContent) {
        if (this._currentView === $0abbbd36a260e067$var$STEPPER_VERTICAL) stepContent.classList.remove($0abbbd36a260e067$var$CONTENT_HIDE_CLASS);
        else stepContent.style.display = "block";
    }
    _animateHorizontalStep(index) {
        if (!this._animations) {
            this._steps.forEach((el, i)=>{
                const stepContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, el);
                if (i !== index) this._hideElement(stepContent);
            });
            this._setHeight(this._steps[index]);
            return;
        }
        const isForward = index > this._activeStepIndex;
        const nextStepContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, this._steps[index]);
        const activeStepContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, this.activeStep);
        let nextStepAnimation;
        let activeStepAnimation;
        this._steps.forEach((el, i)=>{
            const stepContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, el);
            this._clearStepAnimation(stepContent);
            if (i !== index && i !== this._activeStepIndex) this._hideElement(stepContent);
        });
        if (isForward) {
            activeStepAnimation = "slide-out-left";
            nextStepAnimation = "slide-in-right";
        } else {
            activeStepAnimation = "slide-out-right";
            nextStepAnimation = "slide-in-left";
        }
        if (this._animations) {
            activeStepContent.classList.add(activeStepAnimation, "animation", "fast");
            nextStepContent.classList.add(nextStepAnimation, "animation", "fast");
        }
        this._setHeight(this._steps[index]);
        $0abbbd36a260e067$var$EventHandler$1.one(activeStepContent, $0abbbd36a260e067$var$EVENT_ANIMATIONEND, (e)=>{
            this._clearStepAnimation(e.target);
            this._hideElement(e.target);
        });
        $0abbbd36a260e067$var$EventHandler$1.one(nextStepContent, $0abbbd36a260e067$var$EVENT_ANIMATIONEND, (e)=>{
            this._clearStepAnimation(e.target);
        });
    }
    _animateVerticalStep(index) {
        const nextStepContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, this._steps[index]);
        const activeStepContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CONTENT_CLASS}`, this.activeStep);
        this._hideElement(activeStepContent);
        this._showElement(nextStepContent);
    }
    _clearStepAnimation(element2) {
        element2.classList.remove("slide-out-left", "slide-in-right", "slide-out-right", "slide-in-left", "animation", "fast");
    }
    // Static
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$d);
            const _config = typeof config === "object" && config;
            if (!data && /dispose|hide/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$ed8ca599049e8881(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$h = "sticky";
const $0abbbd36a260e067$var$DATA_KEY$c = "mdb.sticky";
const $0abbbd36a260e067$var$ANIMATED_CLASS = "animation";
const $0abbbd36a260e067$var$EVENT_KEY$7 = `.${$0abbbd36a260e067$var$DATA_KEY$c}`;
const $0abbbd36a260e067$var$EVENT_ACTIVATED = `activated${$0abbbd36a260e067$var$EVENT_KEY$7}`;
const $0abbbd36a260e067$var$EVENT_DEACTIVATED = `deactivated${$0abbbd36a260e067$var$EVENT_KEY$7}`;
const $0abbbd36a260e067$var$Default$a = {
    stickyActiveClass: "",
    stickyAnimationSticky: "",
    stickyAnimationUnsticky: "",
    stickyBoundary: false,
    stickyDelay: 0,
    stickyDirection: "down",
    stickyMedia: 0,
    stickyOffset: 0,
    stickyPosition: "top"
};
const $0abbbd36a260e067$var$DefaultType$a = {
    stickyActiveClass: "string",
    stickyAnimationSticky: "string",
    stickyAnimationUnsticky: "string",
    stickyBoundary: "(boolean|string)",
    stickyDelay: "number",
    stickyDirection: "string",
    stickyMedia: "number",
    stickyOffset: "number",
    stickyPosition: "string"
};
class $0abbbd36a260e067$export$cbb1b0785b69b9d8 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options){
        super(element2);
        this._hiddenElement = null;
        this._elementPositionStyles = {};
        this._scrollDirection = "";
        this._isSticked = false;
        this._elementOffsetTop = null;
        this._scrollTop = 0;
        this._pushPoint = "";
        this._manuallyDeactivated = false;
        if (this._element) {
            this._options = this._getConfig(options);
            this._init();
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$h;
    }
    // Public
    dispose() {
        const { stickyAnimationUnsticky: stickyAnimationUnsticky } = this._options;
        let { animationDuration: animationDuration } = getComputedStyle(this._element);
        animationDuration = stickyAnimationUnsticky !== "" ? parseFloat(animationDuration) * 1e3 : 0;
        this._disableSticky();
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        setTimeout(()=>{
            super.dispose();
        }, animationDuration);
    }
    activate() {
        if (this._isSticked) return;
        this._createHiddenElement();
        this._enableSticky();
        this._changeBoundaryPosition();
        this._isSticked = true;
        this._manuallyDeactivated = false;
    }
    deactivate() {
        if (!this._isSticked) return;
        this._disableSticky();
        this._isSticked = false;
        this._manuallyDeactivated = true;
    }
    // Private
    _init() {
        this._userActivityListener();
    }
    _userActivityListener() {
        $0abbbd36a260e067$var$EventHandler$1.on(window, "resize", ()=>{
            this._updateElementPosition();
            this._updateElementOffset();
        });
        $0abbbd36a260e067$var$EventHandler$1.on(window, "scroll", ()=>{
            if (!this._element) return;
            if (window.innerWidth <= this._options.stickyMedia) return;
            if (this._manuallyDeactivated) return;
            const doc = document.documentElement;
            const { stickyDirection: stickyDirection } = this._options;
            const scrollTop = window.pageYOffset || doc.scrollTop;
            this._updateElementOffset();
            this._updatePushPoint();
            this._updateScrollDirection(scrollTop);
            this._clearInProgressAnimations();
            const isCorrectScrollDirection = [
                this._scrollDirection,
                "both"
            ].includes(stickyDirection);
            const isPushPointReached = this._pushPoint <= scrollTop;
            const shouldBeSticky = isPushPointReached && !this._isSticked && isCorrectScrollDirection;
            const shouldNotBeSticky = (!isPushPointReached || !isCorrectScrollDirection) && this._isSticked;
            if (shouldBeSticky) {
                this._createHiddenElement();
                this._enableSticky();
                this._changeBoundaryPosition();
                this._isSticked = true;
            }
            if (shouldNotBeSticky) {
                this._disableSticky();
                this._isSticked = false;
            }
            if (this._isSticked) {
                this._updatePosition({
                    styles: this._elementPositionStyles
                });
                this._changeBoundaryPosition();
            }
            this._scrollTop = scrollTop <= 0 ? 0 : scrollTop;
        });
    }
    _updatePushPoint() {
        if (this._options.stickyPosition === "top") this._pushPoint = this._elementOffsetTop - this._options.stickyDelay;
        else this._pushPoint = this._elementOffsetTop + this._element.height - document.body.scrollHeight + this._options.stickyDelay;
    }
    _updateElementOffset() {
        if (this._hiddenElement) this._elementOffsetTop = this._hiddenElement.offsetTop;
        else this._elementOffsetTop = this._element.offsetTop;
        if (this._options.stickyAnimationUnsticky) this._elementOffsetTop += this._element.height || 0;
    }
    _updateElementPosition() {
        if (this._hiddenElement) {
            const { left: left2 } = this._hiddenElement.getBoundingClientRect();
            this._elementPositionStyles = {
                left: `${left2}px`
            };
        } else this._elementPositionStyles = {};
        this._setStyle(this._element, this._elementPositionStyles);
    }
    _updateScrollDirection(scrollTop) {
        if (scrollTop > this._scrollTop) this._scrollDirection = "down";
        else this._scrollDirection = "up";
    }
    _clearInProgressAnimations() {
        const isScrollUp = this._scrollDirection === "up";
        const isUnstickyAnimationInProgress = this._element.classList.contains(this._options.stickyAnimationUnsticky);
        const isScrolledAboveElement = window.scrollY <= this._elementOffsetTop - this._element.height;
        if (isScrollUp && isUnstickyAnimationInProgress && isScrolledAboveElement) {
            this._removeUnstickyAnimation();
            this._resetStyles();
            this._removeHiddenElement();
        }
    }
    _enableSticky() {
        const { stickyActiveClass: stickyActiveClass, stickyAnimationSticky: stickyAnimationSticky, stickyAnimationUnsticky: stickyAnimationUnsticky, stickyOffset: stickyOffset, stickyPosition: stickyPosition } = this._options;
        const { height: height, left: left2, width: width } = this._element.getBoundingClientRect();
        if (stickyAnimationSticky !== "") {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$ANIMATED_CLASS);
            this._toggleClass(stickyAnimationSticky, stickyAnimationUnsticky, this._element);
        }
        this._toggleClass(stickyActiveClass, "", this._element);
        this._setStyle(this._element, {
            top: stickyPosition === "top" && `${0 + stickyOffset}px`,
            bottom: stickyPosition === "bottom" && `${0 + stickyOffset}px`,
            height: `${height}px`,
            width: `${width}px`,
            left: `${left2}px`,
            zIndex: "100",
            position: "fixed"
        });
        this._hiddenElement.hidden = false;
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_ACTIVATED);
    }
    _changeBoundaryPosition() {
        const { stickyPosition: stickyPosition, stickyBoundary: stickyBoundary, stickyOffset: stickyOffset } = this._options;
        const { height: height } = this._element.getBoundingClientRect();
        const parentOffset = {
            height: this._element.parentElement.getBoundingClientRect().height,
            ...this._getOffset(this._element.parentElement)
        };
        let stopPoint;
        const stopper = $0abbbd36a260e067$var$SelectorEngine$1.findOne(stickyBoundary);
        if (stopper) stopPoint = this._getOffset(stopper).top - height - stickyOffset;
        else stopPoint = parentOffset.height + parentOffset[stickyPosition] - height - stickyOffset;
        const isStickyTop = stickyPosition === "top";
        const isStickyBottom = stickyPosition === "bottom";
        const isStickyBoundary = stickyBoundary;
        const isBelowStopPoint = stopPoint < 0;
        const isBelowParentElementEnd = stopPoint > parentOffset.height - height;
        let elementStyle;
        if (isStickyTop) {
            if (isBelowStopPoint && isStickyBoundary) elementStyle = {
                top: `${stickyOffset + stopPoint}px`
            };
            else elementStyle = {
                top: `${stickyOffset + 0}px`
            };
        }
        if (isStickyBottom) {
            if (isBelowStopPoint && isStickyBoundary) elementStyle = {
                bottom: `${stickyOffset + stopPoint}px`
            };
            else if (isBelowParentElementEnd && isStickyBoundary) elementStyle = {
                bottom: `${stickyOffset + parentOffset.bottom}px`
            };
            else elementStyle = {
                bottom: `${stickyOffset + 0}px`
            };
        }
        this._setStyle(this._element, elementStyle);
    }
    _disableSticky() {
        const { stickyActiveClass: stickyActiveClass, stickyAnimationUnsticky: stickyAnimationUnsticky, stickyAnimationSticky: stickyAnimationSticky } = this._options;
        let { animationDuration: animationDuration } = getComputedStyle(this._element);
        animationDuration = stickyAnimationUnsticky !== "" ? parseFloat(animationDuration) * 1e3 : 0;
        if (this._options.stickyAnimationUnsticky !== "") {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$ANIMATED_CLASS);
            this._toggleClass(stickyAnimationUnsticky, stickyAnimationSticky, this._element);
        }
        setTimeout(()=>{
            if (this._element.classList.contains(stickyAnimationSticky)) return;
            this._removeUnstickyAnimation();
            this._resetStyles();
            this._removeHiddenElement();
            this._toggleClass("", stickyActiveClass, this._element);
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_DEACTIVATED);
        }, animationDuration);
    }
    _createHiddenElement() {
        if (!this._hiddenElement) this._hiddenElement = this._copyElement(this._element);
    }
    _removeHiddenElement() {
        if (!this._hiddenElement) return;
        this._hiddenElement.remove();
        this._hiddenElement = null;
    }
    _removeUnstickyAnimation() {
        this._toggleClass("", this._options.stickyAnimationUnsticky, this._element);
    }
    _resetStyles() {
        this._setStyle(this._element, {
            top: null,
            bottom: null,
            position: null,
            left: null,
            zIndex: null,
            width: null,
            height: null
        });
    }
    _updatePosition({ styles: styles }) {
        this._setStyle(this._element, styles);
    }
    _toggleClass(addClass, removeClass, target) {
        if (addClass) $0abbbd36a260e067$var$Manipulator$1.addClass(target, addClass);
        if (removeClass) $0abbbd36a260e067$var$Manipulator$1.removeClass(target, removeClass);
    }
    _getOffset(element2) {
        const offsetElement = $0abbbd36a260e067$var$Manipulator$1.offset(element2);
        const rectElement = element2.getBoundingClientRect();
        const bottom2 = offsetElement.left === 0 && offsetElement.top === 0 ? 0 : window.innerHeight - rectElement.bottom;
        return {
            ...offsetElement,
            bottom: bottom2
        };
    }
    _copyElement(itemToCopy) {
        const { height: height, width: width } = itemToCopy.getBoundingClientRect();
        const COPIED_ITEM = itemToCopy.cloneNode(false);
        COPIED_ITEM.hidden = true;
        this._setStyle(COPIED_ITEM, {
            height: `${height}px`,
            width: `${width}px`,
            opacity: "0"
        });
        itemToCopy.parentElement.insertBefore(COPIED_ITEM, itemToCopy);
        return COPIED_ITEM;
    }
    _getConfig(config = {}) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        config = {
            ...$0abbbd36a260e067$var$Default$a,
            ...dataAttributes,
            ...config
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$h, config, $0abbbd36a260e067$var$DefaultType$a);
        return config;
    }
    _setStyle(element2, styles) {
        Object.keys(styles).forEach((style)=>{
            element2.style[style] = styles[style];
        });
    }
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$c);
            const _config = typeof config === "object" && config;
            if (!data && /dispose|hide/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$cbb1b0785b69b9d8(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
class $0abbbd36a260e067$var$TouchUtil {
    _getCoordinates(e) {
        const [touch2] = e.touches;
        return {
            x: touch2.clientX,
            y: touch2.clientY
        };
    }
    _getDirection({ x: x, y: y }) {
        return {
            x: {
                direction: x < 0 ? "left" : "right",
                value: Math.abs(x)
            },
            y: {
                direction: y < 0 ? "up" : "down",
                value: Math.abs(y)
            }
        };
    }
    _getOrigin({ x: x, y: y }, { x: x2, y: y2 }) {
        return {
            x: x - x2,
            y: y - y2
        };
    }
    _getDistanceBetweenTwoPoints(x1, x2, y1, y2) {
        return Math.hypot(x2 - x1, y2 - y1);
    }
    _getMidPoint({ x1: x1, x2: x2, y1: y1, y2: y2 }) {
        return {
            x: (x1 + x2) / 2,
            y: (y1 + y2) / 2
        };
    }
    _getVectorLength({ x1: x1, x2: x2, y1: y1, y2: y2 }) {
        return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    }
    _getRightMostTouch(touches) {
        let rightMost = null;
        const distance = Number.MIN_VALUE;
        touches.forEach((touch2)=>{
            if (touch2.clientX > distance) rightMost = touch2;
        });
        return rightMost;
    }
    _getAngle(x1, y1, x2, y2) {
        return Math.atan2(y2 - y1, x2 - x1);
    }
    _getAngularDistance(start2, end2) {
        return end2 - start2;
    }
    _getCenterXY({ x1: x1, x2: x2, y1: y1, y2: y2 }) {
        return {
            x: x1 + (x2 - x1) / 2,
            y: y1 + (y2 - y1) / 2
        };
    }
    _getPinchTouchOrigin(touches) {
        const [t1, t2] = touches;
        const _position = {
            x1: t1.clientX,
            x2: t2.clientX,
            y1: t1.clientY,
            y2: t2.clientY
        };
        return [
            this._getVectorLength(_position),
            this._getCenterXY(_position)
        ];
    }
    _getPosition({ x1: x1, x2: x2, y1: y1, y2: y2 }) {
        return {
            x1: x1,
            x2: x2,
            y1: y1,
            y2: y2
        };
    }
}
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$7 = {
    time: 250,
    pointers: 1
};
const $0abbbd36a260e067$var$NAME$g = "press";
const $0abbbd36a260e067$var$EVENT_UP = "pressup";
class $0abbbd36a260e067$var$Press extends $0abbbd36a260e067$var$TouchUtil {
    constructor(element2, options = {}){
        super();
        this._element = element2;
        this._options = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$7,
            ...options
        };
        this._timer = null;
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$g;
    }
    handleTouchStart(e) {
        const { time: time, pointers: pointers } = this._options;
        if (e.touches.length === pointers) this._timer = setTimeout(()=>{
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$NAME$g, {
                touch: e,
                time: time
            });
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_UP, {
                touch: e
            });
        }, time);
    }
    handleTouchEnd() {
        clearTimeout(this._timer);
    }
}
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$6 = {
    threshold: 10,
    direction: "all"
};
class $0abbbd36a260e067$var$Swipe3 {
    constructor(element2, options){
        this._element = element2;
        this._startPosition = null;
        this._options = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$6,
            ...options
        };
    }
    handleTouchStart(e) {
        this._startPosition = this._getCoordinates(e);
    }
    handleTouchMove(e) {
        if (!this._startPosition) return;
        const position = this._getCoordinates(e);
        const displacement = {
            x: position.x - this._startPosition.x,
            y: position.y - this._startPosition.y
        };
        const swipe = this._getDirection(displacement);
        if (this._options.direction === "all") {
            if (swipe.y.value < this._options.threshold && swipe.x.value < this._options.threshold) return;
            const direction = swipe.y.value > swipe.x.value ? swipe.y.direction : swipe.x.direction;
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, `swipe${direction}`, {
                touch: e
            });
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, "swipe", {
                touch: e,
                direction: direction
            });
            this._startPosition = null;
            return;
        }
        const axis = this._options.direction === "left" || this._options === "right" ? "x" : "y";
        if (swipe[axis].direction === this._options.direction && swipe[axis].value > this._options.threshold) {
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, `swipe${swipe[axis].direction}`, {
                touch: e
            });
            this._startPosition = null;
        }
    }
    handleTouchEnd() {
        this._startPosition = null;
    }
    _getCoordinates(e) {
        const [touch2] = e.touches;
        return {
            x: touch2.clientX,
            y: touch2.clientY
        };
    }
    _getDirection(displacement) {
        return {
            x: {
                direction: displacement.x < 0 ? "left" : "right",
                value: Math.abs(displacement.x)
            },
            y: {
                direction: displacement.y < 0 ? "up" : "down",
                value: Math.abs(displacement.y)
            }
        };
    }
}
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$5 = {
    threshold: 20,
    direction: "all",
    pointers: 1
};
const $0abbbd36a260e067$var$NAME$f = "pan";
const $0abbbd36a260e067$var$EVENT_START$3 = `${$0abbbd36a260e067$var$NAME$f}start`;
const $0abbbd36a260e067$var$EVENT_END$3 = `${$0abbbd36a260e067$var$NAME$f}end`;
const $0abbbd36a260e067$var$EVENT_MOVE$1 = `${$0abbbd36a260e067$var$NAME$f}move`;
const $0abbbd36a260e067$var$LEFT = "left";
const $0abbbd36a260e067$var$RIGHT = "right";
class $0abbbd36a260e067$var$Pan extends $0abbbd36a260e067$var$TouchUtil {
    constructor(element2, options = {}){
        super();
        this._element = element2;
        this._options = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$5,
            ...options
        };
        this._startTouch = null;
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$f;
    }
    handleTouchStart(e) {
        this._startTouch = this._getCoordinates(e);
        this._movedTouch = e;
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_START$3, {
            touch: e
        });
    }
    handleTouchMove(e) {
        e.type === "touchmove" && e.preventDefault();
        const { threshold: threshold, direction: direction } = this._options;
        const postion = this._getCoordinates(e);
        const movedPosition = this._getCoordinates(this._movedTouch);
        const displacement = this._getOrigin(postion, this._startTouch);
        const displacementMoved = this._getOrigin(postion, movedPosition);
        const pan = this._getDirection(displacement);
        const movedDirection = this._getDirection(displacementMoved);
        const { x: x, y: y } = pan;
        if (direction === "all" && (y.value > threshold || x.value > threshold)) {
            const direction2 = y.value > x.value ? y.direction : x.direction;
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, `${$0abbbd36a260e067$var$NAME$f}${direction2}`, {
                touch: e
            });
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$NAME$f, {
                ...displacementMoved,
                touch: e
            });
        }
        const axis = direction === $0abbbd36a260e067$var$LEFT || direction === $0abbbd36a260e067$var$RIGHT ? "x" : "y";
        if (movedDirection[axis].direction === direction && pan[axis].value > threshold) $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, `${$0abbbd36a260e067$var$NAME$f}${direction}`, {
            touch: e,
            [axis]: postion[axis] - movedPosition[axis]
        });
        this._movedTouch = e;
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_MOVE$1, {
            touch: e
        });
    }
    handleTouchEnd(e) {
        e.type === "touchend" && e.preventDefault();
        this._movedTouch = null;
        this._startTouch = null;
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_END$3, {
            touch: e
        });
    }
}
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$4 = {
    pointers: 2,
    threshold: 10
};
const $0abbbd36a260e067$var$NAME$e = "pinch";
const $0abbbd36a260e067$var$EVENT_END$2 = `${$0abbbd36a260e067$var$NAME$e}end`;
const $0abbbd36a260e067$var$EVENT_START$2 = `${$0abbbd36a260e067$var$NAME$e}start`;
const $0abbbd36a260e067$var$EVENT_MOVE = `${$0abbbd36a260e067$var$NAME$e}move`;
class $0abbbd36a260e067$var$Pinch extends $0abbbd36a260e067$var$TouchUtil {
    constructor(element2, options = {}){
        super();
        this._element = element2;
        this._options = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$4,
            ...options
        };
        this._startTouch = null;
        this._origin = null;
        this._touch = null;
        this._math = null;
        this._ratio = null;
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$e;
    }
    get isNumber() {
        return typeof this._startTouch === "number" && typeof this._touch === "number" && // eslint-disable-next-line no-restricted-globals
        !isNaN(this._startTouch) && // eslint-disable-next-line no-restricted-globals
        !isNaN(this._touch);
    }
    handleTouchStart(e) {
        if (e.touches.length !== this._options.pointers) return;
        e.type === "touchstart" && e.preventDefault();
        const [touch2, origin] = this._getPinchTouchOrigin(e.touches);
        this._touch = touch2;
        this._origin = origin;
        this._startTouch = this._touch;
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_START$2, {
            touch: e,
            ratio: this._ratio,
            origin: this._origin
        });
    }
    handleTouchMove(e) {
        const { threshold: threshold, pointers: pointers } = this._options;
        if (e.touches.length !== pointers) return;
        e.type === "touchmove" && e.preventDefault();
        this._touch = this._getPinchTouchOrigin(e.touches)[0];
        this._ratio = this._touch / this._startTouch;
        if (this.isNumber) {
            if (this._origin.x > threshold || this._origin.y > threshold) {
                this._startTouch = this._touch;
                $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$NAME$e, {
                    touch: e,
                    ratio: this._ratio,
                    origin: this._origin
                });
                $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_MOVE, {
                    touch: e,
                    ratio: this._ratio,
                    origin: this._origin
                });
            }
        }
    }
    handleTouchEnd(e) {
        if (this.isNumber) {
            this._startTouch = null;
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_END$2, {
                touch: e,
                ratio: this._ratio,
                origin: this._origin
            });
        }
    }
}
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$3 = {
    interval: 500,
    time: 250,
    taps: 1,
    pointers: 1
};
const $0abbbd36a260e067$var$NAME$d = "tap";
class $0abbbd36a260e067$var$Tap extends $0abbbd36a260e067$var$TouchUtil {
    constructor(element2, options){
        super();
        this._element = element2;
        this._options = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$3,
            ...options
        };
        this._timer = null;
        this._tapCount = 0;
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$d;
    }
    handleTouchStart(e) {
        const { x: x, y: y } = this._getCoordinates(e);
        const { interval: interval, taps: taps, pointers: pointers } = this._options;
        if (e.touches.length === pointers) {
            this._tapCount += 1;
            if (this._tapCount === 1) this._timer = setTimeout(()=>{
                this._tapCount = 0;
            }, interval);
            if (this._tapCount === taps) {
                clearTimeout(this._timer);
                this._tapCount = 0;
                $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$NAME$d, {
                    touch: e,
                    origin: {
                        x: x,
                        y: y
                    }
                });
            }
        }
        return e;
    }
    handleTouchEnd() {
        return;
    }
    handleTouchMove() {
        return;
    }
}
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$2 = {
    angle: 0,
    pointers: 2
};
const $0abbbd36a260e067$var$NAME$c = "rotate";
const $0abbbd36a260e067$var$EVENT_END$1 = `${$0abbbd36a260e067$var$NAME$c}end`;
const $0abbbd36a260e067$var$EVENT_START$1 = `${$0abbbd36a260e067$var$NAME$c}start`;
class $0abbbd36a260e067$var$Rotate extends $0abbbd36a260e067$var$TouchUtil {
    constructor(element2, options){
        super();
        this._element = element2;
        this._options = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$2,
            ...options
        };
        this._origin = {};
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$c;
    }
    handleTouchStart(e) {
        e.type === "touchstart" && e.preventDefault();
        if (e.touches.length < 2) return;
        this._startTouch = e;
        this._origin = {};
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_START$1, {
            touch: e
        });
        return;
    }
    handleTouchMove(e) {
        e.type === "touchmove" && e.preventDefault();
        let origin;
        let input;
        const touches = e.touches;
        if (touches.length === 1 && this._options.pointers === 1) {
            const { left: left2, top: top2, width: width, height: height } = this._element.getBoundingClientRect();
            origin = {
                x: left2 + width / 2,
                y: top2 + height / 2
            };
            input = touches[0];
        } else if (e.touches.length === 2 && this._options.pointers === 2) {
            const [t2, t1] = e.touches;
            const _position = {
                x1: t1.clientX,
                x2: t2.clientX,
                y1: t1.clientY,
                y2: t2.clientY
            };
            origin = this._getMidPoint(_position);
            input = this._getRightMostTouch(e.touches);
        } else return;
        this.currentAngle = this._getAngle(origin.x, origin.y, input.clientX, input.clientY);
        if (!this._origin.initialAngle) {
            this._origin.initialAngle = this._origin.previousAngle = this.currentAngle;
            this._origin.distance = this._origin.change = 0;
        } else {
            this._origin.change = this._getAngularDistance(this._origin.previousAngle, this.currentAngle);
            this._origin.distance += this._origin.change;
        }
        this._origin.previousAngle = this.currentAngle;
        this.rotate = {
            currentAngle: this.currentAngle,
            distance: this._origin.distance,
            change: this._origin.change
        };
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$NAME$c, {
            ...this.rotate,
            touch: e
        });
    }
    handleTouchEnd(e) {
        e.type === "touchend" && e.preventDefault();
        this._origin = {};
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_END$1, {
            touch: e
        });
    }
}
const $0abbbd36a260e067$var$NAME$b = "touch";
const $0abbbd36a260e067$var$DATA_KEY$b = "mdb.touch";
class $0abbbd36a260e067$export$746b04bbf92762fd extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, event = "swipe", options = {}){
        super(element2);
        this._options = this._getConfig(options);
        this._event = this._options.event || event;
        this.swipe = this._event === "swipe" ? new $0abbbd36a260e067$var$Swipe3(element2, this._options) : null;
        this.press = this._event === "press" ? new $0abbbd36a260e067$var$Press(element2, this._options) : null;
        this.pan = this._event === "pan" ? new $0abbbd36a260e067$var$Pan(element2, this._options) : null;
        this.pinch = this._event === "pinch" ? new $0abbbd36a260e067$var$Pinch(element2, this._options) : null;
        this.tap = this._event === "tap" ? new $0abbbd36a260e067$var$Tap(element2, this._options) : null;
        this.rotate = this._event === "rotate" ? new $0abbbd36a260e067$var$Rotate(element2, this._options) : null;
        this._touchStartHandler = this._handleTouchStart.bind(this);
        this._touchMoveHandler = this._handleTouchMove.bind(this);
        this._touchEndHandler = this._handleTouchEnd.bind(this);
        this.init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$b;
    }
    // Public
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "touchstart", this._touchStartHandler);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "touchmove", this._touchMoveHandler);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "touchend", this._touchEndHandler);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    init() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "touchstart", this._touchStartHandler);
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "touchmove", this._touchMoveHandler);
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "touchend", this._touchEndHandler);
    }
    // Private
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        config = {
            ...dataAttributes,
            ...config
        };
        return config;
    }
    _handleTouchStart(e) {
        this[this._event].handleTouchStart(e);
    }
    _handleTouchMove(e) {
        if (this[this._event].handleTouchMove) this[this._event].handleTouchMove(e);
    }
    _handleTouchEnd(e) {
        this[this._event].handleTouchEnd(e);
    }
    static jQueryInterface(config) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$b);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$746b04bbf92762fd(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                return data[config];
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$a = "smoothScroll";
const $0abbbd36a260e067$var$DATA_KEY$a = `mdb.${$0abbbd36a260e067$var$NAME$a}`;
const $0abbbd36a260e067$var$EVENT_KEY$6 = `.${$0abbbd36a260e067$var$DATA_KEY$a}`;
const $0abbbd36a260e067$var$DefaultType$9 = {
    container: "string",
    offset: "number",
    easing: "string",
    duration: "number"
};
const $0abbbd36a260e067$var$Default$9 = {
    container: "body",
    offset: 0,
    easing: "linear",
    duration: 500
};
const $0abbbd36a260e067$var$EVENT_SCROLL_START = `scrollStart${$0abbbd36a260e067$var$EVENT_KEY$6}`;
const $0abbbd36a260e067$var$EVENT_SCROLL_END = `scrollEnd${$0abbbd36a260e067$var$EVENT_KEY$6}`;
const $0abbbd36a260e067$var$EVENT_SCROLL_CANCEL = `scrollCancel${$0abbbd36a260e067$var$EVENT_KEY$6}`;
class $0abbbd36a260e067$export$f8250c268cd0d487 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options = {}){
        super(element2);
        this._options = this._getConfig(options);
        this._href = this._element.getAttribute("href");
        this.isCancel = false;
        if (this._element) {
            this._setup();
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$a;
    }
    get isWindow() {
        return this._options.container === "body";
    }
    get containerToScroll() {
        return this.isWindow ? document.documentElement : $0abbbd36a260e067$var$SelectorEngine$1.findOne(this._options.container, document.documentElement);
    }
    get elFromHrefExist() {
        return !!$0abbbd36a260e067$var$SelectorEngine$1.findOne(this._href, this.containerToScroll);
    }
    get offsetFromEl() {
        const heightFromTop = this.containerToScroll.scrollTop;
        const el = $0abbbd36a260e067$var$SelectorEngine$1.findOne(this._href, this.containerToScroll);
        if (this.isWindow) return $0abbbd36a260e067$var$Manipulator$1.offset(el).top - this._options.offset + heightFromTop;
        const elY = el.getBoundingClientRect().y;
        const containerY = this.containerToScroll.getBoundingClientRect().y;
        const offsetFromContainer = elY - containerY;
        return offsetFromContainer - this._options.offset + heightFromTop;
    }
    get easingFunction() {
        const easing = this._options.easing;
        const motionName = `_motion${easing[0].toUpperCase()}${easing.slice(1)}`;
        return this[motionName] ? this[motionName] : this._motionLinear;
    }
    // public
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "click");
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    cancelScroll() {
        this.isCancel = true;
    }
    // private
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$Default$9,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$a, config, $0abbbd36a260e067$var$DefaultType$9);
        return config;
    }
    _inViewport() {
        if (this.isWindow) return true;
        const rect = this.containerToScroll.getBoundingClientRect();
        return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    }
    _setup() {
        const linkExist = typeof this._href !== "undefined";
        const isHashInLink = this._href.includes("#");
        if (linkExist && isHashInLink && this.elFromHrefExist) {
            this._scrollOnClickEvent();
            this._preventNativeScroll();
        }
    }
    _scrollOnClickEvent() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "click", (e)=>{
            this._handleClick(e);
        });
    }
    _handleClick(e) {
        e.preventDefault();
        this.isCancel = false;
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SCROLL_START);
        const scrollingContainer = this.containerToScroll;
        const positionFrom = this.containerToScroll.scrollTop;
        const positionTo = this.offsetFromEl;
        const scrollProgress = 0;
        const speed = 1 / this._options.duration;
        const step = 4.25;
        const easing = this.easingFunction;
        if (!this._inViewport()) {
            this._scrollOnNextTick(document.documentElement, document.documentElement.scrollTop, this.containerToScroll.offsetTop, scrollProgress, speed, step, easing);
            setTimeout(()=>{
                this._scrollOnNextTick(scrollingContainer, positionFrom, positionTo, scrollProgress, speed, step, easing);
                this.isCancel = false;
            }, this._options.duration);
        } else this._scrollOnNextTick(scrollingContainer, positionFrom, positionTo, scrollProgress, speed, step, easing);
    }
    _scrollOnNextTick(scrollingContainer, positionFrom, positionTo, scrollProgress, speed, step, easing) {
        const progressWrongValue = scrollProgress < 0;
        const scrollEnd = scrollProgress > 1;
        const speedWrongValue = speed <= 0;
        if (progressWrongValue || scrollEnd || speedWrongValue || this.isCancel) {
            if (this.isCancel) {
                if (this.isInViewport) this.isCancel = false;
                $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SCROLL_CANCEL);
                return;
            }
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SCROLL_END);
            scrollingContainer.scrollTop = positionTo;
            return;
        }
        scrollingContainer.scrollTo({
            top: positionFrom - (positionFrom - positionTo) * easing(scrollProgress)
        });
        scrollProgress += speed * step;
        setTimeout(()=>{
            this._scrollOnNextTick(scrollingContainer, positionFrom, positionTo, scrollProgress, speed, step, easing);
        });
    }
    _preventDefault(e) {
        e.preventDefault();
    }
    _preventNativeScroll() {
        let supportsPassive = false;
        try {
            window.addEventListener("test", null, Object.defineProperty({}, "passive", {
                get: ()=>supportsPassive = true
            }));
        } catch (e) {
            this._scrollError = e;
        }
        const wheelOpt = supportsPassive ? {
            passive: false
        } : false;
        const wheelEvent = "onwheel" in $0abbbd36a260e067$var$element("div") ? "wheel" : "mousewheel";
        if (this.isWindow) {
            this._deleteScrollOnStart(wheelOpt, wheelEvent);
            this._addScrollOnEnd(wheelOpt, wheelEvent);
            this._addScrollOnCancel(wheelOpt, wheelEvent);
        }
    }
    _deleteScrollOnStart(wheelOpt, wheelEvent) {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "scrollStart.mdb.smoothScroll", ()=>{
            window.addEventListener(wheelEvent, this._preventDefault, wheelOpt);
            window.addEventListener("touchmove", this._preventDefault, wheelOpt);
        });
    }
    _addScrollOnEnd(wheelOpt, wheelEvent) {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "scrollEnd.mdb.smoothScroll", ()=>{
            window.removeEventListener(wheelEvent, this._preventDefault, wheelOpt);
            window.removeEventListener("touchmove", this._preventDefault, wheelOpt);
        });
    }
    _addScrollOnCancel(wheelOpt, wheelEvent) {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "scrollCancel.mdb.smoothScroll", ()=>{
            window.removeEventListener(wheelEvent, this._preventDefault, wheelOpt);
            window.removeEventListener("touchmove", this._preventDefault, wheelOpt);
        });
    }
    // Motions
    // Linear
    _motionLinear(t) {
        return t;
    }
    // Ease-In
    _motionEaseInQuad(t) {
        return t * t;
    }
    _motionEaseInCubic(t) {
        return t * t * t;
    }
    _motionEaseInQuart(t) {
        return t * t * t * t;
    }
    _motionEaseInQuint(t) {
        return t * t * t * t * t;
    }
    // Ease-In-Out
    _motionEaseInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
    _motionEaseInOutCubic(t) {
        t /= 0.5;
        if (t < 1) return t * t * t / 2;
        t -= 2;
        return (t * t * t + 2) / 2;
    }
    _motionEaseInOutQuart(t) {
        t /= 0.5;
        if (t < 1) return 0.5 * t * t * t * t;
        t -= 2;
        return -(t * t * t * t - 2) / 2;
    }
    _motionEaseInOutQuint(t) {
        t /= 0.5;
        if (t < 1) return t * t * t * t * t / 2;
        t -= 2;
        return (t * t * t * t * t + 2) / 2;
    }
    // Ease-Out
    _motionEaseOutQuad(t) {
        return -t * (t - 2);
    }
    _motionEaseOutCubic(t) {
        t--;
        return t * t * t + 1;
    }
    _motionEaseOutQuart(t) {
        t--;
        return -(t * t * t * t - 1);
    }
    _motionEaseOutQuint(t) {
        t--;
        return t * t * t * t * t + 1;
    }
    // static
    static jQueryInterface(config) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$a);
            const _config = typeof config === "object" && config;
            if (!data) data = new $0abbbd36a260e067$export$f8250c268cd0d487(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$9 = "perfectScrollbar";
const $0abbbd36a260e067$var$CLASSNAME_PS = "perfect-scrollbar";
const $0abbbd36a260e067$var$DATA_KEY$9 = "mdb.perfectScrollbar";
const $0abbbd36a260e067$var$MDB_NAME = "mdb";
const $0abbbd36a260e067$var$PS_NAME = "ps";
const $0abbbd36a260e067$var$EVENTS = [
    {
        mdb: `scrollX.${$0abbbd36a260e067$var$MDB_NAME}.${$0abbbd36a260e067$var$PS_NAME}`,
        ps: "ps-scroll-x"
    },
    {
        mdb: `scrollY.${$0abbbd36a260e067$var$MDB_NAME}.${$0abbbd36a260e067$var$PS_NAME}`,
        ps: "ps-scroll-y"
    },
    {
        mdb: `scrollUp.${$0abbbd36a260e067$var$MDB_NAME}.${$0abbbd36a260e067$var$PS_NAME}`,
        ps: "ps-scroll-up"
    },
    {
        mdb: `scrollDown.${$0abbbd36a260e067$var$MDB_NAME}.${$0abbbd36a260e067$var$PS_NAME}`,
        ps: "ps-scroll-down"
    },
    {
        mdb: `scrollLeft.${$0abbbd36a260e067$var$MDB_NAME}.${$0abbbd36a260e067$var$PS_NAME}`,
        ps: "ps-scroll-left"
    },
    {
        mdb: `scrollRight.${$0abbbd36a260e067$var$MDB_NAME}.${$0abbbd36a260e067$var$PS_NAME}`,
        ps: "ps-scroll-right"
    },
    {
        mdb: `scrollXEnd.${$0abbbd36a260e067$var$MDB_NAME}.${$0abbbd36a260e067$var$PS_NAME}`,
        ps: "ps-x-reach-end"
    },
    {
        mdb: `scrollYEnd.${$0abbbd36a260e067$var$MDB_NAME}.${$0abbbd36a260e067$var$PS_NAME}`,
        ps: "ps-y-reach-end"
    },
    {
        mdb: `scrollXStart.${$0abbbd36a260e067$var$MDB_NAME}.${$0abbbd36a260e067$var$PS_NAME}`,
        ps: "ps-x-reach-start"
    },
    {
        mdb: `scrollYStart.${$0abbbd36a260e067$var$MDB_NAME}.${$0abbbd36a260e067$var$PS_NAME}`,
        ps: "ps-y-reach-start"
    }
];
const $0abbbd36a260e067$var$Default$8 = {
    handlers: [
        "click-rail",
        "drag-thumb",
        "keyboard",
        "wheel",
        "touch"
    ],
    wheelSpeed: 1,
    wheelPropagation: true,
    swipeEasing: true,
    minScrollbarLength: null,
    maxScrollbarLength: null,
    scrollingThreshold: 1e3,
    useBothWheelAxes: false,
    suppressScrollX: false,
    suppressScrollY: false,
    scrollXMarginOffset: 0,
    scrollYMarginOffset: 0
};
const $0abbbd36a260e067$var$DefaultType$8 = {
    handlers: "(string|array)",
    wheelSpeed: "number",
    wheelPropagation: "boolean",
    swipeEasing: "boolean",
    minScrollbarLength: "(number|null)",
    maxScrollbarLength: "(number|null)",
    scrollingThreshold: "number",
    useBothWheelAxes: "boolean",
    suppressScrollX: "boolean",
    suppressScrollY: "boolean",
    scrollXMarginOffset: "number",
    scrollYMarginOffset: "number"
};
class $0abbbd36a260e067$export$cdf548474a278786 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options = {}){
        super(element2);
        this._options = this._getConfig(options);
        this.perfectScrollbar = null;
        if (this._element) $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$CLASSNAME_PS);
        this.init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$9;
    }
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        if (dataAttributes.handlers !== void 0) dataAttributes.handlers = dataAttributes.handlers.split(" ");
        config = {
            ...$0abbbd36a260e067$var$Default$8,
            ...dataAttributes,
            ...config
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$9, config, $0abbbd36a260e067$var$DefaultType$8);
        return config;
    }
    // Public
    dispose() {
        this.removeEvent($0abbbd36a260e067$var$EVENTS);
        this.perfectScrollbar.destroy();
        this.perfectScrollbar = null;
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    init() {
        this.perfectScrollbar = new $0abbbd36a260e067$var$PerfectScrollbar(this._element, this._options);
        this._initEvents($0abbbd36a260e067$var$EVENTS);
    }
    update() {
        return this.perfectScrollbar.update();
    }
    _initEvents(events = []) {
        events.forEach(({ ps: ps, mdb: mdb2 })=>$0abbbd36a260e067$var$EventHandler$1.on(this._element, ps, (e)=>$0abbbd36a260e067$var$EventHandler$1.trigger(this._element, mdb2, {
                    e: e
                })));
    }
    removeEvent(event) {
        let filter = [];
        if (typeof event === "string") filter = $0abbbd36a260e067$var$EVENTS.filter(({ mdb: mdb2 })=>mdb2 === event);
        filter.forEach(({ ps: ps, mdb: mdb2 })=>{
            $0abbbd36a260e067$var$EventHandler$1.off(this._element, ps);
            $0abbbd36a260e067$var$EventHandler$1.off(this._element, mdb2);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$9);
            const _config = typeof config === "object" && config;
            if (!data && /dispose|hide/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$cdf548474a278786(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
function $0abbbd36a260e067$var$getBackdropTemplate({ backdropID: backdropID, backdropOpacity: backdropOpacity, backdropColor: backdropColor }) {
    const backdrop = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(backdrop, "loading-backdrop");
    backdrop.id = backdropID;
    $0abbbd36a260e067$var$Manipulator$1.addStyle(backdrop, {
        opacity: backdropOpacity,
        backgroundColor: backdropColor
    });
    return backdrop;
}
const $0abbbd36a260e067$var$NAME$8 = "loading";
const $0abbbd36a260e067$var$CLASS_SPINNER = "loading-spinner";
const $0abbbd36a260e067$var$DATA_KEY$8 = "mdb.loading";
const $0abbbd36a260e067$var$SELECTOR_LOADING_ICON = ".loading-icon";
const $0abbbd36a260e067$var$SELECTOR_LOADING_TEXT = ".loading-text";
const $0abbbd36a260e067$var$SHOW_EVENT = "show.mdb.loading";
const $0abbbd36a260e067$var$DefaultType$7 = {
    backdrop: "(null|boolean)",
    backdropColor: "string",
    backdropOpacity: "(number|string)",
    backdropID: "string",
    delay: "(null|number)",
    loader: "string",
    parentSelector: "(null|string)",
    loadingIcon: "boolean",
    loadingText: "boolean",
    scroll: "boolean"
};
const $0abbbd36a260e067$var$Default$7 = {
    backdrop: true,
    backdropColor: "rgba(0, 0, 0)",
    backdropOpacity: 0.4,
    backdropID: "",
    delay: null,
    loader: "",
    parentSelector: null,
    scroll: true,
    loadingText: true,
    loadingIcon: true
};
class $0abbbd36a260e067$export$669f6ea7d267feaf extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options = {}){
        super(element2);
        this._options = this._getConfig(options);
        this._backdropElement = null;
        this._parentElement = $0abbbd36a260e067$var$SelectorEngine$1.findOne(this._options.parentSelector);
        this._loadingIcon = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_LOADING_ICON, this._element);
        this._loadingText = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_LOADING_TEXT, this._element);
        this.init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$8;
    }
    // Public
    init() {
        const spinnerCloned = this._loadingIcon.cloneNode(true);
        const loadingCloned = this._loadingText.cloneNode(true);
        this._removeElementsOnStart();
        setTimeout(()=>{
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$CLASS_SPINNER);
            this._setBackdrop();
            this._setLoadingIcon(spinnerCloned);
            this._setLoadingText(loadingCloned);
            this._setScrollOption();
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$SHOW_EVENT);
        }, this._options.delay);
    }
    dispose() {
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, $0abbbd36a260e067$var$CLASS_SPINNER);
        const delay = this._options.delay;
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        setTimeout(()=>{
            this._removeBackdrop();
            setTimeout(()=>{
                super.dispose();
            }, delay);
        }, delay);
    }
    // Private
    _setBackdrop() {
        const { backdrop: backdrop } = this._options;
        if (!backdrop) return;
        this._backdropElement = $0abbbd36a260e067$var$getBackdropTemplate(this._options);
        if (this._parentElement !== null) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, "position-absolute");
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._parentElement, "position-relative");
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._backdropElement, "position-absolute");
            this._parentElement.appendChild(this._backdropElement);
        } else {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, "position-fixed");
            document.body.appendChild(this._backdropElement);
            document.body.appendChild(this._element);
        }
    }
    _removeBackdrop() {
        const { backdrop: backdrop } = this._options;
        if (!backdrop) return;
        if (this._parentElement !== null) {
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, "position-absolute");
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this._parentElement, "position-relative");
            this._backdropElement.remove();
        } else {
            this._backdropElement.remove();
            this._element.remove();
        }
    }
    _setLoadingIcon(spinner) {
        if (!this._options.loadingIcon) {
            spinner.remove();
            return;
        }
        this._element.appendChild(spinner);
        spinner.id = this._options.loader;
    }
    _setLoadingText(text) {
        if (!this._options.loadingText) {
            text.remove();
            return;
        }
        this._element.appendChild(text);
    }
    _removeElementsOnStart() {
        if (this._element === null) return;
        this._loadingIcon.remove();
        this._loadingText.remove();
    }
    _setScrollOption() {
        if (!this._options.scroll) {
            if (this._parentElement === null) {
                document.body.style.overflow = "hidden";
                return;
            }
            $0abbbd36a260e067$var$Manipulator$1.addStyle(this._parentElement, {
                overflow: "hidden"
            });
        } else {
            if (this._parentElement === null) {
                document.body.style.overflow = "";
                return;
            }
            $0abbbd36a260e067$var$Manipulator$1.addStyle(this._parentElement, {
                overflow: ""
            });
        }
    }
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$Default$7,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$8, config, $0abbbd36a260e067$var$DefaultType$7);
        return config;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$8);
            const _config = typeof config === "object" && config;
            if (!data) data = new $0abbbd36a260e067$export$669f6ea7d267feaf(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
const $0abbbd36a260e067$var$uriAttrs = /* @__PURE__ */ new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
const $0abbbd36a260e067$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $0abbbd36a260e067$var$SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/gi;
const $0abbbd36a260e067$var$DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
const $0abbbd36a260e067$var$allowedAttribute = (attr, allowedAttributeList)=>{
    const attrName = attr.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attrName)) {
        if ($0abbbd36a260e067$var$uriAttrs.has(attrName)) return Boolean(attr.nodeValue.match($0abbbd36a260e067$var$SAFE_URL_PATTERN) || attr.nodeValue.match($0abbbd36a260e067$var$DATA_URL_PATTERN));
        return true;
    }
    const regExp = allowedAttributeList.filter((attrRegex)=>attrRegex instanceof RegExp);
    for(let i = 0, len = regExp.length; i < len; i++){
        if (regExp[i].test(attrName)) return true;
    }
    return false;
};
const $0abbbd36a260e067$var$DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $0abbbd36a260e067$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
function $0abbbd36a260e067$var$sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFn && typeof sanitizeFn === "function") return sanitizeFn(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const whitelistKeys = Object.keys(whiteList);
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for(let i = 0, len = elements.length; i < len; i++){
        const el = elements[i];
        const elName = el.nodeName.toLowerCase();
        if (whitelistKeys.indexOf(elName) === -1) {
            el.parentNode.removeChild(el);
            continue;
        }
        const attributeList = [].concat(...el.attributes);
        const whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
        attributeList.forEach((attr)=>{
            if (!$0abbbd36a260e067$var$allowedAttribute(attr, whitelistedAttributes)) el.removeAttribute(attr.nodeName);
        });
    }
    return createdDocument.body.innerHTML;
}
const $0abbbd36a260e067$var$CLASS_NAME_AUTOCOMPLETE_DROPDOWN_CONTAINER = "autocomplete-dropdown-container";
const $0abbbd36a260e067$var$CLASS_NAME_AUTOCOMPLETE_DROPDOWN = "autocomplete-dropdown";
const $0abbbd36a260e067$var$CLASS_NAME_AUTOCOMPLETE_ITEMS_LIST = "autocomplete-items-list";
const $0abbbd36a260e067$var$CLASS_NAME_AUTOCOMPLETE_ITEM = "autocomplete-item";
const $0abbbd36a260e067$var$CLASS_NAME_LOADER = "autocomplete-loader";
const $0abbbd36a260e067$var$CLASS_NAME_SPINNER_BORDER = "spinner-border";
const $0abbbd36a260e067$var$CLASS_NAME_NO_RESULTS = "autocomplete-item autocomplete-no-results";
function $0abbbd36a260e067$var$getDropdownTemplate(settings) {
    const { id: id, items: items, width: width, options: options } = settings;
    const dropdownContainer = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(dropdownContainer, $0abbbd36a260e067$var$CLASS_NAME_AUTOCOMPLETE_DROPDOWN_CONTAINER);
    $0abbbd36a260e067$var$Manipulator$1.addStyle(dropdownContainer, {
        width: `${width}px`
    });
    dropdownContainer.setAttribute("id", id);
    const dropdown = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(dropdown, $0abbbd36a260e067$var$CLASS_NAME_AUTOCOMPLETE_DROPDOWN);
    const itemsList = $0abbbd36a260e067$var$element("ul");
    const listHeight = options.listHeight;
    $0abbbd36a260e067$var$Manipulator$1.addClass(itemsList, $0abbbd36a260e067$var$CLASS_NAME_AUTOCOMPLETE_ITEMS_LIST);
    $0abbbd36a260e067$var$Manipulator$1.addStyle(itemsList, {
        maxHeight: `${listHeight}px`
    });
    itemsList.setAttribute("role", "listbox");
    const itemsListTemplate = $0abbbd36a260e067$var$getItemsTemplate(items, options);
    itemsList.innerHTML = itemsListTemplate;
    dropdown.appendChild(itemsList);
    dropdownContainer.appendChild(dropdown);
    return dropdownContainer;
}
function $0abbbd36a260e067$var$getItemsTemplate(items = [], options) {
    const displayValue = options.displayValue;
    const itemContent = options.itemContent;
    return `
    ${items.map((item, index)=>{
        const content = typeof itemContent === "function" ? $0abbbd36a260e067$var$sanitizeHtml(itemContent(item), $0abbbd36a260e067$var$DefaultWhitelist, null) : displayValue(item);
        return `<li data-mdb-index="${index}" role="option" class="${$0abbbd36a260e067$var$CLASS_NAME_AUTOCOMPLETE_ITEM}">${content}</li>`;
    }).join("")}
  `;
}
function $0abbbd36a260e067$var$getLoaderTemplate() {
    const container = $0abbbd36a260e067$var$element("div");
    $0abbbd36a260e067$var$Manipulator$1.addClass(container, $0abbbd36a260e067$var$CLASS_NAME_LOADER);
    $0abbbd36a260e067$var$Manipulator$1.addClass(container, $0abbbd36a260e067$var$CLASS_NAME_SPINNER_BORDER);
    container.setAttribute("role", "status");
    const content = '<span class="sr-only">Loading...</span>';
    container.innerHTML = content;
    return container;
}
function $0abbbd36a260e067$var$getNoResultsTemplate(message) {
    return `<li class="${$0abbbd36a260e067$var$CLASS_NAME_NO_RESULTS}">${message}</li>`;
}
const $0abbbd36a260e067$var$Default$6 = {
    autoSelect: false,
    container: "body",
    customContent: "",
    debounce: 300,
    displayValue: (value)=>value,
    filter: null,
    itemContent: null,
    listHeight: 190,
    noResults: "No results found",
    threshold: 0
};
const $0abbbd36a260e067$var$DefaultType$6 = {
    autoSelect: "boolean",
    container: "string",
    customContent: "string",
    debounce: "number",
    displayValue: "function",
    filter: "(null|function)",
    itemContent: "(null|function)",
    listHeight: "number",
    noResults: "string",
    threshold: "number"
};
const $0abbbd36a260e067$var$NAME$7 = "autocomplete";
const $0abbbd36a260e067$var$DATA_KEY$7 = "mdb.autocomplete";
const $0abbbd36a260e067$var$CLASS_NAME_CUSTOM_INPUT = "autocomplete-input";
const $0abbbd36a260e067$var$CLASS_NAME_CUSTOM_LABEL = "autocomplete-label";
const $0abbbd36a260e067$var$CLASS_NAME_ACTIVE = "active";
const $0abbbd36a260e067$var$CLASS_NAME_FOCUSED = "focused";
const $0abbbd36a260e067$var$CLASS_NAME_FOCUSING = "focusing";
const $0abbbd36a260e067$var$CLASS_NAME_OPEN$1 = "open";
const $0abbbd36a260e067$var$SELECTOR_DROPDOWN = ".autocomplete-dropdown";
const $0abbbd36a260e067$var$SELECTOR_ITEMS_LIST = ".autocomplete-items-list";
const $0abbbd36a260e067$var$SELECTOR_ITEM = ".autocomplete-item";
const $0abbbd36a260e067$var$SELECTOR_LOADER = ".autocomplete-loader";
const $0abbbd36a260e067$var$SELECTOR_INPUT = ".form-control";
const $0abbbd36a260e067$var$SELECTOR_LABEL = ".form-label";
const $0abbbd36a260e067$var$SELECTOR_CUSTOM_CONTENT = ".autocomplete-custom-content";
const $0abbbd36a260e067$var$EVENT_KEY$5 = `.${$0abbbd36a260e067$var$DATA_KEY$7}`;
const $0abbbd36a260e067$var$EVENT_CLOSE$1 = `close${$0abbbd36a260e067$var$EVENT_KEY$5}`;
const $0abbbd36a260e067$var$EVENT_OPEN$1 = `open${$0abbbd36a260e067$var$EVENT_KEY$5}`;
const $0abbbd36a260e067$var$EVENT_SELECT$2 = `itemSelect${$0abbbd36a260e067$var$EVENT_KEY$5}`;
const $0abbbd36a260e067$var$EVENT_UPDATE = `update${$0abbbd36a260e067$var$EVENT_KEY$5}`;
const $0abbbd36a260e067$var$LOADER_CLOSE_DELAY = 300;
class $0abbbd36a260e067$export$2f2b9559550c7bbc extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options){
        super(element2);
        this._options = this._getConfig(options);
        this._getContainer();
        this._input = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_INPUT, element2);
        this._label = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_LABEL, element2);
        this._customContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_CUSTOM_CONTENT, element2);
        this._loader = $0abbbd36a260e067$var$getLoaderTemplate();
        this._popper = null;
        this._debounceTimeoutId = null;
        this._loaderTimeout = null;
        this._activeItemIndex = -1;
        this._activeItem = null;
        this._filteredResults = null;
        this._lastQueryValue = null;
        this._canOpenOnFocus = true;
        this._isOpen = false;
        this._outsideClickHandler = this._handleOutsideClick.bind(this);
        this._inputFocusHandler = this._handleInputFocus.bind(this);
        this._userInputHandler = this._handleUserInput.bind(this);
        this._keydownHandler = this._handleKeydown.bind(this);
        this._init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$7;
    }
    get filter() {
        return this._options.filter;
    }
    get dropdown() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_DROPDOWN, this._dropdownContainer);
    }
    get items() {
        return $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_ITEM, this._dropdownContainer);
    }
    get itemsList() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_ITEMS_LIST, this._dropdownContainer);
    }
    search(value) {
        this._filterResults(value);
    }
    _getContainer() {
        this._container = $0abbbd36a260e067$var$SelectorEngine$1.findOne(this._options.container);
    }
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        config = {
            ...$0abbbd36a260e067$var$Default$6,
            ...dataAttributes,
            ...config
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$7, config, $0abbbd36a260e067$var$DefaultType$6);
        return config;
    }
    _init() {
        this._initDropdown();
        this._setInputAndLabelClasses();
        this._updateLabelPosition();
        this._setInputAriaAttributes();
        this._listenToInputFocus();
        this._listenToUserInput();
        this._listenToKeydown();
    }
    _initDropdown() {
        this._dropdownContainerId = this._element.id ? `autocomplete-dropdown-${this._element.id}` : $0abbbd36a260e067$var$getUID$1("autocomplete-dropdown-");
        const settings = {
            id: this._dropdownContainerId,
            items: [],
            width: this._input.offsetWidth,
            options: this._options
        };
        this._dropdownContainer = $0abbbd36a260e067$var$getDropdownTemplate(settings);
        if (this._options.customContent !== "") {
            const customContent = this._options.customContent;
            const sanitizedCustomContent = $0abbbd36a260e067$var$sanitizeHtml(customContent, $0abbbd36a260e067$var$DefaultWhitelist, null);
            this.dropdown.insertAdjacentHTML("beforeend", sanitizedCustomContent);
        }
    }
    _setInputAndLabelClasses() {
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._input, $0abbbd36a260e067$var$CLASS_NAME_CUSTOM_INPUT);
        if (this._label) $0abbbd36a260e067$var$Manipulator$1.addClass(this._label, $0abbbd36a260e067$var$CLASS_NAME_CUSTOM_LABEL);
    }
    _setInputAriaAttributes() {
        this._input.setAttribute("role", "combobox");
        this._input.setAttribute("aria-expanded", false);
        this._input.setAttribute("aria-owns", this._dropdownContainerId);
        this._input.setAttribute("aria-haspopup", true);
        this._input.setAttribute("autocomplete", "off");
    }
    _updateLabelPosition() {
        if (!this._label) return;
        if (this._input.value !== "" || this._isOpen) $0abbbd36a260e067$var$Manipulator$1.addClass(this._label, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE);
        else $0abbbd36a260e067$var$Manipulator$1.removeClass(this._label, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE);
    }
    _listenToInputFocus() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._input, "focus", this._inputFocusHandler);
    }
    _handleInputFocus(event) {
        const { value: value } = event.target;
        const threshold = this._options.threshold;
        if (!this._canOpenOnFocus) {
            this._canOpenOnFocus = true;
            return;
        }
        if (value.length < threshold) return;
        if (this._lastQueryValue !== value) this._filterResults(value);
        else this.open();
    }
    _listenToWindowResize() {
        this._windowResizeHandler = this._handleWindowResize.bind(this);
        $0abbbd36a260e067$var$EventHandler$1.on(window, "resize", this._windowResizeHandler);
    }
    _handleWindowResize() {
        if (this._dropdownContainer) this._updateDropdownWidth();
    }
    _updateDropdownWidth() {
        const inputWidth = this._input.offsetWidth;
        $0abbbd36a260e067$var$Manipulator$1.addStyle(this._dropdownContainer, {
            width: `${inputWidth}px`
        });
    }
    _listenToUserInput() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._input, "input", this._userInputHandler);
    }
    _handleUserInput(event) {
        const { value: value } = event.target;
        const threshold = this._options.threshold;
        const debounceTime = this._options.debounce;
        if (!this.filter) return;
        if (value.length < threshold) {
            if (this._isOpen) this.close();
            return;
        }
        this._debounceFilter(value, debounceTime);
    }
    _debounceFilter(searchTerm, debounceTime) {
        if (this._debounceTimeoutId) clearTimeout(this._debounceTimeoutId);
        this._debounceTimeoutId = setTimeout(()=>{
            this._filterResults(searchTerm);
        }, debounceTime);
    }
    _filterResults(value) {
        this._lastQueryValue = value;
        const data = this.filter(value);
        if (this._isPromise(data)) this._asyncUpdateResults(data);
        else this._updateResults(data);
    }
    _isPromise(value) {
        return !!value && typeof value.then === "function";
    }
    _asyncUpdateResults(data) {
        this._resetActiveItem();
        this._showLoader();
        data.then((items)=>{
            this._updateResults(items);
            this._loaderTimeout = setTimeout(()=>{
                this._hideLoader();
                this._loaderTimeout = null;
            }, $0abbbd36a260e067$var$LOADER_CLOSE_DELAY);
        });
    }
    _resetActiveItem() {
        const currentActive = this._activeItem;
        if (currentActive) {
            $0abbbd36a260e067$var$Manipulator$1.removeClass(currentActive, "active");
            this._activeItem = null;
            this._activeItemIndex = -1;
        }
    }
    _showLoader() {
        this._element.appendChild(this._loader);
    }
    _hideLoader() {
        const loader = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_LOADER, this._element);
        if (loader) this._element.removeChild(this._loader);
    }
    _updateResults(data) {
        this._resetActiveItem();
        this._filteredResults = data;
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_UPDATE, {
            results: data
        });
        const itemsList = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".autocomplete-items-list", this._dropdownContainer);
        const newTemplate = $0abbbd36a260e067$var$getItemsTemplate(data, this._options);
        const noResultsTemplate = $0abbbd36a260e067$var$getNoResultsTemplate(this._options.noResults);
        if (data.length === 0 && this._options.noResults !== "") itemsList.innerHTML = noResultsTemplate;
        else itemsList.innerHTML = newTemplate;
        if (!this._isOpen) this.open();
        if (this._popper) this._popper.forceUpdate();
    }
    _listenToKeydown() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "keydown", this._keydownHandler);
    }
    _handleKeydown(event) {
        if (this._isOpen) this._handleOpenKeydown(event);
        else this._handleClosedKeydown(event);
    }
    _handleOpenKeydown(event) {
        const key = event.keyCode;
        if (key === $0abbbd36a260e067$var$TAB && this._options.autoSelect) this._selectActiveItem();
        if (key === $0abbbd36a260e067$var$ESCAPE || key === $0abbbd36a260e067$var$UP_ARROW && event.altKey) {
            if (!this._input.value) $0abbbd36a260e067$var$Manipulator$1.addClass(this._input, $0abbbd36a260e067$var$CLASS_NAME_FOCUSING);
            this.close();
            this._input.focus();
            if (!this._input.value) setTimeout(()=>{
                $0abbbd36a260e067$var$Manipulator$1.removeClass(this._input, $0abbbd36a260e067$var$CLASS_NAME_FOCUSING);
            }, 10);
            return;
        }
        const isCloseKey = key === $0abbbd36a260e067$var$ESCAPE || key === $0abbbd36a260e067$var$UP_ARROW && event.altKey || key === $0abbbd36a260e067$var$TAB;
        if (isCloseKey) {
            this.close();
            this._input.focus();
            return;
        }
        switch(key){
            case $0abbbd36a260e067$var$DOWN_ARROW:
                this._setActiveItem(this._activeItemIndex + 1);
                this._scrollToItem(this._activeItem);
                break;
            case $0abbbd36a260e067$var$UP_ARROW:
                this._setActiveItem(this._activeItemIndex - 1);
                this._scrollToItem(this._activeItem);
                break;
            case $0abbbd36a260e067$var$HOME:
                if (event.shiftKey) {
                    const start2 = 0;
                    const end2 = this._input.selectionStart;
                    this._input.setSelectionRange(start2, end2);
                } else if (this._activeItemIndex > -1) {
                    this._setActiveItem(0);
                    this._scrollToItem(this._activeItem);
                } else this._input.setSelectionRange(0, 0);
                break;
            case $0abbbd36a260e067$var$END:
                if (event.shiftKey) {
                    const start2 = this._input.selectionStart;
                    const end2 = this._input.value.length;
                    this._input.setSelectionRange(start2, end2);
                } else if (this._activeItemIndex > -1) {
                    this._setActiveItem(this.items.length - 1);
                    this._scrollToItem(this._activeItem);
                } else {
                    const end2 = this._input.value.length;
                    this._input.setSelectionRange(end2, end2);
                }
                break;
            case $0abbbd36a260e067$var$ENTER:
                event.preventDefault();
                if (this._activeItemIndex > -1) {
                    const item = this._filteredResults[this._activeItemIndex];
                    this._handleSelection(item);
                }
                return;
            default:
                return;
        }
        event.preventDefault();
    }
    _setActiveItem(index) {
        const items = this.items;
        if (!items[index]) return;
        this._updateActiveItem(items[index], index);
    }
    _updateActiveItem(newActiveItem, index) {
        const currentActiveItem = this._activeItem;
        if (currentActiveItem) $0abbbd36a260e067$var$Manipulator$1.removeClass(currentActiveItem, "active");
        $0abbbd36a260e067$var$Manipulator$1.addClass(newActiveItem, "active");
        this._activeItemIndex = index;
        this._activeItem = newActiveItem;
    }
    _scrollToItem(item) {
        if (!item) return;
        const list = this.itemsList;
        const listHeight = list.offsetHeight;
        const itemIndex = this.items.indexOf(item);
        const itemHeight = item.offsetHeight;
        const scrollTop = list.scrollTop;
        if (itemIndex > -1) {
            const itemOffset = itemIndex * itemHeight;
            const isBelow = itemOffset + itemHeight > scrollTop + listHeight;
            const isAbove = itemOffset < scrollTop;
            if (isAbove) list.scrollTop = itemOffset;
            else if (isBelow) list.scrollTop = itemOffset - listHeight + itemHeight;
            else list.scrollTop = scrollTop;
        }
    }
    _handleClosedKeydown(event) {
        if (event.key === "Enter") event.preventDefault();
        const key = event.keyCode;
        const isOpenKey = key === $0abbbd36a260e067$var$ENTER || key === $0abbbd36a260e067$var$DOWN_ARROW || key === $0abbbd36a260e067$var$DOWN_ARROW;
        if (isOpenKey) this.open();
    }
    open() {
        if (this._lastQueryValue === null) this._filterResults("");
        const openEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_OPEN$1);
        if (this._isOpen || openEvent.defaultPrevented) return;
        this._updateDropdownWidth();
        this._listenToWindowResize();
        this._popper = $0abbbd36a260e067$var$createPopper(this._element, this._dropdownContainer, {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            1
                        ]
                    }
                }
            ]
        });
        this._container.appendChild(this._dropdownContainer);
        this._listenToOutsideClick();
        this._listenToItemsClick();
        setTimeout(()=>{
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.dropdown, $0abbbd36a260e067$var$CLASS_NAME_OPEN$1);
            this._isOpen = true;
            this._input.setAttribute("aria-expanded", true);
            this._setInputActiveStyles();
            this._updateLabelPosition();
        }, 0);
    }
    _listenToOutsideClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(document, "click", this._outsideClickHandler);
    }
    _handleOutsideClick(event) {
        const isInput = this._input === event.target;
        const isDropdown = event.target === this._dropdownContainer;
        const isDropdownContent = this._dropdownContainer && this._dropdownContainer.contains(event.target);
        if (!isInput && !isDropdown && !isDropdownContent) this.close();
    }
    _listenToItemsClick() {
        const itemsList = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_ITEMS_LIST, this._dropdownContainer);
        $0abbbd36a260e067$var$EventHandler$1.on(itemsList, "click", this._handleItemsClick.bind(this));
    }
    _handleItemsClick(event) {
        const target = $0abbbd36a260e067$var$SelectorEngine$1.closest(event.target, $0abbbd36a260e067$var$SELECTOR_ITEM);
        const targetIndex = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(target, "index");
        const item = this._filteredResults[targetIndex];
        this._handleSelection(item);
    }
    _selectActiveItem() {
        const item = this._filteredResults[this._activeItemIndex];
        if (!item) return;
        const value = this._options.displayValue(item);
        const selectEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SELECT$2, {
            value: item
        });
        if (selectEvent.defaultPrevented) return;
        setTimeout(()=>{
            this._canOpenOnFocus = false;
            this._updateInputValue(value);
            this._updateLabelPosition();
        }, 0);
    }
    _handleSelection(item) {
        if (!item) return;
        const value = this._options.displayValue(item);
        const selectEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_SELECT$2, {
            value: item
        });
        if (selectEvent.defaultPrevented) return;
        setTimeout(()=>{
            this._canOpenOnFocus = false;
            this._updateInputValue(value);
            this._updateLabelPosition();
            this._input.focus();
            this.close();
        }, 0);
    }
    _updateInputValue(value) {
        this._input.value = value;
    }
    _setInputActiveStyles() {
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._input, $0abbbd36a260e067$var$CLASS_NAME_FOCUSED);
    }
    close() {
        const closeEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CLOSE$1);
        if (!this._isOpen || closeEvent.defaultPrevented) return;
        this._resetActiveItem();
        this._removeDropdownEvents();
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this.dropdown, $0abbbd36a260e067$var$CLASS_NAME_OPEN$1);
        $0abbbd36a260e067$var$EventHandler$1.on(this.dropdown, "transitionend", this._handleDropdownTransitionEnd.bind(this));
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this._input, $0abbbd36a260e067$var$CLASS_NAME_FOCUSED);
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this._input, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE);
        if (!this._input.value && this._label) $0abbbd36a260e067$var$Manipulator$1.removeClass(this._label, $0abbbd36a260e067$var$CLASS_NAME_ACTIVE);
    }
    _removeDropdownEvents() {
        const itemsList = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_ITEMS_LIST, this._dropdownContainer);
        $0abbbd36a260e067$var$EventHandler$1.off(itemsList, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(document, "click", this._outsideClickHandler);
        $0abbbd36a260e067$var$EventHandler$1.off(window, "resize", this._windowResizeHandler);
    }
    _handleDropdownTransitionEnd(event) {
        if (this._isOpen && event && event.propertyName === "opacity") {
            this._popper.destroy();
            if (this._dropdownContainer) this._container.removeChild(this._dropdownContainer);
            this._isOpen = false;
            this._input.setAttribute("aria-expanded", false);
            $0abbbd36a260e067$var$EventHandler$1.off(this.dropdown, "transitionend");
        }
    }
    dispose() {
        if (this._isOpen) this.close();
        this._removeInputAndElementEvents();
        this._dropdownContainer.remove();
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    _removeInputAndElementEvents() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._input, "focus", this._inputFocusHandler);
        $0abbbd36a260e067$var$EventHandler$1.off(this._input, "input", this._userInputHandler);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "keydown", this._keydownHandler);
    }
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$7);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$2f2b9559550c7bbc(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
$0abbbd36a260e067$var$defineJQueryPlugin($0abbbd36a260e067$export$2f2b9559550c7bbc);
const $0abbbd36a260e067$var$NAME$6 = "modal";
const $0abbbd36a260e067$var$DATA_KEY$6 = "bs.modal";
const $0abbbd36a260e067$var$EVENT_KEY$4 = `.${$0abbbd36a260e067$var$DATA_KEY$6}`;
const $0abbbd36a260e067$var$ESCAPE_KEY = "Escape";
const $0abbbd36a260e067$var$EVENT_HIDE = `hide${$0abbbd36a260e067$var$EVENT_KEY$4}`;
const $0abbbd36a260e067$var$EVENT_HIDE_PREVENTED = `hidePrevented${$0abbbd36a260e067$var$EVENT_KEY$4}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN = `hidden${$0abbbd36a260e067$var$EVENT_KEY$4}`;
const $0abbbd36a260e067$var$EVENT_SHOW = `show${$0abbbd36a260e067$var$EVENT_KEY$4}`;
const $0abbbd36a260e067$var$EVENT_SHOWN = `shown${$0abbbd36a260e067$var$EVENT_KEY$4}`;
const $0abbbd36a260e067$var$EVENT_RESIZE = `resize${$0abbbd36a260e067$var$EVENT_KEY$4}`;
const $0abbbd36a260e067$var$EVENT_CLICK_DISMISS = `click.dismiss${$0abbbd36a260e067$var$EVENT_KEY$4}`;
const $0abbbd36a260e067$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$0abbbd36a260e067$var$EVENT_KEY$4}`;
const $0abbbd36a260e067$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$0abbbd36a260e067$var$EVENT_KEY$4}`;
const $0abbbd36a260e067$var$CLASS_NAME_OPEN = "modal-open";
const $0abbbd36a260e067$var$CLASS_NAME_FADE = "fade";
const $0abbbd36a260e067$var$CLASS_NAME_SHOW = "show";
const $0abbbd36a260e067$var$CLASS_NAME_STATIC = "modal-static";
const $0abbbd36a260e067$var$SELECTOR_DIALOG = ".modal-dialog";
const $0abbbd36a260e067$var$SELECTOR_MODAL_BODY = ".modal-body";
const $0abbbd36a260e067$var$Default$5 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $0abbbd36a260e067$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
let $0abbbd36a260e067$var$Modal$1 = class Modal extends $0abbbd36a260e067$var$BaseComponent$1 {
    constructor(element2, config){
        super(element2, config);
        this._dialog = $0abbbd36a260e067$var$SelectorEngine.findOne($0abbbd36a260e067$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $0abbbd36a260e067$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $0abbbd36a260e067$var$Default$5;
    }
    static get DefaultType() {
        return $0abbbd36a260e067$var$DefaultType$5;
    }
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOW, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($0abbbd36a260e067$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_SHOW);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler.off(window, $0abbbd36a260e067$var$EVENT_KEY$4);
        $0abbbd36a260e067$var$EventHandler.off(this._dialog, $0abbbd36a260e067$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $0abbbd36a260e067$var$Backdrop({
            isVisible: Boolean(this._config.backdrop) && Boolean(!this._config.modalNonInvasive),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $0abbbd36a260e067$var$FocusTrap$1({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $0abbbd36a260e067$var$SelectorEngine.findOne($0abbbd36a260e067$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $0abbbd36a260e067$var$reflow(this._element);
        this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_SHOW);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_SHOWN, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $0abbbd36a260e067$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $0abbbd36a260e067$var$EventHandler.on(window, $0abbbd36a260e067$var$EVENT_RESIZE, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $0abbbd36a260e067$var$EventHandler.on(this._element, $0abbbd36a260e067$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            $0abbbd36a260e067$var$EventHandler.one(this._element, $0abbbd36a260e067$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($0abbbd36a260e067$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($0abbbd36a260e067$var$CLASS_NAME_FADE);
    }
    _triggerBackdropTransition() {
        const hideEvent = $0abbbd36a260e067$var$EventHandler.trigger(this._element, $0abbbd36a260e067$var$EVENT_HIDE_PREVENTED);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        if (initialOverflowY === "hidden" || this._element.classList.contains($0abbbd36a260e067$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($0abbbd36a260e067$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($0abbbd36a260e067$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $0abbbd36a260e067$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $0abbbd36a260e067$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = Modal.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
};
const $0abbbd36a260e067$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $0abbbd36a260e067$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $0abbbd36a260e067$var$reset = ()=>{
    $0abbbd36a260e067$var$_resetElementAttributes("body", "overflow");
    $0abbbd36a260e067$var$_resetElementAttributes("body", "paddingRight");
    $0abbbd36a260e067$var$_resetElementAttributes($0abbbd36a260e067$var$SELECTOR_FIXED_CONTENT, "paddingRight");
    $0abbbd36a260e067$var$_resetElementAttributes($0abbbd36a260e067$var$SELECTOR_STICKY_CONTENT, "marginRight");
};
const $0abbbd36a260e067$var$_resetElementAttributes = (selector, styleProp)=>{
    $0abbbd36a260e067$var$SelectorEngine$1.find(selector).forEach((element2)=>{
        const value = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(element2, styleProp);
        if (typeof value === "undefined") element2.style.removeProperty(styleProp);
        else {
            $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(element2, styleProp);
            element2.style[styleProp] = value;
        }
    });
};
const $0abbbd36a260e067$var$NAME$5 = "modal";
const $0abbbd36a260e067$var$DATA_KEY$5 = "bs.modal";
const $0abbbd36a260e067$var$EVENT_KEY$3 = `.${$0abbbd36a260e067$var$DATA_KEY$5}`;
const $0abbbd36a260e067$var$MODAL_CSS_BREAKPOINT = 992;
const $0abbbd36a260e067$var$NON_INVASIVE_CLASS = "modal-non-invasive-open";
const $0abbbd36a260e067$var$NON_INVASIVE_SHOW_CLASS = "modal-non-invasive-show";
const $0abbbd36a260e067$var$SHOW_CLASS = "show";
const $0abbbd36a260e067$var$MODAL_CLASS = "modal";
const $0abbbd36a260e067$var$MODAL_OPEN_CLASS = "modal-open";
const $0abbbd36a260e067$var$MODAL_CONTENT_CLASS = "modal-content";
const $0abbbd36a260e067$var$MODAL_BOTTOM_CLASS = "modal-bottom";
const $0abbbd36a260e067$var$MODAL_BOTTOM_RIGHT_CLASS = "modal-bottom-right";
const $0abbbd36a260e067$var$MODAL_BOTTOM_LEFT_CLASS = "modal-bottom-left";
const $0abbbd36a260e067$var$MODAL_TOP_RIGHT_CLASS = "modal-top-right";
const $0abbbd36a260e067$var$MODAL_TOP_LEFT_CLASS = "modal-top-left";
const $0abbbd36a260e067$var$MODAL_DIALOG_SCROLLABLE_CLASS = "modal-dialog-scrollable";
const $0abbbd36a260e067$var$MODAL_DIALOG_CLASS = "modal-dialog";
const $0abbbd36a260e067$var$SELECTOR_MODAL_CONTENT = `.${$0abbbd36a260e067$var$MODAL_CONTENT_CLASS}`;
const $0abbbd36a260e067$var$SELECTOR_MODAL_BOTTOM = `.${$0abbbd36a260e067$var$MODAL_BOTTOM_CLASS}`;
const $0abbbd36a260e067$var$SELECTOR_MODAL_BOTTOM_RIGHT = `.${$0abbbd36a260e067$var$MODAL_BOTTOM_RIGHT_CLASS}`;
const $0abbbd36a260e067$var$SELECTOR_MODAL_BOTTOM_LEFT = `.${$0abbbd36a260e067$var$MODAL_BOTTOM_LEFT_CLASS}`;
const $0abbbd36a260e067$var$SELECTOR_MODAL_TOP_RIGHT = `.${$0abbbd36a260e067$var$MODAL_TOP_RIGHT_CLASS}`;
const $0abbbd36a260e067$var$SELECTOR_MODAL_TOP_LEFT = `.${$0abbbd36a260e067$var$MODAL_TOP_LEFT_CLASS}`;
const $0abbbd36a260e067$var$SELECTOR_MODAL_DIALOG_SCROLLABLE = `.${$0abbbd36a260e067$var$MODAL_DIALOG_SCROLLABLE_CLASS}`;
const $0abbbd36a260e067$var$SELECTOR_MODAL_DIALOG = `.${$0abbbd36a260e067$var$MODAL_DIALOG_CLASS}`;
const $0abbbd36a260e067$var$EVENT_SHOW_BS_MODAL = `show${$0abbbd36a260e067$var$EVENT_KEY$3}`;
const $0abbbd36a260e067$var$EVENT_SHOWN_BS_MODAL = `shown${$0abbbd36a260e067$var$EVENT_KEY$3}`;
const $0abbbd36a260e067$var$EVENT_HIDDEN_BS_MODAL = `hidden${$0abbbd36a260e067$var$EVENT_KEY$3}`;
const $0abbbd36a260e067$var$EVENT_HIDE_BS_MODAL = "hide.bs.modal";
const $0abbbd36a260e067$var$EVENT_HIDE_PREVENTED_BS_MODAL = "hidePrevented.bs.modal";
const $0abbbd36a260e067$var$EXTENDED_EVENTS = [
    {
        name: "show",
        parametersToCopy: [
            "relatedTarget"
        ]
    },
    {
        name: "shown",
        parametersToCopy: [
            "relatedTarget"
        ]
    },
    {
        name: "hide"
    },
    {
        name: "hidePrevented"
    },
    {
        name: "hidden"
    }
];
const $0abbbd36a260e067$var$Default$4 = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true,
    modalNonInvasive: false
};
const $0abbbd36a260e067$var$DefaultType$4 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    focus: "boolean",
    show: "boolean",
    modalNonInvasive: "boolean"
};
class $0abbbd36a260e067$export$2b77a92f1a5ad772 extends $0abbbd36a260e067$var$Modal$1 {
    constructor(element2, data){
        super(element2, data);
        this._config = this._getConfig(data);
        this._modalContentRect = "";
        this._modalContentComputedStyles = "";
        this._isNonInvasive = this._config.modalNonInvasive;
        this._isScrollable = "";
        this._isBottomRight = "";
        this._isBottomLeft = "";
        this._isTopRight = "";
        this._isTopLeft = "";
        this._isSideTopModal = "";
        this._isSideBottomModal = "";
        this._isSideModal = "";
        this._isModalBottom = "";
        if (this._isNonInvasive) {
            this._config.backdrop = false;
            this._config.focus = false;
            this._isBodyOverflowing = true;
            this._onModalShow();
            this._onModalShown();
            this._onModalHidden();
            this._listenToWindowResize();
        }
        $0abbbd36a260e067$var$Data$1.setData(element2, $0abbbd36a260e067$var$DATA_KEY$5, this);
        this._bindMdbEvents();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$5;
    }
    // Public
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOW_BS_MODAL);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_SHOWN_BS_MODAL);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_HIDE_BS_MODAL);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN_BS_MODAL);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, $0abbbd36a260e067$var$EVENT_HIDE_PREVENTED_BS_MODAL);
        $0abbbd36a260e067$var$EventHandler$1.off(window, "resize", this._windowResizeHandler);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _onModalShow() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_SHOW_BS_MODAL, ()=>{
            this._addNonInvasiveClass();
        });
    }
    _onModalShown() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_SHOWN_BS_MODAL, ()=>{
            const modalContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_MODAL_CONTENT, this._element);
            this._isScrollable = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_MODAL_DIALOG_SCROLLABLE, this._element);
            this._isBottomRight = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_MODAL_BOTTOM_RIGHT, this._element);
            this._isBottomLeft = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_MODAL_BOTTOM_LEFT, this._element);
            this._isTopRight = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_MODAL_TOP_RIGHT, this._element);
            this._isTopLeft = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_MODAL_TOP_LEFT, this._element);
            this._isSideTopModal = this._isTopLeft || this._isTopRight;
            this._isSideBottomModal = this._isBottomLeft || this._isBottomRight;
            this._isSideModal = this._isSideTopModal || this._isSideBottomModal;
            this._isModalBottom = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_MODAL_BOTTOM, this._element);
            this._modalContentRect = modalContent.getBoundingClientRect();
            this._modalContentComputedStyles = window.getComputedStyle(modalContent);
            this._modalDialogComputedStyles = window.getComputedStyle($0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_MODAL_DIALOG, this._element));
            this._topOffset = parseInt(this._modalDialogComputedStyles.top, 0);
            this._leftOffset = parseInt(this._modalDialogComputedStyles.left, 0);
            this._rightOffset = parseInt(this._modalDialogComputedStyles.right, 0);
            this._bottomOffset = parseInt(this._modalDialogComputedStyles.bottom, 0);
            this._addOpenClass();
            this._setStyles();
        });
    }
    _listenToWindowResize() {
        this._windowResizeHandler = this._handleWindowResize.bind(this);
        $0abbbd36a260e067$var$EventHandler$1.on(window, "resize", this._windowResizeHandler);
    }
    _handleWindowResize() {
        const modalContent = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_MODAL_CONTENT, this._element);
        this._resetStyles();
        this._modalContentRect = modalContent.getBoundingClientRect();
        this._modalContentComputedStyles = window.getComputedStyle(modalContent);
        if (this._isSideTopModal || this._isSideBottomModal) {
            let sideOffset = 0;
            let topOffset = 0;
            if (this._isBottomRight || this._isBottomLeft) topOffset = -this._bottomOffset;
            if (this._isBottomRight || this._isTopRight) sideOffset = -this._rightOffset;
            if (this._isBottomLeft || this._isTopLeft) sideOffset = this._leftOffset;
            this._setStyles(sideOffset, topOffset);
            return;
        }
        this._setStyles();
    }
    _showBackdrop(callback) {
        if (this._isNonInvasive) {
            if (typeof callback === "function") callback();
        } else super._showBackdrop(callback);
    }
    _adjustDialog() {
        super._adjustDialog();
        const isNonInvasiveModalOpen = document.body.classList.contains($0abbbd36a260e067$var$NON_INVASIVE_CLASS);
        if (this._isNonInvasive || isNonInvasiveModalOpen) this._isBodyOverflowing = false;
        if (this._isNonInvasive) {
            this._resetAdjustments();
            $0abbbd36a260e067$var$reset();
        }
    }
    _onModalHidden() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, $0abbbd36a260e067$var$EVENT_HIDDEN_BS_MODAL, (e)=>{
            e.stopImmediatePropagation();
            this._removeOpenClass();
            this._resetStyles();
            this._removeNonInvasiveClass();
        });
    }
    _addOpenClass() {
        this._element.classList.add($0abbbd36a260e067$var$NON_INVASIVE_SHOW_CLASS);
    }
    _removeOpenClass() {
        this._element.classList.remove($0abbbd36a260e067$var$NON_INVASIVE_SHOW_CLASS);
    }
    _addNonInvasiveClass() {
        document.body.classList.add($0abbbd36a260e067$var$NON_INVASIVE_CLASS);
    }
    _removeNonInvasiveClass() {
        const isOtherModalOpen = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$MODAL_CLASS}.${$0abbbd36a260e067$var$SHOW_CLASS}.${$0abbbd36a260e067$var$NON_INVASIVE_SHOW_CLASS}`, document.body);
        if (!isOtherModalOpen) document.body.classList.remove($0abbbd36a260e067$var$NON_INVASIVE_CLASS);
        else document.body.classList.add($0abbbd36a260e067$var$MODAL_OPEN_CLASS);
    }
    _setStyles(leftOffset = 0, topOffset = 0) {
        const isAboveBreakpoint = window.innerWidth >= $0abbbd36a260e067$var$MODAL_CSS_BREAKPOINT;
        this._element.style.left = `${this._modalContentRect.left + leftOffset}px`;
        this._element.style.width = this._modalContentComputedStyles.width;
        if (!this._isScrollable) {
            this._element.style.height = this._modalContentComputedStyles.height;
            this._element.style.display = "";
        }
        if (isAboveBreakpoint) {
            if (this._isSideBottomModal || this._isModalBottom) this._element.style.top = `${this._modalContentRect.top + topOffset}px`;
            if (this._isSideModal) this._element.style.overflowX = "auto";
        }
        if (!isAboveBreakpoint) this._element.style.height = "";
    }
    _resetStyles() {
        this._element.style.left = "";
        this._element.style.top = "";
        this._element.style.height = "";
        this._element.style.width = "";
        if (!this._isScrollable) this._element.style.display = "";
        if (this._isSideModal) this._element.style.overflowX = "";
    }
    _getConfig(options) {
        let target;
        if (this._element) target = $0abbbd36a260e067$var$getElementFromSelector(this._element);
        const config = {
            ...$0abbbd36a260e067$var$Default$4,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(target),
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$5, config, $0abbbd36a260e067$var$DefaultType$4);
        return config;
    }
    // Private
    _bindMdbEvents() {
        $0abbbd36a260e067$var$EventHandler$1.extend(this._element, $0abbbd36a260e067$var$EXTENDED_EVENTS, $0abbbd36a260e067$var$NAME$5);
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$5);
            const _config = {
                ...$0abbbd36a260e067$var$Default$4,
                ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this),
                // eslint-disable-next-line no-extra-parens
                ...typeof config === "object" && config ? config : {}
            };
            if (!data) data = new $0abbbd36a260e067$export$2b77a92f1a5ad772(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](relatedTarget);
            } else if (_config.show) data.show(relatedTarget);
        });
    }
}
const $0abbbd36a260e067$var$NAME$4 = "clipboard";
const $0abbbd36a260e067$var$DATA_KEY$4 = "mdb.clipboard";
const $0abbbd36a260e067$var$EVENT_KEY$2 = `.${$0abbbd36a260e067$var$DATA_KEY$4}`;
const $0abbbd36a260e067$var$DEFAULT_OPTIONS$1 = {
    clipboardTarget: null
};
const $0abbbd36a260e067$var$OPTIONS_TYPE = {
    clipboardTarget: "null|string"
};
const $0abbbd36a260e067$var$EVENT_COPIED = `copied${$0abbbd36a260e067$var$EVENT_KEY$2}`;
class $0abbbd36a260e067$export$8b44c43c7d8f0830 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options = {}){
        super(element2);
        this._options = options;
        if (this._element) {
            this._initCopyHandler = this._initCopy.bind(this);
            this._setup();
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
        }
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$4;
    }
    get options() {
        const config = {
            ...$0abbbd36a260e067$var$DEFAULT_OPTIONS$1,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...this._options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$4, config, $0abbbd36a260e067$var$OPTIONS_TYPE);
        return config;
    }
    get clipboardTarget() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(this.options.clipboardTarget);
    }
    get copyText() {
        const clipboardTextExist = this.clipboardTarget.hasAttribute("data-mdb-clipboard-text");
        const inputValue = this.clipboardTarget.value;
        const targetText = this.clipboardTarget.textContent;
        if (clipboardTextExist) return this.clipboardTarget.getAttribute("data-mdb-clipboard-text");
        if (inputValue) return inputValue;
        return targetText;
    }
    // Public
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "click", this._initCopyHandler);
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _setup() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "click", this._initCopyHandler);
    }
    _initCopy() {
        const inputToCopy = this._createNewInput();
        document.body.appendChild(inputToCopy);
        this._selectInput(inputToCopy);
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_COPIED, {
            copyText: this.copyText
        });
        inputToCopy.remove();
    }
    _createNewInput() {
        const tag = this.clipboardTarget.tagName === "TEXTAREA" ? "textarea" : "input";
        const newInput = $0abbbd36a260e067$var$element(tag);
        newInput.value = this.copyText;
        $0abbbd36a260e067$var$Manipulator$1.style(newInput, {
            left: "-9999px",
            position: "absolute"
        });
        return newInput;
    }
    _selectInput(input) {
        input.select();
        input.focus();
        input.setSelectionRange(0, 99999);
        document.execCommand("copy");
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$4);
            const _config = typeof config === "object" && config;
            if (!data) data = new $0abbbd36a260e067$export$8b44c43c7d8f0830(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
const $0abbbd36a260e067$var$getInputField = ({ inputID: inputID, labelText: labelText })=>{
    return `<div class="form-outline chips-input-wrapper">
      <input type="text" id="${inputID}" class="form-control chips-input" />
      <label class="form-label" for="${inputID}">
        ${labelText}
      </label>
    </div>`;
};
const $0abbbd36a260e067$var$getChip = ({ text: text })=>{
    return `<div class="chip btn"><span class="text-chip">${text}</span> <i class="close fas fa-times"></i></div>`;
};
const $0abbbd36a260e067$var$NAME$3 = "chip";
const $0abbbd36a260e067$var$DATA_KEY$3 = `mdb.${$0abbbd36a260e067$var$NAME$3}`;
const $0abbbd36a260e067$var$SELECTOR_CLOSE$1 = ".close";
const $0abbbd36a260e067$var$EVENT_DELETE$1 = "delete.mdb.chips";
const $0abbbd36a260e067$var$EVENT_SELECT$1 = "select.mdb.chip";
const $0abbbd36a260e067$var$DefaultType$3 = {
    text: "string",
    closeIcon: "boolean",
    img: "object"
};
const $0abbbd36a260e067$var$Default$3 = {
    text: "",
    closeIcon: false,
    img: {
        path: "",
        alt: ""
    }
};
class $0abbbd36a260e067$export$5a7f9a6004988d01 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, data = {}){
        super(element2, data);
        this._options = this._getConfig(data);
        if (this._element) $0abbbd36a260e067$var$Data$1.setData(element2, $0abbbd36a260e067$var$DATA_KEY$3, this);
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$3;
    }
    // Public
    init() {
        this._appendCloseIcon();
        this._handleDelete();
        this._handleTextChip();
        this._handleClickOnChip();
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "click");
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    appendChip() {
        const { text: text, closeIcon: closeIcon } = this._options;
        const chip = $0abbbd36a260e067$var$getChip({
            text: text,
            closeIcon: closeIcon
        });
        return chip;
    }
    // Private
    _appendCloseIcon(el = this._element) {
        if ($0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_CLOSE$1, this._element).length > 0) return;
        if (this._options.closeIcon) {
            const createIcon = $0abbbd36a260e067$var$element("i");
            createIcon.classList = "close fas fa-times";
            el.insertAdjacentElement("beforeend", createIcon);
        }
    }
    _handleClickOnChip() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "click", (event)=>{
            const { textContent: textContent } = event.target;
            const obj = {};
            obj.tag = textContent.trim();
            $0abbbd36a260e067$var$EventHandler$1.trigger($0abbbd36a260e067$var$EVENT_SELECT$1, {
                event: event,
                obj: obj
            });
        });
    }
    _handleDelete() {
        const deleteElement = $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_CLOSE$1, this._element);
        if (deleteElement.length === 0) return;
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "click", $0abbbd36a260e067$var$SELECTOR_CLOSE$1, ()=>{
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_DELETE$1);
            this._element.remove();
        });
    }
    _handleTextChip() {
        if (this._element.innerText !== "") return;
        this._element.innerText = this._options.text;
    }
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$Default$3,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$3, config, $0abbbd36a260e067$var$DefaultType$3);
        return config;
    }
    static jQueryInterface(config) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$3);
            const _config = typeof config === "object" && config;
            if (!data && /dispose|hide/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$5a7f9a6004988d01(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
const $0abbbd36a260e067$var$NAME$2 = "chips";
const $0abbbd36a260e067$var$DATA_KEY$2 = `mdb.${$0abbbd36a260e067$var$NAME$2}`;
const $0abbbd36a260e067$var$CLASSNAME_ACTIVE = "active";
const $0abbbd36a260e067$var$CLASSNAME_CHIPS_INITIAL = `${$0abbbd36a260e067$var$NAME$2}-initial`;
const $0abbbd36a260e067$var$CLASSNAME_CHIPS_PLACEHOLDER = `${$0abbbd36a260e067$var$NAME$2}-placeholder`;
const $0abbbd36a260e067$var$CLASSNAME_CLOSE_OPACITY = "close-opacity";
const $0abbbd36a260e067$var$CLASSNAME_CHIP_OPACITY = "chip-opacity";
const $0abbbd36a260e067$var$CLASSNAME_CHIPS_PADDING = `${$0abbbd36a260e067$var$NAME$2}-padding`;
const $0abbbd36a260e067$var$CLASSNAME_CHIPS_TANSITION = `${$0abbbd36a260e067$var$NAME$2}-transition`;
const $0abbbd36a260e067$var$CLASSNAME_CHIPS_WRAPPER = `${$0abbbd36a260e067$var$NAME$2}-input-wrapper`;
const $0abbbd36a260e067$var$SELECTOR_CHIP = ".chip";
const $0abbbd36a260e067$var$SELECTOR_CHIP_ACTIVE = `${$0abbbd36a260e067$var$SELECTOR_CHIP}.${$0abbbd36a260e067$var$CLASSNAME_ACTIVE}`;
const $0abbbd36a260e067$var$SELECTOR_CLOSE = ".close";
const $0abbbd36a260e067$var$EVENT_ADD = "add.mdb.chips";
const $0abbbd36a260e067$var$EVENT_ADDED = "added.mdb.chips";
const $0abbbd36a260e067$var$EVENT_ARROW_DOWN = "arrowDown.mdb.chips";
const $0abbbd36a260e067$var$EVENT_ARROW_LEFT = "arrowLeft.mdb.chips";
const $0abbbd36a260e067$var$EVENT_ARROW_RIGHT = "arrowRight.mdb.chips";
const $0abbbd36a260e067$var$EVENT_ARROW_UP = "arrowUp.mdb.chips";
const $0abbbd36a260e067$var$EVENT_DELETE = "delete.mdb.chips";
const $0abbbd36a260e067$var$EVENT_SELECT = "select.mdb.chips";
const $0abbbd36a260e067$var$DefaultType$2 = {
    inputID: "string",
    parentSelector: "string",
    initialValues: "array",
    editable: "boolean",
    labelText: "string"
};
const $0abbbd36a260e067$var$Default$2 = {
    inputID: "",
    parentSelector: "",
    initialValues: [
        {
            tag: "init1"
        },
        {
            tag: "init2"
        }
    ],
    editable: false,
    labelText: "Example label"
};
class $0abbbd36a260e067$export$8d350cc6ca027c91 extends $0abbbd36a260e067$export$5a7f9a6004988d01 {
    constructor(element2, data = {}){
        super(element2, data);
        this._options = this._getConfig(data);
        this.numberClicks = 0;
        this._inputInstance = null;
        this.init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$2;
    }
    get activeChip() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_CHIP_ACTIVE, this._element);
    }
    get input() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne("input", this._element);
    }
    get allChips() {
        return $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_CHIP, this._element);
    }
    get chipsInputWrapper() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(`.${$0abbbd36a260e067$var$CLASSNAME_CHIPS_WRAPPER}`, this._element);
    }
    // Public
    init() {
        this._setChipsClass();
        this._appendInputToElement($0abbbd36a260e067$var$CLASSNAME_CHIPS_PLACEHOLDER);
        this._handleInitialValue();
        this._initializeInput();
        this._handleInputText();
        this._handleKeyboard();
        this._handleChipsOnSelect();
        this._handleEditable();
        this._handleChipsFocus();
        this._handleClicksOnChips();
    }
    dispose() {
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, "chips");
        this.allChips.forEach((chip)=>{
            const instance = $0abbbd36a260e067$export$5a7f9a6004988d01.getInstance(chip);
            if (instance) {
                chip.remove();
                $0abbbd36a260e067$var$EventHandler$1.off(chip, "dblclick");
                instance.dispose();
            }
        });
        if (this._inputInstance) this._inputInstance.dispose();
        this.chipsInputWrapper.remove();
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "click");
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "keypress");
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    // Private
    _initializeInput() {
        const formOutline = this._element.querySelector(".form-outline");
        this._inputInstance = new $0abbbd36a260e067$export$f5b8910cec6cf069(formOutline).init();
    }
    _setChipsClass() {
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, "chips");
    }
    _handleDeleteEvents(event) {
        const [last] = this.allChips.slice(-1);
        if (this.activeChip === null) {
            last.remove();
            this._handleEvents(event, $0abbbd36a260e067$var$EVENT_DELETE);
        } else {
            const index = this.allChips.findIndex((chip)=>chip === this.activeChip);
            const activeChipAfter = this._handleActiveChipAfterRemove(index);
            const arr = [];
            if (this.activeChip === null) return;
            this.activeChip.remove();
            this._handleEvents(event, $0abbbd36a260e067$var$EVENT_DELETE);
            this.numberClicks = index;
            $0abbbd36a260e067$var$Manipulator$1.addClass(activeChipAfter, $0abbbd36a260e067$var$CLASSNAME_ACTIVE);
            this.allChips.forEach((chip)=>{
                if ($0abbbd36a260e067$var$Manipulator$1.hasClass(chip, $0abbbd36a260e067$var$CLASSNAME_ACTIVE)) {
                    arr.push(chip);
                    if (arr.length > 1) this.allChips.forEach((chip2)=>chip2.remove());
                }
            });
        }
    }
    _handleUpEvents(event) {
        this.numberClicks += 1;
        if (this.numberClicks === this.allChips.length + 1) this.numberClicks = 0;
        this._handleRightKeyboardArrow(this.numberClicks);
        this._handleEvents(event, $0abbbd36a260e067$var$EVENT_ARROW_RIGHT);
        this._handleEvents(event, $0abbbd36a260e067$var$EVENT_ARROW_UP);
    }
    _handleDownEvents(event) {
        this.numberClicks -= 1;
        if (this.numberClicks <= 0) this.numberClicks = this.allChips.length;
        this._handleLeftKeyboardArrow(this.numberClicks);
        this._handleEvents(event, $0abbbd36a260e067$var$EVENT_ARROW_LEFT);
        this._handleEvents(event, $0abbbd36a260e067$var$EVENT_ARROW_DOWN);
    }
    _keyboardEvents(event) {
        const { target: target, keyCode: keyCode, ctrlKey: ctrlKey } = event;
        if (target.value.length > 0 || this.allChips.length === 0) return;
        if (keyCode === $0abbbd36a260e067$var$BACKSPACE || keyCode === $0abbbd36a260e067$var$DELETE) this._handleDeleteEvents(event);
        else if (keyCode === $0abbbd36a260e067$var$RIGHT_ARROW || keyCode === $0abbbd36a260e067$var$UP_ARROW) this._handleUpEvents(event);
        else if (keyCode === $0abbbd36a260e067$var$LEFT_ARROW || keyCode === $0abbbd36a260e067$var$DOWN_ARROW) this._handleDownEvents(event);
        else if (keyCode === 65 && ctrlKey) this._handleAddActiveClass();
    }
    _handleKeyboard() {
        $0abbbd36a260e067$var$EventHandler$1.on(this.input, "keydown", (event)=>this._keyboardEvents(event));
    }
    _handleEditable() {
        const { editable: editable } = this._options;
        if (!editable) return;
        this.allChips.forEach((chip)=>{
            $0abbbd36a260e067$var$EventHandler$1.on(chip, "dblclick", (e)=>{
                const close = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".close", chip);
                chip.contentEditable = true;
                chip.focus();
                setTimeout(()=>{
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(close, {
                        display: "none"
                    });
                }, 200);
                $0abbbd36a260e067$var$Manipulator$1.addClass(close, "close-opacity");
                e.target.textContent;
                $0abbbd36a260e067$var$EventHandler$1.trigger(chip, $0abbbd36a260e067$var$EVENT_SELECT, {
                    event: e,
                    allChips: this.allChips
                });
            });
            $0abbbd36a260e067$var$EventHandler$1.on(document, "click", ({ target: target })=>{
                const close = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".close", chip);
                const chipText = $0abbbd36a260e067$var$SelectorEngine$1.findOne(".text-chip", chip);
                const isContainer = target === chip;
                const isContainerContent = chip && chip.contains(target);
                if (!isContainer && !isContainerContent) {
                    chip.contentEditable = false;
                    if (chipText.textContent !== "") setTimeout(()=>{
                        $0abbbd36a260e067$var$Manipulator$1.addStyle(close, {
                            display: "block"
                        });
                        $0abbbd36a260e067$var$Manipulator$1.removeClass(close, "close-opacity");
                    }, 160);
                }
                if (chipText.textContent === "") {
                    setTimeout(()=>{
                        $0abbbd36a260e067$var$Manipulator$1.addClass(chip, $0abbbd36a260e067$var$CLASSNAME_CHIP_OPACITY);
                    }, 200);
                    setTimeout(()=>{
                        chip.remove();
                    }, 300);
                }
            });
        });
    }
    _handleRemoveActiveClass() {
        this.allChips.forEach((chip)=>$0abbbd36a260e067$var$Manipulator$1.removeClass(chip, $0abbbd36a260e067$var$CLASSNAME_ACTIVE));
    }
    _handleAddActiveClass() {
        this.allChips.forEach((chip)=>$0abbbd36a260e067$var$Manipulator$1.addClass(chip, $0abbbd36a260e067$var$CLASSNAME_ACTIVE));
    }
    _handleRightKeyboardArrow(num) {
        this._handleRemoveActiveClass();
        if (num === 0) num = 1;
        this._handleAddActiveClassWithKeyboard(num);
    }
    _handleLeftKeyboardArrow(num) {
        this._handleRemoveActiveClass();
        this._handleAddActiveClassWithKeyboard(num);
    }
    _handleActiveChipAfterRemove(index) {
        const chipIndex = index === 0 ? 1 : index - 1;
        return this.allChips[chipIndex];
    }
    _handleClicksOnChips() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "click", ()=>{
            if (this.allChips.length === 0) {
                $0abbbd36a260e067$var$Manipulator$1.removeClass(this.chipsInputWrapper, $0abbbd36a260e067$var$CLASSNAME_CHIPS_PADDING);
                $0abbbd36a260e067$var$Manipulator$1.removeClass(this.input, $0abbbd36a260e067$var$CLASSNAME_ACTIVE);
            }
        });
    }
    _handleTextContent() {
        const arr = [];
        this.allChips.forEach((chip)=>arr.push({
                tag: chip.textContent.trim()
            }));
        return arr;
    }
    _handleEvents(event, eventName) {
        const arr = this._handleTextContent();
        const filterActive = this.allChips.filter((chip)=>$0abbbd36a260e067$var$Manipulator$1.hasClass(chip, $0abbbd36a260e067$var$CLASSNAME_ACTIVE) && chip);
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, eventName, {
            event: event,
            allChips: this.allChips,
            arrOfObjects: arr,
            active: filterActive,
            activeObj: {
                tag: filterActive.length <= 0 ? "" : filterActive[0].textContent.trim()
            }
        });
    }
    _handleChipsFocus() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "click", ({ target: { classList: classList } })=>{
            if (classList.contains("chip") || classList.contains("close") || classList.contains("text-chip")) return;
            this.input.focus();
        });
    }
    _handleInitialValue() {
        this._appendInputToElement($0abbbd36a260e067$var$CLASSNAME_CHIPS_INITIAL);
        if ($0abbbd36a260e067$var$Manipulator$1.hasClass(this._element, $0abbbd36a260e067$var$CLASSNAME_CHIPS_INITIAL)) {
            const { initialValues: initialValues } = this._options;
            initialValues.forEach(({ tag: tag })=>this._handleCreateChip(this.input, tag));
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.input, $0abbbd36a260e067$var$CLASSNAME_ACTIVE);
        }
        if (this.allChips.length > 0) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.chipsInputWrapper, $0abbbd36a260e067$var$CLASSNAME_CHIPS_PADDING);
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.chipsInputWrapper, $0abbbd36a260e067$var$CLASSNAME_CHIPS_TANSITION);
        }
    }
    _handleKeysInputToElement(event) {
        const { keyCode: keyCode, target: target } = event;
        if ($0abbbd36a260e067$var$Manipulator$1.hasClass(target, "chip")) {
            const close = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_CLOSE, target);
            if (keyCode === $0abbbd36a260e067$var$ENTER) {
                target.contentEditable = false;
                if (target.textContent !== "") setTimeout(()=>{
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(close, {
                        display: "block"
                    });
                    $0abbbd36a260e067$var$Manipulator$1.removeClass(close, $0abbbd36a260e067$var$CLASSNAME_CLOSE_OPACITY);
                }, 160);
                else if (target.textContent === "") {
                    setTimeout(()=>{
                        $0abbbd36a260e067$var$Manipulator$1.addClass(target, $0abbbd36a260e067$var$CLASSNAME_CHIP_OPACITY);
                    }, 200);
                    setTimeout(()=>{
                        target.remove();
                    }, 300);
                }
            }
            return;
        }
        if (keyCode === $0abbbd36a260e067$var$ENTER) {
            if (target.value === "") return;
            event.preventDefault();
            this._handleCreateChip(target, target.value);
            this._handleRemoveActiveClass();
            this.numberClicks = this.allChips.length + 1;
        }
        if (this.allChips.length > 0) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.chipsInputWrapper, $0abbbd36a260e067$var$CLASSNAME_CHIPS_PADDING);
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.chipsInputWrapper, $0abbbd36a260e067$var$CLASSNAME_CHIPS_TANSITION);
        } else $0abbbd36a260e067$var$Manipulator$1.removeClass(this.chipsInputWrapper, $0abbbd36a260e067$var$CLASSNAME_CHIPS_PADDING);
    }
    _handleBlurInput(event) {
        const { target: target } = event;
        if (target.value.length > 0) this._handleCreateChip(target, target.value);
        if (this.allChips.length > 0) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(target, $0abbbd36a260e067$var$CLASSNAME_ACTIVE);
            $0abbbd36a260e067$var$Manipulator$1.addClass(this.chipsInputWrapper, $0abbbd36a260e067$var$CLASSNAME_CHIPS_PADDING);
        } else {
            $0abbbd36a260e067$var$Manipulator$1.removeClass(target, $0abbbd36a260e067$var$CLASSNAME_ACTIVE);
            $0abbbd36a260e067$var$Manipulator$1.removeClass(this.chipsInputWrapper, $0abbbd36a260e067$var$CLASSNAME_CHIPS_PADDING);
        }
        this.allChips.forEach((chip)=>$0abbbd36a260e067$var$Manipulator$1.removeClass(chip, $0abbbd36a260e067$var$CLASSNAME_ACTIVE));
    }
    _handleInputText() {
        const placeholder = $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$CLASSNAME_CHIPS_PLACEHOLDER, this._element);
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "keypress", placeholder, (e)=>this._handleKeysInputToElement(e));
        $0abbbd36a260e067$var$EventHandler$1.on(this.input, "blur", (e)=>this._handleBlurInput(e));
    }
    _appendInputToElement(selector) {
        if (!$0abbbd36a260e067$var$Manipulator$1.hasClass(this._element, selector)) return;
        const inputField = $0abbbd36a260e067$var$getInputField(this._options);
        this._element.insertAdjacentHTML("beforeend", inputField);
    }
    _handleCreateChip(target, value) {
        const addEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_ADD, {
            value: value
        });
        if (addEvent.defaultPrevented) return;
        const divElement = $0abbbd36a260e067$var$element("div");
        const divWithChips = new $0abbbd36a260e067$export$5a7f9a6004988d01(divElement, {
            text: value
        });
        let chipsContainer;
        if (this._options.parentSelector !== "") {
            const parent = document.querySelector(this._options.parentSelector);
            parent.insertAdjacentHTML("beforeend", divWithChips.appendChip());
            chipsContainer = parent;
        } else {
            target.insertAdjacentHTML("beforebegin", divWithChips.appendChip());
            chipsContainer = target.parentNode;
        }
        target.value = "";
        $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$SELECTOR_CHIP, chipsContainer).forEach((chip)=>{
            let instance = $0abbbd36a260e067$export$5a7f9a6004988d01.getInstance(chip);
            if (!instance) {
                instance = new $0abbbd36a260e067$export$5a7f9a6004988d01(chip);
                instance.init();
            }
        });
        this._handleEditable();
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_ADDED, {
            value: value
        });
    }
    _handleChipsOnSelect() {
        this.allChips.forEach((chip)=>{
            $0abbbd36a260e067$var$EventHandler$1.on(this._element, "click", (e)=>{
                $0abbbd36a260e067$var$EventHandler$1.trigger(chip, $0abbbd36a260e067$var$EVENT_SELECT, {
                    event: e,
                    allChips: this.allChips
                });
            });
        });
    }
    _handleAddActiveClassWithKeyboard(num) {
        let chip;
        if (this.allChips[num - 1] === void 0) chip = this.allChips[num - 2];
        else chip = this.allChips[num - 1];
        $0abbbd36a260e067$var$Manipulator$1.addClass(chip, $0abbbd36a260e067$var$CLASSNAME_ACTIVE);
    }
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$Default$2,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$2, config, $0abbbd36a260e067$var$DefaultType$2);
        return config;
    }
    static jQueryInterface(config) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$2);
            const _config = typeof config === "object" && config;
            if (!data && /dispose|hide/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$8d350cc6ca027c91(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
const $0abbbd36a260e067$var$getConnectsTemplate = ()=>{
    return `<div class="multi-range-slider-connects">
<div class="multi-range-slider-connect"></div>
</div>`;
};
const $0abbbd36a260e067$var$getHandleTemplate = ()=>{
    return `<div class="multi-range-slider-hand">
  <div class="multi-range-slider-handle"></div>
</div>`;
};
const $0abbbd36a260e067$var$getTooltipTemplate = (value)=>{
    return `
  <span class="multi-range-slider-tooltip">
    <span class="multi-range-slider-tooltip-value">${value}</span>
  </span>
  `;
};
const $0abbbd36a260e067$var$getEventTypeClientX = (ev)=>{
    const event = ev.type === "touchmove" ? ev.touches[0].clientX : ev.clientX;
    return event;
};
const $0abbbd36a260e067$var$NAME$1 = "multiRangeSlider";
const $0abbbd36a260e067$var$DATA_KEY$1 = `mdb.${$0abbbd36a260e067$var$NAME$1}`;
const $0abbbd36a260e067$var$SELECTOR_MULTI = "multi-range-slider";
const $0abbbd36a260e067$var$EVENT_KEY$1 = `.${$0abbbd36a260e067$var$DATA_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_VALUE_CHANGED$1 = `valueChanged${$0abbbd36a260e067$var$EVENT_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_START = `start${$0abbbd36a260e067$var$EVENT_KEY$1}`;
const $0abbbd36a260e067$var$EVENT_END = `end${$0abbbd36a260e067$var$EVENT_KEY$1}`;
const $0abbbd36a260e067$var$CLASSNAME_HAND = ".multi-range-slider-hand";
const $0abbbd36a260e067$var$CLASSNAME_CONNECT = ".multi-range-slider-connect";
const $0abbbd36a260e067$var$CLASSNAME_TOOLTIP = ".multi-range-slider-tooltip";
const $0abbbd36a260e067$var$CLASSNAME_TOOLTIP_VALUE = ".multi-range-slider-tooltip-value";
const $0abbbd36a260e067$var$SELECTOR_ACTIVE = "active";
const $0abbbd36a260e067$var$SELECTOR_HORIZONTAL = "multi-range-slider-horizontal";
const $0abbbd36a260e067$var$DefaultType$1 = {
    max: "number",
    min: "number",
    numberOfRanges: "number",
    startValues: "array",
    step: "(string||null||number)",
    tooltip: "boolean"
};
const $0abbbd36a260e067$var$Default$1 = {
    max: 100,
    min: 0,
    numberOfRanges: 2,
    startValues: [
        0,
        100
    ],
    step: null,
    tooltip: false
};
class $0abbbd36a260e067$export$8e9b6dbf9d49587f extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, data = {}){
        super(element2);
        this._options = this._getConfig(data);
        this._mousemove = false;
        this._movingHand = null;
        this.init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME$1;
    }
    get hands() {
        return $0abbbd36a260e067$var$SelectorEngine$1.find($0abbbd36a260e067$var$CLASSNAME_HAND, this._element);
    }
    get connect() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$CLASSNAME_CONNECT, this._element);
    }
    get leftConnectRect() {
        return this.connect.getBoundingClientRect().left;
    }
    get handsNoActive() {
        return this.hands.filter((hand)=>!$0abbbd36a260e067$var$Manipulator$1.hasClass(hand, "active"));
    }
    get handActive() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$CLASSNAME_HAND}.active`, this._element);
    }
    get activeTooltip() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$CLASSNAME_TOOLTIP, this._element);
    }
    get activeTooltipValue() {
        const handTooltip = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$CLASSNAME_HAND}.active`, this._element);
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$CLASSNAME_TOOLTIP_VALUE}`, handTooltip);
    }
    // Public
    init() {
        this._setClassHorizontalOrVertical();
        this._setRangeConnectsElement();
        this._setRangeHandleElements();
        this._setTransformationOnStart();
        this._setTooltipToHand();
        this._addEventListeners();
    }
    dispose() {
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        $0abbbd36a260e067$var$Manipulator$1.removeClass(this._element, $0abbbd36a260e067$var$SELECTOR_HORIZONTAL);
        this._removeEventListeners();
        this._removeSliderElements();
        super.dispose();
    }
    // Private
    _removeSliderElements() {
        this.hands.forEach((hand)=>{
            hand.remove();
        });
        this.connect.parentNode.remove();
    }
    _addEventListeners() {
        this._onWindowResize = this._handleWindowResize.bind(this);
        this._onConnectMousedown = this._handleClickOnRange.bind(this);
        this._onHandMouseDown = this._handleClickEventOnHand.bind(this);
        this._onDocumentMouseUp = this._handleEndMoveEventDocument.bind(this);
        $0abbbd36a260e067$var$EventHandlerMulti.on(this.connect, "mousedown touchstart", this._onConnectMousedown);
        $0abbbd36a260e067$var$EventHandlerMulti.on(document, "mouseup touchend", this._onDocumentMouseUp);
        this.hands.forEach((hand)=>{
            $0abbbd36a260e067$var$EventHandlerMulti.on(hand, "mousedown touchstart", this._onHandMouseDown);
        });
        $0abbbd36a260e067$var$EventHandler$1.on(window, "resize", this._onWindowResize);
    }
    _removeEventListeners() {
        $0abbbd36a260e067$var$EventHandlerMulti.off(this.connect, "mousedown touchstart", this._onConnectMousedown);
        $0abbbd36a260e067$var$EventHandlerMulti.off(document, "mouseup touchend", this._onDocumentMouseUp);
        this.hands.forEach((hand)=>{
            $0abbbd36a260e067$var$EventHandlerMulti.off(hand, "mousedown touchstart", this._onHandMouseDown);
        });
        $0abbbd36a260e067$var$EventHandler$1.off(window, "resize", this._onWindowResize);
    }
    _handleWindowResize() {
        this._setTransformationOnStart();
    }
    _setTransformationOnStart() {
        const { startValues: startValues, max: max2, min: min2 } = this._options;
        if (startValues.length === 0) this.hands.forEach((hand)=>{
            const translation = -hand.offsetWidth;
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(hand, "translation", Math.round(translation));
            $0abbbd36a260e067$var$Manipulator$1.addStyle(hand, {
                transform: `translate(${translation}px,-25%)`
            });
        });
        else this.hands.forEach((hand, i)=>{
            if (startValues[i] > max2 || startValues[i] < min2) return;
            const normalizedValue = (startValues[i] - min2) / (max2 - min2);
            const translation = normalizedValue * this.connect.offsetWidth - hand.offsetWidth / 2;
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(hand, "translation", Math.round(translation));
            $0abbbd36a260e067$var$Manipulator$1.addStyle(hand, {
                transform: `translate(${translation}px,-25%)`
            });
        });
    }
    _handleClickEventOnHand(ev) {
        const hand = ev.target.closest($0abbbd36a260e067$var$CLASSNAME_HAND);
        const { max: max2, min: min2 } = this._options;
        this._mousemove = true;
        const translation = $0abbbd36a260e067$var$getEventTypeClientX(ev) - this.leftConnectRect - hand.offsetWidth / 2;
        const value = ($0abbbd36a260e067$var$getEventTypeClientX(ev) - this.leftConnectRect) / (this.connect.offsetWidth / (max2 - min2)) % (max2 - min2);
        $0abbbd36a260e067$var$Manipulator$1.addStyle(hand, {
            transform: `translate(${translation}px,-25%)`
        });
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(hand, "translation", translation);
        $0abbbd36a260e067$var$Manipulator$1.addClass(hand, $0abbbd36a260e067$var$SELECTOR_ACTIVE);
        if (this._options.tooltip) {
            $0abbbd36a260e067$var$Manipulator$1.addClass(hand.children[1], "active");
            this.activeTooltipValue.innerText = Math.round(value);
        }
        this._movingHand = hand;
        this._onDocumentMouseMove = this._handleMouseMoveEventDocument.bind(this);
        this._onHandMouseUp = this._handleEndMoveEvent.bind(this);
        $0abbbd36a260e067$var$EventHandlerMulti.on(document, "mousemove touchmove", this._onDocumentMouseMove);
        $0abbbd36a260e067$var$EventHandlerMulti.on(hand, "mouseup touchend", this._onHandMouseUp);
        $0abbbd36a260e067$var$EventHandler$1.trigger(hand, $0abbbd36a260e067$var$EVENT_START, {
            hand: hand
        });
    }
    _setClassHorizontalOrVertical() {
        if (this._element) $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$SELECTOR_MULTI);
        $0abbbd36a260e067$var$Manipulator$1.addClass(this._element, $0abbbd36a260e067$var$SELECTOR_HORIZONTAL);
    }
    _setRangeConnectsElement() {
        this._element.insertAdjacentHTML("afterbegin", $0abbbd36a260e067$var$getConnectsTemplate());
    }
    _setRangeHandleElements() {
        for(let i = 0; i < this._options.numberOfRanges; i++)this._element.insertAdjacentHTML("beforeend", $0abbbd36a260e067$var$getHandleTemplate());
        this.hands.forEach((hand, i)=>{
            hand.setAttribute("aria-orientation", "horizontal");
            hand.setAttribute("role", "slider");
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(hand, "handle", i);
        });
    }
    _setTooltipToHand() {
        if (this._options.tooltip) this.hands.forEach((hand)=>{
            return hand.insertAdjacentHTML("beforeend", $0abbbd36a260e067$var$getTooltipTemplate());
        });
    }
    _handleMouseMoveEventDocument(ev) {
        const { tooltip: tooltip, step: step } = this._options;
        const hand = this._movingHand;
        if (ev.type === "mousemove") ev.preventDefault();
        const { max: max2, min: min2, numberOfRanges: numberOfRanges } = this._options;
        if ($0abbbd36a260e067$var$Manipulator$1.hasClass(hand, $0abbbd36a260e067$var$SELECTOR_ACTIVE)) {
            const maxValue = ($0abbbd36a260e067$var$getEventTypeClientX(ev) - this.leftConnectRect) / this.connect.offsetWidth * max2;
            let value = ($0abbbd36a260e067$var$getEventTypeClientX(ev) - this.leftConnectRect) / (this.connect.offsetWidth / (max2 - min2)) % (max2 - min2) + min2;
            let translation = $0abbbd36a260e067$var$getEventTypeClientX(ev) - this.leftConnectRect - hand.offsetWidth / 2;
            const handActiveHandle = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(this.handActive, "handle");
            const handActiveTranslation = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(this.handActive, "translation");
            if (value < min2) {
                translation = min2 - hand.offsetWidth / 2;
                value = min2;
            } else if (maxValue >= max2) return;
            const handleDataHandle = this.handsNoActive.map((hand2)=>$0abbbd36a260e067$var$Manipulator$1.getDataAttribute(hand2, "handle"));
            const handleDataTranslate = this.handsNoActive.map((hand2)=>$0abbbd36a260e067$var$Manipulator$1.getDataAttribute(hand2, "translation"));
            if (handActiveHandle < handleDataHandle && handActiveTranslation <= handleDataTranslate) {
                if (Math.round(value) % step === 0 && step !== null) {
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(hand, {
                        transform: `translate(${translation}px,-25%)`
                    });
                    if (tooltip) this.activeTooltipValue.innerText = Math.round(value);
                } else if (step === null) {
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(hand, {
                        transform: `translate(${translation}px,-25%)`
                    });
                    if (tooltip) this.activeTooltipValue.innerText = Math.round(value);
                }
            } else if (handActiveHandle > handleDataHandle && handActiveTranslation >= handleDataTranslate) {
                if (Math.round(value) % step === 0 && step !== null) {
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(hand, {
                        transform: `translate(${translation}px,-25%)`
                    });
                    if (tooltip) this.activeTooltipValue.innerText = Math.round(value);
                } else if (step === null) {
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(hand, {
                        transform: `translate(${translation}px,-25%)`
                    });
                    if (tooltip) this.activeTooltipValue.innerText = Math.round(value);
                }
            }
            if (numberOfRanges < 2) {
                if (Math.round(value) % step === 0 && step !== null) {
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(hand, {
                        transform: `translate(${translation}px,-25%)`
                    });
                    if (tooltip) this.activeTooltipValue.innerText = Math.round(value);
                } else if (step === null) {
                    $0abbbd36a260e067$var$Manipulator$1.addStyle(hand, {
                        transform: `translate(${translation}px,-25%)`
                    });
                    if (tooltip) this.activeTooltipValue.innerText = Math.round(value);
                }
            }
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(hand, "translation", translation);
            if (numberOfRanges < 2) $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED$1, {
                values: {
                    value: value + min2,
                    rounded: Math.round(value + min2)
                }
            });
            else this._handleMultiValuesOnRange();
        }
    }
    _handleMultiValuesOnRange() {
        const { max: max2, min: min2 } = this._options;
        const arr = [];
        this.hands.forEach((hand)=>{
            const translation = hand.getBoundingClientRect().left - this.leftConnectRect + hand.offsetWidth / 2;
            let value = translation / (this.connect.offsetWidth / (max2 - min2)) % (max2 - min2);
            if (translation === this.connect.offsetWidth) value = max2;
            else value += min2;
            $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(hand, "value", Math.round(value * 10) / 10);
            arr.push({
                value: value
            });
        });
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED$1, {
            values: {
                value: arr.map(({ value: value })=>value),
                rounded: arr.map(({ value: value })=>Math.round(value))
            }
        });
    }
    _handleEndMoveEventDocument() {
        const hand = this._movingHand;
        if (this._mousemove) {
            this.hands.forEach((hand2)=>{
                $0abbbd36a260e067$var$EventHandler$1.off(hand2, "mousemove");
                $0abbbd36a260e067$var$Manipulator$1.removeClass(hand2, $0abbbd36a260e067$var$SELECTOR_ACTIVE);
                if (this._options.tooltip) $0abbbd36a260e067$var$Manipulator$1.removeClass(hand2.children[1], "active");
            });
            this._mousemove = false;
        }
        $0abbbd36a260e067$var$EventHandler$1.trigger(hand, $0abbbd36a260e067$var$EVENT_END, {
            hand: hand
        });
        this._movingHand = null;
        $0abbbd36a260e067$var$EventHandlerMulti.off(document, "mousemove touchmove", this._onDocumentMouseMove);
    }
    _handleEndMoveEvent(ev) {
        const hand = ev.target.closest($0abbbd36a260e067$var$CLASSNAME_HAND);
        $0abbbd36a260e067$var$EventHandler$1.off(hand, "mousemove");
        $0abbbd36a260e067$var$Manipulator$1.removeClass(hand, $0abbbd36a260e067$var$SELECTOR_ACTIVE);
        if (this._options.tooltip) $0abbbd36a260e067$var$Manipulator$1.removeClass(hand.children[1], "active");
        this._mousemove = false;
    }
    _handleClickOnRange(ev) {
        this.hands.forEach((hand)=>{
            $0abbbd36a260e067$var$Manipulator$1.addClass(hand, $0abbbd36a260e067$var$SELECTOR_ACTIVE);
            this._mousemove = true;
            if (this._options.numberOfRanges < 2) $0abbbd36a260e067$var$Manipulator$1.addStyle(hand, {
                transform: `translate(${$0abbbd36a260e067$var$getEventTypeClientX(ev) - this.leftConnectRect - hand.offsetWidth / 2}px,-25%)`
            });
            else $0abbbd36a260e067$var$Manipulator$1.addStyle(this.hands[0], {
                transform: `translate(${$0abbbd36a260e067$var$getEventTypeClientX(ev) - this.leftConnectRect - hand.offsetWidth / 2}px,-25%)`
            });
        });
    }
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY$1);
            const _config = typeof config === "object" && config;
            if (!data && /dispose|hide/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$8e9b6dbf9d49587f(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
    _getConfig(options) {
        const config = {
            ...$0abbbd36a260e067$var$Default$1,
            ...$0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element),
            ...options
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME$1, config, $0abbbd36a260e067$var$DefaultType$1);
        return config;
    }
}
const $0abbbd36a260e067$var$isValidTime = (time)=>{
    const AmPmReg = /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/;
    const timeReg = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/;
    return time.match(AmPmReg) || time.match(timeReg);
};
const $0abbbd36a260e067$var$isValidDate = (date)=>{
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
};
const $0abbbd36a260e067$var$getMonth = (date)=>{
    return date.getMonth();
};
const $0abbbd36a260e067$var$getYear = (date)=>{
    return date.getFullYear();
};
const $0abbbd36a260e067$var$getDelimeters = (format)=>{
    return format.match(/[^(dmy)]{1,}/g);
};
const $0abbbd36a260e067$var$parseDate = (dateString, format, delimeters, options)=>{
    let delimeterPattern;
    if (delimeters[0] !== delimeters[1]) delimeterPattern = delimeters[0] + delimeters[1];
    else delimeterPattern = delimeters[0];
    const regExp = new RegExp(`[${delimeterPattern}]`);
    const dateParts = dateString.split(regExp);
    const formatParts = format.split(regExp);
    const isMonthString = format.indexOf("mmm") !== -1;
    const datesArray = [];
    for(let i = 0; i < formatParts.length; i++){
        if (formatParts[i].indexOf("yy") !== -1) datesArray[0] = {
            value: dateParts[i],
            format: formatParts[i]
        };
        if (formatParts[i].indexOf("m") !== -1) datesArray[1] = {
            value: dateParts[i],
            format: formatParts[i]
        };
        if (formatParts[i].indexOf("d") !== -1 && formatParts[i].length <= 2) datesArray[2] = {
            value: dateParts[i],
            format: formatParts[i]
        };
    }
    let monthsNames;
    if (format.indexOf("mmmm") !== -1) monthsNames = options.monthsFull;
    else monthsNames = options.monthsShort;
    const year = Number(datesArray[0].value);
    const month = isMonthString ? $0abbbd36a260e067$var$getMonthNumberByMonthName(datesArray[1].value, monthsNames) : Number(datesArray[1].value) - 1;
    const day = Number(datesArray[2].value);
    const parsedDate = $0abbbd36a260e067$var$createDate(year, month, day);
    return parsedDate;
};
const $0abbbd36a260e067$var$getMonthNumberByMonthName = (monthValue, monthLabels)=>{
    return monthLabels.findIndex((monthLabel)=>monthLabel === monthValue);
};
const $0abbbd36a260e067$var$ICON_BUTTONS = `
  <button type="button" class="datepicker-button-toggle"  data-mdb-toggle="datepicker">
    <i class="far fa-calendar datepicker-toggle-icon"></i>
  </button>
  <button type="button" class="timepicker-button-toggle" data-mdb-toggle="timepicker">
    <i class="far fa-clock fa-sm timepicker-icon"></i>
  </button>
`;
const $0abbbd36a260e067$var$TOGGLE_BUTTON = `
  <button type="button" class="datetimepicker-toggle-button" data-mdb-toggle="datetimepicker">
    <i class="far fa-calendar datepicker-toggle-icon"></i>
  </button>
`;
const $0abbbd36a260e067$var$NAME = "datetimepicker";
const $0abbbd36a260e067$var$DATA_KEY = `mdb.${$0abbbd36a260e067$var$NAME}`;
const $0abbbd36a260e067$var$CLASSNAME_DATEPICKER = "datepicker";
const $0abbbd36a260e067$var$CLASSNAME_TIMEPICKER = "timepicker";
const $0abbbd36a260e067$var$CLASSNAME_TOGGLE_BUTTON = `${$0abbbd36a260e067$var$NAME}-toggle-button`;
const $0abbbd36a260e067$var$SELECTOR_TIMEPICKER = `.${$0abbbd36a260e067$var$CLASSNAME_TIMEPICKER}`;
const $0abbbd36a260e067$var$SELECTOR_DATEPICKER = `.${$0abbbd36a260e067$var$CLASSNAME_DATEPICKER}`;
const $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE = `[data-mdb-toggle="${$0abbbd36a260e067$var$NAME}"]`;
const $0abbbd36a260e067$var$SELECTOR_TOGGLE_BUTTON = `.${$0abbbd36a260e067$var$CLASSNAME_TOGGLE_BUTTON}`;
const $0abbbd36a260e067$var$EVENT_KEY = `.${$0abbbd36a260e067$var$DATA_KEY}`;
const $0abbbd36a260e067$var$EVENT_OPEN = `open${$0abbbd36a260e067$var$EVENT_KEY}`;
const $0abbbd36a260e067$var$EVENT_CLOSE = `close${$0abbbd36a260e067$var$EVENT_KEY}`;
const $0abbbd36a260e067$var$EVENT_VALUE_CHANGED = `valueChanged${$0abbbd36a260e067$var$EVENT_KEY}`;
const $0abbbd36a260e067$var$EVENT_CLOSE_DATEPICKER = "close.mdb.datepicker";
const $0abbbd36a260e067$var$EVENT_VALUE_CHANGED_DATEPICKER = "valueChanged.mdb.datepicker";
const $0abbbd36a260e067$var$EVENT_VALUE_CHANGED_TIMEPICKER = "valueChanged.mdb.timepicker";
const $0abbbd36a260e067$var$BUTTONS_WRAPPER = $0abbbd36a260e067$var$element("div");
const $0abbbd36a260e067$var$Default = {
    inline: false,
    toggleButton: true,
    container: "body",
    disabled: false,
    disablePast: false,
    disableFuture: false,
    defaultTime: "",
    defaultDate: "",
    timepicker: {},
    datepicker: {},
    showFormat: false
};
const $0abbbd36a260e067$var$DefaultType = {
    inline: "boolean",
    toggleButton: "boolean",
    container: "string",
    disabled: "boolean",
    disablePast: "boolean",
    disableFuture: "boolean",
    defaultTime: "(string|date|number)",
    defaultDate: "(string|date|number)",
    timepicker: "object",
    datepicker: "object",
    showFormat: "boolean"
};
class $0abbbd36a260e067$export$54050e8fb4df7bd9 extends $0abbbd36a260e067$var$BaseComponent2 {
    constructor(element2, options){
        super(element2);
        this._input = $0abbbd36a260e067$var$SelectorEngine$1.findOne("input", this._element);
        this._options = this._getConfig(options);
        this._timepicker = null;
        this._datepicker = null;
        this._dateValue = this._options.defaultDate ? this._options.defaultDate : "";
        this._timeValue = this._options.defaultTime ? this._options.defaultTime : "";
        this._isInvalidTimeFormat = false;
        this._format = this._options.datepicker.format ? this._options.datepicker.format : "dd/mm/yyyy";
        this._cancel = false;
        this._scrollBar = new $0abbbd36a260e067$var$ScrollBarHelper();
        this._init();
        $0abbbd36a260e067$var$Manipulator$1.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
        $0abbbd36a260e067$var$bindCallbackEventsIfNeeded(this.constructor);
    }
    // Getters
    static get NAME() {
        return $0abbbd36a260e067$var$NAME;
    }
    get toggleButton() {
        return $0abbbd36a260e067$var$SelectorEngine$1.findOne($0abbbd36a260e067$var$SELECTOR_TOGGLE_BUTTON, this._element);
    }
    dispose() {
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "click", this._openDatePicker);
        $0abbbd36a260e067$var$EventHandler$1.off(this._input, "input", this._handleInput);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "click");
        this._removeTimePicker();
        this._removeDatepicker();
        const toggleButton = this.toggleButton;
        if (toggleButton) this.toggleButton.remove();
        $0abbbd36a260e067$var$Manipulator$1.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    update(options = {}) {
        const tempOptions = this._getConfig({
            ...this._options,
            ...options
        });
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "click", this._openDatePicker);
        $0abbbd36a260e067$var$EventHandler$1.off(this._input, "input", this._handleInput);
        $0abbbd36a260e067$var$EventHandler$1.off(this._element, "click");
        this._removeTimePicker();
        this._removeDatepicker();
        const toggleButton = this.toggleButton;
        if (toggleButton) this.toggleButton.remove();
        this._options = $0abbbd36a260e067$var$Default;
        this._timepicker = null;
        this._datepicker = null;
        this._dateValue = null;
        this._timeValue = null;
        this._isInvalidTimeFormat = null;
        this._options = tempOptions;
        this._init();
    }
    // Private
    _init() {
        this._addDatepicker();
        this._addTimePicker();
        this._appendToggleButton();
        this._listenToToggleClick();
        this._listenToUserInput();
        this._disableInput();
        this._setInitialDefaultInput();
        this._applyFormatPlaceholder();
        if (this._options.disablePast) this._handleTimepickerDisablePast();
        if (this._options.disableFuture) this._handleTimepickerDisableFuture();
        if (this._input.value) this._handleInput(this._input.value);
    }
    _removeDatepicker() {
        const datepicker = this._element.querySelector(".datepicker");
        if (datepicker) datepicker.remove();
    }
    _addDatepicker() {
        const DATEPICKER_WRAPPER = $0abbbd36a260e067$var$element("div");
        DATEPICKER_WRAPPER.id = this._element.id ? `datepicker-${this._element.id}` : $0abbbd36a260e067$var$getUID$1("datepicker-");
        const DATEPICKER_INPUT = '<input type="text" class="form-control">';
        DATEPICKER_WRAPPER.innerHTML = DATEPICKER_INPUT;
        $0abbbd36a260e067$var$Manipulator$1.addClass(DATEPICKER_WRAPPER, $0abbbd36a260e067$var$CLASSNAME_DATEPICKER);
        this._element.appendChild(DATEPICKER_WRAPPER);
        $0abbbd36a260e067$var$Manipulator$1.style(DATEPICKER_WRAPPER, {
            display: "none"
        });
        let datepickerOptions = {
            ...this._options.datepicker,
            container: this._options.container,
            disablePast: this._options.disablePast,
            disableFuture: this._options.disableFuture
        };
        if (this._options.inline || this._options.datepicker.inline) datepickerOptions = {
            ...datepickerOptions,
            inline: true
        };
        this._datepicker = new $0abbbd36a260e067$export$7235422eca03ec90(DATEPICKER_WRAPPER, datepickerOptions);
        this._datepicker._input.value = this._dateValue;
    }
    _removeTimePicker() {
        const timepicker = this._element.querySelector(".timepicker");
        if (timepicker) {
            timepicker.remove();
            this._scrollBar.reset();
        }
    }
    _addTimePicker() {
        const TIMEPICKER_WRAPPER = $0abbbd36a260e067$var$element("div");
        TIMEPICKER_WRAPPER.id = this._element.id ? `timepicker-${this._element.id}` : $0abbbd36a260e067$var$getUID$1("timepicker-");
        const TIMEPICKER_INPUT = '<input type="text" class="form-control">';
        TIMEPICKER_WRAPPER.innerHTML = TIMEPICKER_INPUT;
        $0abbbd36a260e067$var$Manipulator$1.addClass(TIMEPICKER_WRAPPER, $0abbbd36a260e067$var$CLASSNAME_TIMEPICKER);
        this._element.appendChild(TIMEPICKER_WRAPPER);
        $0abbbd36a260e067$var$Manipulator$1.style(TIMEPICKER_WRAPPER, {
            display: "none"
        });
        let timepickerOptions = {
            ...this._options.timepicker,
            container: this._options.container
        };
        if (this._options.inline || this._options.timepicker.inline) timepickerOptions = {
            ...timepickerOptions,
            inline: true
        };
        this._timepicker = new $0abbbd36a260e067$export$8497164ca5dbf597(TIMEPICKER_WRAPPER, timepickerOptions);
        this._timepicker._input.value = this._timeValue;
    }
    _addIconButtons() {
        $0abbbd36a260e067$var$Manipulator$1.addClass($0abbbd36a260e067$var$BUTTONS_WRAPPER, "buttons-container");
        $0abbbd36a260e067$var$BUTTONS_WRAPPER.innerHTML = $0abbbd36a260e067$var$ICON_BUTTONS;
        if (this._options.inline || this._options.datepicker.inline) return;
        this._scrollBar.hide();
        if (this._datepicker._isOpen) {
            const headerDate = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$SELECTOR_DATEPICKER}-header`, document.body);
            headerDate.appendChild($0abbbd36a260e067$var$BUTTONS_WRAPPER);
        } else if (this._timepicker._modal && !this._options.timepicker.inline) {
            const header = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$SELECTOR_TIMEPICKER}-elements`, document.body);
            const headerTime = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$SELECTOR_TIMEPICKER}-clock-wrapper`, document.body);
            header.insertBefore($0abbbd36a260e067$var$BUTTONS_WRAPPER, headerTime);
        }
    }
    _enableOrDisableToggleButton() {
        if (this._options.disabled) {
            this.toggleButton.disabled = true;
            this.toggleButton.style.pointerEvents = "none";
        } else {
            this.toggleButton.disabled = false;
            this.toggleButton.style.pointerEvents = "pointer";
        }
    }
    _appendToggleButton() {
        if (!this._options.toggleButton) return;
        this._element.insertAdjacentHTML("beforeend", $0abbbd36a260e067$var$TOGGLE_BUTTON);
        this._enableOrDisableToggleButton();
    }
    _applyFormatPlaceholder() {
        if (this._options.showFormat) this._input.placeholder = this._format;
    }
    _listenToCancelClick() {
        const DATEPICKER_CANCEL_BTN = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$SELECTOR_DATEPICKER}-cancel-btn`, document.body);
        $0abbbd36a260e067$var$EventHandler$1.one(DATEPICKER_CANCEL_BTN, "mousedown", ()=>{
            this._cancel = true;
            this._scrollBar.reset();
            $0abbbd36a260e067$var$EventHandler$1.off(DATEPICKER_CANCEL_BTN, "mousedown");
        });
    }
    _listenToToggleClick() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._element, "click", $0abbbd36a260e067$var$SELECTOR_DATA_TOGGLE, (event)=>{
            event.preventDefault();
            this._openDatePicker();
        });
    }
    _listenToUserInput() {
        $0abbbd36a260e067$var$EventHandler$1.on(this._input, "input", (event)=>{
            this._handleInput(event.target.value);
        });
    }
    _disableInput() {
        if (this._options.disabled) this._input.disabled = "true";
    }
    _getConfig(config) {
        const dataAttributes = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(this._element);
        config = {
            ...$0abbbd36a260e067$var$Default,
            ...dataAttributes,
            ...config
        };
        $0abbbd36a260e067$var$typeCheckConfig($0abbbd36a260e067$var$NAME, config, $0abbbd36a260e067$var$DefaultType);
        return config;
    }
    _handleInput(input) {
        const dateTimeSplited = input.split(", ");
        const dateDelimeters = $0abbbd36a260e067$var$getDelimeters(this._format);
        const inputFirstValue = dateTimeSplited[0];
        const inputSecondValue = dateTimeSplited[1] || "";
        const date = $0abbbd36a260e067$var$parseDate(inputFirstValue, this._format, dateDelimeters, this._datepicker._options);
        if (dateTimeSplited.length === 2) {
            const isInputValid = $0abbbd36a260e067$var$isValidDate(date) && $0abbbd36a260e067$var$isValidTime(inputSecondValue);
            if (isInputValid) {
                this._dateValue = inputFirstValue;
                this._timeValue = inputSecondValue;
                this._datepicker._input.value = this._dateValue;
                this._datepicker._activeDate = this._dateValue;
                this._datepicker._selectedYear = $0abbbd36a260e067$var$getYear(date);
                this._datepicker._selectedMonth = $0abbbd36a260e067$var$getMonth(date);
                this._datepicker._headerDate = date;
                this._timepicker._input.value = this._timeValue;
                this._timepicker._isInvalidTimeFormat = false;
            } else {
                this._datepicker._activeDate = /* @__PURE__ */ new Date();
                this._datepicker._selectedDate = null;
                this._datepicker._selectedMonth = null;
                this._datepicker._selectedYear = null;
                this._datepicker._headerDate = null;
                this._datepicker._headerMonth = null;
                this._datepicker._headerYear = null;
                this._timepicker._isInvalidTimeFormat = true;
            }
        }
    }
    _openDatePicker() {
        const openEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_OPEN);
        if (openEvent.defaultPrevented) return;
        this._datepicker.open();
        if (!this._options.inline) this._scrollBar.hide();
        if (this._options.inline || this._options.datepicker.inline) this._openDropdownDate();
        this._addIconButtons();
        this._listenToCancelClick();
        if (this._options.inline && this._datepicker._isOpen) this.toggleButton.style.pointerEvents = "none";
        $0abbbd36a260e067$var$EventHandler$1.one(this._datepicker._element, $0abbbd36a260e067$var$EVENT_CLOSE_DATEPICKER, ()=>{
            this._dateValue = this._datepicker._input.value;
            this._updateInputValue();
            if (this._cancel) {
                this._cancel = false;
                return;
            }
            $0abbbd36a260e067$var$EventHandler$1.on(this._datepicker.container, "click", (e)=>{
                if (!this._datepicker._selectedDate && e.target.classList.contains("datepicker-ok-btn")) return;
                this._openTimePicker();
            });
            setTimeout(()=>{
                const timepicker = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$SELECTOR_TIMEPICKER}-wrapper`, document.body);
                if (!timepicker) this._scrollBar.reset();
            }, 10);
            if (this._options.inline) this.toggleButton.style.pointerEvents = "auto";
        });
        const CLOCK_BTN = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$SELECTOR_TIMEPICKER}-button-toggle`, document.body);
        $0abbbd36a260e067$var$EventHandler$1.on(CLOCK_BTN, "click", ()=>{
            this._datepicker._confirmSelection(this._datepicker._headerDate);
            this._datepicker.close();
            this._scrollBar.hide();
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._datepicker._element, $0abbbd36a260e067$var$EVENT_CLOSE_DATEPICKER);
        });
    }
    _handleTimepickerDisablePast() {
        const currentDate = /* @__PURE__ */ new Date();
        currentDate.setHours(0, 0, 0, 0);
        $0abbbd36a260e067$var$EventHandler$1.on(this._datepicker._element, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED_DATEPICKER, ()=>{
            if (this._datepicker._selectedDate.getTime() === currentDate.getTime()) this._timepicker.update({
                disablePast: true
            });
            else this._timepicker.update({
                disablePast: false
            });
        });
    }
    _handleTimepickerDisableFuture() {
        const currentDate = /* @__PURE__ */ new Date();
        currentDate.setHours(0, 0, 0, 0);
        $0abbbd36a260e067$var$EventHandler$1.on(this._datepicker._element, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED_DATEPICKER, ()=>{
            if (this._datepicker._selectedDate.getTime() === currentDate.getTime()) this._timepicker.update({
                disableFuture: true
            });
            else this._timepicker.update({
                disableFuture: false
            });
        });
    }
    _openDropdownDate() {
        const datePopper = this._datepicker._popper;
        datePopper.state.elements.reference = this._input;
        this._scrollBar.reset();
    }
    _openTimePicker() {
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._timepicker.toggleButton, "click");
        setTimeout(()=>{
            this._addIconButtons();
            if (this._options.inline || this._options.timepicker.inline) this._openDropdownTime();
            if (this._timepicker._modal) {
                const CANCEL_BTN = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`${$0abbbd36a260e067$var$SELECTOR_TIMEPICKER}-cancel`, document.body);
                $0abbbd36a260e067$var$EventHandler$1.on(this._timepicker._modal, "click", (e)=>{
                    if (e.target.classList.contains(`${$0abbbd36a260e067$var$CLASSNAME_TIMEPICKER}-wrapper`) || e.target.classList.contains(`${$0abbbd36a260e067$var$CLASSNAME_TIMEPICKER}-submit`)) setTimeout(()=>{
                        this._scrollBar.reset();
                    }, 200);
                    if (e.target.classList.contains(`${$0abbbd36a260e067$var$CLASSNAME_TIMEPICKER}-clear`)) $0abbbd36a260e067$var$EventHandler$1.trigger(this._timepicker._element, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED_TIMEPICKER);
                    if (e.target.classList.contains(`${$0abbbd36a260e067$var$CLASSNAME_DATEPICKER}-button-toggle`)) {
                        $0abbbd36a260e067$var$EventHandler$1.trigger(CANCEL_BTN, "click");
                        setTimeout(()=>{
                            this._openDatePicker();
                            this._scrollBar.hide();
                        }, 200);
                    }
                });
            }
        });
        $0abbbd36a260e067$var$EventHandler$1.one(this._timepicker._element, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED_TIMEPICKER, ()=>{
            this._timeValue = this._timepicker._input.value;
            this._updateInputValue();
            $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_CLOSE);
        });
    }
    _openDropdownTime() {
        const timePopper = this._timepicker._popper;
        timePopper.state.elements.reference = this._input;
        timePopper.update();
        this._scrollBar.reset();
    }
    _setInitialDefaultInput() {
        const shouldUpdate = this._options.defaultDate || this._options.defaultTime;
        if (shouldUpdate) this._updateInputValue();
    }
    _updateInputValue() {
        const isDateTimeFilled = this._timeValue && this._dateValue;
        if (isDateTimeFilled) {
            this._input.value = `${this._dateValue}, ${this._timeValue}`;
            const changeEvent = $0abbbd36a260e067$var$EventHandler$1.trigger(this._element, $0abbbd36a260e067$var$EVENT_VALUE_CHANGED, {
                value: this._input.value
            });
            if (changeEvent.defaultPrevented) return;
        }
        $0abbbd36a260e067$var$EventHandler$1.trigger(this._input, "focus");
    }
    // static
    static jQueryInterface(config, options) {
        return this.each(function() {
            let data = $0abbbd36a260e067$var$Data$1.getData(this, $0abbbd36a260e067$var$DATA_KEY);
            const _config = typeof config === "object" && config;
            if (!data && /dispose/.test(config)) return;
            if (!data) data = new $0abbbd36a260e067$export$54050e8fb4df7bd9(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](options);
            }
        });
    }
}
const $0abbbd36a260e067$var$callbackInitState$1 = /* @__PURE__ */ new Map();
const $0abbbd36a260e067$var$alertCallback$1 = (component, initSelector)=>{
    const Alert3 = component;
    if (!$0abbbd36a260e067$var$callbackInitState$1.has(component.name)) {
        $0abbbd36a260e067$var$enableDismissTrigger(Alert3);
        $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
    }
    $0abbbd36a260e067$var$SelectorEngine$1.find(initSelector).forEach((element2)=>{
        return Alert3.getOrCreateInstance(element2);
    });
};
const $0abbbd36a260e067$var$buttonCallback = (component, initSelector)=>{
    const Button3 = component;
    const EVENT_CLICK_DATA_API2 = `click.bs.${component.name}.data-api`;
    if (!$0abbbd36a260e067$var$callbackInitState$1.has(component.name)) {
        $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API2, initSelector, (event)=>{
            event.preventDefault();
            const button = event.target.closest(initSelector);
            const data = Button3.getOrCreateInstance(button);
            data.toggle();
        });
        $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
    }
    $0abbbd36a260e067$var$SelectorEngine$1.find(initSelector).forEach((element2)=>{
        return Button3.getOrCreateInstance(element2);
    });
};
const $0abbbd36a260e067$var$carouselCallback = (component, initSelector)=>{
    if ($0abbbd36a260e067$var$callbackInitState$1.has(component.name)) return;
    const EVENT_CLICK_DATA_API2 = `click.bs.${component.name}.data-api`;
    const SELECTOR_DATA_SLIDE = "[data-mdb-slide], [data-mdb-slide-to]";
    const CLASS_NAME_CAROUSEL2 = "carousel";
    const Carousel3 = component;
    const EVENT_LOAD_DATA_API = `load.bs.${component.name}.data-api`;
    const SELECTOR_DATA_RIDE = initSelector;
    $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API2, SELECTOR_DATA_SLIDE, function(event) {
        const target = $0abbbd36a260e067$var$getElementFromSelector(this);
        if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL2)) return;
        event.preventDefault();
        const carousel = Carousel3.getOrCreateInstance(target);
        const slideIndex = this.getAttribute("data-mdb-slide-to");
        if (slideIndex) {
            carousel.to(slideIndex);
            carousel._maybeEnableCycle();
            return;
        }
        if ($0abbbd36a260e067$var$Manipulator$1.getDataAttribute(this, "slide") === "next") {
            carousel.next();
            carousel._maybeEnableCycle();
            return;
        }
        carousel.prev();
        carousel._maybeEnableCycle();
    });
    $0abbbd36a260e067$var$EventHandler$1.on(window, EVENT_LOAD_DATA_API, ()=>{
        const carousels = $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_DATA_RIDE);
        carousels.forEach((carousel)=>{
            Carousel3.getOrCreateInstance(carousel);
        });
    });
    $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
};
const $0abbbd36a260e067$var$collapseCallback = (component, initSelector)=>{
    const EVENT_CLICK_DATA_API2 = `click.bs.${component.name}.data-api`;
    const SELECTOR_DATA_TOGGLE2 = initSelector;
    const Collapse3 = component;
    if (!$0abbbd36a260e067$var$callbackInitState$1.has(component.name)) {
        $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API2, SELECTOR_DATA_TOGGLE2, function(event) {
            if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
            const selector = $0abbbd36a260e067$var$getSelectorFromElement(this);
            const selectorElements = $0abbbd36a260e067$var$SelectorEngine$1.find(selector);
            selectorElements.forEach((element2)=>{
                Collapse3.getOrCreateInstance(element2, {
                    toggle: false
                }).toggle();
            });
        });
        $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
    }
    $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_DATA_TOGGLE2).forEach((el)=>{
        const selector = $0abbbd36a260e067$var$getSelectorFromElement(el);
        const selectorElements = $0abbbd36a260e067$var$SelectorEngine$1.find(selector);
        selectorElements.forEach((element2)=>{
            Collapse3.getOrCreateInstance(element2, {
                toggle: false
            });
        });
    });
};
const $0abbbd36a260e067$var$dropdownCallback = (component, initSelector)=>{
    const EVENT_CLICK_DATA_API2 = `click.bs.${component.name}.data-api`;
    const EVENT_KEYDOWN_DATA_API2 = `keydown.bs.${component.name}.data-api`;
    const EVENT_KEYUP_DATA_API = `keyup.bs.${component.name}.data-api`;
    const SELECTOR_MENU2 = ".dropdown-menu";
    const SELECTOR_DATA_TOGGLE2 = `[data-mdb-${component.NAME}-initialized]`;
    const Dropdown3 = component;
    if (!$0abbbd36a260e067$var$callbackInitState$1.has(component.name)) {
        $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_KEYDOWN_DATA_API2, SELECTOR_DATA_TOGGLE2, Dropdown3.dataApiKeydownHandler);
        $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_KEYDOWN_DATA_API2, SELECTOR_MENU2, Dropdown3.dataApiKeydownHandler);
        $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API2, Dropdown3.clearMenus);
        $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_KEYUP_DATA_API, Dropdown3.clearMenus);
        $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API2, SELECTOR_DATA_TOGGLE2, function(event) {
            event.preventDefault();
            Dropdown3.getOrCreateInstance(this).toggle();
        });
    }
    $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
    $0abbbd36a260e067$var$SelectorEngine$1.find(initSelector).forEach((el)=>{
        Dropdown3.getOrCreateInstance(el);
    });
};
const $0abbbd36a260e067$var$inputCallback = (component, initSelector)=>{
    const SELECTOR_DATA_INIT = initSelector;
    const SELECTOR_OUTLINE_INPUT = `${SELECTOR_DATA_INIT} input`;
    const SELECTOR_OUTLINE_TEXTAREA = `${SELECTOR_DATA_INIT} textarea`;
    const Input2 = component;
    if (!$0abbbd36a260e067$var$callbackInitState$1.has(component.name)) {
        $0abbbd36a260e067$var$EventHandler$1.on(document, "focus", SELECTOR_OUTLINE_INPUT, Input2.activate(new Input2()));
        $0abbbd36a260e067$var$EventHandler$1.on(document, "input", SELECTOR_OUTLINE_INPUT, Input2.activate(new Input2()));
        $0abbbd36a260e067$var$EventHandler$1.on(document, "blur", SELECTOR_OUTLINE_INPUT, Input2.deactivate(new Input2()));
        $0abbbd36a260e067$var$EventHandler$1.on(document, "focus", SELECTOR_OUTLINE_TEXTAREA, Input2.activate(new Input2()));
        $0abbbd36a260e067$var$EventHandler$1.on(document, "input", SELECTOR_OUTLINE_TEXTAREA, Input2.activate(new Input2()));
        $0abbbd36a260e067$var$EventHandler$1.on(document, "blur", SELECTOR_OUTLINE_TEXTAREA, Input2.deactivate(new Input2()));
        $0abbbd36a260e067$var$EventHandler$1.on(window, "shown.bs.modal", (e)=>{
            $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_OUTLINE_INPUT, e.target).forEach((element2)=>{
                const instance = Input2.getInstance(element2.parentNode);
                if (!instance) return;
                instance.update();
            });
            $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_OUTLINE_TEXTAREA, e.target).forEach((element2)=>{
                const instance = Input2.getInstance(element2.parentNode);
                if (!instance) return;
                instance.update();
            });
        });
        $0abbbd36a260e067$var$EventHandler$1.on(window, "shown.bs.dropdown", (e)=>{
            const target = e.target.parentNode.querySelector(".dropdown-menu");
            if (target) {
                $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_OUTLINE_INPUT, target).forEach((element2)=>{
                    const instance = Input2.getInstance(element2.parentNode);
                    if (!instance) return;
                    instance.update();
                });
                $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_OUTLINE_TEXTAREA, target).forEach((element2)=>{
                    const instance = Input2.getInstance(element2.parentNode);
                    if (!instance) return;
                    instance.update();
                });
            }
        });
        $0abbbd36a260e067$var$EventHandler$1.on(window, "shown.bs.tab", (e)=>{
            let targetId;
            if (e.target.href) targetId = e.target.href.split("#")[1];
            else targetId = $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(e.target, "target").split("#")[1];
            const target = $0abbbd36a260e067$var$SelectorEngine$1.findOne(`#${targetId}`);
            $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_OUTLINE_INPUT, target).forEach((element2)=>{
                const instance = Input2.getInstance(element2.parentNode);
                if (!instance) return;
                instance.update();
            });
            $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_OUTLINE_TEXTAREA, target).forEach((element2)=>{
                const instance = Input2.getInstance(element2.parentNode);
                if (!instance) return;
                instance.update();
            });
        });
        $0abbbd36a260e067$var$EventHandler$1.on(window, "reset", (e)=>{
            $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_OUTLINE_INPUT, e.target).forEach((element2)=>{
                const instance = Input2.getInstance(element2.parentNode);
                if (!instance) return;
                instance.forceInactive();
            });
            $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_OUTLINE_TEXTAREA, e.target).forEach((element2)=>{
                const instance = Input2.getInstance(element2.parentNode);
                if (!instance) return;
                instance.forceInactive();
            });
        });
        $0abbbd36a260e067$var$EventHandler$1.on(window, "onautocomplete", (e)=>{
            const instance = Input2.getInstance(e.target.parentNode);
            if (!instance || !e.cancelable) return;
            instance.forceActive();
        });
        $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
    }
    $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_DATA_INIT).map((element2)=>Input2.getOrCreateInstance(element2));
};
const $0abbbd36a260e067$var$modalCallback$1 = (component, initSelector)=>{
    const EVENT_CLICK_DATA_API2 = `click.bs.${component.name}.data-api`;
    const OPEN_SELECTOR = ".modal.show";
    const Modal3 = component;
    const EVENT_SHOW2 = `show.bs.${component.name}`;
    const EVENT_HIDDEN2 = `hidden.bs.${component.name}`;
    if (!$0abbbd36a260e067$var$callbackInitState$1.has(component.name)) {
        $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API2, initSelector, function(event) {
            const target = $0abbbd36a260e067$var$getElementFromSelector(this);
            if ([
                "A",
                "AREA"
            ].includes(this.tagName)) event.preventDefault();
            $0abbbd36a260e067$var$EventHandler$1.one(target, EVENT_SHOW2, (showEvent)=>{
                if (showEvent.defaultPrevented) return;
                $0abbbd36a260e067$var$EventHandler$1.one(target, EVENT_HIDDEN2, ()=>{
                    if ($0abbbd36a260e067$var$isVisible$1(this)) this.focus();
                });
            });
            const alreadyOpenedModals = $0abbbd36a260e067$var$SelectorEngine$1.find(OPEN_SELECTOR);
            alreadyOpenedModals.forEach((modal)=>{
                if (!modal.classList.contains("modal-non-invasive-show")) Modal3.getInstance(modal).hide();
            });
            const data = Modal3.getOrCreateInstance(target);
            data.toggle(this);
        });
        $0abbbd36a260e067$var$enableDismissTrigger(Modal3);
        $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
    }
    $0abbbd36a260e067$var$SelectorEngine$1.find(initSelector).forEach((el)=>{
        const selector = $0abbbd36a260e067$var$getSelectorFromElement(el);
        const selectorElement = $0abbbd36a260e067$var$SelectorEngine$1.findOne(selector);
        Modal3.getOrCreateInstance(selectorElement);
    });
};
const $0abbbd36a260e067$var$offcanvasCallback = (component, initSelector)=>{
    if ($0abbbd36a260e067$var$callbackInitState$1.has(component.name)) return;
    const EVENT_CLICK_DATA_API2 = `click.bs.${component.name}.data-api`;
    const OPEN_SELECTOR = ".offcanvas.show";
    const Offcanvas2 = component;
    const EVENT_HIDDEN2 = `hidden.bs.${component.name}`;
    const EVENT_LOAD_DATA_API = `load.bs.${component.name}.data-api`;
    const EVENT_RESIZE2 = `resize.bs.${component.name}`;
    $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API2, initSelector, function(event) {
        const target = $0abbbd36a260e067$var$getElementFromSelector(this);
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($0abbbd36a260e067$var$isDisabled$1(this)) return;
        $0abbbd36a260e067$var$EventHandler$1.one(target, EVENT_HIDDEN2, ()=>{
            if ($0abbbd36a260e067$var$isVisible$1(this)) this.focus();
        });
        const alreadyOpen = $0abbbd36a260e067$var$SelectorEngine$1.findOne(OPEN_SELECTOR);
        if (alreadyOpen && alreadyOpen !== target) Offcanvas2.getInstance(alreadyOpen).hide();
        const data = Offcanvas2.getOrCreateInstance(target);
        data.toggle(this);
    });
    $0abbbd36a260e067$var$EventHandler$1.on(window, EVENT_LOAD_DATA_API, ()=>{
        $0abbbd36a260e067$var$SelectorEngine$1.find(OPEN_SELECTOR).forEach((selector)=>{
            Offcanvas2.getOrCreateInstance(selector).show();
        });
    });
    $0abbbd36a260e067$var$EventHandler$1.on(window, EVENT_RESIZE2, ()=>{
        $0abbbd36a260e067$var$SelectorEngine$1.find("[aria-modal][class*=show][class*=offcanvas-]").forEach((element2)=>{
            if (getComputedStyle(element2).position !== "fixed") Offcanvas2.getOrCreateInstance(element2).hide();
        });
    });
    $0abbbd36a260e067$var$enableDismissTrigger(Offcanvas2);
    $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
};
const $0abbbd36a260e067$var$scrollspyCallback = (component, initSelector)=>{
    if ($0abbbd36a260e067$var$callbackInitState$1.has(component.name)) return;
    const EVENT_LOAD_DATA_API = `load.bs.${component.name}.data-api`;
    const ScrollSpy3 = component;
    $0abbbd36a260e067$var$EventHandler$1.on(window, EVENT_LOAD_DATA_API, ()=>{
        $0abbbd36a260e067$var$SelectorEngine$1.find(initSelector).forEach((el)=>{
            ScrollSpy3.getOrCreateInstance(el);
        });
    });
    $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
};
const $0abbbd36a260e067$var$tabCallback = (component, initSelector)=>{
    const EVENT_LOAD_DATA_API = `load.bs.${component.name}.data-api`;
    const EVENT_CLICK_DATA_API2 = `click.bs.${component.name}.data-api`;
    const CLASS_NAME_ACTIVE2 = "active";
    const SELECTOR_DATA_TOGGLE_ACTIVE = `.${CLASS_NAME_ACTIVE2}[data-mdb-tab-init], .${CLASS_NAME_ACTIVE2}[data-mdb-pill-init], .${CLASS_NAME_ACTIVE2}[data-mdb-toggle="list"]`;
    const Tab3 = component;
    if (!$0abbbd36a260e067$var$callbackInitState$1.has(component.name)) {
        $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API2, initSelector, function(event) {
            if ([
                "A",
                "AREA"
            ].includes(this.tagName)) event.preventDefault();
            if ($0abbbd36a260e067$var$isDisabled$1(this)) return;
            Tab3.getOrCreateInstance(this).show();
        });
        $0abbbd36a260e067$var$EventHandler$1.on(window, EVENT_LOAD_DATA_API, ()=>{
            $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_DATA_TOGGLE_ACTIVE).forEach((element2)=>{
                Tab3.getOrCreateInstance(element2);
            });
        });
        $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
    }
};
const $0abbbd36a260e067$var$toastCallback$1 = (component, initSelector)=>{
    const Toast3 = component;
    if (!$0abbbd36a260e067$var$callbackInitState$1.has(component.name)) {
        $0abbbd36a260e067$var$enableDismissTrigger(Toast3);
        $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
    }
    $0abbbd36a260e067$var$SelectorEngine$1.find(initSelector).forEach((element2)=>{
        return Toast3.getOrCreateInstance(element2);
    });
};
const $0abbbd36a260e067$var$rippleCallback = (component, initSelector)=>{
    const Ripple2 = component;
    if (!$0abbbd36a260e067$var$callbackInitState$1.has(component.name)) {
        $0abbbd36a260e067$var$EventHandler$1.one(document, "mousedown", initSelector, Ripple2.autoInitial(new Ripple2()));
        $0abbbd36a260e067$var$callbackInitState$1.set(component.name, true);
    }
};
const $0abbbd36a260e067$var$callbackInitState = /* @__PURE__ */ new Map();
const $0abbbd36a260e067$var$alertCallback = (component, initSelector)=>{
    const Alert3 = component;
    if (!$0abbbd36a260e067$var$callbackInitState.has(component.name)) {
        $0abbbd36a260e067$var$enableDismissTrigger(Alert3);
        $0abbbd36a260e067$var$callbackInitState.set(component.name, true);
    }
    $0abbbd36a260e067$var$SelectorEngine$1.find(initSelector).forEach((element2)=>{
        return Alert3.getOrCreateInstance(element2);
    });
};
const $0abbbd36a260e067$var$lightboxCallback = (component, initSelector)=>{
    const EVENT_CLICK_DATA_API2 = `click.mdb.${component.name}.data-api`;
    const SELECTOR_DATA_TOGGLE2 = `[data-mdb-${component.NAME}-initialized]`;
    const SELECTOR_TOGGLE2 = `${SELECTOR_DATA_TOGGLE2} img:not(.lightbox-disabled)`;
    const Lightbox2 = component;
    $0abbbd36a260e067$var$SelectorEngine$1.find(initSelector).forEach((element2)=>{
        return Lightbox2.getOrCreateInstance(element2);
    });
    if ($0abbbd36a260e067$var$callbackInitState.has(component.name)) return;
    $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API2, SELECTOR_TOGGLE2, (event)=>{
        event.preventDefault();
        Lightbox2.toggle(event);
    });
    $0abbbd36a260e067$var$callbackInitState.set(component.name, true);
};
const $0abbbd36a260e067$var$modalCallback = (component, initSelector)=>{
    const EVENT_CLICK_DATA_API2 = `click.bs.${component.name}.data-api`;
    const OPEN_SELECTOR = ".modal.show";
    const Modal3 = component;
    const EVENT_SHOW2 = `show.bs.${component.name}`;
    const EVENT_HIDDEN2 = `hidden.bs.${component.name}`;
    if (!$0abbbd36a260e067$var$callbackInitState.has(component.name)) {
        $0abbbd36a260e067$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API2, initSelector, function(event) {
            const target = $0abbbd36a260e067$var$getElementFromSelector(this);
            if ([
                "A",
                "AREA"
            ].includes(this.tagName)) event.preventDefault();
            $0abbbd36a260e067$var$EventHandler$1.one(target, EVENT_SHOW2, (showEvent)=>{
                if (showEvent.defaultPrevented) return;
                $0abbbd36a260e067$var$EventHandler$1.one(target, EVENT_HIDDEN2, ()=>{
                    if ($0abbbd36a260e067$var$isVisible$1(this)) this.focus();
                });
            });
            const alreadyOpenedModals = $0abbbd36a260e067$var$SelectorEngine$1.find(OPEN_SELECTOR);
            alreadyOpenedModals.forEach((modal)=>{
                if (!modal.classList.contains("modal-non-invasive-show")) Modal3.getInstance(modal).hide();
            });
            const data = Modal3.getOrCreateInstance(target);
            data.toggle(this);
        });
        $0abbbd36a260e067$var$enableDismissTrigger(Modal3);
        $0abbbd36a260e067$var$callbackInitState.set(component.name, true);
    }
    $0abbbd36a260e067$var$SelectorEngine$1.find(initSelector).forEach((el)=>{
        const selector = $0abbbd36a260e067$var$getSelectorFromElement(el);
        const selectorElement = $0abbbd36a260e067$var$SelectorEngine$1.findOne(selector);
        Modal3.getOrCreateInstance(selectorElement);
    });
};
const $0abbbd36a260e067$var$sidenavCallback = (component, initSelector)=>{
    const SELECTOR_DATA_INIT = initSelector;
    const SELECTOR_TOGGLE2 = '[data-mdb-toggle="sidenav"]';
    const Sidenav2 = component;
    if (!$0abbbd36a260e067$var$callbackInitState.has(component.name)) {
        $0abbbd36a260e067$var$EventHandler$1.on(document, "click", SELECTOR_TOGGLE2, Sidenav2.toggleSidenav());
        $0abbbd36a260e067$var$callbackInitState.set(component.name, true);
    }
    $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_DATA_INIT).forEach((sidenav)=>{
        return Sidenav2.getOrCreateInstance(sidenav);
    });
};
const $0abbbd36a260e067$var$toastCallback = (component, initSelector)=>{
    const SELECTOR_DATA_INIT = initSelector;
    const Toast3 = component;
    if (!$0abbbd36a260e067$var$callbackInitState.has(component.name)) {
        $0abbbd36a260e067$var$enableDismissTrigger(Toast3);
        $0abbbd36a260e067$var$callbackInitState.set(component.name, true);
    }
    $0abbbd36a260e067$var$SelectorEngine$1.find(SELECTOR_DATA_INIT).forEach((toast)=>{
        return Toast3.getOrCreateInstance(toast);
    });
};
const $0abbbd36a260e067$var$defaultInitSelectors$1 = {
    // Bootstrap Components
    alert: {
        name: "Alert",
        selector: "[data-mdb-alert-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$alertCallback$1
    },
    button: {
        name: "Button",
        selector: "[data-mdb-button-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$buttonCallback
    },
    carousel: {
        name: "Carousel",
        selector: "[data-mdb-carousel-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$carouselCallback
    },
    collapse: {
        name: "Collapse",
        selector: "[data-mdb-collapse-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$collapseCallback
    },
    dropdown: {
        name: "Dropdown",
        selector: "[data-mdb-dropdown-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$dropdownCallback
    },
    modal: {
        name: "Modal",
        selector: "[data-mdb-modal-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$modalCallback$1
    },
    offcanvas: {
        name: "Offcanvas",
        selector: "[data-mdb-offcanvas-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$offcanvasCallback
    },
    scrollspy: {
        name: "ScrollSpy",
        selector: "[data-mdb-scrollspy-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$scrollspyCallback
    },
    tab: {
        name: "Tab",
        selector: "[data-mdb-tab-init], [data-mdb-pill-init], [data-mdb-list-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$tabCallback
    },
    toast: {
        name: "Toast",
        selector: "[data-mdb-toast-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$toastCallback$1
    },
    tooltip: {
        name: "Tooltip",
        selector: "[data-mdb-tooltip-init]",
        isToggler: false
    },
    input: {
        name: "Input",
        selector: "[data-mdb-input-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$inputCallback
    },
    range: {
        name: "Range",
        selector: "[data-mdb-range-init]",
        isToggler: false
    },
    ripple: {
        name: "Ripple",
        selector: "[data-mdb-ripple-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$rippleCallback
    },
    popover: {
        name: "Popover",
        selector: "[data-mdb-popover-init]",
        isToggler: false,
        callback: $0abbbd36a260e067$var$rippleCallback
    }
};
const $0abbbd36a260e067$var$DEFAULT_LEGEND_COLOR = {
    plugins: {
        legend: {
            labels: {
                color: "rgb(102,102,102)"
            }
        }
    }
};
const $0abbbd36a260e067$var$DEFAULT_OPTIONS = {
    line: {
        options: {
            ...$0abbbd36a260e067$var$DEFAULT_LEGEND_COLOR,
            elements: {
                line: {
                    backgroundColor: "rgba(59, 112, 202, 0.0)",
                    borderColor: "rgb(59, 112, 202)",
                    borderWidth: 2,
                    tension: 0
                },
                point: {
                    borderColor: "rgb(59, 112, 202)",
                    backgroundColor: "rgb(59, 112, 202)"
                }
            },
            responsive: true,
            legend: {
                display: true
            },
            tooltips: {
                intersect: false,
                mode: "index"
            },
            datasets: {
                borderColor: "red"
            },
            scales: {
                x: {
                    stacked: true,
                    grid: {
                        display: false
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                },
                y: {
                    stacked: false,
                    grid: {
                        borderDash: [
                            2
                        ],
                        drawBorder: false,
                        zeroLineColor: "rgba(0,0,0,0)",
                        zeroLineBorderDash: [
                            2
                        ],
                        zeroLineBorderDashOffset: [
                            2
                        ]
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                }
            }
        }
    },
    bar: {
        options: {
            ...$0abbbd36a260e067$var$DEFAULT_LEGEND_COLOR,
            backgroundColor: "rgb(59, 112, 202)",
            borderWidth: 0,
            responsive: true,
            legend: {
                display: true
            },
            tooltips: {
                intersect: false,
                mode: "index"
            },
            scales: {
                x: {
                    stacked: true,
                    grid: {
                        display: false
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                },
                y: {
                    stacked: true,
                    grid: {
                        borderDash: [
                            2
                        ],
                        drawBorder: false,
                        zeroLineColor: "rgba(0,0,0,0)",
                        zeroLineBorderDash: [
                            2
                        ],
                        zeroLineBorderDashOffset: [
                            2
                        ]
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                }
            }
        }
    },
    pie: {
        options: {
            ...$0abbbd36a260e067$var$DEFAULT_LEGEND_COLOR,
            elements: {
                arc: {
                    backgroundColor: "rgb(59, 112, 202)"
                }
            },
            responsive: true,
            legend: {
                display: true
            }
        }
    },
    doughnut: {
        options: {
            ...$0abbbd36a260e067$var$DEFAULT_LEGEND_COLOR,
            elements: {
                arc: {
                    backgroundColor: "rgb(59, 112, 202)"
                }
            },
            responsive: true,
            legend: {
                display: true
            }
        }
    },
    polarArea: {
        options: {
            ...$0abbbd36a260e067$var$DEFAULT_LEGEND_COLOR,
            elements: {
                arc: {
                    backgroundColor: "rgba(59, 112, 202, 0.5)"
                }
            },
            responsive: true,
            legend: {
                display: true
            }
        }
    },
    radar: {
        options: {
            ...$0abbbd36a260e067$var$DEFAULT_LEGEND_COLOR,
            elements: {
                line: {
                    backgroundColor: "rgba(59, 112, 202, 0.5)",
                    borderColor: "rgb(59, 112, 202)",
                    borderWidth: 2
                },
                point: {
                    borderColor: "rgb(59, 112, 202)",
                    backgroundColor: "rgb(59, 112, 202)"
                }
            },
            responsive: true,
            legend: {
                display: true
            }
        }
    },
    scatter: {
        options: {
            ...$0abbbd36a260e067$var$DEFAULT_LEGEND_COLOR,
            elements: {
                line: {
                    backgroundColor: "rgba(59, 112, 202, 0.5)",
                    borderColor: "rgb(59, 112, 202)",
                    borderWidth: 2,
                    tension: 0
                },
                point: {
                    borderColor: "rgb(59, 112, 202)",
                    backgroundColor: "rgba(59, 112, 202, 0.5)"
                }
            },
            responsive: true,
            legend: {
                display: true
            },
            tooltips: {
                intersect: false,
                mode: "index"
            },
            datasets: {
                borderColor: "red"
            },
            scales: {
                x: {
                    stacked: true,
                    grid: {
                        display: false
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                },
                y: {
                    stacked: false,
                    grid: {
                        borderDash: [
                            2
                        ],
                        drawBorder: false,
                        zeroLineColor: "rgba(0,0,0,0)",
                        zeroLineBorderDash: [
                            2
                        ],
                        zeroLineBorderDashOffset: [
                            2
                        ]
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                }
            }
        }
    },
    bubble: {
        options: {
            ...$0abbbd36a260e067$var$DEFAULT_LEGEND_COLOR,
            elements: {
                point: {
                    borderColor: "rgb(59, 112, 202)",
                    backgroundColor: "rgba(59, 112, 202, 0.5)"
                }
            },
            responsive: true,
            legend: {
                display: true
            },
            scales: {
                x: {
                    grid: {
                        display: false
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                },
                y: {
                    grid: {
                        borderDash: [
                            2
                        ],
                        drawBorder: false,
                        zeroLineColor: "rgba(0,0,0,0)",
                        zeroLineBorderDash: [
                            2
                        ],
                        zeroLineBorderDashOffset: [
                            2
                        ]
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                }
            }
        }
    }
};
const $0abbbd36a260e067$var$chartsCallback = (Component, initSelector)=>{
    const IS_COMPLEX = (data)=>{
        return data[0] === "{" && data[data.length - 1] === "}" || data[0] === "[" && data[data.length - 1] === "]";
    };
    const CONVERT_DATA_TYPE = (data)=>{
        if (typeof data !== "string") return data;
        if (IS_COMPLEX(data)) return JSON.parse(data.replace(/'/g, '"'));
        return data;
    };
    const PARSE_DATA = (data)=>{
        const dataset = {};
        Object.keys(data).forEach((property)=>{
            if (property.match(/dataset.*/)) {
                const chartProperty = property.slice(7, 8).toLowerCase().concat(property.slice(8));
                dataset[chartProperty] = CONVERT_DATA_TYPE(data[property]);
            }
        });
        return dataset;
    };
    $0abbbd36a260e067$var$SelectorEngine$1.find(initSelector).forEach((el)=>{
        if (!Component.getInstance(el) && $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(el, "chart") !== "bubble" && $0abbbd36a260e067$var$Manipulator$1.getDataAttribute(el, "chart") !== "scatter") {
            const dataSet = $0abbbd36a260e067$var$Manipulator$1.getDataAttributes(el);
            const dataAttr = {
                data: {
                    datasets: [
                        PARSE_DATA(dataSet)
                    ]
                }
            };
            if (dataSet.chart) dataAttr.type = dataSet.chart;
            if (dataSet.labels) dataAttr.data.labels = JSON.parse(dataSet.labels.replace(/'/g, '"'));
            return new Component(el, {
                ...dataAttr,
                ...$0abbbd36a260e067$var$DEFAULT_OPTIONS[dataAttr.type]
            });
        }
        return null;
    });
};
const $0abbbd36a260e067$var$defaultInitSelectors = {
    ...$0abbbd36a260e067$var$defaultInitSelectors$1,
    chart: {
        name: "Chart",
        selector: "[data-mdb-chart-init]",
        isToggler: false,
        advanced: $0abbbd36a260e067$var$chartsCallback
    },
    chips: {
        name: "ChipsInput",
        selector: "[data-mdb-chips-input-init]",
        isToggler: false
    },
    chip: {
        name: "Chip",
        selector: "[data-mdb-chip-init]",
        isToggler: false,
        onInit: "init"
    },
    datatable: {
        name: "Datatable",
        selector: "[data-mdb-datatable-init]",
        isToggler: false
    },
    select: {
        name: "Select",
        selector: "[data-mdb-select-init]",
        isToggler: false
    },
    datetimepicker: {
        name: "Datetimepicker",
        selector: "[data-mdb-datetimepicker-init]",
        isToggler: false
    },
    datepicker: {
        name: "Datepicker",
        selector: "[data-mdb-datepicker-init]",
        isToggler: false
    },
    loading: {
        name: "Loading",
        selector: "[data-mdb-loading-init]",
        isToggler: false
    },
    multiRangeSlider: {
        name: "MultiRangeSlider",
        selector: "[data-mdb-multi-range-slider-init]",
        isToggler: false
    },
    timepicker: {
        name: "Timepicker",
        selector: "[data-mdb-timepicker-init]",
        isToggler: false
    },
    touch: {
        name: "Touch",
        selector: "[data-mdb-touch-init]",
        isToggler: false
    },
    alert: {
        name: "Alert",
        selector: "[data-mdb-alert-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$alertCallback
    },
    animation: {
        name: "Animate",
        selector: "[data-mdb-animation-init]",
        isToggler: false,
        onInit: "init"
    },
    clipboard: {
        name: "Clipboard",
        selector: "[data-mdb-clipboard-init]",
        isToggler: false
    },
    infiniteScroll: {
        name: "InfiniteScroll",
        selector: "[data-mdb-infinite-scroll-init]",
        isToggler: false
    },
    lazyLoad: {
        name: "LazyLoad",
        selector: "[data-mdb-lazy-load-init]",
        isToggler: false
    },
    lightbox: {
        name: "Lightbox",
        selector: "[data-mdb-lightbox-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$lightboxCallback
    },
    modal: {
        name: "Modal",
        selector: "[data-mdb-modal-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$modalCallback
    },
    navbar: {
        name: "Navbar",
        selector: "[data-mdb-navbar-init]",
        isToggler: false,
        onInit: "init"
    },
    perfectScrollbar: {
        name: "PerfectScrollbar",
        selector: "[data-mdb-perfect-scrollbar-init]",
        isToggler: false
    },
    popconfirm: {
        name: "Popconfirm",
        selector: "[data-mdb-popconfirm-init]",
        isToggler: false
    },
    rating: {
        name: "Rating",
        selector: "[data-mdb-rating-init]",
        isToggler: false
    },
    sidenav: {
        name: "Sidenav",
        selector: "[data-mdb-sidenav-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$sidenavCallback
    },
    smoothScroll: {
        name: "SmoothScroll",
        selector: "[data-mdb-smooth-scroll-init]",
        isToggler: false
    },
    stepper: {
        name: "Stepper",
        selector: "[data-mdb-stepper-init]",
        isToggler: false
    },
    sticky: {
        name: "Sticky",
        selector: "[data-mdb-sticky-init]",
        isToggler: false
    },
    toast: {
        name: "Toast",
        selector: "[data-mdb-toast-init]",
        isToggler: true,
        callback: $0abbbd36a260e067$var$toastCallback
    }
};
const $0abbbd36a260e067$var$initMDBInstance = new $0abbbd36a260e067$var$InitMDB($0abbbd36a260e067$var$defaultInitSelectors);
const $0abbbd36a260e067$export$c471ba63047b6fd4 = $0abbbd36a260e067$var$initMDBInstance.initMDB;


var $8ae0e8ac8a6018f9$var$__defProp = Object.defineProperty;
var $8ae0e8ac8a6018f9$var$__defNormalProp = (obj, key, value)=>key in obj ? $8ae0e8ac8a6018f9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8ae0e8ac8a6018f9$var$__publicField = (obj, key, value)=>{
    $8ae0e8ac8a6018f9$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ function $8ae0e8ac8a6018f9$var$noop() {}
const $8ae0e8ac8a6018f9$var$uid = function() {
    let id = 0;
    return function() {
        return id++;
    };
}();
function $8ae0e8ac8a6018f9$var$isNullOrUndef(value) {
    return value === null || typeof value === "undefined";
}
function $8ae0e8ac8a6018f9$var$isArray(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
function $8ae0e8ac8a6018f9$var$isObject(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
const $8ae0e8ac8a6018f9$var$isNumberFinite = (value)=>(typeof value === "number" || value instanceof Number) && isFinite(+value);
function $8ae0e8ac8a6018f9$var$finiteOrDefault(value, defaultValue) {
    return $8ae0e8ac8a6018f9$var$isNumberFinite(value) ? value : defaultValue;
}
function $8ae0e8ac8a6018f9$var$valueOrDefault(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $8ae0e8ac8a6018f9$var$toPercentage = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : value / dimension;
const $8ae0e8ac8a6018f9$var$toDimension = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function $8ae0e8ac8a6018f9$var$callback(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $8ae0e8ac8a6018f9$var$each(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($8ae0e8ac8a6018f9$var$isArray(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($8ae0e8ac8a6018f9$var$isObject(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
function $8ae0e8ac8a6018f9$var$_elementsEqual(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
function $8ae0e8ac8a6018f9$var$clone$1(source) {
    if ($8ae0e8ac8a6018f9$var$isArray(source)) return source.map($8ae0e8ac8a6018f9$var$clone$1);
    if ($8ae0e8ac8a6018f9$var$isObject(source)) {
        const target = /* @__PURE__ */ Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $8ae0e8ac8a6018f9$var$clone$1(source[keys[k]]);
        return target;
    }
    return source;
}
function $8ae0e8ac8a6018f9$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
function $8ae0e8ac8a6018f9$var$_merger(key, target, source, options) {
    if (!$8ae0e8ac8a6018f9$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($8ae0e8ac8a6018f9$var$isObject(tval) && $8ae0e8ac8a6018f9$var$isObject(sval)) $8ae0e8ac8a6018f9$var$merge$1(tval, sval, options);
    else target[key] = $8ae0e8ac8a6018f9$var$clone$1(sval);
}
function $8ae0e8ac8a6018f9$var$merge$1(target, source, options) {
    const sources = $8ae0e8ac8a6018f9$var$isArray(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$8ae0e8ac8a6018f9$var$isObject(target)) return target;
    options = options || {};
    const merger = options.merger || $8ae0e8ac8a6018f9$var$_merger;
    for(let i = 0; i < ilen; ++i){
        source = sources[i];
        if (!$8ae0e8ac8a6018f9$var$isObject(source)) continue;
        const keys = Object.keys(source);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, source, options);
    }
    return target;
}
function $8ae0e8ac8a6018f9$var$mergeIf(target, source) {
    return $8ae0e8ac8a6018f9$var$merge$1(target, source, {
        merger: $8ae0e8ac8a6018f9$var$_mergerIf
    });
}
function $8ae0e8ac8a6018f9$var$_mergerIf(key, target, source) {
    if (!$8ae0e8ac8a6018f9$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($8ae0e8ac8a6018f9$var$isObject(tval) && $8ae0e8ac8a6018f9$var$isObject(sval)) $8ae0e8ac8a6018f9$var$mergeIf(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $8ae0e8ac8a6018f9$var$clone$1(sval);
}
const $8ae0e8ac8a6018f9$var$keyResolvers = {
    "": (v)=>v,
    x: (o)=>o.x,
    y: (o)=>o.y
};
function $8ae0e8ac8a6018f9$var$resolveObjectKey(obj, key) {
    const resolver = $8ae0e8ac8a6018f9$var$keyResolvers[key] || ($8ae0e8ac8a6018f9$var$keyResolvers[key] = $8ae0e8ac8a6018f9$var$_getKeyResolver(key));
    return resolver(obj);
}
function $8ae0e8ac8a6018f9$var$_getKeyResolver(key) {
    const keys = $8ae0e8ac8a6018f9$var$_splitKey(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $8ae0e8ac8a6018f9$var$_splitKey(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function $8ae0e8ac8a6018f9$var$_capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $8ae0e8ac8a6018f9$var$defined = (value)=>typeof value !== "undefined";
const $8ae0e8ac8a6018f9$var$isFunction = (value)=>typeof value === "function";
const $8ae0e8ac8a6018f9$var$setsEqual = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
function $8ae0e8ac8a6018f9$var$_isClickEvent(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const $8ae0e8ac8a6018f9$var$PI = Math.PI;
const $8ae0e8ac8a6018f9$var$TAU = 2 * $8ae0e8ac8a6018f9$var$PI;
const $8ae0e8ac8a6018f9$var$PITAU = $8ae0e8ac8a6018f9$var$TAU + $8ae0e8ac8a6018f9$var$PI;
const $8ae0e8ac8a6018f9$var$INFINITY = Number.POSITIVE_INFINITY;
const $8ae0e8ac8a6018f9$var$RAD_PER_DEG = $8ae0e8ac8a6018f9$var$PI / 180;
const $8ae0e8ac8a6018f9$var$HALF_PI = $8ae0e8ac8a6018f9$var$PI / 2;
const $8ae0e8ac8a6018f9$var$QUARTER_PI = $8ae0e8ac8a6018f9$var$PI / 4;
const $8ae0e8ac8a6018f9$var$TWO_THIRDS_PI = $8ae0e8ac8a6018f9$var$PI * 2 / 3;
const $8ae0e8ac8a6018f9$var$log10 = Math.log10;
const $8ae0e8ac8a6018f9$var$sign = Math.sign;
function $8ae0e8ac8a6018f9$var$niceNum(range) {
    const roundedRange = Math.round(range);
    range = $8ae0e8ac8a6018f9$var$almostEquals(range, roundedRange, range / 1e3) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($8ae0e8ac8a6018f9$var$log10(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
function $8ae0e8ac8a6018f9$var$_factorize(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $8ae0e8ac8a6018f9$var$isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $8ae0e8ac8a6018f9$var$almostEquals(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
function $8ae0e8ac8a6018f9$var$almostWhole(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
function $8ae0e8ac8a6018f9$var$_setMinAndMaxByKey(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $8ae0e8ac8a6018f9$var$toRadians(degrees) {
    return degrees * ($8ae0e8ac8a6018f9$var$PI / 180);
}
function $8ae0e8ac8a6018f9$var$toDegrees(radians) {
    return radians * (180 / $8ae0e8ac8a6018f9$var$PI);
}
function $8ae0e8ac8a6018f9$var$_decimalPlaces(x) {
    if (!$8ae0e8ac8a6018f9$var$isNumberFinite(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
function $8ae0e8ac8a6018f9$var$getAngleFromPoint(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $8ae0e8ac8a6018f9$var$PI) angle += $8ae0e8ac8a6018f9$var$TAU;
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $8ae0e8ac8a6018f9$var$distanceBetweenPoints(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function $8ae0e8ac8a6018f9$var$_angleDiff(a, b) {
    return (a - b + $8ae0e8ac8a6018f9$var$PITAU) % $8ae0e8ac8a6018f9$var$TAU - $8ae0e8ac8a6018f9$var$PI;
}
function $8ae0e8ac8a6018f9$var$_normalizeAngle(a) {
    return (a % $8ae0e8ac8a6018f9$var$TAU + $8ae0e8ac8a6018f9$var$TAU) % $8ae0e8ac8a6018f9$var$TAU;
}
function $8ae0e8ac8a6018f9$var$_angleBetween(angle, start, end, sameAngleIsFullCircle) {
    const a = $8ae0e8ac8a6018f9$var$_normalizeAngle(angle);
    const s = $8ae0e8ac8a6018f9$var$_normalizeAngle(start);
    const e = $8ae0e8ac8a6018f9$var$_normalizeAngle(end);
    const angleToStart = $8ae0e8ac8a6018f9$var$_normalizeAngle(s - a);
    const angleToEnd = $8ae0e8ac8a6018f9$var$_normalizeAngle(e - a);
    const startToAngle = $8ae0e8ac8a6018f9$var$_normalizeAngle(a - s);
    const endToAngle = $8ae0e8ac8a6018f9$var$_normalizeAngle(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function $8ae0e8ac8a6018f9$var$_limitValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function $8ae0e8ac8a6018f9$var$_int16Range(value) {
    return $8ae0e8ac8a6018f9$var$_limitValue(value, -32768, 32767);
}
function $8ae0e8ac8a6018f9$var$_isBetween(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $8ae0e8ac8a6018f9$var$_lookup(table, value, cmp) {
    cmp = cmp || ((index2)=>table[index2] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
const $8ae0e8ac8a6018f9$var$_lookupByKey = (table, key, value, last)=>$8ae0e8ac8a6018f9$var$_lookup(table, value, last ? (index2)=>table[index2][key] <= value : (index2)=>table[index2][key] < value);
const $8ae0e8ac8a6018f9$var$_rlookupByKey = (table, key, value)=>$8ae0e8ac8a6018f9$var$_lookup(table, value, (index2)=>table[index2][key] >= value);
function $8ae0e8ac8a6018f9$var$_filterBetween(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $8ae0e8ac8a6018f9$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $8ae0e8ac8a6018f9$var$listenArrayEvents(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $8ae0e8ac8a6018f9$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $8ae0e8ac8a6018f9$var$_capitalize(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $8ae0e8ac8a6018f9$var$unlistenArrayEvents(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index2 = listeners.indexOf(listener);
    if (index2 !== -1) listeners.splice(index2, 1);
    if (listeners.length > 0) return;
    $8ae0e8ac8a6018f9$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
function $8ae0e8ac8a6018f9$var$_arrayUnique(items) {
    const set2 = /* @__PURE__ */ new Set();
    let i, ilen;
    for(i = 0, ilen = items.length; i < ilen; ++i)set2.add(items[i]);
    if (set2.size === ilen) return items;
    return Array.from(set2);
}
const $8ae0e8ac8a6018f9$var$requestAnimFrame = function() {
    if (typeof window === "undefined") return function(callback2) {
        return callback2();
    };
    return window.requestAnimationFrame;
}();
function $8ae0e8ac8a6018f9$var$throttled(fn, thisArg, updateFn) {
    const updateArgs = updateFn || ((args2)=>Array.prototype.slice.call(args2));
    let ticking = false;
    let args = [];
    return function(...rest) {
        args = updateArgs(rest);
        if (!ticking) {
            ticking = true;
            $8ae0e8ac8a6018f9$var$requestAnimFrame.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, args);
            });
        }
    };
}
function $8ae0e8ac8a6018f9$var$debounce(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
const $8ae0e8ac8a6018f9$var$_toLeftRightCenter = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
const $8ae0e8ac8a6018f9$var$_alignStartEnd = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
const $8ae0e8ac8a6018f9$var$_textX = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
function $8ae0e8ac8a6018f9$var$_getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $8ae0e8ac8a6018f9$var$_limitValue(Math.min($8ae0e8ac8a6018f9$var$_lookupByKey(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : $8ae0e8ac8a6018f9$var$_lookupByKey(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $8ae0e8ac8a6018f9$var$_limitValue(Math.max($8ae0e8ac8a6018f9$var$_lookupByKey(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $8ae0e8ac8a6018f9$var$_lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
function $8ae0e8ac8a6018f9$var$_scaleRangesChanged(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $8ae0e8ac8a6018f9$var$atEdge = (t)=>t === 0 || t === 1;
const $8ae0e8ac8a6018f9$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $8ae0e8ac8a6018f9$var$TAU / p));
const $8ae0e8ac8a6018f9$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $8ae0e8ac8a6018f9$var$TAU / p) + 1;
const $8ae0e8ac8a6018f9$var$effects = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $8ae0e8ac8a6018f9$var$HALF_PI) + 1,
    easeOutSine: (t)=>Math.sin(t * $8ae0e8ac8a6018f9$var$HALF_PI),
    easeInOutSine: (t)=>-0.5 * (Math.cos($8ae0e8ac8a6018f9$var$PI * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$8ae0e8ac8a6018f9$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$8ae0e8ac8a6018f9$var$atEdge(t) ? t : $8ae0e8ac8a6018f9$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$8ae0e8ac8a6018f9$var$atEdge(t) ? t : $8ae0e8ac8a6018f9$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $8ae0e8ac8a6018f9$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $8ae0e8ac8a6018f9$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $8ae0e8ac8a6018f9$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $8ae0e8ac8a6018f9$var$effects.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $8ae0e8ac8a6018f9$var$effects.easeInBounce(t * 2) * 0.5 : $8ae0e8ac8a6018f9$var$effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */ function $8ae0e8ac8a6018f9$var$round(v) {
    return v + 0.5 | 0;
}
const $8ae0e8ac8a6018f9$var$lim = (v, l, h)=>Math.max(Math.min(v, h), l);
function $8ae0e8ac8a6018f9$var$p2b(v) {
    return $8ae0e8ac8a6018f9$var$lim($8ae0e8ac8a6018f9$var$round(v * 2.55), 0, 255);
}
function $8ae0e8ac8a6018f9$var$n2b(v) {
    return $8ae0e8ac8a6018f9$var$lim($8ae0e8ac8a6018f9$var$round(v * 255), 0, 255);
}
function $8ae0e8ac8a6018f9$var$b2n(v) {
    return $8ae0e8ac8a6018f9$var$lim($8ae0e8ac8a6018f9$var$round(v / 2.55) / 100, 0, 1);
}
function $8ae0e8ac8a6018f9$var$n2p(v) {
    return $8ae0e8ac8a6018f9$var$lim($8ae0e8ac8a6018f9$var$round(v * 100), 0, 100);
}
const $8ae0e8ac8a6018f9$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $8ae0e8ac8a6018f9$var$hex = [
    ..."0123456789ABCDEF"
];
const $8ae0e8ac8a6018f9$var$h1 = (b)=>$8ae0e8ac8a6018f9$var$hex[b & 15];
const $8ae0e8ac8a6018f9$var$h2 = (b)=>$8ae0e8ac8a6018f9$var$hex[(b & 240) >> 4] + $8ae0e8ac8a6018f9$var$hex[b & 15];
const $8ae0e8ac8a6018f9$var$eq = (b)=>(b & 240) >> 4 === (b & 15);
const $8ae0e8ac8a6018f9$var$isShort = (v)=>$8ae0e8ac8a6018f9$var$eq(v.r) && $8ae0e8ac8a6018f9$var$eq(v.g) && $8ae0e8ac8a6018f9$var$eq(v.b) && $8ae0e8ac8a6018f9$var$eq(v.a);
function $8ae0e8ac8a6018f9$var$hexParse(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $8ae0e8ac8a6018f9$var$map$1[str[1]] * 17,
            g: 255 & $8ae0e8ac8a6018f9$var$map$1[str[2]] * 17,
            b: 255 & $8ae0e8ac8a6018f9$var$map$1[str[3]] * 17,
            a: len === 5 ? $8ae0e8ac8a6018f9$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $8ae0e8ac8a6018f9$var$map$1[str[1]] << 4 | $8ae0e8ac8a6018f9$var$map$1[str[2]],
            g: $8ae0e8ac8a6018f9$var$map$1[str[3]] << 4 | $8ae0e8ac8a6018f9$var$map$1[str[4]],
            b: $8ae0e8ac8a6018f9$var$map$1[str[5]] << 4 | $8ae0e8ac8a6018f9$var$map$1[str[6]],
            a: len === 9 ? $8ae0e8ac8a6018f9$var$map$1[str[7]] << 4 | $8ae0e8ac8a6018f9$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $8ae0e8ac8a6018f9$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $8ae0e8ac8a6018f9$var$hexString(v) {
    var f = $8ae0e8ac8a6018f9$var$isShort(v) ? $8ae0e8ac8a6018f9$var$h1 : $8ae0e8ac8a6018f9$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $8ae0e8ac8a6018f9$var$alpha(v.a, f) : void 0;
}
const $8ae0e8ac8a6018f9$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $8ae0e8ac8a6018f9$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $8ae0e8ac8a6018f9$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $8ae0e8ac8a6018f9$var$hwb2rgbn(h, w, b) {
    const rgb = $8ae0e8ac8a6018f9$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $8ae0e8ac8a6018f9$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $8ae0e8ac8a6018f9$var$rgb2hsl(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $8ae0e8ac8a6018f9$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $8ae0e8ac8a6018f9$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($8ae0e8ac8a6018f9$var$n2b);
}
function $8ae0e8ac8a6018f9$var$hsl2rgb(h, s, l) {
    return $8ae0e8ac8a6018f9$var$calln($8ae0e8ac8a6018f9$var$hsl2rgbn, h, s, l);
}
function $8ae0e8ac8a6018f9$var$hwb2rgb(h, w, b) {
    return $8ae0e8ac8a6018f9$var$calln($8ae0e8ac8a6018f9$var$hwb2rgbn, h, w, b);
}
function $8ae0e8ac8a6018f9$var$hsv2rgb(h, s, v) {
    return $8ae0e8ac8a6018f9$var$calln($8ae0e8ac8a6018f9$var$hsv2rgbn, h, s, v);
}
function $8ae0e8ac8a6018f9$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $8ae0e8ac8a6018f9$var$hueParse(str) {
    const m = $8ae0e8ac8a6018f9$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $8ae0e8ac8a6018f9$var$p2b(+m[5]) : $8ae0e8ac8a6018f9$var$n2b(+m[5]);
    const h = $8ae0e8ac8a6018f9$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $8ae0e8ac8a6018f9$var$hwb2rgb(h, p1, p2);
    else if (m[1] === "hsv") v = $8ae0e8ac8a6018f9$var$hsv2rgb(h, p1, p2);
    else v = $8ae0e8ac8a6018f9$var$hsl2rgb(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $8ae0e8ac8a6018f9$var$rotate(v, deg) {
    var h = $8ae0e8ac8a6018f9$var$rgb2hsl(v);
    h[0] = $8ae0e8ac8a6018f9$var$hue(h[0] + deg);
    h = $8ae0e8ac8a6018f9$var$hsl2rgb(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $8ae0e8ac8a6018f9$var$hslString(v) {
    if (!v) return;
    const a = $8ae0e8ac8a6018f9$var$rgb2hsl(v);
    const h = a[0];
    const s = $8ae0e8ac8a6018f9$var$n2p(a[1]);
    const l = $8ae0e8ac8a6018f9$var$n2p(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$8ae0e8ac8a6018f9$var$b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $8ae0e8ac8a6018f9$var$map$2 = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $8ae0e8ac8a6018f9$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $8ae0e8ac8a6018f9$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($8ae0e8ac8a6018f9$var$names$1);
    const tkeys = Object.keys($8ae0e8ac8a6018f9$var$map$2);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $8ae0e8ac8a6018f9$var$map$2[k]);
        }
        k = parseInt($8ae0e8ac8a6018f9$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 255,
            k >> 8 & 255,
            k & 255
        ];
    }
    return unpacked;
}
let $8ae0e8ac8a6018f9$var$names;
function $8ae0e8ac8a6018f9$var$nameParse(str) {
    if (!$8ae0e8ac8a6018f9$var$names) {
        $8ae0e8ac8a6018f9$var$names = $8ae0e8ac8a6018f9$var$unpack();
        $8ae0e8ac8a6018f9$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $8ae0e8ac8a6018f9$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $8ae0e8ac8a6018f9$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $8ae0e8ac8a6018f9$var$rgbParse(str) {
    const m = $8ae0e8ac8a6018f9$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $8ae0e8ac8a6018f9$var$p2b(v) : $8ae0e8ac8a6018f9$var$lim(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $8ae0e8ac8a6018f9$var$p2b(r) : $8ae0e8ac8a6018f9$var$lim(r, 0, 255));
    g = 255 & (m[4] ? $8ae0e8ac8a6018f9$var$p2b(g) : $8ae0e8ac8a6018f9$var$lim(g, 0, 255));
    b = 255 & (m[6] ? $8ae0e8ac8a6018f9$var$p2b(b) : $8ae0e8ac8a6018f9$var$lim(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $8ae0e8ac8a6018f9$var$rgbString(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$8ae0e8ac8a6018f9$var$b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $8ae0e8ac8a6018f9$var$to = (v)=>v <= 31308e-7 ? v * 12.92 : Math.pow(v, 1 / 2.4) * 1.055 - 0.055;
const $8ae0e8ac8a6018f9$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $8ae0e8ac8a6018f9$var$interpolate$1(rgb1, rgb2, t) {
    const r = $8ae0e8ac8a6018f9$var$from($8ae0e8ac8a6018f9$var$b2n(rgb1.r));
    const g = $8ae0e8ac8a6018f9$var$from($8ae0e8ac8a6018f9$var$b2n(rgb1.g));
    const b = $8ae0e8ac8a6018f9$var$from($8ae0e8ac8a6018f9$var$b2n(rgb1.b));
    return {
        r: $8ae0e8ac8a6018f9$var$n2b($8ae0e8ac8a6018f9$var$to(r + t * ($8ae0e8ac8a6018f9$var$from($8ae0e8ac8a6018f9$var$b2n(rgb2.r)) - r))),
        g: $8ae0e8ac8a6018f9$var$n2b($8ae0e8ac8a6018f9$var$to(g + t * ($8ae0e8ac8a6018f9$var$from($8ae0e8ac8a6018f9$var$b2n(rgb2.g)) - g))),
        b: $8ae0e8ac8a6018f9$var$n2b($8ae0e8ac8a6018f9$var$to(b + t * ($8ae0e8ac8a6018f9$var$from($8ae0e8ac8a6018f9$var$b2n(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $8ae0e8ac8a6018f9$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $8ae0e8ac8a6018f9$var$rgb2hsl(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $8ae0e8ac8a6018f9$var$hsl2rgb(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $8ae0e8ac8a6018f9$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $8ae0e8ac8a6018f9$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $8ae0e8ac8a6018f9$var$n2b(input[3]);
        }
    } else {
        v = $8ae0e8ac8a6018f9$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $8ae0e8ac8a6018f9$var$n2b(v.a);
    }
    return v;
}
function $8ae0e8ac8a6018f9$var$functionParse(str) {
    if (str.charAt(0) === "r") return $8ae0e8ac8a6018f9$var$rgbParse(str);
    return $8ae0e8ac8a6018f9$var$hueParse(str);
}
class $8ae0e8ac8a6018f9$var$Color {
    constructor(input){
        if (input instanceof $8ae0e8ac8a6018f9$var$Color) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $8ae0e8ac8a6018f9$var$fromObject(input);
        else if (type === "string") v = $8ae0e8ac8a6018f9$var$hexParse(input) || $8ae0e8ac8a6018f9$var$nameParse(input) || $8ae0e8ac8a6018f9$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $8ae0e8ac8a6018f9$var$clone(this._rgb);
        if (v) v.a = $8ae0e8ac8a6018f9$var$b2n(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $8ae0e8ac8a6018f9$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $8ae0e8ac8a6018f9$var$rgbString(this._rgb) : void 0;
    }
    hexString() {
        return this._valid ? $8ae0e8ac8a6018f9$var$hexString(this._rgb) : void 0;
    }
    hslString() {
        return this._valid ? $8ae0e8ac8a6018f9$var$hslString(this._rgb) : void 0;
    }
    mix(color2, weight) {
        if (color2) {
            const c1 = this.rgb;
            const c2 = color2.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
            w2 = 1 - w1;
            c1.r = 255 & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 255 & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 255 & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color2, t) {
        if (color2) this._rgb = $8ae0e8ac8a6018f9$var$interpolate$1(this._rgb, color2._rgb, t);
        return this;
    }
    clone() {
        return new $8ae0e8ac8a6018f9$var$Color(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $8ae0e8ac8a6018f9$var$n2b(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $8ae0e8ac8a6018f9$var$round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $8ae0e8ac8a6018f9$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $8ae0e8ac8a6018f9$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $8ae0e8ac8a6018f9$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $8ae0e8ac8a6018f9$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $8ae0e8ac8a6018f9$var$rotate(this._rgb, deg);
        return this;
    }
}
function $8ae0e8ac8a6018f9$var$index_esm(input) {
    return new $8ae0e8ac8a6018f9$var$Color(input);
}
function $8ae0e8ac8a6018f9$var$isPatternOrGradient(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $8ae0e8ac8a6018f9$var$color(value) {
    return $8ae0e8ac8a6018f9$var$isPatternOrGradient(value) ? value : $8ae0e8ac8a6018f9$var$index_esm(value);
}
function $8ae0e8ac8a6018f9$var$getHoverColor(value) {
    return $8ae0e8ac8a6018f9$var$isPatternOrGradient(value) ? value : $8ae0e8ac8a6018f9$var$index_esm(value).saturate(0.5).darken(0.1).hexString();
}
const $8ae0e8ac8a6018f9$var$overrides = /* @__PURE__ */ Object.create(null);
const $8ae0e8ac8a6018f9$var$descriptors = /* @__PURE__ */ Object.create(null);
function $8ae0e8ac8a6018f9$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = /* @__PURE__ */ Object.create(null));
    }
    return node;
}
function $8ae0e8ac8a6018f9$var$set(root, scope, values) {
    if (typeof scope === "string") return $8ae0e8ac8a6018f9$var$merge$1($8ae0e8ac8a6018f9$var$getScope$1(root, scope), values);
    return $8ae0e8ac8a6018f9$var$merge$1($8ae0e8ac8a6018f9$var$getScope$1(root, ""), scope);
}
class $8ae0e8ac8a6018f9$var$Defaults {
    constructor(_descriptors2){
        this.animation = void 0;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$8ae0e8ac8a6018f9$var$getHoverColor(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$8ae0e8ac8a6018f9$var$getHoverColor(options.borderColor);
        this.hoverColor = (ctx, options)=>$8ae0e8ac8a6018f9$var$getHoverColor(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = void 0;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors2);
    }
    set(scope, values) {
        return $8ae0e8ac8a6018f9$var$set(this, scope, values);
    }
    get(scope) {
        return $8ae0e8ac8a6018f9$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $8ae0e8ac8a6018f9$var$set($8ae0e8ac8a6018f9$var$descriptors, scope, values);
    }
    override(scope, values) {
        return $8ae0e8ac8a6018f9$var$set($8ae0e8ac8a6018f9$var$overrides, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $8ae0e8ac8a6018f9$var$getScope$1(this, scope);
        const targetScopeObject = $8ae0e8ac8a6018f9$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($8ae0e8ac8a6018f9$var$isObject(local)) return Object.assign({}, target, local);
                    return $8ae0e8ac8a6018f9$var$valueOrDefault(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
}
var $8ae0e8ac8a6018f9$var$defaults = new $8ae0e8ac8a6018f9$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
});
function $8ae0e8ac8a6018f9$var$toFontString(font) {
    if (!font || $8ae0e8ac8a6018f9$var$isNullOrUndef(font.size) || $8ae0e8ac8a6018f9$var$isNullOrUndef(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function $8ae0e8ac8a6018f9$var$_measureText(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
function $8ae0e8ac8a6018f9$var$_longestText(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        if (thing !== void 0 && thing !== null && $8ae0e8ac8a6018f9$var$isArray(thing) !== true) longest = $8ae0e8ac8a6018f9$var$_measureText(ctx, data, gc, longest, thing);
        else if ($8ae0e8ac8a6018f9$var$isArray(thing)) for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            if (nestedThing !== void 0 && nestedThing !== null && !$8ae0e8ac8a6018f9$var$isArray(nestedThing)) longest = $8ae0e8ac8a6018f9$var$_measureText(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
function $8ae0e8ac8a6018f9$var$_alignPixel(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function $8ae0e8ac8a6018f9$var$clearCanvas(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $8ae0e8ac8a6018f9$var$drawPoint(ctx, options, x, y) {
    $8ae0e8ac8a6018f9$var$drawPointLegend(ctx, options, x, y, null);
}
function $8ae0e8ac8a6018f9$var$drawPointLegend(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $8ae0e8ac8a6018f9$var$RAD_PER_DEG;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $8ae0e8ac8a6018f9$var$TAU);
            else ctx.arc(x, y, radius, 0, $8ae0e8ac8a6018f9$var$TAU);
            ctx.closePath();
            break;
        case "triangle":
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $8ae0e8ac8a6018f9$var$TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += $8ae0e8ac8a6018f9$var$TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $8ae0e8ac8a6018f9$var$QUARTER_PI) * size;
            yOffset = Math.sin(rad + $8ae0e8ac8a6018f9$var$QUARTER_PI) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - $8ae0e8ac8a6018f9$var$PI, rad - $8ae0e8ac8a6018f9$var$HALF_PI);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - $8ae0e8ac8a6018f9$var$HALF_PI, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + $8ae0e8ac8a6018f9$var$HALF_PI);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + $8ae0e8ac8a6018f9$var$HALF_PI, rad + $8ae0e8ac8a6018f9$var$PI);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $8ae0e8ac8a6018f9$var$QUARTER_PI;
        case "rectRot":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $8ae0e8ac8a6018f9$var$QUARTER_PI;
        case "cross":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "star":
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += $8ae0e8ac8a6018f9$var$QUARTER_PI;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
function $8ae0e8ac8a6018f9$var$_isPointInArea(point, area, margin) {
    margin = margin || 0.5;
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $8ae0e8ac8a6018f9$var$clipArea(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $8ae0e8ac8a6018f9$var$unclipArea(ctx) {
    ctx.restore();
}
function $8ae0e8ac8a6018f9$var$_steppedLineTo(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
function $8ae0e8ac8a6018f9$var$_bezierCurveTo(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $8ae0e8ac8a6018f9$var$renderText(ctx, text, x, y, font, opts = {}) {
    const lines = $8ae0e8ac8a6018f9$var$isArray(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $8ae0e8ac8a6018f9$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$8ae0e8ac8a6018f9$var$isNullOrUndef(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $8ae0e8ac8a6018f9$var$decorateText(ctx, x, y, line, opts);
        y += font.lineHeight;
    }
    ctx.restore();
}
function $8ae0e8ac8a6018f9$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$8ae0e8ac8a6018f9$var$isNullOrUndef(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $8ae0e8ac8a6018f9$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $8ae0e8ac8a6018f9$var$addRoundedRectPath(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$8ae0e8ac8a6018f9$var$HALF_PI, $8ae0e8ac8a6018f9$var$PI, true);
    ctx.lineTo(x, y + h - radius.bottomLeft);
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $8ae0e8ac8a6018f9$var$PI, $8ae0e8ac8a6018f9$var$HALF_PI, true);
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $8ae0e8ac8a6018f9$var$HALF_PI, 0, true);
    ctx.lineTo(x + w, y + radius.topRight);
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$8ae0e8ac8a6018f9$var$HALF_PI, true);
    ctx.lineTo(x + radius.topLeft, y);
}
const $8ae0e8ac8a6018f9$var$LINE_HEIGHT = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
const $8ae0e8ac8a6018f9$var$FONT_STYLE = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function $8ae0e8ac8a6018f9$var$toLineHeight(value, size) {
    const matches = ("" + value).match($8ae0e8ac8a6018f9$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $8ae0e8ac8a6018f9$var$numberOrZero = (v)=>+v || 0;
function $8ae0e8ac8a6018f9$var$_readValueToProps(value, props) {
    const ret = {};
    const objProps = $8ae0e8ac8a6018f9$var$isObject(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $8ae0e8ac8a6018f9$var$isObject(value) ? objProps ? (prop)=>$8ae0e8ac8a6018f9$var$valueOrDefault(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $8ae0e8ac8a6018f9$var$numberOrZero(read(prop));
    return ret;
}
function $8ae0e8ac8a6018f9$var$toTRBL(value) {
    return $8ae0e8ac8a6018f9$var$_readValueToProps(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
function $8ae0e8ac8a6018f9$var$toTRBLCorners(value) {
    return $8ae0e8ac8a6018f9$var$_readValueToProps(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
function $8ae0e8ac8a6018f9$var$toPadding(value) {
    const obj = $8ae0e8ac8a6018f9$var$toTRBL(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
function $8ae0e8ac8a6018f9$var$toFont(options, fallback) {
    options = options || {};
    fallback = fallback || $8ae0e8ac8a6018f9$var$defaults.font;
    let size = $8ae0e8ac8a6018f9$var$valueOrDefault(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $8ae0e8ac8a6018f9$var$valueOrDefault(options.style, fallback.style);
    if (style && !("" + style).match($8ae0e8ac8a6018f9$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = "";
    }
    const font = {
        family: $8ae0e8ac8a6018f9$var$valueOrDefault(options.family, fallback.family),
        lineHeight: $8ae0e8ac8a6018f9$var$toLineHeight($8ae0e8ac8a6018f9$var$valueOrDefault(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $8ae0e8ac8a6018f9$var$valueOrDefault(options.weight, fallback.weight),
        string: ""
    };
    font.string = $8ae0e8ac8a6018f9$var$toFontString(font);
    return font;
}
function $8ae0e8ac8a6018f9$var$resolve(inputs, context, index2, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === void 0) continue;
        if (context !== void 0 && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index2 !== void 0 && $8ae0e8ac8a6018f9$var$isArray(value)) {
            value = value[index2 % value.length];
            cacheable = false;
        }
        if (value !== void 0) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
function $8ae0e8ac8a6018f9$var$_addGrace(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $8ae0e8ac8a6018f9$var$toDimension(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $8ae0e8ac8a6018f9$var$createContext(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
function $8ae0e8ac8a6018f9$var$_createResolver(scopes, prefixes = [
    ""
], rootScopes = scopes, fallback, getTarget = ()=>scopes[0]) {
    if (!$8ae0e8ac8a6018f9$var$defined(fallback)) fallback = $8ae0e8ac8a6018f9$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: rootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$8ae0e8ac8a6018f9$var$_createResolver([
                scope,
                ...scopes
            ], prefixes, rootScopes, fallback)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete target._keys;
            delete scopes[0][prop];
            return true;
        },
        get (target, prop) {
            return $8ae0e8ac8a6018f9$var$_cached(target, prop, ()=>$8ae0e8ac8a6018f9$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        has (target, prop) {
            return $8ae0e8ac8a6018f9$var$getKeysFromAllScopes(target).includes(prop);
        },
        ownKeys (target) {
            return $8ae0e8ac8a6018f9$var$getKeysFromAllScopes(target);
        },
        set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value;
            delete target._keys;
            return true;
        }
    });
}
function $8ae0e8ac8a6018f9$var$_attachContext(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: /* @__PURE__ */ new Set(),
        _descriptors: $8ae0e8ac8a6018f9$var$_descriptors(proxy, descriptorDefaults),
        setContext: (ctx)=>$8ae0e8ac8a6018f9$var$_attachContext(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$8ae0e8ac8a6018f9$var$_attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        deleteProperty (target, prop) {
            delete target[prop];
            delete proxy[prop];
            return true;
        },
        get (target, prop, receiver) {
            return $8ae0e8ac8a6018f9$var$_cached(target, prop, ()=>$8ae0e8ac8a6018f9$var$_resolveWithContext(target, prop, receiver));
        },
        getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : void 0 : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        set (target, prop, value) {
            proxy[prop] = value;
            delete target[prop];
            return true;
        }
    });
}
function $8ae0e8ac8a6018f9$var$_descriptors(proxy, defaults2 = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults2.scriptable, _indexable: _indexable = defaults2.indexable, _allKeys: _allKeys = defaults2.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $8ae0e8ac8a6018f9$var$isFunction(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $8ae0e8ac8a6018f9$var$isFunction(_indexable) ? _indexable : ()=>_indexable
    };
}
const $8ae0e8ac8a6018f9$var$readKey = (prefix, name)=>prefix ? prefix + $8ae0e8ac8a6018f9$var$_capitalize(name) : name;
const $8ae0e8ac8a6018f9$var$needsSubResolver = (prop, value)=>$8ae0e8ac8a6018f9$var$isObject(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $8ae0e8ac8a6018f9$var$_cached(target, prop, resolve2) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve2();
    target[prop] = value;
    return value;
}
function $8ae0e8ac8a6018f9$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors2 } = target;
    let value = _proxy[prop];
    if ($8ae0e8ac8a6018f9$var$isFunction(value) && descriptors2.isScriptable(prop)) value = $8ae0e8ac8a6018f9$var$_resolveScriptable(prop, value, target, receiver);
    if ($8ae0e8ac8a6018f9$var$isArray(value) && value.length) value = $8ae0e8ac8a6018f9$var$_resolveArray(prop, value, target, descriptors2.isIndexable);
    if ($8ae0e8ac8a6018f9$var$needsSubResolver(prop, value)) value = $8ae0e8ac8a6018f9$var$_attachContext(value, _context, _subProxy && _subProxy[prop], descriptors2);
    return value;
}
function $8ae0e8ac8a6018f9$var$_resolveScriptable(prop, value, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    value = value(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($8ae0e8ac8a6018f9$var$needsSubResolver(prop, value)) value = $8ae0e8ac8a6018f9$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $8ae0e8ac8a6018f9$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors2 } = target;
    if ($8ae0e8ac8a6018f9$var$defined(_context.index) && isIndexable(prop)) value = value[_context.index % value.length];
    else if ($8ae0e8ac8a6018f9$var$isObject(value[0])) {
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $8ae0e8ac8a6018f9$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($8ae0e8ac8a6018f9$var$_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors2));
        }
    }
    return value;
}
function $8ae0e8ac8a6018f9$var$resolveFallback(fallback, prop, value) {
    return $8ae0e8ac8a6018f9$var$isFunction(fallback) ? fallback(prop, value) : fallback;
}
const $8ae0e8ac8a6018f9$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $8ae0e8ac8a6018f9$var$resolveObjectKey(parent, key) : void 0;
function $8ae0e8ac8a6018f9$var$addScopes(set2, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $8ae0e8ac8a6018f9$var$getScope(key, parent);
        if (scope) {
            set2.add(scope);
            const fallback = $8ae0e8ac8a6018f9$var$resolveFallback(scope._fallback, key, value);
            if ($8ae0e8ac8a6018f9$var$defined(fallback) && fallback !== key && fallback !== parentFallback) return fallback;
        } else if (scope === false && $8ae0e8ac8a6018f9$var$defined(parentFallback) && key !== parentFallback) return null;
    }
    return false;
}
function $8ae0e8ac8a6018f9$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $8ae0e8ac8a6018f9$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set2 = /* @__PURE__ */ new Set();
    set2.add(value);
    let key = $8ae0e8ac8a6018f9$var$addScopesFromKey(set2, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if ($8ae0e8ac8a6018f9$var$defined(fallback) && fallback !== prop) {
        key = $8ae0e8ac8a6018f9$var$addScopesFromKey(set2, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $8ae0e8ac8a6018f9$var$_createResolver(Array.from(set2), [
        ""
    ], rootScopes, fallback, ()=>$8ae0e8ac8a6018f9$var$subGetTarget(resolver, prop, value));
}
function $8ae0e8ac8a6018f9$var$addScopesFromKey(set2, allScopes, key, fallback, item) {
    while(key)key = $8ae0e8ac8a6018f9$var$addScopes(set2, allScopes, key, fallback, item);
    return key;
}
function $8ae0e8ac8a6018f9$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($8ae0e8ac8a6018f9$var$isArray(target) && $8ae0e8ac8a6018f9$var$isObject(value)) return value;
    return target;
}
function $8ae0e8ac8a6018f9$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $8ae0e8ac8a6018f9$var$_resolve($8ae0e8ac8a6018f9$var$readKey(prefix, prop), scopes);
        if ($8ae0e8ac8a6018f9$var$defined(value)) return $8ae0e8ac8a6018f9$var$needsSubResolver(prop, value) ? $8ae0e8ac8a6018f9$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $8ae0e8ac8a6018f9$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if ($8ae0e8ac8a6018f9$var$defined(value)) return value;
    }
}
function $8ae0e8ac8a6018f9$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $8ae0e8ac8a6018f9$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $8ae0e8ac8a6018f9$var$resolveKeysFromAllScopes(scopes) {
    const set2 = /* @__PURE__ */ new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set2.add(key);
    return Array.from(set2);
}
function $8ae0e8ac8a6018f9$var$_parseObjectDataRadialScale(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = "r" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index2, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index2 = i + start;
        item = data[index2];
        parsed[i] = {
            r: iScale.parse($8ae0e8ac8a6018f9$var$resolveObjectKey(item, key), index2)
        };
    }
    return parsed;
}
const $8ae0e8ac8a6018f9$var$EPSILON = Number.EPSILON || 1e-14;
const $8ae0e8ac8a6018f9$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $8ae0e8ac8a6018f9$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $8ae0e8ac8a6018f9$var$splineCurve(firstPoint, middlePoint, afterPoint, t) {
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $8ae0e8ac8a6018f9$var$distanceBetweenPoints(current, previous);
    const d12 = $8ae0e8ac8a6018f9$var$distanceBetweenPoints(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01;
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
function $8ae0e8ac8a6018f9$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $8ae0e8ac8a6018f9$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $8ae0e8ac8a6018f9$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($8ae0e8ac8a6018f9$var$almostEquals(deltaK[i], 0, $8ae0e8ac8a6018f9$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $8ae0e8ac8a6018f9$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $8ae0e8ac8a6018f9$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $8ae0e8ac8a6018f9$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $8ae0e8ac8a6018f9$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
function $8ae0e8ac8a6018f9$var$splineCurveMonotone(points, indexAxis = "x") {
    const valueAxis = $8ae0e8ac8a6018f9$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    let i, pointBefore, pointCurrent;
    let pointAfter = $8ae0e8ac8a6018f9$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $8ae0e8ac8a6018f9$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $8ae0e8ac8a6018f9$var$sign(deltaK[i - 1]) !== $8ae0e8ac8a6018f9$var$sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $8ae0e8ac8a6018f9$var$monotoneAdjust(points, deltaK, mK);
    $8ae0e8ac8a6018f9$var$monotoneCompute(points, mK, indexAxis);
}
function $8ae0e8ac8a6018f9$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $8ae0e8ac8a6018f9$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $8ae0e8ac8a6018f9$var$_isPointInArea(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $8ae0e8ac8a6018f9$var$_isPointInArea(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $8ae0e8ac8a6018f9$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $8ae0e8ac8a6018f9$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $8ae0e8ac8a6018f9$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $8ae0e8ac8a6018f9$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
function $8ae0e8ac8a6018f9$var$_updateBezierControlPoints(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $8ae0e8ac8a6018f9$var$splineCurveMonotone(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $8ae0e8ac8a6018f9$var$splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $8ae0e8ac8a6018f9$var$capBezierPoints(points, area);
}
function $8ae0e8ac8a6018f9$var$_isDomSupported() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function $8ae0e8ac8a6018f9$var$_getParentNode(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
function $8ae0e8ac8a6018f9$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $8ae0e8ac8a6018f9$var$getComputedStyle$1 = (element2)=>window.getComputedStyle(element2, null);
function $8ae0e8ac8a6018f9$var$getStyle(el, property) {
    return $8ae0e8ac8a6018f9$var$getComputedStyle$1(el).getPropertyValue(property);
}
const $8ae0e8ac8a6018f9$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $8ae0e8ac8a6018f9$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $8ae0e8ac8a6018f9$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $8ae0e8ac8a6018f9$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
function $8ae0e8ac8a6018f9$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($8ae0e8ac8a6018f9$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
function $8ae0e8ac8a6018f9$var$getRelativePosition(evt, chart) {
    if ("native" in evt) return evt;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $8ae0e8ac8a6018f9$var$getComputedStyle$1(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $8ae0e8ac8a6018f9$var$getPositionedStyle(style, "padding");
    const borders = $8ae0e8ac8a6018f9$var$getPositionedStyle(style, "border", "width");
    const { x: x, y: y, box: box } = $8ae0e8ac8a6018f9$var$getCanvasPosition(evt, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $8ae0e8ac8a6018f9$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === void 0 || height === void 0) {
        const container = $8ae0e8ac8a6018f9$var$_getParentNode(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect();
            const containerStyle = $8ae0e8ac8a6018f9$var$getComputedStyle$1(container);
            const containerBorder = $8ae0e8ac8a6018f9$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $8ae0e8ac8a6018f9$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $8ae0e8ac8a6018f9$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $8ae0e8ac8a6018f9$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $8ae0e8ac8a6018f9$var$INFINITY,
        maxHeight: maxHeight || $8ae0e8ac8a6018f9$var$INFINITY
    };
}
const $8ae0e8ac8a6018f9$var$round1 = (v)=>Math.round(v * 10) / 10;
function $8ae0e8ac8a6018f9$var$getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $8ae0e8ac8a6018f9$var$getComputedStyle$1(canvas);
    const margins = $8ae0e8ac8a6018f9$var$getPositionedStyle(style, "margin");
    const maxWidth = $8ae0e8ac8a6018f9$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $8ae0e8ac8a6018f9$var$INFINITY;
    const maxHeight = $8ae0e8ac8a6018f9$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $8ae0e8ac8a6018f9$var$INFINITY;
    const containerSize = $8ae0e8ac8a6018f9$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $8ae0e8ac8a6018f9$var$getPositionedStyle(style, "border", "width");
        const paddings = $8ae0e8ac8a6018f9$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height - margins.height);
    width = $8ae0e8ac8a6018f9$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $8ae0e8ac8a6018f9$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) height = $8ae0e8ac8a6018f9$var$round1(width / 2);
    return {
        width: width,
        height: height
    };
}
function $8ae0e8ac8a6018f9$var$retinaScale(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = deviceHeight / pixelRatio;
    chart.width = deviceWidth / pixelRatio;
    const canvas = chart.canvas;
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
const $8ae0e8ac8a6018f9$var$supportsEventListenerOptions = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch (e) {}
    return passiveSupported;
}();
function $8ae0e8ac8a6018f9$var$readUsedSize(element2, property) {
    const value = $8ae0e8ac8a6018f9$var$getStyle(element2, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : void 0;
}
function $8ae0e8ac8a6018f9$var$_pointInLine(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
function $8ae0e8ac8a6018f9$var$_steppedInterpolation(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
function $8ae0e8ac8a6018f9$var$_bezierInterpolation(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $8ae0e8ac8a6018f9$var$_pointInLine(p1, cp1, t);
    const b = $8ae0e8ac8a6018f9$var$_pointInLine(cp1, cp2, t);
    const c = $8ae0e8ac8a6018f9$var$_pointInLine(cp2, p2, t);
    const d = $8ae0e8ac8a6018f9$var$_pointInLine(a, b, t);
    const e = $8ae0e8ac8a6018f9$var$_pointInLine(b, c, t);
    return $8ae0e8ac8a6018f9$var$_pointInLine(d, e, t);
}
const $8ae0e8ac8a6018f9$var$intlCache = /* @__PURE__ */ new Map();
function $8ae0e8ac8a6018f9$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $8ae0e8ac8a6018f9$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $8ae0e8ac8a6018f9$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $8ae0e8ac8a6018f9$var$formatNumber(num, locale, options) {
    return $8ae0e8ac8a6018f9$var$getNumberFormat(locale, options).format(num);
}
const $8ae0e8ac8a6018f9$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $8ae0e8ac8a6018f9$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $8ae0e8ac8a6018f9$var$getRtlAdapter(rtl, rectX, width) {
    return rtl ? $8ae0e8ac8a6018f9$var$getRightToLeftAdapter(rectX, width) : $8ae0e8ac8a6018f9$var$getLeftToRightAdapter();
}
function $8ae0e8ac8a6018f9$var$overrideTextDirection(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $8ae0e8ac8a6018f9$var$restoreTextDirection(ctx, original) {
    if (original !== void 0) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $8ae0e8ac8a6018f9$var$propertyFn(property) {
    if (property === "angle") return {
        between: $8ae0e8ac8a6018f9$var$_angleBetween,
        compare: $8ae0e8ac8a6018f9$var$_angleDiff,
        normalize: $8ae0e8ac8a6018f9$var$_normalizeAngle
    };
    return {
        between: $8ae0e8ac8a6018f9$var$_isBetween,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $8ae0e8ac8a6018f9$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $8ae0e8ac8a6018f9$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $8ae0e8ac8a6018f9$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $8ae0e8ac8a6018f9$var$_boundSegment(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $8ae0e8ac8a6018f9$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $8ae0e8ac8a6018f9$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($8ae0e8ac8a6018f9$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($8ae0e8ac8a6018f9$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $8ae0e8ac8a6018f9$var$_boundSegments(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $8ae0e8ac8a6018f9$var$_boundSegment(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $8ae0e8ac8a6018f9$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $8ae0e8ac8a6018f9$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $8ae0e8ac8a6018f9$var$_computeSegments(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $8ae0e8ac8a6018f9$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $8ae0e8ac8a6018f9$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $8ae0e8ac8a6018f9$var$splitByStyles(line, $8ae0e8ac8a6018f9$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $8ae0e8ac8a6018f9$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $8ae0e8ac8a6018f9$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $8ae0e8ac8a6018f9$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $8ae0e8ac8a6018f9$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $8ae0e8ac8a6018f9$var$readStyle(segmentOptions.setContext($8ae0e8ac8a6018f9$var$createContext(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($8ae0e8ac8a6018f9$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $8ae0e8ac8a6018f9$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $8ae0e8ac8a6018f9$var$styleChanged(style, prevStyle) {
    return prevStyle && JSON.stringify(style) !== JSON.stringify(prevStyle);
}
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */ class $8ae0e8ac8a6018f9$var$Animator {
    constructor(){
        this._request = null;
        this._charts = /* @__PURE__ */ new Map();
        this._running = false;
        this._lastDate = void 0;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = $8ae0e8ac8a6018f9$var$requestAnimFrame.call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw2 = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw2 = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw2) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $8ae0e8ac8a6018f9$var$animator = new $8ae0e8ac8a6018f9$var$Animator();
const $8ae0e8ac8a6018f9$var$transparent = "transparent";
const $8ae0e8ac8a6018f9$var$interpolators = {
    boolean (from2, to2, factor) {
        return factor > 0.5 ? to2 : from2;
    },
    color (from2, to2, factor) {
        const c0 = $8ae0e8ac8a6018f9$var$color(from2 || $8ae0e8ac8a6018f9$var$transparent);
        const c1 = c0.valid && $8ae0e8ac8a6018f9$var$color(to2 || $8ae0e8ac8a6018f9$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to2;
    },
    number (from2, to2, factor) {
        return from2 + (to2 - from2) * factor;
    }
};
class $8ae0e8ac8a6018f9$var$Animation {
    constructor(cfg, target, prop, to2){
        const currentValue = target[prop];
        to2 = $8ae0e8ac8a6018f9$var$resolve([
            cfg.to,
            to2,
            currentValue,
            cfg.from
        ]);
        const from2 = $8ae0e8ac8a6018f9$var$resolve([
            cfg.from,
            currentValue,
            to2
        ]);
        this._active = true;
        this._fn = cfg.fn || $8ae0e8ac8a6018f9$var$interpolators[cfg.type || typeof from2];
        this._easing = $8ae0e8ac8a6018f9$var$effects[cfg.easing] || $8ae0e8ac8a6018f9$var$effects.linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from2;
        this._to = to2;
        this._promises = void 0;
    }
    active() {
        return this._active;
    }
    update(cfg, to2, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = $8ae0e8ac8a6018f9$var$resolve([
                cfg.to,
                to2,
                currentValue,
                cfg.from
            ]);
            this._from = $8ae0e8ac8a6018f9$var$resolve([
                cfg.from,
                currentValue,
                to2
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from2 = this._from;
        const loop = this._loop;
        const to2 = this._to;
        let factor;
        this._active = from2 !== to2 && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to2;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from2;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from2, to2, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
const $8ae0e8ac8a6018f9$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $8ae0e8ac8a6018f9$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
$8ae0e8ac8a6018f9$var$defaults.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
});
const $8ae0e8ac8a6018f9$var$animationOptions = Object.keys($8ae0e8ac8a6018f9$var$defaults.animation);
$8ae0e8ac8a6018f9$var$defaults.describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
});
$8ae0e8ac8a6018f9$var$defaults.set("animations", {
    colors: {
        type: "color",
        properties: $8ae0e8ac8a6018f9$var$colors
    },
    numbers: {
        type: "number",
        properties: $8ae0e8ac8a6018f9$var$numbers
    }
});
$8ae0e8ac8a6018f9$var$defaults.describe("animations", {
    _fallback: "animation"
});
$8ae0e8ac8a6018f9$var$defaults.set("transitions", {
    active: {
        animation: {
            duration: 400
        }
    },
    resize: {
        animation: {
            duration: 0
        }
    },
    show: {
        animations: {
            colors: {
                from: "transparent"
            },
            visible: {
                type: "boolean",
                duration: 0
            }
        }
    },
    hide: {
        animations: {
            colors: {
                to: "transparent"
            },
            visible: {
                type: "boolean",
                easing: "linear",
                fn: (v)=>v | 0
            }
        }
    }
});
class $8ae0e8ac8a6018f9$var$Animations {
    constructor(chart, config){
        this._chart = chart;
        this._properties = /* @__PURE__ */ new Map();
        this.configure(config);
    }
    configure(config) {
        if (!$8ae0e8ac8a6018f9$var$isObject(config)) return;
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!$8ae0e8ac8a6018f9$var$isObject(cfg)) return;
            const resolved = {};
            for (const option of $8ae0e8ac8a6018f9$var$animationOptions)resolved[option] = cfg[option];
            ($8ae0e8ac8a6018f9$var$isArray(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $8ae0e8ac8a6018f9$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $8ae0e8ac8a6018f9$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $8ae0e8ac8a6018f9$var$Animation(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $8ae0e8ac8a6018f9$var$animator.add(this._chart, animations);
            return true;
        }
    }
}
function $8ae0e8ac8a6018f9$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $8ae0e8ac8a6018f9$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $8ae0e8ac8a6018f9$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === void 0 ? allowedOverflow : 0;
    const max = opts.max === void 0 ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $8ae0e8ac8a6018f9$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $8ae0e8ac8a6018f9$var$scaleClip(xScale, allowedOverflow);
    const y = $8ae0e8ac8a6018f9$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $8ae0e8ac8a6018f9$var$toClip(value) {
    let t, r, b, l;
    if ($8ae0e8ac8a6018f9$var$isObject(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $8ae0e8ac8a6018f9$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $8ae0e8ac8a6018f9$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ($8ae0e8ac8a6018f9$var$isNumberFinite(otherValue) && (singleMode || value === 0 || $8ae0e8ac8a6018f9$var$sign(value) === $8ae0e8ac8a6018f9$var$sign(otherValue))) value += otherValue;
    }
    return value;
}
function $8ae0e8ac8a6018f9$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $8ae0e8ac8a6018f9$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === void 0 && meta.stack !== void 0;
}
function $8ae0e8ac8a6018f9$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $8ae0e8ac8a6018f9$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $8ae0e8ac8a6018f9$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $8ae0e8ac8a6018f9$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $8ae0e8ac8a6018f9$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $8ae0e8ac8a6018f9$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index2, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $8ae0e8ac8a6018f9$var$getOrCreateStack(stacks, key, index2);
        stack[datasetIndex] = value;
        stack._top = $8ae0e8ac8a6018f9$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $8ae0e8ac8a6018f9$var$getLastIndexInStack(stack, vScale, false, meta.type);
    }
}
function $8ae0e8ac8a6018f9$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $8ae0e8ac8a6018f9$var$createDatasetContext(parent, index2) {
    return $8ae0e8ac8a6018f9$var$createContext(parent, {
        active: false,
        dataset: void 0,
        datasetIndex: index2,
        index: index2,
        mode: "default",
        type: "dataset"
    });
}
function $8ae0e8ac8a6018f9$var$createDataContext(parent, index2, element2) {
    return $8ae0e8ac8a6018f9$var$createContext(parent, {
        active: false,
        dataIndex: index2,
        parsed: void 0,
        raw: void 0,
        element: element2,
        index: index2,
        mode: "default",
        type: "data"
    });
}
function $8ae0e8ac8a6018f9$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === void 0 || stacks[axis][datasetIndex] === void 0) return;
        delete stacks[axis][datasetIndex];
    }
}
const $8ae0e8ac8a6018f9$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $8ae0e8ac8a6018f9$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $8ae0e8ac8a6018f9$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $8ae0e8ac8a6018f9$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $8ae0e8ac8a6018f9$var$DatasetController {
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = void 0;
        this._parsing = false;
        this._data = void 0;
        this._objectData = void 0;
        this._sharedOptions = void 0;
        this._drawStart = void 0;
        this._drawCount = void 0;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = void 0;
        this._syncList = [];
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $8ae0e8ac8a6018f9$var$isStacked(meta.vScale, meta);
        this.addElements();
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $8ae0e8ac8a6018f9$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = $8ae0e8ac8a6018f9$var$valueOrDefault(dataset.xAxisID, $8ae0e8ac8a6018f9$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = $8ae0e8ac8a6018f9$var$valueOrDefault(dataset.yAxisID, $8ae0e8ac8a6018f9$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = $8ae0e8ac8a6018f9$var$valueOrDefault(dataset.rAxisID, $8ae0e8ac8a6018f9$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) $8ae0e8ac8a6018f9$var$unlistenArrayEvents(this._data, this);
        if (meta._stacked) $8ae0e8ac8a6018f9$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ($8ae0e8ac8a6018f9$var$isObject(data)) this._data = $8ae0e8ac8a6018f9$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                $8ae0e8ac8a6018f9$var$unlistenArrayEvents(_data, this);
                const meta = this._cachedMeta;
                $8ae0e8ac8a6018f9$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) $8ae0e8ac8a6018f9$var$listenArrayEvents(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $8ae0e8ac8a6018f9$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $8ae0e8ac8a6018f9$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $8ae0e8ac8a6018f9$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ($8ae0e8ac8a6018f9$var$isArray(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ($8ae0e8ac8a6018f9$var$isObject(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $8ae0e8ac8a6018f9$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index2;
        for(i = 0, ilen = count; i < ilen; ++i){
            index2 = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index2], index2),
                [vAxis]: vScale.parse(data[index2], index2)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index2, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index2 = i + start;
            item = data[index2];
            parsed[i] = {
                x: xScale.parse(item[0], index2),
                y: yScale.parse(item[1], index2)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index2, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index2 = i + start;
            item = data[index2];
            parsed[i] = {
                x: xScale.parse($8ae0e8ac8a6018f9$var$resolveObjectKey(item, xAxisKey), index2),
                y: yScale.parse($8ae0e8ac8a6018f9$var$resolveObjectKey(item, yAxisKey), index2)
            };
        }
        return parsed;
    }
    getParsed(index2) {
        return this._cachedMeta._parsed[index2];
    }
    getDataElement(index2) {
        return this._cachedMeta.data[index2];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $8ae0e8ac8a6018f9$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]
        };
        return $8ae0e8ac8a6018f9$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $8ae0e8ac8a6018f9$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $8ae0e8ac8a6018f9$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $8ae0e8ac8a6018f9$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !$8ae0e8ac8a6018f9$var$isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ($8ae0e8ac8a6018f9$var$isNumberFinite(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index2) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index2);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $8ae0e8ac8a6018f9$var$toClip($8ae0e8ac8a6018f9$var$valueOrDefault(this.options.clip, $8ae0e8ac8a6018f9$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element2 = elements[i];
            if (element2.hidden) continue;
            if (element2.active && drawActiveElementsOnTop) active.push(element2);
            else element2.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index2, active) {
        const mode = active ? "active" : "default";
        return index2 === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index2 || 0, mode);
    }
    getContext(index2, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index2 >= 0 && index2 < this._cachedMeta.data.length) {
            const element2 = this._cachedMeta.data[index2];
            context = element2.$context || (element2.$context = $8ae0e8ac8a6018f9$var$createDataContext(this.getContext(), index2, element2));
            context.parsed = this.getParsed(index2);
            context.raw = dataset.data[index2];
            context.index = context.dataIndex = index2;
        } else {
            context = this.$context || (this.$context = $8ae0e8ac8a6018f9$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index2, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index2);
    }
    _resolveElementOptions(elementType, mode = "default", index2) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && $8ae0e8ac8a6018f9$var$defined(index2);
        if (cached) return $8ae0e8ac8a6018f9$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names2 = Object.keys($8ae0e8ac8a6018f9$var$defaults.elements[elementType]);
        const context = ()=>this.getContext(index2, active);
        const values = config.resolveNamedOptions(scopes, names2, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($8ae0e8ac8a6018f9$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index2, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index2, active, transition));
        }
        const animations = new $8ae0e8ac8a6018f9$var$Animations(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $8ae0e8ac8a6018f9$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element2, index2, properties, mode) {
        if ($8ae0e8ac8a6018f9$var$isDirectUpdateMode(mode)) Object.assign(element2, properties);
        else this._resolveAnimations(index2, mode).update(element2, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$8ae0e8ac8a6018f9$var$isDirectUpdateMode(mode)) this._resolveAnimations(void 0, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element2, index2, mode, active) {
        element2.active = active;
        const options = this.getStyle(index2, active);
        this._resolveAnimations(index2, mode, active).update(element2, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element2, datasetIndex, index2) {
        this._setStyle(element2, index2, "active", false);
    }
    setHoverStyle(element2, datasetIndex, index2) {
        this._setStyle(element2, index2, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element2 = this._cachedMeta.dataset;
        if (element2) this._setStyle(element2, void 0, "active", false);
    }
    _setDatasetHoverStyle() {
        const element2 = this._cachedMeta.dataset;
        if (element2) this._setStyle(element2, void 0, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element2, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $8ae0e8ac8a6018f9$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
$8ae0e8ac8a6018f9$var$DatasetController.defaults = {};
$8ae0e8ac8a6018f9$var$DatasetController.prototype.datasetElementType = null;
$8ae0e8ac8a6018f9$var$DatasetController.prototype.dataElementType = null;
function $8ae0e8ac8a6018f9$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = $8ae0e8ac8a6018f9$var$_arrayUnique(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $8ae0e8ac8a6018f9$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $8ae0e8ac8a6018f9$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ($8ae0e8ac8a6018f9$var$defined(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = void 0;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $8ae0e8ac8a6018f9$var$computeFitCategoryTraits(index2, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ($8ae0e8ac8a6018f9$var$isNullOrUndef(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index2] - size / 2
    };
}
function $8ae0e8ac8a6018f9$var$computeFlexCategoryTraits(index2, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index2];
    let prev = index2 > 0 ? pixels[index2 - 1] : null;
    let next = index2 < pixels.length - 1 ? pixels[index2 + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $8ae0e8ac8a6018f9$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $8ae0e8ac8a6018f9$var$parseValue(entry, item, vScale, i) {
    if ($8ae0e8ac8a6018f9$var$isArray(entry)) $8ae0e8ac8a6018f9$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $8ae0e8ac8a6018f9$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($8ae0e8ac8a6018f9$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $8ae0e8ac8a6018f9$var$isFloatBar(custom) {
    return custom && custom.barStart !== void 0 && custom.barEnd !== void 0;
}
function $8ae0e8ac8a6018f9$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return $8ae0e8ac8a6018f9$var$sign(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $8ae0e8ac8a6018f9$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $8ae0e8ac8a6018f9$var$setBorderSkipped(properties, options, stack, index2) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $8ae0e8ac8a6018f9$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index2) edge = top;
        else if ((stack._bottom || 0) === index2) edge = bottom;
        else {
            res[$8ae0e8ac8a6018f9$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$8ae0e8ac8a6018f9$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $8ae0e8ac8a6018f9$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $8ae0e8ac8a6018f9$var$swap(edge, a, b);
        edge = $8ae0e8ac8a6018f9$var$startEnd(edge, b, a);
    } else edge = $8ae0e8ac8a6018f9$var$startEnd(edge, a, b);
    return edge;
}
function $8ae0e8ac8a6018f9$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $8ae0e8ac8a6018f9$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $8ae0e8ac8a6018f9$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $8ae0e8ac8a6018f9$var$BarController extends $8ae0e8ac8a6018f9$var$DatasetController {
    parsePrimitiveData(meta, data, start, count) {
        return $8ae0e8ac8a6018f9$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $8ae0e8ac8a6018f9$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = "x", yAxisKey: yAxisKey = "y" } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse($8ae0e8ac8a6018f9$var$resolveObjectKey(obj, iAxisKey), i);
            parsed.push($8ae0e8ac8a6018f9$var$parseValue($8ae0e8ac8a6018f9$var$resolveObjectKey(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index2) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index2);
        const custom = parsed._custom;
        const value = $8ae0e8ac8a6018f9$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index2, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || $8ae0e8ac8a6018f9$var$isNullOrUndef(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $8ae0e8ac8a6018f9$var$isFloatBar(parsed._custom) || index2 === stack._top || index2 === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $8ae0e8ac8a6018f9$var$setBorderSkipped(properties, options, stack, index2);
            $8ae0e8ac8a6018f9$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ($8ae0e8ac8a6018f9$var$isNullOrUndef(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== void 0 && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === void 0 && meta.stack === void 0) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(void 0);
        return stacks;
    }
    _getStackCount(index2) {
        return this._getStacks(void 0, index2).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index2 = name !== void 0 ? stacks.indexOf(name) : -1;
        return index2 === -1 ? stacks.length - 1 : index2;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $8ae0e8ac8a6018f9$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index2) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index2);
        const custom = parsed._custom;
        const floating = $8ae0e8ac8a6018f9$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && $8ae0e8ac8a6018f9$var$sign(value) !== $8ae0e8ac8a6018f9$var$sign(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !$8ae0e8ac8a6018f9$var$isNullOrUndef(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index2)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $8ae0e8ac8a6018f9$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = $8ae0e8ac8a6018f9$var$sign(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index2, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = $8ae0e8ac8a6018f9$var$valueOrDefault(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index2) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $8ae0e8ac8a6018f9$var$computeFlexCategoryTraits(index2, ruler, options, stackCount) : $8ae0e8ac8a6018f9$var$computeFitCategoryTraits(index2, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index2 : void 0);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index2)[scale.axis], index2);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
$8ae0e8ac8a6018f9$var$BarController.id = "bar";
$8ae0e8ac8a6018f9$var$BarController.defaults = {
    datasetElementType: false,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "base",
                "width",
                "height"
            ]
        }
    }
};
$8ae0e8ac8a6018f9$var$BarController.overrides = {
    scales: {
        _index_: {
            type: "category",
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: "linear",
            beginAtZero: true
        }
    }
};
class $8ae0e8ac8a6018f9$var$BubbleController extends $8ae0e8ac8a6018f9$var$DatasetController {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = $8ae0e8ac8a6018f9$var$valueOrDefault(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = $8ae0e8ac8a6018f9$var$valueOrDefault(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index2) {
        const meta = this._cachedMeta;
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index2);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: meta.label,
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index2, mode) {
        const parsed = this.getParsed(index2);
        let values = super.resolveDataElementOptions(index2, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += $8ae0e8ac8a6018f9$var$valueOrDefault(parsed && parsed._custom, radius);
        return values;
    }
}
$8ae0e8ac8a6018f9$var$BubbleController.id = "bubble";
$8ae0e8ac8a6018f9$var$BubbleController.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "borderWidth",
                "radius"
            ]
        }
    }
};
$8ae0e8ac8a6018f9$var$BubbleController.overrides = {
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                }
            }
        }
    }
};
function $8ae0e8ac8a6018f9$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < $8ae0e8ac8a6018f9$var$TAU) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>$8ae0e8ac8a6018f9$var$_angleBetween(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>$8ae0e8ac8a6018f9$var$_angleBetween(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax($8ae0e8ac8a6018f9$var$HALF_PI, startY, endY);
        const minX = calcMin($8ae0e8ac8a6018f9$var$PI, startX, endX);
        const minY = calcMin($8ae0e8ac8a6018f9$var$PI + $8ae0e8ac8a6018f9$var$HALF_PI, startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $8ae0e8ac8a6018f9$var$DoughnutController extends $8ae0e8ac8a6018f9$var$DatasetController {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = void 0;
        this.outerRadius = void 0;
        this.offsetX = void 0;
        this.offsetY = void 0;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i2)=>+data[i2];
            if ($8ae0e8ac8a6018f9$var$isObject(data[start])) {
                const { key: key = "value" } = this._parsing;
                getter = (i2)=>+$8ae0e8ac8a6018f9$var$resolveObjectKey(data[i2], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return $8ae0e8ac8a6018f9$var$toRadians(this.options.rotation - 90);
    }
    _getCircumference() {
        return $8ae0e8ac8a6018f9$var$toRadians(this.options.circumference);
    }
    _getRotationExtents() {
        let min = $8ae0e8ac8a6018f9$var$TAU;
        let max = -$8ae0e8ac8a6018f9$var$TAU;
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i)) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min($8ae0e8ac8a6018f9$var$toPercentage(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $8ae0e8ac8a6018f9$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = $8ae0e8ac8a6018f9$var$toDimension(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / $8ae0e8ac8a6018f9$var$TAU);
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return $8ae0e8ac8a6018f9$var$TAU * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index2) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = $8ae0e8ac8a6018f9$var$formatNumber(meta._parsed[index2], chart.options.locale);
        return {
            label: labels[index2] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max($8ae0e8ac8a6018f9$var$valueOrDefault(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
$8ae0e8ac8a6018f9$var$DoughnutController.id = "doughnut";
$8ae0e8ac8a6018f9$var$DoughnutController.defaults = {
    datasetElementType: false,
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing"
            ]
        }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
};
$8ae0e8ac8a6018f9$var$DoughnutController.descriptors = {
    _scriptable: (name)=>name !== "spacing",
    _indexable: (name)=>name !== "spacing"
};
$8ae0e8ac8a6018f9$var$DoughnutController.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (tooltipItem) {
                    let dataLabel = tooltipItem.label;
                    const value = ": " + tooltipItem.formattedValue;
                    if ($8ae0e8ac8a6018f9$var$isArray(dataLabel)) {
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    }
};
class $8ae0e8ac8a6018f9$var$LineController extends $8ae0e8ac8a6018f9$var$DatasetController {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = $8ae0e8ac8a6018f9$var$_getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ($8ae0e8ac8a6018f9$var$_scaleRangesChanged(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, void 0, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = $8ae0e8ac8a6018f9$var$isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = $8ae0e8ac8a6018f9$var$isNullOrUndef(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
$8ae0e8ac8a6018f9$var$LineController.id = "line";
$8ae0e8ac8a6018f9$var$LineController.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
};
$8ae0e8ac8a6018f9$var$LineController.overrides = {
    scales: {
        _index_: {
            type: "category"
        },
        _value_: {
            type: "linear"
        }
    }
};
class $8ae0e8ac8a6018f9$var$PolarAreaController extends $8ae0e8ac8a6018f9$var$DatasetController {
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = void 0;
        this.outerRadius = void 0;
    }
    getLabelAndValue(index2) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = $8ae0e8ac8a6018f9$var$formatNumber(meta._parsed[index2].r, chart.options.locale);
        return {
            label: labels[index2] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return $8ae0e8ac8a6018f9$var$_parseObjectDataRadialScale.bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element2, index2)=>{
            const parsed = this.getParsed(index2).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index2)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * $8ae0e8ac8a6018f9$var$PI;
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element2, index2)=>{
            if (!isNaN(this.getParsed(index2).r) && this.chart.getDataVisibility(index2)) count++;
        });
        return count;
    }
    _computeAngle(index2, mode, defaultAngle) {
        return this.chart.getDataVisibility(index2) ? $8ae0e8ac8a6018f9$var$toRadians(this.resolveDataElementOptions(index2, mode).angle || defaultAngle) : 0;
    }
}
$8ae0e8ac8a6018f9$var$PolarAreaController.id = "polarArea";
$8ae0e8ac8a6018f9$var$PolarAreaController.defaults = {
    dataElementType: "arc",
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: "number",
            properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius"
            ]
        }
    },
    indexAxis: "r",
    startAngle: 0
};
$8ae0e8ac8a6018f9$var$PolarAreaController.overrides = {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        },
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (context) {
                    return context.chart.data.labels[context.dataIndex] + ": " + context.formattedValue;
                }
            }
        }
    },
    scales: {
        r: {
            type: "radialLinear",
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
};
class $8ae0e8ac8a6018f9$var$PieController extends $8ae0e8ac8a6018f9$var$DoughnutController {
}
$8ae0e8ac8a6018f9$var$PieController.id = "pie";
$8ae0e8ac8a6018f9$var$PieController.defaults = {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: "100%"
};
class $8ae0e8ac8a6018f9$var$RadarController extends $8ae0e8ac8a6018f9$var$DatasetController {
    getLabelAndValue(index2) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index2);
        return {
            label: vScale.getLabels()[index2],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return $8ae0e8ac8a6018f9$var$_parseObjectDataRadialScale.bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, void 0, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
$8ae0e8ac8a6018f9$var$RadarController.id = "radar";
$8ae0e8ac8a6018f9$var$RadarController.defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    indexAxis: "r",
    showLine: true,
    elements: {
        line: {
            fill: "start"
        }
    }
};
$8ae0e8ac8a6018f9$var$RadarController.overrides = {
    aspectRatio: 1,
    scales: {
        r: {
            type: "radialLinear"
        }
    }
};
let $8ae0e8ac8a6018f9$var$Element$1 = class Element2 {
    constructor(){
        this.x = void 0;
        this.y = void 0;
        this.active = false;
        this.options = void 0;
        this.$animations = void 0;
    }
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return $8ae0e8ac8a6018f9$var$isNumber(this.x) && $8ae0e8ac8a6018f9$var$isNumber(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
};
$8ae0e8ac8a6018f9$var$Element$1.defaults = {};
$8ae0e8ac8a6018f9$var$Element$1.defaultRoutes = void 0;
const $8ae0e8ac8a6018f9$var$formatters = {
    values (value) {
        return $8ae0e8ac8a6018f9$var$isArray(value) ? value : "" + value;
    },
    numeric (tickValue, index2, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e15) notation = "scientific";
            delta = $8ae0e8ac8a6018f9$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $8ae0e8ac8a6018f9$var$log10(Math.abs(delta));
        const numDecimal = Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $8ae0e8ac8a6018f9$var$formatNumber(tickValue, locale, options);
    },
    logarithmic (tickValue, index2, ticks) {
        if (tickValue === 0) return "0";
        const remain = tickValue / Math.pow(10, Math.floor($8ae0e8ac8a6018f9$var$log10(tickValue)));
        if (remain === 1 || remain === 2 || remain === 5) return $8ae0e8ac8a6018f9$var$formatters.numeric.call(this, tickValue, index2, ticks);
        return "";
    }
};
function $8ae0e8ac8a6018f9$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $8ae0e8ac8a6018f9$var$Ticks = {
    formatters: $8ae0e8ac8a6018f9$var$formatters
};
$8ae0e8ac8a6018f9$var$defaults.set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    grace: 0,
    grid: {
        display: true,
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickLength: 8,
        tickWidth: (_ctx, options)=>options.lineWidth,
        tickColor: (_ctx, options)=>options.color,
        offset: false,
        borderDash: [],
        borderDashOffset: 0,
        borderWidth: 1
    },
    title: {
        display: false,
        text: "",
        padding: {
            top: 4,
            bottom: 4
        }
    },
    ticks: {
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        textStrokeWidth: 0,
        textStrokeColor: "",
        padding: 3,
        display: true,
        autoSkip: true,
        autoSkipPadding: 3,
        labelOffset: 0,
        callback: $8ae0e8ac8a6018f9$var$Ticks.formatters.values,
        minor: {},
        major: {},
        align: "center",
        crossAlign: "near",
        showLabelBackdrop: false,
        backdropColor: "rgba(255, 255, 255, 0.75)",
        backdropPadding: 2
    }
});
$8ae0e8ac8a6018f9$var$defaults.route("scale.ticks", "color", "", "color");
$8ae0e8ac8a6018f9$var$defaults.route("scale.grid", "color", "", "borderColor");
$8ae0e8ac8a6018f9$var$defaults.route("scale.grid", "borderColor", "", "borderColor");
$8ae0e8ac8a6018f9$var$defaults.route("scale.title", "color", "", "color");
$8ae0e8ac8a6018f9$var$defaults.describe("scale", {
    _fallback: false,
    _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash"
});
$8ae0e8ac8a6018f9$var$defaults.describe("scales", {
    _fallback: "scale"
});
$8ae0e8ac8a6018f9$var$defaults.describe("scale.ticks", {
    _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
    _indexable: (name)=>name !== "backdropPadding"
});
function $8ae0e8ac8a6018f9$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const ticksLimit = tickOpts.maxTicksLimit || $8ae0e8ac8a6018f9$var$determineMaxTicks(scale);
    const majorIndices = tickOpts.major.enabled ? $8ae0e8ac8a6018f9$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $8ae0e8ac8a6018f9$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $8ae0e8ac8a6018f9$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $8ae0e8ac8a6018f9$var$skip(ticks, newTicks, spacing, $8ae0e8ac8a6018f9$var$isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$8ae0e8ac8a6018f9$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $8ae0e8ac8a6018f9$var$skip(ticks, newTicks, spacing, last, $8ae0e8ac8a6018f9$var$isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $8ae0e8ac8a6018f9$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $8ae0e8ac8a6018f9$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $8ae0e8ac8a6018f9$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $8ae0e8ac8a6018f9$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = $8ae0e8ac8a6018f9$var$_factorize(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $8ae0e8ac8a6018f9$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $8ae0e8ac8a6018f9$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $8ae0e8ac8a6018f9$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = $8ae0e8ac8a6018f9$var$valueOrDefault(majorStart, 0);
    const end = Math.min($8ae0e8ac8a6018f9$var$valueOrDefault(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $8ae0e8ac8a6018f9$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $8ae0e8ac8a6018f9$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $8ae0e8ac8a6018f9$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
function $8ae0e8ac8a6018f9$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $8ae0e8ac8a6018f9$var$getPixelForGridLine(scale, index2, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex2 = Math.min(index2, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex2);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index2 === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex2 - 1)) / 2;
        lineValue += validIndex2 < index2 ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $8ae0e8ac8a6018f9$var$garbageCollect(caches, length) {
    $8ae0e8ac8a6018f9$var$each(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $8ae0e8ac8a6018f9$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $8ae0e8ac8a6018f9$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = $8ae0e8ac8a6018f9$var$toFont(options.font, fallback);
    const padding = $8ae0e8ac8a6018f9$var$toPadding(options.padding);
    const lines = $8ae0e8ac8a6018f9$var$isArray(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $8ae0e8ac8a6018f9$var$createScaleContext(parent, scale) {
    return $8ae0e8ac8a6018f9$var$createContext(parent, {
        scale: scale,
        type: "scale"
    });
}
function $8ae0e8ac8a6018f9$var$createTickContext(parent, index2, tick) {
    return $8ae0e8ac8a6018f9$var$createContext(parent, {
        tick: tick,
        index: index2,
        type: "tick"
    });
}
function $8ae0e8ac8a6018f9$var$titleAlign(align, position, reverse) {
    let ret = $8ae0e8ac8a6018f9$var$_toLeftRightCenter(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $8ae0e8ac8a6018f9$var$reverseAlign(ret);
    return ret;
}
function $8ae0e8ac8a6018f9$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, left, right);
        if ($8ae0e8ac8a6018f9$var$isObject(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $8ae0e8ac8a6018f9$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ($8ae0e8ac8a6018f9$var$isObject(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $8ae0e8ac8a6018f9$var$offsetFromEdge(scale, position, offset);
        titleY = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, bottom, top);
        rotation = position === "left" ? -$8ae0e8ac8a6018f9$var$HALF_PI : $8ae0e8ac8a6018f9$var$HALF_PI;
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $8ae0e8ac8a6018f9$var$Scale extends $8ae0e8ac8a6018f9$var$Element$1 {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = void 0;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = void 0;
        this.bottom = void 0;
        this.left = void 0;
        this.right = void 0;
        this.width = void 0;
        this.height = void 0;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = void 0;
        this.maxHeight = void 0;
        this.paddingTop = void 0;
        this.paddingBottom = void 0;
        this.paddingLeft = void 0;
        this.paddingRight = void 0;
        this.axis = void 0;
        this.labelRotation = void 0;
        this.min = void 0;
        this.max = void 0;
        this._range = void 0;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = void 0;
        this._endPixel = void 0;
        this._reversePixels = false;
        this._userMax = void 0;
        this._userMin = void 0;
        this._suggestedMax = void 0;
        this._suggestedMin = void 0;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = void 0;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index2) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = $8ae0e8ac8a6018f9$var$finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
        _userMax = $8ae0e8ac8a6018f9$var$finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = $8ae0e8ac8a6018f9$var$finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = $8ae0e8ac8a6018f9$var$finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: $8ae0e8ac8a6018f9$var$finiteOrDefault(_userMin, _suggestedMin),
            max: $8ae0e8ac8a6018f9$var$finiteOrDefault(_userMax, _suggestedMax),
            minDefined: $8ae0e8ac8a6018f9$var$isNumberFinite(_userMin),
            maxDefined: $8ae0e8ac8a6018f9$var$isNumberFinite(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: $8ae0e8ac8a6018f9$var$finiteOrDefault(min, $8ae0e8ac8a6018f9$var$finiteOrDefault(max, min)),
            max: $8ae0e8ac8a6018f9$var$finiteOrDefault(max, $8ae0e8ac8a6018f9$var$finiteOrDefault(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        $8ae0e8ac8a6018f9$var$callback(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = $8ae0e8ac8a6018f9$var$_addGrace(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $8ae0e8ac8a6018f9$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $8ae0e8ac8a6018f9$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        $8ae0e8ac8a6018f9$var$callback(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        $8ae0e8ac8a6018f9$var$callback(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        $8ae0e8ac8a6018f9$var$callback(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        $8ae0e8ac8a6018f9$var$callback(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        $8ae0e8ac8a6018f9$var$callback(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = $8ae0e8ac8a6018f9$var$callback(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        $8ae0e8ac8a6018f9$var$callback(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        $8ae0e8ac8a6018f9$var$callback(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = this.ticks.length;
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = $8ae0e8ac8a6018f9$var$_limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $8ae0e8ac8a6018f9$var$getTickMarkLength(options.grid) - tickOpts.padding - $8ae0e8ac8a6018f9$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = $8ae0e8ac8a6018f9$var$toDegrees(Math.min(Math.asin($8ae0e8ac8a6018f9$var$_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin($8ae0e8ac8a6018f9$var$_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin($8ae0e8ac8a6018f9$var$_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        $8ae0e8ac8a6018f9$var$callback(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        $8ae0e8ac8a6018f9$var$callback(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $8ae0e8ac8a6018f9$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $8ae0e8ac8a6018f9$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $8ae0e8ac8a6018f9$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = $8ae0e8ac8a6018f9$var$toRadians(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        $8ae0e8ac8a6018f9$var$callback(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ($8ae0e8ac8a6018f9$var$isNullOrUndef(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $8ae0e8ac8a6018f9$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!$8ae0e8ac8a6018f9$var$isNullOrUndef(label) && !$8ae0e8ac8a6018f9$var$isArray(label)) {
                width = $8ae0e8ac8a6018f9$var$_measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ($8ae0e8ac8a6018f9$var$isArray(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!$8ae0e8ac8a6018f9$var$isNullOrUndef(nestedLabel) && !$8ae0e8ac8a6018f9$var$isArray(nestedLabel)) {
                    width = $8ae0e8ac8a6018f9$var$_measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $8ae0e8ac8a6018f9$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index2) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index2) {
        const ticks = this.ticks;
        if (index2 < 0 || index2 > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index2].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return $8ae0e8ac8a6018f9$var$_int16Range(this._alignToPixels ? $8ae0e8ac8a6018f9$var$_alignPixel(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index2) {
        const ticks = this.ticks || [];
        if (index2 >= 0 && index2 < ticks.length) {
            const tick = ticks[index2];
            return tick.$context || (tick.$context = $8ae0e8ac8a6018f9$var$createTickContext(this.getContext(), index2, tick));
        }
        return this.$context || (this.$context = $8ae0e8ac8a6018f9$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = $8ae0e8ac8a6018f9$var$toRadians(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $8ae0e8ac8a6018f9$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = borderOpts.drawBorder ? borderOpts.borderWidth : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return $8ae0e8ac8a6018f9$var$_alignPixel(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ($8ae0e8ac8a6018f9$var$isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ($8ae0e8ac8a6018f9$var$isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = $8ae0e8ac8a6018f9$var$valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const optsAtIndex = grid.setContext(this.getContext(i));
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndex.borderDash || [];
            const borderDashOffset = optsAtIndex.borderDashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $8ae0e8ac8a6018f9$var$getPixelForGridLine(this, i, offset);
            if (lineValue === void 0) continue;
            alignedLineValue = $8ae0e8ac8a6018f9$var$_alignPixel(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $8ae0e8ac8a6018f9$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -$8ae0e8ac8a6018f9$var$toRadians(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ($8ae0e8ac8a6018f9$var$isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ($8ae0e8ac8a6018f9$var$isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = $8ae0e8ac8a6018f9$var$isArray(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color2 = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = $8ae0e8ac8a6018f9$var$toPadding(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = y + textOffset - labelPadding.top;
                let left = x - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                rotation: rotation,
                label: label,
                font: font,
                color: color2,
                strokeColor: strokeColor,
                strokeWidth: strokeWidth,
                textOffset: textOffset,
                textAlign: tickTextAlign,
                textBaseline: textBaseline,
                translation: [
                    x,
                    y
                ],
                backdrop: backdrop
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -$8ae0e8ac8a6018f9$var$toRadians(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index2 = ticks.findIndex((t)=>t.value === value);
        if (index2 >= 0) {
            const opts = grid.setContext(this.getContext(index2));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { grid: grid } } = this;
        const borderOpts = grid.setContext(this.getContext());
        const axisWidth = grid.drawBorder ? borderOpts.borderWidth : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = $8ae0e8ac8a6018f9$var$_alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = $8ae0e8ac8a6018f9$var$_alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = $8ae0e8ac8a6018f9$var$_alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = $8ae0e8ac8a6018f9$var$_alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.borderWidth;
        ctx.strokeStyle = borderOpts.borderColor;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) $8ae0e8ac8a6018f9$var$clipArea(ctx, area);
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        let i, ilen;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            const tickFont = item.font;
            const label = item.label;
            if (item.backdrop) {
                ctx.fillStyle = item.backdrop.color;
                ctx.fillRect(item.backdrop.left, item.backdrop.top, item.backdrop.width, item.backdrop.height);
            }
            let y = item.textOffset;
            $8ae0e8ac8a6018f9$var$renderText(ctx, label, 0, y, tickFont, item);
        }
        if (area) $8ae0e8ac8a6018f9$var$unclipArea(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = $8ae0e8ac8a6018f9$var$toFont(title.font);
        const padding = $8ae0e8ac8a6018f9$var$toPadding(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || $8ae0e8ac8a6018f9$var$isObject(position)) {
            offset += padding.bottom;
            if ($8ae0e8ac8a6018f9$var$isArray(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $8ae0e8ac8a6018f9$var$titleArgs(this, offset, position, align);
        $8ae0e8ac8a6018f9$var$renderText(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $8ae0e8ac8a6018f9$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = $8ae0e8ac8a6018f9$var$valueOrDefault(opts.grid && opts.grid.z, -1);
        if (!this._isVisible() || this.draw !== $8ae0e8ac8a6018f9$var$Scale.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: gz + 1,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index2) {
        const opts = this.options.ticks.setContext(this.getContext(index2));
        return $8ae0e8ac8a6018f9$var$toFont(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $8ae0e8ac8a6018f9$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = /* @__PURE__ */ Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($8ae0e8ac8a6018f9$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $8ae0e8ac8a6018f9$var$registerDefaults(item, scope, parentScope);
        if (this.override) $8ae0e8ac8a6018f9$var$defaults.override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in $8ae0e8ac8a6018f9$var$defaults[scope]) {
            delete $8ae0e8ac8a6018f9$var$defaults[scope][id];
            if (this.override) delete $8ae0e8ac8a6018f9$var$overrides[id];
        }
    }
}
function $8ae0e8ac8a6018f9$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = $8ae0e8ac8a6018f9$var$merge$1(/* @__PURE__ */ Object.create(null), [
        parentScope ? $8ae0e8ac8a6018f9$var$defaults.get(parentScope) : {},
        $8ae0e8ac8a6018f9$var$defaults.get(scope),
        item.defaults
    ]);
    $8ae0e8ac8a6018f9$var$defaults.set(scope, itemDefaults);
    if (item.defaultRoutes) $8ae0e8ac8a6018f9$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) $8ae0e8ac8a6018f9$var$defaults.describe(scope, item.descriptors);
}
function $8ae0e8ac8a6018f9$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        $8ae0e8ac8a6018f9$var$defaults.route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $8ae0e8ac8a6018f9$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $8ae0e8ac8a6018f9$var$Registry {
    constructor(){
        this.controllers = new $8ae0e8ac8a6018f9$var$TypedRegistry($8ae0e8ac8a6018f9$var$DatasetController, "datasets", true);
        this.elements = new $8ae0e8ac8a6018f9$var$TypedRegistry($8ae0e8ac8a6018f9$var$Element$1, "elements");
        this.plugins = new $8ae0e8ac8a6018f9$var$TypedRegistry(Object, "plugins");
        this.scales = new $8ae0e8ac8a6018f9$var$TypedRegistry($8ae0e8ac8a6018f9$var$Scale, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else $8ae0e8ac8a6018f9$var$each(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry2, component) {
        const camelMethod = $8ae0e8ac8a6018f9$var$_capitalize(method);
        $8ae0e8ac8a6018f9$var$callback(component["before" + camelMethod], [], component);
        registry2[method](component);
        $8ae0e8ac8a6018f9$var$callback(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === void 0) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $8ae0e8ac8a6018f9$var$registry = new $8ae0e8ac8a6018f9$var$Registry();
class $8ae0e8ac8a6018f9$var$ScatterController extends $8ae0e8ac8a6018f9$var$DatasetController {
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = $8ae0e8ac8a6018f9$var$_getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ($8ae0e8ac8a6018f9$var$_scaleRangesChanged(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, void 0, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = $8ae0e8ac8a6018f9$var$registry.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = $8ae0e8ac8a6018f9$var$isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = $8ae0e8ac8a6018f9$var$isNullOrUndef(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
$8ae0e8ac8a6018f9$var$ScatterController.id = "scatter";
$8ae0e8ac8a6018f9$var$ScatterController.defaults = {
    datasetElementType: false,
    dataElementType: "point",
    showLine: false,
    fill: false
};
$8ae0e8ac8a6018f9$var$ScatterController.overrides = {
    interaction: {
        mode: "point"
    },
    plugins: {
        tooltip: {
            callbacks: {
                title () {
                    return "";
                },
                label (item) {
                    return "(" + item.label + ", " + item.formattedValue + ")";
                }
            }
        }
    },
    scales: {
        x: {
            type: "linear"
        },
        y: {
            type: "linear"
        }
    }
};
function $8ae0e8ac8a6018f9$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class $8ae0e8ac8a6018f9$var$DateAdapter {
    constructor(options){
        this.options = options || {};
    }
    init(chartOptions) {}
    formats() {
        return $8ae0e8ac8a6018f9$var$abstract();
    }
    parse(value, format) {
        return $8ae0e8ac8a6018f9$var$abstract();
    }
    format(timestamp, format) {
        return $8ae0e8ac8a6018f9$var$abstract();
    }
    add(timestamp, amount, unit) {
        return $8ae0e8ac8a6018f9$var$abstract();
    }
    diff(a, b, unit) {
        return $8ae0e8ac8a6018f9$var$abstract();
    }
    startOf(timestamp, unit, weekday) {
        return $8ae0e8ac8a6018f9$var$abstract();
    }
    endOf(timestamp, unit) {
        return $8ae0e8ac8a6018f9$var$abstract();
    }
}
$8ae0e8ac8a6018f9$var$DateAdapter.override = function(members) {
    Object.assign($8ae0e8ac8a6018f9$var$DateAdapter.prototype, members);
};
var $8ae0e8ac8a6018f9$var$adapters = {
    _date: $8ae0e8ac8a6018f9$var$DateAdapter
};
function $8ae0e8ac8a6018f9$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? $8ae0e8ac8a6018f9$var$_rlookupByKey : $8ae0e8ac8a6018f9$var$_lookupByKey;
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $8ae0e8ac8a6018f9$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index2, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $8ae0e8ac8a6018f9$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element2 = data[j];
            if (!element2.skip) handler(element2, index2, j);
        }
    }
}
function $8ae0e8ac8a6018f9$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $8ae0e8ac8a6018f9$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element2, datasetIndex, index2) {
        if (!includeInvisible && !$8ae0e8ac8a6018f9$var$_isPointInArea(element2, chart.chartArea, 0)) return;
        if (element2.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element2,
            datasetIndex: datasetIndex,
            index: index2
        });
    };
    $8ae0e8ac8a6018f9$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $8ae0e8ac8a6018f9$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element2, datasetIndex, index2) {
        const { startAngle: startAngle, endAngle: endAngle } = element2.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle } = $8ae0e8ac8a6018f9$var$getAngleFromPoint(element2, {
            x: position.x,
            y: position.y
        });
        if ($8ae0e8ac8a6018f9$var$_angleBetween(angle, startAngle, endAngle)) items.push({
            element: element2,
            datasetIndex: datasetIndex,
            index: index2
        });
    }
    $8ae0e8ac8a6018f9$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $8ae0e8ac8a6018f9$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $8ae0e8ac8a6018f9$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element2, datasetIndex, index2) {
        const inRange2 = element2.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange2) return;
        const center = element2.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange2) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element2,
                    datasetIndex: datasetIndex,
                    index: index2
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element2,
            datasetIndex: datasetIndex,
            index: index2
        });
    }
    $8ae0e8ac8a6018f9$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $8ae0e8ac8a6018f9$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $8ae0e8ac8a6018f9$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $8ae0e8ac8a6018f9$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $8ae0e8ac8a6018f9$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $8ae0e8ac8a6018f9$var$evaluateInteractionItems(chart, axis, position, (element2, datasetIndex, index2)=>{
        if (element2[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element2,
                datasetIndex: datasetIndex,
                index: index2
            });
            intersectsItem = intersectsItem || element2.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $8ae0e8ac8a6018f9$var$Interaction = {
    evaluateInteractionItems: $8ae0e8ac8a6018f9$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = $8ae0e8ac8a6018f9$var$getRelativePosition(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $8ae0e8ac8a6018f9$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $8ae0e8ac8a6018f9$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index2 = items[0].index;
                const element2 = meta.data[index2];
                if (element2 && !element2.skip) elements.push({
                    element: element2,
                    datasetIndex: meta.index,
                    index: index2
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = $8ae0e8ac8a6018f9$var$getRelativePosition(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $8ae0e8ac8a6018f9$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $8ae0e8ac8a6018f9$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = $8ae0e8ac8a6018f9$var$getRelativePosition(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $8ae0e8ac8a6018f9$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = $8ae0e8ac8a6018f9$var$getRelativePosition(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $8ae0e8ac8a6018f9$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = $8ae0e8ac8a6018f9$var$getRelativePosition(e, chart);
            return $8ae0e8ac8a6018f9$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = $8ae0e8ac8a6018f9$var$getRelativePosition(e, chart);
            return $8ae0e8ac8a6018f9$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $8ae0e8ac8a6018f9$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $8ae0e8ac8a6018f9$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $8ae0e8ac8a6018f9$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$8ae0e8ac8a6018f9$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $8ae0e8ac8a6018f9$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $8ae0e8ac8a6018f9$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $8ae0e8ac8a6018f9$var$buildStacks(layouts2) {
    const stacks = {};
    for (const wrap of layouts2){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$8ae0e8ac8a6018f9$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $8ae0e8ac8a6018f9$var$setLayoutDims(layouts2, params) {
    const stacks = $8ae0e8ac8a6018f9$var$buildStacks(layouts2);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts2.length; i < ilen; ++i){
        layout = layouts2[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $8ae0e8ac8a6018f9$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $8ae0e8ac8a6018f9$var$wrapBoxes(boxes);
    const fullSize = $8ae0e8ac8a6018f9$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $8ae0e8ac8a6018f9$var$sortByWeight($8ae0e8ac8a6018f9$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $8ae0e8ac8a6018f9$var$sortByWeight($8ae0e8ac8a6018f9$var$filterByPosition(layoutBoxes, "right"));
    const top = $8ae0e8ac8a6018f9$var$sortByWeight($8ae0e8ac8a6018f9$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $8ae0e8ac8a6018f9$var$sortByWeight($8ae0e8ac8a6018f9$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $8ae0e8ac8a6018f9$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $8ae0e8ac8a6018f9$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $8ae0e8ac8a6018f9$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $8ae0e8ac8a6018f9$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $8ae0e8ac8a6018f9$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $8ae0e8ac8a6018f9$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!$8ae0e8ac8a6018f9$var$isObject(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $8ae0e8ac8a6018f9$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $8ae0e8ac8a6018f9$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $8ae0e8ac8a6018f9$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $8ae0e8ac8a6018f9$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $8ae0e8ac8a6018f9$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions2) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions2.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $8ae0e8ac8a6018f9$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $8ae0e8ac8a6018f9$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $8ae0e8ac8a6018f9$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $8ae0e8ac8a6018f9$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $8ae0e8ac8a6018f9$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $8ae0e8ac8a6018f9$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ($8ae0e8ac8a6018f9$var$defined(stack.start)) y = stack.start;
            if (box.fullSize) $8ae0e8ac8a6018f9$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $8ae0e8ac8a6018f9$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ($8ae0e8ac8a6018f9$var$defined(stack.start)) x = stack.start;
            if (box.fullSize) $8ae0e8ac8a6018f9$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $8ae0e8ac8a6018f9$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
$8ae0e8ac8a6018f9$var$defaults.set("layout", {
    autoPadding: true,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
});
var $8ae0e8ac8a6018f9$var$layouts = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index2 = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index2 !== -1) chart.boxes.splice(index2, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = $8ae0e8ac8a6018f9$var$toPadding(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $8ae0e8ac8a6018f9$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        $8ae0e8ac8a6018f9$var$each(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $8ae0e8ac8a6018f9$var$updateMaxPadding(maxPadding, $8ae0e8ac8a6018f9$var$toPadding(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $8ae0e8ac8a6018f9$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $8ae0e8ac8a6018f9$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $8ae0e8ac8a6018f9$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($8ae0e8ac8a6018f9$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $8ae0e8ac8a6018f9$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $8ae0e8ac8a6018f9$var$handleMaxPadding(chartArea);
        $8ae0e8ac8a6018f9$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $8ae0e8ac8a6018f9$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        $8ae0e8ac8a6018f9$var$each(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $8ae0e8ac8a6018f9$var$BasePlatform {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element2, width, height, aspectRatio) {
        width = Math.max(0, width || element2.width);
        height = height || element2.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $8ae0e8ac8a6018f9$var$BasicPlatform extends $8ae0e8ac8a6018f9$var$BasePlatform {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $8ae0e8ac8a6018f9$var$EXPANDO_KEY = "$chartjs";
const $8ae0e8ac8a6018f9$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $8ae0e8ac8a6018f9$var$isNullOrEmpty = (value)=>value === null || value === "";
function $8ae0e8ac8a6018f9$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$8ae0e8ac8a6018f9$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($8ae0e8ac8a6018f9$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = $8ae0e8ac8a6018f9$var$readUsedSize(canvas, "width");
        if (displayWidth !== void 0) canvas.width = displayWidth;
    }
    if ($8ae0e8ac8a6018f9$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = $8ae0e8ac8a6018f9$var$readUsedSize(canvas, "height");
            if (displayHeight !== void 0) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $8ae0e8ac8a6018f9$var$eventListenerOptions = $8ae0e8ac8a6018f9$var$supportsEventListenerOptions ? {
    passive: true
} : false;
function $8ae0e8ac8a6018f9$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $8ae0e8ac8a6018f9$var$eventListenerOptions);
}
function $8ae0e8ac8a6018f9$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $8ae0e8ac8a6018f9$var$eventListenerOptions);
}
function $8ae0e8ac8a6018f9$var$fromNativeEvent(event, chart) {
    const type = $8ae0e8ac8a6018f9$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = $8ae0e8ac8a6018f9$var$getRelativePosition(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== void 0 ? x : null,
        y: y !== void 0 ? y : null
    };
}
function $8ae0e8ac8a6018f9$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $8ae0e8ac8a6018f9$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $8ae0e8ac8a6018f9$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$8ae0e8ac8a6018f9$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $8ae0e8ac8a6018f9$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $8ae0e8ac8a6018f9$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$8ae0e8ac8a6018f9$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $8ae0e8ac8a6018f9$var$drpListeningCharts = /* @__PURE__ */ new Map();
let $8ae0e8ac8a6018f9$var$oldDevicePixelRatio = 0;
function $8ae0e8ac8a6018f9$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $8ae0e8ac8a6018f9$var$oldDevicePixelRatio) return;
    $8ae0e8ac8a6018f9$var$oldDevicePixelRatio = dpr;
    $8ae0e8ac8a6018f9$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $8ae0e8ac8a6018f9$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$8ae0e8ac8a6018f9$var$drpListeningCharts.size) window.addEventListener("resize", $8ae0e8ac8a6018f9$var$onWindowResize);
    $8ae0e8ac8a6018f9$var$drpListeningCharts.set(chart, resize);
}
function $8ae0e8ac8a6018f9$var$unlistenDevicePixelRatioChanges(chart) {
    $8ae0e8ac8a6018f9$var$drpListeningCharts.delete(chart);
    if (!$8ae0e8ac8a6018f9$var$drpListeningCharts.size) window.removeEventListener("resize", $8ae0e8ac8a6018f9$var$onWindowResize);
}
function $8ae0e8ac8a6018f9$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && $8ae0e8ac8a6018f9$var$_getParentNode(canvas);
    if (!container) return;
    const resize = $8ae0e8ac8a6018f9$var$throttled((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $8ae0e8ac8a6018f9$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $8ae0e8ac8a6018f9$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $8ae0e8ac8a6018f9$var$unlistenDevicePixelRatioChanges(chart);
}
function $8ae0e8ac8a6018f9$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = $8ae0e8ac8a6018f9$var$throttled((event)=>{
        if (chart.ctx !== null) listener($8ae0e8ac8a6018f9$var$fromNativeEvent(event, chart));
    }, chart, (args)=>{
        const event = args[0];
        return [
            event,
            event.offsetX,
            event.offsetY
        ];
    });
    $8ae0e8ac8a6018f9$var$addListener(canvas, type, proxy);
    return proxy;
}
class $8ae0e8ac8a6018f9$var$DomPlatform extends $8ae0e8ac8a6018f9$var$BasePlatform {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $8ae0e8ac8a6018f9$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$8ae0e8ac8a6018f9$var$EXPANDO_KEY]) return false;
        const initial = canvas[$8ae0e8ac8a6018f9$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ($8ae0e8ac8a6018f9$var$isNullOrUndef(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$8ae0e8ac8a6018f9$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $8ae0e8ac8a6018f9$var$createAttachObserver,
            detach: $8ae0e8ac8a6018f9$var$createDetachObserver,
            resize: $8ae0e8ac8a6018f9$var$createResizeObserver
        };
        const handler = handlers[type] || $8ae0e8ac8a6018f9$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $8ae0e8ac8a6018f9$var$releaseObserver,
            detach: $8ae0e8ac8a6018f9$var$releaseObserver,
            resize: $8ae0e8ac8a6018f9$var$releaseObserver
        };
        const handler = handlers[type] || $8ae0e8ac8a6018f9$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = void 0;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return $8ae0e8ac8a6018f9$var$getMaximumSize(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = $8ae0e8ac8a6018f9$var$_getParentNode(canvas);
        return !!(container && container.isConnected);
    }
}
function $8ae0e8ac8a6018f9$var$_detectPlatform(canvas) {
    if (!$8ae0e8ac8a6018f9$var$_isDomSupported() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $8ae0e8ac8a6018f9$var$BasicPlatform;
    return $8ae0e8ac8a6018f9$var$DomPlatform;
}
class $8ae0e8ac8a6018f9$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors2 = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors2, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors2, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors2, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors2){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ($8ae0e8ac8a6018f9$var$callback(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!$8ae0e8ac8a6018f9$var$isNullOrUndef(this._cache)) {
            this._oldCache = this._cache;
            this._cache = void 0;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors2 = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors2;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = $8ae0e8ac8a6018f9$var$valueOrDefault(config.options && config.options.plugins, {});
        const plugins = $8ae0e8ac8a6018f9$var$allPlugins(config);
        return options === false && !all ? [] : $8ae0e8ac8a6018f9$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors2 = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors2), chart, "stop");
        this._notify(diff(descriptors2, previousDescriptors), chart, "start");
    }
}
function $8ae0e8ac8a6018f9$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($8ae0e8ac8a6018f9$var$registry.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($8ae0e8ac8a6018f9$var$registry.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $8ae0e8ac8a6018f9$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $8ae0e8ac8a6018f9$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $8ae0e8ac8a6018f9$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $8ae0e8ac8a6018f9$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $8ae0e8ac8a6018f9$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $8ae0e8ac8a6018f9$var$getIndexAxis(type, options) {
    const datasetDefaults = $8ae0e8ac8a6018f9$var$defaults.datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $8ae0e8ac8a6018f9$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $8ae0e8ac8a6018f9$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $8ae0e8ac8a6018f9$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $8ae0e8ac8a6018f9$var$determineAxis(id, scaleOptions) {
    if (id === "x" || id === "y") return id;
    return scaleOptions.axis || $8ae0e8ac8a6018f9$var$axisFromPosition(scaleOptions.position) || id.charAt(0).toLowerCase();
}
function $8ae0e8ac8a6018f9$var$mergeScaleConfig(config, options) {
    const chartDefaults = $8ae0e8ac8a6018f9$var$overrides[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $8ae0e8ac8a6018f9$var$getIndexAxis(config.type, options);
    const firstIDs = /* @__PURE__ */ Object.create(null);
    const scales = /* @__PURE__ */ Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!$8ae0e8ac8a6018f9$var$isObject(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $8ae0e8ac8a6018f9$var$determineAxis(id, scaleConf);
        const defaultId = $8ae0e8ac8a6018f9$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        firstIDs[axis] = firstIDs[axis] || id;
        scales[id] = $8ae0e8ac8a6018f9$var$mergeIf(/* @__PURE__ */ Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $8ae0e8ac8a6018f9$var$getIndexAxis(type, options);
        const datasetDefaults = $8ae0e8ac8a6018f9$var$overrides[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $8ae0e8ac8a6018f9$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || firstIDs[axis] || axis;
            scales[id] = scales[id] || /* @__PURE__ */ Object.create(null);
            $8ae0e8ac8a6018f9$var$mergeIf(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        $8ae0e8ac8a6018f9$var$mergeIf(scale, [
            $8ae0e8ac8a6018f9$var$defaults.scales[scale.type],
            $8ae0e8ac8a6018f9$var$defaults.scale
        ]);
    });
    return scales;
}
function $8ae0e8ac8a6018f9$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = $8ae0e8ac8a6018f9$var$valueOrDefault(options.plugins, {});
    options.scales = $8ae0e8ac8a6018f9$var$mergeScaleConfig(config, options);
}
function $8ae0e8ac8a6018f9$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $8ae0e8ac8a6018f9$var$initConfig(config) {
    config = config || {};
    config.data = $8ae0e8ac8a6018f9$var$initData(config.data);
    $8ae0e8ac8a6018f9$var$initOptions(config);
    return config;
}
const $8ae0e8ac8a6018f9$var$keyCache = /* @__PURE__ */ new Map();
const $8ae0e8ac8a6018f9$var$keysCached = /* @__PURE__ */ new Set();
function $8ae0e8ac8a6018f9$var$cachedKeys(cacheKey, generate) {
    let keys = $8ae0e8ac8a6018f9$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $8ae0e8ac8a6018f9$var$keyCache.set(cacheKey, keys);
        $8ae0e8ac8a6018f9$var$keysCached.add(keys);
    }
    return keys;
}
const $8ae0e8ac8a6018f9$var$addIfFound = (set2, obj, key)=>{
    const opts = $8ae0e8ac8a6018f9$var$resolveObjectKey(obj, key);
    if (opts !== void 0) set2.add(opts);
};
class $8ae0e8ac8a6018f9$var$Config {
    constructor(config){
        this._config = $8ae0e8ac8a6018f9$var$initConfig(config);
        this._scopeCache = /* @__PURE__ */ new Map();
        this._resolverCache = /* @__PURE__ */ new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $8ae0e8ac8a6018f9$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $8ae0e8ac8a6018f9$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $8ae0e8ac8a6018f9$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $8ae0e8ac8a6018f9$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $8ae0e8ac8a6018f9$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $8ae0e8ac8a6018f9$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = /* @__PURE__ */ new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = /* @__PURE__ */ new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$8ae0e8ac8a6018f9$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$8ae0e8ac8a6018f9$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$8ae0e8ac8a6018f9$var$addIfFound(scopes, $8ae0e8ac8a6018f9$var$overrides[type] || {}, key));
            keys.forEach((key)=>$8ae0e8ac8a6018f9$var$addIfFound(scopes, $8ae0e8ac8a6018f9$var$defaults, key));
            keys.forEach((key)=>$8ae0e8ac8a6018f9$var$addIfFound(scopes, $8ae0e8ac8a6018f9$var$descriptors, key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(/* @__PURE__ */ Object.create(null));
        if ($8ae0e8ac8a6018f9$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            $8ae0e8ac8a6018f9$var$overrides[type] || {},
            $8ae0e8ac8a6018f9$var$defaults.datasets[type] || {},
            {
                type: type
            },
            $8ae0e8ac8a6018f9$var$defaults,
            $8ae0e8ac8a6018f9$var$descriptors
        ];
    }
    resolveNamedOptions(scopes, names2, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $8ae0e8ac8a6018f9$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($8ae0e8ac8a6018f9$var$needContext(resolver, names2)) {
            result.$shared = false;
            context = $8ae0e8ac8a6018f9$var$isFunction(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = $8ae0e8ac8a6018f9$var$_attachContext(resolver, context, subResolver);
        }
        for (const prop of names2)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver } = $8ae0e8ac8a6018f9$var$getResolver(this._resolverCache, scopes, prefixes);
        return $8ae0e8ac8a6018f9$var$isObject(context) ? $8ae0e8ac8a6018f9$var$_attachContext(resolver, context, void 0, descriptorDefaults) : resolver;
    }
}
function $8ae0e8ac8a6018f9$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = /* @__PURE__ */ new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = $8ae0e8ac8a6018f9$var$_createResolver(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $8ae0e8ac8a6018f9$var$hasFunction = (value)=>$8ae0e8ac8a6018f9$var$isObject(value) && Object.getOwnPropertyNames(value).reduce((acc, key)=>acc || $8ae0e8ac8a6018f9$var$isFunction(value[key]), false);
function $8ae0e8ac8a6018f9$var$needContext(proxy, names2) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = $8ae0e8ac8a6018f9$var$_descriptors(proxy);
    for (const prop of names2){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ($8ae0e8ac8a6018f9$var$isFunction(value) || $8ae0e8ac8a6018f9$var$hasFunction(value)) || indexable && $8ae0e8ac8a6018f9$var$isArray(value)) return true;
    }
    return false;
}
var $8ae0e8ac8a6018f9$var$version = "3.9.1";
const $8ae0e8ac8a6018f9$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $8ae0e8ac8a6018f9$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $8ae0e8ac8a6018f9$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $8ae0e8ac8a6018f9$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $8ae0e8ac8a6018f9$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions2 = chart.options.animation;
    chart.notifyPlugins("afterRender");
    $8ae0e8ac8a6018f9$var$callback(animationOptions2 && animationOptions2.onComplete, [
        context
    ], chart);
}
function $8ae0e8ac8a6018f9$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions2 = chart.options.animation;
    $8ae0e8ac8a6018f9$var$callback(animationOptions2 && animationOptions2.onProgress, [
        context
    ], chart);
}
function $8ae0e8ac8a6018f9$var$getCanvas(item) {
    if ($8ae0e8ac8a6018f9$var$_isDomSupported() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $8ae0e8ac8a6018f9$var$instances = {};
const $8ae0e8ac8a6018f9$var$getChart = (key)=>{
    const canvas = $8ae0e8ac8a6018f9$var$getCanvas(key);
    return Object.values($8ae0e8ac8a6018f9$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $8ae0e8ac8a6018f9$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $8ae0e8ac8a6018f9$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
let $8ae0e8ac8a6018f9$var$Chart$1 = class Chart {
    constructor(item, userConfig){
        const config = this.config = new $8ae0e8ac8a6018f9$var$Config(userConfig);
        const initialCanvas = $8ae0e8ac8a6018f9$var$getCanvas(item);
        const existingChart = $8ae0e8ac8a6018f9$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "' must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $8ae0e8ac8a6018f9$var$_detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = $8ae0e8ac8a6018f9$var$uid();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = void 0;
        this.boxes = [];
        this.currentDevicePixelRatio = void 0;
        this.chartArea = void 0;
        this._active = [];
        this._lastEvent = void 0;
        this._listeners = {};
        this._responsiveListeners = void 0;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $8ae0e8ac8a6018f9$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = void 0;
        this.$context = void 0;
        this._doResize = $8ae0e8ac8a6018f9$var$debounce((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $8ae0e8ac8a6018f9$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $8ae0e8ac8a6018f9$var$animator.listen(this, "complete", $8ae0e8ac8a6018f9$var$onAnimationsComplete);
        $8ae0e8ac8a6018f9$var$animator.listen(this, "progress", $8ae0e8ac8a6018f9$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!$8ae0e8ac8a6018f9$var$isNullOrUndef(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else $8ae0e8ac8a6018f9$var$retinaScale(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        $8ae0e8ac8a6018f9$var$clearCanvas(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $8ae0e8ac8a6018f9$var$animator.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$8ae0e8ac8a6018f9$var$animator.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!$8ae0e8ac8a6018f9$var$retinaScale(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        $8ae0e8ac8a6018f9$var$callback(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        $8ae0e8ac8a6018f9$var$each(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $8ae0e8ac8a6018f9$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        $8ae0e8ac8a6018f9$var$each(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $8ae0e8ac8a6018f9$var$determineAxis(id, scaleOptions);
            const scaleType = $8ae0e8ac8a6018f9$var$valueOrDefault(scaleOptions.type, item.dtype);
            if (scaleOptions.position === void 0 || $8ae0e8ac8a6018f9$var$positionIsHorizontal(scaleOptions.position, axis) !== $8ae0e8ac8a6018f9$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $8ae0e8ac8a6018f9$var$registry.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        $8ae0e8ac8a6018f9$var$each(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        $8ae0e8ac8a6018f9$var$each(scales, (scale)=>{
            $8ae0e8ac8a6018f9$var$layouts.configure(this, scale, scale.options);
            $8ae0e8ac8a6018f9$var$layouts.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($8ae0e8ac8a6018f9$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index2)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index2);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $8ae0e8ac8a6018f9$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $8ae0e8ac8a6018f9$var$registry.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = $8ae0e8ac8a6018f9$var$defaults.datasets[type];
                Object.assign(ControllerClass.prototype, {
                    dataElementType: $8ae0e8ac8a6018f9$var$registry.getElement(dataElementType),
                    datasetElementType: datasetElementType && $8ae0e8ac8a6018f9$var$registry.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        $8ae0e8ac8a6018f9$var$each(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) $8ae0e8ac8a6018f9$var$each(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($8ae0e8ac8a6018f9$var$compare2Level("z", "_idx"));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        $8ae0e8ac8a6018f9$var$each(this.scales, (scale)=>{
            $8ae0e8ac8a6018f9$var$layouts.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!$8ae0e8ac8a6018f9$var$setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === "_removeElements" ? -count : count;
            $8ae0e8ac8a6018f9$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!$8ae0e8ac8a6018f9$var$setsEqual(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $8ae0e8ac8a6018f9$var$layouts.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        $8ae0e8ac8a6018f9$var$each(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index2)=>{
            item._idx = index2;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, $8ae0e8ac8a6018f9$var$isFunction(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index2, mode) {
        const meta = this.getDatasetMeta(index2);
        const args = {
            meta: meta,
            index: index2,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($8ae0e8ac8a6018f9$var$animator.has(this)) {
            if (this.attached && !$8ae0e8ac8a6018f9$var$animator.running(this)) $8ae0e8ac8a6018f9$var$animator.start(this);
        } else {
            this.draw();
            $8ae0e8ac8a6018f9$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = this.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) $8ae0e8ac8a6018f9$var$clipArea(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) $8ae0e8ac8a6018f9$var$unclipArea(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return $8ae0e8ac8a6018f9$var$_isPointInArea(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $8ae0e8ac8a6018f9$var$Interaction.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = $8ae0e8ac8a6018f9$var$createContext(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index2) {
        this._hiddenIndices[index2] = !this._hiddenIndices[index2];
    }
    getDataVisibility(index2) {
        return !this._hiddenIndices[index2];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(void 0, mode);
        if ($8ae0e8ac8a6018f9$var$defined(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : void 0);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $8ae0e8ac8a6018f9$var$animator.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            $8ae0e8ac8a6018f9$var$clearCanvas(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        this.notifyPlugins("destroy");
        delete $8ae0e8ac8a6018f9$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener2)=>{
            platform.addEventListener(this, type, listener2);
            listeners[type] = listener2;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        $8ae0e8ac8a6018f9$var$each(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener2)=>{
            platform.addEventListener(this, type, listener2);
            listeners[type] = listener2;
        };
        const _remove = (type, listener2)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener2);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        $8ae0e8ac8a6018f9$var$each(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        $8ae0e8ac8a6018f9$var$each(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = void 0;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index2 })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index2],
                index: index2
            };
        });
        const changed = !$8ae0e8ac8a6018f9$var$_elementsEqual(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = $8ae0e8ac8a6018f9$var$_isClickEvent(e);
        const lastEvent = $8ae0e8ac8a6018f9$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            $8ae0e8ac8a6018f9$var$callback(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) $8ae0e8ac8a6018f9$var$callback(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !$8ae0e8ac8a6018f9$var$_elementsEqual(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
};
const $8ae0e8ac8a6018f9$var$invalidatePlugins = ()=>$8ae0e8ac8a6018f9$var$each($8ae0e8ac8a6018f9$var$Chart$1.instances, (chart)=>chart._plugins.invalidate());
const $8ae0e8ac8a6018f9$var$enumerable = true;
Object.defineProperties($8ae0e8ac8a6018f9$var$Chart$1, {
    defaults: {
        enumerable: $8ae0e8ac8a6018f9$var$enumerable,
        value: $8ae0e8ac8a6018f9$var$defaults
    },
    instances: {
        enumerable: $8ae0e8ac8a6018f9$var$enumerable,
        value: $8ae0e8ac8a6018f9$var$instances
    },
    overrides: {
        enumerable: $8ae0e8ac8a6018f9$var$enumerable,
        value: $8ae0e8ac8a6018f9$var$overrides
    },
    registry: {
        enumerable: $8ae0e8ac8a6018f9$var$enumerable,
        value: $8ae0e8ac8a6018f9$var$registry
    },
    version: {
        enumerable: $8ae0e8ac8a6018f9$var$enumerable,
        value: $8ae0e8ac8a6018f9$var$version
    },
    getChart: {
        enumerable: $8ae0e8ac8a6018f9$var$enumerable,
        value: $8ae0e8ac8a6018f9$var$getChart
    },
    register: {
        enumerable: $8ae0e8ac8a6018f9$var$enumerable,
        value: (...items)=>{
            $8ae0e8ac8a6018f9$var$registry.add(...items);
            $8ae0e8ac8a6018f9$var$invalidatePlugins();
        }
    },
    unregister: {
        enumerable: $8ae0e8ac8a6018f9$var$enumerable,
        value: (...items)=>{
            $8ae0e8ac8a6018f9$var$registry.remove(...items);
            $8ae0e8ac8a6018f9$var$invalidatePlugins();
        }
    }
});
function $8ae0e8ac8a6018f9$var$clipArc(ctx, element2, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element2;
    let angleMargin = pixelMargin / outerRadius;
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + $8ae0e8ac8a6018f9$var$HALF_PI, startAngle - $8ae0e8ac8a6018f9$var$HALF_PI);
    ctx.closePath();
    ctx.clip();
}
function $8ae0e8ac8a6018f9$var$toRadiusCorners(value) {
    return $8ae0e8ac8a6018f9$var$_readValueToProps(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
function $8ae0e8ac8a6018f9$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $8ae0e8ac8a6018f9$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return $8ae0e8ac8a6018f9$var$_limitValue(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: $8ae0e8ac8a6018f9$var$_limitValue(o.innerStart, 0, innerLimit),
        innerEnd: $8ae0e8ac8a6018f9$var$_limitValue(o.innerEnd, 0, innerLimit)
    };
}
function $8ae0e8ac8a6018f9$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
function $8ae0e8ac8a6018f9$var$pathArc(ctx, element2, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element2;
    const outerRadius = Math.max(element2.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha2 = end - start;
    if (spacing) {
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha2 * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha2;
        spacingOffset = (alpha2 - adjustedAngle) / 2;
    }
    const beta = Math.max(1e-3, alpha2 * outerRadius - offset / $8ae0e8ac8a6018f9$var$PI) / outerRadius;
    const angleOffset = (alpha2 - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $8ae0e8ac8a6018f9$var$parseBorderRadius$1(element2, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerEndAdjustedAngle);
        if (outerEnd > 0) {
            const pCenter = $8ae0e8ac8a6018f9$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + $8ae0e8ac8a6018f9$var$HALF_PI);
        }
        const p4 = $8ae0e8ac8a6018f9$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        if (innerEnd > 0) {
            const pCenter = $8ae0e8ac8a6018f9$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + $8ae0e8ac8a6018f9$var$HALF_PI, innerEndAdjustedAngle + Math.PI);
        }
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, startAngle + innerStart / innerRadius, true);
        if (innerStart > 0) {
            const pCenter = $8ae0e8ac8a6018f9$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - $8ae0e8ac8a6018f9$var$HALF_PI);
        }
        const p8 = $8ae0e8ac8a6018f9$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        if (outerStart > 0) {
            const pCenter = $8ae0e8ac8a6018f9$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - $8ae0e8ac8a6018f9$var$HALF_PI, outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $8ae0e8ac8a6018f9$var$drawArc(ctx, element2, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element2;
    let endAngle = element2.endAngle;
    if (fullCircles) {
        $8ae0e8ac8a6018f9$var$pathArc(ctx, element2, offset, spacing, startAngle + $8ae0e8ac8a6018f9$var$TAU, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) {
            endAngle = startAngle + circumference % $8ae0e8ac8a6018f9$var$TAU;
            if (circumference % $8ae0e8ac8a6018f9$var$TAU === 0) endAngle += $8ae0e8ac8a6018f9$var$TAU;
        }
    }
    $8ae0e8ac8a6018f9$var$pathArc(ctx, element2, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $8ae0e8ac8a6018f9$var$drawFullCircleBorders(ctx, element2, inner) {
    const { x: x, y: y, startAngle: startAngle, pixelMargin: pixelMargin, fullCircles: fullCircles } = element2;
    const outerRadius = Math.max(element2.outerRadius - pixelMargin, 0);
    const innerRadius = element2.innerRadius + pixelMargin;
    let i;
    if (inner) $8ae0e8ac8a6018f9$var$clipArc(ctx, element2, startAngle + $8ae0e8ac8a6018f9$var$TAU);
    ctx.beginPath();
    ctx.arc(x, y, innerRadius, startAngle + $8ae0e8ac8a6018f9$var$TAU, startAngle, true);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle, startAngle + $8ae0e8ac8a6018f9$var$TAU);
    for(i = 0; i < fullCircles; ++i)ctx.stroke();
}
function $8ae0e8ac8a6018f9$var$drawBorder(ctx, element2, offset, spacing, endAngle, circular) {
    const { options: options } = element2;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    if (element2.fullCircles) $8ae0e8ac8a6018f9$var$drawFullCircleBorders(ctx, element2, inner);
    if (inner) $8ae0e8ac8a6018f9$var$clipArc(ctx, element2, endAngle);
    $8ae0e8ac8a6018f9$var$pathArc(ctx, element2, offset, spacing, endAngle, circular);
    ctx.stroke();
}
class $8ae0e8ac8a6018f9$var$ArcElement extends $8ae0e8ac8a6018f9$var$Element$1 {
    constructor(cfg){
        super();
        this.options = void 0;
        this.circumference = void 0;
        this.startAngle = void 0;
        this.endAngle = void 0;
        this.innerRadius = void 0;
        this.outerRadius = void 0;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle, distance: distance } = $8ae0e8ac8a6018f9$var$getAngleFromPoint(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = this.options.spacing / 2;
        const _circumference = $8ae0e8ac8a6018f9$var$valueOrDefault(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= $8ae0e8ac8a6018f9$var$TAU || $8ae0e8ac8a6018f9$var$_angleBetween(angle, startAngle, endAngle);
        const withinRadius = $8ae0e8ac8a6018f9$var$_isBetween(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 2;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > $8ae0e8ac8a6018f9$var$TAU ? Math.floor(circumference / $8ae0e8ac8a6018f9$var$TAU) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        let radiusOffset = 0;
        if (offset) {
            radiusOffset = offset / 2;
            const halfAngle = (this.startAngle + this.endAngle) / 2;
            ctx.translate(Math.cos(halfAngle) * radiusOffset, Math.sin(halfAngle) * radiusOffset);
            if (this.circumference >= $8ae0e8ac8a6018f9$var$PI) radiusOffset = offset;
        }
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        const endAngle = $8ae0e8ac8a6018f9$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $8ae0e8ac8a6018f9$var$drawBorder(ctx, this, radiusOffset, spacing, endAngle, circular);
        ctx.restore();
    }
}
$8ae0e8ac8a6018f9$var$ArcElement.id = "arc";
$8ae0e8ac8a6018f9$var$ArcElement.defaults = {
    borderAlign: "center",
    borderColor: "#fff",
    borderJoinStyle: void 0,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: void 0,
    circular: true
};
$8ae0e8ac8a6018f9$var$ArcElement.defaultRoutes = {
    backgroundColor: "backgroundColor"
};
function $8ae0e8ac8a6018f9$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = $8ae0e8ac8a6018f9$var$valueOrDefault(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash($8ae0e8ac8a6018f9$var$valueOrDefault(style.borderDash, options.borderDash));
    ctx.lineDashOffset = $8ae0e8ac8a6018f9$var$valueOrDefault(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = $8ae0e8ac8a6018f9$var$valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = $8ae0e8ac8a6018f9$var$valueOrDefault(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = $8ae0e8ac8a6018f9$var$valueOrDefault(style.borderColor, options.borderColor);
}
function $8ae0e8ac8a6018f9$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $8ae0e8ac8a6018f9$var$getLineMethod(options) {
    if (options.stepped) return $8ae0e8ac8a6018f9$var$_steppedLineTo;
    if (options.tension || options.cubicInterpolationMode === "monotone") return $8ae0e8ac8a6018f9$var$_bezierCurveTo;
    return $8ae0e8ac8a6018f9$var$lineTo;
}
function $8ae0e8ac8a6018f9$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $8ae0e8ac8a6018f9$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $8ae0e8ac8a6018f9$var$pathVars(points, segment, params);
    const lineMethod = $8ae0e8ac8a6018f9$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $8ae0e8ac8a6018f9$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $8ae0e8ac8a6018f9$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index2)=>(start + (reverse ? ilen - index2 : index2)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $8ae0e8ac8a6018f9$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $8ae0e8ac8a6018f9$var$fastPathSegment : $8ae0e8ac8a6018f9$var$pathSegment;
}
function $8ae0e8ac8a6018f9$var$_getInterpolationMethod(options) {
    if (options.stepped) return $8ae0e8ac8a6018f9$var$_steppedInterpolation;
    if (options.tension || options.cubicInterpolationMode === "monotone") return $8ae0e8ac8a6018f9$var$_bezierInterpolation;
    return $8ae0e8ac8a6018f9$var$_pointInLine;
}
function $8ae0e8ac8a6018f9$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $8ae0e8ac8a6018f9$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $8ae0e8ac8a6018f9$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $8ae0e8ac8a6018f9$var$_getSegmentMethod(line);
    for (const segment of segments){
        $8ae0e8ac8a6018f9$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $8ae0e8ac8a6018f9$var$usePath2D = typeof Path2D === "function";
function $8ae0e8ac8a6018f9$var$draw(ctx, line, start, count) {
    if ($8ae0e8ac8a6018f9$var$usePath2D && !line.options.segment) $8ae0e8ac8a6018f9$var$strokePathWithCache(ctx, line, start, count);
    else $8ae0e8ac8a6018f9$var$strokePathDirect(ctx, line, start, count);
}
class $8ae0e8ac8a6018f9$var$LineElement extends $8ae0e8ac8a6018f9$var$Element$1 {
    constructor(cfg){
        super();
        this.animated = true;
        this.options = void 0;
        this._chart = void 0;
        this._loop = void 0;
        this._fullLoop = void 0;
        this._path = void 0;
        this._points = void 0;
        this._segments = void 0;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = void 0;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            $8ae0e8ac8a6018f9$var$_updateBezierControlPoints(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = $8ae0e8ac8a6018f9$var$_computeSegments(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = $8ae0e8ac8a6018f9$var$_boundSegments(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $8ae0e8ac8a6018f9$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $8ae0e8ac8a6018f9$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $8ae0e8ac8a6018f9$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $8ae0e8ac8a6018f9$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = void 0;
        }
    }
}
$8ae0e8ac8a6018f9$var$LineElement.id = "line";
$8ae0e8ac8a6018f9$var$LineElement.defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
};
$8ae0e8ac8a6018f9$var$LineElement.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
$8ae0e8ac8a6018f9$var$LineElement.descriptors = {
    _scriptable: true,
    _indexable: (name)=>name !== "borderDash" && name !== "fill"
};
function $8ae0e8ac8a6018f9$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $8ae0e8ac8a6018f9$var$PointElement extends $8ae0e8ac8a6018f9$var$Element$1 {
    constructor(cfg){
        super();
        this.options = void 0;
        this.parsed = void 0;
        this.skip = void 0;
        this.stop = void 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $8ae0e8ac8a6018f9$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $8ae0e8ac8a6018f9$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !$8ae0e8ac8a6018f9$var$_isPointInArea(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        $8ae0e8ac8a6018f9$var$drawPoint(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        return options.radius + options.hitRadius;
    }
}
$8ae0e8ac8a6018f9$var$PointElement.id = "point";
$8ae0e8ac8a6018f9$var$PointElement.defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
};
$8ae0e8ac8a6018f9$var$PointElement.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
function $8ae0e8ac8a6018f9$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $8ae0e8ac8a6018f9$var$skipOrLimit(skip2, value, min, max) {
    return skip2 ? 0 : $8ae0e8ac8a6018f9$var$_limitValue(value, min, max);
}
function $8ae0e8ac8a6018f9$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip2 = bar.borderSkipped;
    const o = $8ae0e8ac8a6018f9$var$toTRBL(value);
    return {
        t: $8ae0e8ac8a6018f9$var$skipOrLimit(skip2.top, o.top, 0, maxH),
        r: $8ae0e8ac8a6018f9$var$skipOrLimit(skip2.right, o.right, 0, maxW),
        b: $8ae0e8ac8a6018f9$var$skipOrLimit(skip2.bottom, o.bottom, 0, maxH),
        l: $8ae0e8ac8a6018f9$var$skipOrLimit(skip2.left, o.left, 0, maxW)
    };
}
function $8ae0e8ac8a6018f9$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = $8ae0e8ac8a6018f9$var$toTRBLCorners(value);
    const maxR = Math.min(maxW, maxH);
    const skip2 = bar.borderSkipped;
    const enableBorder = enableBorderRadius || $8ae0e8ac8a6018f9$var$isObject(value);
    return {
        topLeft: $8ae0e8ac8a6018f9$var$skipOrLimit(!enableBorder || skip2.top || skip2.left, o.topLeft, 0, maxR),
        topRight: $8ae0e8ac8a6018f9$var$skipOrLimit(!enableBorder || skip2.top || skip2.right, o.topRight, 0, maxR),
        bottomLeft: $8ae0e8ac8a6018f9$var$skipOrLimit(!enableBorder || skip2.bottom || skip2.left, o.bottomLeft, 0, maxR),
        bottomRight: $8ae0e8ac8a6018f9$var$skipOrLimit(!enableBorder || skip2.bottom || skip2.right, o.bottomRight, 0, maxR)
    };
}
function $8ae0e8ac8a6018f9$var$boundingRects(bar) {
    const bounds = $8ae0e8ac8a6018f9$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $8ae0e8ac8a6018f9$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $8ae0e8ac8a6018f9$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $8ae0e8ac8a6018f9$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $8ae0e8ac8a6018f9$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || $8ae0e8ac8a6018f9$var$_isBetween(x, bounds.left, bounds.right)) && (skipY || $8ae0e8ac8a6018f9$var$_isBetween(y, bounds.top, bounds.bottom));
}
function $8ae0e8ac8a6018f9$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $8ae0e8ac8a6018f9$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $8ae0e8ac8a6018f9$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $8ae0e8ac8a6018f9$var$BarElement extends $8ae0e8ac8a6018f9$var$Element$1 {
    constructor(cfg){
        super();
        this.options = void 0;
        this.horizontal = void 0;
        this.base = void 0;
        this.width = void 0;
        this.height = void 0;
        this.inflateAmount = void 0;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $8ae0e8ac8a6018f9$var$boundingRects(this);
        const addRectPath = $8ae0e8ac8a6018f9$var$hasRadius(outer.radius) ? $8ae0e8ac8a6018f9$var$addRoundedRectPath : $8ae0e8ac8a6018f9$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $8ae0e8ac8a6018f9$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $8ae0e8ac8a6018f9$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $8ae0e8ac8a6018f9$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $8ae0e8ac8a6018f9$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $8ae0e8ac8a6018f9$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $8ae0e8ac8a6018f9$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
$8ae0e8ac8a6018f9$var$BarElement.id = "bar";
$8ae0e8ac8a6018f9$var$BarElement.defaults = {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: "auto",
    pointStyle: void 0
};
$8ae0e8ac8a6018f9$var$BarElement.defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
};
function $8ae0e8ac8a6018f9$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $8ae0e8ac8a6018f9$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!$8ae0e8ac8a6018f9$var$isNullOrUndef(minIndex) && !$8ae0e8ac8a6018f9$var$isNullOrUndef(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $8ae0e8ac8a6018f9$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            value: data
        });
    }
}
function $8ae0e8ac8a6018f9$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $8ae0e8ac8a6018f9$var$cleanDecimatedDataset(dataset);
    });
}
function $8ae0e8ac8a6018f9$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = $8ae0e8ac8a6018f9$var$_limitValue($8ae0e8ac8a6018f9$var$_lookupByKey(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = $8ae0e8ac8a6018f9$var$_limitValue($8ae0e8ac8a6018f9$var$_lookupByKey(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $8ae0e8ac8a6018f9$var$plugin_decimation = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $8ae0e8ac8a6018f9$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ($8ae0e8ac8a6018f9$var$resolve([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $8ae0e8ac8a6018f9$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $8ae0e8ac8a6018f9$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ($8ae0e8ac8a6018f9$var$isNullOrUndef(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $8ae0e8ac8a6018f9$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $8ae0e8ac8a6018f9$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $8ae0e8ac8a6018f9$var$cleanDecimatedData(chart);
    }
};
function $8ae0e8ac8a6018f9$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $8ae0e8ac8a6018f9$var$_findSegmentEnd(start, end, points);
        const bounds = $8ae0e8ac8a6018f9$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = $8ae0e8ac8a6018f9$var$_boundSegments(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $8ae0e8ac8a6018f9$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = $8ae0e8ac8a6018f9$var$_boundSegment(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $8ae0e8ac8a6018f9$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $8ae0e8ac8a6018f9$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $8ae0e8ac8a6018f9$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = $8ae0e8ac8a6018f9$var$_normalizeAngle(start);
        end = $8ae0e8ac8a6018f9$var$_normalizeAngle(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $8ae0e8ac8a6018f9$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $8ae0e8ac8a6018f9$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $8ae0e8ac8a6018f9$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $8ae0e8ac8a6018f9$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $8ae0e8ac8a6018f9$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ($8ae0e8ac8a6018f9$var$isArray(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $8ae0e8ac8a6018f9$var$_pointsFromSegments(boundary, line);
    return points.length ? new $8ae0e8ac8a6018f9$var$LineElement({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $8ae0e8ac8a6018f9$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $8ae0e8ac8a6018f9$var$_resolveTarget(sources, index2, propagate) {
    const source = sources[index2];
    let fill2 = source.fill;
    const visited = [
        index2
    ];
    let target;
    if (!propagate) return fill2;
    while(fill2 !== false && visited.indexOf(fill2) === -1){
        if (!$8ae0e8ac8a6018f9$var$isNumberFinite(fill2)) return fill2;
        target = sources[fill2];
        if (!target) return false;
        if (target.visible) return fill2;
        visited.push(fill2);
        fill2 = target.fill;
    }
    return false;
}
function $8ae0e8ac8a6018f9$var$_decodeFill(line, index2, count) {
    const fill2 = $8ae0e8ac8a6018f9$var$parseFillOption(line);
    if ($8ae0e8ac8a6018f9$var$isObject(fill2)) return isNaN(fill2.value) ? false : fill2;
    let target = parseFloat(fill2);
    if ($8ae0e8ac8a6018f9$var$isNumberFinite(target) && Math.floor(target) === target) return $8ae0e8ac8a6018f9$var$decodeTargetIndex(fill2[0], index2, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill2) >= 0 && fill2;
}
function $8ae0e8ac8a6018f9$var$decodeTargetIndex(firstCh, index2, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index2 + target;
    if (target === index2 || target < 0 || target >= count) return false;
    return target;
}
function $8ae0e8ac8a6018f9$var$_getTargetPixel(fill2, scale) {
    let pixel = null;
    if (fill2 === "start") pixel = scale.bottom;
    else if (fill2 === "end") pixel = scale.top;
    else if ($8ae0e8ac8a6018f9$var$isObject(fill2)) pixel = scale.getPixelForValue(fill2.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $8ae0e8ac8a6018f9$var$_getTargetValue(fill2, scale, startValue) {
    let value;
    if (fill2 === "start") value = startValue;
    else if (fill2 === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ($8ae0e8ac8a6018f9$var$isObject(fill2)) value = fill2.value;
    else value = scale.getBaseValue();
    return value;
}
function $8ae0e8ac8a6018f9$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill2 = $8ae0e8ac8a6018f9$var$valueOrDefault(fillOption && fillOption.target, fillOption);
    if (fill2 === void 0) fill2 = !!options.backgroundColor;
    if (fill2 === false || fill2 === null) return false;
    if (fill2 === true) return "origin";
    return fill2;
}
function $8ae0e8ac8a6018f9$var$_buildStackLine(source) {
    const { scale: scale, index: index2, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $8ae0e8ac8a6018f9$var$getLinesBelow(scale, index2);
    linesBelow.push($8ae0e8ac8a6018f9$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$8ae0e8ac8a6018f9$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $8ae0e8ac8a6018f9$var$LineElement({
        points: points,
        options: {}
    });
}
function $8ae0e8ac8a6018f9$var$getLinesBelow(scale, index2) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index2) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $8ae0e8ac8a6018f9$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $8ae0e8ac8a6018f9$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $8ae0e8ac8a6018f9$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ($8ae0e8ac8a6018f9$var$_isBetween(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $8ae0e8ac8a6018f9$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: $8ae0e8ac8a6018f9$var$TAU
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $8ae0e8ac8a6018f9$var$_getTarget(source) {
    const { chart: chart, fill: fill2, line: line } = source;
    if ($8ae0e8ac8a6018f9$var$isNumberFinite(fill2)) return $8ae0e8ac8a6018f9$var$getLineByIndex(chart, fill2);
    if (fill2 === "stack") return $8ae0e8ac8a6018f9$var$_buildStackLine(source);
    if (fill2 === "shape") return true;
    const boundary = $8ae0e8ac8a6018f9$var$computeBoundary(source);
    if (boundary instanceof $8ae0e8ac8a6018f9$var$simpleArc) return boundary;
    return $8ae0e8ac8a6018f9$var$_createBoundaryLine(boundary, line);
}
function $8ae0e8ac8a6018f9$var$getLineByIndex(chart, index2) {
    const meta = chart.getDatasetMeta(index2);
    const visible = meta && chart.isDatasetVisible(index2);
    return visible ? meta.dataset : null;
}
function $8ae0e8ac8a6018f9$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $8ae0e8ac8a6018f9$var$computeCircularBoundary(source);
    return $8ae0e8ac8a6018f9$var$computeLinearBoundary(source);
}
function $8ae0e8ac8a6018f9$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill2 } = source;
    const pixel = $8ae0e8ac8a6018f9$var$_getTargetPixel(fill2, scale);
    if ($8ae0e8ac8a6018f9$var$isNumberFinite(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $8ae0e8ac8a6018f9$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill2 } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $8ae0e8ac8a6018f9$var$_getTargetValue(fill2, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $8ae0e8ac8a6018f9$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $8ae0e8ac8a6018f9$var$_drawfill(ctx, source, area) {
    const target = $8ae0e8ac8a6018f9$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color2 = lineOpts.backgroundColor;
    const { above: above = color2, below: below = color2 } = fillOption || {};
    if (target && line.points.length) {
        $8ae0e8ac8a6018f9$var$clipArea(ctx, area);
        $8ae0e8ac8a6018f9$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        $8ae0e8ac8a6018f9$var$unclipArea(ctx);
    }
}
function $8ae0e8ac8a6018f9$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $8ae0e8ac8a6018f9$var$clipVertical(ctx, target, area.top);
        $8ae0e8ac8a6018f9$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $8ae0e8ac8a6018f9$var$clipVertical(ctx, target, area.bottom);
    }
    $8ae0e8ac8a6018f9$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $8ae0e8ac8a6018f9$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$8ae0e8ac8a6018f9$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $8ae0e8ac8a6018f9$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color2, scale: scale } = cfg;
    const segments = $8ae0e8ac8a6018f9$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color2 } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $8ae0e8ac8a6018f9$var$clipBounds(ctx, scale, notShape && $8ae0e8ac8a6018f9$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $8ae0e8ac8a6018f9$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $8ae0e8ac8a6018f9$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $8ae0e8ac8a6018f9$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $8ae0e8ac8a6018f9$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $8ae0e8ac8a6018f9$var$index = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $8ae0e8ac8a6018f9$var$LineElement) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $8ae0e8ac8a6018f9$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $8ae0e8ac8a6018f9$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw2 = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw2 && source.fill) $8ae0e8ac8a6018f9$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($8ae0e8ac8a6018f9$var$_shouldApplyFill(source)) $8ae0e8ac8a6018f9$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$8ae0e8ac8a6018f9$var$_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        $8ae0e8ac8a6018f9$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $8ae0e8ac8a6018f9$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $8ae0e8ac8a6018f9$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $8ae0e8ac8a6018f9$var$Legend extends $8ae0e8ac8a6018f9$var$Element$1 {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = void 0;
        this.columnSizes = void 0;
        this.lineWidths = void 0;
        this.maxHeight = void 0;
        this.maxWidth = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.left = void 0;
        this.right = void 0;
        this.height = void 0;
        this.width = void 0;
        this._margins = void 0;
        this.position = void 0;
        this.weight = void 0;
        this.fullSize = void 0;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = $8ae0e8ac8a6018f9$var$callback(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = $8ae0e8ac8a6018f9$var$toFont(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $8ae0e8ac8a6018f9$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = $8ae0e8ac8a6018f9$var$getRtlAdapter(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            $8ae0e8ac8a6018f9$var$clipArea(ctx, this);
            this._draw();
            $8ae0e8ac8a6018f9$var$unclipArea(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = $8ae0e8ac8a6018f9$var$defaults.color;
        const rtlHelper = $8ae0e8ac8a6018f9$var$getRtlAdapter(opts.rtl, this.left, this.width);
        const labelFont = $8ae0e8ac8a6018f9$var$toFont(labelOpts.font);
        const { color: fontColor, padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $8ae0e8ac8a6018f9$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = $8ae0e8ac8a6018f9$var$valueOrDefault(legendItem.lineWidth, 1);
            ctx.fillStyle = $8ae0e8ac8a6018f9$var$valueOrDefault(legendItem.fillStyle, defaultColor);
            ctx.lineCap = $8ae0e8ac8a6018f9$var$valueOrDefault(legendItem.lineCap, "butt");
            ctx.lineDashOffset = $8ae0e8ac8a6018f9$var$valueOrDefault(legendItem.lineDashOffset, 0);
            ctx.lineJoin = $8ae0e8ac8a6018f9$var$valueOrDefault(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = $8ae0e8ac8a6018f9$var$valueOrDefault(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash($8ae0e8ac8a6018f9$var$valueOrDefault(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                $8ae0e8ac8a6018f9$var$drawPointLegend(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = $8ae0e8ac8a6018f9$var$toTRBLCorners(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) $8ae0e8ac8a6018f9$var$addRoundedRectPath(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            $8ae0e8ac8a6018f9$var$renderText(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: $8ae0e8ac8a6018f9$var$_alignStartEnd(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: $8ae0e8ac8a6018f9$var$_alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        $8ae0e8ac8a6018f9$var$overrideTextDirection(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor || fontColor;
            ctx.fillStyle = legendItem.fontColor || fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = $8ae0e8ac8a6018f9$var$_textX(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else cursor.y += lineHeight;
        });
        $8ae0e8ac8a6018f9$var$restoreTextDirection(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = $8ae0e8ac8a6018f9$var$toFont(titleOpts.font);
        const titlePadding = $8ae0e8ac8a6018f9$var$toPadding(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = $8ae0e8ac8a6018f9$var$getRtlAdapter(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = $8ae0e8ac8a6018f9$var$_alignStartEnd(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + $8ae0e8ac8a6018f9$var$_alignStartEnd(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = $8ae0e8ac8a6018f9$var$_alignStartEnd(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign($8ae0e8ac8a6018f9$var$_toLeftRightCenter(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        $8ae0e8ac8a6018f9$var$renderText(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = $8ae0e8ac8a6018f9$var$toFont(titleOpts.font);
        const titlePadding = $8ae0e8ac8a6018f9$var$toPadding(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ($8ae0e8ac8a6018f9$var$_isBetween(x, this.left, this.right) && $8ae0e8ac8a6018f9$var$_isBetween(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ($8ae0e8ac8a6018f9$var$_isBetween(x, hitBox.left, hitBox.left + hitBox.width) && $8ae0e8ac8a6018f9$var$_isBetween(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$8ae0e8ac8a6018f9$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $8ae0e8ac8a6018f9$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) $8ae0e8ac8a6018f9$var$callback(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) $8ae0e8ac8a6018f9$var$callback(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) $8ae0e8ac8a6018f9$var$callback(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $8ae0e8ac8a6018f9$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $8ae0e8ac8a6018f9$var$plugin_legend = {
    id: "legend",
    _element: $8ae0e8ac8a6018f9$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $8ae0e8ac8a6018f9$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $8ae0e8ac8a6018f9$var$layouts.configure(chart, legend, options);
        $8ae0e8ac8a6018f9$var$layouts.addBox(chart, legend);
    },
    stop (chart) {
        $8ae0e8ac8a6018f9$var$layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $8ae0e8ac8a6018f9$var$layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1e3,
        onClick (e, legendItem, legend) {
            const index2 = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index2)) {
                ci.hide(index2);
                legendItem.hidden = true;
            } else {
                ci.show(index2);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color2 } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : void 0);
                    const borderWidth = $8ae0e8ac8a6018f9$var$toPadding(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color2,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: 0,
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $8ae0e8ac8a6018f9$var$Title extends $8ae0e8ac8a6018f9$var$Element$1 {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.left = void 0;
        this.right = void 0;
        this.width = void 0;
        this.height = void 0;
        this.position = void 0;
        this.weight = void 0;
        this.fullSize = void 0;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = $8ae0e8ac8a6018f9$var$isArray(opts.text) ? opts.text.length : 1;
        this._padding = $8ae0e8ac8a6018f9$var$toPadding(opts.padding);
        const textSize = lineCount * $8ae0e8ac8a6018f9$var$toFont(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, bottom, top);
                rotation = $8ae0e8ac8a6018f9$var$PI * -0.5;
            } else {
                titleX = right - offset;
                titleY = $8ae0e8ac8a6018f9$var$_alignStartEnd(align, top, bottom);
                rotation = $8ae0e8ac8a6018f9$var$PI * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = $8ae0e8ac8a6018f9$var$toFont(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        $8ae0e8ac8a6018f9$var$renderText(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $8ae0e8ac8a6018f9$var$_toLeftRightCenter(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $8ae0e8ac8a6018f9$var$createTitle(chart, titleOpts) {
    const title = new $8ae0e8ac8a6018f9$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $8ae0e8ac8a6018f9$var$layouts.configure(chart, title, titleOpts);
    $8ae0e8ac8a6018f9$var$layouts.addBox(chart, title);
    chart.titleBlock = title;
}
var $8ae0e8ac8a6018f9$var$plugin_title = {
    id: "title",
    _element: $8ae0e8ac8a6018f9$var$Title,
    start (chart, _args, options) {
        $8ae0e8ac8a6018f9$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $8ae0e8ac8a6018f9$var$layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $8ae0e8ac8a6018f9$var$layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2e3
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $8ae0e8ac8a6018f9$var$map = /* @__PURE__ */ new WeakMap();
var $8ae0e8ac8a6018f9$var$plugin_subtitle = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $8ae0e8ac8a6018f9$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $8ae0e8ac8a6018f9$var$layouts.configure(chart, title, options);
        $8ae0e8ac8a6018f9$var$layouts.addBox(chart, title);
        $8ae0e8ac8a6018f9$var$map.set(chart, title);
    },
    stop (chart) {
        $8ae0e8ac8a6018f9$var$layouts.removeBox(chart, $8ae0e8ac8a6018f9$var$map.get(chart));
        $8ae0e8ac8a6018f9$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $8ae0e8ac8a6018f9$var$map.get(chart);
        $8ae0e8ac8a6018f9$var$layouts.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $8ae0e8ac8a6018f9$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = $8ae0e8ac8a6018f9$var$distanceBetweenPoints(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $8ae0e8ac8a6018f9$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ($8ae0e8ac8a6018f9$var$isArray(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $8ae0e8ac8a6018f9$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $8ae0e8ac8a6018f9$var$createTooltipItem(chart, item) {
    const { element: element2, datasetIndex: datasetIndex, index: index2 } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index2);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index2),
        raw: chart.data.datasets[datasetIndex].data[index2],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index2,
        datasetIndex: datasetIndex,
        element: element2
    };
}
function $8ae0e8ac8a6018f9$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = $8ae0e8ac8a6018f9$var$toFont(options.bodyFont);
    const titleFont = $8ae0e8ac8a6018f9$var$toFont(options.titleFont);
    const footerFont = $8ae0e8ac8a6018f9$var$toFont(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = $8ae0e8ac8a6018f9$var$toPadding(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    $8ae0e8ac8a6018f9$var$each(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    $8ae0e8ac8a6018f9$var$each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    $8ae0e8ac8a6018f9$var$each(body, (bodyItem)=>{
        $8ae0e8ac8a6018f9$var$each(bodyItem.before, maxLineWidth);
        $8ae0e8ac8a6018f9$var$each(bodyItem.lines, maxLineWidth);
        $8ae0e8ac8a6018f9$var$each(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    $8ae0e8ac8a6018f9$var$each(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $8ae0e8ac8a6018f9$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $8ae0e8ac8a6018f9$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $8ae0e8ac8a6018f9$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($8ae0e8ac8a6018f9$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $8ae0e8ac8a6018f9$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $8ae0e8ac8a6018f9$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $8ae0e8ac8a6018f9$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $8ae0e8ac8a6018f9$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $8ae0e8ac8a6018f9$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $8ae0e8ac8a6018f9$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = $8ae0e8ac8a6018f9$var$toTRBLCorners(cornerRadius);
    let x = $8ae0e8ac8a6018f9$var$alignX(size, xAlign);
    const y = $8ae0e8ac8a6018f9$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: $8ae0e8ac8a6018f9$var$_limitValue(x, 0, chart.width - size.width),
        y: $8ae0e8ac8a6018f9$var$_limitValue(y, 0, chart.height - size.height)
    };
}
function $8ae0e8ac8a6018f9$var$getAlignedX(tooltip, align, options) {
    const padding = $8ae0e8ac8a6018f9$var$toPadding(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $8ae0e8ac8a6018f9$var$getBeforeAfterBodyLines(callback2) {
    return $8ae0e8ac8a6018f9$var$pushOrConcat([], $8ae0e8ac8a6018f9$var$splitNewlines(callback2));
}
function $8ae0e8ac8a6018f9$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return $8ae0e8ac8a6018f9$var$createContext(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $8ae0e8ac8a6018f9$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
class $8ae0e8ac8a6018f9$var$Tooltip extends $8ae0e8ac8a6018f9$var$Element$1 {
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = void 0;
        this._size = void 0;
        this._cachedAnimations = void 0;
        this._tooltipItems = [];
        this.$animations = void 0;
        this.$context = void 0;
        this.chart = config.chart || config._chart;
        this._chart = this.chart;
        this.options = config.options;
        this.dataPoints = void 0;
        this.title = void 0;
        this.beforeBody = void 0;
        this.body = void 0;
        this.afterBody = void 0;
        this.footer = void 0;
        this.xAlign = void 0;
        this.yAlign = void 0;
        this.x = void 0;
        this.y = void 0;
        this.height = void 0;
        this.width = void 0;
        this.caretX = void 0;
        this.caretY = void 0;
        this.labelColors = void 0;
        this.labelPointStyles = void 0;
        this.labelTextColors = void 0;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = void 0;
        this.$context = void 0;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $8ae0e8ac8a6018f9$var$Animations(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $8ae0e8ac8a6018f9$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = callbacks.beforeTitle.apply(this, [
            context
        ]);
        const title = callbacks.title.apply(this, [
            context
        ]);
        const afterTitle = callbacks.afterTitle.apply(this, [
            context
        ]);
        let lines = [];
        lines = $8ae0e8ac8a6018f9$var$pushOrConcat(lines, $8ae0e8ac8a6018f9$var$splitNewlines(beforeTitle));
        lines = $8ae0e8ac8a6018f9$var$pushOrConcat(lines, $8ae0e8ac8a6018f9$var$splitNewlines(title));
        lines = $8ae0e8ac8a6018f9$var$pushOrConcat(lines, $8ae0e8ac8a6018f9$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $8ae0e8ac8a6018f9$var$getBeforeAfterBodyLines(options.callbacks.beforeBody.apply(this, [
            tooltipItems
        ]));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        $8ae0e8ac8a6018f9$var$each(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $8ae0e8ac8a6018f9$var$overrideCallbacks(callbacks, context);
            $8ae0e8ac8a6018f9$var$pushOrConcat(bodyItem.before, $8ae0e8ac8a6018f9$var$splitNewlines(scoped.beforeLabel.call(this, context)));
            $8ae0e8ac8a6018f9$var$pushOrConcat(bodyItem.lines, scoped.label.call(this, context));
            $8ae0e8ac8a6018f9$var$pushOrConcat(bodyItem.after, $8ae0e8ac8a6018f9$var$splitNewlines(scoped.afterLabel.call(this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $8ae0e8ac8a6018f9$var$getBeforeAfterBodyLines(options.callbacks.afterBody.apply(this, [
            tooltipItems
        ]));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = callbacks.beforeFooter.apply(this, [
            tooltipItems
        ]);
        const footer = callbacks.footer.apply(this, [
            tooltipItems
        ]);
        const afterFooter = callbacks.afterFooter.apply(this, [
            tooltipItems
        ]);
        let lines = [];
        lines = $8ae0e8ac8a6018f9$var$pushOrConcat(lines, $8ae0e8ac8a6018f9$var$splitNewlines(beforeFooter));
        lines = $8ae0e8ac8a6018f9$var$pushOrConcat(lines, $8ae0e8ac8a6018f9$var$splitNewlines(footer));
        lines = $8ae0e8ac8a6018f9$var$pushOrConcat(lines, $8ae0e8ac8a6018f9$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($8ae0e8ac8a6018f9$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element2, index2, array)=>options.filter(element2, index2, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        $8ae0e8ac8a6018f9$var$each(tooltipItems, (context)=>{
            const scoped = $8ae0e8ac8a6018f9$var$overrideCallbacks(options.callbacks, context);
            labelColors.push(scoped.labelColor.call(this, context));
            labelPointStyles.push(scoped.labelPointStyle.call(this, context));
            labelTextColors.push(scoped.labelTextColor.call(this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $8ae0e8ac8a6018f9$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $8ae0e8ac8a6018f9$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $8ae0e8ac8a6018f9$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $8ae0e8ac8a6018f9$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = void 0;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = $8ae0e8ac8a6018f9$var$toTRBLCorners(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = $8ae0e8ac8a6018f9$var$getRtlAdapter(options.rtl, this.x, this.width);
            pt.x = $8ae0e8ac8a6018f9$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = $8ae0e8ac8a6018f9$var$toFont(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColors = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = $8ae0e8ac8a6018f9$var$toFont(options.bodyFont);
        const colorX = $8ae0e8ac8a6018f9$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            $8ae0e8ac8a6018f9$var$drawPoint(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColors.borderColor;
            ctx.fillStyle = labelColors.backgroundColor;
            $8ae0e8ac8a6018f9$var$drawPoint(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = $8ae0e8ac8a6018f9$var$isObject(labelColors.borderWidth) ? Math.max(...Object.values(labelColors.borderWidth)) : labelColors.borderWidth || 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.setLineDash(labelColors.borderDash || []);
            ctx.lineDashOffset = labelColors.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth - boxPadding);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - boxPadding - 2);
            const borderRadius = $8ae0e8ac8a6018f9$var$toTRBLCorners(labelColors.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                $8ae0e8ac8a6018f9$var$addRoundedRectPath(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.beginPath();
                $8ae0e8ac8a6018f9$var$addRoundedRectPath(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColors.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = $8ae0e8ac8a6018f9$var$toFont(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = $8ae0e8ac8a6018f9$var$getRtlAdapter(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $8ae0e8ac8a6018f9$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        $8ae0e8ac8a6018f9$var$each(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            $8ae0e8ac8a6018f9$var$each(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            $8ae0e8ac8a6018f9$var$each(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        $8ae0e8ac8a6018f9$var$each(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = $8ae0e8ac8a6018f9$var$getRtlAdapter(options.rtl, this.x, this.width);
            pt.x = $8ae0e8ac8a6018f9$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = $8ae0e8ac8a6018f9$var$toFont(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = $8ae0e8ac8a6018f9$var$toTRBLCorners(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $8ae0e8ac8a6018f9$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $8ae0e8ac8a6018f9$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $8ae0e8ac8a6018f9$var$determineAlignment(chart, options, positionAndSize);
            const point = $8ae0e8ac8a6018f9$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = $8ae0e8ac8a6018f9$var$toPadding(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            $8ae0e8ac8a6018f9$var$overrideTextDirection(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            $8ae0e8ac8a6018f9$var$restoreTextDirection(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index2 })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index2],
                index: index2
            };
        });
        const changed = !$8ae0e8ac8a6018f9$var$_elementsEqual(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !$8ae0e8ac8a6018f9$var$_elementsEqual(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $8ae0e8ac8a6018f9$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
$8ae0e8ac8a6018f9$var$Tooltip.positioners = $8ae0e8ac8a6018f9$var$positioners;
var $8ae0e8ac8a6018f9$var$plugin_tooltip = {
    id: "tooltip",
    _element: $8ae0e8ac8a6018f9$var$Tooltip,
    positioners: $8ae0e8ac8a6018f9$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $8ae0e8ac8a6018f9$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", args) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: {
            beforeTitle: $8ae0e8ac8a6018f9$var$noop,
            title (tooltipItems) {
                if (tooltipItems.length > 0) {
                    const item = tooltipItems[0];
                    const labels = item.chart.data.labels;
                    const labelCount = labels ? labels.length : 0;
                    if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
                    else if (item.label) return item.label;
                    else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
                }
                return "";
            },
            afterTitle: $8ae0e8ac8a6018f9$var$noop,
            beforeBody: $8ae0e8ac8a6018f9$var$noop,
            beforeLabel: $8ae0e8ac8a6018f9$var$noop,
            label (tooltipItem) {
                if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
                let label = tooltipItem.dataset.label || "";
                if (label) label += ": ";
                const value = tooltipItem.formattedValue;
                if (!$8ae0e8ac8a6018f9$var$isNullOrUndef(value)) label += value;
                return label;
            },
            labelColor (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    borderColor: options.borderColor,
                    backgroundColor: options.backgroundColor,
                    borderWidth: options.borderWidth,
                    borderDash: options.borderDash,
                    borderDashOffset: options.borderDashOffset,
                    borderRadius: 0
                };
            },
            labelTextColor () {
                return this.options.bodyColor;
            },
            labelPointStyle (tooltipItem) {
                const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
                const options = meta.controller.getStyle(tooltipItem.dataIndex);
                return {
                    pointStyle: options.pointStyle,
                    rotation: options.rotation
                };
            },
            afterLabel: $8ae0e8ac8a6018f9$var$noop,
            afterBody: $8ae0e8ac8a6018f9$var$noop,
            beforeFooter: $8ae0e8ac8a6018f9$var$noop,
            footer: $8ae0e8ac8a6018f9$var$noop,
            afterFooter: $8ae0e8ac8a6018f9$var$noop
        }
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
const $8ae0e8ac8a6018f9$var$addIfString = (labels, raw, index2, addedLabels)=>{
    if (typeof raw === "string") {
        index2 = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index2,
            label: raw
        });
    } else if (isNaN(raw)) index2 = null;
    return index2;
};
function $8ae0e8ac8a6018f9$var$findOrAddLabel(labels, raw, index2, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $8ae0e8ac8a6018f9$var$addIfString(labels, raw, index2, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index2 : first;
}
const $8ae0e8ac8a6018f9$var$validIndex = (index2, max)=>index2 === null ? null : $8ae0e8ac8a6018f9$var$_limitValue(Math.round(index2), 0, max);
class $8ae0e8ac8a6018f9$var$CategoryScale extends $8ae0e8ac8a6018f9$var$Scale {
    constructor(cfg){
        super(cfg);
        this._startValue = void 0;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index2, label: label } of added)if (labels[index2] === label) labels.splice(index2, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index2) {
        if ($8ae0e8ac8a6018f9$var$isNullOrUndef(raw)) return null;
        const labels = this.getLabels();
        index2 = isFinite(index2) && labels[index2] === raw ? index2 : $8ae0e8ac8a6018f9$var$findOrAddLabel(labels, raw, $8ae0e8ac8a6018f9$var$valueOrDefault(index2, raw), this._addedLabels);
        return $8ae0e8ac8a6018f9$var$validIndex(index2, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        const labels = this.getLabels();
        if (value >= 0 && value < labels.length) return labels[value];
        return value;
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index2) {
        const ticks = this.ticks;
        if (index2 < 0 || index2 > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index2].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
$8ae0e8ac8a6018f9$var$CategoryScale.id = "category";
$8ae0e8ac8a6018f9$var$CategoryScale.defaults = {
    ticks: {
        callback: $8ae0e8ac8a6018f9$var$CategoryScale.prototype.getLabelForValue
    }
};
function $8ae0e8ac8a6018f9$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !$8ae0e8ac8a6018f9$var$isNullOrUndef(min);
    const maxDefined = !$8ae0e8ac8a6018f9$var$isNullOrUndef(max);
    const countDefined = !$8ae0e8ac8a6018f9$var$isNullOrUndef(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = $8ae0e8ac8a6018f9$var$niceNum((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = $8ae0e8ac8a6018f9$var$niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!$8ae0e8ac8a6018f9$var$isNullOrUndef(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && $8ae0e8ac8a6018f9$var$almostWhole((max - min) / step, spacing / 1e3)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ($8ae0e8ac8a6018f9$var$almostEquals(numSpaces, Math.round(numSpaces), spacing / 1e3)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max($8ae0e8ac8a6018f9$var$_decimalPlaces(spacing), $8ae0e8ac8a6018f9$var$_decimalPlaces(niceMin));
    factor = Math.pow(10, $8ae0e8ac8a6018f9$var$isNullOrUndef(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ($8ae0e8ac8a6018f9$var$almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min, $8ae0e8ac8a6018f9$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j)ticks.push({
        value: Math.round((niceMin + j * spacing) * factor) / factor
    });
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && $8ae0e8ac8a6018f9$var$almostEquals(ticks[ticks.length - 1].value, max, $8ae0e8ac8a6018f9$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $8ae0e8ac8a6018f9$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = $8ae0e8ac8a6018f9$var$toRadians(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 1e-3;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $8ae0e8ac8a6018f9$var$LinearScaleBase extends $8ae0e8ac8a6018f9$var$Scale {
    constructor(cfg){
        super(cfg);
        this.start = void 0;
        this.end = void 0;
        this._startValue = void 0;
        this._endValue = void 0;
        this._valueRange = 0;
    }
    parse(raw, index2) {
        if ($8ae0e8ac8a6018f9$var$isNullOrUndef(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = $8ae0e8ac8a6018f9$var$sign(min);
            const maxSign = $8ae0e8ac8a6018f9$var$sign(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = 1;
            if (max >= Number.MAX_SAFE_INTEGER || min <= Number.MIN_SAFE_INTEGER) offset = Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1e3) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1e3;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $8ae0e8ac8a6018f9$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") $8ae0e8ac8a6018f9$var$_setMinAndMaxByKey(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return $8ae0e8ac8a6018f9$var$formatNumber(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $8ae0e8ac8a6018f9$var$LinearScale extends $8ae0e8ac8a6018f9$var$LinearScaleBase {
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = $8ae0e8ac8a6018f9$var$isNumberFinite(min) ? min : 0;
        this.max = $8ae0e8ac8a6018f9$var$isNumberFinite(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = $8ae0e8ac8a6018f9$var$toRadians(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 1e-3;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
$8ae0e8ac8a6018f9$var$LinearScale.id = "linear";
$8ae0e8ac8a6018f9$var$LinearScale.defaults = {
    ticks: {
        callback: $8ae0e8ac8a6018f9$var$Ticks.formatters.numeric
    }
};
function $8ae0e8ac8a6018f9$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, Math.floor($8ae0e8ac8a6018f9$var$log10(tickVal)));
    return remain === 1;
}
function $8ae0e8ac8a6018f9$var$generateTicks(generationOptions, dataRange) {
    const endExp = Math.floor($8ae0e8ac8a6018f9$var$log10(dataRange.max));
    const endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    const ticks = [];
    let tickVal = $8ae0e8ac8a6018f9$var$finiteOrDefault(generationOptions.min, Math.pow(10, Math.floor($8ae0e8ac8a6018f9$var$log10(dataRange.min))));
    let exp = Math.floor($8ae0e8ac8a6018f9$var$log10(tickVal));
    let significand = Math.floor(tickVal / Math.pow(10, exp));
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
        ticks.push({
            value: tickVal,
            major: $8ae0e8ac8a6018f9$var$isMajor(tickVal)
        });
        ++significand;
        if (significand === 10) {
            significand = 1;
            ++exp;
            precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    }while (exp < endExp || exp === endExp && significand < endSignificand);
    const lastTick = $8ae0e8ac8a6018f9$var$finiteOrDefault(generationOptions.max, tickVal);
    ticks.push({
        value: lastTick,
        major: $8ae0e8ac8a6018f9$var$isMajor(tickVal)
    });
    return ticks;
}
class $8ae0e8ac8a6018f9$var$LogarithmicScale extends $8ae0e8ac8a6018f9$var$Scale {
    constructor(cfg){
        super(cfg);
        this.start = void 0;
        this.end = void 0;
        this._startValue = void 0;
        this._valueRange = 0;
    }
    parse(raw, index2) {
        const value = $8ae0e8ac8a6018f9$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index2
        ]);
        if (value === 0) {
            this._zero = true;
            return void 0;
        }
        return $8ae0e8ac8a6018f9$var$isNumberFinite(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = $8ae0e8ac8a6018f9$var$isNumberFinite(min) ? Math.max(0, min) : null;
        this.max = $8ae0e8ac8a6018f9$var$isNumberFinite(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        const exp = (v, m)=>Math.pow(10, Math.floor($8ae0e8ac8a6018f9$var$log10(v)) + m);
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(exp(min, -1));
                setMax(exp(max, 1));
            }
        }
        if (min <= 0) setMin(exp(max, -1));
        if (max <= 0) setMax(exp(min, 1));
        if (this._zero && this.min !== this._suggestedMin && min === exp(this.min, 0)) setMin(exp(min, -1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $8ae0e8ac8a6018f9$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") $8ae0e8ac8a6018f9$var$_setMinAndMaxByKey(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === void 0 ? "0" : $8ae0e8ac8a6018f9$var$formatNumber(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = $8ae0e8ac8a6018f9$var$log10(start);
        this._valueRange = $8ae0e8ac8a6018f9$var$log10(this.max) - $8ae0e8ac8a6018f9$var$log10(start);
    }
    getPixelForValue(value) {
        if (value === void 0 || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ($8ae0e8ac8a6018f9$var$log10(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
$8ae0e8ac8a6018f9$var$LogarithmicScale.id = "logarithmic";
$8ae0e8ac8a6018f9$var$LogarithmicScale.defaults = {
    ticks: {
        callback: $8ae0e8ac8a6018f9$var$Ticks.formatters.logarithmic,
        major: {
            enabled: true
        }
    }
};
function $8ae0e8ac8a6018f9$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = $8ae0e8ac8a6018f9$var$toPadding(tickOpts.backdropPadding);
        return $8ae0e8ac8a6018f9$var$valueOrDefault(tickOpts.font && tickOpts.font.size, $8ae0e8ac8a6018f9$var$defaults.font.size) + padding.height;
    }
    return 0;
}
function $8ae0e8ac8a6018f9$var$measureLabelSize(ctx, font, label) {
    label = $8ae0e8ac8a6018f9$var$isArray(label) ? label : [
        label
    ];
    return {
        w: $8ae0e8ac8a6018f9$var$_longestText(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $8ae0e8ac8a6018f9$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $8ae0e8ac8a6018f9$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? $8ae0e8ac8a6018f9$var$PI / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = $8ae0e8ac8a6018f9$var$toFont(opts.font);
        const textSize = $8ae0e8ac8a6018f9$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = $8ae0e8ac8a6018f9$var$_normalizeAngle(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round($8ae0e8ac8a6018f9$var$toDegrees(angleRadians));
        const hLimits = $8ae0e8ac8a6018f9$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $8ae0e8ac8a6018f9$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $8ae0e8ac8a6018f9$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $8ae0e8ac8a6018f9$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $8ae0e8ac8a6018f9$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $8ae0e8ac8a6018f9$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const extra = $8ae0e8ac8a6018f9$var$getTickBackdropHeight(opts) / 2;
    const outerDistance = scale.drawingArea;
    const additionalAngle = opts.pointLabels.centerPointLabels ? $8ae0e8ac8a6018f9$var$PI / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + padding[i], additionalAngle);
        const angle = Math.round($8ae0e8ac8a6018f9$var$toDegrees($8ae0e8ac8a6018f9$var$_normalizeAngle(pointLabelPosition.angle + $8ae0e8ac8a6018f9$var$HALF_PI)));
        const size = labelSizes[i];
        const y = $8ae0e8ac8a6018f9$var$yForAngle(pointLabelPosition.y, size.h, angle);
        const textAlign = $8ae0e8ac8a6018f9$var$getTextAlignForAngle(angle);
        const left = $8ae0e8ac8a6018f9$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
        items.push({
            x: pointLabelPosition.x,
            y: y,
            textAlign: textAlign,
            left: left,
            top: y,
            right: left + size.w,
            bottom: y + size.h
        });
    }
    return items;
}
function $8ae0e8ac8a6018f9$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $8ae0e8ac8a6018f9$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $8ae0e8ac8a6018f9$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $8ae0e8ac8a6018f9$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        const plFont = $8ae0e8ac8a6018f9$var$toFont(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign, left: left, top: top, right: right, bottom: bottom } = scale._pointLabelItems[i];
        const { backdropColor: backdropColor } = optsAtIndex;
        if (!$8ae0e8ac8a6018f9$var$isNullOrUndef(backdropColor)) {
            const borderRadius = $8ae0e8ac8a6018f9$var$toTRBLCorners(optsAtIndex.borderRadius);
            const padding = $8ae0e8ac8a6018f9$var$toPadding(optsAtIndex.backdropPadding);
            ctx.fillStyle = backdropColor;
            const backdropLeft = left - padding.left;
            const backdropTop = top - padding.top;
            const backdropWidth = right - left + padding.width;
            const backdropHeight = bottom - top + padding.height;
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                $8ae0e8ac8a6018f9$var$addRoundedRectPath(ctx, {
                    x: backdropLeft,
                    y: backdropTop,
                    w: backdropWidth,
                    h: backdropHeight,
                    radius: borderRadius
                });
                ctx.fill();
            } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
        $8ae0e8ac8a6018f9$var$renderText(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $8ae0e8ac8a6018f9$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, $8ae0e8ac8a6018f9$var$TAU);
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $8ae0e8ac8a6018f9$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color2, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color2 || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color2;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(gridLineOpts.borderDash);
    ctx.lineDashOffset = gridLineOpts.borderDashOffset;
    ctx.beginPath();
    $8ae0e8ac8a6018f9$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $8ae0e8ac8a6018f9$var$createPointLabelContext(parent, index2, label) {
    return $8ae0e8ac8a6018f9$var$createContext(parent, {
        label: label,
        index: index2,
        type: "pointLabel"
    });
}
class $8ae0e8ac8a6018f9$var$RadialLinearScale extends $8ae0e8ac8a6018f9$var$LinearScaleBase {
    constructor(cfg){
        super(cfg);
        this.xCenter = void 0;
        this.yCenter = void 0;
        this.drawingArea = void 0;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = $8ae0e8ac8a6018f9$var$toPadding($8ae0e8ac8a6018f9$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = $8ae0e8ac8a6018f9$var$isNumberFinite(min) && !isNaN(min) ? min : 0;
        this.max = $8ae0e8ac8a6018f9$var$isNumberFinite(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $8ae0e8ac8a6018f9$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $8ae0e8ac8a6018f9$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index2)=>{
            const label = $8ae0e8ac8a6018f9$var$callback(this.options.pointLabels.callback, [
                value,
                index2
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $8ae0e8ac8a6018f9$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index2) {
        const angleMultiplier = $8ae0e8ac8a6018f9$var$TAU / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return $8ae0e8ac8a6018f9$var$_normalizeAngle(index2 * angleMultiplier + $8ae0e8ac8a6018f9$var$toRadians(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ($8ae0e8ac8a6018f9$var$isNullOrUndef(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ($8ae0e8ac8a6018f9$var$isNullOrUndef(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index2) {
        const pointLabels = this._pointLabels || [];
        if (index2 >= 0 && index2 < pointLabels.length) {
            const pointLabel = pointLabels[index2];
            return $8ae0e8ac8a6018f9$var$createPointLabelContext(this.getContext(), index2, pointLabel);
        }
    }
    getPointPosition(index2, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index2) - $8ae0e8ac8a6018f9$var$HALF_PI + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index2, value) {
        return this.getPointPosition(index2, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index2) {
        return this.getPointPositionForValue(index2 || 0, this.getBaseValue());
    }
    getPointLabelPosition(index2) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index2];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $8ae0e8ac8a6018f9$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $8ae0e8ac8a6018f9$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index2)=>{
            if (index2 !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const optsAtIndex = grid.setContext(this.getContext(index2 - 1));
                $8ae0e8ac8a6018f9$var$drawRadiusLine(this, optsAtIndex, offset, labelCount);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color2, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color2) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color2;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index2)=>{
            if (index2 === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index2));
            const tickFont = $8ae0e8ac8a6018f9$var$toFont(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index2].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = $8ae0e8ac8a6018f9$var$toPadding(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            $8ae0e8ac8a6018f9$var$renderText(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
$8ae0e8ac8a6018f9$var$RadialLinearScale.id = "radialLinear";
$8ae0e8ac8a6018f9$var$RadialLinearScale.defaults = {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: $8ae0e8ac8a6018f9$var$Ticks.formatters.numeric
    },
    pointLabels: {
        backdropColor: void 0,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
};
$8ae0e8ac8a6018f9$var$RadialLinearScale.defaultRoutes = {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
};
$8ae0e8ac8a6018f9$var$RadialLinearScale.descriptors = {
    angleLines: {
        _fallback: "grid"
    }
};
const $8ae0e8ac8a6018f9$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1e3
    },
    second: {
        common: true,
        size: 1e3,
        steps: 60
    },
    minute: {
        common: true,
        size: 6e4,
        steps: 60
    },
    hour: {
        common: true,
        size: 36e5,
        steps: 24
    },
    day: {
        common: true,
        size: 864e5,
        steps: 30
    },
    week: {
        common: false,
        size: 6048e5,
        steps: 4
    },
    month: {
        common: true,
        size: 2628e6,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7884e6,
        steps: 4
    },
    year: {
        common: true,
        size: 3154e7
    }
};
const $8ae0e8ac8a6018f9$var$UNITS = Object.keys($8ae0e8ac8a6018f9$var$INTERVALS);
function $8ae0e8ac8a6018f9$var$sorter(a, b) {
    return a - b;
}
function $8ae0e8ac8a6018f9$var$parse(scale, input) {
    if ($8ae0e8ac8a6018f9$var$isNullOrUndef(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round2, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!$8ae0e8ac8a6018f9$var$isNumberFinite(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round2) value = round2 === "week" && ($8ae0e8ac8a6018f9$var$isNumber(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round2);
    return +value;
}
function $8ae0e8ac8a6018f9$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $8ae0e8ac8a6018f9$var$UNITS.length;
    for(let i = $8ae0e8ac8a6018f9$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $8ae0e8ac8a6018f9$var$INTERVALS[$8ae0e8ac8a6018f9$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $8ae0e8ac8a6018f9$var$UNITS[i];
    }
    return $8ae0e8ac8a6018f9$var$UNITS[ilen - 1];
}
function $8ae0e8ac8a6018f9$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $8ae0e8ac8a6018f9$var$UNITS.length - 1; i >= $8ae0e8ac8a6018f9$var$UNITS.indexOf(minUnit); i--){
        const unit = $8ae0e8ac8a6018f9$var$UNITS[i];
        if ($8ae0e8ac8a6018f9$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $8ae0e8ac8a6018f9$var$UNITS[minUnit ? $8ae0e8ac8a6018f9$var$UNITS.indexOf(minUnit) : 0];
}
function $8ae0e8ac8a6018f9$var$determineMajorUnit(unit) {
    for(let i = $8ae0e8ac8a6018f9$var$UNITS.indexOf(unit) + 1, ilen = $8ae0e8ac8a6018f9$var$UNITS.length; i < ilen; ++i){
        if ($8ae0e8ac8a6018f9$var$INTERVALS[$8ae0e8ac8a6018f9$var$UNITS[i]].common) return $8ae0e8ac8a6018f9$var$UNITS[i];
    }
}
function $8ae0e8ac8a6018f9$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = $8ae0e8ac8a6018f9$var$_lookup(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $8ae0e8ac8a6018f9$var$setMajorTicks(scale, ticks, map2, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index2;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index2 = map2[major];
        if (index2 >= 0) ticks[index2].major = true;
    }
    return ticks;
}
function $8ae0e8ac8a6018f9$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map2 = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map2[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $8ae0e8ac8a6018f9$var$setMajorTicks(scale, ticks, map2, majorUnit);
}
class $8ae0e8ac8a6018f9$var$TimeScale extends $8ae0e8ac8a6018f9$var$Scale {
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = void 0;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = void 0;
    }
    init(scaleOpts, opts) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $8ae0e8ac8a6018f9$var$adapters._date(scaleOpts.adapters.date);
        adapter.init(opts);
        $8ae0e8ac8a6018f9$var$mergeIf(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index2) {
        if (raw === void 0) return null;
        return $8ae0e8ac8a6018f9$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = $8ae0e8ac8a6018f9$var$isNumberFinite(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = $8ae0e8ac8a6018f9$var$isNumberFinite(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = $8ae0e8ac8a6018f9$var$_filterBetween(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $8ae0e8ac8a6018f9$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $8ae0e8ac8a6018f9$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? void 0 : $8ae0e8ac8a6018f9$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $8ae0e8ac8a6018f9$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = $8ae0e8ac8a6018f9$var$_limitValue(start, 0, limit);
        end = $8ae0e8ac8a6018f9$var$_limitValue(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $8ae0e8ac8a6018f9$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = $8ae0e8ac8a6018f9$var$valueOrDefault(timeOpts.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = $8ae0e8ac8a6018f9$var$isNumber(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 1e5 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$8ae0e8ac8a6018f9$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $8ae0e8ac8a6018f9$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    _tickFormatFunction(time, index2, ticks, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index2];
        const major = majorUnit && majorFormat && tick && tick.major;
        const label = this._adapter.format(time, format || (major ? majorFormat : minorFormat));
        const formatter = options.ticks.callback;
        return formatter ? $8ae0e8ac8a6018f9$var$callback(formatter, [
            label,
            index2,
            ticks
        ], this) : label;
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = $8ae0e8ac8a6018f9$var$toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $8ae0e8ac8a6018f9$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($8ae0e8ac8a6018f9$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return $8ae0e8ac8a6018f9$var$_arrayUnique(values.sort($8ae0e8ac8a6018f9$var$sorter));
    }
}
$8ae0e8ac8a6018f9$var$TimeScale.id = "time";
$8ae0e8ac8a6018f9$var$TimeScale.defaults = {
    bounds: "data",
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: "millisecond",
        displayFormats: {}
    },
    ticks: {
        source: "auto",
        major: {
            enabled: false
        }
    }
};
function $8ae0e8ac8a6018f9$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = $8ae0e8ac8a6018f9$var$_lookupByKey(table, "pos", val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = $8ae0e8ac8a6018f9$var$_lookupByKey(table, "time", val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $8ae0e8ac8a6018f9$var$TimeSeriesScale extends $8ae0e8ac8a6018f9$var$TimeScale {
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = void 0;
        this._tableRange = void 0;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $8ae0e8ac8a6018f9$var$interpolate(table, this.min);
        this._tableRange = $8ae0e8ac8a6018f9$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($8ae0e8ac8a6018f9$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $8ae0e8ac8a6018f9$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
$8ae0e8ac8a6018f9$var$TimeSeriesScale.id = "timeseries";
$8ae0e8ac8a6018f9$var$TimeSeriesScale.defaults = $8ae0e8ac8a6018f9$var$TimeScale.defaults;
function $8ae0e8ac8a6018f9$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $8ae0e8ac8a6018f9$var$isMergeableObject = function isMergeableObject2(value) {
    return $8ae0e8ac8a6018f9$var$isNonNullObject(value) && !$8ae0e8ac8a6018f9$var$isSpecial(value);
};
function $8ae0e8ac8a6018f9$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $8ae0e8ac8a6018f9$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $8ae0e8ac8a6018f9$var$isReactElement(value);
}
var $8ae0e8ac8a6018f9$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $8ae0e8ac8a6018f9$var$REACT_ELEMENT_TYPE = $8ae0e8ac8a6018f9$var$canUseSymbol ? Symbol.for("react.element") : 60103;
function $8ae0e8ac8a6018f9$var$isReactElement(value) {
    return value.$$typeof === $8ae0e8ac8a6018f9$var$REACT_ELEMENT_TYPE;
}
function $8ae0e8ac8a6018f9$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $8ae0e8ac8a6018f9$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $8ae0e8ac8a6018f9$var$deepmerge($8ae0e8ac8a6018f9$var$emptyTarget(value), value, options) : value;
}
function $8ae0e8ac8a6018f9$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element2) {
        return $8ae0e8ac8a6018f9$var$cloneUnlessOtherwiseSpecified(element2, options);
    });
}
function $8ae0e8ac8a6018f9$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $8ae0e8ac8a6018f9$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $8ae0e8ac8a6018f9$var$deepmerge;
}
function $8ae0e8ac8a6018f9$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $8ae0e8ac8a6018f9$var$getKeys(target) {
    return Object.keys(target).concat($8ae0e8ac8a6018f9$var$getEnumerableOwnPropertySymbols(target));
}
function $8ae0e8ac8a6018f9$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
function $8ae0e8ac8a6018f9$var$propertyIsUnsafe(target, key) {
    return $8ae0e8ac8a6018f9$var$propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
}
function $8ae0e8ac8a6018f9$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $8ae0e8ac8a6018f9$var$getKeys(target).forEach(function(key) {
        destination[key] = $8ae0e8ac8a6018f9$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $8ae0e8ac8a6018f9$var$getKeys(source).forEach(function(key) {
        if ($8ae0e8ac8a6018f9$var$propertyIsUnsafe(target, key)) return;
        if ($8ae0e8ac8a6018f9$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $8ae0e8ac8a6018f9$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $8ae0e8ac8a6018f9$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $8ae0e8ac8a6018f9$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $8ae0e8ac8a6018f9$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $8ae0e8ac8a6018f9$var$isMergeableObject;
    options.cloneUnlessOtherwiseSpecified = $8ae0e8ac8a6018f9$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $8ae0e8ac8a6018f9$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $8ae0e8ac8a6018f9$var$mergeObject(target, source, options);
}
$8ae0e8ac8a6018f9$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $8ae0e8ac8a6018f9$var$deepmerge(prev, next, options);
    }, {});
};
var $8ae0e8ac8a6018f9$var$deepmerge_1 = $8ae0e8ac8a6018f9$var$deepmerge;
var $8ae0e8ac8a6018f9$var$cjs = $8ae0e8ac8a6018f9$var$deepmerge_1;
const $8ae0e8ac8a6018f9$var$merge = /* @__PURE__ */ $8ae0e8ac8a6018f9$var$getDefaultExportFromCjs($8ae0e8ac8a6018f9$var$cjs);
const $8ae0e8ac8a6018f9$var$toType = (obj)=>{
    if (obj === null || obj === void 0) return `${obj}`;
    return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
};
const $8ae0e8ac8a6018f9$var$getSelector$1 = (element2)=>{
    let selector = element2.getAttribute("data-mdb-target");
    if (!selector || selector === "#") {
        const hrefAttr = element2.getAttribute("href");
        selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
    }
    return selector;
};
const $8ae0e8ac8a6018f9$var$getSelectorFromElement = (element2)=>{
    const selector = $8ae0e8ac8a6018f9$var$getSelector$1(element2);
    if (selector) return document.querySelector(selector) ? selector : null;
    return null;
};
const $8ae0e8ac8a6018f9$var$getElementFromSelector = (element2)=>{
    const selector = $8ae0e8ac8a6018f9$var$getSelector$1(element2);
    return selector ? document.querySelector(selector) : null;
};
const $8ae0e8ac8a6018f9$var$isElement$1 = (obj)=>{
    if (!obj || typeof obj !== "object") return false;
    if (typeof obj.jquery !== "undefined") obj = obj[0];
    return typeof obj.nodeType !== "undefined";
};
const $8ae0e8ac8a6018f9$var$getElement = (obj)=>{
    if ($8ae0e8ac8a6018f9$var$isElement$1(obj)) return obj.jquery ? obj[0] : obj;
    if (typeof obj === "string" && obj.length > 0) return document.querySelector(obj);
    return null;
};
const $8ae0e8ac8a6018f9$var$typeCheckConfig = (componentName, config, configTypes)=>{
    Object.keys(configTypes).forEach((property)=>{
        const expectedTypes = configTypes[property];
        const value = config[property];
        const valueType = value && $8ae0e8ac8a6018f9$var$isElement$1(value) ? "element" : $8ae0e8ac8a6018f9$var$toType(value);
        if (!new RegExp(expectedTypes).test(valueType)) throw new Error(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
    });
};
const $8ae0e8ac8a6018f9$var$isVisible$1 = (element2)=>{
    if (!element2) return false;
    if (element2.style && element2.parentNode && element2.parentNode.style) {
        const elementStyle = getComputedStyle(element2);
        const parentNodeStyle = getComputedStyle(element2.parentNode);
        return elementStyle.display !== "none" && parentNodeStyle.display !== "none" && elementStyle.visibility !== "hidden";
    }
    return false;
};
const $8ae0e8ac8a6018f9$var$isDisabled$1 = (element2)=>{
    if (!element2 || element2.nodeType !== Node.ELEMENT_NODE) return true;
    if (element2.classList.contains("disabled")) return true;
    if (typeof element2.disabled !== "undefined") return element2.disabled;
    return element2.hasAttribute("disabled") && element2.getAttribute("disabled") !== "false";
};
const $8ae0e8ac8a6018f9$var$getjQuery$1 = ()=>{
    const { jQuery: jQuery } = window;
    if (jQuery && !document.body.hasAttribute("data-mdb-no-jquery")) return jQuery;
    return null;
};
const $8ae0e8ac8a6018f9$var$onDOMContentLoaded = (callback2)=>{
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", callback2);
    else callback2();
};
document.documentElement.dir;
const $8ae0e8ac8a6018f9$var$element = (tag)=>{
    return document.createElement(tag);
};
const $8ae0e8ac8a6018f9$var$defineJQueryPlugin = (plugin)=>{
    $8ae0e8ac8a6018f9$var$onDOMContentLoaded(()=>{
        const $2 = $8ae0e8ac8a6018f9$var$getjQuery$1();
        if ($2) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $2.fn[name];
            $2.fn[name] = plugin.jQueryInterface;
            $2.fn[name].Constructor = plugin;
            $2.fn[name].noConflict = ()=>{
                $2.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $8ae0e8ac8a6018f9$var$mapData = (()=>{
    const storeData = {};
    let id = 1;
    return {
        set (element2, key, data) {
            if (typeof element2[key] === "undefined") {
                element2[key] = {
                    key: key,
                    id: id
                };
                id++;
            }
            storeData[element2[key].id] = data;
        },
        get (element2, key) {
            if (!element2 || typeof element2[key] === "undefined") return null;
            const keyProperties = element2[key];
            if (keyProperties.key === key) return storeData[keyProperties.id];
            return null;
        },
        delete (element2, key) {
            if (typeof element2[key] === "undefined") return;
            const keyProperties = element2[key];
            if (keyProperties.key === key) {
                delete storeData[keyProperties.id];
                delete element2[key];
            }
        }
    };
})();
const $8ae0e8ac8a6018f9$var$Data = {
    setData (instance, key, data) {
        $8ae0e8ac8a6018f9$var$mapData.set(instance, key, data);
    },
    getData (instance, key) {
        return $8ae0e8ac8a6018f9$var$mapData.get(instance, key);
    },
    removeData (instance, key) {
        $8ae0e8ac8a6018f9$var$mapData.delete(instance, key);
    }
};
function $8ae0e8ac8a6018f9$var$normalizeData(val) {
    if (val === "true") return true;
    if (val === "false") return false;
    if (val === Number(val).toString()) return Number(val);
    if (val === "" || val === "null") return null;
    return val;
}
function $8ae0e8ac8a6018f9$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $8ae0e8ac8a6018f9$var$Manipulator = {
    setDataAttribute (element2, key, value) {
        element2.setAttribute(`data-mdb-${$8ae0e8ac8a6018f9$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element2, key) {
        element2.removeAttribute(`data-mdb-${$8ae0e8ac8a6018f9$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element2) {
        if (!element2) return {};
        const attributes = {
            ...element2.dataset
        };
        Object.keys(attributes).filter((key)=>key.startsWith("mdb")).forEach((key)=>{
            let pureKey = key.replace(/^mdb/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $8ae0e8ac8a6018f9$var$normalizeData(attributes[key]);
        });
        return attributes;
    },
    getDataAttribute (element2, key) {
        return $8ae0e8ac8a6018f9$var$normalizeData(element2.getAttribute(`data-mdb-${$8ae0e8ac8a6018f9$var$normalizeDataKey(key)}`));
    },
    offset (element2) {
        const rect = element2.getBoundingClientRect();
        return {
            top: rect.top + document.body.scrollTop,
            left: rect.left + document.body.scrollLeft
        };
    },
    position (element2) {
        return {
            top: element2.offsetTop,
            left: element2.offsetLeft
        };
    },
    style (element2, style) {
        Object.assign(element2.style, style);
    },
    toggleClass (element2, className) {
        if (!element2) return;
        if (element2.classList.contains(className)) element2.classList.remove(className);
        else element2.classList.add(className);
    },
    addClass (element2, className) {
        if (element2.classList.contains(className)) return;
        element2.classList.add(className);
    },
    addStyle (element2, style) {
        Object.keys(style).forEach((property)=>{
            element2.style[property] = style[property];
        });
    },
    removeClass (element2, className) {
        if (!element2.classList.contains(className)) return;
        element2.classList.remove(className);
    },
    hasClass (element2, className) {
        return element2.classList.contains(className);
    }
};
const $8ae0e8ac8a6018f9$var$$ = $8ae0e8ac8a6018f9$var$getjQuery$1();
const $8ae0e8ac8a6018f9$var$namespaceRegex$1 = /[^.]*(?=\..*)\.|.*/;
const $8ae0e8ac8a6018f9$var$stripNameRegex$1 = /\..*/;
const $8ae0e8ac8a6018f9$var$stripUidRegex$1 = /::\d+$/;
const $8ae0e8ac8a6018f9$var$eventRegistry$1 = {};
let $8ae0e8ac8a6018f9$var$uidEvent$1 = 1;
const $8ae0e8ac8a6018f9$var$customEvents$1 = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $8ae0e8ac8a6018f9$var$nativeEvents$1 = [
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
];
function $8ae0e8ac8a6018f9$var$getUidEvent(element2, uid2) {
    return uid2 && `${uid2}::${$8ae0e8ac8a6018f9$var$uidEvent$1++}` || element2.uidEvent || $8ae0e8ac8a6018f9$var$uidEvent$1++;
}
function $8ae0e8ac8a6018f9$var$getEvent(element2) {
    const uid2 = $8ae0e8ac8a6018f9$var$getUidEvent(element2);
    element2.uidEvent = uid2;
    $8ae0e8ac8a6018f9$var$eventRegistry$1[uid2] = $8ae0e8ac8a6018f9$var$eventRegistry$1[uid2] || {};
    return $8ae0e8ac8a6018f9$var$eventRegistry$1[uid2];
}
function $8ae0e8ac8a6018f9$var$bootstrapHandler$1(element2, fn) {
    return function handler(event) {
        event.delegateTarget = element2;
        if (handler.oneOff) $8ae0e8ac8a6018f9$var$EventHandler$1.off(element2, event.type, fn);
        return fn.apply(element2, [
            event
        ]);
    };
}
function $8ae0e8ac8a6018f9$var$bootstrapDelegationHandler$1(element2, selector, fn) {
    return function handler(event) {
        const domElements = element2.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode){
            for(let i = domElements.length; i--;)if (domElements[i] === target) {
                event.delegateTarget = target;
                if (handler.oneOff) $8ae0e8ac8a6018f9$var$EventHandler$1.off(element2, event.type, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        }
        return null;
    };
}
function $8ae0e8ac8a6018f9$var$findHandler$1(events, handler, delegationSelector = null) {
    const uidEventList = Object.keys(events);
    for(let i = 0, len = uidEventList.length; i < len; i++){
        const event = events[uidEventList[i]];
        if (event.originalHandler === handler && event.delegationSelector === delegationSelector) return event;
    }
    return null;
}
function $8ae0e8ac8a6018f9$var$normalizeParams(originalTypeEvent, handler, delegationFn) {
    const delegation = typeof handler === "string";
    const originalHandler = delegation ? delegationFn : handler;
    let typeEvent = originalTypeEvent.replace($8ae0e8ac8a6018f9$var$stripNameRegex$1, "");
    const custom = $8ae0e8ac8a6018f9$var$customEvents$1[typeEvent];
    if (custom) typeEvent = custom;
    const isNative = $8ae0e8ac8a6018f9$var$nativeEvents$1.indexOf(typeEvent) > -1;
    if (!isNative) typeEvent = originalTypeEvent;
    return [
        delegation,
        originalHandler,
        typeEvent
    ];
}
function $8ae0e8ac8a6018f9$var$addHandler$1(element2, originalTypeEvent, handler, delegationFn, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element2) return;
    if (!handler) {
        handler = delegationFn;
        delegationFn = null;
    }
    const [delegation, originalHandler, typeEvent] = $8ae0e8ac8a6018f9$var$normalizeParams(originalTypeEvent, handler, delegationFn);
    const events = $8ae0e8ac8a6018f9$var$getEvent(element2);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFn = $8ae0e8ac8a6018f9$var$findHandler$1(handlers, originalHandler, delegation ? handler : null);
    if (previousFn) {
        previousFn.oneOff = previousFn.oneOff && oneOff;
        return;
    }
    const uid2 = $8ae0e8ac8a6018f9$var$getUidEvent(originalHandler, originalTypeEvent.replace($8ae0e8ac8a6018f9$var$namespaceRegex$1, ""));
    const fn = delegation ? $8ae0e8ac8a6018f9$var$bootstrapDelegationHandler$1(element2, handler, delegationFn) : $8ae0e8ac8a6018f9$var$bootstrapHandler$1(element2, handler);
    fn.delegationSelector = delegation ? handler : null;
    fn.originalHandler = originalHandler;
    fn.oneOff = oneOff;
    fn.uidEvent = uid2;
    handlers[uid2] = fn;
    element2.addEventListener(typeEvent, fn, delegation);
}
function $8ae0e8ac8a6018f9$var$removeHandler$1(element2, events, typeEvent, handler, delegationSelector) {
    const fn = $8ae0e8ac8a6018f9$var$findHandler$1(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element2.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $8ae0e8ac8a6018f9$var$removeNamespacedHandlers$1(element2, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    Object.keys(storeElementEvent).forEach((handlerKey)=>{
        if (handlerKey.indexOf(namespace) > -1) {
            const event = storeElementEvent[handlerKey];
            $8ae0e8ac8a6018f9$var$removeHandler$1(element2, events, typeEvent, event.originalHandler, event.delegationSelector);
        }
    });
}
const $8ae0e8ac8a6018f9$var$EventHandler$1 = {
    on (element2, event, handler, delegationFn) {
        $8ae0e8ac8a6018f9$var$addHandler$1(element2, event, handler, delegationFn, false);
    },
    one (element2, event, handler, delegationFn) {
        $8ae0e8ac8a6018f9$var$addHandler$1(element2, event, handler, delegationFn, true);
    },
    extend (element2, events, componentName) {
        events.forEach((event)=>{
            $8ae0e8ac8a6018f9$var$EventHandler$1.on(element2, `${event.name}.bs.${componentName}`, (e)=>{
                const eventParameters = {};
                if (event.parametersToCopy) event.parametersToCopy.forEach((param)=>{
                    eventParameters[param] = e[param];
                });
                const mdbEvent = $8ae0e8ac8a6018f9$var$EventHandler$1.trigger(element2, `${event.name}.mdb.${componentName}`, eventParameters);
                if (mdbEvent.defaultPrevented) e.preventDefault();
            });
        });
    },
    off (element2, originalTypeEvent, handler, delegationFn) {
        if (typeof originalTypeEvent !== "string" || !element2) return;
        const [delegation, originalHandler, typeEvent] = $8ae0e8ac8a6018f9$var$normalizeParams(originalTypeEvent, handler, delegationFn);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $8ae0e8ac8a6018f9$var$getEvent(element2);
        const isNamespace = originalTypeEvent.charAt(0) === ".";
        if (typeof originalHandler !== "undefined") {
            if (!events || !events[typeEvent]) return;
            $8ae0e8ac8a6018f9$var$removeHandler$1(element2, events, typeEvent, originalHandler, delegation ? handler : null);
            return;
        }
        if (isNamespace) Object.keys(events).forEach((elementEvent)=>{
            $8ae0e8ac8a6018f9$var$removeNamespacedHandlers$1(element2, events, elementEvent, originalTypeEvent.slice(1));
        });
        const storeElementEvent = events[typeEvent] || {};
        Object.keys(storeElementEvent).forEach((keyHandlers)=>{
            const handlerKey = keyHandlers.replace($8ae0e8ac8a6018f9$var$stripUidRegex$1, "");
            if (!inNamespace || originalTypeEvent.indexOf(handlerKey) > -1) {
                const event = storeElementEvent[keyHandlers];
                $8ae0e8ac8a6018f9$var$removeHandler$1(element2, events, typeEvent, event.originalHandler, event.delegationSelector);
            }
        });
    },
    trigger (element2, event, args) {
        if (typeof event !== "string" || !element2) return null;
        const typeEvent = event.replace($8ae0e8ac8a6018f9$var$stripNameRegex$1, "");
        const inNamespace = event !== typeEvent;
        const isNative = $8ae0e8ac8a6018f9$var$nativeEvents$1.indexOf(typeEvent) > -1;
        let jQueryEvent;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        let evt = null;
        if (inNamespace && $8ae0e8ac8a6018f9$var$$) {
            jQueryEvent = $8ae0e8ac8a6018f9$var$$.Event(event, args);
            $8ae0e8ac8a6018f9$var$$(element2).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        if (isNative) {
            evt = document.createEvent("HTMLEvents");
            evt.initEvent(typeEvent, bubbles, true);
        } else evt = new CustomEvent(event, {
            bubbles: bubbles,
            cancelable: true
        });
        if (typeof args !== "undefined") Object.keys(args).forEach((key)=>{
            Object.defineProperty(evt, key, {
                get () {
                    return args[key];
                }
            });
        });
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element2.dispatchEvent(evt);
        if (evt.defaultPrevented && typeof jQueryEvent !== "undefined") jQueryEvent.preventDefault();
        return evt;
    }
};
class $8ae0e8ac8a6018f9$var$BaseComponent {
    constructor(element2){
        element2 = $8ae0e8ac8a6018f9$var$getElement(element2);
        if (!element2) return;
        this._element = element2;
        $8ae0e8ac8a6018f9$var$Data.setData(this._element, this.constructor.DATA_KEY, this);
    }
    dispose() {
        $8ae0e8ac8a6018f9$var$Data.removeData(this._element, this.constructor.DATA_KEY);
        $8ae0e8ac8a6018f9$var$EventHandler$1.off(this._element, this.constructor.EVENT_KEY);
        Object.getOwnPropertyNames(this).forEach((propertyName)=>{
            this[propertyName] = null;
        });
    }
    /** Static */ static getInstance(element2) {
        return $8ae0e8ac8a6018f9$var$Data.getData($8ae0e8ac8a6018f9$var$getElement(element2), this.DATA_KEY);
    }
    static getOrCreateInstance(element2, config = {}) {
        return this.getInstance(element2) || new this(element2, typeof config === "object" ? config : null);
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    static get DATA_KEY() {
        return `mdb.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
}
const $8ae0e8ac8a6018f9$var$NODE_TEXT = 3;
const $8ae0e8ac8a6018f9$var$SelectorEngine$1 = {
    closest (element2, selector) {
        return element2.closest(selector);
    },
    matches (element2, selector) {
        return element2.matches(selector);
    },
    find (selector, element2 = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element2, selector));
    },
    findOne (selector, element2 = document.documentElement) {
        return Element.prototype.querySelector.call(element2, selector);
    },
    children (element2, selector) {
        const children = [].concat(...element2.children);
        return children.filter((child)=>child.matches(selector));
    },
    parents (element2, selector) {
        const parents = [];
        let ancestor = element2.parentNode;
        while(ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== $8ae0e8ac8a6018f9$var$NODE_TEXT){
            if (this.matches(ancestor, selector)) parents.push(ancestor);
            ancestor = ancestor.parentNode;
        }
        return parents;
    },
    prev (element2, selector) {
        let previous = element2.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    next (element2, selector) {
        let next = element2.nextElementSibling;
        while(next){
            if (this.matches(next, selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    }
};
const $8ae0e8ac8a6018f9$var$mapComponentsData = (()=>{
    const componentsData = [];
    return {
        set (componentName) {
            componentsData.push(componentName);
        },
        get (componentName) {
            return componentsData.includes(componentName);
        }
    };
})();
const $8ae0e8ac8a6018f9$var$InitializedComponents = {
    set (componentName) {
        $8ae0e8ac8a6018f9$var$mapComponentsData.set(componentName);
    },
    get (componentName) {
        return $8ae0e8ac8a6018f9$var$mapComponentsData.get(componentName);
    }
};
const $8ae0e8ac8a6018f9$var$isInitialized = (componentName)=>{
    return $8ae0e8ac8a6018f9$var$InitializedComponents.get(componentName);
};
const $8ae0e8ac8a6018f9$var$bindCallbackEventsIfNeeded = (component)=>{
    if (!$8ae0e8ac8a6018f9$var$isInitialized(component.NAME)) {
        const manualInit = true;
        $8ae0e8ac8a6018f9$var$initComponent(component, manualInit);
    }
};
const $8ae0e8ac8a6018f9$var$initComponent = (component, manualInit = false)=>{
    if (!component || $8ae0e8ac8a6018f9$var$InitializedComponents.get(component.NAME)) return;
    if (!manualInit) $8ae0e8ac8a6018f9$var$InitializedComponents.set(component.NAME);
    const thisComponent = $8ae0e8ac8a6018f9$var$_defaultInitSelectors[component.NAME] || null;
    const isToggler = (thisComponent == null ? void 0 : thisComponent.isToggler) || false;
    $8ae0e8ac8a6018f9$var$defineJQueryPlugin(component);
    if (thisComponent == null ? void 0 : thisComponent.advanced) {
        thisComponent.advanced(component, thisComponent == null ? void 0 : thisComponent.selector);
        return;
    }
    if (isToggler) {
        thisComponent.callback(component, thisComponent == null ? void 0 : thisComponent.selector);
        return;
    }
    if (manualInit) return;
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(thisComponent == null ? void 0 : thisComponent.selector).forEach((element2)=>{
        let instance = component.getInstance(element2);
        if (!instance) {
            instance = new component(element2);
            if (thisComponent == null ? void 0 : thisComponent.onInit) instance[thisComponent.onInit]();
        }
    });
};
let $8ae0e8ac8a6018f9$var$_defaultInitSelectors;
class $8ae0e8ac8a6018f9$var$InitMDB {
    constructor(defaultInitSelectors2){
        $8ae0e8ac8a6018f9$var$__publicField(this, "init", (components)=>{
            components.forEach((component)=>$8ae0e8ac8a6018f9$var$initComponent(component));
        });
        $8ae0e8ac8a6018f9$var$__publicField(this, "initMDB", (components, checkOtherImports = false)=>{
            const componentList = Object.keys($8ae0e8ac8a6018f9$var$_defaultInitSelectors).map((element2)=>{
                const requireAutoInit = Boolean(document.querySelector($8ae0e8ac8a6018f9$var$_defaultInitSelectors[element2].selector));
                if (requireAutoInit) {
                    const component = components[$8ae0e8ac8a6018f9$var$_defaultInitSelectors[element2].name];
                    if (!component && !$8ae0e8ac8a6018f9$var$InitializedComponents.get(element2) && checkOtherImports) console.warn(`Please import ${$8ae0e8ac8a6018f9$var$_defaultInitSelectors[element2].name} from "MDB" package and add it to a object parameter inside "initMDB" function`);
                    return component;
                }
                return null;
            });
            this.init(componentList);
        });
        $8ae0e8ac8a6018f9$var$_defaultInitSelectors = defaultInitSelectors2;
    }
}
const $8ae0e8ac8a6018f9$var$DEFAULT_LEGEND_COLOR = {
    plugins: {
        legend: {
            labels: {
                color: "rgb(102,102,102)"
            }
        }
    }
};
const $8ae0e8ac8a6018f9$var$DEFAULT_OPTIONS = {
    line: {
        options: {
            ...$8ae0e8ac8a6018f9$var$DEFAULT_LEGEND_COLOR,
            elements: {
                line: {
                    backgroundColor: "rgba(59, 112, 202, 0.0)",
                    borderColor: "rgb(59, 112, 202)",
                    borderWidth: 2,
                    tension: 0
                },
                point: {
                    borderColor: "rgb(59, 112, 202)",
                    backgroundColor: "rgb(59, 112, 202)"
                }
            },
            responsive: true,
            legend: {
                display: true
            },
            tooltips: {
                intersect: false,
                mode: "index"
            },
            datasets: {
                borderColor: "red"
            },
            scales: {
                x: {
                    stacked: true,
                    grid: {
                        display: false
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                },
                y: {
                    stacked: false,
                    grid: {
                        borderDash: [
                            2
                        ],
                        drawBorder: false,
                        zeroLineColor: "rgba(0,0,0,0)",
                        zeroLineBorderDash: [
                            2
                        ],
                        zeroLineBorderDashOffset: [
                            2
                        ]
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                }
            }
        }
    },
    bar: {
        options: {
            ...$8ae0e8ac8a6018f9$var$DEFAULT_LEGEND_COLOR,
            backgroundColor: "rgb(59, 112, 202)",
            borderWidth: 0,
            responsive: true,
            legend: {
                display: true
            },
            tooltips: {
                intersect: false,
                mode: "index"
            },
            scales: {
                x: {
                    stacked: true,
                    grid: {
                        display: false
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                },
                y: {
                    stacked: true,
                    grid: {
                        borderDash: [
                            2
                        ],
                        drawBorder: false,
                        zeroLineColor: "rgba(0,0,0,0)",
                        zeroLineBorderDash: [
                            2
                        ],
                        zeroLineBorderDashOffset: [
                            2
                        ]
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                }
            }
        }
    },
    pie: {
        options: {
            ...$8ae0e8ac8a6018f9$var$DEFAULT_LEGEND_COLOR,
            elements: {
                arc: {
                    backgroundColor: "rgb(59, 112, 202)"
                }
            },
            responsive: true,
            legend: {
                display: true
            }
        }
    },
    doughnut: {
        options: {
            ...$8ae0e8ac8a6018f9$var$DEFAULT_LEGEND_COLOR,
            elements: {
                arc: {
                    backgroundColor: "rgb(59, 112, 202)"
                }
            },
            responsive: true,
            legend: {
                display: true
            }
        }
    },
    polarArea: {
        options: {
            ...$8ae0e8ac8a6018f9$var$DEFAULT_LEGEND_COLOR,
            elements: {
                arc: {
                    backgroundColor: "rgba(59, 112, 202, 0.5)"
                }
            },
            responsive: true,
            legend: {
                display: true
            }
        }
    },
    radar: {
        options: {
            ...$8ae0e8ac8a6018f9$var$DEFAULT_LEGEND_COLOR,
            elements: {
                line: {
                    backgroundColor: "rgba(59, 112, 202, 0.5)",
                    borderColor: "rgb(59, 112, 202)",
                    borderWidth: 2
                },
                point: {
                    borderColor: "rgb(59, 112, 202)",
                    backgroundColor: "rgb(59, 112, 202)"
                }
            },
            responsive: true,
            legend: {
                display: true
            }
        }
    },
    scatter: {
        options: {
            ...$8ae0e8ac8a6018f9$var$DEFAULT_LEGEND_COLOR,
            elements: {
                line: {
                    backgroundColor: "rgba(59, 112, 202, 0.5)",
                    borderColor: "rgb(59, 112, 202)",
                    borderWidth: 2,
                    tension: 0
                },
                point: {
                    borderColor: "rgb(59, 112, 202)",
                    backgroundColor: "rgba(59, 112, 202, 0.5)"
                }
            },
            responsive: true,
            legend: {
                display: true
            },
            tooltips: {
                intersect: false,
                mode: "index"
            },
            datasets: {
                borderColor: "red"
            },
            scales: {
                x: {
                    stacked: true,
                    grid: {
                        display: false
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                },
                y: {
                    stacked: false,
                    grid: {
                        borderDash: [
                            2
                        ],
                        drawBorder: false,
                        zeroLineColor: "rgba(0,0,0,0)",
                        zeroLineBorderDash: [
                            2
                        ],
                        zeroLineBorderDashOffset: [
                            2
                        ]
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                }
            }
        }
    },
    bubble: {
        options: {
            ...$8ae0e8ac8a6018f9$var$DEFAULT_LEGEND_COLOR,
            elements: {
                point: {
                    borderColor: "rgb(59, 112, 202)",
                    backgroundColor: "rgba(59, 112, 202, 0.5)"
                }
            },
            responsive: true,
            legend: {
                display: true
            },
            scales: {
                x: {
                    grid: {
                        display: false
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                },
                y: {
                    grid: {
                        borderDash: [
                            2
                        ],
                        drawBorder: false,
                        zeroLineColor: "rgba(0,0,0,0)",
                        zeroLineBorderDash: [
                            2
                        ],
                        zeroLineBorderDashOffset: [
                            2
                        ]
                    },
                    ticks: {
                        fontColor: "rgba(0,0,0, 0.5)"
                    }
                }
            }
        }
    }
};
$8ae0e8ac8a6018f9$var$Chart$1.register($8ae0e8ac8a6018f9$var$ArcElement, $8ae0e8ac8a6018f9$var$LineElement, $8ae0e8ac8a6018f9$var$BarElement, $8ae0e8ac8a6018f9$var$PointElement, $8ae0e8ac8a6018f9$var$BarController, $8ae0e8ac8a6018f9$var$BubbleController, $8ae0e8ac8a6018f9$var$DoughnutController, $8ae0e8ac8a6018f9$var$LineController, $8ae0e8ac8a6018f9$var$PieController, $8ae0e8ac8a6018f9$var$PolarAreaController, $8ae0e8ac8a6018f9$var$RadarController, $8ae0e8ac8a6018f9$var$ScatterController, $8ae0e8ac8a6018f9$var$CategoryScale, $8ae0e8ac8a6018f9$var$LinearScale, $8ae0e8ac8a6018f9$var$LogarithmicScale, $8ae0e8ac8a6018f9$var$RadialLinearScale, $8ae0e8ac8a6018f9$var$TimeScale, $8ae0e8ac8a6018f9$var$TimeSeriesScale, $8ae0e8ac8a6018f9$var$plugin_decimation, $8ae0e8ac8a6018f9$var$index, $8ae0e8ac8a6018f9$var$plugin_legend, $8ae0e8ac8a6018f9$var$plugin_title, $8ae0e8ac8a6018f9$var$plugin_tooltip, $8ae0e8ac8a6018f9$var$plugin_subtitle);
const $8ae0e8ac8a6018f9$var$NAME = "chart";
const $8ae0e8ac8a6018f9$var$DATA_KEY = "mdb.chart";
const $8ae0e8ac8a6018f9$var$CLASSNAME_CHARTS = "chart";
const $8ae0e8ac8a6018f9$var$GENERATE_DATA = (options, type, defaultType)=>{
    const mergeObjects = (target, source, options2)=>{
        const destination = target.slice();
        source.forEach((item, index2)=>{
            if (typeof destination[index2] === "undefined") destination[index2] = options2.cloneUnlessOtherwiseSpecified(item, options2);
            else if (options2.isMergeableObject(item)) destination[index2] = $8ae0e8ac8a6018f9$var$merge(target[index2], item, options2);
            else if (target.indexOf(item) === -1) destination.push(item);
        });
        return destination;
    };
    return $8ae0e8ac8a6018f9$var$merge(defaultType[type], options, {
        arrayMerge: mergeObjects
    });
};
const $8ae0e8ac8a6018f9$var$DEFAULT_DARK_OPTIONS = {
    darkTicksColor: "#fff",
    darkLabelColor: "#fff",
    darkGridLinesColor: "#555",
    darkmodeOff: "undefined",
    darkMode: null,
    darkBgColor: "#262626",
    darkBgColorLight: "#fff",
    options: null
};
const $8ae0e8ac8a6018f9$var$DARK_OPTIONS_TYPE = {
    darkTicksColor: "string",
    darkLabelColor: "string",
    darkGridLinesColor: "string",
    darkmodeOff: "(string|null)",
    darkMode: "(string|null)",
    darkBgColor: "string",
    darkBgColorLight: "string",
    options: "(object|null)"
};
class $8ae0e8ac8a6018f9$export$acaa6426d77a227e extends $8ae0e8ac8a6018f9$var$BaseComponent {
    constructor(element2, data, options = {}, darkOptions = {}){
        super(element2);
        this._data = data;
        this._options = options;
        this._type = data.type;
        this._canvas = null;
        this._chart = null;
        this._darkOptions = this._getDarkConfig(darkOptions);
        this._darkModeClassContainer = document.querySelector("html");
        this._prevConfig = options;
        this._observer = null;
        if (this._element) {
            $8ae0e8ac8a6018f9$var$Manipulator.addClass(this._element, $8ae0e8ac8a6018f9$var$CLASSNAME_CHARTS);
            this._chartConstructor();
            $8ae0e8ac8a6018f9$var$Manipulator.setDataAttribute(this._element, `${this.constructor.NAME}-initialized`, true);
            $8ae0e8ac8a6018f9$var$bindCallbackEventsIfNeeded(this.constructor);
        }
        if (this._element && this._darkOptions.darkmodeOff !== null) {
            let mode;
            switch(this._darkOptions.darkMode){
                case "dark":
                    mode = "dark";
                    break;
                case "light":
                    mode = "light";
                    break;
                default:
                    mode = this.systemColorMode;
                    break;
            }
            this._handleMode(mode);
            this._observer = new MutationObserver(this._observerCallback.bind(this));
            this._observer.observe(this._darkModeClassContainer, {
                attributes: true
            });
        }
    }
    // Getters
    static get NAME() {
        return $8ae0e8ac8a6018f9$var$NAME;
    }
    get systemColorMode() {
        return localStorage.theme || $8ae0e8ac8a6018f9$var$Manipulator.getDataAttribute(this._darkModeClassContainer, "theme") || "light";
    }
    static get BarController() {
        return $8ae0e8ac8a6018f9$var$BarController;
    }
    static get BubbleController() {
        return $8ae0e8ac8a6018f9$var$BubbleController;
    }
    static get DoughnutController() {
        return $8ae0e8ac8a6018f9$var$DoughnutController;
    }
    static get LineController() {
        return $8ae0e8ac8a6018f9$var$LineController;
    }
    static get PieController() {
        return $8ae0e8ac8a6018f9$var$PieController;
    }
    static get PolarAreaController() {
        return $8ae0e8ac8a6018f9$var$PolarAreaController;
    }
    static get RadarController() {
        return $8ae0e8ac8a6018f9$var$RadarController;
    }
    static get ScatterController() {
        return $8ae0e8ac8a6018f9$var$ScatterController;
    }
    // Public
    dispose() {
        this._observer.disconnect();
        $8ae0e8ac8a6018f9$var$Data.removeData(this._element, $8ae0e8ac8a6018f9$var$DATA_KEY);
        this._chart.destroy();
        $8ae0e8ac8a6018f9$var$Manipulator.removeDataAttribute(this._element, `${this.constructor.NAME}-initialized`);
        super.dispose();
    }
    update(data, config = {}) {
        if (data) {
            this._data = {
                ...this._data,
                ...data
            };
            this._chart.data = this._data;
        }
        const configOptions = Object.prototype.hasOwnProperty.call(config, "options") ? config : {
            options: {
                ...config
            }
        };
        this._options = $8ae0e8ac8a6018f9$var$merge(this._options, configOptions);
        this._chart.options = $8ae0e8ac8a6018f9$var$GENERATE_DATA(this._options, this._type, $8ae0e8ac8a6018f9$var$DEFAULT_OPTIONS).options;
        this._chart.update();
    }
    static register(MyType) {
        $8ae0e8ac8a6018f9$var$Chart$1.register(MyType);
    }
    setTheme(theme) {
        if (theme !== "dark" && theme !== "light" || !this._data) return;
        this._handleMode(theme);
    }
    // Private
    _getDarkConfig(config) {
        let dataAttributes = {};
        const dataAttr = $8ae0e8ac8a6018f9$var$Manipulator.getDataAttributes(this._element);
        Object.keys(dataAttr).forEach((key)=>key.startsWith("dark") && (dataAttributes[key] = dataAttr[key]));
        dataAttributes = {
            ...$8ae0e8ac8a6018f9$var$DEFAULT_DARK_OPTIONS,
            ...dataAttributes
        };
        const xyScale = {
            y: {
                ticks: {
                    color: dataAttributes.darkTicksColor
                },
                grid: {
                    color: dataAttributes.darkGridLinesColor
                }
            },
            x: {
                ticks: {
                    color: dataAttributes.darkTicksColor
                },
                grid: {
                    color: dataAttributes.darkGridLinesColor
                }
            }
        };
        const rScale = {
            r: {
                ticks: {
                    color: dataAttributes.darkTicksColor,
                    backdropColor: dataAttributes.darkBgColor
                },
                grid: {
                    color: dataAttributes.darkGridLinesColor
                },
                pointLabels: {
                    color: dataAttributes.darkTicksColor
                }
            }
        };
        const radials = [
            "pie",
            "doughnut",
            "polarArea",
            "radar"
        ];
        let scales = {};
        if (!radials.includes(this._type)) scales = xyScale;
        else if ([
            "polarArea",
            "radar"
        ].includes(this._type)) scales = rScale;
        const opt = {
            scales: scales,
            plugins: {
                legend: {
                    labels: {
                        color: dataAttributes.darkLabelColor
                    }
                }
            }
        };
        config = {
            ...dataAttributes,
            options: {
                ...opt
            },
            ...config
        };
        $8ae0e8ac8a6018f9$var$typeCheckConfig($8ae0e8ac8a6018f9$var$NAME, config, $8ae0e8ac8a6018f9$var$DARK_OPTIONS_TYPE);
        return config;
    }
    _getLightTheme(type) {
        const defaultOptions = $8ae0e8ac8a6018f9$var$DEFAULT_OPTIONS[`${type}`] ? $8ae0e8ac8a6018f9$var$DEFAULT_OPTIONS[`${type}`].options : {};
        const prevConfig = this._prevConfig || {};
        return $8ae0e8ac8a6018f9$var$merge(defaultOptions, prevConfig);
    }
    _chartConstructor() {
        if (this._data) {
            this._createCanvas();
            const options = $8ae0e8ac8a6018f9$var$GENERATE_DATA(this._options, this._type, $8ae0e8ac8a6018f9$var$DEFAULT_OPTIONS);
            this._chart = new $8ae0e8ac8a6018f9$var$Chart$1(this._canvas, {
                ...this._data,
                ...options
            });
        }
    }
    _createCanvas() {
        if (this._canvas) return;
        if (this._element.nodeName === "CANVAS") this._canvas = this._element;
        else {
            this._canvas = $8ae0e8ac8a6018f9$var$element("canvas");
            this._element.appendChild(this._canvas);
        }
    }
    _handleMode(systemColor) {
        if (systemColor === "dark") {
            this._changeDatasetBorderColor();
            this.update(null, this._darkOptions.options);
        } else {
            this._changeDatasetBorderColor(false);
            this._options = null;
            this.update(null, this._getLightTheme(this._type));
        }
    }
    _observerCallback(mutationList) {
        mutationList.forEach((mutation)=>{
            if (mutation.type === "attributes") this._handleMode(this.systemColorMode);
        });
    }
    _changeDatasetBorderColor(dark = true) {
        if (!this._data.data) return;
        [
            ...this._data.data.datasets
        ].forEach((set2)=>[
                "pie",
                "doughnut",
                "polarArea"
            ].includes(this._type) && (set2.borderColor = dark ? this._darkOptions.darkBgColor : this._darkOptions.darkBgColorLight));
    }
    static jQueryInterface(data, options, type) {
        return this.each(function() {
            let chartData = $8ae0e8ac8a6018f9$var$Data.getData(this, $8ae0e8ac8a6018f9$var$DATA_KEY);
            if (!chartData && /dispose/.test(data)) return;
            if (!chartData) {
                const chartOptions = options ? $8ae0e8ac8a6018f9$var$GENERATE_DATA(options, type, $8ae0e8ac8a6018f9$var$DEFAULT_OPTIONS) : $8ae0e8ac8a6018f9$var$DEFAULT_OPTIONS[type];
                chartData = new $8ae0e8ac8a6018f9$export$acaa6426d77a227e(this, data, chartOptions);
            }
            if (typeof data === "string") {
                if (typeof chartData[data] === "undefined") throw new TypeError(`No method named "${data}"`);
                chartData[data](options, type);
            }
        });
    }
    static getInstance(element2) {
        return $8ae0e8ac8a6018f9$var$Data.getData(element2, $8ae0e8ac8a6018f9$var$DATA_KEY);
    }
    static getOrCreateInstance(element2, config = {}) {
        return this.getInstance(element2) || new this(element2, typeof config === "object" ? config : null);
    }
}
const $8ae0e8ac8a6018f9$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
const $8ae0e8ac8a6018f9$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $8ae0e8ac8a6018f9$var$isVisible = (element2)=>{
    if (!$8ae0e8ac8a6018f9$var$isElement(element2) || element2.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element2).getPropertyValue("visibility") === "visible";
    const closedDetails = element2.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element2) {
        const summary = element2.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $8ae0e8ac8a6018f9$var$isDisabled = (element2)=>{
    if (!element2 || element2.nodeType !== Node.ELEMENT_NODE) return true;
    if (element2.classList.contains("disabled")) return true;
    if (typeof element2.disabled !== "undefined") return element2.disabled;
    return element2.hasAttribute("disabled") && element2.getAttribute("disabled") !== "false";
};
const $8ae0e8ac8a6018f9$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-mdb-no-jquery")) return window.jQuery;
    return null;
};
const $8ae0e8ac8a6018f9$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $8ae0e8ac8a6018f9$var$stripNameRegex = /\..*/;
const $8ae0e8ac8a6018f9$var$stripUidRegex = /::\d+$/;
const $8ae0e8ac8a6018f9$var$eventRegistry = {};
let $8ae0e8ac8a6018f9$var$uidEvent = 1;
const $8ae0e8ac8a6018f9$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $8ae0e8ac8a6018f9$var$nativeEvents = /* @__PURE__ */ new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
function $8ae0e8ac8a6018f9$var$makeEventUid(element2, uid2) {
    return uid2 && `${uid2}::${$8ae0e8ac8a6018f9$var$uidEvent++}` || element2.uidEvent || $8ae0e8ac8a6018f9$var$uidEvent++;
}
function $8ae0e8ac8a6018f9$var$getElementEvents(element2) {
    const uid2 = $8ae0e8ac8a6018f9$var$makeEventUid(element2);
    element2.uidEvent = uid2;
    $8ae0e8ac8a6018f9$var$eventRegistry[uid2] = $8ae0e8ac8a6018f9$var$eventRegistry[uid2] || {};
    return $8ae0e8ac8a6018f9$var$eventRegistry[uid2];
}
function $8ae0e8ac8a6018f9$var$bootstrapHandler(element2, fn) {
    return function handler(event) {
        $8ae0e8ac8a6018f9$var$hydrateObj(event, {
            delegateTarget: element2
        });
        if (handler.oneOff) $8ae0e8ac8a6018f9$var$EventHandler.off(element2, event.type, fn);
        return fn.apply(element2, [
            event
        ]);
    };
}
function $8ae0e8ac8a6018f9$var$bootstrapDelegationHandler(element2, selector, fn) {
    return function handler(event) {
        const domElements = element2.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $8ae0e8ac8a6018f9$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $8ae0e8ac8a6018f9$var$EventHandler.off(element2, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $8ae0e8ac8a6018f9$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $8ae0e8ac8a6018f9$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $8ae0e8ac8a6018f9$var$getTypeEvent(originalTypeEvent);
    if (!$8ae0e8ac8a6018f9$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $8ae0e8ac8a6018f9$var$addHandler(element2, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element2) return;
    let [isDelegated, callable, typeEvent] = $8ae0e8ac8a6018f9$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    if (originalTypeEvent in $8ae0e8ac8a6018f9$var$customEvents) {
        const wrapFunction = (fn2)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn2.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $8ae0e8ac8a6018f9$var$getElementEvents(element2);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $8ae0e8ac8a6018f9$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid2 = $8ae0e8ac8a6018f9$var$makeEventUid(callable, originalTypeEvent.replace($8ae0e8ac8a6018f9$var$namespaceRegex, ""));
    const fn = isDelegated ? $8ae0e8ac8a6018f9$var$bootstrapDelegationHandler(element2, handler, callable) : $8ae0e8ac8a6018f9$var$bootstrapHandler(element2, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid2;
    handlers[uid2] = fn;
    element2.addEventListener(typeEvent, fn, isDelegated);
}
function $8ae0e8ac8a6018f9$var$removeHandler(element2, events, typeEvent, handler, delegationSelector) {
    const fn = $8ae0e8ac8a6018f9$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element2.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $8ae0e8ac8a6018f9$var$removeNamespacedHandlers(element2, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $8ae0e8ac8a6018f9$var$removeHandler(element2, events, typeEvent, event.callable, event.delegationSelector);
}
function $8ae0e8ac8a6018f9$var$getTypeEvent(event) {
    event = event.replace($8ae0e8ac8a6018f9$var$stripNameRegex, "");
    return $8ae0e8ac8a6018f9$var$customEvents[event] || event;
}
const $8ae0e8ac8a6018f9$var$EventHandler = {
    on (element2, event, handler, delegationFunction) {
        $8ae0e8ac8a6018f9$var$addHandler(element2, event, handler, delegationFunction, false);
    },
    one (element2, event, handler, delegationFunction) {
        $8ae0e8ac8a6018f9$var$addHandler(element2, event, handler, delegationFunction, true);
    },
    off (element2, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element2) return;
        const [isDelegated, callable, typeEvent] = $8ae0e8ac8a6018f9$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $8ae0e8ac8a6018f9$var$getElementEvents(element2);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            if (!Object.keys(storeElementEvent).length) return;
            $8ae0e8ac8a6018f9$var$removeHandler(element2, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$8ae0e8ac8a6018f9$var$removeNamespacedHandlers(element2, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($8ae0e8ac8a6018f9$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $8ae0e8ac8a6018f9$var$removeHandler(element2, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element2, event, args) {
        if (typeof event !== "string" || !element2) return null;
        const $2 = $8ae0e8ac8a6018f9$var$getjQuery();
        const typeEvent = $8ae0e8ac8a6018f9$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $2) {
            jQueryEvent = $2.Event(event, args);
            $2(element2).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $8ae0e8ac8a6018f9$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element2.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $8ae0e8ac8a6018f9$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch  {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
const $8ae0e8ac8a6018f9$var$getSelector = (element2)=>{
    let selector = element2.getAttribute("data-mdb-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element2.getAttribute("href");
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$8ae0e8ac8a6018f9$var$parseSelector(sel)).join(",") : null;
};
const $8ae0e8ac8a6018f9$var$SelectorEngine = {
    find (selector, element2 = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element2, selector));
    },
    findOne (selector, element2 = document.documentElement) {
        return Element.prototype.querySelector.call(element2, selector);
    },
    children (element2, selector) {
        return [].concat(...element2.children).filter((child)=>child.matches(selector));
    },
    parents (element2, selector) {
        const parents = [];
        let ancestor = element2.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element2, selector) {
        let previous = element2.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element2, selector) {
        let next = element2.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element2) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element2).filter((el)=>!$8ae0e8ac8a6018f9$var$isDisabled(el) && $8ae0e8ac8a6018f9$var$isVisible(el));
    },
    getSelectorFromElement (element2) {
        const selector = $8ae0e8ac8a6018f9$var$getSelector(element2);
        if (selector) return $8ae0e8ac8a6018f9$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element2) {
        const selector = $8ae0e8ac8a6018f9$var$getSelector(element2);
        return selector ? $8ae0e8ac8a6018f9$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element2) {
        const selector = $8ae0e8ac8a6018f9$var$getSelector(element2);
        return selector ? $8ae0e8ac8a6018f9$var$SelectorEngine.find(selector) : [];
    }
};
const $8ae0e8ac8a6018f9$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $8ae0e8ac8a6018f9$var$EventHandler.on(document, clickEvent, `[data-mdb-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($8ae0e8ac8a6018f9$var$isDisabled(this)) return;
        const target = $8ae0e8ac8a6018f9$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        instance[method]();
    });
};
const $8ae0e8ac8a6018f9$var$callbackInitState$1 = /* @__PURE__ */ new Map();
const $8ae0e8ac8a6018f9$var$alertCallback$1 = (component, initSelector)=>{
    const Alert = component;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) {
        $8ae0e8ac8a6018f9$var$enableDismissTrigger(Alert);
        $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
    }
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(initSelector).forEach((element2)=>{
        return Alert.getOrCreateInstance(element2);
    });
};
const $8ae0e8ac8a6018f9$var$buttonCallback = (component, initSelector)=>{
    const Button = component;
    const EVENT_CLICK_DATA_API = `click.bs.${component.name}.data-api`;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) {
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API, initSelector, (event)=>{
            event.preventDefault();
            const button = event.target.closest(initSelector);
            const data = Button.getOrCreateInstance(button);
            data.toggle();
        });
        $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
    }
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(initSelector).forEach((element2)=>{
        return Button.getOrCreateInstance(element2);
    });
};
const $8ae0e8ac8a6018f9$var$carouselCallback = (component, initSelector)=>{
    if ($8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) return;
    const EVENT_CLICK_DATA_API = `click.bs.${component.name}.data-api`;
    const SELECTOR_DATA_SLIDE = "[data-mdb-slide], [data-mdb-slide-to]";
    const CLASS_NAME_CAROUSEL = "carousel";
    const Carousel = component;
    const EVENT_LOAD_DATA_API = `load.bs.${component.name}.data-api`;
    const SELECTOR_DATA_RIDE = initSelector;
    $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_SLIDE, function(event) {
        const target = $8ae0e8ac8a6018f9$var$getElementFromSelector(this);
        if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) return;
        event.preventDefault();
        const carousel = Carousel.getOrCreateInstance(target);
        const slideIndex = this.getAttribute("data-mdb-slide-to");
        if (slideIndex) {
            carousel.to(slideIndex);
            carousel._maybeEnableCycle();
            return;
        }
        if ($8ae0e8ac8a6018f9$var$Manipulator.getDataAttribute(this, "slide") === "next") {
            carousel.next();
            carousel._maybeEnableCycle();
            return;
        }
        carousel.prev();
        carousel._maybeEnableCycle();
    });
    $8ae0e8ac8a6018f9$var$EventHandler$1.on(window, EVENT_LOAD_DATA_API, ()=>{
        const carousels = $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_DATA_RIDE);
        carousels.forEach((carousel)=>{
            Carousel.getOrCreateInstance(carousel);
        });
    });
    $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
};
const $8ae0e8ac8a6018f9$var$collapseCallback = (component, initSelector)=>{
    const EVENT_CLICK_DATA_API = `click.bs.${component.name}.data-api`;
    const SELECTOR_DATA_TOGGLE = initSelector;
    const Collapse = component;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) {
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
            if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
            const selector = $8ae0e8ac8a6018f9$var$getSelectorFromElement(this);
            const selectorElements = $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(selector);
            selectorElements.forEach((element2)=>{
                Collapse.getOrCreateInstance(element2, {
                    toggle: false
                }).toggle();
            });
        });
        $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
    }
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_DATA_TOGGLE).forEach((el)=>{
        const selector = $8ae0e8ac8a6018f9$var$getSelectorFromElement(el);
        const selectorElements = $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(selector);
        selectorElements.forEach((element2)=>{
            Collapse.getOrCreateInstance(element2, {
                toggle: false
            });
        });
    });
};
const $8ae0e8ac8a6018f9$var$dropdownCallback = (component, initSelector)=>{
    const EVENT_CLICK_DATA_API = `click.bs.${component.name}.data-api`;
    const EVENT_KEYDOWN_DATA_API = `keydown.bs.${component.name}.data-api`;
    const EVENT_KEYUP_DATA_API = `keyup.bs.${component.name}.data-api`;
    const SELECTOR_MENU = ".dropdown-menu";
    const SELECTOR_DATA_TOGGLE = `[data-mdb-${component.NAME}-initialized]`;
    const Dropdown = component;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) {
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE, Dropdown.dataApiKeydownHandler);
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API, Dropdown.clearMenus);
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
            event.preventDefault();
            Dropdown.getOrCreateInstance(this).toggle();
        });
    }
    $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(initSelector).forEach((el)=>{
        Dropdown.getOrCreateInstance(el);
    });
};
const $8ae0e8ac8a6018f9$var$inputCallback = (component, initSelector)=>{
    const SELECTOR_DATA_INIT = initSelector;
    const SELECTOR_OUTLINE_INPUT = `${SELECTOR_DATA_INIT} input`;
    const SELECTOR_OUTLINE_TEXTAREA = `${SELECTOR_DATA_INIT} textarea`;
    const Input = component;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) {
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, "focus", SELECTOR_OUTLINE_INPUT, Input.activate(new Input()));
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, "input", SELECTOR_OUTLINE_INPUT, Input.activate(new Input()));
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, "blur", SELECTOR_OUTLINE_INPUT, Input.deactivate(new Input()));
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, "focus", SELECTOR_OUTLINE_TEXTAREA, Input.activate(new Input()));
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, "input", SELECTOR_OUTLINE_TEXTAREA, Input.activate(new Input()));
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, "blur", SELECTOR_OUTLINE_TEXTAREA, Input.deactivate(new Input()));
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(window, "shown.bs.modal", (e)=>{
            $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_OUTLINE_INPUT, e.target).forEach((element2)=>{
                const instance = Input.getInstance(element2.parentNode);
                if (!instance) return;
                instance.update();
            });
            $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_OUTLINE_TEXTAREA, e.target).forEach((element2)=>{
                const instance = Input.getInstance(element2.parentNode);
                if (!instance) return;
                instance.update();
            });
        });
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(window, "shown.bs.dropdown", (e)=>{
            const target = e.target.parentNode.querySelector(".dropdown-menu");
            if (target) {
                $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_OUTLINE_INPUT, target).forEach((element2)=>{
                    const instance = Input.getInstance(element2.parentNode);
                    if (!instance) return;
                    instance.update();
                });
                $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_OUTLINE_TEXTAREA, target).forEach((element2)=>{
                    const instance = Input.getInstance(element2.parentNode);
                    if (!instance) return;
                    instance.update();
                });
            }
        });
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(window, "shown.bs.tab", (e)=>{
            let targetId;
            if (e.target.href) targetId = e.target.href.split("#")[1];
            else targetId = $8ae0e8ac8a6018f9$var$Manipulator.getDataAttribute(e.target, "target").split("#")[1];
            const target = $8ae0e8ac8a6018f9$var$SelectorEngine$1.findOne(`#${targetId}`);
            $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_OUTLINE_INPUT, target).forEach((element2)=>{
                const instance = Input.getInstance(element2.parentNode);
                if (!instance) return;
                instance.update();
            });
            $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_OUTLINE_TEXTAREA, target).forEach((element2)=>{
                const instance = Input.getInstance(element2.parentNode);
                if (!instance) return;
                instance.update();
            });
        });
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(window, "reset", (e)=>{
            $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_OUTLINE_INPUT, e.target).forEach((element2)=>{
                const instance = Input.getInstance(element2.parentNode);
                if (!instance) return;
                instance.forceInactive();
            });
            $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_OUTLINE_TEXTAREA, e.target).forEach((element2)=>{
                const instance = Input.getInstance(element2.parentNode);
                if (!instance) return;
                instance.forceInactive();
            });
        });
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(window, "onautocomplete", (e)=>{
            const instance = Input.getInstance(e.target.parentNode);
            if (!instance || !e.cancelable) return;
            instance.forceActive();
        });
        $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
    }
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_DATA_INIT).map((element2)=>Input.getOrCreateInstance(element2));
};
const $8ae0e8ac8a6018f9$var$modalCallback$1 = (component, initSelector)=>{
    const EVENT_CLICK_DATA_API = `click.bs.${component.name}.data-api`;
    const OPEN_SELECTOR = ".modal.show";
    const Modal = component;
    const EVENT_SHOW = `show.bs.${component.name}`;
    const EVENT_HIDDEN = `hidden.bs.${component.name}`;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) {
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API, initSelector, function(event) {
            const target = $8ae0e8ac8a6018f9$var$getElementFromSelector(this);
            if ([
                "A",
                "AREA"
            ].includes(this.tagName)) event.preventDefault();
            $8ae0e8ac8a6018f9$var$EventHandler$1.one(target, EVENT_SHOW, (showEvent)=>{
                if (showEvent.defaultPrevented) return;
                $8ae0e8ac8a6018f9$var$EventHandler$1.one(target, EVENT_HIDDEN, ()=>{
                    if ($8ae0e8ac8a6018f9$var$isVisible$1(this)) this.focus();
                });
            });
            const alreadyOpenedModals = $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(OPEN_SELECTOR);
            alreadyOpenedModals.forEach((modal)=>{
                if (!modal.classList.contains("modal-non-invasive-show")) Modal.getInstance(modal).hide();
            });
            const data = Modal.getOrCreateInstance(target);
            data.toggle(this);
        });
        $8ae0e8ac8a6018f9$var$enableDismissTrigger(Modal);
        $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
    }
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(initSelector).forEach((el)=>{
        const selector = $8ae0e8ac8a6018f9$var$getSelectorFromElement(el);
        const selectorElement = $8ae0e8ac8a6018f9$var$SelectorEngine$1.findOne(selector);
        Modal.getOrCreateInstance(selectorElement);
    });
};
const $8ae0e8ac8a6018f9$var$offcanvasCallback = (component, initSelector)=>{
    if ($8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) return;
    const EVENT_CLICK_DATA_API = `click.bs.${component.name}.data-api`;
    const OPEN_SELECTOR = ".offcanvas.show";
    const Offcanvas = component;
    const EVENT_HIDDEN = `hidden.bs.${component.name}`;
    const EVENT_LOAD_DATA_API = `load.bs.${component.name}.data-api`;
    const EVENT_RESIZE = `resize.bs.${component.name}`;
    $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API, initSelector, function(event) {
        const target = $8ae0e8ac8a6018f9$var$getElementFromSelector(this);
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($8ae0e8ac8a6018f9$var$isDisabled$1(this)) return;
        $8ae0e8ac8a6018f9$var$EventHandler$1.one(target, EVENT_HIDDEN, ()=>{
            if ($8ae0e8ac8a6018f9$var$isVisible$1(this)) this.focus();
        });
        const alreadyOpen = $8ae0e8ac8a6018f9$var$SelectorEngine$1.findOne(OPEN_SELECTOR);
        if (alreadyOpen && alreadyOpen !== target) Offcanvas.getInstance(alreadyOpen).hide();
        const data = Offcanvas.getOrCreateInstance(target);
        data.toggle(this);
    });
    $8ae0e8ac8a6018f9$var$EventHandler$1.on(window, EVENT_LOAD_DATA_API, ()=>{
        $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(OPEN_SELECTOR).forEach((selector)=>{
            Offcanvas.getOrCreateInstance(selector).show();
        });
    });
    $8ae0e8ac8a6018f9$var$EventHandler$1.on(window, EVENT_RESIZE, ()=>{
        $8ae0e8ac8a6018f9$var$SelectorEngine$1.find("[aria-modal][class*=show][class*=offcanvas-]").forEach((element2)=>{
            if (getComputedStyle(element2).position !== "fixed") Offcanvas.getOrCreateInstance(element2).hide();
        });
    });
    $8ae0e8ac8a6018f9$var$enableDismissTrigger(Offcanvas);
    $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
};
const $8ae0e8ac8a6018f9$var$scrollspyCallback = (component, initSelector)=>{
    if ($8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) return;
    const EVENT_LOAD_DATA_API = `load.bs.${component.name}.data-api`;
    const ScrollSpy = component;
    $8ae0e8ac8a6018f9$var$EventHandler$1.on(window, EVENT_LOAD_DATA_API, ()=>{
        $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(initSelector).forEach((el)=>{
            ScrollSpy.getOrCreateInstance(el);
        });
    });
    $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
};
const $8ae0e8ac8a6018f9$var$tabCallback = (component, initSelector)=>{
    const EVENT_LOAD_DATA_API = `load.bs.${component.name}.data-api`;
    const EVENT_CLICK_DATA_API = `click.bs.${component.name}.data-api`;
    const CLASS_NAME_ACTIVE = "active";
    const SELECTOR_DATA_TOGGLE_ACTIVE = `.${CLASS_NAME_ACTIVE}[data-mdb-tab-init], .${CLASS_NAME_ACTIVE}[data-mdb-pill-init], .${CLASS_NAME_ACTIVE}[data-mdb-toggle="list"]`;
    const Tab = component;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) {
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API, initSelector, function(event) {
            if ([
                "A",
                "AREA"
            ].includes(this.tagName)) event.preventDefault();
            if ($8ae0e8ac8a6018f9$var$isDisabled$1(this)) return;
            Tab.getOrCreateInstance(this).show();
        });
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(window, EVENT_LOAD_DATA_API, ()=>{
            $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_DATA_TOGGLE_ACTIVE).forEach((element2)=>{
                Tab.getOrCreateInstance(element2);
            });
        });
        $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
    }
};
const $8ae0e8ac8a6018f9$var$toastCallback$1 = (component, initSelector)=>{
    const Toast = component;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) {
        $8ae0e8ac8a6018f9$var$enableDismissTrigger(Toast);
        $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
    }
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(initSelector).forEach((element2)=>{
        return Toast.getOrCreateInstance(element2);
    });
};
const $8ae0e8ac8a6018f9$var$rippleCallback = (component, initSelector)=>{
    const Ripple = component;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState$1.has(component.name)) {
        $8ae0e8ac8a6018f9$var$EventHandler$1.one(document, "mousedown", initSelector, Ripple.autoInitial(new Ripple()));
        $8ae0e8ac8a6018f9$var$callbackInitState$1.set(component.name, true);
    }
};
const $8ae0e8ac8a6018f9$var$callbackInitState = /* @__PURE__ */ new Map();
const $8ae0e8ac8a6018f9$var$alertCallback = (component, initSelector)=>{
    const Alert = component;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState.has(component.name)) {
        $8ae0e8ac8a6018f9$var$enableDismissTrigger(Alert);
        $8ae0e8ac8a6018f9$var$callbackInitState.set(component.name, true);
    }
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(initSelector).forEach((element2)=>{
        return Alert.getOrCreateInstance(element2);
    });
};
const $8ae0e8ac8a6018f9$var$lightboxCallback = (component, initSelector)=>{
    const EVENT_CLICK_DATA_API = `click.mdb.${component.name}.data-api`;
    const SELECTOR_DATA_TOGGLE = `[data-mdb-${component.NAME}-initialized]`;
    const SELECTOR_TOGGLE = `${SELECTOR_DATA_TOGGLE} img:not(.lightbox-disabled)`;
    const Lightbox = component;
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(initSelector).forEach((element2)=>{
        return Lightbox.getOrCreateInstance(element2);
    });
    if ($8ae0e8ac8a6018f9$var$callbackInitState.has(component.name)) return;
    $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API, SELECTOR_TOGGLE, (event)=>{
        event.preventDefault();
        Lightbox.toggle(event);
    });
    $8ae0e8ac8a6018f9$var$callbackInitState.set(component.name, true);
};
const $8ae0e8ac8a6018f9$var$modalCallback = (component, initSelector)=>{
    const EVENT_CLICK_DATA_API = `click.bs.${component.name}.data-api`;
    const OPEN_SELECTOR = ".modal.show";
    const Modal = component;
    const EVENT_SHOW = `show.bs.${component.name}`;
    const EVENT_HIDDEN = `hidden.bs.${component.name}`;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState.has(component.name)) {
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, EVENT_CLICK_DATA_API, initSelector, function(event) {
            const target = $8ae0e8ac8a6018f9$var$getElementFromSelector(this);
            if ([
                "A",
                "AREA"
            ].includes(this.tagName)) event.preventDefault();
            $8ae0e8ac8a6018f9$var$EventHandler$1.one(target, EVENT_SHOW, (showEvent)=>{
                if (showEvent.defaultPrevented) return;
                $8ae0e8ac8a6018f9$var$EventHandler$1.one(target, EVENT_HIDDEN, ()=>{
                    if ($8ae0e8ac8a6018f9$var$isVisible$1(this)) this.focus();
                });
            });
            const alreadyOpenedModals = $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(OPEN_SELECTOR);
            alreadyOpenedModals.forEach((modal)=>{
                if (!modal.classList.contains("modal-non-invasive-show")) Modal.getInstance(modal).hide();
            });
            const data = Modal.getOrCreateInstance(target);
            data.toggle(this);
        });
        $8ae0e8ac8a6018f9$var$enableDismissTrigger(Modal);
        $8ae0e8ac8a6018f9$var$callbackInitState.set(component.name, true);
    }
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(initSelector).forEach((el)=>{
        const selector = $8ae0e8ac8a6018f9$var$getSelectorFromElement(el);
        const selectorElement = $8ae0e8ac8a6018f9$var$SelectorEngine$1.findOne(selector);
        Modal.getOrCreateInstance(selectorElement);
    });
};
const $8ae0e8ac8a6018f9$var$sidenavCallback = (component, initSelector)=>{
    const SELECTOR_DATA_INIT = initSelector;
    const SELECTOR_TOGGLE = '[data-mdb-toggle="sidenav"]';
    const Sidenav = component;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState.has(component.name)) {
        $8ae0e8ac8a6018f9$var$EventHandler$1.on(document, "click", SELECTOR_TOGGLE, Sidenav.toggleSidenav());
        $8ae0e8ac8a6018f9$var$callbackInitState.set(component.name, true);
    }
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_DATA_INIT).forEach((sidenav)=>{
        return Sidenav.getOrCreateInstance(sidenav);
    });
};
const $8ae0e8ac8a6018f9$var$toastCallback = (component, initSelector)=>{
    const SELECTOR_DATA_INIT = initSelector;
    const Toast = component;
    if (!$8ae0e8ac8a6018f9$var$callbackInitState.has(component.name)) {
        $8ae0e8ac8a6018f9$var$enableDismissTrigger(Toast);
        $8ae0e8ac8a6018f9$var$callbackInitState.set(component.name, true);
    }
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(SELECTOR_DATA_INIT).forEach((toast)=>{
        return Toast.getOrCreateInstance(toast);
    });
};
const $8ae0e8ac8a6018f9$var$defaultInitSelectors$1 = {
    // Bootstrap Components
    alert: {
        name: "Alert",
        selector: "[data-mdb-alert-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$alertCallback$1
    },
    button: {
        name: "Button",
        selector: "[data-mdb-button-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$buttonCallback
    },
    carousel: {
        name: "Carousel",
        selector: "[data-mdb-carousel-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$carouselCallback
    },
    collapse: {
        name: "Collapse",
        selector: "[data-mdb-collapse-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$collapseCallback
    },
    dropdown: {
        name: "Dropdown",
        selector: "[data-mdb-dropdown-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$dropdownCallback
    },
    modal: {
        name: "Modal",
        selector: "[data-mdb-modal-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$modalCallback$1
    },
    offcanvas: {
        name: "Offcanvas",
        selector: "[data-mdb-offcanvas-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$offcanvasCallback
    },
    scrollspy: {
        name: "ScrollSpy",
        selector: "[data-mdb-scrollspy-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$scrollspyCallback
    },
    tab: {
        name: "Tab",
        selector: "[data-mdb-tab-init], [data-mdb-pill-init], [data-mdb-list-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$tabCallback
    },
    toast: {
        name: "Toast",
        selector: "[data-mdb-toast-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$toastCallback$1
    },
    tooltip: {
        name: "Tooltip",
        selector: "[data-mdb-tooltip-init]",
        isToggler: false
    },
    input: {
        name: "Input",
        selector: "[data-mdb-input-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$inputCallback
    },
    range: {
        name: "Range",
        selector: "[data-mdb-range-init]",
        isToggler: false
    },
    ripple: {
        name: "Ripple",
        selector: "[data-mdb-ripple-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$rippleCallback
    },
    popover: {
        name: "Popover",
        selector: "[data-mdb-popover-init]",
        isToggler: false,
        callback: $8ae0e8ac8a6018f9$var$rippleCallback
    }
};
const $8ae0e8ac8a6018f9$var$chartsCallback = (Component, initSelector)=>{
    const IS_COMPLEX = (data)=>{
        return data[0] === "{" && data[data.length - 1] === "}" || data[0] === "[" && data[data.length - 1] === "]";
    };
    const CONVERT_DATA_TYPE = (data)=>{
        if (typeof data !== "string") return data;
        if (IS_COMPLEX(data)) return JSON.parse(data.replace(/'/g, '"'));
        return data;
    };
    const PARSE_DATA = (data)=>{
        const dataset = {};
        Object.keys(data).forEach((property)=>{
            if (property.match(/dataset.*/)) {
                const chartProperty = property.slice(7, 8).toLowerCase().concat(property.slice(8));
                dataset[chartProperty] = CONVERT_DATA_TYPE(data[property]);
            }
        });
        return dataset;
    };
    $8ae0e8ac8a6018f9$var$SelectorEngine$1.find(initSelector).forEach((el)=>{
        if (!Component.getInstance(el) && $8ae0e8ac8a6018f9$var$Manipulator.getDataAttribute(el, "chart") !== "bubble" && $8ae0e8ac8a6018f9$var$Manipulator.getDataAttribute(el, "chart") !== "scatter") {
            const dataSet = $8ae0e8ac8a6018f9$var$Manipulator.getDataAttributes(el);
            const dataAttr = {
                data: {
                    datasets: [
                        PARSE_DATA(dataSet)
                    ]
                }
            };
            if (dataSet.chart) dataAttr.type = dataSet.chart;
            if (dataSet.labels) dataAttr.data.labels = JSON.parse(dataSet.labels.replace(/'/g, '"'));
            return new Component(el, {
                ...dataAttr,
                ...$8ae0e8ac8a6018f9$var$DEFAULT_OPTIONS[dataAttr.type]
            });
        }
        return null;
    });
};
const $8ae0e8ac8a6018f9$var$defaultInitSelectors = {
    ...$8ae0e8ac8a6018f9$var$defaultInitSelectors$1,
    chart: {
        name: "Chart",
        selector: "[data-mdb-chart-init]",
        isToggler: false,
        advanced: $8ae0e8ac8a6018f9$var$chartsCallback
    },
    chips: {
        name: "ChipsInput",
        selector: "[data-mdb-chips-input-init]",
        isToggler: false
    },
    chip: {
        name: "Chip",
        selector: "[data-mdb-chip-init]",
        isToggler: false,
        onInit: "init"
    },
    datatable: {
        name: "Datatable",
        selector: "[data-mdb-datatable-init]",
        isToggler: false
    },
    select: {
        name: "Select",
        selector: "[data-mdb-select-init]",
        isToggler: false
    },
    datetimepicker: {
        name: "Datetimepicker",
        selector: "[data-mdb-datetimepicker-init]",
        isToggler: false
    },
    datepicker: {
        name: "Datepicker",
        selector: "[data-mdb-datepicker-init]",
        isToggler: false
    },
    loading: {
        name: "Loading",
        selector: "[data-mdb-loading-init]",
        isToggler: false
    },
    multiRangeSlider: {
        name: "MultiRangeSlider",
        selector: "[data-mdb-multi-range-slider-init]",
        isToggler: false
    },
    timepicker: {
        name: "Timepicker",
        selector: "[data-mdb-timepicker-init]",
        isToggler: false
    },
    touch: {
        name: "Touch",
        selector: "[data-mdb-touch-init]",
        isToggler: false
    },
    alert: {
        name: "Alert",
        selector: "[data-mdb-alert-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$alertCallback
    },
    animation: {
        name: "Animate",
        selector: "[data-mdb-animation-init]",
        isToggler: false,
        onInit: "init"
    },
    clipboard: {
        name: "Clipboard",
        selector: "[data-mdb-clipboard-init]",
        isToggler: false
    },
    infiniteScroll: {
        name: "InfiniteScroll",
        selector: "[data-mdb-infinite-scroll-init]",
        isToggler: false
    },
    lazyLoad: {
        name: "LazyLoad",
        selector: "[data-mdb-lazy-load-init]",
        isToggler: false
    },
    lightbox: {
        name: "Lightbox",
        selector: "[data-mdb-lightbox-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$lightboxCallback
    },
    modal: {
        name: "Modal",
        selector: "[data-mdb-modal-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$modalCallback
    },
    navbar: {
        name: "Navbar",
        selector: "[data-mdb-navbar-init]",
        isToggler: false,
        onInit: "init"
    },
    perfectScrollbar: {
        name: "PerfectScrollbar",
        selector: "[data-mdb-perfect-scrollbar-init]",
        isToggler: false
    },
    popconfirm: {
        name: "Popconfirm",
        selector: "[data-mdb-popconfirm-init]",
        isToggler: false
    },
    rating: {
        name: "Rating",
        selector: "[data-mdb-rating-init]",
        isToggler: false
    },
    sidenav: {
        name: "Sidenav",
        selector: "[data-mdb-sidenav-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$sidenavCallback
    },
    smoothScroll: {
        name: "SmoothScroll",
        selector: "[data-mdb-smooth-scroll-init]",
        isToggler: false
    },
    stepper: {
        name: "Stepper",
        selector: "[data-mdb-stepper-init]",
        isToggler: false
    },
    sticky: {
        name: "Sticky",
        selector: "[data-mdb-sticky-init]",
        isToggler: false
    },
    toast: {
        name: "Toast",
        selector: "[data-mdb-toast-init]",
        isToggler: true,
        callback: $8ae0e8ac8a6018f9$var$toastCallback
    }
};
const $8ae0e8ac8a6018f9$var$initMDBInstance = new $8ae0e8ac8a6018f9$var$InitMDB($8ae0e8ac8a6018f9$var$defaultInitSelectors);
const $8ae0e8ac8a6018f9$export$c471ba63047b6fd4 = $8ae0e8ac8a6018f9$var$initMDBInstance.initMDB;


var $5b3002ca6a005b42$exports = {};
!function(e, t) {
    $5b3002ca6a005b42$exports = t();
}($5b3002ca6a005b42$exports, function() {
    "use strict";
    const e = (e)=>{
        do e += Math.floor(1e6 * Math.random());
        while (document.getElementById(e));
        return e;
    }, t = ()=>{
        const { jQuery: e } = window;
        return e && !document.body.hasAttribute("data-mdb-no-jquery") ? e : null;
    };
    document.documentElement.dir;
    const n = (e)=>document.createElement(e), s = (()=>{
        const e = {};
        let t = 1;
        return {
            set (n, s, i) {
                void 0 === n[s] && (n[s] = {
                    key: s,
                    id: t
                }, t++), e[n[s].id] = i;
            },
            get (t, n) {
                if (!t || void 0 === t[n]) return null;
                const s = t[n];
                return s.key === n ? e[s.id] : null;
            },
            delete (t, n) {
                if (void 0 === t[n]) return;
                const s = t[n];
                s.key === n && (delete e[s.id], delete t[n]);
            }
        };
    })(), i = {
        setData (e, t, n) {
            s.set(e, t, n);
        },
        getData: (e, t)=>s.get(e, t),
        removeData (e, t) {
            s.delete(e, t);
        }
    };
    function o(e) {
        return "true" === e || "false" !== e && (e === Number(e).toString() ? Number(e) : "" === e || "null" === e ? null : e);
    }
    function r(e) {
        return e.replace(/[A-Z]/g, (e)=>`-${e.toLowerCase()}`);
    }
    const l = {
        setDataAttribute (e, t, n) {
            e.setAttribute(`data-mdb-${r(t)}`, n);
        },
        removeDataAttribute (e, t) {
            e.removeAttribute(`data-mdb-${r(t)}`);
        },
        getDataAttributes (e) {
            if (!e) return {};
            const t = {
                ...e.dataset
            };
            return Object.keys(t).filter((e)=>e.startsWith("mdb")).forEach((e)=>{
                let n = e.replace(/^mdb/, "");
                n = n.charAt(0).toLowerCase() + n.slice(1, n.length), t[n] = o(t[e]);
            }), t;
        },
        getDataAttribute: (e, t)=>o(e.getAttribute(`data-mdb-${r(t)}`)),
        offset (e) {
            const t = e.getBoundingClientRect();
            return {
                top: t.top + document.body.scrollTop,
                left: t.left + document.body.scrollLeft
            };
        },
        position: (e)=>({
                top: e.offsetTop,
                left: e.offsetLeft
            }),
        style (e, t) {
            Object.assign(e.style, t);
        },
        toggleClass (e, t) {
            e && (e.classList.contains(t) ? e.classList.remove(t) : e.classList.add(t));
        },
        addClass (e, t) {
            e.classList.contains(t) || e.classList.add(t);
        },
        addStyle (e, t) {
            Object.keys(t).forEach((n)=>{
                e.style[n] = t[n];
            });
        },
        removeClass (e, t) {
            e.classList.contains(t) && e.classList.remove(t);
        },
        hasClass: (e, t)=>e.classList.contains(t)
    };
    let a = Element.prototype.querySelectorAll, c = Element.prototype.querySelector;
    const d = (()=>{
        const e = new CustomEvent("Bootstrap", {
            cancelable: !0
        }), t = document.createElement("div");
        return t.addEventListener("Bootstrap", ()=>null), e.preventDefault(), t.dispatchEvent(e), e.defaultPrevented;
    })(), u = /:scope\b/;
    (()=>{
        const e = document.createElement("div");
        try {
            e.querySelectorAll(":scope *");
        } catch (t) {
            return !1;
        }
        return !0;
    })() || (a = function(t) {
        if (!u.test(t)) return this.querySelectorAll(t);
        const n = Boolean(this.id);
        n || (this.id = e("scope"));
        let s = null;
        try {
            t = t.replace(u, `#${this.id}`), s = this.querySelectorAll(t);
        } finally{
            n || this.removeAttribute("id");
        }
        return s;
    }, c = function(e) {
        if (!u.test(e)) return this.querySelector(e);
        const t = h.call(this, e);
        return void 0 !== t[0] ? t[0] : null;
    });
    const h = a, f = c, p = {
        closest: (e, t)=>e.closest(t),
        matches: (e, t)=>e.matches(t),
        find: (e, t = document.documentElement)=>[].concat(...h.call(t, e)),
        findOne: (e, t = document.documentElement)=>f.call(t, e),
        children: (e, t)=>[].concat(...e.children).filter((e)=>e.matches(t)),
        parents (e, t) {
            const n = [];
            let s = e.parentNode;
            for(; s && s.nodeType === Node.ELEMENT_NODE && 3 !== s.nodeType;)this.matches(s, t) && n.push(s), s = s.parentNode;
            return n;
        },
        prev (e, t) {
            let n = e.previousElementSibling;
            for(; n;){
                if (n.matches(t)) return [
                    n
                ];
                n = n.previousElementSibling;
            }
            return [];
        },
        next (e, t) {
            let n = e.nextElementSibling;
            for(; n;){
                if (this.matches(n, t)) return [
                    n
                ];
                n = n.nextElementSibling;
            }
            return [];
        }
    }, m = t(), g = /[^.]*(?=\..*)\.|.*/, _ = /\..*/, b = /::\d+$/, v = {};
    let y = 1;
    const E = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    }, C = [
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ];
    function w(e, t) {
        return t && `${t}::${y++}` || e.uidEvent || y++;
    }
    function O(e) {
        const t = w(e);
        return e.uidEvent = t, v[t] = v[t] || {}, v[t];
    }
    function k(e, t, n = null) {
        const s = Object.keys(e);
        for(let i = 0, o = s.length; i < o; i++){
            const o = e[s[i]];
            if (o.originalHandler === t && o.delegationSelector === n) return o;
        }
        return null;
    }
    function L(e, t, n) {
        const s = "string" == typeof t, i = s ? n : t;
        let o = e.replace(_, "");
        const r = E[o];
        r && (o = r);
        return C.indexOf(o) > -1 || (o = e), [
            s,
            i,
            o
        ];
    }
    function I(e, t, n, s, i) {
        if ("string" != typeof t || !e) return;
        n || (n = s, s = null);
        const [o, r, l] = L(t, n, s), a = O(e), c = a[l] || (a[l] = {}), d = k(c, r, o ? n : null);
        if (d) return void (d.oneOff = d.oneOff && i);
        const u = w(r, t.replace(g, "")), h = o ? function(e, t, n) {
            return function s(i) {
                const o = e.querySelectorAll(t);
                for(let { target: t } = i; t && t !== this; t = t.parentNode)for(let r = o.length; r--;)if (o[r] === t) return s.oneOff && S.off(e, i.type, n), n.apply(t, [
                    i
                ]);
                return null;
            };
        }(e, n, s) : function(e, t) {
            return function n(s) {
                return n.oneOff && S.off(e, s.type, t), t.apply(e, [
                    s
                ]);
            };
        }(e, n);
        h.delegationSelector = o ? n : null, h.originalHandler = r, h.oneOff = i, h.uidEvent = u, c[u] = h, e.addEventListener(l, h, o);
    }
    function A(e, t, n, s, i) {
        const o = k(t[n], s, i);
        o && (e.removeEventListener(n, o, Boolean(i)), delete t[n][o.uidEvent]);
    }
    const S = {
        on (e, t, n, s) {
            I(e, t, n, s, !1);
        },
        one (e, t, n, s) {
            I(e, t, n, s, !0);
        },
        off (e, t, n, s) {
            if ("string" != typeof t || !e) return;
            const [i, o, r] = L(t, n, s), l = r !== t, a = O(e), c = "." === t.charAt(0);
            if (void 0 !== o) {
                if (!a || !a[r]) return;
                return void A(e, a, r, o, i ? n : null);
            }
            c && Object.keys(a).forEach((n)=>{
                !function(e, t, n, s) {
                    const i = t[n] || {};
                    Object.keys(i).forEach((o)=>{
                        if (o.indexOf(s) > -1) {
                            const s = i[o];
                            A(e, t, n, s.originalHandler, s.delegationSelector);
                        }
                    });
                }(e, a, n, t.slice(1));
            });
            const d = a[r] || {};
            Object.keys(d).forEach((n)=>{
                const s = n.replace(b, "");
                if (!l || t.indexOf(s) > -1) {
                    const t = d[n];
                    A(e, a, r, t.originalHandler, t.delegationSelector);
                }
            });
        },
        trigger (e, t, n) {
            if ("string" != typeof t || !e) return null;
            const s = t.replace(_, ""), i = t !== s, o = C.indexOf(s) > -1;
            let r, l = !0, a = !0, c = !1, u = null;
            return i && m && (r = m.Event(t, n), m(e).trigger(r), l = !r.isPropagationStopped(), a = !r.isImmediatePropagationStopped(), c = r.isDefaultPrevented()), o ? (u = document.createEvent("HTMLEvents"), u.initEvent(s, l, !0)) : u = new CustomEvent(t, {
                bubbles: l,
                cancelable: !0
            }), void 0 !== n && Object.keys(n).forEach((e)=>{
                Object.defineProperty(u, e, {
                    get: ()=>n[e]
                });
            }), c && (u.preventDefault(), d || Object.defineProperty(u, "defaultPrevented", {
                get: ()=>!0
            })), a && e.dispatchEvent(u), u.defaultPrevented && void 0 !== r && r.preventDefault(), u;
        }
    }, D = 37, x = 38, T = 39, M = 40, j = 36, $ = 35, U = 13, N = "treeview", H = "mdb.treeview", P = 'input[type="checkbox"]', B = "show", K = "active", q = "treeview-category", z = "treeview-disabled", G = [
        "primary",
        "secondary",
        "warning",
        "success",
        "info",
        "danger",
        "light",
        "dark"
    ], Q = {
        structure: "(null|array)",
        openOnClick: "boolean",
        selectable: "boolean",
        accordion: "boolean",
        rotationAngle: "number",
        treeviewColor: "string",
        line: "boolean"
    }, R = {
        structure: null,
        openOnClick: !0,
        selectable: !1,
        accordion: !1,
        rotationAngle: 90,
        treeviewColor: "primary",
        line: !1
    };
    class J {
        constructor(e, t){
            this._element = e, this._element && i.setData(e, H, this), this._options = this._getConfig(t), this._innerLists = [], this._stringCollection = new Map, this._init(), this._checkboxes = p.find(P, this._mainList), this._listElements = p.find("li", this._mainList);
        }
        static get NAME() {
            return N;
        }
        get parsedDOM() {
            return this._parseDOM(this._element);
        }
        get selectedItems() {
            return p.find(P, this._mainList).filter((e)=>e.checked).map((e)=>{
                const [t] = p.parents(e, "li");
                return t;
            });
        }
        dispose() {
            i.removeData(this._element, H), this._checkboxes.forEach((e)=>{
                S.off(e, "change"), S.off(e, "mousedown");
            }), this._listElements.forEach((e)=>{
                S.off(e, "click"), S.off(e, "mouseover"), S.off(e, "mouseout"), S.off(e, "keydown");
            }), this._innerLists.forEach((e)=>{
                e.collapse.dispose();
                const [t] = p.parents(e.toggler, "a");
                S.off(t, "click");
            }), this._element = null;
        }
        collapse() {
            p.find("ul", this._mainList).forEach((e)=>{
                if (l.hasClass(e, B)) {
                    const { collapse: t } = this._getInnerList(e);
                    t.hide();
                }
            });
        }
        expand(e) {
            const t = p.findOne(`#${e}`, this._mainList);
            [
                t,
                ...p.parents(t, 'ul:not([role="tree"])')
            ].forEach((e)=>{
                if (!l.hasClass(e, B)) {
                    const { collapse: t } = this._getInnerList(e);
                    t.show();
                }
            });
        }
        filter(e) {
            this.collapse(), setTimeout(()=>{
                this._stringCollection.forEach((t, n)=>{
                    const s = this._normalize(e);
                    if (this._normalize(t).includes(s)) {
                        let e;
                        l.hasClass(n, q) ? [e] = p.parents(n, "ul") : e = p.findOne("ul", n);
                        const t = l.hasClass(e, B), s = p.children(n, "ul").length > 0;
                        if (!t && s) {
                            const t = e.getAttribute("id");
                            this.expand(t);
                        }
                    }
                });
            }, 351);
        }
        _init() {
            const { initMDB: e, Collapse: t } = mdb;
            e({
                Collapse: t
            }), this._options.structure ? this._initJS() : this._initDOM(), S.on(this._element, "keydown", (e)=>{
                const { keyCode: t } = e;
                9 !== t && t === M && (e.preventDefault(), this._handleHomeKey());
            });
        }
        _initJS() {
            this._generateMainList(), l.addClass(this._element, "treeview"), this._options.structure.forEach((e)=>this._generateTree(e, this._mainList)), this._initDOM();
        }
        _initDOM() {
            this._setupMainList(), this.parsedDOM.forEach((e)=>this._setupTree(e, 1, this._mainList)), this._setupUIElement(this._element, {
                tabindex: "0"
            }), this._options.treeviewColor && this._setupColors();
        }
        _setupColors() {
            const e = G.includes(this._options.treeviewColor) ? `treeview-${this._options.treeviewColor}` : "treeview-primary";
            return l.addClass(this._element, e);
        }
        _getInnerList(e) {
            return this._innerLists.find((t)=>t.element === e);
        }
        _generateTree(e, t) {
            const { name: s, children: i, show: o, id: r, icon: a, disabled: c } = e, d = n("li");
            i ? this._generateGroupItem({
                li: d,
                name: s,
                children: i,
                show: o,
                id: r,
                icon: a,
                disabled: c
            }) : (c && l.addClass(d, z), d.innerHTML = s, r && this._setupUIElement(d, {
                id: r
            })), t.appendChild(d);
        }
        _generateGroupItem({ li: e, name: t, children: s, show: i, id: o, icon: r, disabled: a }) {
            const c = n("a"), d = n("ul");
            if (c.innerHTML = t, a && l.addClass(c, z), e.appendChild(c), e.appendChild(d), i && l.addClass(d, B), o && this._setupUIElement(d, {
                id: o
            }), r) {
                const e = n("span");
                this._setupUIElement(e, {
                    "aria-label": "toggle"
                }), e.innerHTML = r, c.insertBefore(e, c.firstChild);
            }
            s.forEach((e)=>this._generateTree(e, d));
        }
        _generateMainList() {
            this._mainList = n("ul"), this._element.appendChild(this._mainList);
        }
        _setupMainList() {
            this._mainList = p.findOne("ul", this._element), this._setupUIElement(this._mainList, {
                role: "tree"
            });
        }
        _setupTree(e, t, n) {
            const { node: s, children: i } = e;
            this._setupTreeItem(s, t), this._setupUIElement(s, {
                tabindex: "-1"
            }), i.length > 0 && this._setupGroupItem(s, i, t, n);
        }
        _setupTreeItem(e, t) {
            this._setupUIElement(e, {
                "aria-level": t,
                role: "tree-item"
            }), this._options.selectable && this._setupCheckbox(e);
            const n = this._getSelector(e);
            l.addClass(n, q), S.on(e, "keydown", (t)=>this._handleKeyboardNavigation(t, e)), l.hasClass(n, z) || S.on(n, "click", (e)=>this._handleItemClick(e, n));
        }
        _setupGroupItem(t, n, s, i) {
            const o = p.findOne("a", t), r = p.findOne("ul", t);
            let a;
            this._options.line && l.addClass(r, "treeview-line"), a = r.hasAttribute("id") ? r.getAttribute("id") : e("level-");
            const c = this._setupToggler(a, o);
            this._setupUIElement(r, {
                id: a,
                role: "group"
            }), this._setupUIElement(o, {
                role: "button",
                tabindex: "-1"
            }), this._setupCollapse(r, c, i), n.forEach((e)=>this._setupTree(e, s + 1, r));
        }
        _setupCollapse(e, t, n) {
            const s = l.hasClass(e, B);
            l.removeClass(e, B);
            const i = new mdb.Collapse(e, {
                parent: this._options.accordion ? n : "",
                toggle: s
            });
            s && this._rotateIcon(t, 90), S.on(e, "show.bs.collapse", (e)=>{
                e.stopPropagation(), this._rotateIcon(t, this._options.rotationAngle);
            }), S.on(e, "hide.bs.collapse", (n)=>{
                n.stopPropagation(), this._rotateIcon(t, 0), p.find("ul", e).forEach((e)=>{
                    mdb.Collapse.getInstance(e).hide();
                });
            }), this._innerLists.push({
                element: e,
                collapse: i,
                toggler: t
            });
        }
        _createCheckbox() {
            const e = n("input");
            return this._setupUIElement(e, {
                type: "checkbox",
                "data-mdb-collapse-init": ""
            }, [
                "mx-1",
                "form-check-input"
            ]), e;
        }
        _setupCheckbox(e) {
            const t = this._createCheckbox(), n = this._getSelector(e);
            if (l.hasClass(n, z)) {
                t.setAttribute("disabled", !0);
                p.find("li", e).forEach((e)=>{
                    const t = this._getSelector(e);
                    l.addClass(t, z);
                });
            }
            "A" === n.nodeName && l.style(n, {
                marginLeft: "-1rem"
            }), n.insertBefore(t, n.firstChild), S.on(t, "mousedown", (t)=>this._handleInputChange(t, e)), S.on(t, "change", (t)=>this._handleInputChange(t, e));
        }
        _handleKeyboardNavigation(e, t) {
            const { keyCode: n } = e;
            if ([
                x,
                M,
                U,
                j,
                $,
                T,
                D
            ].includes(n) && (e.stopPropagation(), 9 !== n)) switch(e.preventDefault(), n){
                case U:
                    this._handleEnterKey(t);
                    break;
                case j:
                    this._handleHomeKey();
                    break;
                case $:
                    {
                        const e = p.children(this._mainList, "li"), t = e[e.length - 1];
                        this._handleEndKey(t);
                        break;
                    }
                case T:
                    this._handleRightArrow(t);
                    break;
                case D:
                    this._handleLeftArrow(t);
                    break;
                case M:
                    this._handleDownArrow(t);
                    break;
                case x:
                    this._handleUpArrow(t);
                    break;
                default:
                    return;
            }
        }
        _handleHomeKey() {
            const e = p.findOne("li", this._mainList);
            this._getSelector(e).focus();
        }
        _handleRightArrow(e) {
            const t = p.findOne("ul", e);
            if (t) {
                const e = t.getAttribute("id");
                this.expand(e);
            }
        }
        _handleLeftArrow(e) {
            const t = p.findOne("ul", e);
            if (t) {
                const { collapse: e } = this._getInnerList(t);
                e.hide();
            }
        }
        _handleEndKey(e) {
            const t = p.findOne("ul", e);
            let n = e;
            if (t && l.hasClass(t, B)) {
                const e = p.children(t, "li"), s = e[e.length - 1];
                n = s, this._handleEndKey(s);
            } else this._getSelector(n).focus();
        }
        _handleEnterKey(e) {
            const t = this._getSelector(e);
            if (l.hasClass(t, z)) return;
            p.find("li", this._mainList).forEach((e)=>{
                l.removeClass(e, K);
                const t = p.findOne("a", e);
                t && l.removeClass(t, K);
            }), l.addClass(t, K);
        }
        _handleUpArrow(e) {
            const [t] = p.prev(e, "li");
            if (!t) {
                const [t] = p.parents(e, "li");
                if (!t) return;
                return void this._getSelector(t).focus();
            }
            const n = p.findOne("ul", t);
            if (n && l.hasClass(n, B)) {
                const e = p.children(n, "li");
                return void e[e.length - 1].focus();
            }
            this._getSelector(t).focus();
        }
        _handleDownArrow(e) {
            let t;
            const n = p.findOne("ul", e);
            if (n) {
                if (l.hasClass(n, B)) {
                    if (t = p.findOne("li", n), !t) return;
                    this._getSelector(t).focus();
                } else {
                    if ([t] = p.next(e, "li"), !t) return;
                    this._getSelector(t).focus();
                }
            } else {
                if ([t] = p.next(e, "li"), !t) {
                    const [t] = p.parents(e, "li"), [n] = p.next(t, "li");
                    if (!n) return;
                    return void this._getSelector(n).focus();
                }
                this._getSelector(t).focus();
            }
        }
        _handleInputChange(e, t) {
            let n = e.target.checked;
            "" === l.getDataAttributes(e.target.parentNode).mdbCollapseInit && (n = !n);
            p.find(P, t).forEach((e)=>{
                e.disabled || (e.checked = n);
            });
            const s = p.parents(t, "li"), [i] = s, o = p.findOne(P, i);
            i && !o.checked && n && s.forEach((e)=>{
                const t = p.findOne(P, e);
                p.find(P, e).every((e, t)=>0 === t || e.checked) && (t.checked = !0);
            }), i && o.checked && !n && s.forEach((e)=>{
                p.findOne(P, e).checked = !1;
            }), S.trigger(this._element, "itemSelected.mdb.treeview", {
                items: this.selectedItems
            });
        }
        _handleItemClick(e, t) {
            e.stopPropagation();
            p.find("li", this._mainList).forEach((e)=>{
                l.removeClass(e, K);
                const t = p.findOne("a", e);
                t && l.removeClass(t, K);
            }), l.addClass(t, K), S.trigger(this._element, "itemActive.mdb.treeview", {
                item: t
            });
        }
        _setupToggler(e, t) {
            const n = p.findOne('span[aria-label="toggle"]', t);
            if (n) {
                const s = this._options.openOnClick ? t : n;
                return l.setDataAttribute(s, "collapseInit", ""), this._setupUIElement(s, {
                    "data-mdb-collapse-init": "",
                    "data-mdb-target": `#${e}`
                }), n;
            }
            return this._createToggler(e, t);
        }
        _createToggler(e, t) {
            const s = n("span"), i = this._options.openOnClick ? t : s;
            return this._setupUIElement(s, {
                "aria-label": "toggle"
            }), s.innerHTML = '<i class="fas fa-angle-right mx-1"></i>', l.setDataAttribute(i, "collapseInit", ""), this._setupUIElement(i, {
                "data-mdb-collapse-init": "",
                "data-mdb-target": `#${e}`
            }), t.insertBefore(s, t.firstChild), s;
        }
        _parseDOM(e) {
            const [t] = p.children(e, "ul");
            return t ? p.children(t, "li").map((e)=>{
                const t = this._parseDOM(e), n = {
                    name: e.innerText ? e.innerText.split("\n")[0] : "",
                    node: e,
                    children: t
                };
                if (n.children.length > 0) {
                    const t = p.findOne("a", e);
                    n.name = t.innerText ? t.innerText.split("\n")[0] : "";
                }
                return this._stringCollection.set(n.node, n.name), n;
            }) : [];
        }
        _rotateIcon(e, t) {
            const n = p.findOne("i", e);
            n && l.style(n, {
                transform: `rotate(${t}deg)`
            });
        }
        _setupUIElement(e, t = {}, n = []) {
            Object.keys(t).forEach((n)=>{
                const s = t[n];
                e.setAttribute(n, s);
            }), n.forEach((t)=>{
                l.addClass(e, t);
            });
        }
        _getSelector(e) {
            return p.findOne("a", e) || e;
        }
        _normalize(e) {
            return e.trim().toLowerCase();
        }
        _getConfig(e) {
            const t = {
                ...R,
                ...l.getDataAttributes(this._element),
                ...e
            };
            return ((e, t, n)=>{
                Object.keys(n).forEach((s)=>{
                    const i = n[s], o = t[s], r = o && ((l = o)[0] || l).nodeType ? "element" : ((e)=>null == e ? `${e}` : ({}).toString.call(e).match(/\s([a-z]+)/i)[1].toLowerCase())(o);
                    var l;
                    if (!new RegExp(i).test(r)) throw new Error(`${e.toUpperCase()}: Option "${s}" provided type "${r}" but expected type "${i}".`);
                });
            })(N, t, Q), t;
        }
        static getInstance(e) {
            return i.getData(e, H);
        }
        static jQueryInterface(e) {
            return this.each(function() {
                let t = i.getData(this, H);
                if (t || (t = new J(this, "object" == typeof e && e)), "string" == typeof e) {
                    if (void 0 === t[e]) throw new TypeError(`No method named "${e}"`);
                    t[e](this);
                }
            });
        }
    }
    var W;
    return p.find("[data-mdb-treeview-init]").forEach((e)=>{
        let t = J.getInstance(e);
        return t || (t = new J(e)), t;
    }), W = ()=>{
        const e = t();
        if (e) {
            const t = e.fn[N];
            e.fn[N] = J.jQueryInterface, e.fn[N].Constructor = J, e.fn[N].noConflict = ()=>(e.fn[N] = t, J.jQueryInterface);
        }
    }, "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", W) : W(), J;
});


window.mdb = $0abbbd36a260e067$exports;
window.mdb.Chart = (0, $8ae0e8ac8a6018f9$export$acaa6426d77a227e);
window.Treeview = $5b3002ca6a005b42$exports;
var $b25b8f2cb1cb2b8e$exports = {};
$b25b8f2cb1cb2b8e$exports = new URL("favicon.dad33c62.svg", import.meta.url).toString();


// Workaround to import images outside ES modules
// Reference: https://parceljs.org/recipes/image/#javascript
const $3a2e12953ada105b$var$favicon = new URL($b25b8f2cb1cb2b8e$exports);
var $fae186fb7c5646ee$exports = {};
$fae186fb7c5646ee$exports = new URL("logo.8c2f6b64.svg", import.meta.url).toString();


const $3a2e12953ada105b$var$logo = new URL($fae186fb7c5646ee$exports);
var $06c1ccb9bf4ae801$exports = {};
$06c1ccb9bf4ae801$exports = new URL("wysiwyg.aa5c5cd4.css", import.meta.url).toString();


const $3a2e12953ada105b$var$wysiwyg = new URL($06c1ccb9bf4ae801$exports);
window.fileUrls = {
    favicon: $3a2e12953ada105b$var$favicon,
    logo: $3a2e12953ada105b$var$logo,
    wysiwyg: $3a2e12953ada105b$var$wysiwyg
};


//# sourceMappingURL=index.773d3407.js.map
